/*! For license information please see index.js.LICENSE.txt */
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__ from "@mui/material";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__ from "@mui/material/Typography";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__ from "@emotion/react";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__ from "@mui/material/Grid";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__ from "@mui/material/Box";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__ from "@mui/material/SvgIcon";
import * as __WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__ from "@mui/system/Box";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__ from "@mui/material/IconButton";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__ from "@mui/material/CircularProgress";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionDetails_d2db12ca__ from "@mui/material/AccordionDetails";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Accordion_4220dc4d__ from "@mui/material/Accordion";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionSummary_85088446__ from "@mui/material/AccordionSummary";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Alert_759df34a__ from "@mui/material/Alert";
import * as __WEBPACK_EXTERNAL_MODULE_react_device_detect_2985bda2__ from "react-device-detect";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_AppBar_72083ef1__ from "@mui/material/AppBar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Toolbar_089287ec__ from "@mui/material/Toolbar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Chip_305fde45__ from "@mui/material/Chip";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__ from "@mui/material/Autocomplete";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__ from "@mui/material/TextField";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__ from "@mui/material/Badge";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Avatar_eb4ee1a2__ from "@mui/material/Avatar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_List_e42ad5de__ from "@mui/material/List";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Collapse_1f7ec3cf__ from "@mui/material/Collapse";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__ from "@mui/material/ListItemButton";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__ from "@mui/material/ListItemIcon";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__ from "@mui/material/ListItemText";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__ from "@mui/material/Stack";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_SwipeableDrawer_b1c2876e__ from "@mui/material/SwipeableDrawer";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigation_918bb977__ from "@mui/material/BottomNavigation";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigationAction_261e3421__ from "@mui/material/BottomNavigationAction";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Link_317b0bd9__ from "@mui/material/Link";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Breadcrumbs_3d9c9a2c__ from "@mui/material/Breadcrumbs";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__ from "@mui/material/Button";
import * as __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__ from "@mui/system";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__ from "@mui/material/InputAdornment";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ClickAwayListener_a7328dbe__ from "@mui/material/ClickAwayListener";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__ from "@mui/material/Checkbox";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__ from "@mui/material/styles";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Grow_8b326669__ from "@mui/material/Grow";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Fade_74850abd__ from "@mui/material/Fade";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__ from "@mui/material/Paper";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Popper_24cb866b__ from "@mui/material/Popper";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Unstable_TrapFocus_0439b381__ from "@mui/material/Unstable_TrapFocus";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_useMediaQuery_95ceafc9__ from "@mui/material/useMediaQuery";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_DialogActions_c3764e69__ from "@mui/material/DialogActions";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItem_695b112b__ from "@mui/material/ListItem";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__ from "@mui/material/utils";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_InputLabel_cf26b488__ from "@mui/material/InputLabel";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_FormHelperText_3b87fa55__ from "@mui/material/FormHelperText";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__ from "@mui/material/FormControl";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ButtonBase_d8a51b7c__ from "@mui/material/ButtonBase";
import * as __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__ from "react-dom";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_DialogContent_37fd6d87__ from "@mui/material/DialogContent";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__ from "@mui/material/Dialog";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__ from "@mui/material/Divider";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Tab_d16acec7__ from "@mui/material/Tab";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Tabs_81f0807c__ from "@mui/material/Tabs";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__ from "@mui/material/MenuItem";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_MenuList_abce8441__ from "@mui/material/MenuList";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_DialogTitle_112a25af__ from "@mui/material/DialogTitle";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Tooltip_69cc2f11__ from "@mui/material/Tooltip";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_FormControlLabel_8c33cd98__ from "@mui/material/FormControlLabel";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__ from "@mui/material/Card";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_LinearProgress_13636fa3__ from "@mui/material/LinearProgress";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemAvatar_037fd911__ from "@mui/material/ListItemAvatar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Select_bb5d0ab2__ from "@mui/material/Select";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Slide_61aa8233__ from "@mui/material/Slide";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Switch_72bb925c__ from "@mui/material/Switch";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_InputBase_7d3cd5a3__ from "@mui/material/InputBase";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Skeleton_cf835446__ from "@mui/material/Skeleton";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_TablePagination_0e00fcfb__ from "@mui/material/TablePagination";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_CssBaseline_6a578862__ from "@mui/material/CssBaseline";
var __webpack_modules__ = {
    "./node_modules/attr-accept/dist/es/index.js": function(__unused_webpack_module, exports) {
        exports["default"] = function(file, acceptedFiles) {
            if (file && acceptedFiles) {
                var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
                var fileName = file.name || '';
                var mimeType = (file.type || '').toLowerCase();
                var baseMimeType = mimeType.replace(/\/.*$/, '');
                return acceptedFilesArray.some(function(type) {
                    var validType = type.trim().toLowerCase();
                    if ('.' === validType.charAt(0)) return fileName.toLowerCase().endsWith(validType);
                    if (validType.endsWith('/*')) return baseMimeType === validType.replace(/\/.*$/, '');
                    return mimeType === validType;
                });
            }
            return true;
        };
    },
    "./node_modules/lodash/_DataView.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var DataView = getNative(root, 'DataView');
        module.exports = DataView;
    },
    "./node_modules/lodash/_Map.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var Map1 = getNative(root, 'Map');
        module.exports = Map1;
    },
    "./node_modules/lodash/_Promise.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var Promise1 = getNative(root, 'Promise');
        module.exports = Promise1;
    },
    "./node_modules/lodash/_Set.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var Set1 = getNative(root, 'Set');
        module.exports = Set1;
    },
    "./node_modules/lodash/_Symbol.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var root = __webpack_require__("./node_modules/lodash/_root.js");
        var Symbol1 = root.Symbol;
        module.exports = Symbol1;
    },
    "./node_modules/lodash/_WeakMap.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var WeakMap1 = getNative(root, 'WeakMap');
        module.exports = WeakMap1;
    },
    "./node_modules/lodash/_baseGetTag.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var Symbol1 = __webpack_require__("./node_modules/lodash/_Symbol.js"), getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"), objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");
        var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
        var symToStringTag = Symbol1 ? Symbol1.toStringTag : void 0;
        function baseGetTag(value) {
            if (null == value) return void 0 === value ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        module.exports = baseGetTag;
    },
    "./node_modules/lodash/_baseIsArguments.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var argsTag = '[object Arguments]';
        function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        module.exports = baseIsArguments;
    },
    "./node_modules/lodash/_baseIsNative.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"), isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"), isObject = __webpack_require__("./node_modules/lodash/isObject.js"), toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var funcProto = Function.prototype, objectProto = Object.prototype;
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        module.exports = baseIsNative;
    },
    "./node_modules/lodash/_baseIsTypedArray.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isLength = __webpack_require__("./node_modules/lodash/isLength.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        module.exports = baseIsTypedArray;
    },
    "./node_modules/lodash/_baseKeys.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"), nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object(object))if (hasOwnProperty.call(object, key) && 'constructor' != key) result.push(key);
            return result;
        }
        module.exports = baseKeys;
    },
    "./node_modules/lodash/_baseUnary.js": function(module) {
        function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        module.exports = baseUnary;
    },
    "./node_modules/lodash/_coreJsData.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var root = __webpack_require__("./node_modules/lodash/_root.js");
        var coreJsData = root['__core-js_shared__'];
        module.exports = coreJsData;
    },
    "./node_modules/lodash/_freeGlobal.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var freeGlobal = 'object' == typeof __webpack_require__.g && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
        module.exports = freeGlobal;
    },
    "./node_modules/lodash/_getNative.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"), getValue = __webpack_require__("./node_modules/lodash/_getValue.js");
        function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : void 0;
        }
        module.exports = getNative;
    },
    "./node_modules/lodash/_getRawTag.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var Symbol1 = __webpack_require__("./node_modules/lodash/_Symbol.js");
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var nativeObjectToString = objectProto.toString;
        var symToStringTag = Symbol1 ? Symbol1.toStringTag : void 0;
        function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = void 0;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) if (isOwn) value[symToStringTag] = tag;
            else delete value[symToStringTag];
            return result;
        }
        module.exports = getRawTag;
    },
    "./node_modules/lodash/_getTag.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"), Map1 = __webpack_require__("./node_modules/lodash/_Map.js"), Promise1 = __webpack_require__("./node_modules/lodash/_Promise.js"), Set1 = __webpack_require__("./node_modules/lodash/_Set.js"), WeakMap1 = __webpack_require__("./node_modules/lodash/_WeakMap.js"), baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
        var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
        var dataViewTag = '[object DataView]';
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map1), promiseCtorString = toSource(Promise1), setCtorString = toSource(Set1), weakMapCtorString = toSource(WeakMap1);
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map1 && getTag(new Map1) != mapTag || Promise1 && getTag(Promise1.resolve()) != promiseTag || Set1 && getTag(new Set1) != setTag || WeakMap1 && getTag(new WeakMap1) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        module.exports = getTag;
    },
    "./node_modules/lodash/_getValue.js": function(module) {
        function getValue(object, key) {
            return null == object ? void 0 : object[key];
        }
        module.exports = getValue;
    },
    "./node_modules/lodash/_isMasked.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");
        var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        module.exports = isMasked;
    },
    "./node_modules/lodash/_isPrototype.js": function(module) {
        var objectProto = Object.prototype;
        function isPrototype(value) {
            var Ctor = value && value.constructor, proto = 'function' == typeof Ctor && Ctor.prototype || objectProto;
            return value === proto;
        }
        module.exports = isPrototype;
    },
    "./node_modules/lodash/_nativeKeys.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
        var nativeKeys = overArg(Object.keys, Object);
        module.exports = nativeKeys;
    },
    "./node_modules/lodash/_nodeUtil.js": function(module, exports, __webpack_require__) {
        module = __webpack_require__.nmd(module);
        var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
            try {
                var types = freeModule && freeModule.require && freeModule.require('util').types;
                if (types) return types;
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        }();
        module.exports = nodeUtil;
    },
    "./node_modules/lodash/_objectToString.js": function(module) {
        var objectProto = Object.prototype;
        var nativeObjectToString = objectProto.toString;
        function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        module.exports = objectToString;
    },
    "./node_modules/lodash/_overArg.js": function(module) {
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        module.exports = overArg;
    },
    "./node_modules/lodash/_root.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
        var freeSelf = 'object' == typeof self && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function('return this')();
        module.exports = root;
    },
    "./node_modules/lodash/_toSource.js": function(module) {
        var funcProto = Function.prototype;
        var funcToString = funcProto.toString;
        function toSource(func) {
            if (null != func) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        module.exports = toSource;
    },
    "./node_modules/lodash/isArguments.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var propertyIsEnumerable = objectProto.propertyIsEnumerable;
        var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        module.exports = isArguments;
    },
    "./node_modules/lodash/isArray.js": function(module) {
        var isArray = Array.isArray;
        module.exports = isArray;
    },
    "./node_modules/lodash/isArrayLike.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"), isLength = __webpack_require__("./node_modules/lodash/isLength.js");
        function isArrayLike(value) {
            return null != value && isLength(value.length) && !isFunction(value);
        }
        module.exports = isArrayLike;
    },
    "./node_modules/lodash/isBuffer.js": function(module, exports, __webpack_require__) {
        module = __webpack_require__.nmd(module);
        var root = __webpack_require__("./node_modules/lodash/_root.js"), stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var Buffer = moduleExports ? root.Buffer : void 0;
        var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
        var isBuffer = nativeIsBuffer || stubFalse;
        module.exports = isBuffer;
    },
    "./node_modules/lodash/isEmpty.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"), getTag = __webpack_require__("./node_modules/lodash/_getTag.js"), isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"), isArray = __webpack_require__("./node_modules/lodash/isArray.js"), isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"), isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"), isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"), isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
        var mapTag = '[object Map]', setTag = '[object Set]';
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        function isEmpty(value) {
            if (null == value) return true;
            if (isArrayLike(value) && (isArray(value) || 'string' == typeof value || 'function' == typeof value.splice || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value)if (hasOwnProperty.call(value, key)) return false;
            return true;
        }
        module.exports = isEmpty;
    },
    "./node_modules/lodash/isFunction.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isObject = __webpack_require__("./node_modules/lodash/isObject.js");
        var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
        function isFunction(value) {
            if (!isObject(value)) return false;
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        module.exports = isFunction;
    },
    "./node_modules/lodash/isLength.js": function(module) {
        var MAX_SAFE_INTEGER = 9007199254740991;
        function isLength(value) {
            return 'number' == typeof value && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        module.exports = isLength;
    },
    "./node_modules/lodash/isNaN.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isNumber = __webpack_require__("./node_modules/lodash/isNumber.js");
        function isNaN1(value) {
            return isNumber(value) && value != +value;
        }
        module.exports = isNaN1;
    },
    "./node_modules/lodash/isNumber.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var numberTag = '[object Number]';
        function isNumber(value) {
            return 'number' == typeof value || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        module.exports = isNumber;
    },
    "./node_modules/lodash/isObject.js": function(module) {
        function isObject(value) {
            var type = typeof value;
            return null != value && ('object' == type || 'function' == type);
        }
        module.exports = isObject;
    },
    "./node_modules/lodash/isObjectLike.js": function(module) {
        function isObjectLike(value) {
            return null != value && 'object' == typeof value;
        }
        module.exports = isObjectLike;
    },
    "./node_modules/lodash/isTypedArray.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"), baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"), nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
        var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        module.exports = isTypedArray;
    },
    "./node_modules/lodash/isUndefined.js": function(module) {
        function isUndefined(value) {
            return void 0 === value;
        }
        module.exports = isUndefined;
    },
    "./node_modules/lodash/stubFalse.js": function(module) {
        function stubFalse() {
            return false;
        }
        module.exports = stubFalse;
    },
    "./node_modules/object-assign/index.js": function(module) {
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
            if (null == val) throw new TypeError('Object.assign cannot be called with null or undefined');
            return Object(val);
        }
        function shouldUseNative() {
            try {
                if (!Object.assign) return false;
                var test1 = new String('abc');
                test1[5] = 'de';
                if ('5' === Object.getOwnPropertyNames(test1)[0]) return false;
                var test2 = {};
                for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
                var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                });
                if ('0123456789' !== order2.join('')) return false;
                var test3 = {};
                'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                    test3[letter] = letter;
                });
                if ('abcdefghijklmnopqrst' !== Object.keys(Object.assign({}, test3)).join('')) return false;
                return true;
            } catch (err) {
                return false;
            }
        }
        module.exports = shouldUseNative() ? Object.assign : function(target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for(var s = 1; s < arguments.length; s++){
                from = Object(arguments[s]);
                for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                }
            }
            return to;
        };
    },
    "./node_modules/prop-types/checkPropTypes.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var printWarning = function() {};
        if ('production' !== process.env.NODE_ENV) {
            var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
            var loggedTypeFailures = {};
            var has = __webpack_require__("./node_modules/prop-types/lib/has.js");
            printWarning = function(text) {
                var message = 'Warning: ' + text;
                if ('undefined' != typeof console) console.error(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            };
        }
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
            if ('production' !== process.env.NODE_ENV) {
                for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                    var error;
                    try {
                        if ('function' != typeof typeSpecs[typeSpecName]) {
                            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                            err.name = 'Invariant Violation';
                            throw err;
                        }
                        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                    } catch (ex) {
                        error = ex;
                    }
                    if (error && !(error instanceof Error)) printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
                    if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                        loggedTypeFailures[error.message] = true;
                        var stack = getStack ? getStack() : '';
                        printWarning('Failed ' + location + ' type: ' + error.message + (null != stack ? stack : ''));
                    }
                }
            }
        }
        checkPropTypes.resetWarningCache = function() {
            if ('production' !== process.env.NODE_ENV) loggedTypeFailures = {};
        };
        module.exports = checkPropTypes;
    },
    "./node_modules/prop-types/factoryWithThrowingShims.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        module.exports = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            var ReactPropTypes = {
                array: shim,
                bigint: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    },
    "./node_modules/prop-types/factoryWithTypeCheckers.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var ReactIs = __webpack_require__("./node_modules/prop-types/node_modules/react-is/index.js");
        var assign = __webpack_require__("./node_modules/object-assign/index.js");
        var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
        var has = __webpack_require__("./node_modules/prop-types/lib/has.js");
        var checkPropTypes = __webpack_require__("./node_modules/prop-types/checkPropTypes.js");
        var printWarning = function() {};
        if ('production' !== process.env.NODE_ENV) printWarning = function(text) {
            var message = 'Warning: ' + text;
            if ('undefined' != typeof console) console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        };
        function emptyFunctionThatReturnsNull() {
            return null;
        }
        module.exports = function(isValidElement, throwOnDirectAccess) {
            var ITERATOR_SYMBOL = 'function' == typeof Symbol && Symbol.iterator;
            var FAUX_ITERATOR_SYMBOL = '@@iterator';
            function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if ('function' == typeof iteratorFn) return iteratorFn;
            }
            var ANONYMOUS = '<<anonymous>>';
            var ReactPropTypes = {
                array: createPrimitiveTypeChecker('array'),
                bigint: createPrimitiveTypeChecker('bigint'),
                bool: createPrimitiveTypeChecker('boolean'),
                func: createPrimitiveTypeChecker('function'),
                number: createPrimitiveTypeChecker('number'),
                object: createPrimitiveTypeChecker('object'),
                string: createPrimitiveTypeChecker('string'),
                symbol: createPrimitiveTypeChecker('symbol'),
                any: createAnyTypeChecker(),
                arrayOf: createArrayOfTypeChecker,
                element: createElementTypeChecker(),
                elementType: createElementTypeTypeChecker(),
                instanceOf: createInstanceTypeChecker,
                node: createNodeChecker(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
            };
            function is(x, y) {
                if (x === y) return 0 !== x || 1 / x === 1 / y;
                return x !== x && y !== y;
            }
            function PropTypeError(message, data) {
                this.message = message;
                this.data = data && 'object' == typeof data ? data : {};
                this.stack = '';
            }
            PropTypeError.prototype = Error.prototype;
            function createChainableTypeChecker(validate) {
                if ('production' !== process.env.NODE_ENV) {
                    var manualPropTypeCallCache = {};
                    var manualPropTypeWarningCount = 0;
                }
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    componentName = componentName || ANONYMOUS;
                    propFullName = propFullName || propName;
                    if (secret !== ReactPropTypesSecret) {
                        if (throwOnDirectAccess) {
                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            err.name = 'Invariant Violation';
                            throw err;
                        } else if ('production' !== process.env.NODE_ENV && 'undefined' != typeof console) {
                            var cacheKey = componentName + ':' + propName;
                            if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
                                printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
                                manualPropTypeCallCache[cacheKey] = true;
                                manualPropTypeWarningCount++;
                            }
                        }
                    }
                    if (null != props[propName]) return validate(props, propName, componentName, location, propFullName);
                    if (isRequired) {
                        if (null === props[propName]) return new PropTypeError('The ' + location + ' `' + propFullName + "` is marked as required in `" + componentName + '`, but its value is `null`.');
                        return new PropTypeError('The ' + location + ' `' + propFullName + "` is marked as required in `" + componentName + '`, but its value is `undefined`.');
                    }
                    return null;
                }
                var chainedCheckType = checkType.bind(null, false);
                chainedCheckType.isRequired = checkType.bind(null, true);
                return chainedCheckType;
            }
            function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== expectedType) {
                        var preciseType = getPreciseType(propValue);
                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `') + componentName + "`, expected `" + expectedType + '`.', {
                            expectedType: expectedType
                        });
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createAnyTypeChecker() {
                return createChainableTypeChecker(emptyFunctionThatReturnsNull);
            }
            function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ('function' != typeof typeChecker) return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                        var propType = getPropType(propValue);
                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `') + componentName + '`, expected an array.');
                    }
                    for(var i = 0; i < propValue.length; i++){
                        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createElementTypeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    if (!isValidElement(propValue)) {
                        var propType = getPropType(propValue);
                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `') + componentName + '`, expected a single ReactElement.');
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createElementTypeTypeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    if (!ReactIs.isValidElementType(propValue)) {
                        var propType = getPropType(propValue);
                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `') + componentName + '`, expected a single ReactElement type.');
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!(props[propName] instanceof expectedClass)) {
                        var expectedClassName = expectedClass.name || ANONYMOUS;
                        var actualClassName = getClassName(props[propName]);
                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `') + componentName + "`, expected instance of `" + expectedClassName + '`.');
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createEnumTypeChecker(expectedValues) {
                if (!Array.isArray(expectedValues)) {
                    if ('production' !== process.env.NODE_ENV) arguments.length > 1 ? printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : printWarning('Invalid argument supplied to oneOf, expected an array.');
                    return emptyFunctionThatReturnsNull;
                }
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    for(var i = 0; i < expectedValues.length; i++)if (is(propValue, expectedValues[i])) return null;
                    var valuesString = JSON.stringify(expectedValues, function(key, value) {
                        var type = getPreciseType(value);
                        if ('symbol' === type) return String(value);
                        return value;
                    });
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ') + valuesString + '.');
                }
                return createChainableTypeChecker(validate);
            }
            function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ('function' != typeof typeChecker) return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if ('object' !== propType) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `') + componentName + '`, expected an object.');
                    for(var key in propValue)if (has(propValue, key)) {
                        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createUnionTypeChecker(arrayOfTypeCheckers) {
                if (!Array.isArray(arrayOfTypeCheckers)) {
                    'production' !== process.env.NODE_ENV && printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
                    return emptyFunctionThatReturnsNull;
                }
                for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                    var checker = arrayOfTypeCheckers[i];
                    if ('function' != typeof checker) {
                        printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                        return emptyFunctionThatReturnsNull;
                    }
                }
                function validate(props, propName, componentName, location, propFullName) {
                    var expectedTypes = [];
                    for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                        var checker = arrayOfTypeCheckers[i];
                        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                        if (null == checkerResult) return null;
                        if (checkerResult.data && has(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
                    }
                    var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`') + expectedTypesMessage + '.');
                }
                return createChainableTypeChecker(validate);
            }
            function createNodeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + "` supplied to `" + componentName + '`, expected a ReactNode.');
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function invalidValidatorError(componentName, location, propFullName, key, type) {
                return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + '`.');
            }
            function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if ('object' !== propType) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + "` supplied to `" + componentName + '`, expected `object`.');
                    for(var key in shapeTypes){
                        var checker = shapeTypes[key];
                        if ('function' != typeof checker) return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                        if (error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if ('object' !== propType) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + "` supplied to `" + componentName + '`, expected `object`.');
                    var allKeys = assign({}, props[propName], shapeTypes);
                    for(var key in allKeys){
                        var checker = shapeTypes[key];
                        if (has(shapeTypes, key) && 'function' != typeof checker) return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                        if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                        if (error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function isNode(propValue) {
                switch(typeof propValue){
                    case 'number':
                    case 'string':
                    case 'undefined':
                        return true;
                    case 'boolean':
                        return !propValue;
                    case 'object':
                        if (Array.isArray(propValue)) return propValue.every(isNode);
                        if (null === propValue || isValidElement(propValue)) return true;
                        var iteratorFn = getIteratorFn(propValue);
                        if (!iteratorFn) return false;
                        var iterator = iteratorFn.call(propValue);
                        var step;
                        if (iteratorFn !== propValue.entries) {
                            while(!(step = iterator.next()).done)if (!isNode(step.value)) return false;
                        } else while(!(step = iterator.next()).done){
                            var entry = step.value;
                            if (entry) {
                                if (!isNode(entry[1])) return false;
                            }
                        }
                        return true;
                    default:
                        return false;
                }
            }
            function isSymbol(propType, propValue) {
                if ('symbol' === propType) return true;
                if (!propValue) return false;
                if ('Symbol' === propValue['@@toStringTag']) return true;
                if ('function' == typeof Symbol && propValue instanceof Symbol) return true;
                return false;
            }
            function getPropType(propValue) {
                var propType = typeof propValue;
                if (Array.isArray(propValue)) return 'array';
                if (propValue instanceof RegExp) return 'object';
                if (isSymbol(propType, propValue)) return 'symbol';
                return propType;
            }
            function getPreciseType(propValue) {
                if (null == propValue) return '' + propValue;
                var propType = getPropType(propValue);
                if ('object' === propType) {
                    if (propValue instanceof Date) return 'date';
                    else if (propValue instanceof RegExp) return 'regexp';
                }
                return propType;
            }
            function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch(type){
                    case 'array':
                    case 'object':
                        return 'an ' + type;
                    case 'boolean':
                    case 'date':
                    case 'regexp':
                        return 'a ' + type;
                    default:
                        return type;
                }
            }
            function getClassName(propValue) {
                if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                return propValue.constructor.name;
            }
            ReactPropTypes.checkPropTypes = checkPropTypes;
            ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    },
    "./node_modules/prop-types/index.js": function(module, __unused_webpack_exports, __webpack_require__) {
        if ('production' !== process.env.NODE_ENV) {
            var ReactIs = __webpack_require__("./node_modules/prop-types/node_modules/react-is/index.js");
            var throwOnDirectAccess = true;
            module.exports = __webpack_require__("./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
        } else module.exports = __webpack_require__("./node_modules/prop-types/factoryWithThrowingShims.js")();
    },
    "./node_modules/prop-types/lib/ReactPropTypesSecret.js": function(module) {
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        module.exports = ReactPropTypesSecret;
    },
    "./node_modules/prop-types/lib/has.js": function(module) {
        module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
    },
    "./node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js": function(__unused_webpack_module, exports) {
        /** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ if ("production" !== process.env.NODE_ENV) (function() {
            'use strict';
            var hasSymbol = 'function' == typeof Symbol && Symbol.for;
            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
            var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
            var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
            var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
            var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
            var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
            var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
            var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
            var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
            var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
            var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
            var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
            function isValidElementType(type) {
                return 'string' == typeof type || 'function' == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || 'object' == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
            }
            function typeOf(object) {
                if ('object' == typeof object && null !== object) {
                    var $$typeof = object.$$typeof;
                    switch($$typeof){
                        case REACT_ELEMENT_TYPE:
                            var type = object.type;
                            switch(type){
                                case REACT_ASYNC_MODE_TYPE:
                                case REACT_CONCURRENT_MODE_TYPE:
                                case REACT_FRAGMENT_TYPE:
                                case REACT_PROFILER_TYPE:
                                case REACT_STRICT_MODE_TYPE:
                                case REACT_SUSPENSE_TYPE:
                                    return type;
                                default:
                                    var $$typeofType = type && type.$$typeof;
                                    switch($$typeofType){
                                        case REACT_CONTEXT_TYPE:
                                        case REACT_FORWARD_REF_TYPE:
                                        case REACT_LAZY_TYPE:
                                        case REACT_MEMO_TYPE:
                                        case REACT_PROVIDER_TYPE:
                                            return $$typeofType;
                                        default:
                                            return $$typeof;
                                    }
                            }
                        case REACT_PORTAL_TYPE:
                            return $$typeof;
                    }
                }
            }
            var AsyncMode = REACT_ASYNC_MODE_TYPE;
            var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
            var ContextConsumer = REACT_CONTEXT_TYPE;
            var ContextProvider = REACT_PROVIDER_TYPE;
            var Element1 = REACT_ELEMENT_TYPE;
            var ForwardRef = REACT_FORWARD_REF_TYPE;
            var Fragment = REACT_FRAGMENT_TYPE;
            var Lazy = REACT_LAZY_TYPE;
            var Memo = REACT_MEMO_TYPE;
            var Portal = REACT_PORTAL_TYPE;
            var Profiler = REACT_PROFILER_TYPE;
            var StrictMode = REACT_STRICT_MODE_TYPE;
            var Suspense = REACT_SUSPENSE_TYPE;
            var hasWarnedAboutDeprecatedIsAsyncMode = false;
            function isAsyncMode(object) {
                if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                    hasWarnedAboutDeprecatedIsAsyncMode = true;
                    console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                }
                return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
                return 'object' == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            exports.AsyncMode = AsyncMode;
            exports.ConcurrentMode = ConcurrentMode;
            exports.ContextConsumer = ContextConsumer;
            exports.ContextProvider = ContextProvider;
            exports.Element = Element1;
            exports.ForwardRef = ForwardRef;
            exports.Fragment = Fragment;
            exports.Lazy = Lazy;
            exports.Memo = Memo;
            exports.Portal = Portal;
            exports.Profiler = Profiler;
            exports.StrictMode = StrictMode;
            exports.Suspense = Suspense;
            exports.isAsyncMode = isAsyncMode;
            exports.isConcurrentMode = isConcurrentMode;
            exports.isContextConsumer = isContextConsumer;
            exports.isContextProvider = isContextProvider;
            exports.isElement = isElement;
            exports.isForwardRef = isForwardRef;
            exports.isFragment = isFragment;
            exports.isLazy = isLazy;
            exports.isMemo = isMemo;
            exports.isPortal = isPortal;
            exports.isProfiler = isProfiler;
            exports.isStrictMode = isStrictMode;
            exports.isSuspense = isSuspense;
            exports.isValidElementType = isValidElementType;
            exports.typeOf = typeOf;
        })();
    },
    "./node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js": function(__unused_webpack_module, exports) {
        /** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var b = "function" == typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
        function z(a) {
            if ("object" == typeof a && null !== a) {
                var u = a.$$typeof;
                switch(u){
                    case c:
                        switch(a = a.type){
                            case l:
                            case m:
                            case e:
                            case g:
                            case f:
                            case p:
                                return a;
                            default:
                                switch(a = a && a.$$typeof){
                                    case k:
                                    case n:
                                    case t:
                                    case r:
                                    case h:
                                        return a;
                                    default:
                                        return u;
                                }
                        }
                    case d:
                        return u;
                }
            }
        }
        function A(a) {
            return z(a) === m;
        }
        exports.AsyncMode = l;
        exports.ConcurrentMode = m;
        exports.ContextConsumer = k;
        exports.ContextProvider = h;
        exports.Element = c;
        exports.ForwardRef = n;
        exports.Fragment = e;
        exports.Lazy = t;
        exports.Memo = r;
        exports.Portal = d;
        exports.Profiler = g;
        exports.StrictMode = f;
        exports.Suspense = p;
        exports.isAsyncMode = function(a) {
            return A(a) || z(a) === l;
        };
        exports.isConcurrentMode = A;
        exports.isContextConsumer = function(a) {
            return z(a) === k;
        };
        exports.isContextProvider = function(a) {
            return z(a) === h;
        };
        exports.isElement = function(a) {
            return "object" == typeof a && null !== a && a.$$typeof === c;
        };
        exports.isForwardRef = function(a) {
            return z(a) === n;
        };
        exports.isFragment = function(a) {
            return z(a) === e;
        };
        exports.isLazy = function(a) {
            return z(a) === t;
        };
        exports.isMemo = function(a) {
            return z(a) === r;
        };
        exports.isPortal = function(a) {
            return z(a) === d;
        };
        exports.isProfiler = function(a) {
            return z(a) === g;
        };
        exports.isStrictMode = function(a) {
            return z(a) === f;
        };
        exports.isSuspense = function(a) {
            return z(a) === p;
        };
        exports.isValidElementType = function(a) {
            return "string" == typeof a || "function" == typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" == typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
        };
        exports.typeOf = z;
    },
    "./node_modules/prop-types/node_modules/react-is/index.js": function(module, __unused_webpack_exports, __webpack_require__) {
        if ('production' === process.env.NODE_ENV) module.exports = __webpack_require__("./node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js");
        else module.exports = __webpack_require__("./node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js");
    }
};
var __webpack_module_cache__ = {};
function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
        id: moduleId,
        loaded: false,
        exports: {}
    };
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    module.loaded = true;
    return module.exports;
}
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.g = (()=>{
        if ('object' == typeof globalThis) return globalThis;
        try {
            return this || new Function('return this')();
        } catch (e) {
            if ('object' == typeof window) return window;
        }
    })();
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.nmd = (module)=>{
        module.paths = [];
        if (!module.children) module.children = [];
        return module;
    };
})();
const Bluex = {
    0: "#FCFDFF",
    50: "#F1F4FC",
    100: "#DAE2F6",
    200: "#B1C2ED",
    300: "#5378d7",
    400: "#1246C8",
    500: "#0E379E",
    600: "#0A266D",
    700: "#05153D"
};
const Tealx = {
    0: "#dcf8f1",
    100: "#b8f1e2",
    200: "#7ae4ca",
    300: "#3dd8b1",
    400: "#00bb8c",
    500: "#008a67",
    600: "#006a50",
    700: "#00392b"
};
const Pinkx = {
    0: "#ffecf2",
    100: "#fecfdd",
    200: "#fd9cb9",
    300: "#fc608e",
    400: "#d72f60",
    500: "#a3284c",
    600: "#6f1b34",
    700: "#3f0f1d"
};
const DeepBluex = {
    0: "#eaecf0",
    100: "#cbcfda",
    200: "#979fb5",
    300: "#626e90",
    400: "#2e3e6b",
    500: "#232f50",
    600: "#171f36",
    700: "#0c101b"
};
const Nudex = {
    0: "#fffefd",
    100: "#fefcfa",
    200: "#fdfaf6",
    300: "#fcf7f1",
    400: "#fcf5ed",
    500: "#eee7dd",
    600: "#bab4ac",
    700: "#85817b"
};
const Purplex = {
    0: "#f8f7fe",
    100: "#e1dff9",
    200: "#c2bff4",
    300: "#a49fee",
    400: "#867fe8",
    500: "#685fe3",
    600: "#5148cb",
    700: "#403aa2"
};
const Napolix = {
    0: "#f3fbff",
    100: "#d6f2ff",
    200: "#b5e7ff",
    300: "#83d8ff",
    400: "#5acaff",
    500: "#179fdf",
    600: "#1176a6",
    700: "#0b4d6c"
};
const Celestex = {
    0: "#e7fafd",
    100: "#aff0f8",
    200: "#4dddef",
    300: "#00c4db",
    400: "#00a9bd",
    500: "#008fa0",
    600: "#007684",
    700: "#005e69"
};
const Orangex = {
    0: "#fff4e6",
    100: "#ffe3bf",
    200: "#ffc680",
    300: "#ffaa40",
    400: "#ff8d00",
    500: "#bf6a00",
    600: "#804700",
    700: "#402300"
};
const Redx = {
    0: "#fbecec",
    100: "#f6d0d0",
    200: "#eca1a1",
    300: "#e37171",
    400: "#d94242",
    500: "#d01313",
    600: "#b60000",
    700: "#900000"
};
const Greenx = {
    0: "#ddf5eb",
    100: "#aee6d0",
    200: "#5acd9e",
    300: "#2bac78",
    400: "#22885f",
    500: "#1a6648",
    600: "#124631",
    700: "#0a291c"
};
const Greyx = {
    0: "#F9FAFA",
    100: "#F1F2F3",
    200: "#E3E5E8",
    300: "#D4D8DC",
    400: "#C6CBD1",
    500: "#B8BEC5",
    600: "#93989E",
    700: "#6E7276",
    800: "#4A4C4F",
    900: "#252627"
};
const Goldenx = {
    0: "#FDF8E6",
    100: "#F6EBC2",
    200: "#EDD98F",
    300: "#E2C05A",
    400: "#B3931E",
    500: "#947E05",
    600: "#664D00",
    700: "#543C00"
};
const AlphaDeepColor = "#171f36";
const AlphaDeep = {
    4: `${AlphaDeepColor}0a`,
    8: `${AlphaDeepColor}14`,
    10: `${AlphaDeepColor}1a`,
    12: `${AlphaDeepColor}1f`,
    16: `${AlphaDeepColor}29`,
    20: `${AlphaDeepColor}33`,
    24: `${AlphaDeepColor}3d`,
    30: `${AlphaDeepColor}4d`,
    38: `${AlphaDeepColor}61`,
    50: `${AlphaDeepColor}80`,
    56: `${AlphaDeepColor}8f`,
    60: `${AlphaDeepColor}99`,
    70: `${AlphaDeepColor}b3`
};
const GREY_BORDER_CARD = "rgba(23, 31, 54, 0.12)";
const GREY_BORDER_CARD_MIDDLE_OPACITY = "rgba(23, 31, 54, 0.5)";
const GREY_BORDER_CARD_HOVERED = "rgba(23, 31, 54, 0.30)";
const GREY_BORDER_CARD_HOVERED_MIDDLE_OPACITY = "rgba(23, 31, 54, 0.5)";
const WHITE_TRANSPARENT_LIGHT = "rgba(0, 0, 0, 0.08)";
const White = {
    main: "#FFFFFF",
    light: "rgba(255, 255, 255, 0.12)",
    dark: "rgba(255, 255, 255, 0.30)",
    contrastText: "rgba(255, 255, 255, 0.08)",
    focus: "rgba(255, 255, 255, 0.12)",
    focusVisible: "rgba(255, 255, 255, 0.30)",
    hover: "rgba(255, 255, 255, 0.04)",
    outlinedBorder: "rgba(255, 255, 255, 0.50)",
    selected: "rgba(255, 255, 255, 0.08)"
};
const palette_Common = {
    white: White,
    dark: {
        main: DeepBluex["600"],
        hover: AlphaDeep["4"]
    }
};
const palette_Text = {
    primary: DeepBluex["600"],
    secondary: AlphaDeep["70"],
    disabled: AlphaDeep["38"]
};
const palette_Primary = {
    main: Bluex["400"],
    light: Bluex["50"],
    dark: Bluex["500"],
    contrastText: palette_Common.white.main,
    focus: "rgba(18, 70, 200, 0.12)",
    focusVisible: "rgba(18, 70, 200, 0.10)",
    hover: "rgba(18, 70, 200, 0.04)",
    outlinedBorder: "rgba(18, 70, 200, 0.50)",
    selected: "rgba(18, 70, 200, 0.08)"
};
const palette_Secondary = {
    main: Tealx["400"],
    light: Tealx["0"],
    dark: Tealx["500"],
    contrastText: palette_Text.primary,
    focus: "rgba(0, 187, 140, 0.12)",
    focusVisible: "rgba(0, 187, 140, 0.10)",
    hover: "rgba(0, 187, 140, 0.04)",
    outlinedBorder: "rgba(0, 187, 140, 0.50)",
    selected: "rgba(0, 187, 140, 0.08)"
};
const ErrorToken = {
    main: Redx["400"],
    light: Redx["200"],
    dark: Redx["600"],
    contrastText: palette_Common.white.main,
    focusVisible: "rgba(217, 66, 66, 0.10)",
    hover: "rgba(217, 66, 66, 0.04)",
    outlinedBorder: "rgba(217, 66, 66, 0.50)",
    selected: "rgba(217, 66, 66, 0.08)"
};
const palette_Warning = {
    main: Orangex["400"],
    light: Orangex["100"],
    dark: Orangex["600"],
    contrastText: palette_Common.white.main,
    hover: "rgba(255, 141, 0, 0.04)",
    focusVisible: "rgba(255, 141, 0, 0.10)",
    outlinedBorder: "rgba(255, 141, 0, 0.50)",
    selected: "rgba(255, 141, 0, 0.08)"
};
const palette_Info = {
    main: Napolix["500"],
    light: Napolix["0"],
    dark: Napolix["600"],
    contrastText: palette_Common.white.main,
    focusVisible: "rgba(23, 159, 223, 0.10)",
    hover: "rgba(23, 159, 223, 0.04)",
    outlinedBorder: "rgba(23, 159, 223, 0.50)",
    selected: "rgba(23, 159, 223, 0.08)"
};
const palette_Success = {
    main: Greenx["400"],
    light: Greenx["0"],
    dark: Greenx["500"],
    contrastText: palette_Common.white.main,
    hover: "rgba(34, 136, 95, 0.04)",
    focusVisible: "rgba(34, 136, 95, 0.08)",
    outlinedBorder: "rgba(34, 136, 95, 0.50)",
    selected: "rgba(34, 136, 95, 0.08)"
};
const palette_Action = {
    active: AlphaDeep["56"],
    disabled: AlphaDeep["24"],
    disabledBackground: AlphaDeep["12"],
    focus: AlphaDeep["12"],
    hover: AlphaDeep["4"],
    selected: AlphaDeep["8"]
};
const palette_Tertiary = {
    main: Pinkx["400"],
    light: Pinkx["0"],
    dark: Pinkx["500"],
    contrastText: palette_Common.white.main,
    focus: "rgba(215, 47, 96, 0.12)",
    focusVisible: "rgba(215, 47, 96, 0.10)",
    hover: "rgba(215, 47, 96, 0.04)",
    outlinedBorder: "rgba(215, 47, 96, 0.50)",
    selected: "rgba(215, 47, 96, 0.08)"
};
const palette_Purple = {
    main: Purplex["600"],
    light: Purplex["100"],
    dark: Purplex["700"],
    contrastText: palette_Common.white.main
};
const PurpleLight = {
    main: Purplex["0"],
    dark: Purplex["100"],
    contrastText: Purplex["600"],
    focus: "rgba(134, 127, 232, 0.12)",
    focusVisible: "rgba(134, 127, 232, 0.10)",
    hover: "rgba(134, 127, 232, 0.12)",
    outlinedBorder: "rgba(134, 95, 227, 0.50)",
    selected: "rgba(134, 127, 232, 0.8)"
};
const palette_DeepBlue = {
    main: DeepBluex["300"],
    light: DeepBluex["0"],
    dark: DeepBluex["700"],
    contrastText: palette_Common.white.main
};
const palette_Border = {
    main: AlphaDeep["12"],
    light: AlphaDeep["10"],
    dark: AlphaDeep["30"],
    outlinedBorder: AlphaDeep["50"],
    selected: AlphaDeep["8"],
    focus: AlphaDeep["12"],
    focusVisible: AlphaDeep["30"],
    fillBackdrop: AlphaDeep["50"],
    contrastText: ""
};
const palette_Background = {
    default: Greyx["0"],
    paper: palette_Common.white.main
};
const DIVIDER_COLOR = "#171F361F";
const TRANSPARENT_COLOR = "transparent";
const palette = {
    primary: {
        main: palette_Primary.main,
        light: palette_Primary.light,
        dark: palette_Primary.dark,
        contrastText: palette_Primary.contrastText
    },
    secondary: {
        main: palette_Secondary.main,
        light: palette_Secondary.light,
        dark: palette_Secondary.dark,
        contrastText: palette_Secondary.contrastText
    },
    error: {
        main: ErrorToken.main,
        light: ErrorToken.light,
        dark: ErrorToken.dark,
        contrastText: ErrorToken.contrastText
    },
    warning: {
        main: palette_Warning.main,
        light: palette_Warning.light,
        dark: palette_Warning.dark,
        contrastText: palette_Warning.contrastText
    },
    info: {
        main: palette_Info.main,
        light: palette_Info.light,
        dark: palette_Info.dark,
        contrastText: palette_Info.contrastText
    },
    success: {
        main: palette_Success.main,
        light: palette_Success.light,
        dark: palette_Success.dark,
        contrastText: palette_Success.contrastText
    },
    white: {
        main: White.main,
        light: White.light,
        dark: White.dark,
        contrastText: White.contrastText
    },
    text: {
        primary: palette_Text.primary,
        secondary: palette_Text.secondary,
        disabled: palette_Text.disabled
    },
    action: {
        active: palette_Action.active,
        hover: palette_Action.hover,
        selected: palette_Action.selected,
        focus: palette_Action.focus,
        disabled: palette_Action.disabled,
        disabledBackground: palette_Action.disabledBackground
    },
    tertiary: {
        main: palette_Tertiary.main,
        light: palette_Tertiary.light,
        dark: palette_Tertiary.dark,
        contrastText: palette_Tertiary.contrastText
    },
    purple: {
        main: palette_Purple.main,
        light: palette_Purple.light,
        dark: palette_Purple.dark,
        contrastText: palette_Purple.contrastText
    },
    purpleLight: {
        main: PurpleLight.main,
        dark: PurpleLight.dark,
        contrastText: PurpleLight.contrastText,
        focus: PurpleLight.focus,
        focusVisible: PurpleLight.focusVisible,
        hover: PurpleLight.hover,
        outlinedBorder: PurpleLight.outlinedBorder
    },
    deepBlue: {
        main: palette_DeepBlue.main,
        light: palette_DeepBlue.light,
        dark: palette_DeepBlue.dark,
        contrastText: palette_DeepBlue.contrastText
    },
    border: {
        main: palette_Border.main,
        light: palette_Border.light,
        dark: palette_Border.dark,
        contrastText: palette_Border.contrastText
    },
    tealDusk: {
        main: Tealx["500"],
        light: Tealx["100"],
        dark: Tealx["500"],
        contrastText: "#FFFFFF"
    },
    pinkHaze: {
        main: Purplex["600"],
        light: Purplex["100"],
        dark: Purplex["600"],
        contrastText: "#FFFFFF"
    },
    goldenUmber: {
        main: Goldenx["500"],
        light: Goldenx["100"],
        dark: Goldenx["500"],
        contrastText: "#FFFFFF"
    },
    background: {
        default: palette_Background.default,
        paper: palette_Background.paper
    },
    divider: DIVIDER_COLOR
};
const palette_WorkingTurnsColors = {
    cafOperator: Orangex["400"],
    user: Bluex["400"],
    finalized: Tealx["400"]
};
var displaying_Displaying = /*#__PURE__*/ function(Displaying) {
    Displaying["inherit"] = "inherit";
    Displaying["initial"] = "initial";
    Displaying["inline"] = "inline";
    Displaying["flex"] = "flex";
    Displaying["block"] = "block";
    Displaying["contents"] = "contents";
    Displaying["grid"] = "grid";
    Displaying["inlineBlock"] = "inline-block";
    Displaying["inlineFlex"] = "inline-flex";
    Displaying["inlineGrid"] = "inline-grid";
    Displaying["inlineTable"] = "inline-table";
    Displaying["listItem"] = "list-item";
    Displaying["table"] = "table";
    Displaying["tableCell"] = "table-cell";
    Displaying["none"] = "none";
    Displaying["auto"] = "auto";
    return Displaying;
}({});
var direction_Direction = /*#__PURE__*/ function(Direction) {
    Direction["column"] = "column";
    Direction["row"] = "row";
    Direction["rowReverse"] = "row-reverse";
    Direction["columnReverse"] = "column-reverse";
    return Direction;
}({});
var alignment_Alignment = /*#__PURE__*/ function(Alignment) {
    Alignment["start"] = "start";
    Alignment["end"] = "end";
    Alignment["flexStart"] = "flex-start";
    Alignment["flexEnd"] = "flex-end";
    Alignment["center"] = "center";
    Alignment["left"] = "left";
    Alignment["right"] = "right";
    Alignment["normal"] = "normal";
    Alignment["spaceBetween"] = "space-between";
    Alignment["spaceAround"] = "space-around";
    Alignment["spaceEvenly"] = "space-evenly";
    Alignment["stretch"] = "stretch";
    Alignment["safe"] = "safe";
    Alignment["unsafe"] = "unsafe";
    return Alignment;
}({});
const Spacing = {
    0: "0rem",
    25: "0.025rem",
    125: "0.125rem",
    250: "0.25rem",
    500: "0.5rem",
    650: "0.65rem",
    750: "0.75rem",
    875: "0.875rem",
    1000: "1rem",
    1125: "1.125rem",
    1250: "1.25rem",
    1500: "1.5rem",
    1750: "1.75rem",
    2000: "2rem",
    2180: "2.1875rem",
    2500: "2.5rem",
    3000: "3rem",
    3500: "3.5rem",
    4000: "4rem",
    4500: "4.5rem",
    4750: "4.75rem",
    5000: "5rem",
    6000: "6rem",
    7000: "7rem",
    8000: "8rem",
    10000: "10rem",
    12500: "12.5rem",
    15000: "15rem",
    18750: "18.75rem"
};
const ONE_PIXEL_REM = "0.065rem";
const BorderRadius = {
    none: 0,
    soft: Spacing["125"],
    brand: Spacing["500"],
    paper: Spacing["750"],
    full: "100%"
};
var positioning_Positioning = /*#__PURE__*/ function(Positioning) {
    Positioning["absolute"] = "absolute";
    Positioning["fixed"] = "fixed";
    Positioning["relative"] = "relative";
    Positioning["static"] = "static";
    Positioning["sticky"] = "sticky";
    Positioning["inherit"] = "inherit";
    Positioning["initial"] = "initial";
    Positioning["revert"] = "revert";
    Positioning["revertLayer"] = "revert-layer";
    Positioning["unset"] = "unset";
    Positioning["flexEnd"] = "flex-end";
    return Positioning;
}({});
class Gradient {
    colorName;
    startMainColor;
    fromPercentages;
    toMainColor;
    toPercentages;
    type;
    degree;
    startDarkColor;
    toDarkColor;
    _computedMainColor = new Map();
    _computedDarkColor = new Map();
    getMainColor(opacityScale = 100, overrideToPercentage) {
        const colorMapKey = `${opacityScale}-${overrideToPercentage}`;
        const currentColor = this._computedMainColor.get(colorMapKey);
        if (currentColor) return currentColor;
        const opacity = this._getOpacity(opacityScale);
        const rgbaFrom = this._hexToRgba(this.startMainColor, opacity);
        const rgbaTo = this._hexToRgba(this.toMainColor, opacity);
        const styleWithOpacity = (0, __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.css)`
      ${this.type}(${this.degree}deg, ${rgbaFrom} ${this.fromPercentages}%, ${rgbaTo} ${overrideToPercentage ?? this.toPercentages}%)
    `;
        const styleSerialized = styleWithOpacity.styles.trim();
        this._computedMainColor.set(colorMapKey, styleSerialized);
        return styleSerialized;
    }
    getDarkColor(opacityScale = 100, overrideToPercentage) {
        const colorMapKey = `${opacityScale}-${overrideToPercentage}`;
        const currentColor = this._computedDarkColor.get(colorMapKey);
        if (currentColor) return currentColor;
        const opacity = this._getOpacity(opacityScale);
        const rgbaFrom = this._hexToRgba(this.startDarkColor, opacity);
        const rgbaTo = this._hexToRgba(this.toDarkColor, opacity);
        const styleWithOpacity = (0, __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.css)`
      ${this.type}(${this.degree}deg, ${rgbaFrom} ${this.fromPercentages}%, ${rgbaTo} ${overrideToPercentage ?? this.toPercentages}%)
    `;
        const styleSerialized = styleWithOpacity.styles.trim();
        this._computedDarkColor.set(colorMapKey, styleSerialized);
        return styleSerialized;
    }
    getButtonStylesOverride(opacityScale = 100) {
        const overrideSelectorFilled = `&[class*="filled${this.colorName}"]`;
        const overrideSelectorOutlined = `&[class*="outlined${this.colorName}"]:not(:disabled)`;
        const overrideSelectorOutlinedHover = `${overrideSelectorOutlined}:hover`;
        const overrideSelectorOutlinedBefore = `${overrideSelectorOutlined}::before`;
        const overrideSelectorOutlinedBeforeHover = `${overrideSelectorOutlined}:hover::before`;
        const overrideContained = `&[class*="contained${this.colorName}"]:not(:disabled)`;
        const overrideContainedHover = `${overrideContained}:hover`;
        const overrideText = `&[class*="text${this.colorName}"]:not(:disabled)`;
        const overrideTextHover = `${overrideText}:hover`;
        const mainColor = this.getMainColor(opacityScale);
        const darkColor = this.getDarkColor(opacityScale);
        return {
            [overrideSelectorFilled]: {
                background: mainColor
            },
            [overrideContained]: {
                background: mainColor
            },
            [overrideContainedHover]: {
                background: darkColor
            },
            [overrideSelectorOutlined]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${mainColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            [overrideSelectorOutlinedHover]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${darkColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            [overrideText]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${mainColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            [overrideTextHover]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${darkColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            "&.MuiButton-root::before": {
                borderRadius: "0.5rem"
            },
            "&.MuiChip-root::before": {
                borderRadius: "50px"
            },
            [overrideSelectorOutlinedBefore]: {
                content: '""',
                position: positioning_Positioning.absolute,
                inset: "0",
                border: "1px solid transparent",
                background: `${mainColor} border-box`,
                mask: `
          linear-gradient(#000 0 0) padding-box, 
          linear-gradient(#000 0 0);`,
                maskComposite: "exclude"
            },
            [overrideSelectorOutlinedBeforeHover]: {
                content: '""',
                position: positioning_Positioning.absolute,
                inset: "0",
                border: "1px solid transparent",
                background: `${darkColor} border-box`,
                mask: `
          linear-gradient(#000 0 0) padding-box, 
          linear-gradient(#000 0 0);`,
                maskComposite: "exclude"
            }
        };
    }
    getTextStylesOverride(opacityScale = 100) {
        const textGradient = `&.text-gradient${this.colorName}`;
        const mainColor = this.getMainColor(opacityScale, 50);
        return {
            [textGradient]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: mainColor,
                backgroundClip: "text",
                textFillColor: "transparent"
            }
        };
    }
    getBoxStylesOverride(opacityScale = 100) {
        const color = this.getMainColor(opacityScale);
        const background = this.getMainColor(10);
        const boxGradient = `&.box-gradient${this.colorName}`;
        const boxGradientBefore = `${boxGradient}::before`;
        const boxGradientBackground = `${boxGradient} .background`;
        const boxGradientContent = `${boxGradient} .content`;
        return {
            [boxGradient]: {
                borderRadius: "0.5rem",
                position: positioning_Positioning.relative,
                background: "transparent"
            },
            [boxGradientBackground]: {
                borderRadius: "0.5rem",
                position: "absolute",
                background: background,
                zIndex: "1"
            },
            [boxGradientContent]: {
                zIndex: "2"
            },
            [boxGradientBefore]: {
                borderRadius: "0.5rem",
                content: '""',
                position: "absolute",
                inset: "0",
                border: "1px solid transparent",
                background: `${color} border-box`,
                mask: `
          linear-gradient(#000 0 0) padding-box, 
          linear-gradient(#000 0 0);`,
                maskComposite: "exclude"
            }
        };
    }
    getBoxOutlinedStylesOverride(opacityScale = 100) {
        const color = this.getMainColor(opacityScale);
        const boxGradient = `&.box-gradientOutlined${this.colorName}`;
        const boxGradientContent = `${boxGradient} .content`;
        return {
            [boxGradient]: {
                position: positioning_Positioning.relative,
                border: "1px solid transparent",
                background: `${color} border-box`
            },
            [boxGradientContent]: {
                background: palette_Background.paper
            }
        };
    }
    getIconStylesOverride() {
        const overrideSvgIconColor = `&[class*="SvgIcon-color${this.colorName}"]`;
        const gradientId = `gradient-${this.colorName.toLowerCase()}`;
        return {
            [overrideSvgIconColor]: {
                fill: `url(#${gradientId})`,
                "*": {
                    fill: `url(#${gradientId}) !important`
                }
            }
        };
    }
    getSvgGradient(opacityScale = 100) {
        const gradientId = `gradient-${this.colorName.toLowerCase()}`;
        const opacity = this._getOpacity(opacityScale);
        const rgbaFrom = this._hexToRgba(this.startMainColor, opacity);
        const rgbaTo = this._hexToRgba(this.toMainColor, opacity);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: 0,
            height: 0,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                id: gradientId,
                x1: 0,
                y1: 0,
                x2: 1,
                y2: 0,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                        offset: 0,
                        stopColor: rgbaFrom
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                        offset: 1,
                        stopColor: rgbaTo
                    })
                ]
            })
        });
    }
    _getOpacity(opacityScale) {
        const OPACITY_SCALE_DIVISOR = 100;
        const OPACITY_MIN = 0;
        const OPACITY_MAX = 1;
        const opacityWithMin = Math.max(opacityScale / OPACITY_SCALE_DIVISOR, OPACITY_MIN);
        return Math.min(opacityWithMin, OPACITY_MAX);
    }
    _hexToRgba(hex, opacity = 1) {
        const bigint = parseInt(hex.replace("#", ""), 16);
        const red = bigint >> 16 & 255;
        const green = bigint >> 8 & 255;
        const blue = 255 & bigint;
        return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
    }
}
class TealDusk extends Gradient {
    colorName = "TealDusk";
    startMainColor = Tealx["500"];
    fromPercentages = "0";
    toMainColor = Purplex["600"];
    toPercentages = "100";
    type = "linear-gradient";
    degree = 98;
    startDarkColor = Tealx["600"];
    toDarkColor = Purplex["700"];
}
const tealDusk = new TealDusk();
class PinkHaze extends Gradient {
    colorName = "PinkHaze";
    startMainColor = Pinkx["400"];
    fromPercentages = "12.96";
    toMainColor = Purplex["600"];
    toPercentages = "85.66";
    type = "linear-gradient";
    degree = 121.52;
    startDarkColor = Pinkx["500"];
    toDarkColor = Purplex["700"];
}
const pinkHaze = new PinkHaze();
class GoldenUmber extends Gradient {
    colorName = "GoldenUmber";
    startMainColor = Goldenx["400"];
    fromPercentages = "7.99";
    toMainColor = Goldenx["600"];
    toPercentages = "84.09";
    type = "linear-gradient";
    degree = 128.09;
    startDarkColor = Goldenx["500"];
    toDarkColor = Goldenx["700"];
}
const goldenUmber = new GoldenUmber();
function capitalizeFirstLetter(string) {
    const text = string.charAt(0).toUpperCase() + string.slice(1);
    return text;
}
const tealDuskStyle = tealDusk.getTextStylesOverride();
const pinkHazeStyle = pinkHaze.getTextStylesOverride();
const goldenUmberStyle = goldenUmber.getTextStylesOverride();
const TypographyWithGradient = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"])`
  ${tealDuskStyle}
  ${pinkHazeStyle}
  ${goldenUmberStyle}
`;
function Typography(props) {
    const [color, gradientClassName] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        let gradientClassName = "";
        let color = props.color;
        if (props.gradient) {
            const colorNameCapitalized = capitalizeFirstLetter(props.gradient);
            gradientClassName = ` text-gradient${colorNameCapitalized}`;
            color = `${props.gradient}.main`;
        }
        return [
            color,
            gradientClassName
        ];
    }, [
        props.gradient,
        props.color
    ]);
    const defaultClassname = "";
    const propsClassName = props.className ?? defaultClassname;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TypographyWithGradient, {
        ...props,
        className: propsClassName + gradientClassName,
        color: color
    });
}
var dist_palette_WorkingTurnsColors = /*#__PURE__*/ function(WorkingTurnsColors) {
    WorkingTurnsColors["cafOperator"] = "#FF8D00";
    WorkingTurnsColors["user"] = "#1246C8";
    WorkingTurnsColors["finalized"] = "#00BB8C";
    return WorkingTurnsColors;
}({});
function BookOpenTextDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.7129 4.85907C19.0679 4.07807 17.3291 3.86006 15.5171 4.08306C13.5101 4.33006 12 6.03811 12 8.06011V20.0001C14.785 18.1441 17.569 18.0101 20.354 18.8011C20.677 18.8931 21 18.661 21 18.325V5.31903C21 5.12603 20.8879 4.94207 20.7129 4.85907Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M3.28711 4.85907C4.93211 4.07807 6.67091 3.86006 8.48291 4.08306C10.4899 4.33006 12 6.03811 12 8.06011V20.0001C9.215 18.1441 6.431 18.0101 3.646 18.8011C3.323 18.8931 3 18.661 3 18.325V5.31903C3 5.12603 3.11211 4.94207 3.28711 4.85907Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M18 9.75H15C14.586 9.75 14.25 9.414 14.25 9C14.25 8.586 14.586 8.25 15 8.25H18C18.414 8.25 18.75 8.586 18.75 9C18.75 9.414 18.414 9.75 18 9.75ZM17.75 12C17.75 11.586 17.414 11.25 17 11.25H15C14.586 11.25 14.25 11.586 14.25 12C14.25 12.414 14.586 12.75 15 12.75H17C17.414 12.75 17.75 12.414 17.75 12Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function BoxDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10.48 11.15C10.73 11.26 10.99 11.33 11.25 11.39V20.91C11.09 20.87 10.93 20.81 10.78 20.74L4.78003 18.07C3.70003 17.59 3 16.52 3 15.33V8.67001C3 8.40001 3.03999 8.13 3.10999 7.88L10.48 11.15Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.1301 6.56005L14.8201 8.92006L12.9202 9.77004C12.3302 10.03 11.6601 10.03 11.0801 9.77004L3.87012 6.56005C4.13012 6.30005 4.43015 6.08004 4.78015 5.93004L10.7802 3.26006C11.5602 2.91006 12.4401 2.91006 13.2201 3.26006L19.2201 5.93004C19.5701 6.08004 19.8701 6.30005 20.1301 6.56005Z",
                    fill: "#00CC99"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M21 8.67001V15.33C21 16.52 20.3 17.59 19.22 18.07L13.22 20.74C13.07 20.81 12.91 20.87 12.75 20.91V11.39C13.01 11.33 13.27 11.25 13.52 11.15L15.88 10.1L17.38 9.44L20.89 7.88C20.96 8.13 21 8.40001 21 8.67001Z",
                    fill: "#00CC99"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M16.6399 8.11002L14.8198 8.92004L6.66992 5.09003L8.48987 4.28003L16.6399 8.11002Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M17.3799 9.43994V11.89C17.3799 12.3 17.0399 12.64 16.6299 12.64C16.2199 12.64 15.8799 12.3 15.8799 11.89V10.0999L17.3799 9.43994Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function EuroCircleDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M14.658 15.478C14.209 15.659 13.735 15.75 13.25 15.75C11.868 15.75 10.672 14.99 10.022 13.875H12.688C13.102 13.875 13.438 13.539 13.438 13.125C13.438 12.711 13.102 12.375 12.688 12.375H9.53799C9.52499 12.25 9.5 12.128 9.5 12C9.5 11.872 9.52499 11.75 9.53799 11.625H12.688C13.102 11.625 13.438 11.289 13.438 10.875C13.438 10.461 13.102 10.125 12.688 10.125H10.022C10.673 9.01 11.869 8.25 13.25 8.25C13.738 8.25 14.209 8.34302 14.651 8.52502C15.036 8.68302 15.473 8.50104 15.631 8.11804C15.789 7.73504 15.607 7.29594 15.224 7.13794C14.599 6.87994 13.935 6.74902 13.25 6.74902C11.018 6.74902 9.11899 8.15502 8.36099 10.124H7.06201C6.64801 10.124 6.31201 10.46 6.31201 10.874C6.31201 11.288 6.64801 11.624 7.06201 11.624H8.03699C8.02799 11.75 7.99899 11.871 7.99899 11.999C7.99899 12.127 8.02799 12.248 8.03699 12.374H7.06201C6.64801 12.374 6.31201 12.71 6.31201 13.124C6.31201 13.538 6.64801 13.874 7.06201 13.874H8.36099C9.11899 15.843 11.017 17.249 13.25 17.249C13.927 17.249 14.589 17.121 15.217 16.869C15.601 16.715 15.788 16.2779 15.633 15.8929C15.479 15.5099 15.044 15.322 14.658 15.478Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function FileTextEditDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M18 8V11.502C18 11.581 17.9691 11.657 17.9131 11.714L11.936 17.725C11.657 18.005 11.5 18.385 11.5 18.781V19.701C11.5 19.867 11.366 20.001 11.2 20.001H6C4 20.001 3 19.001 3 17.001V5.00101C3 3.00101 4 2.00101 6 2.00101H12V5.00101C12 6.65801 13.343 8.00101 15 8.00101H18V8Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M15 8H18L12 2V5C12 7 13 8 15 8Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M14 11.75H7C6.586 11.75 6.25 11.414 6.25 11C6.25 10.586 6.586 10.25 7 10.25H14C14.414 10.25 14.75 10.586 14.75 11C14.75 11.414 14.414 11.75 14 11.75ZM11.75 15C11.75 14.586 11.414 14.25 11 14.25H7C6.586 14.25 6.25 14.586 6.25 15C6.25 15.414 6.586 15.75 7 15.75H11C11.414 15.75 11.75 15.414 11.75 15Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M16.98 14.78L19.22 17.02L15.22 21H13V18.78L16.98 14.78ZM20.74 14.25L19.75 13.2601C19.4 12.9101 18.84 12.9101 18.49 13.2601L17.6799 14.08L19.9199 16.3201L20.74 15.5101C21.09 15.1601 21.09 14.6 20.74 14.25Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function FileWandDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M14 6C14 8 15 9 17 9H20V17.9793L16.7753 15.1372C17.2646 14.2955 17.1107 13.119 16.1039 12.5269L16.1025 12.526L15.1821 11.9837L15.118 10.8433L15.1179 10.8412C15.0255 9.23748 13.1438 8.52431 11.9901 9.54555L11.9889 9.54658L11.1054 10.3273L10.0415 10.0681C8.51418 9.69578 7.20806 11.2274 7.81794 12.6764L8.24292 13.6864L7.61225 14.6826C7.61225 14.6826 7.41333 15.0332 7.35542 15.3555C7.2975 15.6777 7.30796 16.0622 7.48042 16.4609L7.7225 16.8711C7.7225 16.8711 7.87482 17.0641 8.08203 17.2188C8.25268 17.3461 8.39062 17.4062 8.58203 17.4805C8.77344 17.5547 9.23456 17.582 9.23456 17.582L10.5272 17.4531L11.2811 18.3633C11.2811 18.3633 11.5233 18.6133 11.7772 18.7461C12.0311 18.8789 12.3166 18.9421 12.4515 18.9561C13.285 19.043 13.8512 18.5586 13.8512 18.5586L16.6215 21H8C6 21 5 20 5 18V6C5 4 6 3 8 3H14V6Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20 9H17C15 9 14 8 14 6V3L20 9Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M9.68609 11.526L11.3159 11.923C11.4389 11.953 11.5697 11.9196 11.6651 11.8354L12.9844 10.6697C13.2262 10.4553 13.6024 10.609 13.6207 10.9281L13.7184 12.6668C13.7257 12.7939 13.7951 12.9083 13.9037 12.9719L15.3434 13.8203C15.6359 13.992 15.5977 14.4285 15.2797 14.5595L13.7067 15.2059C13.5886 15.2551 13.5012 15.3577 13.472 15.4813L13.0834 17.1353C13.0052 17.4707 12.5781 17.5771 12.3622 17.3156L11.2976 16.0302C11.2175 15.933 11.0935 15.8827 10.9669 15.8956L9.23493 16.0748C8.91625 16.1081 8.70537 15.7604 8.87867 15.4877L9.82052 14.0001C9.88919 13.8917 9.90116 13.7574 9.85147 13.6415L9.20091 12.0954C9.06876 11.7817 9.35547 11.4453 9.68609 11.526Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M14.5839 16.2054C14.8578 15.8946 15.3317 15.8647 15.6425 16.1386L19.3558 19.4114C19.6666 19.6852 19.6965 20.1592 19.4226 20.4699C19.1487 20.7807 18.6748 20.8106 18.364 20.5367L14.6507 17.2639C14.3399 16.99 14.3101 16.5161 14.5839 16.2054Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function FolderOpenDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M5.09497 12.573C5.62497 11.624 6.62899 11.035 7.71899 11.036L18.9861 11.042L19 11.036V10C19 8 18 7 16 7H10L8 5H5C3 5 2 6 2 8V18.496L2.0061 18.493C2.0081 18.255 2.06092 18.011 2.19092 17.78L5.09497 12.573Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.4988 11.043L18.9869 11.042L7.71977 11.036C6.62977 11.035 5.62475 11.624 5.09575 12.573L2.19169 17.78C2.06269 18.012 2.00888 18.255 2.00688 18.493C2.00088 19.279 2.62473 20 3.50273 20H16.2837C17.3727 20 18.3768 19.412 18.9058 18.464L21.8099 13.263C22.3649 12.268 21.6418 11.043 20.4988 11.043Z",
                    fill: "#00BB8C"
                })
            ]
        })
    });
}
function HomeDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "9",
                    y: "14",
                    width: "6",
                    height: "7",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18 20.9993H14.8C14.634 20.9993 14.5 20.8652 14.5 20.6992V16.4993C14.5 15.1183 13.381 13.9993 12 13.9993C10.619 13.9993 9.5 15.1183 9.5 16.4993V20.6992C9.5 20.8652 9.36595 20.9993 9.19995 20.9993H6C4 20.9993 3 19.9993 3 17.9993V11.6503C3 9.65229 3.52305 9.34535 4.43005 8.58535L10.394 3.58425C11.323 2.80525 12.6781 2.80525 13.6071 3.58425L19.571 8.58535C20.477 9.34535 21.001 9.65229 21.001 11.6503V17.9993C21 19.9993 20 20.9993 18 20.9993Z",
                    fill: "#00BB8C"
                })
            ]
        })
    });
}
function ListDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M21 6.5H10C9.448 6.5 9 6.052 9 5.5C9 4.948 9.448 4.5 10 4.5H21C21.552 4.5 22 4.948 22 5.5C22 6.052 21.552 6.5 21 6.5Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M21 13H10C9.448 13 9 12.552 9 12C9 11.448 9.448 11 10 11H21C21.552 11 22 11.448 22 12C22 12.552 21.552 13 21 13Z",
                    fill: "#00CC99"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M21 19.5H10C9.448 19.5 9 19.052 9 18.5C9 17.948 9.448 17.5 10 17.5H21C21.552 17.5 22 17.948 22 18.5C22 19.052 21.552 19.5 21 19.5Z",
                    fill: "#00CC99"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.5 7C3.672 7 3 6.328 3 5.5C3 4.672 3.672 4 4.5 4C5.328 4 6 4.672 6 5.5C6 6.328 5.328 7 4.5 7Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.5 13.5C3.672 13.5 3 12.828 3 12C3 11.172 3.672 10.5 4.5 10.5C5.328 10.5 6 11.172 6 12C6 12.828 5.328 13.5 4.5 13.5Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.5 20C3.672 20 3 19.328 3 18.5C3 17.672 3.672 17 4.5 17C5.328 17 6 17.672 6 18.5C6 19.328 5.328 20 4.5 20Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function LogOutDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M15 7V6C15 4 14 3 12 3H6C4 3 3 4 3 6V18C3 20 4 21 6 21H12C14 21 15 20 15 18V17",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M21.692 11.713C21.654 11.621 21.599 11.538 21.53 11.469L18.53 8.46902C18.237 8.17602 17.762 8.17602 17.469 8.46902C17.176 8.76202 17.176 9.23702 17.469 9.53002L19.189 11.25H8C7.586 11.25 7.25 11.586 7.25 12C7.25 12.414 7.586 12.75 8 12.75H19.189L17.469 14.47C17.176 14.763 17.176 15.238 17.469 15.531C17.615 15.677 17.807 15.751 17.999 15.751C18.191 15.751 18.383 15.678 18.529 15.531L21.529 12.531C21.598 12.462 21.653 12.379 21.691 12.287C21.768 12.103 21.768 11.897 21.692 11.713Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function MoreHorizontalDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.02014 14C2.91614 14 2.01514 13.104 2.01514 12C2.01514 10.896 2.90513 10 4.01013 10H4.02014C5.12414 10 6.02014 10.896 6.02014 12C6.02014 13.104 5.12514 14 4.02014 14Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.0201 14C18.9161 14 18.0151 13.104 18.0151 12C18.0151 10.896 18.9051 10 20.0101 10H20.0201C21.1241 10 22.0201 10.896 22.0201 12C22.0201 13.104 21.1251 14 20.0201 14Z",
                    fill: "#00CC99"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M12.0201 14C10.9161 14 10.0151 13.104 10.0151 12C10.0151 10.896 10.9051 10 12.0101 10H12.0201C13.1241 10 14.0201 10.896 14.0201 12C14.0201 13.104 13.1251 14 12.0201 14Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function SettingsDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M8.19019 18.069L8.1872 18.067C7.2552 17.527 6.10518 17.525 5.17218 18.063C5.01318 18.155 4.8092 18.1 4.7172 17.942L3.0452 15.057C2.9532 14.898 3.00717 14.695 3.16617 14.603L3.17517 14.598C4.10317 14.06 4.67418 13.067 4.67118 11.995C4.66818 10.924 4.0972 9.93596 3.1702 9.39896L3.16519 9.39597C3.00719 9.30397 2.95319 9.10198 3.04419 8.94498L4.7172 6.05698C4.8092 5.89898 5.0112 5.84497 5.1702 5.93597C6.1042 6.47397 7.2542 6.47298 8.1872 5.93198L8.19019 5.93097C9.11519 5.39497 9.68518 4.40598 9.68518 3.33698C9.68518 3.15098 9.83619 3.00098 10.0222 3.00098H13.9772C14.1632 3.00098 14.3142 3.15198 14.3142 3.33698C14.3142 4.40598 14.8842 5.39497 15.8092 5.93097L15.8122 5.93198C16.7452 6.47298 17.8952 6.47397 18.8292 5.93597C18.9882 5.84497 19.1902 5.89898 19.2822 6.05698L20.9542 8.94296C21.0462 9.10196 20.9922 9.30497 20.8332 9.39697L20.8252 9.40097C19.8982 9.93797 19.3272 10.93 19.3292 12.001C19.3312 13.073 19.9022 14.064 20.8302 14.602L20.8342 14.604C20.9922 14.696 21.0462 14.898 20.9542 15.055L19.2812 17.943C19.1892 18.101 18.9872 18.155 18.8282 18.064C17.8942 17.526 16.7432 17.527 15.8112 18.068L15.8092 18.069C14.8832 18.606 14.3142 19.594 14.3142 20.664C14.3142 20.849 14.1632 20.999 13.9782 20.999H10.0192C9.8332 20.999 9.6822 20.849 9.6832 20.663C9.6842 19.595 9.11519 18.606 8.19019 18.069Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M12.001 15C13.6578 15 15.001 13.6569 15.001 12C15.001 10.3431 13.6578 9 12.001 9C10.3441 9 9.00098 10.3431 9.00098 12C9.00098 13.6569 10.3441 15 12.001 15Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function UserCircleDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M17.7397 18.26C16.2297 19.65 14.2098 20.5 11.9998 20.5C9.78976 20.5 7.76977 19.65 6.25977 18.26C6.69977 16.88 7.83979 15.5699 10.2898 15.5699H13.7097C16.1497 15.5699 17.2897 16.89 17.7397 18.26ZM15.0078 10C15.0078 8.343 13.6648 7 12.0078 7C10.3508 7 9.00781 8.343 9.00781 10C9.00781 11.657 10.3508 13 12.0078 13C13.6648 13 15.0078 11.657 15.0078 10Z",
                    fill: "#171F36"
                })
            ]
        })
    });
}
function UsersGroupAltDuotone(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.0099 9.29004C19.7199 10.16 18.9799 10.8399 18.0999 11.0699C17.2499 11.2899 16.4498 11.13 15.8198 10.73C15.6698 10.63 15.6599 10.42 15.7799 10.29C16.5399 9.40004 17.0099 8.26 17.0099 7C17.0099 6.63 16.9699 6.27004 16.8899 5.92004C16.8899 5.92004 16.8699 5.84006 16.8699 5.81006C16.8699 5.65006 16.9959 5.51696 17.1559 5.50696C17.1659 5.50696 17.2898 5.5 17.3398 5.5C19.2098 5.5 20.6699 7.33004 20.0099 9.29004Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M3.98986 9.29004C4.27986 10.16 5.01989 10.8399 5.89989 11.0699C6.74989 11.2899 7.54992 11.13 8.17992 10.73C8.32992 10.63 8.33984 10.42 8.21984 10.29C7.45984 9.40004 6.98986 8.26 6.98986 7C6.98986 6.63 7.02986 6.27004 7.10986 5.92004C7.10986 5.92004 7.12987 5.84006 7.12987 5.81006C7.12987 5.65006 7.00386 5.51696 6.84386 5.50696C6.83386 5.50696 6.7099 5.5 6.6599 5.5C4.7899 5.5 3.32986 7.33004 3.98986 9.29004Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M12.0078 10.5C13.9408 10.5 15.5078 8.933 15.5078 7C15.5078 5.067 13.9408 3.5 12.0078 3.5C10.0748 3.5 8.50781 5.067 8.50781 7C8.50781 8.933 10.0748 10.5 12.0078 10.5Z",
                    fill: "#171F36"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M22.4999 16.01V18C22.4999 18.28 22.2799 18.5 21.9999 18.5H20.4899C20.3399 18.5 20.2198 18.38 20.2198 18.24V17.35C20.2198 15.64 19.6598 13.9199 18.4698 12.6899C18.4158 12.6299 18.3599 12.54 18.3599 12.47C18.3599 12.3 18.4799 12.17 18.6699 12.17C21.4999 12.17 22.4999 14.24 22.4999 16.01Z",
                    fill: "#00BB8C"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M1.5 16.01V18C1.5 18.28 1.72 18.5 2 18.5H3.51001C3.66001 18.5 3.78003 18.38 3.78003 18.24V17.35C3.78003 15.64 4.34003 13.9199 5.53003 12.6899C5.58403 12.6299 5.64001 12.54 5.64001 12.47C5.64001 12.3 5.51996 12.17 5.32996 12.17C2.49996 12.17 1.5 14.24 1.5 16.01Z",
                    fill: "#00CC99"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M13.7769 12.389H10.2219C6.57192 12.389 5.27686 15.061 5.27686 17.35V20C5.27686 20.276 5.50086 20.5 5.77686 20.5H18.2219C18.4979 20.5 18.7219 20.276 18.7219 20V17.35C18.7229 15.061 17.4279 12.389 13.7769 12.389Z",
                    fill: "#00CC99"
                })
            ]
        })
    });
}
function AngleDownSmallOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M11.9858 15.9322C11.7439 15.9322 11.5019 15.8402 11.3179 15.655L6.27694 10.6141C5.90769 10.2448 5.90769 9.64618 6.27694 9.27693C6.64618 8.90769 7.24484 8.90769 7.61408 9.27693L11.987 13.6499L16.36 9.27693C16.7293 8.90769 17.3279 8.90769 17.6972 9.27693C18.0664 9.64618 18.0664 10.2448 17.6972 10.6141L12.6562 15.655C12.4697 15.8402 12.2278 15.9322 11.9858 15.9322Z",
                fill: "currentColor"
            })
        })
    });
}
const DISABLED_FILL_COLOR = "rgba(23, 31, 54, 0.24)";
function AngleRightSmallOutlined(props) {
    const fillColor = props.disabled ? DISABLED_FILL_COLOR : "currentColor";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "2rem",
            height: "2rem",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M9.94489 17.9743C9.70293 17.9743 9.46093 17.8824 9.27694 17.6971C8.90769 17.3279 8.90769 16.7292 9.27694 16.36L13.6499 11.987L9.27694 7.61408C8.90769 7.24483 8.90769 6.64618 9.27694 6.27693C9.64618 5.90769 10.2448 5.90769 10.6141 6.27693L15.655 11.3178C16.0243 11.6871 16.0243 12.2857 15.655 12.655L10.6141 17.6959C10.4288 17.8824 10.1869 17.9743 9.94489 17.9743Z",
                fill: props.customColor ?? fillColor
            })
        })
    });
}
function AngleUpSmallOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M17.028 15.9322C16.786 15.9322 16.544 15.8402 16.36 15.655L11.987 11.282L7.61408 15.655C7.24484 16.0242 6.64618 16.0242 6.27694 15.655C5.90769 15.2857 5.90769 14.6871 6.27694 14.3178L11.3179 9.27693C11.6871 8.90769 12.2858 8.90769 12.655 9.27693L17.6959 14.3178C18.0652 14.6871 18.0652 15.2857 17.6959 15.655C17.5119 15.8402 17.2699 15.9322 17.028 15.9322Z",
                fill: "currentColor"
            })
        })
    });
}
function ArrowDownSmallOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M16.5301 16.53L12.5301 20.53C12.4611 20.599 12.3781 20.6539 12.2871 20.6919C12.1961 20.7299 12.098 20.75 12 20.75C11.902 20.75 11.8049 20.7299 11.7129 20.6919C11.6209 20.6539 11.539 20.599 11.47 20.53L7.46999 16.53C7.17699 16.237 7.17699 15.762 7.46999 15.469C7.76299 15.176 8.23803 15.176 8.53103 15.469L11.251 18.189V4C11.251 3.586 11.587 3.25 12.001 3.25C12.415 3.25 12.751 3.586 12.751 4V18.189L15.471 15.469C15.764 15.176 16.239 15.176 16.532 15.469C16.825 15.762 16.8231 16.237 16.5301 16.53Z",
                fill: "currentColor"
            })
        })
    });
}
function ArrowUpSmallOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M16.5298 8.53014C16.3838 8.67614 16.1918 8.75012 15.9998 8.75012C15.8078 8.75012 15.6158 8.67714 15.4698 8.53014L12.7498 5.81017V20.0001C12.7498 20.4141 12.4138 20.7501 11.9998 20.7501C11.5858 20.7501 11.2498 20.4141 11.2498 20.0001V5.81115L8.52981 8.53112C8.23681 8.82412 7.76177 8.82412 7.46877 8.53112C7.17577 8.23812 7.17577 7.76309 7.46877 7.47009L11.4688 3.47009C11.5378 3.40109 11.6207 3.34622 11.7127 3.30822C11.8957 3.23222 12.1027 3.23222 12.2857 3.30822C12.3777 3.34622 12.4608 3.40109 12.5298 3.47009L16.5298 7.47009C16.8228 7.76309 16.8228 8.23714 16.5298 8.53014Z",
                fill: "currentColor"
            })
        })
    });
}
function BellOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12.0002 21.75C11.0122 21.75 10.1242 21.237 9.6222 20.378C9.4142 20.02 9.5342 19.561 9.8922 19.352C10.2482 19.144 10.7082 19.264 10.9182 19.622C11.3772 20.409 12.6232 20.409 13.0822 19.622C13.2912 19.264 13.7512 19.144 14.1082 19.352C14.4662 19.56 14.5872 20.02 14.3782 20.378C13.8762 21.237 12.9882 21.75 12.0002 21.75ZM20.6752 18.325C20.8002 18.065 20.7652 17.757 20.5862 17.532C20.5672 17.509 18.7452 15.189 18.7452 12.5V8.995C18.7452 5.276 15.7192 2.25 12.0002 2.25C8.2812 2.25 5.2552 5.276 5.2552 8.995V12.5C5.2552 15.189 3.4332 17.509 3.4142 17.532C3.2352 17.757 3.2002 18.066 3.3252 18.325C3.4502 18.584 3.7122 18.75 4.0002 18.75H20.0002C20.2882 18.75 20.5502 18.584 20.6752 18.325ZM6.7552 12.5V8.995C6.7552 6.103 9.1082 3.75 12.0002 3.75C14.8922 3.75 17.2452 6.103 17.2452 8.995V12.5C17.2452 14.436 17.9952 16.158 18.6132 17.25H5.3862C6.0052 16.158 6.7552 14.436 6.7552 12.5Z",
                fill: "currentColor"
            })
        })
    });
}
function BookOpenTextOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.0359 4.18199C21.0349 4.18199 21.0349 4.18201 21.0339 4.18101C19.3319 3.37401 17.445 3.09099 15.425 3.33799C13.971 3.51699 12.741 4.34794 12 5.51194C11.258 4.34894 10.029 3.51699 8.57495 3.33799C6.55195 3.09099 4.66706 3.37401 2.96606 4.18101C2.96606 4.18101 2.96609 4.18101 2.96509 4.18101C2.53109 4.38701 2.25 4.83393 2.25 5.31993V18.3249C2.25 18.7189 2.42992 19.08 2.74292 19.317C3.05492 19.554 3.4711 19.6289 3.8501 19.5229C6.7581 18.6969 9.21701 19.047 11.583 20.624C11.593 20.631 11.605 20.633 11.615 20.639C11.626 20.645 11.634 20.655 11.646 20.661C11.657 20.667 11.6699 20.664 11.6809 20.67C11.7819 20.718 11.889 20.75 11.999 20.75C12.109 20.75 12.2159 20.718 12.3169 20.67C12.3279 20.665 12.3411 20.667 12.3521 20.661C12.3631 20.655 12.3721 20.646 12.3821 20.639C12.3921 20.633 12.4041 20.631 12.4141 20.624C14.7801 19.046 17.238 18.696 20.147 19.522C20.527 19.63 20.9409 19.554 21.2539 19.317C21.5669 19.081 21.7471 18.7189 21.7471 18.3249V5.31993C21.7501 4.83593 21.4699 4.38899 21.0359 4.18199ZM6.73291 17.593C5.77191 17.593 4.779 17.728 3.75 17.995V5.46995C5.17 4.82695 6.69309 4.61603 8.39209 4.82603C10.0221 5.02603 11.25 6.41596 11.25 8.05796V18.6889C9.815 17.9579 8.31691 17.593 6.73291 17.593ZM20.25 17.996C17.522 17.287 15.056 17.514 12.75 18.691V8.06004C12.75 6.41704 13.9789 5.02798 15.6079 4.82798C16.0299 4.77598 16.441 4.74998 16.842 4.74998C18.057 4.74998 19.182 4.98903 20.249 5.47203V17.996H20.25ZM15 8.24998H18C18.414 8.24998 18.75 8.58598 18.75 8.99998C18.75 9.41398 18.414 9.74998 18 9.74998H15C14.586 9.74998 14.25 9.41398 14.25 8.99998C14.25 8.58598 14.586 8.24998 15 8.24998ZM17.75 12C17.75 12.414 17.414 12.75 17 12.75H15C14.586 12.75 14.25 12.414 14.25 12C14.25 11.586 14.586 11.25 15 11.25H17C17.414 11.25 17.75 11.586 17.75 12Z",
                fill: "currentColor"
            })
        })
    });
}
function BoxOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.2869 6.88198C21.2859 6.87998 21.2869 6.878 21.2859 6.876C21.2839 6.871 21.2789 6.868 21.2769 6.863C20.8899 6.16 20.2869 5.57999 19.5249 5.24099L13.5249 2.574C12.5559 2.144 11.4469 2.144 10.4779 2.574L4.47791 5.24099C3.71491 5.57999 3.11283 6.16 2.72583 6.863C2.72383 6.868 2.71892 6.871 2.71692 6.876C2.71592 6.878 2.71682 6.87998 2.71582 6.88198C2.42282 7.42098 2.25293 8.02898 2.25293 8.66698V15.334C2.25293 16.814 3.12686 18.159 4.47986 18.761L10.4799 21.428C10.9619 21.642 11.4788 21.748 11.9958 21.75C11.9988 21.75 12.0009 21.751 12.0039 21.751C12.0069 21.751 12.0088 21.75 12.0118 21.75C12.5288 21.749 13.0458 21.642 13.5278 21.428L19.5278 18.761C20.8808 18.16 21.7549 16.815 21.7549 15.334V8.66698C21.7499 8.02898 21.5799 7.41998 21.2869 6.88198ZM11.0859 3.94399C11.3759 3.81499 11.6889 3.74999 11.9999 3.74999C12.3109 3.74999 12.6238 3.81398 12.9138 3.94298L18.9138 6.60998C19.0838 6.68598 19.2329 6.791 19.3759 6.902L16.6428 8.11699L9.38391 4.7L11.0859 3.94399ZM7.57288 5.505L14.8319 8.92199L12.9199 9.77199C12.3339 10.027 11.6628 10.027 11.0848 9.77398L4.6239 6.902C4.7669 6.791 4.91594 6.68498 5.08594 6.60998L7.57288 5.505ZM5.08594 17.389C4.27394 17.028 3.74988 16.221 3.74988 15.333V8.66598C3.74988 8.50098 3.78582 8.343 3.81982 8.187L10.4799 11.147C10.7289 11.255 10.9869 11.334 11.2499 11.386V20.108C11.1959 20.089 11.1389 20.078 11.0859 20.055L5.08594 17.389ZM20.2499 15.333C20.2499 16.221 19.7258 17.028 18.9138 17.389L12.9138 20.056C12.8608 20.08 12.8039 20.09 12.7499 20.109V11.386C13.0139 11.333 13.2739 11.254 13.5239 11.145L15.8789 10.098V11.89C15.8789 12.304 16.2149 12.64 16.6289 12.64C17.0429 12.64 17.3789 12.304 17.3789 11.89V9.432L20.1788 8.18798C20.2138 8.34498 20.2489 8.50198 20.2489 8.66698V15.333H20.2499Z",
                fill: "currentColor"
            })
        })
    });
}
function CalendarOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z",
                fill: "currentColor"
            })
        })
    });
}
function CheckCircleOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 1.25C6.072 1.25 1.25 6.073 1.25 12C1.25 17.927 6.072 22.75 12 22.75C17.928 22.75 22.75 17.927 22.75 12C22.75 6.073 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM16.03 9.13599C16.323 9.42899 16.323 9.90402 16.03 10.197L11.363 14.864C11.217 15.01 11.025 15.084 10.833 15.084C10.641 15.084 10.449 15.011 10.303 14.864L7.97 12.531C7.677 12.238 7.677 11.763 7.97 11.47C8.263 11.177 8.73801 11.177 9.03101 11.47L10.834 13.273L14.97 9.13702C15.263 8.84402 15.737 8.84399 16.03 9.13599Z",
                fill: "currentColor"
            })
        })
    });
}
function CircleLargeOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 1.25C6.072 1.25 1.25 6.073 1.25 12C1.25 17.927 6.072 22.75 12 22.75C17.928 22.75 22.75 17.927 22.75 12C22.75 6.073 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25Z",
                fill: "currentColor"
            })
        })
    });
}
function ClockOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z",
                fill: "currentColor"
            })
        })
    });
}
function CloudUploadOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.75 11C21.75 13.727 19.8139 16.097 17.1479 16.635C17.0979 16.645 17.048 16.65 16.999 16.65C16.649 16.65 16.3369 16.404 16.2649 16.048C16.1829 15.642 16.4461 15.246 16.8521 15.165C18.8221 14.768 20.25 13.016 20.25 11C20.25 8.656 18.344 6.75 16 6.75C15.717 6.75 15.4449 6.77503 15.1689 6.82703C14.8639 6.88503 14.5551 6.74801 14.3931 6.48401C14.1011 6.01301 13.7301 5.57298 13.2891 5.17798C12.2511 4.25798 10.904 3.75 9.5 3.75C6.329 3.75 3.75 6.329 3.75 9.5C3.75 11.828 5.13906 13.911 7.28906 14.808C7.67106 14.967 7.85089 15.407 7.69189 15.789C7.53189 16.172 7.09094 16.351 6.71094 16.192C4.00094 15.062 2.25 12.435 2.25 9.5C2.25 5.502 5.502 2.25 9.5 2.25C11.271 2.25 12.9721 2.89202 14.2871 4.05902C14.7071 4.43502 15.0761 4.84401 15.3911 5.28101C15.5921 5.26001 15.794 5.25 16 5.25C19.171 5.25 21.75 7.829 21.75 11ZM12.531 10.47C12.462 10.401 12.3791 10.346 12.2871 10.308C12.1041 10.232 11.8971 10.232 11.7141 10.308C11.6221 10.346 11.539 10.401 11.47 10.47L9.46997 12.47C9.17697 12.763 9.17697 13.238 9.46997 13.531C9.76297 13.824 10.238 13.824 10.531 13.531L11.251 12.811V21C11.251 21.414 11.587 21.75 12.001 21.75C12.415 21.75 12.751 21.414 12.751 21V12.811L13.4709 13.531C13.6169 13.677 13.809 13.751 14.001 13.751C14.193 13.751 14.385 13.678 14.531 13.531C14.824 13.238 14.824 12.763 14.531 12.47L12.531 10.47Z",
                fill: "currentColor"
            })
        })
    });
}
function EnvelopeOpenOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M18 21.75H6C3.582 21.75 2.25 20.418 2.25 18V9.73199C2.25 8.64299 2.79102 7.632 3.69702 7.028L9.91992 2.88C11.1839 2.038 12.8161 2.038 14.0801 2.88L20.303 7.028C21.209 7.632 21.75 8.64299 21.75 9.73199V18C21.75 20.418 20.418 21.75 18 21.75ZM12 3.74899C11.565 3.74899 11.131 3.87501 10.752 4.12801L4.52905 8.276C4.04105 8.601 3.75 9.14599 3.75 9.73199V18C3.75 19.577 4.423 20.25 6 20.25H18C19.577 20.25 20.25 19.577 20.25 18V9.73199C20.25 9.14599 19.9589 8.601 19.4709 8.276L13.248 4.12801C12.869 3.87501 12.435 3.74899 12 3.74899ZM12.8569 14.94L17.4409 11.606C17.7759 11.362 17.85 10.893 17.606 10.558C17.363 10.224 16.8961 10.148 16.5581 10.393L11.9751 13.726C11.9091 13.774 11.8231 13.774 11.7581 13.727L7.17407 10.393C6.83707 10.149 6.36798 10.224 6.12598 10.558C5.88198 10.893 5.95602 11.362 6.29102 11.606L10.875 14.94C11.171 15.155 11.518 15.263 11.865 15.263C12.213 15.263 12.5609 15.156 12.8569 14.94Z",
                fill: "currentColor"
            })
        })
    });
}
function EnvelopeOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M18 20.75H6C3.582 20.75 2.25 19.418 2.25 17V8C2.25 5.582 3.582 4.25 6 4.25H18C20.418 4.25 21.75 5.582 21.75 8V17C21.75 19.418 20.418 20.75 18 20.75ZM6 5.75C4.423 5.75 3.75 6.423 3.75 8V17C3.75 18.577 4.423 19.25 6 19.25H18C19.577 19.25 20.25 18.577 20.25 17V8C20.25 6.423 19.577 5.75 18 5.75H6ZM13.0291 13.179L17.9409 9.60699C18.2759 9.36399 18.35 8.89401 18.106 8.55901C17.863 8.22501 17.3951 8.149 17.0581 8.394L12.146 11.966C12.058 12.03 11.941 12.03 11.853 11.966L6.94092 8.394C6.60292 8.149 6.13607 8.22601 5.89307 8.55901C5.64907 8.89401 5.72311 9.36299 6.05811 9.60699L10.97 13.18C11.278 13.404 11.639 13.515 11.999 13.515C12.359 13.515 12.7221 13.403 13.0291 13.179Z",
                fill: "currentColor"
            })
        })
    });
}
function EuroCircleOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM13.25 8.25C13.738 8.25 14.209 8.34302 14.651 8.52502C15.036 8.68302 15.473 8.50104 15.631 8.11804C15.789 7.73504 15.607 7.29594 15.224 7.13794C14.599 6.87994 13.935 6.74902 13.25 6.74902C11.018 6.74902 9.11899 8.15502 8.36099 10.124H7.06201C6.64801 10.124 6.31201 10.46 6.31201 10.874C6.31201 11.288 6.64801 11.624 7.06201 11.624H8.03699C8.02799 11.75 7.99899 11.871 7.99899 11.999C7.99899 12.127 8.02799 12.248 8.03699 12.374H7.06201C6.64801 12.374 6.31201 12.71 6.31201 13.124C6.31201 13.538 6.64801 13.874 7.06201 13.874H8.36099C9.11899 15.843 11.017 17.249 13.25 17.249C13.927 17.249 14.589 17.121 15.217 16.869C15.601 16.715 15.788 16.2779 15.633 15.8929C15.479 15.5089 15.044 15.3211 14.657 15.4771C14.208 15.6581 13.734 15.749 13.249 15.749C11.867 15.749 10.671 14.989 10.021 13.874H12.687C13.101 13.874 13.437 13.538 13.437 13.124C13.437 12.71 13.101 12.374 12.687 12.374H9.53699C9.52399 12.249 9.49899 12.127 9.49899 11.999C9.49899 11.871 9.52399 11.749 9.53699 11.624H12.687C13.101 11.624 13.437 11.288 13.437 10.874C13.437 10.46 13.101 10.124 12.687 10.124H10.021C10.672 9.01002 11.868 8.25 13.25 8.25Z",
                fill: "currentColor"
            })
        })
    });
}
function ExclamationCircleOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM13.02 15.5C13.02 14.948 12.573 14.5 12.02 14.5H12.01C11.458 14.5 11.0149 14.948 11.0149 15.5C11.0149 16.052 11.468 16.5 12.02 16.5C12.572 16.5 13.02 16.052 13.02 15.5ZM12.75 12.071V7.5C12.75 7.086 12.414 6.75 12 6.75C11.586 6.75 11.25 7.086 11.25 7.5V12.071C11.25 12.485 11.586 12.821 12 12.821C12.414 12.821 12.75 12.485 12.75 12.071Z",
                fill: "currentColor"
            })
        })
    });
}
function FileOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M20.53 8.47L14.53 2.47C14.389 2.329 14.199 2.25 14 2.25H8C5.582 2.25 4.25 3.582 4.25 6V18C4.25 20.418 5.582 21.75 8 21.75H17C19.418 21.75 20.75 20.418 20.75 18V9C20.75 8.801 20.671 8.61 20.53 8.47ZM14.75 4.811L18.189 8.25H17C15.423 8.25 14.75 7.577 14.75 6V4.811ZM17 20.25H8C6.423 20.25 5.75 19.577 5.75 18V6C5.75 4.423 6.423 3.75 8 3.75H13.25V6C13.25 8.418 14.582 9.75 17 9.75H19.25V18C19.25 19.577 18.577 20.25 17 20.25Z",
                fill: "currentColor"
            })
        })
    });
}
function FileTextEditOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.27 13.72L20.28 12.73C19.97 12.42 19.5591 12.25 19.1221 12.25C19.1211 12.25 19.1201 12.25 19.1201 12.25C18.6821 12.25 18.2689 12.422 17.9609 12.733L12.47 18.249C12.329 18.389 12.251 18.58 12.251 18.778V21C12.251 21.414 12.587 21.75 13.001 21.75H15.2241C15.4221 21.75 15.6129 21.671 15.7529 21.531L21.269 16.04C21.58 15.731 21.75 15.319 21.751 14.881C21.75 14.443 21.58 14.031 21.27 13.72ZM19.1211 13.75C19.1471 13.75 19.185 13.757 19.219 13.791L20.209 14.781C20.243 14.815 20.25 14.854 20.25 14.88C20.25 14.906 20.243 14.944 20.209 14.978L19.573 15.611L18.3889 14.427L19.022 13.791C19.057 13.757 19.0951 13.75 19.1211 13.75ZM14.9131 20.25H13.75V19.087L17.3311 15.49L18.51 16.669L14.9131 20.25ZM10 19.25H6C4.423 19.25 3.75 18.577 3.75 17V5C3.75 3.423 4.423 2.75 6 2.75H11.25V5C11.25 7.418 12.582 8.75 15 8.75H17.25V10C17.25 10.414 17.586 10.75 18 10.75C18.414 10.75 18.75 10.414 18.75 10V8C18.75 7.801 18.671 7.61 18.53 7.47L12.53 1.47C12.389 1.329 12.199 1.25 12 1.25H6C3.582 1.25 2.25 2.582 2.25 5V17C2.25 19.418 3.582 20.75 6 20.75H10C10.414 20.75 10.75 20.414 10.75 20C10.75 19.586 10.414 19.25 10 19.25ZM12.75 5V3.811L16.189 7.25H15C13.423 7.25 12.75 6.577 12.75 5ZM7 10.25C6.586 10.25 6.25 10.586 6.25 11C6.25 11.414 6.586 11.75 7 11.75H14C14.414 11.75 14.75 11.414 14.75 11C14.75 10.586 14.414 10.25 14 10.25H7ZM11 14.25H7C6.586 14.25 6.25 14.586 6.25 15C6.25 15.414 6.586 15.75 7 15.75H11C11.414 15.75 11.75 15.414 11.75 15C11.75 14.586 11.414 14.25 11 14.25Z",
                fill: "currentColor"
            })
        })
    });
}
function FileWandOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M14.75 20H7.75C6.173 20 5.5 19.327 5.5 17.75V5.75C5.5 4.173 6.173 3.5 7.75 3.5H13V5.75C13 8.168 14.332 9.5 16.75 9.5H19V16.75C19 17.164 19.336 17.5 19.75 17.5C20.164 17.5 20.5 17.164 20.5 16.75V8.75C20.5 8.551 20.421 8.36 20.28 8.22L14.28 2.22C14.139 2.079 13.949 2 13.75 2H7.75C5.332 2 4 3.332 4 5.75V17.75C4 20.168 5.332 21.5 7.75 21.5H14.75C15.164 21.5 15.5 21.164 15.5 20.75C15.5 20.336 15.164 20 14.75 20ZM14.5 5.75V4.561L17.939 8H16.75C15.173 8 14.5 7.327 14.5 5.75Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.5837 16.2052C14.8576 15.8945 15.3315 15.8646 15.6422 16.1385L19.3556 19.4112C19.6664 19.6851 19.6962 20.159 19.4224 20.4698C19.1485 20.7805 18.6746 20.8104 18.3638 20.5366L14.6505 17.2638C14.3397 16.9899 14.3098 16.516 14.5837 16.2052Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.83206 10.2552C8.016 10.0465 8.30034 9.95679 8.57075 10.0221L10.7591 10.5505L12.5137 9.1401C12.7305 8.96581 13.026 8.92586 13.2814 9.0363C13.5367 9.14674 13.7099 9.38944 13.7314 9.66679L13.9051 11.9113L15.7886 13.1442C16.0214 13.2966 16.1507 13.5653 16.1245 13.8422C16.0984 14.1192 15.9211 14.3589 15.664 14.465L13.583 15.3238L12.9925 17.4962C12.9195 17.7646 12.7039 17.9706 12.4324 18.0314C12.161 18.0921 11.8782 17.9976 11.6978 17.7858L10.238 16.0721L7.98944 16.1817C7.71158 16.1953 7.44905 16.0539 7.3074 15.8145C7.16576 15.5751 7.16827 15.2769 7.31394 15.0399L8.4927 13.122L7.69356 11.0174C7.59481 10.7573 7.64812 10.4639 7.83206 10.2552ZM9.60048 11.8138L10.0259 12.9343C10.1085 13.1517 10.0855 13.3951 9.96373 13.5932L9.33619 14.6143L10.5332 14.5559C10.7655 14.5445 10.9899 14.6416 11.1407 14.8186L11.9179 15.731L12.2323 14.5745C12.2933 14.3501 12.4549 14.1666 12.6699 14.0779L13.7777 13.6207L12.775 12.9644C12.5804 12.837 12.4559 12.6266 12.438 12.3947L12.3455 11.1998L11.4114 11.9506C11.2301 12.0963 10.9915 12.1497 10.7655 12.0951L9.60048 11.8138Z",
                    fill: "currentColor"
                })
            ]
        })
    });
}
function FolderOpenOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M22.439 11.403C22.032 10.708 21.306 10.293 20.499 10.292H19.75V10C19.75 7.582 18.418 6.25 16 6.25H10.311L8.53101 4.47C8.39001 4.329 8.19998 4.25 8.00098 4.25H5.00098C2.58298 4.25 1.25098 5.582 1.25098 8V18.496C1.25098 18.5 1.25293 18.503 1.25293 18.507C1.25293 18.897 1.35404 19.287 1.56104 19.64C1.96904 20.335 2.69495 20.75 3.50195 20.75H16.283C17.643 20.75 18.8981 20.014 19.5601 18.83L22.4629 13.629C22.8539 12.928 22.846 12.096 22.439 11.403ZM5 5.75H7.68896L9.46899 7.53C9.60999 7.671 9.80002 7.75 9.99902 7.75H15.999C17.576 7.75 18.249 8.423 18.249 10V10.292L7.71997 10.286C7.71897 10.286 7.71804 10.286 7.71704 10.286C6.35604 10.286 5.09996 11.022 4.43896 12.208L2.75 15.238V8C2.75 6.423 3.423 5.75 5 5.75ZM21.1531 12.898L18.25 18.099C17.854 18.809 17.1 19.251 16.283 19.251H3.50195C3.11295 19.251 2.91998 18.993 2.85498 18.882C2.79098 18.772 2.66092 18.481 2.84692 18.147L5.75 12.94C6.146 12.229 6.90002 11.788 7.71802 11.788C7.71902 11.788 7.71897 11.788 7.71997 11.788L20.499 11.795C20.888 11.795 21.081 12.054 21.145 12.165C21.21 12.272 21.3401 12.564 21.1531 12.898Z",
                fill: "currentColor"
            })
        })
    });
}
function HomeOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M18 21.75H13.75V16.5C13.75 15.535 12.965 14.75 12 14.75C11.035 14.75 10.25 15.535 10.25 16.5V21.75H6C3.582 21.75 2.25 20.418 2.25 18V11.65C2.25 9.52704 2.83599 8.93401 3.79199 8.14101L9.91199 3.01003C11.121 1.99503 12.879 1.99503 14.088 3.01003L20.208 8.14101C21.164 8.93401 21.75 9.52804 21.75 11.65V18C21.75 20.418 20.418 21.75 18 21.75ZM15.25 20.25H18C19.577 20.25 20.25 19.577 20.25 18V11.65C20.25 10.124 19.998 9.91506 19.251 9.29506L13.125 4.15908C12.473 3.61308 11.527 3.61308 10.875 4.15908L4.74902 9.29506C4.00202 9.91506 3.75 10.124 3.75 11.65V18C3.75 19.577 4.423 20.25 6 20.25H8.75V16.5C8.75 14.708 10.208 13.25 12 13.25C13.792 13.25 15.25 14.708 15.25 16.5V20.25Z",
                fill: "currentColor"
            })
        })
    });
}
function InboxUploadOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.689 13.009C21.689 13.006 21.6909 13.003 21.6909 13C21.6909 12.991 21.686 12.984 21.686 12.975C21.674 12.904 21.6601 12.833 21.6431 12.762C21.6351 12.738 21.6311 12.714 21.6211 12.691C21.5731 12.504 21.525 12.318 21.448 12.138L19.469 7.522C18.968 6.353 18.495 5.24899 16.022 5.24899C15.608 5.24899 15.272 5.58499 15.272 5.99899C15.272 6.41299 15.608 6.74899 16.022 6.74899C17.506 6.74899 17.6411 7.065 18.0901 8.113L19.863 12.249H17.0449C15.7949 12.249 14.6361 12.954 13.9431 14.136C13.5421 14.822 12.797 15.249 12 15.249C11.203 15.249 10.4579 14.822 10.0569 14.135C9.36488 12.954 8.20508 12.249 6.95508 12.249H4.13696L5.90991 8.113C6.35891 7.065 6.49403 6.74899 7.97803 6.74899C8.39203 6.74899 8.72803 6.41299 8.72803 5.99899C8.72803 5.58499 8.39203 5.24899 7.97803 5.24899C5.50403 5.24899 5.03201 6.353 4.53101 7.522L2.552 12.137C2.475 12.317 2.42593 12.504 2.37793 12.692C2.36893 12.712 2.36591 12.734 2.35791 12.755C2.34091 12.828 2.32599 12.901 2.31299 12.975C2.31299 12.983 2.30811 12.99 2.30811 12.998C2.30811 13.001 2.30908 13.003 2.30908 13.006C2.27608 13.206 2.24805 13.408 2.24805 13.614V18C2.24805 20.418 3.58005 21.75 5.99805 21.75H17.998C20.416 21.75 21.748 20.418 21.748 18V13.616C21.75 13.41 21.722 13.209 21.689 13.009ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V13.75H6.95508C7.66708 13.75 8.34196 14.178 8.76196 14.894C9.43096 16.039 10.672 16.75 12 16.75C13.328 16.75 14.569 16.039 15.238 14.895C15.658 14.178 16.3329 13.75 17.0449 13.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.46997 4.52999C9.17697 4.23699 9.17697 3.76199 9.46997 3.46899L11.47 1.46899C11.539 1.39999 11.6221 1.345 11.7141 1.307C11.8971 1.231 12.1041 1.231 12.2871 1.307C12.3791 1.345 12.462 1.39999 12.531 1.46899L14.531 3.46899C14.824 3.76199 14.824 4.23699 14.531 4.52999C14.385 4.67599 14.193 4.74999 14.001 4.74999C13.809 4.74999 13.6169 4.67699 13.4709 4.52999L12.751 3.80999V9.99999C12.751 10.414 12.415 10.75 12.001 10.75C11.587 10.75 11.251 10.414 11.251 9.99999V3.811L10.531 4.531C10.237 4.823 9.76297 4.82299 9.46997 4.52999Z",
                fill: "currentColor"
            })
        })
    });
}
function InfoCircleOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM12.75 16.5V11.929C12.75 11.515 12.414 11.179 12 11.179C11.586 11.179 11.25 11.515 11.25 11.929V16.5C11.25 16.914 11.586 17.25 12 17.25C12.414 17.25 12.75 16.914 12.75 16.5ZM13.02 8.5C13.02 7.948 12.573 7.5 12.02 7.5H12.01C11.458 7.5 11.0149 7.948 11.0149 8.5C11.0149 9.052 11.468 9.5 12.02 9.5C12.572 9.5 13.02 9.052 13.02 8.5Z",
                fill: "currentColor"
            })
        })
    });
}
function ListOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M9.25 5.5C9.25 5.086 9.586 4.75 10 4.75H21C21.414 4.75 21.75 5.086 21.75 5.5C21.75 5.914 21.414 6.25 21 6.25H10C9.586 6.25 9.25 5.914 9.25 5.5ZM21 11.25H10C9.586 11.25 9.25 11.586 9.25 12C9.25 12.414 9.586 12.75 10 12.75H21C21.414 12.75 21.75 12.414 21.75 12C21.75 11.586 21.414 11.25 21 11.25ZM21 17.75H10C9.586 17.75 9.25 18.086 9.25 18.5C9.25 18.914 9.586 19.25 10 19.25H21C21.414 19.25 21.75 18.914 21.75 18.5C21.75 18.086 21.414 17.75 21 17.75ZM6.75 5.5C6.75 6.741 5.741 7.75 4.5 7.75C3.259 7.75 2.25 6.741 2.25 5.5C2.25 4.259 3.259 3.25 4.5 3.25C5.741 3.25 6.75 4.259 6.75 5.5ZM5.25 5.5C5.25 5.086 4.914 4.75 4.5 4.75C4.086 4.75 3.75 5.086 3.75 5.5C3.75 5.914 4.086 6.25 4.5 6.25C4.914 6.25 5.25 5.914 5.25 5.5ZM6.75 12C6.75 13.241 5.741 14.25 4.5 14.25C3.259 14.25 2.25 13.241 2.25 12C2.25 10.759 3.259 9.75 4.5 9.75C5.741 9.75 6.75 10.759 6.75 12ZM5.25 12C5.25 11.586 4.914 11.25 4.5 11.25C4.086 11.25 3.75 11.586 3.75 12C3.75 12.414 4.086 12.75 4.5 12.75C4.914 12.75 5.25 12.414 5.25 12ZM6.75 18.5C6.75 19.741 5.741 20.75 4.5 20.75C3.259 20.75 2.25 19.741 2.25 18.5C2.25 17.259 3.259 16.25 4.5 16.25C5.741 16.25 6.75 17.259 6.75 18.5ZM5.25 18.5C5.25 18.086 4.914 17.75 4.5 17.75C4.086 17.75 3.75 18.086 3.75 18.5C3.75 18.914 4.086 19.25 4.5 19.25C4.914 19.25 5.25 18.914 5.25 18.5Z",
                fill: "currentColor"
            })
        })
    });
}
function LockViewfinderOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M17.417 16V12C17.417 10.523 16.694 9.5861 15.417 9.3291V8.66602C15.417 6.78202 13.884 5.24902 12 5.24902C10.116 5.24902 8.58301 6.78202 8.58301 8.66602V9.3291C7.30601 9.5861 6.58301 10.523 6.58301 12V16C6.58301 17.748 7.58501 18.75 9.33301 18.75H14.667C16.415 18.75 17.417 17.748 17.417 16ZM12 6.75C13.057 6.75 13.917 7.60999 13.917 8.66699V9.25H10.083V8.66699C10.083 7.60999 10.943 6.75 12 6.75ZM15.917 16C15.917 16.923 15.59 17.25 14.667 17.25H9.33301C8.41001 17.25 8.08301 16.923 8.08301 16V12C8.08301 11.077 8.41001 10.75 9.33301 10.75H14.667C15.59 10.75 15.917 11.077 15.917 12V16ZM13.27 13.333C13.27 13.745 13.058 14.0931 12.75 14.3201V15.333C12.75 15.747 12.414 16.083 12 16.083C11.586 16.083 11.25 15.747 11.25 15.333V14.2949C10.962 14.0659 10.7649 13.728 10.7649 13.333C10.7649 12.643 11.32 12.083 12.01 12.083H12.02C12.71 12.083 13.27 12.643 13.27 13.333ZM21.75 4.5V8C21.75 8.414 21.414 8.75 21 8.75C20.586 8.75 20.25 8.414 20.25 8V4.5C20.25 3.911 20.089 3.75 19.5 3.75H16C15.586 3.75 15.25 3.414 15.25 3C15.25 2.586 15.586 2.25 16 2.25H19.5C20.909 2.25 21.75 3.091 21.75 4.5ZM2.25 8V4.5C2.25 3.091 3.091 2.25 4.5 2.25H8C8.414 2.25 8.75 2.586 8.75 3C8.75 3.414 8.414 3.75 8 3.75H4.5C3.911 3.75 3.75 3.911 3.75 4.5V8C3.75 8.414 3.414 8.75 3 8.75C2.586 8.75 2.25 8.414 2.25 8ZM8.75 21C8.75 21.414 8.414 21.75 8 21.75H4.5C3.091 21.75 2.25 20.909 2.25 19.5V16C2.25 15.586 2.586 15.25 3 15.25C3.414 15.25 3.75 15.586 3.75 16V19.5C3.75 20.089 3.911 20.25 4.5 20.25H8C8.414 20.25 8.75 20.586 8.75 21ZM21.75 16V19.5C21.75 20.909 20.909 21.75 19.5 21.75H16C15.586 21.75 15.25 21.414 15.25 21C15.25 20.586 15.586 20.25 16 20.25H19.5C20.089 20.25 20.25 20.089 20.25 19.5V16C20.25 15.586 20.586 15.25 21 15.25C21.414 15.25 21.75 15.586 21.75 16Z",
                fill: "currentColor"
            })
        })
    });
}
function LogOutOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M15.75 17V18C15.75 20.418 14.418 21.75 12 21.75H6C3.582 21.75 2.25 20.418 2.25 18V6C2.25 3.582 3.582 2.25 6 2.25H12C14.418 2.25 15.75 3.582 15.75 6V7C15.75 7.414 15.414 7.75 15 7.75C14.586 7.75 14.25 7.414 14.25 7V6C14.25 4.423 13.577 3.75 12 3.75H6C4.423 3.75 3.75 4.423 3.75 6V18C3.75 19.577 4.423 20.25 6 20.25H12C13.577 20.25 14.25 19.577 14.25 18V17C14.25 16.586 14.586 16.25 15 16.25C15.414 16.25 15.75 16.586 15.75 17ZM21.692 12.287C21.768 12.104 21.768 11.897 21.692 11.714C21.654 11.622 21.599 11.539 21.53 11.47L18.53 8.47C18.237 8.177 17.762 8.177 17.469 8.47C17.176 8.763 17.176 9.23801 17.469 9.53101L19.189 11.251H8C7.586 11.251 7.25 11.587 7.25 12.001C7.25 12.415 7.586 12.751 8 12.751H19.189L17.469 14.471C17.176 14.764 17.176 15.239 17.469 15.532C17.615 15.678 17.807 15.752 17.999 15.752C18.191 15.752 18.383 15.679 18.529 15.532L21.529 12.532C21.599 12.461 21.654 12.378 21.692 12.287Z",
                fill: "currentColor"
            })
        })
    });
}
function MoreHorizontalOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M4.02014 13.5C3.19114 13.5 2.51514 12.829 2.51514 12C2.51514 11.171 3.18213 10.5 4.01013 10.5H4.02014C4.84914 10.5 5.52014 11.171 5.52014 12C5.52014 12.829 4.84914 13.5 4.02014 13.5ZM12.0201 13.5C11.1911 13.5 10.5151 12.829 10.5151 12C10.5151 11.171 11.1821 10.5 12.0101 10.5H12.0201C12.8491 10.5 13.5201 11.171 13.5201 12C13.5201 12.829 12.8491 13.5 12.0201 13.5ZM20.0201 13.5C19.1911 13.5 18.5151 12.829 18.5151 12C18.5151 11.171 19.1821 10.5 20.0101 10.5H20.0201C20.8491 10.5 21.5201 11.171 21.5201 12C21.5201 12.829 20.8491 13.5 20.0201 13.5Z",
                fill: "currentColor"
            })
        })
    });
}
function PDFFileOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.53 8.47L14.53 2.47C14.389 2.329 14.199 2.25 14 2.25H8C5.582 2.25 4.25 3.582 4.25 6V11.25H3.57007C3.01778 11.25 2.57007 11.6977 2.57007 12.25V15.75C2.57007 16.3023 3.01778 16.75 3.57007 16.75H4.25V18C4.25 20.418 5.582 21.75 8 21.75H17C19.418 21.75 20.75 20.418 20.75 18V9C20.75 8.801 20.671 8.61 20.53 8.47ZM12.4201 16.75H5.75V18C5.75 19.577 6.423 20.25 8 20.25H17C18.577 20.25 19.25 19.577 19.25 18V9.75H17C14.582 9.75 13.25 8.418 13.25 6V3.75H8C6.423 3.75 5.75 4.423 5.75 6V11.25H12.4201C12.9724 11.25 13.4201 11.6977 13.4201 12.25V15.75C13.4201 16.3023 12.9724 16.75 12.4201 16.75ZM14.75 4.811L18.189 8.25H17C15.423 8.25 14.75 7.577 14.75 6V4.811ZM3.57422 15.75V12.25H4.86922C5.14922 12.25 5.38089 12.2967 5.56422 12.39C5.74755 12.4833 5.88422 12.6117 5.97422 12.775C6.06422 12.9383 6.10922 13.1217 6.10922 13.325C6.10922 13.5183 6.06589 13.6967 5.97922 13.86C5.89255 14.02 5.75755 14.15 5.57422 14.25C5.39089 14.3467 5.15589 14.395 4.86922 14.395H4.21422V15.75H3.57422ZM4.21422 13.875H4.82922C5.05255 13.875 5.21255 13.8267 5.30922 13.73C5.40922 13.63 5.45922 13.495 5.45922 13.325C5.45922 13.1517 5.40922 13.0167 5.30922 12.92C5.21255 12.82 5.05255 12.77 4.82922 12.77H4.21422V13.875ZM6.61133 12.25V15.75H7.80633C8.21633 15.75 8.55299 15.6783 8.81633 15.535C9.08299 15.3883 9.27966 15.185 9.40633 14.925C9.53633 14.6617 9.60133 14.3533 9.60133 14C9.60133 13.6467 9.53633 13.34 9.40633 13.08C9.27966 12.8167 9.08299 12.6133 8.81633 12.47C8.55299 12.3233 8.21633 12.25 7.80633 12.25H6.61133ZM7.77633 15.2H7.25133V12.795H7.77633C8.06966 12.795 8.30133 12.8433 8.47133 12.94C8.64133 13.0367 8.76299 13.175 8.83633 13.355C8.90966 13.535 8.94633 13.75 8.94633 14C8.94633 14.2533 8.90966 14.47 8.83633 14.65C8.76299 14.8267 8.64133 14.9633 8.47133 15.06C8.30133 15.1533 8.06966 15.2 7.77633 15.2ZM12.426 12.25H10.166V15.75H10.806V14.25H12.116V13.745H10.806V12.765H12.426V12.25Z",
                fill: "currentColor"
            })
        })
    });
}
function PenOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M20.9441 5.28406L18.7161 3.05603C18.1951 2.53603 17.5441 2.249 16.7681 2.25C16.0321 2.251 15.341 2.53906 14.823 3.06006L2.46899 15.471C2.32799 15.612 2.25 15.802 2.25 16V21C2.25 21.414 2.586 21.75 3 21.75H8C8.198 21.75 8.38905 21.671 8.52905 21.532L20.9399 9.177C21.4609 8.658 21.749 7.96706 21.75 7.23206C21.751 6.49606 21.4651 5.80406 20.9441 5.28406ZM7.68994 20.25H3.75V16.3101L12.7429 7.276L16.7251 11.257L7.68994 20.25ZM19.8821 8.11402L17.7881 10.199L13.801 6.21302L15.886 4.11804C16.122 3.88104 16.436 3.751 16.771 3.75H16.772C17.106 3.75 17.42 3.87997 17.657 4.11597L19.885 6.344C20.121 6.581 20.251 6.89498 20.251 7.22998C20.25 7.56398 20.1191 7.87802 19.8821 8.11402Z",
                fill: "currentColor"
            })
        })
    });
}
function PlusOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z",
                fill: "currentColor"
            })
        })
    });
}
function SettingsOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M11.9998 8.25C9.9318 8.25 8.2498 9.932 8.2498 12C8.2498 14.068 9.9318 15.75 11.9998 15.75C14.0678 15.75 15.7498 14.068 15.7498 12C15.7498 9.932 14.0678 8.25 11.9998 8.25ZM11.9998 14.25C10.7588 14.25 9.7498 13.241 9.7498 12C9.7498 10.759 10.7588 9.75 11.9998 9.75C13.2408 9.75 14.2498 10.759 14.2498 12C14.2498 13.241 13.2408 14.25 11.9998 14.25ZM21.2078 13.953C20.5138 13.551 20.0818 12.803 20.0808 12C20.0798 11.199 20.5088 10.452 21.2118 10.045C21.7268 9.74601 21.9028 9.08299 21.6048 8.56699L19.9328 5.681C19.6348 5.166 18.9718 4.98901 18.4558 5.28601C17.7568 5.68901 16.8878 5.68901 16.1868 5.28201C15.4958 4.88101 15.0658 4.13601 15.0658 3.33701C15.0658 2.73801 14.5778 2.25101 13.9788 2.25101H10.0238C9.42379 2.25101 8.93681 2.73801 8.93681 3.33701C8.93681 4.13601 8.5068 4.881 7.8138 5.284C7.1148 5.689 6.24681 5.68999 5.54781 5.28699C5.03081 4.98899 4.36882 5.16701 4.07082 5.68201L2.3968 8.57101C2.0988 9.08601 2.27579 9.74799 2.79579 10.05C3.48879 10.451 3.92081 11.198 3.92281 11.999C3.92481 12.801 3.4948 13.55 2.7928 13.957C2.5428 14.102 2.3628 14.335 2.2888 14.615C2.2148 14.894 2.25281 15.185 2.39781 15.436L4.0688 18.32C4.3668 18.836 5.02981 19.015 5.54781 18.716C6.24681 18.313 7.11381 18.314 7.80281 18.713L7.80479 18.714C7.80779 18.716 7.8108 18.718 7.8148 18.72C8.5058 19.121 8.93479 19.866 8.93379 20.666C8.93379 21.265 9.42079 21.752 10.0198 21.752H13.9788C14.5778 21.752 15.0648 21.265 15.0648 20.667C15.0648 19.867 15.4948 19.122 16.1888 18.719C16.8868 18.314 17.7548 18.312 18.4548 18.716C18.9708 19.014 19.6328 18.837 19.9318 18.322L21.6058 15.433C21.9028 14.916 21.7258 14.253 21.2078 13.953ZM18.8308 17.227C17.7408 16.752 16.4758 16.817 15.4338 17.42C14.4008 18.019 13.7188 19.078 13.5868 20.25H10.4098C10.2798 19.078 9.59579 18.017 8.56279 17.419C7.52279 16.816 6.25581 16.752 5.16881 17.227L3.89281 15.024C4.84781 14.321 5.42479 13.193 5.42079 11.993C5.41779 10.801 4.8418 9.681 3.8918 8.978L5.16881 6.77399C6.25681 7.24799 7.52381 7.18399 8.56581 6.57999C9.59781 5.98199 10.2798 4.92201 10.4118 3.75101H13.5868C13.7178 4.92301 14.4008 5.982 15.4358 6.582C16.4748 7.185 17.7418 7.24899 18.8308 6.77499L20.1078 8.978C19.1548 9.68 18.5788 10.806 18.5808 12.004C18.5818 13.198 19.1578 14.32 20.1088 15.025L18.8308 17.227Z",
                fill: "currentColor"
            })
        })
    });
}
function TrashOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21 5.25H17.441C16.54 5.25 16.502 5.136 16.255 4.396L16.053 3.789C15.746 2.869 14.889 2.25 13.919 2.25H10.081C9.11099 2.25 8.253 2.868 7.947 3.789L7.745 4.396C7.498 5.137 7.46 5.25 6.559 5.25H3C2.586 5.25 2.25 5.586 2.25 6C2.25 6.414 2.586 6.75 3 6.75H4.298L5.065 18.249C5.213 20.474 6.57701 21.75 8.80701 21.75H15.194C17.423 21.75 18.787 20.474 18.936 18.249L19.703 6.75H21C21.414 6.75 21.75 6.414 21.75 6C21.75 5.586 21.414 5.25 21 5.25ZM9.37 4.263C9.473 3.956 9.75799 3.75 10.081 3.75H13.919C14.242 3.75 14.528 3.956 14.63 4.263L14.832 4.87C14.876 5.001 14.92 5.128 14.968 5.25H9.03C9.078 5.127 9.12301 5 9.16701 4.87L9.37 4.263ZM17.438 18.149C17.343 19.582 16.629 20.25 15.193 20.25H8.806C7.37 20.25 6.657 19.583 6.561 18.149L5.801 6.75H6.558C6.683 6.75 6.787 6.737 6.899 6.729C6.933 6.734 6.964 6.75 6.999 6.75H16.999C17.035 6.75 17.065 6.734 17.099 6.729C17.211 6.737 17.315 6.75 17.44 6.75H18.197L17.438 18.149ZM14.75 11V16C14.75 16.414 14.414 16.75 14 16.75C13.586 16.75 13.25 16.414 13.25 16V11C13.25 10.586 13.586 10.25 14 10.25C14.414 10.25 14.75 10.586 14.75 11ZM10.75 11V16C10.75 16.414 10.414 16.75 10 16.75C9.586 16.75 9.25 16.414 9.25 16V11C9.25 10.586 9.586 10.25 10 10.25C10.414 10.25 10.75 10.586 10.75 11Z",
                fill: "currentColor"
            })
        })
    });
}
function TriangleExclamationOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M18.6916 22.75H5.3078C3.8688 22.75 2.56879 22.014 1.82879 20.781C1.09179 19.551 1.05565 18.0621 1.73065 16.7981L8.33661 4.44312C9.06961 3.07012 10.4397 2.25098 11.9977 2.25098C13.5557 2.25098 14.9256 3.07012 15.6586 4.44312L22.2646 16.7981C22.9416 18.0621 22.9057 19.551 22.1677 20.781C21.4327 22.014 20.1316 22.75 18.6916 22.75ZM11.9997 3.75C11.0037 3.75 10.1296 4.27293 9.66058 5.14893L3.05462 17.5039C2.62962 18.2989 2.65363 19.235 3.11663 20.009C3.58263 20.786 4.40177 21.249 5.30877 21.249H18.6928C19.5998 21.249 20.4197 20.785 20.8847 20.009C21.3477 19.236 21.3697 18.2999 20.9457 17.5039L14.3398 5.14893C13.8698 4.27293 12.9957 3.75 11.9997 3.75ZM12.7497 14V10C12.7497 9.586 12.4137 9.25 11.9997 9.25C11.5857 9.25 11.2497 9.586 11.2497 10V14C11.2497 14.414 11.5857 14.75 11.9997 14.75C12.4137 14.75 12.7497 14.414 12.7497 14ZM13.0197 17C13.0197 16.448 12.5727 16 12.0197 16H12.0097C11.4577 16 11.0146 16.448 11.0146 17C11.0146 17.552 11.4677 18 12.0197 18C12.5717 18 13.0197 17.552 13.0197 17Z",
                fill: "currentColor"
            })
        })
    });
}
function UserCircleOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M22.75 12C22.75 6.072 17.928 1.25 12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 15.47 2.90899 18.552 5.46899 20.519C5.47299 20.523 5.47903 20.5251 5.48303 20.5291C7.29403 21.9161 9.54898 22.75 12.001 22.75C14.453 22.75 16.708 21.9161 18.519 20.5291C18.523 20.5251 18.529 20.523 18.533 20.519C21.091 18.552 22.75 15.47 22.75 12ZM2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 14.523 20.232 16.8121 18.588 18.4821C18.139 16.5811 16.702 14.8199 13.71 14.8199H10.29C7.29804 14.8199 5.85999 16.5811 5.41199 18.4821C3.76799 16.8121 2.75 14.523 2.75 12ZM6.75903 19.614C6.81703 18.588 7.28604 16.3199 10.29 16.3199H13.71C16.714 16.3199 17.183 18.588 17.241 19.614C15.75 20.644 13.945 21.25 12 21.25C10.055 21.25 8.25003 20.643 6.75903 19.614ZM12.0081 13.75C14.0751 13.75 15.7581 12.068 15.7581 10C15.7581 7.932 14.0751 6.25 12.0081 6.25C9.94106 6.25 8.25806 7.932 8.25806 10C8.25806 12.068 9.94006 13.75 12.0081 13.75ZM12.0081 7.75C13.2481 7.75 14.2581 8.759 14.2581 10C14.2581 11.241 13.2481 12.25 12.0081 12.25C10.7681 12.25 9.75806 11.241 9.75806 10C9.75806 8.759 10.7681 7.75 12.0081 7.75Z",
                fill: "currentColor"
            })
        })
    });
}
function UsersGroupAltOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M16.08 10.389C16.196 9.99204 16.611 9.764 17.011 9.88C17.102 9.907 17.209 9.92004 17.34 9.92004C18.211 9.92004 18.92 9.20696 18.92 8.32996C18.92 7.61296 18.436 6.98603 17.741 6.80603C17.34 6.70203 17.099 6.29199 17.204 5.89099C17.307 5.48999 17.714 5.25203 18.118 5.35303C19.473 5.70503 20.42 6.92898 20.42 8.32898C20.42 10.033 19.038 11.4189 17.34 11.4189C17.065 11.4189 16.819 11.386 16.589 11.319C16.191 11.203 15.964 10.787 16.08 10.389ZM18.897 11.931C18.887 11.931 18.878 11.931 18.87 11.931C18.468 11.931 18.135 12.2491 18.121 12.6541C18.105 13.0681 18.429 13.4151 18.843 13.4301C21.076 13.5111 21.25 15.425 21.25 16.01V18C21.25 18.414 21.586 18.75 22 18.75C22.414 18.75 22.75 18.414 22.75 18V16.01C22.75 14.192 21.741 12.033 18.897 11.931ZM6.67004 11.42C6.94504 11.42 7.19102 11.3869 7.42102 11.3199C7.81802 11.2029 8.04605 10.787 7.93005 10.389C7.81405 9.99204 7.39802 9.764 6.99902 9.88C6.90802 9.907 6.80104 9.92004 6.67004 9.92004C5.79904 9.92004 5.08997 9.20696 5.08997 8.32996C5.08997 7.60696 5.57795 6.97602 6.27795 6.79602C6.67795 6.69302 6.92102 6.28406 6.81702 5.88306C6.71302 5.48106 6.30295 5.23799 5.90295 5.34399C4.54195 5.69499 3.59094 6.92296 3.59094 8.32996C3.58994 10.034 4.97204 11.42 6.67004 11.42ZM5.85901 12.65C5.84201 12.236 5.50196 11.909 5.07996 11.931C2.25296 12.045 1.25 14.2 1.25 16.01V18C1.25 18.414 1.586 18.75 2 18.75C2.414 18.75 2.75 18.414 2.75 18V16.01C2.75 15.263 2.98299 13.5161 5.14099 13.4301C5.55499 13.4131 5.87601 13.064 5.85901 12.65ZM8.25806 7C8.25806 4.932 9.94106 3.25 12.0081 3.25C14.0751 3.25 15.7581 4.932 15.7581 7C15.7581 9.068 14.0751 10.75 12.0081 10.75C9.94106 10.75 8.25806 9.068 8.25806 7ZM9.75806 7C9.75806 8.241 10.7681 9.25 12.0081 9.25C13.2481 9.25 14.2581 8.241 14.2581 7C14.2581 5.759 13.2481 4.75 12.0081 4.75C10.7681 4.75 9.75806 5.759 9.75806 7ZM13.777 12.139H10.222C6.38705 12.139 5.02698 14.946 5.02698 17.35V20C5.02698 20.414 5.36298 20.75 5.77698 20.75C6.19098 20.75 6.52698 20.414 6.52698 20V17.35C6.52698 16.479 6.79405 13.639 10.222 13.639H13.777C17.206 13.639 17.472 16.479 17.472 17.35V20C17.472 20.414 17.808 20.75 18.222 20.75C18.636 20.75 18.972 20.414 18.972 20V17.35C18.973 14.946 17.612 12.139 13.777 12.139Z",
                fill: "currentColor"
            })
        })
    });
}
function VideoPlayOutlined(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M17.625 2.25H6.375C3.715 2.25 2.25 3.715 2.25 6.375V17.625C2.25 20.285 3.715 21.75 6.375 21.75H17.625C20.285 21.75 21.75 20.285 21.75 17.625V6.375C21.75 3.715 20.285 2.25 17.625 2.25ZM20.25 6.375V8.25H15.75V3.75H17.625C19.465 3.75 20.25 4.535 20.25 6.375ZM9.75 8.25V3.75H14.25V8.25H9.75ZM6.375 3.75H8.25V8.25H3.75V6.375C3.75 4.535 4.535 3.75 6.375 3.75ZM17.625 20.25H6.375C4.535 20.25 3.75 19.465 3.75 17.625V9.75H20.25V17.625C20.25 19.465 19.465 20.25 17.625 20.25ZM14.973 13.115L11.825 11.188C11.303 10.868 10.647 10.856 10.114 11.155C9.57301 11.458 9.25098 12.008 9.25098 12.627V16.373C9.25098 16.992 9.57301 17.542 10.114 17.845C10.371 17.989 10.656 18.061 10.941 18.061C11.248 18.061 11.554 17.978 11.825 17.812L14.972 15.886C15.459 15.588 15.75 15.07 15.75 14.5C15.75 13.93 15.459 13.412 14.973 13.115ZM14.189 14.606L11.041 16.533C10.959 16.582 10.891 16.5611 10.847 16.5371C10.803 16.5121 10.75 16.464 10.75 16.373V12.627C10.75 12.537 10.803 12.4879 10.847 12.4629C10.871 12.4489 10.904 12.437 10.942 12.437C10.972 12.437 11.006 12.445 11.042 12.467L14.1899 14.394C14.1899 14.394 14.19 14.394 14.191 14.394C14.23 14.418 14.251 14.454 14.251 14.499C14.251 14.544 14.229 14.582 14.189 14.606Z",
                fill: "currentColor"
            })
        })
    });
}
function ZipOutlined(props) {
    const width = props.width || 24;
    const height = props.height || 24;
    const fillColor = props.color || "#171F36";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height,
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.5303 8.47L14.5303 2.47C14.3893 2.329 14.1992 2.25 14.0002 2.25H8.00024C5.58224 2.25 4.25024 3.582 4.25024 6V11.25H3.57031C3.01803 11.25 2.57031 11.6977 2.57031 12.25V15.75C2.57031 16.3023 3.01803 16.75 3.57031 16.75H4.25024V18C4.25024 20.418 5.58224 21.75 8.00024 21.75H17.0002C19.4182 21.75 20.7502 20.418 20.7502 18V9C20.7502 8.801 20.6713 8.61 20.5303 8.47ZM12.4203 16.75H5.75024V18C5.75024 19.577 6.42324 20.25 8.00024 20.25H17.0002C18.5772 20.25 19.2502 19.577 19.2502 18V9.75H17.0002C14.5822 9.75 13.2502 8.418 13.2502 6V3.75H8.00024C6.42324 3.75 5.75024 4.423 5.75024 6V11.25H12.4203C12.9726 11.25 13.4203 11.6977 13.4203 12.25V15.75C13.4203 16.3023 12.9726 16.75 12.4203 16.75ZM14.7502 4.811L18.1892 8.25H17.0002C15.4232 8.25 14.7502 7.577 14.7502 6V4.811ZM3.8 15.8291V15.1772L5.67988 12.8555H4.0124V12.25H6.63203V12.8115L4.67158 15.2261H6.70771V15.8291H3.8ZM7.7082 12.25V15.8291H8.43086V12.25H7.7082ZM9.43086 12.25V15.8291H10.1535V14.479H10.6247C10.9519 14.479 11.2017 14.4619 11.3742 14.4277C11.5012 14.4001 11.6257 14.3439 11.7478 14.2593C11.8715 14.173 11.9732 14.055 12.0529 13.9053C12.1327 13.7555 12.1726 13.5708 12.1726 13.3511C12.1726 13.0662 12.1034 12.8343 11.965 12.6553C11.8267 12.4746 11.655 12.3574 11.4499 12.3037C11.3164 12.2679 11.03 12.25 10.5905 12.25H9.43086ZM10.1535 13.8711V12.8555H10.5026C10.7631 12.8555 10.9364 12.8636 11.0227 12.8799C11.1398 12.901 11.2367 12.9539 11.3132 13.0386C11.3897 13.1232 11.4279 13.2306 11.4279 13.3608C11.4279 13.4666 11.4003 13.5594 11.3449 13.6392C11.2912 13.7189 11.2163 13.7775 11.1203 13.8149C11.0243 13.8524 10.8339 13.8711 10.549 13.8711H10.1535Z",
                fill: fillColor
            })
        })
    });
}
function ArrowUpCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM15.53 11.53C15.384 11.676 15.192 11.75 15 11.75C14.808 11.75 14.616 11.677 14.47 11.53L12.75 9.81006V16C12.75 16.414 12.414 16.75 12 16.75C11.586 16.75 11.25 16.414 11.25 16V9.81104L9.53003 11.531C9.23703 11.824 8.76199 11.824 8.46899 11.531C8.17599 11.238 8.17599 10.763 8.46899 10.47L11.469 7.46997C11.538 7.40097 11.6209 7.34611 11.7129 7.30811C11.8959 7.23211 12.1029 7.23211 12.2859 7.30811C12.3779 7.34611 12.461 7.40097 12.53 7.46997L15.53 10.47C15.823 10.763 15.823 11.237 15.53 11.53Z",
                fill: "currentColor"
            })
        })
    });
}
function BadgeDiscountSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.1219 9.87999L19.681 9.43898C19.4 9.15798 19.2419 8.77598 19.2419 8.37798V7.75697C19.2419 6.10097 17.9 4.75899 16.244 4.75899H15.623C15.225 4.75899 14.844 4.60099 14.562 4.31999L14.1209 3.87898C12.9499 2.70798 11.0519 2.70798 9.88094 3.87898L9.4399 4.31999C9.1589 4.60099 8.77698 4.75899 8.37898 4.75899H7.75801C6.10201 4.75899 4.75996 6.10097 4.75996 7.75697V8.37798C4.75996 8.77598 4.602 9.15698 4.321 9.43898L3.87996 9.87999C2.70896 11.051 2.70896 12.949 3.87996 14.12L4.321 14.561C4.602 14.842 4.75996 15.224 4.75996 15.622V16.243C4.75996 17.899 6.10201 19.241 7.75801 19.241H8.37898C8.77698 19.241 9.1579 19.399 9.4399 19.68L9.88094 20.121C11.0519 21.292 12.9499 21.292 14.1209 20.121L14.562 19.68C14.843 19.399 15.225 19.241 15.623 19.241H16.244C17.9 19.241 19.2419 17.899 19.2419 16.243V15.622C19.2419 15.224 19.4 14.843 19.681 14.561L20.1219 14.12C21.2929 12.949 21.2929 11.051 20.1219 9.87999ZM9.50996 8.49998H9.51997C10.073 8.49998 10.52 8.94798 10.52 9.49998C10.52 10.052 10.073 10.5 9.51997 10.5C8.96797 10.5 8.51497 10.052 8.51497 9.49998C8.51497 8.94798 8.95796 8.49998 9.50996 8.49998ZM10.03 15.03C9.88398 15.176 9.69195 15.25 9.49995 15.25C9.30795 15.25 9.11592 15.177 8.96992 15.03C8.67692 14.737 8.67692 14.262 8.96992 13.969L13.9699 8.96898C14.2629 8.67598 14.738 8.67598 15.031 8.96898C15.324 9.26198 15.324 9.73698 15.031 10.03L10.03 15.03ZM14.52 15.5C13.968 15.5 13.515 15.052 13.515 14.5C13.515 13.948 13.958 13.5 14.51 13.5H14.52C15.073 13.5 15.52 13.948 15.52 14.5C15.52 15.052 15.072 15.5 14.52 15.5Z",
                fill: "currentColor"
            })
        })
    });
}
function BoltSquareAltSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M17.62 3H6.38C4.12 3 3 4.13 3 6.38V17.63C3 19.88 4.12 21 6.38 21H17.62C19.88 21 21 19.88 21 17.63V6.38C21 4.13 19.88 3 17.62 3ZM16.56 11.64L11.06 17.75C10.98 17.83 10.88 17.88 10.78 17.88C10.73 17.88 10.69 17.87 10.64 17.85C10.5 17.79 10.4 17.66 10.4 17.5V12.99H7.71997C7.56997 12.99 7.44 12.9 7.38 12.76C7.32 12.63 7.34 12.47 7.44 12.36L12.94 6.25C13.05 6.13 13.21 6.08999 13.36 6.14999C13.5 6.20999 13.6 6.34 13.6 6.5V11.01H16.28C16.43 11.01 16.56 11.1 16.62 11.24C16.68 11.37 16.66 11.53 16.56 11.64Z",
                fill: "currentColor"
            })
        })
    });
}
function BookTextSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M18.5 2.25H7C4.582 2.25 3.25 3.582 3.25 6V18C3.25 20.243 4.757 21.75 7 21.75H18.5C19.74 21.75 20.75 20.741 20.75 19.5V13.5V4.5C20.75 3.259 19.74 2.25 18.5 2.25ZM9 6.25H15C15.414 6.25 15.75 6.586 15.75 7C15.75 7.414 15.414 7.75 15 7.75H9C8.586 7.75 8.25 7.414 8.25 7C8.25 6.586 8.586 6.25 9 6.25ZM9 9.25H13C13.414 9.25 13.75 9.586 13.75 10C13.75 10.414 13.414 10.75 13 10.75H9C8.586 10.75 8.25 10.414 8.25 10C8.25 9.586 8.586 9.25 9 9.25ZM19.25 19.5C19.25 19.914 18.913 20.25 18.5 20.25H7C4.97 20.25 4.75 18.676 4.75 18C4.75 17.324 4.97 15.75 7 15.75H18.5C18.645 15.75 18.7851 15.733 18.9221 15.707C18.9661 15.699 19.008 15.684 19.051 15.673C19.117 15.656 19.186 15.644 19.25 15.621V19.5Z",
                fill: "currentColor"
            })
        })
    });
}
function CaretDownSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M10.698 15.396L6.3181 10.2019C5.5821 9.3289 6.20603 8 7.35203 8H16.6479C17.7939 8 18.4179 9.3299 17.6819 10.2019L13.302 15.396C12.623 16.201 11.377 16.201 10.698 15.396Z",
                fill: "currentColor"
            })
        })
    });
}
function CaretUpSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M13.302 8.60399L17.6819 13.7981C18.4179 14.6711 17.7939 16 16.6479 16H7.35203C6.20603 16 5.5821 14.6701 6.3181 13.7981L10.698 8.60399C11.377 7.79899 12.623 7.79899 13.302 8.60399Z",
                fill: "currentColor"
            })
        })
    });
}
function CheckCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.03 10.2L11.36 14.86C11.22 15.01 11.03 15.08 10.83 15.08C10.64 15.08 10.45 15.01 10.3 14.86L7.97 12.53C7.68 12.24 7.68 11.76 7.97 11.47C8.26 11.18 8.74 11.18 9.03 11.47L10.83 13.27L14.97 9.14001C15.26 8.84001 15.74 8.84001 16.03 9.14001C16.32 9.43001 16.32 9.90001 16.03 10.2Z",
                fill: "currentColor"
            })
        })
    });
}
function CoinsSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M7.5 18.01C7.5 18.74 7.72 19.4 8.13 19.97C5.45 19.8 3 18.82 3 17.01V16.13C4.05 16.95 5.6 17.5 7.5 17.68V18.01ZM7.53998 13.94C7.52998 13.95 7.53003 13.96 7.53003 13.97C7.51003 14.07 7.5 14.17 7.5 14.27V16.18C5.08 15.9 3 14.94 3 13.27V12.39C4.05 13.22 5.61003 13.77 7.53003 13.94H7.53998V13.94ZM11.44 10.28C9.92 10.75 8.73001 11.52 8.07001 12.48C5.41001 12.31 3 11.33 3 9.53003V8.84998C4.31 9.87998 6.41 10.48 9 10.48C9.87 10.48 10.69 10.41 11.44 10.28ZM15 8.84998V9.53003C15 9.62003 14.99 9.70003 14.98 9.78003C14.19 9.78003 13.44 9.84997 12.74 9.96997C13.64 9.69997 14.4 9.31998 15 8.84998ZM9 3C6 3 3 3.99999 3 5.98999C3 7.99999 6 8.97998 9 8.97998C12 8.97998 15 7.99999 15 5.98999C15 3.99999 12 3 9 3ZM15 18.76C12.49 18.76 10.35 18.1 9 17.03V18.01C9 20 12 21 15 21C18 21 21 20 21 18.01V17.03C19.65 18.1 17.51 18.76 15 18.76ZM15 11.28C11.69 11.28 9 12.62 9 14.27C9 15.92 11.69 17.26 15 17.26C18.31 17.26 21 15.92 21 14.27C21 12.62 18.31 11.28 15 11.28Z",
                fill: "currentColor"
            })
        })
    });
}
function DocumentListSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21 11.5V18.25C21 18.94 20.44 19.5 19.75 19.5C19.06 19.5 18.5 18.94 18.5 18.25V10H19.5C20.328 10 21 10.672 21 11.5ZM17 19V6C17 4 16 3 14 3H6C4 3 3 4 3 6V18C3 20 4 21 6 21H19C17.896 21 17 20.105 17 19ZM6.5 16.75C6.086 16.75 5.75 16.414 5.75 16C5.75 15.586 6.086 15.25 6.5 15.25C6.914 15.25 7.25 15.586 7.25 16C7.25 16.414 6.914 16.75 6.5 16.75ZM6.5 12.75C6.086 12.75 5.75 12.414 5.75 12C5.75 11.586 6.086 11.25 6.5 11.25C6.914 11.25 7.25 11.586 7.25 12C7.25 12.414 6.914 12.75 6.5 12.75ZM6.5 8.75C6.086 8.75 5.75 8.414 5.75 8C5.75 7.586 6.086 7.25 6.5 7.25C6.914 7.25 7.25 7.586 7.25 8C7.25 8.414 6.914 8.75 6.5 8.75ZM13.5 16.75H9C8.586 16.75 8.25 16.414 8.25 16C8.25 15.586 8.586 15.25 9 15.25H13.5C13.914 15.25 14.25 15.586 14.25 16C14.25 16.414 13.914 16.75 13.5 16.75ZM13.5 12.75H9C8.586 12.75 8.25 12.414 8.25 12C8.25 11.586 8.586 11.25 9 11.25H13.5C13.914 11.25 14.25 11.586 14.25 12C14.25 12.414 13.914 12.75 13.5 12.75ZM13.5 8.75H9C8.586 8.75 8.25 8.414 8.25 8C8.25 7.586 8.586 7.25 9 7.25H13.5C13.914 7.25 14.25 7.586 14.25 8C14.25 8.414 13.914 8.75 13.5 8.75Z",
                fill: "currentColor"
            })
        })
    });
}
function ExclamationCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM11.25 7.5C11.25 7.086 11.586 6.75 12 6.75C12.414 6.75 12.75 7.086 12.75 7.5V12.071C12.75 12.485 12.414 12.821 12 12.821C11.586 12.821 11.25 12.485 11.25 12.071V7.5ZM12.02 16.5C11.468 16.5 11.0149 16.052 11.0149 15.5C11.0149 14.948 11.458 14.5 12.01 14.5H12.02C12.573 14.5 13.02 14.948 13.02 15.5C13.02 16.052 12.572 16.5 12.02 16.5Z",
                fill: "currentColor"
            })
        })
    });
}
function FileCheckSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M14.75 6V3.75L19.25 8.25H17C15.42 8.25 14.75 7.58 14.75 6ZM20 9.75V18C20 20 19 21 17 21H8C6 21 5 20 5 18V6C5 4 6 3 8 3H13.25V6C13.25 8.42 14.58 9.75 17 9.75H20ZM15.53 11.803C15.237 11.51 14.762 11.51 14.469 11.803L11.666 14.606L10.5291 13.47C10.2361 13.177 9.76102 13.177 9.46802 13.47C9.17502 13.763 9.17502 14.238 9.46802 14.531L11.135 16.198C11.276 16.339 11.466 16.418 11.665 16.418C11.864 16.418 12.0551 16.339 12.1951 16.198L15.5281 12.865C15.8231 12.571 15.823 12.096 15.53 11.803Z",
                fill: "currentColor"
            })
        })
    });
}
function HandHoldingDollarCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M5 22H3C2.448 22 2 21.552 2 21V17C2 16.448 2.448 16 3 16H5C5.552 16 6 16.448 6 17V21C6 21.552 5.552 22 5 22ZM19.66 16.02C19.43 16.02 19.2 16.08 18.98 16.21L16.71 17.5699C16.5 18.7999 15.42 19.75 14.12 19.75H11C10.59 19.75 10.25 19.41 10.25 19C10.25 18.59 10.59 18.25 11 18.25H14.12C14.74 18.25 15.25 17.75 15.25 17.12C15.25 16.5 14.74 16 14.12 16H9C7.9 16 7 16.9 7 18V20C7 21.1 7.9 22 9 22H14.6C15.51 22 16.39 21.69 17.1 21.12L20.5 18.4C20.82 18.15 21 17.76 21 17.36C21 16.58 20.36 16.02 19.66 16.02ZM18 7.5C18 10.809 15.309 13.5 12 13.5C8.691 13.5 6 10.809 6 7.5C6 4.191 8.691 1.5 12 1.5C15.309 1.5 18 4.191 18 7.5ZM14.25 8.91199C14.25 7.96999 13.626 7.14894 12.731 6.91394L11.646 6.63403C11.535 6.60503 11.438 6.53894 11.363 6.43994C11.29 6.34394 11.25 6.21901 11.25 6.08801C11.25 5.77901 11.48 5.52698 11.764 5.52698H12.237C12.497 5.52698 12.717 5.74102 12.748 6.02502C12.792 6.43702 13.157 6.73194 13.575 6.68994C13.987 6.64594 14.284 6.27504 14.24 5.86304C14.146 4.99204 13.531 4.307 12.737 4.099V3.99902C12.737 3.58502 12.401 3.24902 11.987 3.24902C11.573 3.24902 11.237 3.58502 11.237 3.99902V4.10803C10.384 4.34703 9.75201 5.13904 9.75201 6.08704C9.75201 6.54404 9.90101 6.99004 10.169 7.34204C10.442 7.70604 10.833 7.96898 11.272 8.08398L12.357 8.36401C12.59 8.42501 12.753 8.65003 12.753 8.91003C12.753 9.06303 12.696 9.20696 12.593 9.31396C12.536 9.37296 12.416 9.46997 12.239 9.46997H11.766C11.506 9.46997 11.286 9.25605 11.255 8.97205C11.211 8.56005 10.847 8.26401 10.428 8.30701C10.016 8.35101 9.719 8.72203 9.763 9.13403C9.856 9.99303 10.456 10.671 11.236 10.889V11C11.236 11.414 11.572 11.75 11.986 11.75C12.4 11.75 12.736 11.414 12.736 11V10.9C13.085 10.808 13.408 10.6281 13.67 10.3571C14.044 9.96906 14.25 9.45499 14.25 8.91199Z",
                fill: "currentColor"
            })
        })
    });
}
function HourglassSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M17.49 8.86011L12.02 12L6.52002 8.86011C5.58002 8.33011 5 8.00001 5 6.26001V4.5C5 3.67 5.67 3 6.5 3H17.5C18.33 3 19 3.67 19 4.5V6.26001C19 8.00001 18.42 8.33011 17.49 8.86011ZM5 17.74V19.5C5 20.33 5.67 21 6.5 21H17.5C18.33 21 19 20.33 19 19.5V17.74C19 16 18.42 15.6699 17.49 15.1399L12.02 12L6.52002 15.1399C5.58002 15.6699 5 16 5 17.74Z",
                fill: "currentColor"
            })
        })
    });
}
function InfoCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12.75 16.5C12.75 16.914 12.414 17.25 12 17.25C11.586 17.25 11.25 16.914 11.25 16.5V11.929C11.25 11.515 11.586 11.179 12 11.179C12.414 11.179 12.75 11.515 12.75 11.929V16.5ZM12.02 9.5C11.468 9.5 11.0149 9.052 11.0149 8.5C11.0149 7.948 11.458 7.5 12.01 7.5H12.02C12.573 7.5 13.02 7.948 13.02 8.5C13.02 9.052 12.572 9.5 12.02 9.5Z",
                fill: "currentColor"
            })
        })
    });
}
function InvoiceSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21 11.5V18.25C21 18.94 20.44 19.5 19.75 19.5C19.06 19.5 18.5 18.94 18.5 18.25V10H19.5C20.328 10 21 10.672 21 11.5ZM19 21H6C4 21 3 20 3 18V6C3 4 4 3 6 3H14C16 3 17 4 17 6V19C17 20.104 17.895 21 19 21ZM6.25 7.29004C6.25 7.70504 6.38499 8.11105 6.62799 8.43005C6.87699 8.76205 7.233 9.00196 7.633 9.10596L8.56201 9.34595C8.71501 9.38595 8.82202 9.53596 8.82202 9.70996C8.82202 9.84996 8.75403 9.94106 8.71503 9.98206C8.67103 10.0281 8.59501 10.083 8.48901 10.083H8.08398C7.91798 10.083 7.77299 9.93695 7.75299 9.75195C7.70799 9.33995 7.34303 9.04304 6.92603 9.08704C6.51403 9.13104 6.21699 9.50194 6.26099 9.91394C6.34199 10.6659 6.85201 11.2661 7.52301 11.4871V11.5C7.52301 11.914 7.85901 12.25 8.27301 12.25C8.68701 12.25 9.02301 11.914 9.02301 11.5V11.493C9.31001 11.403 9.57501 11.25 9.79401 11.024C10.134 10.67 10.321 10.2041 10.321 9.71106C10.321 8.85506 9.75403 8.10902 8.93903 7.89502L8.00897 7.65503C7.91897 7.63103 7.86097 7.57398 7.82397 7.52698C7.77697 7.46498 7.74902 7.37902 7.74902 7.29102C7.74902 7.08502 7.89797 6.91699 8.08197 6.91699H8.487C8.655 6.91699 8.79799 7.05905 8.81799 7.24805C8.86199 7.66005 9.22402 7.95396 9.64502 7.91296C10.057 7.86896 10.354 7.49806 10.31 7.08606C10.228 6.32506 9.70597 5.71998 9.02197 5.50598V5.50098C9.02197 5.08698 8.68597 4.75098 8.27197 4.75098C7.85797 4.75098 7.52197 5.08698 7.52197 5.50098V5.51599C6.78697 5.75899 6.25 6.45804 6.25 7.29004ZM10.75 17C10.75 16.586 10.414 16.25 10 16.25H7C6.586 16.25 6.25 16.586 6.25 17C6.25 17.414 6.586 17.75 7 17.75H10C10.414 17.75 10.75 17.414 10.75 17ZM13.75 14C13.75 13.586 13.414 13.25 13 13.25H7C6.586 13.25 6.25 13.586 6.25 14C6.25 14.414 6.586 14.75 7 14.75H13C13.414 14.75 13.75 14.414 13.75 14Z",
                fill: "currentColor"
            })
        })
    });
}
function LockSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M16.75 9.05811V7C16.75 4.38 14.62 2.25 12 2.25C9.38 2.25 7.25 4.38 7.25 7V9.05811C5.752 9.29111 5 10.269 5 12V18C5 20 6 21 8 21H16C18 21 19 20 19 18V12C19 10.269 18.248 9.29111 16.75 9.05811ZM12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14C13.27 14.412 13.057 14.7601 12.75 14.9871ZM15.25 9H8.75V7C8.75 5.21 10.21 3.75 12 3.75C13.79 3.75 15.25 5.21 15.25 7V9Z",
                fill: "currentColor"
            })
        })
    });
}
function MinusCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.5 12.75H8.5C8.09 12.75 7.75 12.41 7.75 12C7.75 11.59 8.09 11.25 8.5 11.25H15.5C15.91 11.25 16.25 11.59 16.25 12C16.25 12.41 15.91 12.75 15.5 12.75Z",
                fill: "currentColor"
            })
        })
    });
}
function MoreHorizontalSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M4.02002 14C2.91602 14 2.01501 13.104 2.01501 12C2.01501 10.896 2.90501 10 4.01001 10H4.02002C5.12402 10 6.02002 10.896 6.02002 12C6.02002 13.104 5.12502 14 4.02002 14ZM14.02 12C14.02 10.896 13.124 10 12.02 10H12.01C10.906 10 10.015 10.896 10.015 12C10.015 13.104 10.915 14 12.02 14C13.125 14 14.02 13.104 14.02 12ZM22.02 12C22.02 10.896 21.124 10 20.02 10H20.01C18.906 10 18.015 10.896 18.015 12C18.015 13.104 18.915 14 20.02 14C21.125 14 22.02 13.104 22.02 12Z",
                fill: "currentColor"
            })
        })
    });
}
function PenSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M17.0371 11.577C17.1541 11.694 17.1541 11.8849 17.0371 12.0019L8 21H3V16L11.998 6.963C12.115 6.845 12.3051 6.845 12.4231 6.963L17.0371 11.577ZM20.4099 5.81005L18.1899 3.58995C17.4059 2.80595 16.1341 2.80595 15.3501 3.58995L13.4719 5.468C13.3549 5.585 13.3549 5.77496 13.4719 5.89196L18.1079 10.5279C18.2249 10.6449 18.415 10.6449 18.532 10.5279L20.4099 8.65001C21.1939 7.86601 21.1939 6.59405 20.4099 5.81005Z",
                fill: "currentColor"
            })
        })
    });
}
function PlusCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.5 12.75H12.75V15.5C12.75 15.91 12.41 16.25 12 16.25C11.59 16.25 11.25 15.91 11.25 15.5V12.75H8.5C8.09 12.75 7.75 12.41 7.75 12C7.75 11.59 8.09 11.25 8.5 11.25H11.25V8.5C11.25 8.09 11.59 7.75 12 7.75C12.41 7.75 12.75 8.09 12.75 8.5V11.25H15.5C15.91 11.25 16.25 11.59 16.25 12C16.25 12.41 15.91 12.75 15.5 12.75Z",
                fill: "currentColor"
            })
        })
    });
}
function ShieldCheckSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12.0181 2C9.77807 3.111 8 4 3 5C3 6.137 3 9.70192 3 10.8889C3 17.5559 8.667 20.889 12 22C15.333 20.889 21 17.5559 21 10.8889C21 9.66392 21 6.194 21 5C16 4 14.2221 3.111 12.0181 2ZM15.542 10.53L11.542 14.53C11.396 14.676 11.204 14.75 11.012 14.75C10.82 14.75 10.6279 14.677 10.4819 14.53L8.48193 12.53C8.18893 12.237 8.18893 11.762 8.48193 11.469C8.77493 11.176 9.24997 11.176 9.54297 11.469L11.0129 12.939L14.4829 9.46899C14.7759 9.17599 15.2509 9.17599 15.5439 9.46899C15.8369 9.76199 15.835 10.237 15.542 10.53Z",
                fill: "currentColor"
            })
        })
    });
}
function StarMagicSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M19.276 13.359L15.25 14.619C14.948 14.713 14.7119 14.95 14.6169 15.252L13.358 19.275C13.103 20.09 12.0249 20.262 11.5329 19.565L9.11398 16.138C8.93098 15.879 8.63191 15.727 8.31491 15.732L3.97495 15.797C3.17695 15.809 2.71496 14.901 3.19296 14.261L5.79892 10.773C5.98892 10.519 6.04201 10.1889 5.94101 9.88895L4.59799 5.90598C4.32599 5.09798 5.09798 4.32599 5.90598 4.59799L9.88791 5.94095C10.1879 6.04195 10.5179 5.98898 10.7719 5.79898L14.259 3.19296C14.899 2.71496 15.807 3.17695 15.795 3.97495L15.7299 8.31595C15.7249 8.63295 15.877 8.93196 16.136 9.11496L19.5649 11.536C20.2609 12.028 20.09 13.104 19.276 13.359ZM21.53 20.4699L18.53 17.4699C18.237 17.1769 17.762 17.1769 17.469 17.4699C17.176 17.7629 17.176 18.238 17.469 18.531L20.469 21.531C20.615 21.677 20.807 21.7509 20.999 21.7509C21.191 21.7509 21.383 21.678 21.529 21.531C21.823 21.238 21.823 20.7619 21.53 20.4699Z",
                fill: "currentColor"
            })
        })
    });
}
function TimesCircleSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.53 14.47C15.82 14.76 15.82 15.24 15.53 15.53C15.38 15.68 15.19 15.75 15 15.75C14.81 15.75 14.62 15.68 14.47 15.53L12 13.06L9.53 15.53C9.38 15.68 9.19 15.75 9 15.75C8.81 15.75 8.62 15.68 8.47 15.53C8.18 15.24 8.18 14.76 8.47 14.47L10.94 12L8.47 9.53003C8.18 9.24003 8.18 8.75997 8.47 8.46997C8.76 8.17997 9.24 8.17997 9.53 8.46997L12 10.94L14.47 8.46997C14.76 8.17997 15.24 8.17997 15.53 8.46997C15.82 8.75997 15.82 9.24003 15.53 9.53003L13.06 12L15.53 14.47Z",
                fill: "currentColor"
            })
        })
    });
}
function TimesSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z",
                fill: "currentColor"
            })
        })
    });
}
function TriangleExclamationSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.6069 17.1522L14.9999 4.79599C13.7199 2.40199 10.2809 2.40199 8.99993 4.79599L2.393 17.1522C1.219 19.3482 2.81304 22.0001 5.30804 22.0001H18.6918C21.1858 22.0001 22.7809 19.3472 21.6069 17.1522ZM11.2499 10.0001C11.2499 9.58609 11.5859 9.25009 11.9999 9.25009C12.4139 9.25009 12.7499 9.58609 12.7499 10.0001V14.0001C12.7499 14.4141 12.4139 14.7501 11.9999 14.7501C11.5859 14.7501 11.2499 14.4141 11.2499 14.0001V10.0001ZM12.02 18.0001C11.468 18.0001 11.0148 17.5521 11.0148 17.0001C11.0148 16.4481 11.4579 16.0001 12.0099 16.0001H12.02C12.573 16.0001 13.02 16.4481 13.02 17.0001C13.02 17.5521 12.572 18.0001 12.02 18.0001Z",
                fill: "currentColor"
            })
        })
    });
}
const TurnIcons = {
    cafOperator: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HourglassSolid, {
        style: {
            color: dist_palette_WorkingTurnsColors.cafOperator
        }
    }),
    user: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoltSquareAltSolid, {
        style: {
            color: dist_palette_WorkingTurnsColors.user
        }
    }),
    finalized: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileCheckSolid, {
        style: {
            color: dist_palette_WorkingTurnsColors.finalized
        }
    })
};
function UploadAltSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.SvgIcon, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M19.4141 21.75H5.41504C5.00104 21.75 4.66504 21.414 4.66504 21C4.66504 20.586 5.00104 20.25 5.41504 20.25H19.4141C19.8281 20.25 20.1641 20.586 20.1641 21C20.1641 21.414 19.8281 21.75 19.4141 21.75ZM8.58496 11V16C8.58496 16.552 9.03296 17 9.58496 17H15.585C16.137 17 16.585 16.552 16.585 16V11H19.0081C19.9041 11 20.339 9.90604 19.688 9.29104L13.4131 3.363C12.9011 2.879 12.0989 2.879 11.5869 3.363L5.31201 9.29104C4.66101 9.90604 5.09594 11 5.99194 11H8.58496Z",
                fill: "currentColor"
            })
        })
    });
}
const wrapperStyle = {
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    gap: Spacing["250"],
    alignItems: alignment_Alignment.center,
    lineHeight: "166%"
};
const GridIconWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    height: Spacing["1250"]
});
const BoxWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    wrapperStyle
});
function InnerLabel({ label, icon, className }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        className: className,
        style: {
            display: displaying_Displaying.flex,
            flexDirection: direction_Direction.row,
            gap: Spacing["250"],
            whiteSpace: "nowrap"
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "primary",
                variant: "caption",
                children: label
            }),
            icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridIconWrapper, {
                item: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxWrapper, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ShieldCheckSolid, {
                        color: "secondary",
                        fontSize: "small"
                    })
                })
            })
        ]
    });
}
function Visa(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "25",
            viewBox: "0 0 36 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "0.78125",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.9768 16.9364H8.79971L7.16714 10.6178C7.08965 10.3271 6.92512 10.0701 6.6831 9.94904C6.07911 9.64469 5.41356 9.40248 4.6875 9.28032V9.03705H8.19466C8.6787 9.03705 9.04173 9.40248 9.10224 9.82688L9.94931 14.3847L12.1254 9.03705H14.242L10.9768 16.9364ZM15.4526 16.9364H13.3965L15.0896 9.03705H17.1457L15.4526 16.9364ZM19.8051 11.226C19.8656 10.8006 20.2287 10.5573 20.6522 10.5573C21.3177 10.4962 22.0427 10.6184 22.6478 10.9217L23.0108 9.2209C22.4058 8.97763 21.7402 8.85547 21.1362 8.85547C19.1406 8.85547 17.6885 9.94964 17.6885 11.4682C17.6885 12.6235 18.7171 13.2301 19.4432 13.5955C20.2287 13.9599 20.5312 14.2031 20.4707 14.5675C20.4707 15.1141 19.8656 15.3573 19.2616 15.3573C18.5356 15.3573 17.8095 15.1751 17.145 14.8708L16.782 16.5726C17.5081 16.8759 18.2936 16.9981 19.0196 16.9981C21.2572 17.0581 22.6478 15.965 22.6478 14.3242C22.6478 12.258 19.8051 12.1369 19.8051 11.226ZM29.8442 16.9364L28.2117 9.03705H26.4581C26.0951 9.03705 25.732 9.28032 25.611 9.64469L22.5879 16.9364H24.7045L25.127 15.7822H27.7276L27.9696 16.9364H29.8442ZM26.7601 11.1656L27.3641 14.1428H25.671L26.7601 11.1656Z",
                    fill: "#172B85"
                })
            ]
        })
    });
}
function Amex(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.4585",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "#1F72CD",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.15272 8.78143L3.80225 16.5246H7.81323L8.31048 15.29H9.44707L9.94432 16.5246H14.3593V15.5823L14.7527 16.5246H17.0365L17.4299 15.5624V16.5246H26.6118L27.7283 15.3221L28.7737 16.5246L33.4897 16.5346L30.1287 12.6746L33.4897 8.78143H28.8468L27.76 9.96173L26.7475 8.78143H16.7588L15.901 10.78L15.0232 8.78143H11.0206V9.69165L10.5753 8.78143H7.15272ZM20.8638 9.883H26.1365L27.7491 11.7022L29.4138 9.883H31.0265L28.5762 12.6756L31.0265 15.436H29.3407L27.728 13.5956L26.0548 15.436H20.8638V9.883ZM22.1665 12.0467V11.0324V11.0314H25.4565L26.8921 12.6535L25.3929 14.2845H22.1665V13.1772H25.043V12.0467H22.1665ZM7.9282 9.883H9.88334L12.1057 15.1337V9.883H14.2475L15.964 13.6477L17.546 9.883H19.6771V15.4392H18.3804L18.3698 11.0854L16.4793 15.4392H15.3193L13.4183 11.0854V15.4392H10.7506L10.2449 14.1936H7.51259L7.0079 15.4381H5.57861L7.9282 9.883ZM7.97998 13.0395L8.88016 10.8205L9.7793 13.0395H7.97998Z",
                    fill: "white"
                })
            ]
        })
    });
}
function MasterCard(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.13525",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6579 18.2752C17.2867 19.4257 15.5079 20.1203 13.5642 20.1203C9.22721 20.1203 5.71143 16.6625 5.71143 12.3971C5.71143 8.13163 9.22721 4.67383 13.5642 4.67383C15.5079 4.67383 17.2867 5.36837 18.6579 6.51889C20.0292 5.36837 21.808 4.67383 23.7517 4.67383C28.0886 4.67383 31.6044 8.13163 31.6044 12.3971C31.6044 16.6625 28.0886 20.1203 23.7517 20.1203C21.808 20.1203 20.0292 19.4257 18.6579 18.2752Z",
                    fill: "#ED0006"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6577 18.2752C20.3461 16.8586 21.4167 14.7508 21.4167 12.3971C21.4167 10.0433 20.3461 7.93546 18.6577 6.51888C20.029 5.36837 21.8078 4.67383 23.7515 4.67383C28.0884 4.67383 31.6042 8.13163 31.6042 12.3971C31.6042 16.6625 28.0884 20.1203 23.7515 20.1203C21.8078 20.1203 20.029 19.4257 18.6577 18.2752Z",
                    fill: "#F9A000"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6579 18.2752C20.3463 16.8586 21.4169 14.7508 21.4169 12.3971C21.4169 10.0433 20.3463 7.93546 18.6579 6.51888C16.9695 7.93546 15.8989 10.0433 15.8989 12.397C15.8989 14.7508 16.9695 16.8586 18.6579 18.2752Z",
                    fill: "#FF5E00"
                })
            ]
        })
    });
}
function Maestro(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "25",
            viewBox: "0 0 36 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "0.8125",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.7758 12.4141C20.7758 16.6813 17.3562 20.1406 13.1379 20.1406C8.9196 20.1406 5.5 16.6813 5.5 12.4141C5.5 8.1468 8.9196 4.6875 13.1379 4.6875C17.3562 4.6875 20.7758 8.1468 20.7758 12.4141Z",
                    fill: "#ED0006"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M30.684 12.4141C30.684 16.6813 27.2644 20.1406 23.0461 20.1406C18.8278 20.1406 15.4082 16.6813 15.4082 12.4141C15.4082 8.1468 18.8278 4.6875 23.0461 4.6875C27.2644 4.6875 30.684 8.1468 30.684 12.4141Z",
                    fill: "#0099DF"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.093 18.2951C19.7353 16.8779 20.7768 14.7691 20.7768 12.4142C20.7768 10.0592 19.7354 7.9504 18.093 6.5332C16.4506 7.9504 15.4092 10.0593 15.4092 12.4142C15.4092 14.7691 16.4506 16.8779 18.093 18.2951Z",
                    fill: "#6C6BBD"
                })
            ]
        })
    });
}
function Paypal(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.48975",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.021 15.8768H9.40057C9.28968 15.8768 9.19537 15.9574 9.17808 16.0669L8.5227 20.2221C8.50967 20.3041 8.57317 20.378 8.65634 20.378H9.42995C9.54084 20.378 9.63514 20.2975 9.65244 20.1878L9.8292 19.0671C9.84625 18.9573 9.94079 18.8768 10.0515 18.8768H10.5644C11.6319 18.8768 12.2479 18.3603 12.4088 17.3367C12.4813 16.8889 12.4119 16.537 12.2021 16.2905C11.9719 16.02 11.5633 15.8768 11.021 15.8768ZM11.208 17.3945C11.1194 17.976 10.6751 17.976 10.2455 17.976H10.001L10.1725 16.89C10.1827 16.8244 10.2396 16.7761 10.3059 16.7761H10.418C10.7106 16.7761 10.9867 16.7761 11.1293 16.9428C11.2143 17.0424 11.2404 17.1902 11.208 17.3945ZM15.8649 17.3758H15.0889C15.0228 17.3758 14.9656 17.4242 14.9554 17.4899L14.9211 17.7069L14.8668 17.6283C14.6989 17.3844 14.3243 17.3029 13.9504 17.3029C13.0928 17.3029 12.3605 17.9524 12.2178 18.8635C12.1437 19.3178 12.2491 19.7524 12.5069 20.0555C12.7434 20.3341 13.0818 20.4502 13.4843 20.4502C14.1752 20.4502 14.5584 20.0059 14.5584 20.0059L14.5238 20.2216C14.5107 20.304 14.5742 20.3779 14.6569 20.3779H15.3559C15.4671 20.3779 15.5608 20.2973 15.5784 20.1877L15.9978 17.5318C16.011 17.4501 15.9478 17.3758 15.8649 17.3758ZM14.7832 18.8862C14.7083 19.3295 14.3564 19.6271 13.9077 19.6271C13.6824 19.6271 13.5023 19.5548 13.3867 19.4178C13.272 19.2819 13.2284 19.0882 13.2649 18.8727C13.3348 18.4331 13.6926 18.1258 14.1345 18.1258C14.3548 18.1258 14.5339 18.199 14.6519 18.3371C14.7701 18.4767 14.8171 18.6715 14.7832 18.8862ZM19.2178 17.3757H19.9977C20.1069 17.3757 20.1706 17.4982 20.1085 17.5878L17.515 21.3314C17.473 21.3921 17.4038 21.4282 17.3299 21.4282H16.5511C16.4414 21.4282 16.3774 21.3047 16.4409 21.2149L17.2484 20.075L16.3895 17.5544C16.3598 17.4667 16.4245 17.3757 16.5177 17.3757H17.284C17.3835 17.3757 17.4713 17.4411 17.5001 17.5364L17.9559 19.0587L19.0314 17.4745C19.0735 17.4127 19.1435 17.3757 19.2178 17.3757Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.6728 20.2223L28.3378 15.9911C28.348 15.9254 28.4049 15.8771 28.471 15.8768H29.2197C29.3024 15.8768 29.3659 15.951 29.3528 16.033L28.697 20.188C28.6799 20.2977 28.5856 20.3783 28.4745 20.3783H27.8059C27.7232 20.3783 27.6597 20.3044 27.6728 20.2223ZM22.5797 15.8771H20.9589C20.8483 15.8771 20.754 15.9576 20.7367 16.0671L20.0813 20.2223C20.0682 20.3044 20.1317 20.3783 20.2145 20.3783H21.0461C21.1234 20.3783 21.1895 20.3219 21.2016 20.2452L21.3875 19.0673C21.4047 18.9575 21.4992 18.8771 21.6098 18.8771H22.1225C23.1902 18.8771 23.8061 18.3605 23.9672 17.3369C24.0399 16.8891 23.97 16.5372 23.7604 16.2908C23.5302 16.0203 23.122 15.8771 22.5797 15.8771ZM22.7666 17.3947C22.6782 17.9762 22.2339 17.9762 21.8041 17.9762H21.5598L21.7316 16.8902C21.7418 16.8246 21.7982 16.7763 21.8647 16.7763H21.9768C22.2692 16.7763 22.5456 16.7763 22.6881 16.9431C22.7732 17.0426 22.7991 17.1904 22.7666 17.3947ZM27.4231 17.3761H26.6477C26.581 17.3761 26.5244 17.4244 26.5144 17.4901L26.4801 17.7071L26.4256 17.6285C26.2576 17.3846 25.8833 17.3032 25.5094 17.3032C24.6518 17.3032 23.9197 17.9526 23.777 18.8637C23.7031 19.3181 23.8081 19.7526 24.0658 20.0557C24.3028 20.3343 24.6407 20.4504 25.0433 20.4504C25.7342 20.4504 26.1173 20.0061 26.1173 20.0061L26.0827 20.2218C26.0697 20.3043 26.1332 20.3782 26.2164 20.3782H26.9151C27.0257 20.3782 27.12 20.2976 27.1373 20.1879L27.557 17.532C27.5698 17.4503 27.5063 17.3761 27.4231 17.3761ZM26.3415 18.8864C26.2671 19.3297 25.9148 19.6273 25.466 19.6273C25.2411 19.6273 25.0606 19.555 24.9449 19.4181C24.8302 19.2821 24.7871 19.0885 24.8232 18.8729C24.8935 18.4333 25.2508 18.1261 25.6927 18.1261C25.9131 18.1261 26.0922 18.1992 26.2103 18.3374C26.3289 18.4769 26.3758 18.6717 26.3415 18.8864Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M17.0183 14.389L17.2175 13.1236L16.7738 13.1133H14.6548L16.1274 3.77597C16.1319 3.74778 16.1468 3.7215 16.1685 3.70284C16.1902 3.68417 16.2181 3.67389 16.247 3.67389H19.8199C21.0061 3.67389 21.8246 3.92072 22.2521 4.4079C22.4524 4.63646 22.58 4.87528 22.6418 5.13811C22.7064 5.4139 22.7077 5.74339 22.6444 6.14525L22.6398 6.17459V6.43208L22.8402 6.5456C23.009 6.6351 23.143 6.73757 23.2458 6.85489C23.4173 7.0503 23.5282 7.29866 23.575 7.5931C23.6233 7.89593 23.6073 8.25627 23.5282 8.66423C23.4367 9.13352 23.2889 9.54224 23.0893 9.87668C22.9057 10.1848 22.6718 10.4404 22.3942 10.6385C22.129 10.8267 21.814 10.9695 21.4579 11.061C21.1127 11.1508 20.7193 11.1962 20.2877 11.1962H20.0096C19.8108 11.1962 19.6176 11.2678 19.4661 11.3962C19.3141 11.5272 19.2135 11.7062 19.1826 11.902L19.1617 12.0159L18.8097 14.2461L18.7937 14.328C18.7896 14.354 18.7823 14.3669 18.7717 14.3757C18.7621 14.3836 18.7484 14.389 18.7351 14.389H17.0183Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M23.03 6.20709C23.0193 6.27527 23.0072 6.34498 22.9935 6.41659C22.5222 8.83577 20.9102 9.6715 18.8514 9.6715H17.8031C17.5514 9.6715 17.3392 9.85433 17.2999 10.1027L16.7632 13.5066L16.6112 14.4714C16.5857 14.6344 16.7114 14.7815 16.8759 14.7815H18.7352C18.9554 14.7815 19.1424 14.6215 19.177 14.4044L19.1953 14.3099L19.5454 12.0884L19.5679 11.9665C19.6021 11.7487 19.7895 11.5887 20.0097 11.5887H20.2878C22.0891 11.5887 23.4993 10.8573 23.9115 8.74092C24.0836 7.85682 23.9945 7.11862 23.5389 6.59943C23.401 6.44287 23.23 6.31298 23.03 6.20709Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M22.5365 6.00903C22.4646 5.98807 22.3902 5.96903 22.314 5.95189C22.2375 5.93514 22.159 5.92028 22.0783 5.90733C21.7956 5.86162 21.486 5.8399 21.1542 5.8399H18.3537C18.2847 5.8399 18.2193 5.85552 18.1606 5.88371C18.0314 5.94579 17.9355 6.06807 17.9123 6.21777L17.3164 9.9911L17.2993 10.1012C17.3386 9.85282 17.5507 9.66998 17.8025 9.66998H18.8507C20.9096 9.66998 22.5217 8.83388 22.9929 6.41508C23.0069 6.34347 23.0187 6.27377 23.0294 6.20559C22.9102 6.14235 22.781 6.08826 22.642 6.04216C22.6078 6.03074 22.5724 6.0197 22.5365 6.00903Z",
                    fill: "#222D65"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M17.9125 6.21793C17.9358 6.06822 18.0318 5.94595 18.1609 5.88424C18.22 5.85605 18.2851 5.84044 18.354 5.84044H21.1545C21.4863 5.84044 21.796 5.86215 22.0786 5.90786C22.1594 5.92081 22.2379 5.93567 22.3144 5.95242C22.3906 5.96957 22.4648 5.98862 22.5369 6.00956C22.5726 6.02023 22.6081 6.03127 22.6427 6.04232C22.7817 6.08841 22.9109 6.14288 23.0301 6.20574C23.1703 5.31173 23.029 4.70303 22.5457 4.15185C22.0128 3.54506 21.0509 3.28528 19.8202 3.28528H16.2472C15.9958 3.28528 15.7814 3.46811 15.7425 3.71685L14.2543 13.1502C14.2249 13.3368 14.3689 13.5052 14.557 13.5052H16.763L17.3168 9.99125L17.9125 6.21793Z",
                    fill: "#253B80"
                })
            ]
        })
    });
}
function ApplePay(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.1665",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.95529 9.30647C9.43792 9.34777 9.92056 9.05865 10.2222 8.69209C10.5188 8.31521 10.7149 7.80925 10.6646 7.29297C10.2373 7.31362 9.7094 7.58209 9.40776 7.95897C9.13125 8.28423 8.89496 8.81084 8.95529 9.30647ZM14.6958 15.9567V7.9079H17.6368C19.1551 7.9079 20.2159 8.98176 20.2159 10.5513C20.2159 12.1208 19.135 13.2049 17.5966 13.2049H15.9124V15.9567H14.6958ZM10.6591 9.40484C10.2339 9.37971 9.84598 9.53616 9.53261 9.66252C9.33094 9.74384 9.16017 9.81271 9.03025 9.81271C8.88446 9.81271 8.70664 9.74016 8.50698 9.65871C8.24537 9.55198 7.94628 9.42996 7.63263 9.43582C6.91371 9.44615 6.24507 9.86433 5.87807 10.5303C5.12396 11.8623 5.682 13.8345 6.41097 14.9187C6.76792 15.4557 7.19525 16.0442 7.75832 16.0236C8.00604 16.014 8.18423 15.9363 8.36864 15.856C8.58095 15.7634 8.80151 15.6673 9.14588 15.6673C9.47832 15.6673 9.68923 15.7609 9.89169 15.8508C10.0842 15.9362 10.2691 16.0183 10.5435 16.0132C11.1267 16.0029 11.4937 15.4763 11.8506 14.9394C12.2358 14.3631 12.4051 13.8007 12.4308 13.7153L12.4338 13.7055C12.4332 13.7048 12.4285 13.7026 12.4201 13.6987L12.4201 13.6987L12.42 13.6986C12.2913 13.6381 11.3071 13.1754 11.2976 11.9346C11.2881 10.8932 12.0783 10.3655 12.2026 10.2824C12.2102 10.2774 12.2153 10.274 12.2176 10.2722C11.7149 9.5081 10.9306 9.4255 10.6591 9.40484ZM22.4385 16.0174C23.2027 16.0174 23.9116 15.6199 24.2333 14.99H24.2585V15.9555H25.3846V11.9491C25.3846 10.7875 24.4797 10.0389 23.0871 10.0389C21.795 10.0389 20.8398 10.7978 20.8046 11.8407H21.9006C21.9911 11.3451 22.4385 11.0198 23.0519 11.0198C23.7959 11.0198 24.2132 11.376 24.2132 12.0317V12.4757L22.6949 12.5687C21.2822 12.6564 20.5181 13.2501 20.5181 14.2827C20.5181 15.3256 21.3074 16.0174 22.4385 16.0174ZM22.7651 15.0652C22.1166 15.0652 21.7043 14.7451 21.7043 14.2546C21.7043 13.7486 22.1015 13.4544 22.8606 13.4079L24.213 13.3201V13.7745C24.213 14.5282 23.5896 15.0652 22.7651 15.0652ZM29.1197 16.2711C28.6321 17.6805 28.074 18.1452 26.8876 18.1452C26.7971 18.1452 26.4954 18.1348 26.425 18.1142V17.1488C26.5004 17.1591 26.6865 17.1694 26.782 17.1694C27.3199 17.1694 27.6216 16.9371 27.8076 16.333L27.9182 15.9768L25.8569 10.117H27.1289L28.5617 14.872H28.5868L30.0196 10.117H31.2564L29.1197 16.2711ZM15.9126 8.96075H17.3152C18.371 8.96075 18.9743 9.53899 18.9743 10.5561C18.9743 11.5731 18.371 12.1565 17.3102 12.1565H15.9126V8.96075Z",
                    fill: "black"
                })
            ]
        })
    });
}
function Bancomat(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "25",
            viewBox: "0 0 36 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "0.84375",
                    y: "0.781494",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.92472 10.7023H6.2105C6.53412 10.7023 6.81384 11.0526 6.73518 11.5284C6.65638 12.0043 6.33291 12.1931 6.33291 12.1931C6.33291 12.1931 6.50908 12.2559 6.60261 12.4633C6.66934 12.6116 6.6907 12.8343 6.5954 13.1267C6.47387 13.4995 6.1451 13.7735 5.78628 13.7735H4.51817C4.43097 13.7735 4.33464 13.7554 4.3697 13.5668C4.39798 13.4147 4.67151 11.1336 4.70628 10.918C4.72513 10.8014 4.76402 10.7023 4.92472 10.7023ZM5.45809 11.3759L5.38386 11.8697H5.73796C5.86464 11.8697 5.92842 11.7411 5.95656 11.6545C5.99176 11.5465 5.99176 11.3761 5.81662 11.3761L5.45809 11.3759ZM5.28826 12.5195L5.19988 13.1244C5.19988 13.1244 5.51598 13.1276 5.61512 13.1244C5.74503 13.1199 5.8315 12.9837 5.86361 12.8734C5.90338 12.7362 5.90338 12.5195 5.70438 12.5195H5.28826ZM9.18552 13.6299C9.16357 13.4816 8.80092 10.9314 8.78339 10.8595C8.76601 10.7876 8.72211 10.7023 8.62593 10.7023H7.83021C7.7601 10.7023 7.69028 10.7113 7.64638 10.81C7.60278 10.9088 6.57507 13.5311 6.53559 13.6162C6.49626 13.7015 6.5353 13.7734 6.63193 13.7734H7.22672C7.3098 13.7734 7.36681 13.7866 7.41041 13.6701C7.42956 13.6191 7.51381 13.3625 7.61692 13.0472C7.62605 13.0351 7.64329 13.0233 7.67702 13.0233H8.18005C8.19419 13.0233 8.20303 13.0327 8.21025 13.0444C8.23735 13.3749 8.25885 13.6415 8.25885 13.661C8.25885 13.7149 8.29818 13.7734 8.39864 13.7734H9.08535C9.15488 13.7735 9.20334 13.7464 9.18552 13.6299ZM8.13174 12.35C8.08195 12.3479 7.94363 12.35 7.89119 12.35C7.86173 12.35 7.85496 12.3332 7.85555 12.3158C7.92426 12.1042 7.99364 11.8929 8.06368 11.6817C8.08195 11.6272 8.09697 11.6811 8.09697 11.6811C8.09697 11.6811 8.12142 11.9726 8.15118 12.3314C8.14735 12.3419 8.14205 12.3506 8.13174 12.35ZM9.61946 10.8415C9.60179 10.9853 9.29143 13.468 9.27817 13.5534C9.26521 13.6387 9.28716 13.7735 9.42709 13.7735H9.82937C9.88622 13.7735 10.0347 13.7823 10.0653 13.5668C10.096 13.3515 10.2028 12.5736 10.2184 12.4985C10.2316 12.4356 10.2926 12.4444 10.3015 12.4761C10.3103 12.5073 10.6987 13.5135 10.73 13.5805C10.7868 13.7018 10.8307 13.7738 10.9223 13.7738H11.3552C11.4383 13.7738 11.5258 13.7557 11.5476 13.585C11.5694 13.4145 11.8801 10.999 11.8975 10.8822C11.9148 10.7655 11.845 10.7026 11.7357 10.7026H11.294C11.1979 10.7026 11.1409 10.6758 11.1147 10.8282C11.0885 10.981 10.9774 11.7274 10.9662 11.7801C10.9574 11.8205 10.9094 11.8205 10.8961 11.7845C10.8602 11.6861 10.5725 10.9495 10.5289 10.8374C10.485 10.725 10.4547 10.7026 10.3583 10.7026H9.82937C9.69356 10.7023 9.63685 10.6979 9.61946 10.8415ZM13.7827 10.7H12.6764C12.2653 10.7 12.0947 10.938 11.9766 11.4183C11.8838 11.7967 11.7862 12.8283 11.7929 13.0302C11.8061 13.421 11.8499 13.771 12.2172 13.771C12.5845 13.771 13.2535 13.7754 13.3761 13.771C13.4985 13.7666 13.5683 13.7171 13.6078 13.6006C13.6493 13.4771 13.6555 13.3939 13.6646 13.2862C13.6735 13.183 13.6776 13.0887 13.5465 13.0887H12.9037C12.7841 13.0887 12.6107 13.0796 12.6063 12.8776C12.6018 12.6755 12.6151 12.4424 12.6499 12.2132C12.6849 11.9844 12.7344 11.7109 12.7854 11.5533C12.8556 11.3376 12.9474 11.3423 13.1006 11.3423H13.7652C13.8701 11.3423 13.9184 11.2791 13.9443 11.1853C13.9708 11.0909 13.9894 10.9431 13.9927 10.8484C13.9971 10.7179 13.9574 10.7 13.7827 10.7ZM23.6026 10.7023H21.8975C21.7726 10.7023 21.7131 10.697 21.6919 10.8303C21.6684 10.9836 21.6457 11.1371 21.624 11.2906C21.611 11.3846 21.6458 11.3937 21.7333 11.3937H22.1794C22.2186 11.3937 22.2229 11.4161 22.2142 11.479C22.2055 11.5419 21.9555 13.5478 21.9432 13.625C21.9214 13.7598 21.9342 13.7734 22.0482 13.7734C22.1442 13.7734 22.4811 13.776 22.5727 13.7734C22.7218 13.7687 22.7433 13.8046 22.7786 13.6206C22.8131 13.4365 23.0537 11.4834 23.0537 11.4431C23.0537 11.4027 23.0669 11.389 23.1285 11.389C23.1892 11.389 23.5568 11.3846 23.6178 11.389C23.6791 11.3937 23.7053 11.3578 23.7141 11.3083C23.7231 11.2591 23.7423 10.9381 23.7423 10.8751C23.7424 10.7584 23.7296 10.7023 23.6026 10.7023ZM15.9174 13.192C15.8043 13.6623 15.5196 13.7712 15.2525 13.7712H14.251C13.8838 13.7712 13.8115 13.4168 13.8182 13.026C13.8244 12.6531 13.9125 11.8443 14.0019 11.4183C14.1033 10.934 14.2993 10.7 14.7104 10.7H15.6851C15.9653 10.7 16.1684 10.8524 16.1708 11.2031C16.1745 11.7243 16.0918 12.4645 15.9174 13.192ZM14.9825 11.3579C14.8557 11.3668 14.7978 11.4329 14.7727 11.5375C14.7121 11.7891 14.6053 12.5316 14.5889 12.8934C14.582 13.0425 14.6599 13.0713 14.7507 13.0911C14.8384 13.1096 14.9357 13.117 15.009 13.0999C15.0924 13.0805 15.1488 13.0563 15.1837 12.9202C15.2718 12.5767 15.3413 12.0128 15.3715 11.6091C15.3776 11.5312 15.3701 11.3868 15.2538 11.3666C15.1498 11.349 15.1093 11.3487 14.9825 11.3579ZM16.6237 10.7023C16.5624 10.7023 16.4749 10.7291 16.4442 10.9088C16.4137 11.0884 16.0736 13.5042 16.0551 13.6299C16.0419 13.7195 16.0989 13.7735 16.1907 13.7735H16.7068C16.8336 13.7735 16.8728 13.7554 16.9033 13.5894C16.9341 13.4231 17.0784 12.3456 17.0829 12.3007C17.0871 12.2557 17.1223 12.2691 17.1266 12.3051C17.1309 12.341 17.2621 12.9561 17.271 13.0102C17.2794 13.064 17.2972 13.1179 17.3409 13.1223C17.3844 13.1267 17.7385 13.1223 17.765 13.1223C17.7912 13.1223 17.835 13.1314 17.8786 13.064C17.9289 12.9865 18.2417 12.3323 18.2502 12.3052C18.2592 12.2784 18.3069 12.2649 18.3025 12.3008C18.2985 12.3367 18.1256 13.5358 18.1147 13.6072C18.1014 13.6926 18.1542 13.7735 18.2415 13.7735C18.3287 13.7735 18.7314 13.7762 18.7968 13.7735C18.9061 13.7688 18.9499 13.742 18.9936 13.5084C19.0196 13.3706 19.2912 10.9853 19.2997 10.9044C19.313 10.7832 19.2732 10.7023 19.1509 10.7023H18.4603C18.3815 10.7023 18.3115 10.7247 18.2677 10.8011C18.1956 10.9268 17.8108 11.6764 17.7867 11.7171C17.7516 11.7754 17.6949 11.771 17.6774 11.7035C17.6598 11.6362 17.5286 10.9582 17.5114 10.873C17.4935 10.7874 17.4981 10.703 17.3188 10.7022C17.0958 10.7011 16.6847 10.7023 16.6237 10.7023ZM21.7157 13.6275C21.6939 13.4795 21.3314 10.9292 21.3136 10.8571C21.2964 10.7854 21.2523 10.7 21.1563 10.7H20.3606C20.2906 10.7 20.2208 10.7091 20.1767 10.8079C20.133 10.9066 19.1057 13.5287 19.0662 13.6138C19.0268 13.6991 19.066 13.771 19.1623 13.771H19.7569C19.84 13.771 19.897 13.7846 19.9408 13.6677C19.9598 13.6171 20.044 13.3605 20.1473 13.0453C20.1563 13.0332 20.1735 13.0214 20.2074 13.0214H20.7103C20.7244 13.0214 20.7332 13.0308 20.7405 13.0425C20.7676 13.373 20.7891 13.6393 20.7891 13.6588C20.7891 13.7127 20.8283 13.7712 20.9289 13.7712H21.6153C21.6852 13.7712 21.7336 13.7443 21.7157 13.6275ZM20.6618 12.3479C20.612 12.3456 20.474 12.3479 20.4216 12.3479C20.3919 12.3479 20.385 12.3307 20.3856 12.3133C20.4545 12.1019 20.524 11.8907 20.5939 11.6796C20.612 11.6248 20.627 11.6789 20.627 11.6789C20.627 11.6789 20.6518 11.9704 20.6814 12.3291C20.6777 12.3397 20.6723 12.3485 20.6618 12.3479Z",
                    fill: "#1A4678"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("mask", {
                    id: "mask0_3361_5052",
                    style: {
                        maskType: "alpha"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "24",
                    y: "9",
                    width: "8",
                    height: "7",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M31.7622 12.5C31.7622 14.433 30.1952 16 28.2622 16C26.3292 16 24.7622 14.433 24.7622 12.5C24.7622 10.567 26.3292 9 28.2622 9C30.1952 9 31.7622 10.567 31.7622 12.5Z",
                        fill: "#D9D9D9"
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    mask: "url(#mask0_3361_5052)",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M24.7622 9H31.7622V12.5H24.7622V9Z",
                            fill: "#1A4678"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M24.7622 12.5H31.7622V16H24.7622V12.5Z",
                            fill: "#A09EA9"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M30.342 12.934C30.3897 12.9569 30.4343 12.9851 30.4749 13.0183C30.5227 12.9136 30.5389 12.775 30.5101 12.6523C30.4865 12.5532 30.4403 12.4653 30.3562 12.3753C30.2968 12.3067 30.2107 12.2497 30.119 12.209C30.0314 12.173 29.924 12.1514 29.8273 12.1514H29.3951C29.5938 12.0215 29.755 11.8454 29.8638 11.6394C29.939 11.4934 29.9979 11.3382 30.0065 11.1745C30.0156 11.0127 29.979 10.8552 29.915 10.7058C29.8553 10.5665 29.7668 10.4403 29.6548 10.3349C29.5169 10.2059 29.34 10.1217 29.1575 10.0649C29.0019 10.0178 28.839 10 28.6764 10H26.91L26.5984 10.7206L28.2931 10.7177C28.436 10.7119 28.5785 10.771 28.6335 10.8059C28.72 10.8516 28.783 10.9236 28.839 11.0023C28.933 11.1311 28.9621 11.2888 28.952 11.4427C28.9438 11.5878 28.8915 11.7273 28.8018 11.8441C28.7414 11.9213 28.6655 11.986 28.5787 12.0345C28.446 12.1127 28.2906 12.1607 28.1316 12.1607H26.8715L26.5661 12.8802H28.1264C28.2818 12.8802 28.4571 12.9317 28.5871 13.0101C28.6854 13.0691 28.7667 13.162 28.8305 13.2544C28.9057 13.3616 28.9268 13.4702 28.9343 13.6006C28.9431 13.7544 28.9057 13.894 28.8241 14.0231C28.7816 14.0954 28.6964 14.1722 28.6211 14.2182C28.5224 14.2773 28.3997 14.3072 28.2817 14.3072H26.8527L26.5244 15H28.7051C28.8618 15 29.0154 14.9807 29.1648 14.9361C29.3087 14.8927 29.4503 14.8349 29.5693 14.7425C29.7212 14.6239 29.8287 14.466 29.899 14.2915C29.9594 14.1392 29.9845 13.9761 29.9726 13.8136C29.9601 13.6242 29.8952 13.4436 29.7938 13.2823C29.69 13.1197 29.5485 12.9823 29.3803 12.8809H30.0705C30.1818 12.8822 30.257 12.8955 30.342 12.934Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M32.289 9.69093C32.1643 9.69093 32.0579 9.73528 31.9695 9.82398C31.8816 9.91221 31.8377 10.0188 31.8377 10.1437C31.8377 10.2696 31.8814 10.3769 31.9688 10.4656C32.0567 10.5543 32.1634 10.5987 32.289 10.5987C32.4146 10.5987 32.5213 10.5543 32.6092 10.4656C32.697 10.3769 32.741 10.2696 32.741 10.1437C32.741 10.0188 32.697 9.91221 32.6092 9.82398C32.5208 9.73528 32.4141 9.69093 32.289 9.69093ZM32.8155 10.1437C32.8155 10.2892 32.7641 10.4134 32.6614 10.5164C32.5588 10.6194 32.4346 10.6709 32.289 10.6709C32.1433 10.6709 32.0194 10.6194 31.9172 10.5164C31.8155 10.4139 31.7646 10.2897 31.7646 10.1437C31.7646 9.99924 31.816 9.87572 31.9187 9.7732C32.0208 9.67114 32.1443 9.62012 32.289 9.62012C32.4346 9.62012 32.5588 9.67114 32.6614 9.7732C32.7641 9.87525 32.8155 9.99876 32.8155 10.1437ZM32.4265 10.0293C32.4265 9.98731 32.4136 9.95918 32.3878 9.94487C32.3625 9.93057 32.3217 9.92341 32.2653 9.92341H32.1787V10.1323H32.2704C32.3133 10.1323 32.3456 10.128 32.3671 10.1194C32.4067 10.1037 32.4265 10.0736 32.4265 10.0293ZM32.2789 9.85403C32.3506 9.85403 32.4031 9.86094 32.4365 9.87477C32.4962 9.89957 32.5261 9.94821 32.5261 10.0207C32.5261 10.0722 32.5072 10.1101 32.4695 10.1344C32.4494 10.1473 32.4215 10.1566 32.3857 10.1623C32.431 10.1695 32.4642 10.1883 32.4852 10.2188C32.5063 10.2494 32.5168 10.2792 32.5168 10.3083V10.3505C32.5168 10.3638 32.5172 10.3781 32.5182 10.3934C32.5191 10.4086 32.5208 10.4187 32.5232 10.4234L32.5268 10.4306H32.4315C32.431 10.4287 32.4306 10.4268 32.4301 10.4249C32.4296 10.4229 32.4291 10.4208 32.4287 10.4184L32.4265 10.3998V10.354C32.4265 10.2873 32.4084 10.2432 32.3721 10.2217C32.3506 10.2093 32.3129 10.2031 32.2589 10.2031H32.1787V10.4306H32.077V9.85403H32.2789Z",
                    fill: "#1A4678"
                })
            ]
        })
    });
}
const AcceptedPaymentContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"])({
    ".inner-label": {
        width: "auto",
        padding: `0 ${Spacing["250"]}`,
        position: positioning_Positioning.relative,
        background: "inherit"
    }
});
const CommonBorder = `1px solid ${palette_Primary.main}`;
const accepted_payment_BoxWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.spaceBetween,
    padding: `0 ${Spacing["750"]} ${Spacing["1000"]}`,
    borderRadius: `0 0 ${BorderRadius.brand} ${BorderRadius.brand}`,
    border: CommonBorder,
    borderTop: "0",
    width: "auto"
});
const LeftRadiusStyle = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    borderRadius: `${BorderRadius.brand} 0 0 0`,
    borderTop: CommonBorder,
    borderLeft: CommonBorder
});
const RightRadiusStyle = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    borderRadius: `0 ${BorderRadius.brand} 0 0`,
    borderTop: CommonBorder,
    borderRight: CommonBorder
});
const FlexSpaceBetween = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    justifyContent: "space-between"
});
const FlexRow = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row
});
const accepted_payment_fullWidth = {
    width: "100%"
};
function AcceptedPayment({ label, labelIcon, id }) {
    const largeFontSize = "large";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AcceptedPaymentContainer, {
            className: "accepted-payment",
            "data-testid": id ?? "id",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FlexSpaceBetween, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: accepted_payment_fullWidth,
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftRadiusStyle, {
                                    children: "\xa0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FlexRow, {
                            style: accepted_payment_fullWidth,
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: {
                                        display: displaying_Displaying.flex,
                                        alignItems: alignment_Alignment.center
                                    },
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InnerLabel, {
                                        className: "inner-label",
                                        label: label,
                                        icon: labelIcon
                                    })
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: accepted_payment_fullWidth,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                        style: {
                                            borderBottom: CommonBorder
                                        },
                                        children: "\xa0"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: accepted_payment_fullWidth,
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RightRadiusStyle, {
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(accepted_payment_BoxWrapper, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Visa, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Amex, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MasterCard, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Maestro, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Paypal, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ApplePay, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Bancomat, {
                            fontSize: largeFontSize
                        })
                    ]
                })
            ]
        })
    });
}
const icon_button_IconButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, isLoading = false, color, disabled, ...rest }, ref) {
    const isPurpleLightColor = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "purpleLight" === color;
    }, [
        color
    ]);
    const isButtonLoadingOrDisabled = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return isLoading || disabled;
    }, [
        isLoading,
        disabled
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
        disabled: isButtonLoadingOrDisabled,
        ref: ref,
        color: isPurpleLightColor ? "inherit" : color,
        sx: isPurpleLightColor ? {
            color: PurpleLight.contrastText,
            ...!isButtonLoadingOrDisabled && {
                backgroundColor: PurpleLight.main,
                "&:hover": {
                    backgroundColor: `${PurpleLight.dark} !important`
                },
                "& .MuiTouchRipple-child": {
                    backgroundColor: `${PurpleLight.contrastText} !important`
                }
            }
        } : void 0,
        ...rest,
        children: isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
            color: "inherit",
            size: "1rem"
        }) : children
    });
});
var mui_class_collection_MuiClassCollection = /*#__PURE__*/ function(MuiClassCollection) {
    MuiClassCollection["disabled"] = "Mui-disabled";
    MuiClassCollection["selected"] = "Mui-selected";
    MuiClassCollection["hovered"] = "Mui-hovered";
    MuiClassCollection["expanded"] = "Mui-expanded";
    MuiClassCollection["readOnly"] = "Mui-readOnly";
    return MuiClassCollection;
}({});
const DEFAULT_FONT_FAMILY = "DM Sans";
var typography_FontSize = /*#__PURE__*/ function(FontSize) {
    FontSize["xs"] = "0.75rem";
    FontSize["sm"] = "0.875rem";
    FontSize["normal"] = "1rem";
    FontSize["lg"] = "1.25rem";
    FontSize["xl"] = "1.5rem";
    FontSize["2xl"] = "2.125rem";
    FontSize["3xl"] = "3rem";
    FontSize["4xl"] = "3.75rem";
    FontSize["5xl"] = "6rem";
    return FontSize;
}({});
var typography_FontWeight = /*#__PURE__*/ function(FontWeight) {
    FontWeight[FontWeight["normal"] = 400] = "normal";
    FontWeight[FontWeight["medium"] = 500] = "medium";
    FontWeight[FontWeight["bold"] = 700] = "bold";
    return FontWeight;
}({});
var typography_LineHeight = /*#__PURE__*/ function(LineHeight) {
    LineHeight[LineHeight["3xs"] = 1.17] = "3xs";
    LineHeight[LineHeight["2xs"] = 1.2] = "2xs";
    LineHeight[LineHeight["xs"] = 1.24] = "xs";
    LineHeight[LineHeight["sm"] = 1.33] = "sm";
    LineHeight[LineHeight["md"] = 1.5] = "md";
    LineHeight[LineHeight["lg"] = 1.57] = "lg";
    LineHeight[LineHeight["xl"] = 1.6] = "xl";
    LineHeight[LineHeight["2xl"] = 1.66] = "2xl";
    LineHeight[LineHeight["3xl"] = 1.75] = "3xl";
    LineHeight[LineHeight["4xl"] = 2.66] = "4xl";
    return LineHeight;
}({});
var typography_LetterSpacing = /*#__PURE__*/ function(LetterSpacing) {
    LetterSpacing["tighter"] = "-0.0938rem";
    LetterSpacing["tight"] = "-0.0313rem";
    LetterSpacing["normal"] = "0rem";
    LetterSpacing["wide"] = "0.0011rem";
    LetterSpacing["wider"] = "0.025rem";
    LetterSpacing["widerMedium"] = "0.029rem";
    LetterSpacing["widerPlus"] = "0.0625rem";
    LetterSpacing["widest"] = "0.0094rem";
    return LetterSpacing;
}({});
const typography = {
    fontFamily: [
        DEFAULT_FONT_FAMILY,
        "Open Sans",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
    ].join(","),
    allVariants: {
        fontFamily: DEFAULT_FONT_FAMILY
    },
    h1: {
        fontSize: "6rem",
        fontWeight: 500,
        lineHeight: 1.17,
        letterSpacing: "-0.0938rem"
    },
    h2: {
        fontSize: "3.75rem",
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: "-0.0313rem"
    },
    h3: {
        fontSize: "3rem",
        fontWeight: 500,
        lineHeight: 1.17,
        letterSpacing: "0rem"
    },
    h4: {
        fontSize: "2.125rem",
        fontWeight: 700,
        lineHeight: 1.24,
        letterSpacing: "0rem"
    },
    h5: {
        fontSize: "1.5rem",
        fontWeight: 700,
        lineHeight: 1.33,
        letterSpacing: "0rem"
    },
    h6: {
        fontSize: "1.25rem",
        fontWeight: 700,
        lineHeight: 1.6,
        letterSpacing: "0rem"
    },
    subtitle1: {
        fontSize: "1rem",
        fontWeight: 700,
        lineHeight: 1.75,
        letterSpacing: "0.0094rem"
    },
    subtitle2: {
        fontSize: "0.875rem",
        fontWeight: 700,
        lineHeight: 1.57,
        letterSpacing: "0.0094rem"
    },
    body1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.0094rem"
    },
    body2: {
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.0011rem"
    },
    overline: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 2.66,
        letterSpacing: "0.0625rem"
    },
    caption: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 1.66,
        letterSpacing: "0.025rem"
    },
    button: {
        fontWeight: 500,
        textTransform: "none"
    }
};
const accordionStyleOverrides = {
    root: {
        fontSize: typography_FontSize.xs,
        fontWeight: typography_FontWeight.medium,
        letterSpacing: typography_LetterSpacing.widerMedium,
        boxShadow: "none",
        border: `1px solid ${palette_Action.focus}`,
        borderRadius: `${Spacing["750"]} !important`,
        ":hover": {
            borderColor: palette_Border.dark
        },
        ":before": {
            content: "none"
        }
    }
};
const accordionSummaryStyleOverrides = {
    root: {
        display: displaying_Displaying.flex,
        padding: Spacing["0"],
        ".MuiAccordionSummary-content": {
            display: displaying_Displaying.flex,
            flexDirection: direction_Direction.row,
            gap: `0 ${Spacing["500"]}`,
            margin: 0,
            alignItems: alignment_Alignment.center,
            wordBreak: "break-all"
        },
        ".MuiTypography-root": {
            lineHeight: Spacing["1500"],
            display: displaying_Displaying.flex
        },
        "#accordion-icon": {
            paddingLeft: 0
        }
    }
};
const accordionDetailsStyleOverrides = {
    root: {
        paddingBottom: Spacing["1500"]
    }
};
const TYPOGRAPHY_SUCCESS_COLOR = "#1E4620";
const TYPOGRAPHY_ERROR_COLOR = "#5F2120";
const TYPOGRAPHY_WARNING_COLOR = "#663C00";
const SUCCESS_SHADE_COLOR = "#EDF7ED";
const ERROR_SHADE_COLOR = "#FDEDED";
const WARNING_SHADE_COLOR = "#FFF4E5";
const INFO_SHADE_COLOR = "#F1F4FC";
const alertStylesOverride = {
    root: {
        width: "100%",
        padding: `${Spacing["500"]} ${Spacing["1000"]}`
    },
    filledWarning: {
        color: palette_Common.white.main
    },
    filledInfo: {
        color: palette_Common.white.main,
        backgroundColor: palette_Primary.main
    },
    standardSuccess: {
        backgroundColor: SUCCESS_SHADE_COLOR,
        color: TYPOGRAPHY_SUCCESS_COLOR
    },
    standardError: {
        backgroundColor: ERROR_SHADE_COLOR,
        color: TYPOGRAPHY_ERROR_COLOR
    },
    standardWarning: {
        backgroundColor: WARNING_SHADE_COLOR,
        color: TYPOGRAPHY_WARNING_COLOR
    },
    standardInfo: {
        backgroundColor: INFO_SHADE_COLOR,
        color: palette_Primary.dark,
        "& .MuiAlert-icon": {
            color: palette_Primary.dark
        }
    },
    outlinedSuccess: {
        borderColor: palette_Success.main,
        color: TYPOGRAPHY_SUCCESS_COLOR
    },
    outlinedError: {
        borderColor: ErrorToken.main,
        color: TYPOGRAPHY_ERROR_COLOR
    },
    outlinedWarning: {
        borderColor: palette_Warning.main,
        color: TYPOGRAPHY_WARNING_COLOR
    },
    outlinedInfo: {
        borderColor: palette_Primary.main,
        color: palette_Primary.dark,
        "& .MuiAlert-icon": {
            color: palette_Primary.dark
        }
    },
    icon: {
        alignItems: alignment_Alignment.center
    },
    message: {
        ...typography.body2
    }
};
const alertDefaultProps = {
    iconMapping: {
        success: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CheckCircleOutlined, {
            fontSize: "inherit"
        }),
        info: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BookTextSolid, {
            fontSize: "inherit"
        }),
        error: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ExclamationCircleOutlined, {
            fontSize: "inherit"
        }),
        warning: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TriangleExclamationOutlined, {
            fontSize: "inherit"
        })
    }
};
const alertTitleStylesOverride = {
    root: {
        marginBottom: Spacing["0"],
        fontWeight: typography_FontWeight.medium
    }
};
const badgeStylesOverride = {
    colorSecondary: {
        color: palette_Common.white.main
    }
};
var cursor_style_CursorStyle = /*#__PURE__*/ function(CursorStyle) {
    CursorStyle["pointer"] = "pointer";
    CursorStyle["notAllowed"] = "not-allowed";
    CursorStyle["default"] = "default";
    return CursorStyle;
}({});
const styles_tealDuskStyle = tealDusk.getButtonStylesOverride();
const styles_pinkHazeStyle = pinkHaze.getButtonStylesOverride();
const styles_goldenUmberStyle = goldenUmber.getButtonStylesOverride();
const buttonStyleOverrides = {
    root: function({ ownerState }) {
        return {
            ...buttonStyles[ownerState.size || "medium"],
            [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                pointerEvents: "initial",
                cursor: cursor_style_CursorStyle.notAllowed
            },
            ..."white" === ownerState.color && {
                color: White.main,
                backgroundColor: TRANSPARENT_COLOR,
                ..."contained" === ownerState.variant && {
                    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                        backgroundColor: TRANSPARENT_COLOR,
                        pointerEvents: "initial",
                        cursor: cursor_style_CursorStyle.notAllowed
                    }
                },
                ..."outlined" === ownerState.variant && {
                    borderColor: TRANSPARENT_COLOR,
                    [`&:hover,&:active,&:focus,&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                        borderColor: TRANSPARENT_COLOR
                    }
                }
            },
            ...styles_tealDuskStyle,
            ...styles_pinkHazeStyle,
            ...styles_goldenUmberStyle
        };
    },
    startIcon: {
        marginLeft: Spacing["0"]
    },
    endIcon: {
        marginRight: Spacing["0"]
    }
};
const buttonStyles = {
    large: {
        padding: `${Spacing["500"]} ${Spacing["1000"]}`,
        lineHeight: typography_LineHeight.xl,
        letterSpacing: typography_LetterSpacing.widerMedium,
        minWidth: Spacing["5000"],
        minHeight: Spacing["3000"]
    },
    medium: {
        padding: `${Spacing["500"]} ${Spacing["750"]}`,
        lineHeight: typography_LineHeight.md,
        letterSpacing: typography_LetterSpacing.wider,
        minWidth: Spacing["4000"],
        minHeight: Spacing["2500"]
    },
    small: {
        padding: `${Spacing["250"]} ${Spacing["500"]}`,
        lineHeight: typography_LineHeight.sm,
        letterSpacing: typography_LetterSpacing.widerMedium,
        minWidth: Spacing["3500"],
        minHeight: Spacing["2000"]
    }
};
const checkboxStylesOverride = {
    root: {
        padding: Spacing["500"],
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            pointerEvents: "initial",
            cursor: "not-allowed",
            "&:hover": {
                backgroundColor: "initial"
            }
        }
    }
};
const CHIP_SMALL_DELETE_ICON_SIZE = "0.833rem";
const chip_styles_tealDuskStyle = tealDusk.getButtonStylesOverride();
const chip_styles_pinkHazeStyle = pinkHaze.getButtonStylesOverride();
const chip_styles_goldenUmberStyle = goldenUmber.getButtonStylesOverride();
const chipStyleOverrides = {
    root: {
        padding: `${Spacing["750"]} ${Spacing["1000"]}`,
        gap: Spacing["250"],
        fontSize: typography_FontSize.xs,
        fontWeight: typography_FontWeight.bold,
        letterSpacing: typography_LetterSpacing.widerMedium,
        ...chip_styles_tealDuskStyle,
        ...chip_styles_pinkHazeStyle,
        ...chip_styles_goldenUmberStyle
    },
    icon: {
        marginLeft: Spacing["0"],
        marginRight: Spacing["0"]
    },
    deleteIcon: {
        height: Spacing["1500"],
        width: Spacing["1500"],
        marginLeft: Spacing["0"],
        marginRight: Spacing["0"],
        "&.MuiChip-deleteIconSmall": {
            width: CHIP_SMALL_DELETE_ICON_SIZE,
            height: CHIP_SMALL_DELETE_ICON_SIZE
        }
    },
    label: {
        paddingLeft: Spacing["0"],
        paddingRight: Spacing["0"]
    }
};
const dialogActionsStylesOverrides = {
    root: {
        padding: Spacing["0"]
    }
};
const dialogContentStylesOverrides = {
    root: {
        padding: Spacing["0"],
        textAlign: "initial"
    }
};
const dialogTitleStylesOverrides = {
    root: {
        padding: Spacing["0"]
    }
};
const EXTRA_SMALL_DIALOG_MAX_WIDTH = 328;
const SMALL_DIALOG_MAX_WIDTH = 512;
const dialogStyleOverrides = {
    root: {
        ".MuiPaper-root": {
            padding: Spacing["1500"],
            border: `1px solid ${DIVIDER_COLOR}`
        },
        ".align-end": {
            width: "100%"
        },
        ".align-center": {
            width: "100%",
            margin: "0 auto"
        },
        ".inner-icon > .MuiSvgIcon-root": {
            width: Spacing["3000"],
            height: Spacing["3000"]
        }
    },
    paperWidthXs: {
        maxWidth: EXTRA_SMALL_DIALOG_MAX_WIDTH
    },
    paperWidthSm: {
        maxWidth: SMALL_DIALOG_MAX_WIDTH
    }
};
const iconButtonStyleOverrides = {
    root: {
        padding: Spacing["500"],
        "& .MuiSvgIcon-root": {
            fontSize: "inherit"
        },
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            pointerEvents: "initial",
            cursor: cursor_style_CursorStyle.notAllowed
        }
    },
    sizeSmall: {
        fontSize: Spacing["1000"]
    },
    sizeMedium: {
        fontSize: Spacing["1500"]
    },
    sizeLarge: {
        fontSize: Spacing["2000"]
    }
};
const inputStyleOverrides = {
    root: {
        ".MuiOutlinedInput-notchedOutline": {
            borderColor: palette.border.main
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.border.dark
        },
        [`&.${mui_class_collection_MuiClassCollection.disabled} .MuiOutlinedInput-notchedOutline, &.${mui_class_collection_MuiClassCollection.disabled}:hover .MuiOutlinedInput-notchedOutline`]: {
            borderColor: palette.border.light
        }
    }
};
const DASH_DOT_WIDTH = 0.625;
const DASH_DOT_HEIGHT = 0.66875;
const linearProgressStylesOverride = {
    root: {
        height: Spacing["500"]
    },
    dashed: {
        backgroundSize: `${DASH_DOT_WIDTH}rem ${DASH_DOT_HEIGHT}rem`
    },
    colorSecondary: {
        background: palette_Secondary.light
    }
};
const menuItemStylesOverrides = {
    root: {
        whiteSpace: "initial"
    }
};
const paperStyleOverrides = {
    root: {}
};
const radioStylesOverride = {
    root: {
        padding: Spacing["500"],
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            pointerEvents: "initial",
            cursor: "not-allowed",
            "&:hover": {
                backgroundColor: "initial"
            }
        }
    }
};
const LIST_ITEM_LIGHT_DARK_BACKGROUND_COLOR = "rgba(0, 0, 0, 0.04)";
const listItemButtonOverrides = {
    root: {
        borderRadius: BorderRadius.brand,
        [`&.${mui_class_collection_MuiClassCollection.selected}, &.${mui_class_collection_MuiClassCollection.selected}:hover`]: {
            backgroundColor: LIST_ITEM_LIGHT_DARK_BACKGROUND_COLOR,
            color: palette_Primary.main
        }
    }
};
const switchStylesOverride = {
    root: {
        "& .MuiSwitch-switchBase": {
            [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                pointerEvents: "initial",
                cursor: "not-allowed",
                "&:hover": {
                    backgroundColor: "initial"
                }
            }
        }
    }
};
const textFieldStyleOverrides = {
    root: {
        fontFamily: DEFAULT_FONT_FAMILY,
        color: palette.text?.secondary,
        "& .MuiOutlinedInput-root": {
            borderRadius: Spacing["500"],
            backgroundColor: palette_Common.white.main,
            "&:has([readonly])": {
                backgroundColor: palette.action?.selected,
                cursor: cursor_style_CursorStyle.notAllowed
            },
            "&.blocked": {
                backgroundColor: palette_Primary.light,
                color: palette_Primary.main,
                "& fieldset": {
                    borderColor: palette_Primary.main
                }
            },
            "&:has(.adornment-start)": {
                paddingLeft: 0
            },
            "&:has(.adornment-end)": {
                paddingRight: 0
            },
            "&.MuiInputBase-multiline": {
                backgroundColor: palette_Common.white.main
            }
        },
        [`& .${mui_class_collection_MuiClassCollection.disabled}, & .${mui_class_collection_MuiClassCollection.readOnly}`]: {
            cursor: cursor_style_CursorStyle.notAllowed
        },
        "&.MuiTextField-sizeMedium": {
            "& .MuiInputBase-input": {
                padding: `${Spacing["1000"]} ${Spacing["750"]}`
            }
        },
        "&.MuiTextField-sizeSmall": {
            "& .MuiInputBase-input": {
                padding: `${Spacing["500"]} ${Spacing["750"]}`
            }
        },
        "& .adornment": {
            backgroundColor: palette.background?.default,
            "&.MuiInputAdornment-positionEnd": {
                borderTopRightRadius: Spacing["500"],
                borderBottomRightRadius: Spacing["500"]
            },
            "&.MuiInputAdornment-positionStart": {
                borderTopLeftRadius: Spacing["500"],
                borderBottomLeftRadius: Spacing["500"]
            },
            "&.small": {
                paddingBottom: Spacing["1250"],
                paddingTop: Spacing["1250"],
                paddingRight: Spacing["750"],
                paddingLeft: Spacing["750"]
            },
            "&.medium": {
                paddingBottom: Spacing["1750"],
                paddingTop: Spacing["1750"],
                paddingRight: Spacing["1000"],
                paddingLeft: Spacing["1000"]
            }
        }
    }
};
const commonStyle = {
    padding: `${Spacing["250"]} ${Spacing["1000"]}`,
    background: palette_Common.dark.main
};
const toolTipStyleOverrides = {
    tooltipArrow: {
        ...commonStyle
    },
    tooltip: {
        ...commonStyle
    },
    arrow: {
        color: palette_Common.dark.main
    }
};
const theme_theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.createTheme)({
    palette: palette,
    typography: typography,
    spacing: 4,
    shape: {
        borderRadius: 8
    },
    components: {
        MuiButton: {
            styleOverrides: buttonStyleOverrides
        },
        MuiOutlinedInput: {
            styleOverrides: inputStyleOverrides
        },
        MuiListItemButton: {
            styleOverrides: listItemButtonOverrides
        },
        MuiChip: {
            styleOverrides: chipStyleOverrides
        },
        MuiPaper: {
            styleOverrides: paperStyleOverrides
        },
        MuiAlert: {
            styleOverrides: alertStylesOverride,
            defaultProps: alertDefaultProps
        },
        MuiAlertTitle: {
            styleOverrides: alertTitleStylesOverride
        },
        MuiAccordion: {
            styleOverrides: accordionStyleOverrides
        },
        MuiAccordionSummary: {
            styleOverrides: accordionSummaryStyleOverrides
        },
        MuiAccordionDetails: {
            styleOverrides: accordionDetailsStyleOverrides
        },
        MuiIconButton: {
            styleOverrides: iconButtonStyleOverrides
        },
        MuiCheckbox: {
            styleOverrides: checkboxStylesOverride
        },
        MuiSwitch: {
            styleOverrides: switchStylesOverride
        },
        MuiRadio: {
            styleOverrides: radioStylesOverride
        },
        MuiDialog: {
            styleOverrides: dialogStyleOverrides
        },
        MuiDialogTitle: {
            styleOverrides: dialogTitleStylesOverrides
        },
        MuiDialogContent: {
            styleOverrides: dialogContentStylesOverrides
        },
        MuiDialogActions: {
            styleOverrides: dialogActionsStylesOverrides
        },
        MuiTextField: {
            styleOverrides: textFieldStyleOverrides
        },
        MuiTooltip: {
            styleOverrides: toolTipStyleOverrides
        },
        MuiLinearProgress: {
            styleOverrides: linearProgressStylesOverride
        },
        MuiMenuItem: {
            styleOverrides: menuItemStylesOverrides
        },
        MuiBadge: {
            styleOverrides: badgeStylesOverride
        }
    }
});
const INVALD_PROPS = [
    "color",
    "active",
    "isActive",
    "shouldBeExpandable",
    "isMobile",
    "collapsed",
    "isSelected",
    "elevated",
    "disablepadding",
    "variant",
    "turnBorderColor",
    "turn",
    "maxWidth",
    "gap",
    "accentColor",
    "isSmall"
];
function isStyledValidProp(prop) {
    const includeProp = INVALD_PROPS.includes(prop);
    return !includeProp;
}
const styledOptions = {
    shouldForwardProp: isStyledValidProp
};
const MuiAccordionSummaryContentContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.spaceBetween,
    width: "100%",
    alignItems: alignment_Alignment.center
});
const ContainerWithMarginRight = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginRight: Spacing["500"],
    display: displaying_Displaying.inherit,
    alignItems: alignment_Alignment.center
});
const ContainerWithTopSpacing = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginTop: Spacing["250"],
    display: displaying_Displaying.inherit,
    alignItems: alignment_Alignment.center
});
const EndItemsContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ shouldBeExpandable })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        pointerEvents: "auto",
        marginRight: shouldBeExpandable ? Spacing["500"] : Spacing["0"]
    }));
const MuiAccordionContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Accordion_4220dc4d__["default"], styledOptions)(({ isMobile })=>({
        padding: isMobile ? `${Spacing["750"]} ${Spacing["1000"]}` : `${Spacing["500"]} ${Spacing["1500"]}`
    }));
const MuiAccordionSummaryContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_AccordionSummary_85088446__["default"], styledOptions)(({ isMobile, shouldBeExpandable })=>({
        pointerEvents: shouldBeExpandable ? displaying_Displaying.initial : displaying_Displaying.none,
        ".MuiAccordionSummary-content": {
            [`&.${mui_class_collection_MuiClassCollection.expanded}`]: {
                margin: isMobile ? `${Spacing["500"]} 0` : displaying_Displaying.inherit
            }
        }
    }));
const AccordionContainerStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(MuiAccordionContainer)({
    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
        backgroundColor: "transparent",
        cursor: "not-allowed !important",
        "> *": {
            cursor: "not-allowed !important"
        }
    }
});
function Accordion({ children, isMobile, accordionDetailsProps, title, subtitle, ...rest }) {
    const { id, startIcon, defaultExpanded, endChip, endAction, iconButtonId } = rest;
    const flexDirection = isMobile ? direction_Direction.column : direction_Direction.row;
    const shouldBeExpandable = void 0 === endAction;
    const secondaryTypographyVariant = isMobile ? theme_theme.typography.body2 : theme_theme.typography.body1;
    const subtitleElement = "string" == typeof subtitle ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        sx: {
            ...secondaryTypographyVariant,
            marginLeft: isMobile ? Spacing["0"] : Spacing["500"]
        },
        children: subtitle
    }) : subtitle;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AccordionContainerStyled, {
        "data-testid": rest.id,
        isMobile: isMobile,
        square: false,
        defaultExpanded: defaultExpanded,
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(MuiAccordionSummaryContainer, {
                expandIcon: shouldBeExpandable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                    id: iconButtonId || "accordion-icon-id",
                    color: "default",
                    size: "medium",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleDownSmallOutlined, {})
                }),
                "aria-controls": "accordion-content",
                id: id,
                isMobile: isMobile,
                shouldBeExpandable: shouldBeExpandable,
                children: [
                    startIcon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContainerWithMarginRight, {
                        children: startIcon
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(MuiAccordionSummaryContentContainer, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                style: {
                                    display: "inherit",
                                    flexDirection
                                },
                                children: [
                                    title,
                                    subtitle ? subtitleElement : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
                                    isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContainerWithTopSpacing, {
                                        children: endChip
                                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(EndItemsContainer, {
                                shouldBeExpandable: shouldBeExpandable,
                                children: [
                                    isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContainerWithMarginRight, {
                                        children: endChip
                                    }),
                                    endAction
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_AccordionDetails_d2db12ca__["default"], {
                ...accordionDetailsProps,
                children: children
            })
        ]
    });
}
const StyledVerticalAlert = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Alert_759df34a__["default"])({
    "& .MuiAlert-message": {
        width: "100%"
    }
});
const StyledActionContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    width: "100%",
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.end,
    marginTop: Spacing["750"]
});
const StyledChildrenContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.start,
    alignItems: alignment_Alignment.center,
    gap: Spacing["750"]
});
const DEFAULT_ICON_SIZE = 22;
const vertical_alert_VerticalAlert = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, action, icon, severity, ...rest }, ref) {
    const displayedIcon = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (icon) return icon;
        if (!severity) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
        const severityAsIconIndex = severity;
        const severityIcon = alertDefaultProps.iconMapping ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
            className: "MuiAlert-icon",
            fontSize: DEFAULT_ICON_SIZE,
            display: displaying_Displaying.flex,
            children: alertDefaultProps.iconMapping[severityAsIconIndex]
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
        return severityIcon;
    }, [
        severity,
        icon
    ]);
    const displayedContent = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (!children) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledChildrenContainer, {
            children: displayedIcon
        });
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(StyledChildrenContainer, {
            children: [
                displayedIcon,
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                    children: children
                })
            ]
        });
    }, [
        children,
        displayedIcon
    ]);
    const displayedAction = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (action) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledActionContainer, {
            children: action
        });
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    }, [
        action
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(StyledVerticalAlert, {
        ...rest,
        ref: ref,
        icon: false,
        severity: severity,
        children: [
            displayedContent,
            displayedAction
        ]
    });
});
const alert_Alert = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, vertical = false, ...rest }, ref) {
    if (vertical) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(vertical_alert_VerticalAlert, {
        ...rest,
        ref: ref,
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Alert_759df34a__["default"], {
        ...rest,
        ref: ref,
        children: children
    });
});
const STORYBOOK_LARGE_MOBILE_WIDTH = 414;
function useIsMobile() {
    const isMobileMediaQuery = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useMediaQuery)(`@media only screen and (max-width:${STORYBOOK_LARGE_MOBILE_WIDTH}px)`);
    const codeRunningInStorybook = window?.IS_STORYBOOK ?? false;
    if (codeRunningInStorybook) return isMobileMediaQuery;
    return __WEBPACK_EXTERNAL_MODULE_react_device_detect_2985bda2__.isMobile;
}
const use_is_mobile = useIsMobile;
const APP_BAR_HEIGHT_DESKTOP = Spacing["4750"];
const APP_BAR_HEIGHT_MOBILE = Spacing["4000"];
const app_bar_AppBar = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, ...rest }, ref) {
    const isMobile = use_is_mobile();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_AppBar_72083ef1__["default"], {
        ref: ref,
        color: "transparent",
        sx: {
            backgroundColor: theme_theme.palette.background.paper,
            zIndex: 10
        },
        elevation: 0,
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(app_bar_Toolbar, {
            isMobile: isMobile,
            children: children
        })
    });
});
const app_bar_Toolbar = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Toolbar_089287ec__["default"], styledOptions)(({ isMobile, theme })=>({
        display: displaying_Displaying.flex,
        justifyContent: alignment_Alignment.spaceBetween,
        borderBottom: `1px solid ${palette_Border.main}`,
        gap: isMobile ? Spacing["0"] : Spacing["1500"],
        padding: isMobile ? Spacing["750"] : `${Spacing["1000"]} ${Spacing["3000"]}`,
        minHeight: `${isMobile ? APP_BAR_HEIGHT_MOBILE : APP_BAR_HEIGHT_DESKTOP}!important`,
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(12),
            paddingRight: theme.spacing(12)
        }
    }));
const ChipStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Chip_305fde45__["default"])(({ color, variant })=>{
    const isVariantOutlined = "outlined" === variant;
    const needsTextColorAdjustment = [
        "secondary",
        "info"
    ].includes(color ?? "");
    if (isVariantOutlined && needsTextColorAdjustment) return {
        color: theme_theme.palette.text.primary
    };
});
const chip_Chip = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ChipStyled, {
        ref: ref,
        ...rest,
        children: children
    });
});
function Autocomplete({ multiple, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__["default"], {
        multiple: multiple,
        popupIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleDownSmallOutlined, {}),
        disableCloseOnSelect: multiple,
        renderTags: function(tags, getTagProps) {
            return tags.map(function(option, index) {
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_Chip, {
                    variant: "filled",
                    size: "small",
                    label: option,
                    color: "default",
                    ...getTagProps({
                        index
                    })
                });
            });
        },
        ...rest
    });
}
function AutocompleteTextField({ ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"], {
        ...rest
    });
}
const PROGRESS_BAR_COMPLETED_COLOR = "#00BB8C";
const PROGRESS_BAR_NOT_COMPLETED_FILL_COLOR = "#FFECF2";
const PROGRESS_BAR_NOT_COMPLETED_STROKE_COLOR = "#DD4C77";
function getProgressBarFillColor(isCompleted) {
    return isCompleted ? PROGRESS_BAR_COMPLETED_COLOR : PROGRESS_BAR_NOT_COMPLETED_FILL_COLOR;
}
function getProgressBarStrokeColor(isCompleted) {
    return isCompleted ? PROGRESS_BAR_COMPLETED_COLOR : PROGRESS_BAR_NOT_COMPLETED_STROKE_COLOR;
}
function AvatarProgressBar({ numberBarCompleted }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
        width: "84",
        height: "64",
        viewBox: "0 0 84 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M7.5314 28.5035C6.515 28.1224 5.99525 26.9905 6.4226 25.9972C9.15995 19.5985 13.549 14.0545 19.1392 9.90802C20.0054 9.26122 21.2297 9.51532 21.8303 10.4162C22.4309 11.3171 22.1884 12.5299 21.3106 13.1882C16.4018 16.8611 12.5441 21.7468 10.0955 27.3716C9.66815 28.3649 8.53625 28.8847 7.51985 28.5151L7.5314 28.5035Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 2)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.38621 27.3583C6.39077 27.3707 6.39547 27.3831 6.40029 27.3955C6.58814 27.8761 6.97354 28.2819 7.49382 28.489C7.50416 28.4931 7.51456 28.4971 7.52501 28.5011C7.52716 28.5019 7.52932 28.5027 7.53148 28.5035L7.51993 28.5151C7.52204 28.5158 7.52416 28.5166 7.52628 28.5174C7.53605 28.5209 7.54584 28.5243 7.55563 28.5277C8.23927 28.7617 8.97059 28.5977 9.50194 28.161C9.75332 27.9545 9.95993 27.6869 10.0956 27.3716C12.5442 21.7468 16.4019 16.8611 21.3106 13.1882C22.1884 12.5299 22.431 11.3171 21.8304 10.4162C21.2298 9.51533 20.0055 9.26123 19.1392 9.90803C13.549 14.0545 9.16003 19.5985 6.42268 25.9972C6.22778 26.4502 6.22987 26.932 6.38621 27.3583ZM4.58468 25.2087C3.73085 27.196 4.69 29.3618 6.49906 30.235C6.60527 30.298 6.71807 30.3516 6.83644 30.3947C8.89453 31.1431 11.1031 30.0838 11.9307 28.1668C14.2415 22.86 17.8803 18.2528 22.5088 14.7896L22.5106 14.7882C24.1801 13.5361 24.7229 11.1495 23.4945 9.30683C22.3059 7.5239 19.7985 6.92434 17.9477 8.30168C12.0749 12.6578 7.46212 18.4834 4.58468 25.2087Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 2),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M79.4381 38.3499C80.5119 38.2591 81.4734 39.0526 81.5178 40.1421C81.7716 47.0981 80.1704 53.9802 76.89 60.1156C76.3703 61.07 75.169 61.3683 74.2299 60.8175C73.2959 60.2563 73.008 59.0601 73.5069 58.0956C76.3692 52.6813 77.7801 46.6064 77.5895 40.4919C77.5555 39.4075 78.3438 38.4562 79.433 38.3602L79.4381 38.3499Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 5)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M78.9946 36.3996C79.0845 36.3792 79.1763 36.3649 79.2696 36.357C81.4072 36.1764 83.4225 37.7635 83.516 40.0608L83.5164 40.0692L83.5164 40.0692C83.7831 47.3805 82.1 54.6129 78.6536 61.0587L78.6464 61.0722C77.5549 63.0765 75.0733 63.6309 73.218 62.5427L73.1998 62.5319C71.288 61.3832 70.7869 59.0005 71.7304 57.1767L71.7387 57.1609C74.4393 52.0524 75.7701 46.3211 75.5904 40.5546M78.9946 36.3996C76.9235 36.7171 75.5282 38.5638 75.5904 40.5543ZM81.5177 40.1422C81.4733 39.0526 80.5118 38.2592 79.438 38.3499L79.4329 38.3603C78.3437 38.4563 77.5554 39.4075 77.5894 40.492C77.78 46.6065 76.3691 52.6813 73.5068 58.0956C73.0079 59.0601 73.2958 60.2564 74.2298 60.8175C75.1689 61.3683 76.3702 61.07 76.8899 60.1157C80.1703 53.9802 81.7715 47.0981 81.5177 40.1422Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 5),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M10.1302 60.8897C9.20618 61.4441 7.99343 61.1554 7.47368 60.1967C4.18193 54.0637 2.58803 47.1799 2.83058 40.2268C2.87678 39.1411 3.82388 38.3441 4.90958 38.425C5.99528 38.5174 6.78068 39.4645 6.75758 40.5502C6.57278 46.6717 7.98188 52.747 10.8463 58.1524C11.3545 59.111 11.0657 60.3122 10.1302 60.8782V60.8897Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 1)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.3873 62.4453C11.3156 62.5032 11.2395 62.5565 11.1592 62.6047C9.3197 63.7084 6.81132 63.1712 5.71547 61.1499L5.71145 61.1425L5.71146 61.1425C2.2516 54.6962 0.576982 47.4618 0.8318 40.157L0.832393 40.1417C0.929424 37.8615 2.9131 36.2707 5.05811 36.4305L5.07918 36.4322C7.30148 36.6213 8.80081 38.5397 8.75713 40.5927L8.75667 40.6105C8.58231 46.3862 9.912 52.1178 12.6133 57.2156M11.3873 62.4453C13.1069 61.248 13.5461 58.9755 12.6135 57.2159ZM7.47368 60.1967C7.99343 61.1553 9.20618 61.4441 10.1302 60.8897V60.8781C11.0657 60.3122 11.3545 59.111 10.8463 58.1523C7.98188 52.7469 6.57278 46.6716 6.75758 40.5501C6.78068 39.4644 5.99528 38.5173 4.90958 38.4249C3.82388 38.3441 2.87678 39.141 2.83058 40.2267C2.58803 47.1798 4.18193 54.0636 7.47368 60.1967Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 1),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M30.6249 6.46209C30.2899 5.43414 30.8443 4.31379 31.8954 4.02504C38.6059 2.17704 45.6745 2.15394 52.3966 3.94419C53.4477 4.22139 54.0136 5.33019 53.6787 6.36969C53.3437 7.39764 52.2465 7.96359 51.1954 7.69794C45.2703 6.15024 39.0333 6.18489 33.1197 7.76724C32.0686 8.04444 30.9598 7.49004 30.6249 6.46209Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 3)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.1197 7.76724C32.0687 8.04444 30.9599 7.49004 30.6249 6.46209C30.29 5.43414 30.8444 4.31379 31.8954 4.02504C38.606 2.17704 45.6746 2.15394 52.3967 3.94419C53.4477 4.22139 54.0137 5.33019 53.6787 6.36969C53.3438 7.39764 52.2465 7.96359 51.1955 7.69794C45.2703 6.15024 39.0333 6.18489 33.1197 7.76724ZM52.9114 2.01156C45.8481 0.13044 38.419 0.154303 31.3656 2.0965ZM52.9114 2.01156C55.1382 2.60169 56.246 4.92351 55.5823 6.98308L55.5803 6.98932C54.8997 9.07798 52.7141 10.1447 50.7054 9.63697L50.69 9.63302C45.1036 8.17381 39.219 8.20558 33.6367 9.69927L33.6298 9.70113C31.6346 10.2273 29.4121 9.19552 28.7233 7.08171C28.0589 5.04255 29.1403 2.70857 31.3644 2.09682",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 3),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M63.1919 10.4271C63.781 9.52623 65.0053 9.26058 65.8831 9.90738C71.5079 13.9961 75.9431 19.517 78.7382 25.8926C79.1771 26.8859 78.6574 28.0178 77.641 28.4105C76.6246 28.7916 75.4927 28.2834 75.0538 27.2901C72.559 21.6768 68.6551 16.8258 63.7232 13.1876C62.857 12.5523 62.5913 11.3396 63.1919 10.4271Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 4)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.6409 28.4105C76.6245 28.7916 75.4926 28.2834 75.0537 27.2901C72.5589 21.6768 68.655 16.8258 63.7231 13.1876C62.8569 12.5523 62.5912 11.3396 63.1918 10.4271C63.7809 9.52621 65.0052 9.26056 65.883 9.90736C71.5078 13.9961 75.943 19.517 78.7381 25.8926C79.177 26.8859 78.6573 28.0178 77.6409 28.4105ZM67.0634 8.29282C72.9743 12.5907 77.6336 18.3921 80.5698 25.0895C81.503 27.2096 80.3538 29.5064 78.3617 30.2761L78.3431 30.2831C76.2846 31.055 74.0713 30.0123 73.2253 28.1006C70.8719 22.8063 67.1899 18.2309 62.5377 14.7984C60.8752 13.5771 60.2961 11.1917 61.5196 9.33004C62.6945 7.53608 65.2017 6.92636 67.0634 8.29282Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 4),
                fillOpacity: "0.5"
            })
        ]
    });
}
var prop_types = __webpack_require__("./node_modules/prop-types/index.js");
var prop_types_default = /*#__PURE__*/ __webpack_require__.n(prop_types);
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (1 & t[0]) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, "function" == typeof Symbol && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = 2 & op[0] ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                2 & op[0],
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (t = _.trys, !(t = t.length > 0 && t[t.length - 1]) && (6 === op[0] || 2 === op[0])) {
                        _ = 0;
                        continue;
                    }
                    if (3 === op[0] && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (6 === op[0] && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (5 & op[0]) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __read(o, n) {
    var m = "function" == typeof Symbol && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((void 0 === n || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || 2 === arguments.length) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var COMMON_MIME_TYPES = new Map([
    [
        'aac',
        'audio/aac'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'ico',
        'image/vnd.microsoft.icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'js',
        "text/javascript"
    ],
    [
        'json',
        'application/json'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mjs',
        "text/javascript"
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'opus',
        'audio/opus'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'ppt',
        'application/vnd.ms-powerpoint'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'rar',
        'application/vnd.rar'
    ],
    [
        'rtf',
        'application/rtf'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'wav',
        'audio/wav'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ]
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if ('string' != typeof f.path) {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: 'string' == typeof path ? path : 'string' == typeof webkitRelativePath && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && -1 !== name.lastIndexOf('.');
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
var FILES_TO_IGNORE = [
    '.DS_Store',
    'Thumbs.db'
];
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) return [
                2,
                getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            if (isChangeEvt(evt)) return [
                2,
                getInputFiles(evt)
            ];
            if (Array.isArray(evt) && evt.every(function(item) {
                return 'getFile' in item && 'function' == typeof item.getFile;
            })) return [
                2,
                getFsHandleFiles(evt)
            ];
            return [
                2,
                []
            ];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return 'object' == typeof v && null !== v;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function(file) {
        return toFileWithPath(file);
    });
}
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function() {
        var files;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2,
                        files.map(function(file) {
                            return toFileWithPath(file);
                        })
                    ];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function() {
        var items, files;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3,
                        2
                    ];
                    items = fromList(dt.items).filter(function(item) {
                        return 'file' === item.kind;
                    });
                    if ('drop' !== type) return [
                        2,
                        items
                    ];
                    return [
                        4,
                        Promise.all(items.map(toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2,
                        noIgnoredFiles(flatten(files))
                    ];
                case 2:
                    return [
                        2,
                        noIgnoredFiles(fromList(dt.files).map(function(file) {
                            return toFileWithPath(file);
                        }))
                    ];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function(file) {
        return -1 === FILES_TO_IGNORE.indexOf(file.name);
    });
}
function fromList(items) {
    if (null === items) return [];
    var files = [];
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
function toFilePromises(item) {
    if ('function' != typeof item.webkitGetAsEntry) return fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    if (entry && entry.isDirectory) return fromDirEntry(entry);
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function(acc, files) {
        return __spreadArray(__spreadArray([], __read(acc), false), __read(Array.isArray(files) ? flatten(files) : [
            files
        ]), false);
    }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a) {
            return [
                2,
                entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)
            ];
        });
    });
}
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            reader.readEntries(function(batch) {
                return __awaiter(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map(fromEntry));
                                entries.push(items);
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}
var es = __webpack_require__("./node_modules/attr-accept/dist/es/index.js");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if ("undefined" != typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null == _i) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && null != _i["return"]) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var utils_getInvalidTypeRejectionErr = function(accept) {
    accept = Array.isArray(accept) && 1 === accept.length ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: FILE_INVALID_TYPE,
        message: "File type must be ".concat(messageSuffix)
    };
};
var utils_getTooLargeRejectionErr = function(maxSize) {
    return {
        code: FILE_TOO_LARGE,
        message: "File is larger than ".concat(maxSize, " ").concat(1 === maxSize ? "byte" : "bytes")
    };
};
var utils_getTooSmallRejectionErr = function(minSize) {
    return {
        code: FILE_TOO_SMALL,
        message: "File is smaller than ".concat(minSize, " ").concat(1 === minSize ? "byte" : "bytes")
    };
};
var TOO_MANY_FILES_REJECTION = {
    code: TOO_MANY_FILES,
    message: "Too many files"
};
function fileAccepted(file, accept) {
    var isAcceptable = "application/x-moz-file" === file.type || (0, es["default"])(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : utils_getInvalidTypeRejectionErr(accept)
    ];
}
function fileMatchSize(file, minSize, maxSize) {
    if (utils_isDefined(file.size)) {
        if (utils_isDefined(minSize) && utils_isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                utils_getTooLargeRejectionErr(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                utils_getTooSmallRejectionErr(minSize)
            ];
        } else if (utils_isDefined(minSize) && file.size < minSize) return [
            false,
            utils_getTooSmallRejectionErr(minSize)
        ];
        else if (utils_isDefined(maxSize) && file.size > maxSize) return [
            false,
            utils_getTooLargeRejectionErr(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function utils_isDefined(value) {
    return null != value;
}
function allFilesAccepted(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
}
function isPropagationStopped(event) {
    if ("function" == typeof event.isPropagationStopped) return event.isPropagationStopped();
    if (void 0 !== event.cancelBubble) return event.cancelBubble;
    return false;
}
function isEvtWithFiles(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return "Files" === type || "application/x-moz-file" === type;
    });
}
function onDocumentDragOver(event) {
    event.preventDefault();
}
function isIe(userAgent) {
    return -1 !== userAgent.indexOf("MSIE") || -1 !== userAgent.indexOf("Trident/");
}
function isEdge(userAgent) {
    return -1 !== userAgent.indexOf("Edge/");
}
function isIeOrEdge() {
    var userAgent = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!isPropagationStopped(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return isPropagationStopped(event);
        });
    };
}
function canUseFileSystemAccessAPI() {
    return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
    if (utils_isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!isMIMEType(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every(isExt)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = _slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function acceptPropAsAcceptAttr(accept) {
    if (utils_isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat(_toConsumableArray(a), [
            mimeType
        ], _toConsumableArray(ext));
    }, []).filter(function(v) {
        return isMIMEType(v) || isExt(v);
    }).join(",");
}
function isAbort(v) {
    return v instanceof DOMException && ("AbortError" === v.name || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
    return v instanceof DOMException && ("SecurityError" === v.name || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
    return "audio/*" === v || "video/*" === v || "image/*" === v || "text/*" === v || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
    return /^.*\.[\w]+$/.test(v);
}
var _excluded = [
    "children"
], _excluded2 = [
    "open"
], _excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], _excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function es_toConsumableArray(arr) {
    return es_arrayWithoutHoles(arr) || es_iterableToArray(arr) || es_unsupportedIterableToArray(arr) || es_nonIterableSpread();
}
function es_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function es_iterableToArray(iter) {
    if ("undefined" != typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) return Array.from(iter);
}
function es_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return es_arrayLikeToArray(arr);
}
function es_slicedToArray(arr, i) {
    return es_arrayWithHoles(arr) || es_iterableToArrayLimit(arr, i) || es_unsupportedIterableToArray(arr, i) || es_nonIterableRest();
}
function es_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function es_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" == typeof o) return es_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return es_arrayLikeToArray(o, minLen);
}
function es_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function es_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null == _i) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && null != _i["return"]) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function es_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function es_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function es_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? es_ownKeys(Object(source), !0).forEach(function(key) {
            es_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function es_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutProperties(source, excluded) {
    if (null == source) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (null == source) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) target[key] = source[key];
    }
    return target;
}
var Dropzone = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = _objectWithoutProperties(_ref, _excluded);
    var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties(_useDropzone, _excluded2);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, null, children(es_objectSpread(es_objectSpread({}, props), {}, {
        open: open
    })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
    disabled: false,
    getFilesFromEvent: fromEvent,
    maxSize: 1 / 0,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
    children: prop_types_default().func,
    accept: prop_types_default().objectOf(prop_types_default().arrayOf(prop_types_default().string)),
    multiple: prop_types_default().bool,
    preventDropOnDocument: prop_types_default().bool,
    noClick: prop_types_default().bool,
    noKeyboard: prop_types_default().bool,
    noDrag: prop_types_default().bool,
    noDragEventsBubbling: prop_types_default().bool,
    minSize: prop_types_default().number,
    maxSize: prop_types_default().number,
    maxFiles: prop_types_default().number,
    disabled: prop_types_default().bool,
    getFilesFromEvent: prop_types_default().func,
    onFileDialogCancel: prop_types_default().func,
    onFileDialogOpen: prop_types_default().func,
    useFsAccessApi: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    onDragEnter: prop_types_default().func,
    onDragLeave: prop_types_default().func,
    onDragOver: prop_types_default().func,
    onDrop: prop_types_default().func,
    onDropAccepted: prop_types_default().func,
    onDropRejected: prop_types_default().func,
    onError: prop_types_default().func,
    validator: prop_types_default().func
};
var es_initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function useDropzone() {
    var props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    var _defaultProps$props = es_objectSpread(es_objectSpread({}, defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return acceptPropAsAcceptAttr(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return pickerOptionsFromAccept(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "function" == typeof onFileDialogOpen ? onFileDialogOpen : noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "function" == typeof onFileDialogCancel ? onFileDialogCancel : noop;
    }, [
        onFileDialogCancel
    ]);
    var rootRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    var inputRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    var _useReducer = (0, __WEBPACK_EXTERNAL_MODULE_react__.useReducer)(reducer, es_initialState), _useReducer2 = es_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)("undefined" != typeof window && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
    var onWindowFocus = function() {
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)([]);
    var onDocumentDrop = function(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", onDocumentDragOver, false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", onDocumentDragOver);
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(e) {
        if (onError) onError(e);
        else console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat(es_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if (isEvtWithFiles(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if (isPropagationStopped(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && allFilesAccepted({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = isEvtWithFiles(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        });
        var targetIdx = targets.indexOf(event.target);
        if (-1 !== targetIdx) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if (isEvtWithFiles(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = fileAccepted(file, acceptAttr), _fileAccepted2 = es_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = es_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        TOO_MANY_FILES_REJECTION
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if (isEvtWithFiles(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if (isPropagationStopped(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]);
    var openFileDialog = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                if (isAbort(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if (isSecurityError(e)) {
                    fsAccessApiWorksRef.current = false;
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]);
    var onKeyDownCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (" " === event.key || "Enter" === event.key || 32 === event.keyCode || 13 === event.keyCode) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]);
    var onFocusCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []);
    var onClickCb = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        if (noClick) return;
        if (isIeOrEdge()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = void 0 === _ref2$refKey ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = _objectWithoutProperties(_ref2, _excluded3);
            return es_objectSpread(es_objectSpread(es_defineProperty({
                onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
                onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
                onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
                role: "string" == typeof role && "" !== role ? role : "presentation"
            }, refKey, rootRef), disabled || noKeyboard ? {} : {
                tabIndex: 0
            }), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = void 0 === _ref3$refKey ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties(_ref3, _excluded4);
            var inputProps = es_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
                onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return es_objectSpread(es_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function reducer(state, action) {
    switch(action.type){
        case "focus":
            return es_objectSpread(es_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return es_objectSpread(es_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return es_objectSpread(es_objectSpread({}, es_initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return es_objectSpread(es_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return es_objectSpread(es_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return es_objectSpread(es_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return es_objectSpread({}, es_initialState);
        default:
            return state;
    }
}
function noop() {}
const avatar_Avatar = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Avatar_eb4ee1a2__["default"], {
        ref: ref,
        variant: "circular",
        ...rest,
        children: children
    });
});
const AVATAR_STEPPER_SIZE = "3.625rem";
const AVATAR_STEPPER_ICON_SIZE = "4.375rem";
const AVATAR_STEPPER_BADGE_ICON_SIZE = "0.469rem";
function AvatarStepper({ numberBarCompleted, id, avatarProps, label, handleProfileImageUpdate, children }) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: handleProfileImageUpdate,
        maxFiles: 1,
        accept: {
            "image/*": []
        }
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AvatarStepperContainer, {
        id: id,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                position: positioning_Positioning.relative,
                display: displaying_Displaying.flex,
                alignItems: alignment_Alignment.center,
                justifyContent: alignment_Alignment.center,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AvatarProgressBar, {
                        numberBarCompleted: numberBarCompleted
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AvatarContainer, {
                        ...getRootProps(),
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                                ...getInputProps()
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledBadge, {
                                overlap: "circular",
                                badgeContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PenSolid, {}),
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledAvatar, {
                                    ...avatarProps,
                                    children: children
                                })
                            })
                        ]
                    })
                ]
            }),
            label
        ]
    });
}
const StyledBadge = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"])(({ theme })=>({
        ".MuiBadge-overlapCircular": {
            border: `1px solid ${theme.palette.primary.main}`,
            height: theme.spacing(3),
            width: theme.spacing(3),
            minWidth: theme.spacing(3),
            padding: theme.spacing(0),
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.common.white
        },
        ".MuiSvgIcon-root": {
            width: AVATAR_STEPPER_BADGE_ICON_SIZE,
            height: AVATAR_STEPPER_BADGE_ICON_SIZE
        }
    }));
const StyledAvatar = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(avatar_Avatar)(({ theme })=>({
        width: AVATAR_STEPPER_SIZE,
        height: AVATAR_STEPPER_SIZE,
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        ".MuiSvgIcon-root": {
            width: AVATAR_STEPPER_ICON_SIZE,
            height: AVATAR_STEPPER_ICON_SIZE
        },
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer
        }
    }));
const AvatarContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ theme })=>({
        position: positioning_Positioning.absolute,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingTop: theme.spacing(2),
        height: AVATAR_STEPPER_SIZE,
        width: AVATAR_STEPPER_SIZE
    }));
const AvatarStepperContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ theme })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        alignItems: alignment_Alignment.center,
        gap: theme.spacing(3)
    }));
const MUI_BADGE_CLASS = "MuiBadge-badge";
const SmallBadge = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"])({
    [`& .${MUI_BADGE_CLASS}`]: {
        height: Spacing["1000"],
        padding: `${Spacing["0"]} 0.375rem`,
        minWidth: "auto"
    }
});
const MediumBadge = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"])({
    [`& .${MUI_BADGE_CLASS}`]: {
        padding: `${Spacing["0"]} 0.40625rem`
    }
});
const BADGE_MAX_VALUE = 99;
const badge_Badge = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, size, ...rest }, ref) {
    const badgeProps = {
        ref,
        max: BADGE_MAX_VALUE,
        ...rest
    };
    if ("dot" === rest.variant) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"], {
        ...badgeProps,
        children: children
    });
    if ("small" === size) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SmallBadge, {
        ...badgeProps,
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MediumBadge, {
        ...badgeProps,
        children: children
    });
});
var border_style_BorderStyle = /*#__PURE__*/ function(BorderStyle) {
    BorderStyle["solid"] = "solid";
    BorderStyle["dashed"] = "dashed";
    return BorderStyle;
}({});
const BlockNoticeContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    borderWidth: 1,
    borderStyle: border_style_BorderStyle.solid,
    borderRadius: BorderRadius.paper,
    overflow: "hidden",
    "&.primary": {
        borderColor: theme_theme.palette.primary.main
    },
    "&.warning": {
        borderColor: theme_theme.palette.warning.main
    }
});
const BlockNoticeIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
});
const BlockNoticeTitleContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isMobile })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        gap: Spacing["500"],
        padding: isMobile ? Spacing["1000"] : `${Spacing["1000"]} ${Spacing["1500"]}`,
        borderBottomLeftRadius: BorderRadius.brand,
        borderBottomRightRadius: BorderRadius.brand,
        "&.primary.high": {
            background: theme_theme.palette.primary.main,
            color: theme_theme.palette.primary.contrastText
        },
        "&.primary.light": {
            background: theme_theme.palette.primary.light,
            color: theme_theme.palette.primary.dark
        },
        "&.warning.high": {
            background: theme_theme.palette.warning.main,
            color: theme_theme.palette.warning.contrastText
        },
        "&.warning.light": {
            background: theme_theme.palette.warning.light,
            color: theme_theme.palette.warning.dark
        }
    }));
const BlockNoticeBodyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isMobile })=>({
        padding: isMobile ? Spacing["1000"] : `${Spacing["1000"]} ${Spacing["2500"]}`,
        backgroundColor: palette_Background.paper
    }));
function BlockNotice({ title, body, color, contrast, icon, id, isMobile }) {
    const className = `${color} ${contrast}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BlockNoticeContainer, {
        id: id,
        className: className,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BlockNoticeTitleContainer, {
                isMobile: isMobile,
                className: className,
                "data-testid": "block-notice-title-container",
                children: [
                    icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlockNoticeIconContainer, {
                        children: icon
                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlockNoticeBodyContainer, {
                isMobile: isMobile,
                children: body
            })
        ]
    });
}
function NavigationListItemCollapsible({ label, icon, children, selected, disabled }) {
    const [isCollapsedMenuOpen, setIsCollapsedMenuOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const endIcon = isCollapsedMenuOpen ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleUpSmallOutlined, {
        color: "action"
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleDownSmallOutlined, {
        color: "action"
    });
    function handleToggleCollapsedMenu() {
        setIsCollapsedMenuOpen((prevOpen)=>!prevOpen);
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__["default"], {
                onClick: handleToggleCollapsedMenu,
                selected: selected,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                        sx: {
                            minWidth: Spacing["3000"]
                        },
                        children: icon
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                        primary: label
                    }),
                    endIcon
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Collapse_1f7ec3cf__["default"], {
                in: isCollapsedMenuOpen,
                timeout: "auto",
                unmountOnExit: true,
                children: children
            })
        ]
    });
}
function NavigationListItem({ label, selected, onClickRoute, path, icon, iconSelected, disabled, isSectionDivider, isNestedItem }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__["default"], {
        sx: {
            padding: `${isNestedItem ? Spacing["250"] : Spacing["500"]} ${Spacing["1000"]}`
        },
        onClick: ()=>onClickRoute?.(path),
        selected: selected,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                sx: {
                    color: selected ? palette_Common.white.main : palette_Action.active,
                    minWidth: Spacing["3000"]
                },
                children: selected ? iconSelected : icon
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                primary: label,
                primaryTypographyProps: isSectionDivider || isNestedItem ? {
                    variant: "body2"
                } : void 0
            })
        ]
    });
}
const NestedNavigation = function({ navigationItems }) {
    function renderNavigationItems(items, isParent = false) {
        return items.map(function(item) {
            const isNestedItem = isParent;
            return item.subpaths ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationListItemCollapsible, {
                ...item,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationList, {
                    children: renderNavigationItems(item.subpaths, true)
                })
            }, item.label) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationListItem, {
                ...item,
                isNestedItem: isNestedItem
            }, item.label);
        });
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: renderNavigationItems(navigationItems)
    });
};
const List = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_List_e42ad5de__["default"], styledOptions)(({ isMobile })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: isMobile ? Spacing["250"] : Spacing["500"]
    }));
const NavigationList = function(props) {
    const isMobile = use_is_mobile();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(List, {
        ...props,
        isMobile: isMobile
    });
};
const BOTTOM_NAVIGATION_HEIGHT = Spacing["4500"];
const MuiBottomNavigationActionElement = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigationAction_261e3421__["default"], styledOptions)(({ isSelected })=>({
        ".MuiBottomNavigationAction-label": {
            color: isSelected ? palette_Primary.main : palette_Text.secondary,
            "&.Mui-selected": {
                fontSize: Spacing["750"]
            }
        }
    }));
function BottomNavigation({ items, children, ref, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BottomNavigationContainer, {
        showLabels: true,
        ref: ref,
        ...rest,
        children: [
            items.map(function(item) {
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MuiBottomNavigationActionElement, {
                    isSelected: item.selected ?? false,
                    label: item.label,
                    icon: item.selected ? item.iconSelected : item.icon,
                    onClick: ()=>item.onClickRoute?.(item?.path)
                }, item.label);
            }),
            children
        ]
    });
}
const BottomNavigationContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigation_918bb977__["default"])(({ theme })=>({
        position: positioning_Positioning.fixed,
        width: "100vw",
        borderTop: `1px solid ${palette_Border.main}`,
        height: BOTTOM_NAVIGATION_HEIGHT,
        left: Spacing["0"],
        bottom: Spacing["0"],
        zIndex: theme.zIndex.drawer + 1,
        paddingLeft: Spacing["1000"],
        paddingRight: Spacing["1000"]
    }));
function BottomNavigationDrawer({ items, children, ref, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SwipeableDrawer_b1c2876e__["default"], {
        anchor: "bottom",
        ref: ref,
        ...rest,
        PaperProps: {
            sx: {
                borderTopRightRadius: BorderRadius.paper,
                borderTopLeftRadius: BorderRadius.paper,
                minWidth: "100%"
            }
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
            spacing: 2,
            paddingX: 1,
            paddingTop: 4,
            sx: {
                paddingBottom: BOTTOM_NAVIGATION_HEIGHT
            },
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationList, {
                    children: items && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NestedNavigation, {
                        navigationItems: items
                    })
                }),
                children
            ]
        })
    });
}
const bottomNavigationRoutes = [
    {
        label: "Profilo",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UserCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UserCircleDuotone, {}),
        path: ""
    },
    {
        label: "Bonus",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EuroCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EuroCircleDuotone, {}),
        path: ""
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileTextEditOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileTextEditDuotone, {}),
        path: ""
    },
    {
        label: "Upgrade",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileWandOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileWandDuotone, {}),
        path: ""
    },
    {
        label: "Altro",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalSolid, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalDuotone, {}),
        path: ""
    }
];
const bottomNavigationDrawerRoutes = [
    {
        label: "Altro",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalDuotone, {}),
        disabled: true
    },
    {
        label: "Documenti",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FolderOpenOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FolderOpenDuotone, {}),
        path: "/documents",
        onClickRoute (path) {
            console.log(path);
        },
        selected: true
    },
    {
        label: "Impostazioni",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SettingsOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SettingsDuotone, {})
    },
    {
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxOutlined, {}),
        label: "Scartoffie",
        subpaths: [
            {
                label: "Termini di utilizzo",
                path: "/tos",
                onClickRoute: (path)=>console.log(path)
            },
            {
                label: "Condizioni Generali di Servizio"
            },
            {
                label: "Privacy Policy"
            },
            {
                label: "Cookies Policy"
            }
        ]
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutDuotone, {})
    }
];
function isError(value) {
    return value instanceof Error;
}
function isFunction(value) {
    return "function" == typeof value;
}
const CustomBreadcrumbsLink = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Link_317b0bd9__["default"], styledOptions)(({ theme, active })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        gap: theme.spacing(2),
        color: active ? theme.palette.text.secondary : displaying_Displaying.inherit,
        fontWeight: active ? typography_FontWeight.bold : typography_FontWeight.normal
    }));
function BreadcrumbsLinkBuilder({ children, lastElement, onClick, href, sx, ...rest }) {
    const isClickable = isFunction(onClick) || href;
    const onHoverTextDecoration = isClickable ? "hover" : displaying_Displaying.none;
    const cursorStyle = isClickable ? cursor_style_CursorStyle.pointer : cursor_style_CursorStyle["default"];
    if (lastElement) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
        noWrap: true,
        textOverflow: "ellipsis",
        overflow: "hidden",
        color: palette_Text.secondary,
        fontWeight: typography_FontWeight.bold,
        onClick: onClick,
        sx: {
            cursor: cursorStyle,
            ...sx
        },
        ...rest,
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomBreadcrumbsLink, {
        sx: {
            cursor: cursorStyle,
            ...sx
        },
        underline: onHoverTextDecoration,
        href: href,
        onClick: onClick,
        ...rest,
        children: children
    });
}
const BreadcrumbsLink = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(BreadcrumbsLinkBuilder);
var wrapping_Wrapping = /*#__PURE__*/ function(Wrapping) {
    Wrapping["noWrap"] = "nowrap";
    Wrapping["wrap"] = "wrap";
    Wrapping["wrapReverse"] = "wrap-reverse";
    return Wrapping;
}({});
const BREADCRUMBS_MAX_ITEMS = 5;
const StyledBreadcrumbs = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Breadcrumbs_3d9c9a2c__["default"])({
    maxWidth: "100%",
    ol: {
        flexWrap: wrapping_Wrapping.noWrap
    },
    "li:last-of-type": {
        overflow: "hidden"
    }
});
const breadcrumbs_Breadcrumbs = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, maxItems = BREADCRUMBS_MAX_ITEMS, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledBreadcrumbs, {
        ref: ref,
        color: "primary",
        maxItems: maxItems,
        separator: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {}),
        ...rest,
        children: children
    });
});
const button_Button = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ loading, children, disabled, endIcon, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
        ref: ref,
        disableElevation: true,
        endIcon: loading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
            color: "inherit",
            size: "1rem"
        }) : endIcon,
        disabled: disabled,
        "aria-disabled": disabled,
        ...rest,
        children: children
    });
});
const ChatInputBottomBar = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
    shouldForwardProp: (prop)=>"shouldShow" !== prop
})(({ shouldShow })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.spaceBetween,
        overflow: "hidden",
        transition: "height 0.3s, opacity 0.3s",
        height: shouldShow ? "40px" : 0,
        opacity: shouldShow ? 1 : 0,
        padding: `0 ${Spacing["500"]} ${shouldShow ? Spacing["500"] : 0}`
    }));
const ChatInputInnerBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(()=>({
        display: displaying_Displaying.flex,
        position: positioning_Positioning.relative,
        backgroundColor: TRANSPARENT_COLOR,
        padding: `${Spacing["1000"]} ${Spacing["750"]}`
    }));
const PRIMARY_COLOR = "primary";
const SECONDARY_OPTION = "secondary";
const NONE_OPTION = "none";
const INITIAL_OPTION = "initial";
const CONTAIN_OPTION = "contain";
const AUTO_OPTION = "auto";
const STABLE_OPTION = "stable";
const ChatInputOuterBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"])(()=>({
        position: positioning_Positioning.relative,
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        backgroundColor: Greyx["0"],
        borderRadius: Spacing["1000"],
        minWidth: Spacing["15000"],
        minHeight: AUTO_OPTION,
        boxSizing: "border-box"
    }));
function computeLabelProps({ readonly, InputLabelProps }) {
    return {
        shrink: readonly,
        ...InputLabelProps
    };
}
function computeInputProps({ size, readonly, blocked, startIcon, endIcon, startAdornment, endAdornment, onStartIconClick, onEndIconClick, onStartAdornmentClick, onEndAdornmentClick, InputProps }) {
    const isNotEditable = readonly ?? blocked;
    let generatedInputProps = {
        readOnly: isNotEditable
    };
    if (blocked) return {
        ...generatedInputProps,
        endAdornment: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LockSolid, {
            color: "primary"
        }),
        className: "blocked"
    };
    if (startIcon || startAdornment) generatedInputProps = {
        ...generatedInputProps,
        startAdornment: getAdornmentAndIcon({
            position: "start",
            size,
            icon: startIcon,
            adornment: startAdornment,
            onIconClick: onStartIconClick,
            onAdornmentClick: onStartAdornmentClick
        })
    };
    if (endIcon || endAdornment) generatedInputProps = {
        ...generatedInputProps,
        endAdornment: getAdornmentAndIcon({
            position: "end",
            size,
            icon: endIcon,
            adornment: endAdornment,
            onIconClick: onEndIconClick,
            onAdornmentClick: onEndAdornmentClick
        })
    };
    return {
        ...generatedInputProps,
        ...InputProps
    };
}
function getAdornmentAndIcon({ position, size, icon, adornment, onIconClick, onAdornmentClick }) {
    if ("start" === position) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            getTextFieldInputAdornmentProperty("adornment", position, size, adornment, onAdornmentClick),
            getTextFieldInputAdornmentProperty("icon", position, size, icon, onIconClick)
        ]
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            getTextFieldInputAdornmentProperty("icon", position, size, icon, onIconClick),
            getTextFieldInputAdornmentProperty("adornment", position, size, adornment, onAdornmentClick)
        ]
    });
}
function getTextFieldInputAdornmentProperty(type, position, size, icon, onClick) {
    if (icon) {
        const adornmentClass = "icon" === type ? "icon" : "adornment";
        const adornmentSize = size ?? "medium";
        const inputAdornmentClassName = `${adornmentClass} ${adornmentSize} ${adornmentClass}-${position}`;
        const testID = `text-field-${position}-${adornmentClass}-${adornmentSize}`;
        const testIDForIconButton = `${testID}-button`;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__["default"], {
            className: inputAdornmentClassName,
            position: position,
            "data-testid": testID,
            children: isFunction(onClick) ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                "data-testid": testIDForIconButton,
                size: size,
                onClick: onClick,
                children: icon
            }) : icon
        });
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
}
const text_field_TextField = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ size, readonly, disabled, blocked, startIcon, endIcon, startAdornment, endAdornment, onStartIconClick, onStartAdornmentClick, onEndIconClick, onEndAdornmentClick, InputProps, InputLabelProps, ...rest }, ref) {
    const isTextFieldDisabled = readonly ?? disabled ?? blocked;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"], {
        ref: ref,
        size: size ?? "medium",
        variant: "outlined",
        disabled: isTextFieldDisabled,
        InputProps: computeInputProps({
            size,
            readonly,
            blocked,
            startIcon,
            endIcon,
            startAdornment,
            endAdornment,
            onStartIconClick,
            onEndIconClick,
            onStartAdornmentClick,
            onEndAdornmentClick,
            InputProps
        }),
        InputLabelProps: computeLabelProps({
            readonly,
            InputLabelProps
        }),
        ...rest
    });
});
const chatInputBoxStyles = {
    position: positioning_Positioning.relative,
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    backgroundColor: Greyx["0"],
    borderRadius: Spacing["1000"],
    minWidth: Spacing["15000"],
    minHeight: AUTO_OPTION,
    boxSizing: "border-box"
};
const chatInputInnerBoxStyles = {
    display: displaying_Displaying.flex,
    position: positioning_Positioning.relative,
    backgroundColor: TRANSPARENT_COLOR,
    padding: `${Spacing["1000"]} ${Spacing["750"]}`
};
const textFieldStyles = {
    flexGrow: 1,
    justifyContent: alignment_Alignment.center,
    backgroundColor: TRANSPARENT_COLOR,
    padding: 0,
    boxShadow: "none",
    scrollbarColor: `${Greyx["400"]} ${TRANSPARENT_COLOR}`,
    "&::-webkit-scrollbar": {
        width: Spacing["250"]
    },
    "&::-webkit-scrollbar-track": {
        background: TRANSPARENT_COLOR
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: Greyx["400"],
        borderRadius: Spacing["500"],
        transition: "background-color 0.3s, width 0.3s"
    },
    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: Greyx["600"],
        width: Spacing["500"]
    }
};
const sendButtonBoxStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
};
const leftActionsBoxStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
};
const rightActionsBoxStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
};
const bottomBarStyles = (shouldBottomBarBeVisible)=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.spaceBetween,
        overflow: "hidden",
        transition: "height 0.3s, opacity 0.3s",
        height: shouldBottomBarBeVisible ? "40px" : 0,
        opacity: shouldBottomBarBeVisible ? 1 : 0,
        padding: `0 ${Spacing["500"]} ${shouldBottomBarBeVisible ? Spacing["500"] : 0}`
    });
const sendButtonStyles = (isChatInputDisabled)=>({
        "&:hover": {
            color: isChatInputDisabled ? "disabled" : palette_Primary.dark
        }
    });
const LeftActionsBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box)(()=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center
    }));
const SendButtonBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"])(()=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center
    }));
const RightActionsBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box)(()=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center
    }));
const DEFAULT_PLACEHOLDER = "Type a message...";
const ENTER_KEY = "Enter";
const BACKSPACE_KEY = "Backspace";
const chat_input_ChatInput = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ readonly = false, blocked = false, isMobile = false, placeholder = DEFAULT_PLACEHOLDER, leftActions, rightActions, onSubmit, onChange, onKeyDown, onBlur, onFocus, inputRef: externalInputRef, ...rest }, ref) {
    const [prompt, setPrompt] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const [isFocused, setIsFocused] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const inputRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const combinedInputRef = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useForkRef)(inputRef, externalInputRef);
    const isTextFieldDisabled = readonly || blocked;
    const maxRows = isMobile ? 4 : 8;
    const isChatInputDisabled = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>0 === prompt.trim().length || readonly || blocked, [
        prompt,
        readonly,
        blocked
    ]);
    const shouldBottomBarBeVisible = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>isFocused || prompt.trim().length > 0, [
        isFocused,
        prompt
    ]);
    const hasLeftActions = leftActions && leftActions.length > 0;
    const hasRightActions = rightActions && rightActions.length > 0;
    const clearPrompt = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        setPrompt("");
    }, []);
    const handleSubmit = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (onSubmit && prompt.length > 0) {
            onSubmit(prompt);
            if (isMobile) handleFocusAway();
            clearPrompt();
        }
    }, [
        prompt,
        onSubmit,
        clearPrompt,
        isMobile
    ]);
    const handleChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        const newValue = event.target.value;
        setPrompt(newValue);
        if (onChange) onChange(event);
    }, [
        onChange
    ]);
    const handleKeyDown = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        const isCtrlOrMetaPressed = event.metaKey || event.ctrlKey;
        function handleEnterKey() {
            if (!isCtrlOrMetaPressed && (isMobile || event.shiftKey)) createNewLine();
            else handleSubmit();
            event.preventDefault();
        }
        function handleBackspaceKey() {
            if (isCtrlOrMetaPressed) {
                clearPrompt();
                event.preventDefault();
            }
        }
        switch(event.key){
            case ENTER_KEY:
                handleEnterKey();
                break;
            case BACKSPACE_KEY:
                handleBackspaceKey();
                break;
            default:
                break;
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        handleSubmit,
        onKeyDown,
        clearPrompt,
        isMobile
    ]);
    const handleBlur = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event, fromAway = false)=>{
        if (fromAway) setIsFocused(false);
        const textAreaElement = inputRef.current?.querySelector("textarea");
        if (textAreaElement) textAreaElement.blur();
        if (onBlur && "currentTarget" in event) onBlur(event);
    }, [
        onBlur
    ]);
    const handleFocus = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        setIsFocused(true);
        const textAreaElement = inputRef.current?.querySelector("textarea");
        if (textAreaElement) textAreaElement.focus();
        if (onFocus) onFocus(event);
    }, [
        onFocus
    ]);
    const handleFocusAway = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        handleBlur({}, true);
    }, []);
    const createNewLine = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        const textAreaElement = inputRef.current;
        if (textAreaElement) {
            const cursorPosition = textAreaElement.selectionStart ?? 0;
            setPrompt((prevPrompt)=>{
                const newPrompt = prevPrompt.slice(0, cursorPosition) + "\n" + prevPrompt.slice(cursorPosition);
                setTimeout(()=>{
                    textAreaElement.selectionStart = textAreaElement.selectionEnd = cursorPosition + 1;
                    textAreaElement.scrollTop = textAreaElement.scrollHeight;
                    textAreaElement.focus();
                }, 0);
                return newPrompt;
            });
        }
    }, []);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle)(ref, ()=>({
            ...inputRef,
            textAreaElement: inputRef.current?.querySelector("textarea"),
            focus: ()=>{
                inputRef.current?.focus();
                if (!isFocused) handleFocus({});
            },
            blur: ()=>{
                inputRef.current?.blur();
                if (isFocused) handleBlur({});
            }
        }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ClickAwayListener_a7328dbe__["default"], {
        onClickAway: (event)=>handleBlur(event, true),
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ChatInputOuterBox, {
            onFocus: handleFocus,
            onClick: handleFocus,
            ...rest,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ChatInputInnerBox, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(text_field_TextField, {
                        inputRef: combinedInputRef,
                        variant: "standard",
                        size: "medium",
                        placeholder: placeholder,
                        value: prompt,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        onBlur: handleBlur,
                        disabled: isTextFieldDisabled,
                        multiline: true,
                        maxRows: maxRows,
                        "data-testid": "chat-input-text-field",
                        focused: isFocused,
                        InputProps: {
                            disableUnderline: true,
                            sx: {
                                padding: 0
                            }
                        },
                        sx: textFieldStyles
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ChatInputBottomBar, {
                    shouldShow: shouldBottomBarBeVisible,
                    children: [
                        hasLeftActions ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftActionsBox, {
                            children: leftActions
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SendButtonBox, {
                            children: [
                                hasRightActions && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RightActionsBox, {
                                    children: rightActions
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
                                    onClick: handleSubmit,
                                    disabled: isChatInputDisabled,
                                    "data-testid": "chat-input-send-button",
                                    disableRipple: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ArrowUpCircleSolid, {
                                        color: isChatInputDisabled ? "disabled" : "primary",
                                        sx: sendButtonStyles(isChatInputDisabled)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const LargeCheckbox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__["default"])({
    "& .MuiSvgIcon-root": {
        fontSize: Spacing["1750"]
    }
});
const checkbox_Checkbox = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isLarge, ...rest }, ref) {
    if (isLarge) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LargeCheckbox, {
        ...rest
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__["default"], {
        ref: ref,
        ...rest
    });
});
function CompanyData() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        variant: "caption",
        color: "text.disabled",
        sx: {
            paddingX: 4
        },
        children: "SimplifAI Ted Srl \u2022 P.I. 11237050965 | Milano (MI) \u2013 Via Roberto Lepetit, 18"
    });
}
const conversationBubbleContainerStyles = (isInteractive)=>({
        display: displaying_Displaying.flex,
        flexDirection: "row",
        alignItems: alignment_Alignment.center,
        padding: `${Spacing["750"]} ${Spacing["1000"]}`,
        gap: Spacing["1000"],
        width: "fit-content",
        maxWidth: "75%",
        backgroundColor: palette_DeepBlue.light,
        borderRadius: Spacing["750"],
        border: `1px solid ${TRANSPARENT_COLOR}`,
        cursor: isInteractive ? "pointer" : "default",
        "&:hover": isInteractive ? {
            borderColor: PurpleLight.outlinedBorder
        } : {},
        "&:focus": isInteractive ? {
            borderColor: PurpleLight.contrastText
        } : {},
        "&:active": isInteractive ? {
            borderColor: PurpleLight.contrastText
        } : {}
    });
const conversationBubbleStartIconStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.center,
    color: PurpleLight.contrastText
};
const conversationBubbleTextStyles = {
    flexGrow: 1,
    wordBreak: "break-word"
};
const renderTextWithSpecialChars = (text)=>text.split("\n").map((line, lineIndex, lines)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
            children: [
                line.split("\t").map((segment, segmentIndex, segments)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                        children: [
                            segment,
                            segmentIndex < segments.length - 1 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                style: {
                                    display: "inline-block",
                                    width: "1em"
                                }
                            })
                        ]
                    }, segmentIndex)),
                lineIndex < lines.length - 1 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("br", {})
            ]
        }, lineIndex));
const conversation_bubble_ConversationBubble = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ text, startIcon, fullWidth = false, maxWidth = "100%", onClick, sx = {}, ...rest }, ref) {
    const isInteractive = Boolean(onClick);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        ref: ref,
        onClick: onClick,
        ...rest,
        sx: {
            ...conversationBubbleContainerStyles(isInteractive),
            width: fullWidth ? "100%" : "fit-content",
            maxWidth: fullWidth ? "none" : maxWidth,
            ...sx
        },
        children: [
            startIcon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                sx: conversationBubbleStartIconStyles,
                children: startIcon
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "body1",
                sx: conversationBubbleTextStyles,
                children: renderTextWithSpecialChars(text)
            })
        ]
    });
}));
function extends_extends() {
    extends_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return extends_extends.apply(this, arguments);
}
function resolveComponentProps(componentProps, ownerState, slotState) {
    if ('function' == typeof componentProps) return componentProps(ownerState, slotState);
    return componentProps;
}
const refType_refType = prop_types_default().oneOfType([
    prop_types_default().func,
    prop_types_default().object
]);
const refType = refType_refType;
function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded) {
    if (null == source) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const areViewsEqual = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const applyDefaultViewProps = ({ openTo, defaultOpenTo, views, defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (null != openTo) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};
const mergeDateAndTime = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const findClosestEnabledDate = ({ date, disableFuture, disablePast, maxDate, minDate, isDateDisabled, utils, timezone })=>{
    const today = mergeDateAndTime(utils, utils.date(void 0, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const replaceInvalidDateByNull = (utils, value)=>null != value && utils.isValid(value) ? value : null;
const applyDefaultDate = (utils, value, defaultValue)=>{
    if (null == value || !utils.isValid(value)) return defaultValue;
    return value;
};
const areDatesEqual = (utils, a, b)=>{
    if (!utils.isValid(a) && null != a && !utils.isValid(b) && null != b) return true;
    return utils.isEqual(a, b);
};
const getMonthsInYear = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const getTodayDate = (utils, timezone, valueType)=>'date' === valueType ? utils.startOfDay(utils.date(void 0, timezone)) : utils.date(void 0, timezone);
const formatMeridiem = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), 'am' === meridiem ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const date_utils_dateViews = [
    'year',
    'month',
    'day'
];
const isDatePickerView = (view)=>date_utils_dateViews.includes(view);
const resolveDateFormat = (utils, { format, views }, isInToolbar)=>{
    if (null != format) return format;
    const formats = utils.formats;
    if (areViewsEqual(views, [
        'year'
    ])) return formats.year;
    if (areViewsEqual(views, [
        'month'
    ])) return formats.month;
    if (areViewsEqual(views, [
        'day'
    ])) return formats.dayOfMonth;
    if (areViewsEqual(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if (areViewsEqual(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const getWeekdays = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};
const time_utils_timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const isTimeView = (view)=>time_utils_timeViews.includes(view);
const isInternalTimeView = (view)=>time_utils_timeViews.includes(view) || 'meridiem' === view;
const getMeridiem = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const convertValueToMeridiem = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return 'am' === meridiem ? value - 12 : value + 12;
    }
    return value;
};
const convertToMeridiem = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const getSecondsInDay = (date, utils)=>3600 * utils.getHours(date) + 60 * utils.getMinutes(date) + utils.getSeconds(date);
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
    };
const resolveTimeFormat = (utils, { format, views, ampm })=>{
    if (null != format) return format;
    const formats = utils.formats;
    if (areViewsEqual(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if (areViewsEqual(views, [
        'minutes'
    ])) return formats.minutes;
    if (areViewsEqual(views, [
        'seconds'
    ])) return formats.seconds;
    if (areViewsEqual(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if (areViewsEqual(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};
const SECTION_TYPE_GRANULARITY = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const getSectionTypeGranularity = (sections)=>Math.max(...sections.map((section)=>SECTION_TYPE_GRANULARITY[section.type] ?? 1));
const roundDate = (utils, granularity, date)=>{
    if (granularity === SECTION_TYPE_GRANULARITY.year) return utils.startOfYear(date);
    if (granularity === SECTION_TYPE_GRANULARITY.month) return utils.startOfMonth(date);
    if (granularity === SECTION_TYPE_GRANULARITY.day) return utils.startOfDay(date);
    let roundedDate = date;
    if (granularity < SECTION_TYPE_GRANULARITY.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < SECTION_TYPE_GRANULARITY.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const getDefaultReferenceDate = ({ props, utils, granularity, timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(utils, granularity, getTodayDate(utils, timezone));
    if (null != props.minDate && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = roundDate(utils, granularity, props.minDate);
    if (null != props.maxDate && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = roundDate(utils, granularity, props.maxDate);
    const isAfter = createIsAfterIgnoreDatePart(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (null != props.minTime && isAfter(props.minTime, referenceDate)) referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : mergeDateAndTime(utils, referenceDate, props.minTime));
    if (null != props.maxTime && isAfter(referenceDate, props.maxTime)) referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : mergeDateAndTime(utils, referenceDate, props.maxTime));
    return referenceDate;
};
const getDateSectionConfigFromFormatToken = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (null == config) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if ('string' == typeof config) return {
        type: config,
        contentType: 'meridiem' === config ? 'letter' : 'digit',
        maxLength: void 0
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const getDaysInWeekStr = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.date(void 0, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const getLetterEditingOptions = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return getMonthsInYear(utils, utils.date(void 0, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return getDaysInWeekStr(utils, timezone, format);
        case 'meridiem':
            {
                const now = utils.date(void 0, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const FORMAT_SECONDS_NO_LEADING_ZEROS = 's';
const NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const getLocalizedDigits = (utils)=>{
    const today = utils.date(void 0);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), FORMAT_SECONDS_NO_LEADING_ZEROS);
    if ('0' === formattedZero) return NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), FORMAT_SECONDS_NO_LEADING_ZEROS));
};
const removeLocalizedDigits = (valueStr, localizedDigits)=>{
    if ('0' === localizedDigits[0]) return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const applyLocalizedDigits = (valueStr, localizedDigits)=>{
    if ('0' === localizedDigits[0]) return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const isStringNumber = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = removeLocalizedDigits(valueStr, localizedDigits);
    return !Number.isNaN(Number(nonLocalizedValueStr));
};
const cleanLeadingZeros = (valueStr, size)=>{
    let cleanValueStr = valueStr;
    cleanValueStr = Number(cleanValueStr).toString();
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const cleanDigitSectionValue = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if ('production' !== process.env.NODE_ENV) {
        if ('day' !== section.type && 'digit-with-letter' === section.contentType) throw new Error([
            `MUI X: The token "${section.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`
        ].join('\n'));
    }
    if ('day' === section.type && 'digit-with-letter' === section.contentType) {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = cleanLeadingZeros(valueStr, section.maxLength);
    return applyLocalizedDigits(valueStr, localizedDigits);
};
const adjustSectionValue = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes)=>{
    const delta = getDeltaFromKeyCode(keyCode);
    const isStart = 'Home' === keyCode;
    const isEnd = 'End' === keyCode;
    const shouldSetAbsolute = '' === section.value || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>cleanDigitSectionValue(utils, value, sectionBoundaries, localizedDigits, section);
        const step = 'minutes' === section.type && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt(removeLocalizedDigits(section.value, localizedDigits), 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if ('year' === section.type && !isEnd && !isStart) return utils.formatByString(utils.date(void 0, timezone), section.format);
            newSectionValueNumber = delta > 0 || isStart ? sectionBoundaries.minimum : sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step;
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = getLetterEditingOptions(utils, timezone, section.type, section.format);
        if (0 === options.length) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if ('digit' === section.contentType || 'digit-with-letter' === section.contentType) return adjustDigitSection();
    return adjustLetterSection();
};
const getSectionVisibleValue = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = 'non-input' === target ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if ('non-input' === target && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(removeLocalizedDigits(value, localizedDigits)).toString();
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && 'digit' === section.contentType && !hasLeadingZeros && 1 === value.length;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if ('input-rtl' === target) value = `\u2068${value}\u2069`;
    return value;
};
const changeSectionValueFormat = (utils, valueStr, currentFormat, newFormat)=>{
    if ('production' !== process.env.NODE_ENV) {
        if ('weekDay' === getDateSectionConfigFromFormatToken(utils, currentFormat).type) throw new Error("changeSectionValueFormat doesn't support week day formats");
    }
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const isFourDigitYearFormat = (utils, timezone, format)=>4 === utils.formatByString(utils.date(void 0, timezone), format).length;
const doesSectionFormatHaveLeadingZeros = (utils, timezone, contentType, sectionType, format)=>{
    if ('digit' !== contentType) return false;
    const now = utils.date(void 0, timezone);
    switch(sectionType){
        case 'year':
            {
                if (isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return '0001' === formatted0001;
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return '01' === formatted2001;
            }
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const getDateFromDateSections = (utils, sections, localizedDigits)=>{
    const shouldSkipWeekDays = sections.some((section)=>'day' === section.type);
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && 'weekDay' === section.type;
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push(getSectionVisibleValue(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const createDateStrForV7HiddenInputFromSections = (sections)=>sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
const createDateStrForV6InputFromSections = (sections, localizedDigits, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = getSectionVisibleValue(section, isRTL ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRTL) return dateStr;
    return `\u2066${dateStr}\u2069`;
};
const getSectionsBoundaries = (utils, localizedDigits, timezone)=>{
    const today = utils.date(void 0, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth, longestMonth } = getMonthsInYear(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format })=>({
                minimum: 0,
                maximum: isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate })=>({
                minimum: 1,
                maximum: null != currentDate && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format, contentType })=>{
            if ('digit' === contentType) {
                const daysInWeek = getDaysInWeekStr(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = removeLocalizedDigits(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(removeLocalizedDigits(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let warnedOnceInvalidSection = false;
const validateSections = (sections, valueType)=>{
    if ('production' !== process.env.NODE_ENV) {
        if (!warnedOnceInvalidSection) {
            const supportedSections = [
                'empty'
            ];
            if ([
                'date',
                'date-time'
            ].includes(valueType)) supportedSections.push('weekDay', 'day', 'month', 'year');
            if ([
                'time',
                'date-time'
            ].includes(valueType)) supportedSections.push('hours', 'minutes', 'seconds', 'meridiem');
            const invalidSection = sections.find((section)=>!supportedSections.includes(section.type));
            if (invalidSection) {
                console.warn(`MUI X: The field component you are using is not compatible with the "${invalidSection.type}" date section.`, `The supported date sections are ["${supportedSections.join('", "')}"]\`.`);
                warnedOnceInvalidSection = true;
            }
        }
    }
};
const transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = getDaysInWeekStr(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const mergeDateIntoReferenceDate = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>[
        ...sections
    ].sort((a, b)=>reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const isAndroid = ()=>navigator.userAgent.toLowerCase().indexOf('android') > -1;
const getSectionOrder = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = 0 === index ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex,
                rightIndex
            };
        });
        return {
            neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex((section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && ' / ' !== section.endSeparator);
        if (-1 === groupedSectionsEnd) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = 0 === rtlIndex ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex,
            rightIndex
        };
    });
    return {
        neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const parseSelectedSections = (selectedSections, sections)=>{
    if (null == selectedSections) return null;
    if ('all' === selectedSections) return 'all';
    if ('string' == typeof selectedSections) return sections.findIndex((section)=>section.type === selectedSections);
    return selectedSections;
};
const getSectionValueText = (section, utils)=>{
    if (!section.value) return;
    switch(section.type){
        case 'month':
            {
                if ('digit' === section.contentType) return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), 'month');
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, 'month') : void 0;
            }
        case 'day':
            return 'digit' === section.contentType ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), 'dayOfMonthFull') : section.value;
        case 'weekDay':
            return;
        default:
            return;
    }
};
const getSectionValueNow = (section, utils)=>{
    if (!section.value) return;
    switch(section.type){
        case 'weekDay':
            if ('letter' === section.contentType) return;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return;
            }
        case 'day':
            return 'digit-with-letter' === section.contentType ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if ('digit' === section.contentType) return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : void 0;
            }
        default:
            return 'letter' !== section.contentType ? Number(section.value) : void 0;
    }
};
const valueManagers_excluded = [
    "value",
    "referenceDate"
];
const singleItemValueManager = {
    emptyValue: null,
    getTodayValue: getTodayDate,
    getInitialReferenceValue: (_ref)=>{
        let { value, referenceDate } = _ref, params = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, valueManagers_excluded);
        if (null != value && params.utils.isValid(value)) return value;
        if (null != referenceDate) return referenceDate;
        return getDefaultReferenceDate(params);
    },
    cleanValue: replaceInvalidDateByNull,
    areValuesEqual: areDatesEqual,
    isSameError: (a, b)=>a === b,
    hasError: (error)=>null != error,
    defaultErrorState: null,
    getTimezone: (utils, value)=>null != value && utils.isValid(value) ? utils.getTimezone(value) : null,
    setTimezone: (utils, timezone, value)=>null == value ? null : utils.setTimezone(value, timezone)
};
const singleItemFieldValueManager = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>null != value && utils.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return getSectionsFromDate(date);
    },
    getV7HiddenInputValueFromSections: createDateStrForV7HiddenInputFromSections,
    getV6InputValueFromSections: createDateStrForV6InputFromSections,
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: null != newActiveDate && utils.isValid(newActiveDate) ? newActiveDate : state.referenceValue
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};
const LocalizationProvider_excluded = [
    "localeText"
];
const MuiPickersAdapterContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext(null);
if ('production' !== process.env.NODE_ENV) MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
const LocalizationProvider_LocalizationProvider = function(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(inProps, LocalizationProvider_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = __WEBPACK_EXTERNAL_MODULE_react__.useContext(MuiPickersAdapterContext) ?? {
        utils: void 0,
        localeText: void 0
    };
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children, dateAdapter: DateAdapter, dateFormats, dateLibInstance, adapterLocale, localeText: themeLocaleText } = props;
    const localeText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>extends_extends({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            utils,
            defaultDates,
            localeText
        }), [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MuiPickersAdapterContext.Provider, {
        value: contextValue,
        children: children
    });
};
"production" !== process.env.NODE_ENV && (LocalizationProvider_LocalizationProvider.propTypes = {
    adapterLocale: prop_types_default().any,
    children: prop_types_default().node,
    dateAdapter: prop_types_default().func,
    dateFormats: prop_types_default().shape({
        dayOfMonth: prop_types_default().string,
        dayOfMonthFull: prop_types_default().string,
        fullDate: prop_types_default().string,
        fullTime: prop_types_default().string,
        fullTime12h: prop_types_default().string,
        fullTime24h: prop_types_default().string,
        hours12h: prop_types_default().string,
        hours24h: prop_types_default().string,
        keyboardDate: prop_types_default().string,
        keyboardDateTime: prop_types_default().string,
        keyboardDateTime12h: prop_types_default().string,
        keyboardDateTime24h: prop_types_default().string,
        meridiem: prop_types_default().string,
        minutes: prop_types_default().string,
        month: prop_types_default().string,
        monthShort: prop_types_default().string,
        normalDate: prop_types_default().string,
        normalDateWithWeekday: prop_types_default().string,
        seconds: prop_types_default().string,
        shortDate: prop_types_default().string,
        weekday: prop_types_default().string,
        weekdayShort: prop_types_default().string,
        year: prop_types_default().string
    }),
    dateLibInstance: prop_types_default().any,
    localeText: prop_types_default().object
});
const getPickersLocalization = (pickersTranslations)=>({
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: extends_extends({}, pickersTranslations)
                }
            }
        }
    });
const enUSPickers = {
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>'year' === view ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${null === time ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    selectViewText: (view)=>`Select ${view}`,
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    openDatePickerDialogue: (value, utils)=>null !== value && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils)=>null !== value && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
    fieldClearLabel: 'Clear value',
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>'letter' === params.contentType ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>'letter' === params.contentType ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    empty: 'Empty'
};
const DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);
const useLocalizationContext = ()=>{
    const localization = __WEBPACK_EXTERNAL_MODULE_react__.useContext(MuiPickersAdapterContext);
    if (null === localization) throw new Error("MUI X: Can not find the date and time pickers localization context.\nIt looks like you forgot to wrap your component in LocalizationProvider.\nThis can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package");
    if (null === localization.utils) throw new Error("MUI X: Can not find the date and time pickers adapter from its localization context.\nIt looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.");
    const localeText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>extends_extends({}, DEFAULT_LOCALE, localization.localeText), [
        localization.localeText
    ]);
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>extends_extends({}, localization, {
            localeText
        }), [
        localization,
        localeText
    ]);
};
const useUtils_useUtils = ()=>useLocalizationContext().utils;
const useDefaultDates = ()=>useLocalizationContext().defaultDates;
const useLocaleText = ()=>useLocalizationContext().localeText;
const useNow = (timezone)=>{
    const utils = useUtils_useUtils();
    const now = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    if (void 0 === now.current) now.current = utils.date(void 0, timezone);
    return now.current;
};
function clsx_r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) if (Array.isArray(e)) {
        var o = e.length;
        for(t = 0; t < o; t++)e[t] && (f = clsx_r(e[t])) && (n && (n += " "), n += f);
    } else for(f in e)e[f] && (n && (n += " "), n += f);
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = clsx_r(e)) && (n && (n += " "), n += t);
    return n;
}
const dist_clsx = clsx;
function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach((slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if ('' !== utilityClass) acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator_ClassNameGenerator = createClassNameGenerator();
const ClassNameGenerator = ClassNameGenerator_ClassNameGenerator;
const globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}
function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
    });
    return result;
}
function getPickersToolbarUtilityClass(slot) {
    return generateUtilityClass('MuiPickersToolbar', slot);
}
const pickersToolbarClasses = generateUtilityClasses('MuiPickersToolbar', [
    'root',
    'content'
]);
const PickersToolbar_excluded = [
    "children",
    "className",
    "toolbarTitle",
    "hidden",
    "titleId",
    "isLandscape",
    "classes",
    "landscapeDirection"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        penIconButton: [
            'penIconButton',
            isLandscape && 'penIconButtonLandscape'
        ]
    };
    return composeClasses(slots, getPickersToolbarUtilityClass, classes);
};
const PickersToolbarRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const PickersToolbarContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                isLandscape: true,
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const PickersToolbar_PickersToolbar = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children, className, toolbarTitle, hidden, titleId } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersToolbar_excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersToolbarRoot, extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});
function getDatePickerToolbarUtilityClass(slot) {
    return generateUtilityClass('MuiDatePickerToolbar', slot);
}
generateUtilityClasses('MuiDatePickerToolbar', [
    'root',
    'title'
]);
const DatePickerToolbar_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "className",
    "onViewChange",
    "view"
];
const DatePickerToolbar_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return composeClasses(slots, getDatePickerToolbarUtilityClass, classes);
};
const DatePickerToolbarRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersToolbar_PickersToolbar, {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const DatePickerToolbarTitle = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})({
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const DatePickerToolbar_DatePickerToolbar = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value, isLandscape, toolbarFormat, toolbarPlaceholder = '––', views, className } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, DatePickerToolbar_excluded);
    const utils = useUtils_useUtils();
    const localeText = useLocaleText();
    const classes = DatePickerToolbar_useUtilityClasses(props);
    const dateText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = resolveDateFormat(utils, {
            format: toolbarFormat,
            views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DatePickerToolbarRoot, extends_extends({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: dist_clsx(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});
"production" !== process.env.NODE_ENV && (DatePickerToolbar_DatePickerToolbar.propTypes = {
    classes: prop_types_default().object,
    className: prop_types_default().string,
    disabled: prop_types_default().bool,
    hidden: prop_types_default().bool,
    isLandscape: prop_types_default().bool.isRequired,
    onChange: prop_types_default().func.isRequired,
    onViewChange: prop_types_default().func.isRequired,
    readOnly: prop_types_default().bool,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    titleId: prop_types_default().string,
    toolbarFormat: prop_types_default().string,
    toolbarPlaceholder: prop_types_default().node,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired,
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired).isRequired
});
function useDatePickerDefaultizedProps(props, name) {
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props,
        name
    });
    const localeText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return extends_extends({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return extends_extends({}, themeProps, {
        localeText
    }, applyDefaultViewProps({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: extends_extends({
            toolbar: DatePickerToolbar_DatePickerToolbar
        }, themeProps.slots)
    });
}
const validateDate = ({ props, value, adapter })=>{
    if (null === value) return null;
    const { shouldDisableDate, shouldDisableMonth, shouldDisableYear, disablePast, disableFuture, timezone } = props;
    const now = adapter.utils.date(void 0, timezone);
    const minDate = applyDefaultDate(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = applyDefaultDate(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
function setRef(ref, value) {
    if ('function' == typeof ref) ref(value);
    else if (ref) ref.current = value;
}
'use client';
function useForkRef(...refs) {
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (refs.every((ref)=>null == ref)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                setRef(ref, instance);
            });
        };
    }, refs);
}
function isHostComponent(element) {
    return 'string' == typeof element;
}
function appendOwnerState(elementType, otherProps, ownerState) {
    if (void 0 === elementType || isHostComponent(elementType)) return otherProps;
    return extends_extends({}, otherProps, {
        ownerState: extends_extends({}, otherProps.ownerState, ownerState)
    });
}
function dist_clsx_r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) if (Array.isArray(e)) {
        var o = e.length;
        for(t = 0; t < o; t++)e[t] && (f = dist_clsx_r(e[t])) && (n && (n += " "), n += f);
    } else for(f in e)e[f] && (n && (n += " "), n += f);
    return n;
}
function clsx_clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = dist_clsx_r(e)) && (n && (n += " "), n += t);
    return n;
}
const clsx_dist_clsx = clsx_clsx;
function extractEventHandlers(object, excludeKeys = []) {
    if (void 0 === object) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && 'function' == typeof object[prop] && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
function omitEventHandlers(object) {
    if (void 0 === object) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && 'function' == typeof object[prop])).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        const joinedClasses = clsx_dist_clsx(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = extends_extends({}, additionalProps?.style, externalForwardedProps?.style, externalSlotProps?.style);
        const props = extends_extends({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: void 0
        };
    }
    const eventHandlers = extractEventHandlers(extends_extends({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
    const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    const joinedClasses = clsx_dist_clsx(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = extends_extends({}, internalSlotProps?.style, additionalProps?.style, externalForwardedProps?.style, externalSlotProps?.style);
    const props = extends_extends({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}
'use client';
const useSlotProps_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function useSlotProps(parameters) {
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false } = parameters, rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(parameters, useSlotProps_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = mergeSlotProps(extends_extends({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = useForkRef(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = appendOwnerState(elementType, extends_extends({}, mergedProps, {
        ref
    }), ownerState);
    return props;
}
function setRef_setRef(ref, value) {
    if ('function' == typeof ref) ref(value);
    else if (ref) ref.current = value;
}
'use client';
function useForkRef_useForkRef(...refs) {
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (refs.every((ref)=>null == ref)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                setRef_setRef(ref, instance);
            });
        };
    }, refs);
}
'use client';
let globalId = 0;
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = __WEBPACK_EXTERNAL_MODULE_react__.useState(idOverride);
    const id = idOverride || defaultId;
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null == defaultId) {
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
const maybeReactUseId = __WEBPACK_EXTERNAL_MODULE_react__['useId'.toString()];
function useId(idOverride) {
    if (void 0 !== maybeReactUseId) {
        const reactId = maybeReactUseId();
        return null != idOverride ? idOverride : reactId;
    }
    return useGlobalId(idOverride);
}
'use client';
const useEnhancedEffect_useEnhancedEffect = 'undefined' != typeof window ? __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect : __WEBPACK_EXTERNAL_MODULE_react__.useEffect;
const useEnhancedEffect = useEnhancedEffect_useEnhancedEffect;
'use client';
function useEventCallback(fn) {
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef(fn);
    useEnhancedEffect(()=>{
        ref.current = fn;
    });
    return __WEBPACK_EXTERNAL_MODULE_react__.useRef((...args)=>(0, ref.current)(...args)).current;
}
const useEventCallback_useEventCallback = useEventCallback;
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function getPickersPopperUtilityClass(slot) {
    return generateUtilityClass('MuiPickersPopper', slot);
}
generateUtilityClasses('MuiPickersPopper', [
    'root',
    'paper'
]);
function arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>-1 !== array.indexOf(item));
    return -1 !== array.indexOf(itemOrItems);
}
const onSpaceOrEnter = (innerFn, externalEvent)=>(event)=>{
        if ('Enter' === event.key || ' ' === event.key) {
            innerFn(event);
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const getActiveElement = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return getActiveElement(activeEl.shadowRoot);
    return activeEl;
};
const PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
const mobileVersionMatches = 'undefined' != typeof navigator && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
const iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
const slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
const useDefaultReduceAnimations = ()=>{
    const prefersReduced = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_useMediaQuery_95ceafc9__["default"])(PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || slowAnimationDevices;
};
const PickersPopper_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const PickersPopper_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return composeClasses(slots, getPickersPopperUtilityClass, classes);
};
const PickersPopperRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Popper_24cb866b__["default"], {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        zIndex: theme.zIndex.modal
    }));
const PickersPopperPaper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__["default"], {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ placement })=>[
                    'top',
                    'top-start',
                    'top-end'
                ].includes(placement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
function useClickAwayListener(active, onClickAway) {
    const movedRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const syntheticEventRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const nodeRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const activatedRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!active) return;
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    const handleClickAway = useEventCallback_useEventCallback((event)=>{
        if (!activatedRef.current) return;
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = ownerDocument(nodeRef.current);
        if (!nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) return;
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        insideDOM = event.composedPath ? event.composedPath().indexOf(nodeRef.current) > -1 : !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (active) {
            const doc = ownerDocument(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
    }, [
        active,
        handleClickAway
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (active) {
            const doc = ownerDocument(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                syntheticEventRef.current = false;
            };
        }
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const PickersPopperPaperWrapper = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    const { PaperComponent, popperPlacement, ownerState: inOwnerState, children, paperSlotProps, paperClasses, onPaperClick, onPaperTouchStart } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersPopper_excluded);
    const ownerState = extends_extends({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = useSlotProps({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref
        },
        className: paperClasses,
        ownerState
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PaperComponent, extends_extends({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function PickersPopper(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl, children, containerRef = null, shouldRestoreFocus, onBlur, onDismiss, open, role, placement, slots, slotProps, reduceAnimations: inReduceAnimations } = props;
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && 'Escape' === nativeEvent.key) onDismiss();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if ('tooltip' === role || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = getActiveElement(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, onBlur ?? onDismiss);
    const paperRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(paperRef, containerRef);
    const handlePaperRef = useForkRef_useForkRef(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = PickersPopper_useUtilityClasses(ownerState);
    const defaultReduceAnimations = useDefaultReduceAnimations();
    const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if ('Escape' === event.key) {
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? __WEBPACK_EXTERNAL_MODULE__mui_material_Fade_74850abd__["default"] : __WEBPACK_EXTERNAL_MODULE__mui_material_Grow_8b326669__["default"];
    const FocusTrap = slots?.desktopTrapFocus ?? __WEBPACK_EXTERNAL_MODULE__mui_material_Unstable_TrapFocus_0439b381__["default"];
    const Paper = slots?.desktopPaper ?? PickersPopperPaper;
    const Popper = slots?.popper ?? PickersPopperRoot;
    const popperProps = useSlotProps({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role,
            open,
            anchorEl,
            placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Popper, extends_extends({}, popperProps, {
        children: ({ TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FocusTrap, extends_extends({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: 'tooltip' === role,
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Transition, extends_extends({}, TransitionProps, slotProps?.desktopTransition, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}
const useOpenState = ({ open, onOpen, onClose })=>{
    const isControllingOpenProp = __WEBPACK_EXTERNAL_MODULE_react__.useRef('boolean' == typeof open).current;
    const [openState, setIsOpenState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isControllingOpenProp) {
            if ('boolean' != typeof open) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen
    };
};
function useValidation(props, validate, isSameError, defaultErrorState) {
    const { value, onError } = props;
    const adapter = useLocalizationContext();
    const previousValidationErrorRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(defaultErrorState);
    const validationError = validate({
        adapter,
        value,
        props
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}
'use client';
function useControlled({ controlled, default: defaultProp, name, state = 'value' }) {
    const { current: isControlled } = __WEBPACK_EXTERNAL_MODULE_react__.useRef(void 0 !== controlled);
    const [valueState, setValue] = __WEBPACK_EXTERNAL_MODULE_react__.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    if ('production' !== process.env.NODE_ENV) {
        __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
            if (isControlled !== (void 0 !== controlled)) console.error([
                `MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`,
                'Elements should not switch from uncontrolled to controlled (or vice versa).',
                `Decide between using a controlled or uncontrolled ${name} element for the lifetime of the component.`,
                "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                'More info: https://fb.me/react-controlled-components'
            ].join('\n'));
        }, [
            state,
            name,
            controlled
        ]);
        const { current: defaultValue } = __WEBPACK_EXTERNAL_MODULE_react__.useRef(defaultProp);
        __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
            if (!isControlled && defaultValue !== defaultProp) console.error([
                `MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. To suppress this warning opt to use a controlled ${name}.`
            ].join('\n'));
        }, [
            JSON.stringify(defaultProp)
        ]);
    }
    const setValueIfUncontrolled = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}
const useValueWithTimezone = ({ timezone: timezoneProp, value: valueProp, defaultValue, onChange, valueManager })=>{
    const utils = useUtils_useUtils();
    const firstDefaultValue = __WEBPACK_EXTERNAL_MODULE_react__.useRef(defaultValue);
    const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
    const inputTimezone = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = useEventCallback_useEventCallback((newValue)=>{
        if (null == inputTimezone) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = timezoneProp ?? inputTimezone ?? 'default';
    const valueWithTimezoneToRender = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = useEventCallback_useEventCallback((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange,
        timezone: timezoneToRender
    };
};
const useControlledValueWithTimezone = ({ name, timezone: timezoneProp, value: valueProp, defaultValue, onChange: onChangeProp, valueManager })=>{
    const [valueWithInputTimezone, setValue] = useControlled({
        name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const onChange = useEventCallback_useEventCallback((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp?.(newValue, ...otherParams);
    });
    return useValueWithTimezone({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: void 0,
        onChange,
        valueManager
    });
};
const shouldPublishValue = (params)=>{
    const { action, hasChanged, dateState, isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if ('setValueFromField' === action.name) return true;
    if ('setValueFromAction' === action.name) {
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if ('setValueFromView' === action.name && 'shallow' !== action.selectionState) {
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if ('setValueFromShortcut' === action.name) {
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
const shouldCommitValue = (params)=>{
    const { action, hasChanged, dateState, isControlled, closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if ('setValueFromAction' === action.name) {
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if ('setValueFromView' === action.name && 'finish' === action.selectionState && closeOnSelect) {
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if ('setValueFromShortcut' === action.name) return 'accept' === action.changeImportance && hasChanged(dateState.lastCommittedValue);
    return false;
};
const shouldClosePicker = (params)=>{
    const { action, closeOnSelect } = params;
    if ('setValueFromAction' === action.name) return true;
    if ('setValueFromView' === action.name) return 'finish' === action.selectionState && closeOnSelect;
    if ('setValueFromShortcut' === action.name) return 'accept' === action.changeImportance;
    return false;
};
const usePickerValue = ({ props, valueManager, valueType, wrapperVariant, validator })=>{
    const { onAccept, onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect = 'desktop' === wrapperVariant, timezone: timezoneProp } = props;
    const { current: defaultValue } = __WEBPACK_EXTERNAL_MODULE_react__.useRef(inDefaultValue);
    const { current: isControlled } = __WEBPACK_EXTERNAL_MODULE_react__.useRef(void 0 !== inValue);
    if ('production' !== process.env.NODE_ENV) {
        __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
            if (isControlled !== (void 0 !== inValue)) console.error([
                `MUI X: A component is changing the ${isControlled ? '' : 'un'}controlled value of a picker to be ${isControlled ? 'un' : ''}controlled.`,
                'Elements should not switch from uncontrolled to controlled (or vice versa).',
                "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.",
                "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                'More info: https://fb.me/react-controlled-components'
            ].join('\n'));
        }, [
            inValue
        ]);
        __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
            if (!isControlled && defaultValue !== inDefaultValue) console.error("MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value.");
        }, [
            JSON.stringify(defaultValue)
        ]);
    }
    const utils = useUtils_useUtils();
    const adapter = useLocalizationContext();
    const { isOpen, setIsOpen } = useOpenState(props);
    const [dateState, setDateState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>{
        let initialValue;
        initialValue = void 0 !== inValue ? inValue : void 0 !== defaultValue ? defaultValue : valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone, handleValueChange } = useValueWithTimezone({
        timezone: timezoneProp,
        value: inValue,
        defaultValue,
        onChange,
        valueManager
    });
    useValidation(extends_extends({}, props, {
        value: dateState.draft,
        timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = useEventCallback_useEventCallback((action)=>{
        const updaterParams = {
            action,
            dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled,
            closeOnSelect
        };
        const shouldPublish = shouldPublishValue(updaterParams);
        const shouldCommit = shouldCommitValue(updaterParams);
        const shouldClose = shouldClosePicker(updaterParams);
        setDateState((prev)=>extends_extends({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = 'setValueFromField' === action.name ? action.context.validationError : validator({
                adapter,
                value: action.value,
                props: extends_extends({}, props, {
                    value: action.value,
                    timezone
                })
            });
            const context = {
                validationError
            };
            if ('setValueFromShortcut' === action.name) context.shortcut = action.shortcut;
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (void 0 !== inValue && (void 0 === dateState.lastControlledValue || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>extends_extends({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = useEventCallback_useEventCallback(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = useEventCallback_useEventCallback(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = useEventCallback_useEventCallback(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = useEventCallback_useEventCallback(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = useEventCallback_useEventCallback(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = useEventCallback_useEventCallback((event)=>{
        event.preventDefault();
        setIsOpen(true);
    });
    const handleClose = useEventCallback_useEventCallback((event)=>{
        event?.preventDefault();
        setIsOpen(false);
    });
    const handleChange = useEventCallback_useEventCallback((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState
        }));
    const handleSelectShortcut = useEventCallback_useEventCallback((newValue, changeImportance, shortcut)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance,
            shortcut
        }));
    const handleChangeFromField = useEventCallback_useEventCallback((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context
        }));
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField
    };
    const viewValue = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter,
            value: testedValue,
            props: extends_extends({}, props, {
                value: testedValue,
                timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = extends_extends({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions
    };
};
let warnedOnceNotValidView = false;
function useViews({ onChange, onViewChange, openTo, view: inView, views, autoFocus, focusedView: inFocusedView, onFocusedViewChange }) {
    if ('production' !== process.env.NODE_ENV) {
        if (!warnedOnceNotValidView) {
            if (null != inView && !views.includes(inView)) {
                console.warn(`MUI X: \`view="${inView}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
                warnedOnceNotValidView = true;
            }
            if (null == inView && null != openTo && !views.includes(openTo)) {
                console.warn(`MUI X: \`openTo="${openTo}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
                warnedOnceNotValidView = true;
            }
        }
    }
    const previousOpenTo = __WEBPACK_EXTERNAL_MODULE_react__.useRef(openTo);
    const previousViews = __WEBPACK_EXTERNAL_MODULE_react__.useRef(views);
    const defaultView = __WEBPACK_EXTERNAL_MODULE_react__.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = useControlled({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = __WEBPACK_EXTERNAL_MODULE_react__.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = useControlled({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = useEventCallback_useEventCallback((viewToFocus, hasFocus)=>{
        hasFocus ? setFocusedView(viewToFocus) : setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView);
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = useEventCallback_useEventCallback((newView)=>{
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = useEventCallback_useEventCallback(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = useEventCallback_useEventCallback((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = 'finish' === currentViewSelectionState;
        const hasMoreViews = selectedView ? views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view,
        setView: handleChangeView,
        focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView,
        previousView,
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView,
        setValueAndGoToNextView
    };
}
const usePickerViews_excluded = [
    "className",
    "sx"
];
const usePickerViews = ({ props, propsFromPickerValue, additionalViewProps, autoFocusView, rendererInterceptor, fieldRef })=>{
    const { onChange, open, onClose } = propsFromPickerValue;
    const { views, openTo, onViewChange, disableOpenPicker, viewRenderers, timezone } = props;
    const propsToForwardToView = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, usePickerViews_excluded);
    const { view, setView, defaultView, focusedView, setFocusedView, setValueAndGoToNextView } = useViews({
        view: void 0,
        views,
        openTo,
        onChange,
        onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView, viewModeLookup } = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            viewMode = disableOpenPicker ? 'field' : null != viewRenderers[viewForReduce] ? 'UI' : 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if ('UI' === viewMode) acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (null != viewRenderers[viewForReduce] && isTimeView(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = useEventCallback_useEventCallback(()=>'UI' === currentViewMode);
    const [popperView, setPopperView] = __WEBPACK_EXTERNAL_MODULE_react__.useState('UI' === currentViewMode ? view : null);
    if (popperView !== view && 'UI' === viewModeLookup[view]) setPopperView(view);
    useEnhancedEffect(()=>{
        if ('field' === currentViewMode && open) {
            onClose();
            setTimeout(()=>{
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]);
    useEnhancedEffect(()=>{
        if (!open) return;
        let newView = view;
        if ('field' === currentViewMode && null != popperView) newView = popperView;
        if (newView !== defaultView && 'UI' === viewModeLookup[newView] && 'UI' === viewModeLookup[defaultView]) newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]);
    const layoutProps = {
        views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView,
        shouldRestoreFocus,
        layoutProps,
        renderCurrentView: ()=>{
            if (null == popperView) return null;
            const renderer = viewRenderers[popperView];
            if (null == renderer) return null;
            const rendererProps = extends_extends({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views,
                timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount
            });
            if (rendererInterceptor) return rendererInterceptor(viewRenderers, popperView, rendererProps);
            return renderer(rendererProps);
        }
    };
};
function getOrientation() {
    if ('undefined' == typeof window) return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return 90 === Math.abs(window.screen.orientation.angle) ? 'landscape' : 'portrait';
    if (window.orientation) return 90 === Math.abs(Number(window.orientation)) ? 'landscape' : 'portrait';
    return 'portrait';
}
const useIsLandscape = (views, customOrientation)=>{
    const [orientation, setOrientation] = __WEBPACK_EXTERNAL_MODULE_react__.useState(getOrientation);
    useEnhancedEffect(()=>{
        const eventHandler = ()=>{
            setOrientation(getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if (arrayIncludes(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return false;
    const orientationToUse = customOrientation || orientation;
    return 'landscape' === orientationToUse;
};
const usePickerLayoutProps = ({ props, propsFromPickerValue, propsFromPickerViews, wrapperVariant })=>{
    const { orientation } = props;
    const isLandscape = useIsLandscape(propsFromPickerViews.views, orientation);
    const layoutProps = extends_extends({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape,
        wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps
    };
};
const buildWarning = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if ('error' === gravity) console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};
const warnRenderInputIsDefined = buildWarning([
    'The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.',
    'You can replace it with the `textField` component slot in most cases.',
    'For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5).'
]);
const usePicker = ({ props, valueManager, valueType, wrapperVariant, additionalViewProps, validator, autoFocusView, rendererInterceptor, fieldRef })=>{
    if ('production' !== process.env.NODE_ENV) {
        if (null != props.renderInput) warnRenderInputIsDefined();
    }
    const pickerValueResponse = usePickerValue({
        props,
        valueManager,
        valueType,
        wrapperVariant,
        validator
    });
    const pickerViewsResponse = usePickerViews({
        props,
        additionalViewProps,
        autoFocusView,
        fieldRef,
        propsFromPickerValue: pickerValueResponse.viewProps,
        rendererInterceptor
    });
    const pickerLayoutResponse = usePickerLayoutProps({
        props,
        wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        layoutProps: pickerLayoutResponse.layoutProps
    };
};
function getPickersLayoutUtilityClass(slot) {
    return generateUtilityClass('MuiPickersLayout', slot);
}
const pickersLayoutClasses = generateUtilityClasses('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);
const PickersActionBar_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
function PickersActionBar(props) {
    const { onAccept, onClear, onCancel, onSetToday, actions } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersActionBar_excluded);
    const localeText = useLocaleText();
    if (null == actions || 0 === actions.length) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogActions_c3764e69__["default"], extends_extends({}, other, {
        children: buttons
    }));
}
"production" !== process.env.NODE_ENV && (PickersActionBar.propTypes = {
    actions: prop_types_default().arrayOf(prop_types_default().oneOf([
        'accept',
        'cancel',
        'clear',
        'today'
    ]).isRequired),
    disableSpacing: prop_types_default().bool,
    onAccept: prop_types_default().func.isRequired,
    onCancel: prop_types_default().func.isRequired,
    onClear: prop_types_default().func.isRequired,
    onSetToday: prop_types_default().func.isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = 336;
const DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;
const PickersShortcuts_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], PickersShortcuts_excluded2 = [
    "getValue"
];
function PickersShortcuts(props) {
    const { items, changeImportance = 'accept', onChange, isValid } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersShortcuts_excluded);
    if (null == items || 0 === items.length) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue } = _ref, item = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, PickersShortcuts_excluded2);
        const newValue = getValue({
            isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_List_e42ad5de__["default"], extends_extends({
        dense: true,
        sx: [
            {
                maxHeight: VIEW_HEIGHT,
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItem_695b112b__["default"], {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Chip_305fde45__["default"], extends_extends({}, item))
            }, item.label))
    }));
}
"production" !== process.env.NODE_ENV && (PickersShortcuts.propTypes = {
    changeImportance: prop_types_default().oneOf([
        'accept',
        'set'
    ]),
    className: prop_types_default().string,
    component: prop_types_default().elementType,
    dense: prop_types_default().bool,
    disablePadding: prop_types_default().bool,
    isLandscape: prop_types_default().bool.isRequired,
    isValid: prop_types_default().func.isRequired,
    items: prop_types_default().arrayOf(prop_types_default().shape({
        getValue: prop_types_default().func.isRequired,
        label: prop_types_default().string.isRequired
    })),
    onChange: prop_types_default().func.isRequired,
    style: prop_types_default().object,
    subheader: prop_types_default().node,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
function toolbarHasView(toolbarProps) {
    return null !== toolbarProps.view;
}
const usePickerLayout_useUtilityClasses = (ownerState)=>{
    const { classes, isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
const usePickerLayout = (props)=>{
    const { wrapperVariant, onAccept, onClear, onCancel, onSetToday, view, views, onViewChange, value, onChange, onSelectShortcut, isValid, isLandscape, disabled, readOnly, children, slots, slotProps } = props;
    const classes = usePickerLayout_useUtilityClasses(props);
    const ActionBar = slots?.actionBar ?? PickersActionBar;
    const actionBarProps = useSlotProps({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            onAccept,
            onClear,
            onCancel,
            onSetToday,
            actions: 'desktop' === wrapperVariant ? [] : [
                'cancel',
                'accept'
            ],
            className: classes.actionBar
        },
        ownerState: extends_extends({}, props, {
            wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ActionBar, extends_extends({}, actionBarProps));
    const Toolbar = slots?.toolbar;
    const toolbarProps = useSlotProps({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        additionalProps: {
            isLandscape,
            onChange,
            value,
            view,
            onViewChange,
            views,
            disabled,
            readOnly,
            className: classes.toolbar
        },
        ownerState: extends_extends({}, props, {
            wrapperVariant
        })
    });
    const toolbar = toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Toolbar, extends_extends({}, toolbarProps)) : null;
    const content = children;
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tabs, extends_extends({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    const Shortcuts = slots?.shortcuts ?? PickersShortcuts;
    const shortcutsProps = useSlotProps({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        additionalProps: {
            isValid,
            isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid,
            isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Shortcuts, extends_extends({}, shortcutsProps)) : null;
    return {
        toolbar,
        content,
        tabs,
        actionBar,
        shortcuts
    };
};
const PickersLayout_usePickerLayout = usePickerLayout;
const PickersLayout_useUtilityClasses = (ownerState)=>{
    const { isLandscape, classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
const PickersLayoutRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>({
        display: 'grid',
        gridAutoColumns: 'max-content auto max-content',
        gridAutoRows: 'max-content auto max-content',
        [`& .${pickersLayoutClasses.actionBar}`]: {
            gridColumn: '1 / 4',
            gridRow: 3
        },
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    [`& .${pickersLayoutClasses.toolbar}`]: {
                        gridColumn: 'rtl' === theme.direction ? 3 : 1,
                        gridRow: '2 / 3'
                    },
                    [`.${pickersLayoutClasses.shortcuts}`]: {
                        gridColumn: '2 / 4',
                        gridRow: 1
                    }
                }
            },
            {
                props: {
                    isLandscape: false
                },
                style: {
                    [`& .${pickersLayoutClasses.toolbar}`]: {
                        gridColumn: '2 / 4',
                        gridRow: 1
                    },
                    [`& .${pickersLayoutClasses.shortcuts}`]: {
                        gridColumn: 'rtl' === theme.direction ? 3 : 1,
                        gridRow: '2 / 3'
                    }
                }
            }
        ]
    }));
PickersLayoutRoot.propTypes = {
    as: prop_types_default().elementType,
    ownerState: prop_types_default().shape({
        isLandscape: prop_types_default().bool.isRequired
    }).isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
};
const PickersLayoutContentWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
const PickersLayout_PickersLayout = function(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar, content, tabs, actionBar, shortcuts } = PickersLayout_usePickerLayout(props);
    const { sx, className, isLandscape, ref, wrapperVariant } = props;
    const ownerState = props;
    const classes = PickersLayout_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersLayoutRoot, {
        ref: ref,
        sx: sx,
        className: dist_clsx(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersLayoutContentWrapper, {
                className: classes.contentWrapper,
                children: 'desktop' === wrapperVariant ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};
"production" !== process.env.NODE_ENV && (PickersLayout_PickersLayout.propTypes = {
    children: prop_types_default().node,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    disabled: prop_types_default().bool,
    isLandscape: prop_types_default().bool.isRequired,
    isValid: prop_types_default().func.isRequired,
    onAccept: prop_types_default().func.isRequired,
    onCancel: prop_types_default().func.isRequired,
    onChange: prop_types_default().func.isRequired,
    onClear: prop_types_default().func.isRequired,
    onClose: prop_types_default().func.isRequired,
    onDismiss: prop_types_default().func.isRequired,
    onOpen: prop_types_default().func.isRequired,
    onSelectShortcut: prop_types_default().func.isRequired,
    onSetToday: prop_types_default().func.isRequired,
    onViewChange: prop_types_default().func.isRequired,
    orientation: prop_types_default().oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().any,
    view: prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired).isRequired,
    wrapperVariant: prop_types_default().oneOf([
        'desktop',
        'mobile'
    ])
});
const useDesktopPicker_excluded = [
    "props",
    "getOpenDialogAriaText"
], useDesktopPicker_excluded2 = [
    "ownerState"
], useDesktopPicker_excluded3 = [
    "ownerState"
];
const useDesktopPicker = (_ref)=>{
    let { props, getOpenDialogAriaText } = _ref, pickerParams = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, useDesktopPicker_excluded);
    const { slots, slotProps: innerSlotProps, className, sx, format, formatDensity, enableAccessibleFieldDOMStructure, selectedSections, onSelectedSectionsChange, timezone, name, label, inputRef, readOnly, disabled, autoFocus, localeText, reduceAnimations } = props;
    const utils = useUtils_useUtils();
    const containerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const fieldRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const labelId = useId();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open, actions, hasUIView, layoutProps, renderCurrentView, shouldRestoreFocus, fieldProps: pickerFieldProps } = usePicker(extends_extends({}, pickerParams, {
        props,
        fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'desktop'
    }));
    const InputAdornment = slots.inputAdornment ?? __WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__["default"];
    const _useSlotProps = useSlotProps({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps?.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: props
    }), inputAdornmentProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps, useDesktopPicker_excluded2);
    const OpenPickerButton = slots.openPickerButton ?? __WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"];
    const _useSlotProps2 = useSlotProps({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps?.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps2, useDesktopPicker_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = useSlotProps({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: extends_extends({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly,
            disabled,
            className,
            sx,
            format,
            formatDensity,
            enableAccessibleFieldDOMStructure,
            selectedSections,
            onSelectedSectionsChange,
            timezone,
            label,
            name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : void 0
        }, inputRef ? {
            inputRef
        } : {}),
        ownerState: props
    });
    if (hasUIView) fieldProps.InputProps = extends_extends({}, fieldProps.InputProps, {
        ref: containerRef,
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InputAdornment, extends_extends({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(OpenPickerButton, extends_extends({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(OpenPickerIcon, extends_extends({}, innerSlotProps?.openPickerIcon))
            }))
        }))
    });
    const slotsForField = extends_extends({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = slots.layout ?? PickersLayout_PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) labelledById = label ? `${labelId}-label` : void 0;
    const slotProps = extends_extends({}, innerSlotProps, {
        toolbar: extends_extends({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: extends_extends({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const handleFieldRef = useForkRef_useForkRef(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(LocalizationProvider_LocalizationProvider, {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Field, extends_extends({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersPopper, extends_extends({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Layout, extends_extends({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker
    };
};
const ArrowDropDownIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const ArrowLeftIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const ArrowRightIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const CalendarIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
(0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
    children: [
        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const DateRangeIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const TimeIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
    children: [
        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const ClearIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
const expandFormat = ({ utils, format })=>{
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.');
    }
    return nextFormat;
};
const getEscapedPartsFromFormat = ({ utils, expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(void 0, timezone), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const createSection = ({ utils, timezone, date, shouldRespectLeadingZeros, localeText, localizedDigits, now, token, startSeparator })=>{
    if ('' === token) throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = getDateSectionConfigFromFormatToken(utils, token);
    const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : 'digit' === sectionConfig.contentType;
    const isValidDate = null != date && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) if (hasLeadingZerosInFormat) maxLength = '' === sectionValue ? utils.formatByString(now, token).length : sectionValue.length;
    else {
        if (null == sectionConfig.maxLength) throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
        maxLength = sectionConfig.maxLength;
        if (isValidDate) sectionValue = applyLocalizedDigits(cleanLeadingZeros(removeLocalizedDigits(sectionValue, localizedDigits), maxLength), localizedDigits);
    }
    return extends_extends({}, sectionConfig, {
        format: token,
        maxLength,
        value: sectionValue,
        placeholder: getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
        hasLeadingZerosInFormat,
        hasLeadingZerosInInput,
        startSeparator,
        endSeparator: '',
        modified: false
    });
};
const buildSections = (params)=>{
    const { utils, expandedFormat, escapedParts } = params;
    const now = utils.date(void 0);
    const sections = [];
    let startSeparator = '';
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length);
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = null != escapedPartOfCurrentChar;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        if (!isEscapedChar && null != firstWordInFormat && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push(createSection(extends_extends({}, params, {
                    now,
                    token: firstWord,
                    startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) if (0 === sections.length) startSeparator += char;
            else sections[sections.length - 1].endSeparator += char;
            i += 1;
        }
    }
    if (0 === sections.length && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const postProcessSections = ({ isRTL, formatDensity, sections })=>sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && null !== cleanedSeparator && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if ('spacious' === formatDensity && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
const buildSectionsFromFormat = (params)=>{
    let expandedFormat = expandFormat(params);
    if (params.isRTL && params.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = getEscapedPartsFromFormat(extends_extends({}, params, {
        expandedFormat
    }));
    const sections = buildSections(extends_extends({}, params, {
        expandedFormat,
        escapedParts
    }));
    return postProcessSections(extends_extends({}, params, {
        sections
    }));
};
const useFieldState = (params)=>{
    const utils = useUtils_useUtils();
    const localeText = useLocaleText();
    const adapter = useLocalizationContext();
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const isRTL = 'rtl' === theme.direction;
    const { valueManager, fieldValueManager, valueType, validator, internalProps, internalProps: { value: valueProp, defaultValue, referenceDate: referenceDateProp, onChange, format, formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange, shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure = false } } = params;
    const { timezone, value: valueFromTheOutside, handleValueChange } = useValueWithTimezone({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange,
        valueManager
    });
    const localizedDigits = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>getLocalizedDigits(utils), [
        utils
    ]);
    const sectionsValueBoundaries = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>getSectionsBoundaries(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date)=>buildSectionsFromFormat({
                utils,
                timezone,
                localeText,
                localizedDigits,
                format,
                date,
                formatDensity,
                shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure,
                isRTL
            })), [
        fieldValueManager,
        format,
        localeText,
        localizedDigits,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        validateSections(sections, valueType);
        const stateWithoutReferenceDate = {
            sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = getSectionTypeGranularity(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils,
            props: internalProps,
            granularity,
            timezone
        });
        return extends_extends({}, stateWithoutReferenceDate, {
            referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = useControlled({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>parseSelectedSections(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = 'all' === parsedSelectedSections ? 0 : parsedSelectedSections;
    const publishValue = ({ value, referenceValue, sections })=>{
        setState((prevState)=>extends_extends({}, prevState, {
                sections,
                value,
                referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter,
                value,
                props: extends_extends({}, internalProps, {
                    value,
                    timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = extends_extends({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (null == activeSectionIndex) return;
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>'' !== section.value).length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === ('' === activeSection.value ? 0 : 1);
        const newSections = setSectionValue(activeSectionIndex, '');
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        publishValue(extends_extends({}, newValues, {
            sections: newSections
        }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (null == date || !utils.isValid(date)) return null;
            const sections = buildSectionsFromFormat({
                utils,
                timezone,
                localeText,
                localizedDigits,
                format,
                date,
                formatDensity,
                shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure,
                isRTL
            });
            return mergeDateIntoReferenceDate(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection, newSectionValue, shouldGoToNextSection })=>{
        if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = getDateFromDateSections(utils, newActiveDateSections, localizedDigits);
        let values;
        let shouldPublish;
        if (null != newActiveDate && utils.isValid(newActiveDate)) {
            const mergedDate = mergeDateIntoReferenceDate(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (null != newActiveDate && !utils.isValid(newActiveDate)) !== (null != activeDateManager.date && !utils.isValid(activeDateManager.date));
        }
        if (shouldPublish) return publishValue(extends_extends({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>extends_extends({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>extends_extends({}, prev, {
                tempValueStrAndroid
            }));
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        validateSections(sections, valueType);
        setState((prevState)=>extends_extends({}, prevState, {
                sections
            }));
    }, [
        format,
        utils.locale,
        isRTL
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        let shouldUpdate;
        shouldUpdate = valueManager.areValuesEqual(utils, state.value, valueFromTheOutside) ? valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside) : true;
        if (shouldUpdate) setState((prevState)=>extends_extends({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]);
    return {
        state,
        activeSectionIndex,
        parsedSelectedSections,
        setSelectedSections,
        clearValue,
        clearActiveSection,
        updateSectionValue,
        updateValueFromValueStr,
        setTempAndroidValueStr,
        getSectionsFromValue,
        sectionsValueBoundaries,
        localizedDigits,
        timezone
    };
};
const QUERY_LIFE_DURATION_MS = 5000;
const isQueryResponseWithoutValue = (response)=>null != response.saveQuery;
const useFieldCharacterEditing = ({ sections, updateSectionValue, sectionsValueBoundaries, localizedDigits, setTempAndroidValueStr, timezone })=>{
    const utils = useUtils_useUtils();
    const [query, setQuery] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null);
    const resetQuery = useEventCallback_useEventCallback(()=>setQuery(null));
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null != query && sections[query.sectionIndex]?.type !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null != query) {
            const timeout = setTimeout(()=>resetQuery(), QUERY_LIFE_DURATION_MS);
            return ()=>{
                clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed, sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        if (null != query && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if (isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if (isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (0 === matchingValues.length) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: 1 === matchingValues.length
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>getLetterEditingOptions(utils, timezone, activeSection.type, format);
            if ('letter' === activeSection.contentType) return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            if (fallbackFormat && null != formatFallbackValue && 'letter' === getDateSectionConfigFromFormatToken(utils, fallbackFormat).contentType) {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if (isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return extends_extends({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>changeSectionValueFormat(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const cleanQueryValue = removeLocalizedDigits(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = 10 * queryValueNumber > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = cleanDigitSectionValue(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if ('digit' === activeSection.contentType || 'digit-with-letter' === activeSection.contentType) return getNewSectionValue(queryValue, activeSection);
            if ('month' === activeSection.type) {
                const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if (isQueryResponseWithoutValue(response)) return response;
                const formattedValue = changeSectionValueFormat(utils, response.sectionValue, 'MM', activeSection.format);
                return extends_extends({}, response, {
                    sectionValue: formattedValue
                });
            }
            if ('weekDay' === activeSection.type) {
                const response = getNewSectionValue(queryValue, activeSection);
                if (isQueryResponseWithoutValue(response)) return response;
                const formattedValue = getDaysInWeekStr(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return extends_extends({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>isStringNumber(queryValue, localizedDigits));
    };
    const applyCharacterEditing = useEventCallback_useEventCallback((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = isStringNumber(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing(extends_extends({}, params, {
            keyPressed: applyLocalizedDigits(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (null == response) return void setTempAndroidValueStr(null);
        updateSectionValue({
            activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};
const useFieldV7TextField = (params)=>{
    const { internalProps: { disabled, readOnly = false }, forwardedProps: { sectionListRef: inSectionListRef, onBlur, onClick, onFocus, onInput, onPaste, focused: focusedProp, autoFocus = false }, fieldValueManager, applyCharacterEditing, resetCharacterQuery, setSelectedSections, parsedSelectedSections, state, clearActiveSection, clearValue, updateSectionValue, updateValueFromValueStr, sectionOrder, areAllSectionsEmpty, sectionsValueBoundaries } = params;
    const sectionListRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleSectionListRef = useForkRef_useForkRef(inSectionListRef, sectionListRef);
    const localeText = useLocaleText();
    const utils = useUtils_useUtils();
    const id = useId();
    const [focused, setFocused] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const interactions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!sectionListRef.current) return;
                const selection = document.getSelection();
                if (!selection) return;
                if (null == parsedSelectedSections) {
                    if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
                    if (focused) sectionListRef.current.getRoot().blur();
                    return;
                }
                if (!sectionListRef.current.getRoot().contains(getActiveElement(document))) return;
                const range = new window.Range();
                let target;
                if ('all' === parsedSelectedSections) target = sectionListRef.current.getRoot();
                else {
                    const section = state.sections[parsedSelectedSections];
                    target = 'empty' === section.type ? sectionListRef.current.getSectionContainer(parsedSelectedSections) : sectionListRef.current.getSectionContent(parsedSelectedSections);
                }
                range.selectNodeContents(target);
                target.focus();
                selection.removeAllRanges();
                selection.addRange(range);
            },
            getActiveSectionIndexFromDOM: ()=>{
                const activeElement = getActiveElement(document);
                if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
                return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
            },
            focusField: (newSelectedSections = 0)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = parseSelectedSections(newSelectedSections, state.sections);
                setFocused(true);
                sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
            },
            setSelectedSections: (newSelectedSections)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = parseSelectedSections(newSelectedSections, state.sections);
                const newActiveSectionIndex = 'all' === newParsedSelectedSections ? 0 : newParsedSelectedSections;
                setFocused(null !== newActiveSectionIndex);
                setSelectedSections(newSelectedSections);
            },
            isFieldFocused: ()=>{
                const activeElement = getActiveElement(document);
                return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
            }
        }), [
        parsedSelectedSections,
        setSelectedSections,
        state.sections,
        focused
    ]);
    const revertDOMSectionChange = useEventCallback_useEventCallback((sectionIndex)=>{
        if (!sectionListRef.current) return;
        const section = state.sections[sectionIndex];
        sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        interactions.syncSelectionToDOM();
    });
    const handleContainerClick = useEventCallback_useEventCallback((event, ...args)=>{
        if (event.isDefaultPrevented() || !sectionListRef.current) return;
        setFocused(true);
        onClick?.(event, ...args);
        if ('all' === parsedSelectedSections) setTimeout(()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (0 === cursorPosition) return void setSelectedSections(sectionOrder.startIndex);
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (focused) {
            const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        } else {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleContainerInput = useEventCallback_useEventCallback((event)=>{
        onInput?.(event);
        if (!sectionListRef.current || 'all' !== parsedSelectedSections) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        sectionListRef.current.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        interactions.syncSelectionToDOM();
        if (0 === keyPressed.length || 10 === keyPressed.charCodeAt(0)) {
            resetCharacterQuery();
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else applyCharacterEditing({
            keyPressed,
            sectionIndex: 0
        });
    });
    const handleContainerPaste = useEventCallback_useEventCallback((event)=>{
        onPaste?.(event);
        if (readOnly || 'all' !== parsedSelectedSections) return void event.preventDefault();
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerFocus = useEventCallback_useEventCallback((...args)=>{
        onFocus?.(...args);
        if (focused || !sectionListRef.current) return;
        setFocused(true);
        const isFocusInsideASection = null != sectionListRef.current.getSectionIndexFromDOMElement(getActiveElement(document));
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerBlur = useEventCallback_useEventCallback((...args)=>{
        onBlur?.(...args);
        setTimeout(()=>{
            if (!sectionListRef.current) return;
            const activeElement = getActiveElement(document);
            const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    const getInputContainerClickHandler = useEventCallback_useEventCallback((sectionIndex)=>(event)=>{
            if (event.isDefaultPrevented() || readOnly) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentMouseUp = useEventCallback_useEventCallback((event)=>{
        event.preventDefault();
    });
    const getInputContentFocusHandler = useEventCallback_useEventCallback((sectionIndex)=>()=>{
            if (readOnly) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentPaste = useEventCallback_useEventCallback((event)=>{
        event.preventDefault();
        if (readOnly || 'number' != typeof parsedSelectedSections) return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = 'letter' === activeSection.contentType && lettersOnly || 'digit' === activeSection.contentType && digitsOnly || 'digit-with-letter' === activeSection.contentType && digitsAndLetterOnly;
        if (isValidPastedValue) {
            resetCharacterQuery();
            updateSectionValue({
                activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            resetCharacterQuery();
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleInputContentDragOver = useEventCallback_useEventCallback((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const handleInputContentInput = useEventCallback_useEventCallback((event)=>{
        if (!sectionListRef.current) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly || !sectionListRef.current) return void revertDOMSectionChange(sectionIndex);
        if (0 === keyPressed.length) {
            if ('' === section.value) return void revertDOMSectionChange(sectionIndex);
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed,
            sectionIndex
        });
        revertDOMSectionChange(sectionIndex);
    });
    useEnhancedEffect(()=>{
        if (!focused || !sectionListRef.current) return;
        if ('all' === parsedSelectedSections) sectionListRef.current.getRoot().focus();
        else if ('number' == typeof parsedSelectedSections) {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    const sectionBoundaries = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>state.sections.reduce((acc, next)=>{
            acc[next.type] = sectionsValueBoundaries[next.type]({
                currentDate: null,
                contentType: next.contentType,
                format: next.format
            });
            return acc;
        }, {}), [
        sectionsValueBoundaries,
        state.sections
    ]);
    const isContainerEditable = 'all' === parsedSelectedSections;
    const elements = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>state.sections.map((section, index)=>{
            const isEditable = !isContainerEditable && !disabled && !readOnly;
            return {
                container: {
                    'data-sectionindex': index,
                    onClick: getInputContainerClickHandler(index)
                },
                content: {
                    tabIndex: isContainerEditable || index > 0 ? -1 : 0,
                    contentEditable: !isContainerEditable && !disabled && !readOnly,
                    role: 'spinbutton',
                    id: `${id}-${section.type}`,
                    'aria-labelledby': `${id}-${section.type}`,
                    'aria-readonly': readOnly,
                    'aria-valuenow': getSectionValueNow(section, utils),
                    'aria-valuemin': sectionBoundaries[section.type].minimum,
                    'aria-valuemax': sectionBoundaries[section.type].maximum,
                    'aria-valuetext': section.value ? getSectionValueText(section, utils) : localeText.empty,
                    'aria-label': localeText[section.type],
                    'aria-disabled': disabled,
                    spellCheck: isEditable ? false : void 0,
                    autoCapitalize: isEditable ? 'off' : void 0,
                    autoCorrect: isEditable ? 'off' : void 0,
                    [parseInt(__WEBPACK_EXTERNAL_MODULE_react__.version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: isEditable ? 'next' : void 0,
                    children: section.value || section.placeholder,
                    onInput: handleInputContentInput,
                    onPaste: handleInputContentPaste,
                    onFocus: getInputContentFocusHandler(index),
                    onDragOver: handleInputContentDragOver,
                    onMouseUp: handleInputContentMouseUp,
                    inputMode: 'letter' === section.contentType ? 'text' : 'numeric'
                },
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator
                }
            };
        }), [
        state.sections,
        getInputContentFocusHandler,
        handleInputContentPaste,
        handleInputContentDragOver,
        handleInputContentInput,
        getInputContainerClickHandler,
        handleInputContentMouseUp,
        disabled,
        readOnly,
        isContainerEditable,
        localeText,
        utils,
        sectionBoundaries,
        id
    ]);
    const handleValueStrChange = useEventCallback_useEventCallback((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null == sectionListRef.current) throw new Error("MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`\nYou probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.\n\nIf you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:\n\n<DatePicker slots={{ textField: MyCustomTextField }} />\n\nLearn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element");
        if (autoFocus && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []);
    return {
        interactions,
        returnedValue: {
            autoFocus,
            readOnly,
            focused: focusedProp ?? focused,
            sectionListRef: handleSectionListRef,
            onBlur: handleContainerBlur,
            onClick: handleContainerClick,
            onFocus: handleContainerFocus,
            onInput: handleContainerInput,
            onPaste: handleContainerPaste,
            enableAccessibleFieldDOMStructure: true,
            elements,
            tabIndex: 0 === parsedSelectedSections ? -1 : 0,
            contentEditable: isContainerEditable,
            value: valueStr,
            onChange: handleValueStrChange,
            areAllSectionsEmpty
        }
    };
};
const cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const addPositionPropertiesToSections = (sections, localizedDigits, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = getSectionVisibleValue(section, isRTL ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        const cleanedValue = cleanString(renderedValue);
        const startInInput = positionInInput + ('' === cleanedValue ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push(extends_extends({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput,
            endInInput
        }));
        position += sectionLength;
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const useFieldV6TextField = (params)=>{
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const isRTL = 'rtl' === theme.direction;
    const focusTimeoutRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const { forwardedProps: { onFocus, onClick, onPaste, onBlur, inputRef: inputRefProp, placeholder: inPlaceholder }, internalProps: { readOnly = false }, parsedSelectedSections, activeSectionIndex, state, fieldValueManager, valueManager, applyCharacterEditing, resetCharacterQuery, updateSectionValue, updateValueFromValueStr, clearActiveSection, clearValue, setTempAndroidValueStr, setSelectedSections, getSectionsFromValue, areAllSectionsEmpty, localizedDigits } = params;
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(inputRefProp, inputRef);
    const sections = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>addPositionPropertiesToSections(state.sections, localizedDigits, isRTL), [
        state.sections,
        localizedDigits,
        isRTL
    ]);
    const interactions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!inputRef.current) return;
                if (null == parsedSelectedSections) {
                    if (inputRef.current.scrollLeft) inputRef.current.scrollLeft = 0;
                    return;
                }
                if (inputRef.current !== getActiveElement(document)) return;
                const currentScrollTop = inputRef.current.scrollTop;
                if ('all' === parsedSelectedSections) inputRef.current.select();
                else {
                    const selectedSection = sections[parsedSelectedSections];
                    const selectionStart = 'empty' === selectedSection.type ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                    const selectionEnd = 'empty' === selectedSection.type ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                        if (inputRef.current === getActiveElement(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    }
                }
                inputRef.current.scrollTop = currentScrollTop;
            },
            getActiveSectionIndexFromDOM: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                const isInputReadOnly = !!inputRef.current?.readOnly;
                if (0 === browserStartIndex && 0 === browserEndIndex || isInputReadOnly) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return -1 === nextSectionIndex ? sections.length - 1 : nextSectionIndex - 1;
            },
            focusField: (newSelectedSection = 0)=>{
                inputRef.current?.focus();
                setSelectedSections(newSelectedSection);
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            isFieldFocused: ()=>inputRef.current === getActiveElement(document)
        }), [
        inputRef,
        parsedSelectedSections,
        sections,
        setSelectedSections
    ]);
    const syncSelectionFromDOM = ()=>{
        if (readOnly) return void setSelectedSections(null);
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 : browserStartIndex >= sections[sections.length - 1].endInInput ? 1 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = -1 === nextSectionIndex ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputFocus = useEventCallback_useEventCallback((...args)=>{
        onFocus?.(...args);
        const input = inputRef.current;
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            if (!input || input !== inputRef.current) return;
            if (null != activeSectionIndex || readOnly) return;
            if (input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = useEventCallback_useEventCallback((event, ...args)=>{
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = useEventCallback_useEventCallback((event)=>{
        onPaste?.(event);
        event.preventDefault();
        if (readOnly) return;
        const pastedValue = event.clipboardData.getData('text');
        if ('number' == typeof parsedSelectedSections) {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = 'letter' === activeSection.contentType && lettersOnly || 'digit' === activeSection.contentType && digitsOnly || 'digit-with-letter' === activeSection.contentType && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) return;
        }
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = useEventCallback_useEventCallback((...args)=>{
        onBlur?.(...args);
        setSelectedSections(null);
    });
    const handleInputChange = useEventCallback_useEventCallback((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if ('' === targetValue) {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = cleanString(valueStr);
        if (null == activeSectionIndex || shouldUseEventData) return void updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
        let keyPressed;
        if ('all' === parsedSelectedSections && 1 === cleanValueStr.length) keyPressed = cleanValueStr;
        else {
            const prevValueStr = cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (-1 === startOfDiffIndex && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (-1 === endOfDiffIndex && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) return;
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (0 === keyPressed.length) {
            if (isAndroid()) setTempAndroidValueStr(valueStr);
            else {
                resetCharacterQuery();
                clearActiveSection();
            }
            return;
        }
        applyCharacterEditing({
            keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const placeholder = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (inPlaceholder) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRTL);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRTL
    ]);
    const valueStr = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRTL), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRTL
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (inputRef.current && inputRef.current === getActiveElement(document)) setSelectedSections('all');
        return ()=>{
            clearTimeout(focusTimeoutRef.current);
        };
    }, []);
    const inputMode = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (null == activeSectionIndex) return 'text';
        if ('letter' === state.sections[activeSectionIndex].contentType) return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === getActiveElement(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    return {
        interactions,
        returnedValue: {
            readOnly,
            onBlur: handleContainerBlur,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onPaste: handleInputPaste,
            inputRef: handleRef,
            enableAccessibleFieldDOMStructure: false,
            placeholder,
            inputMode,
            autoComplete: 'off',
            value: shouldShowPlaceholder ? '' : valueStr,
            onChange: handleInputChange
        }
    };
};
const useField = (params)=>{
    const utils = useUtils_useUtils();
    const { internalProps, internalProps: { unstableFieldRef, minutesStep, enableAccessibleFieldDOMStructure = false, disabled = false, readOnly = false }, forwardedProps: { onKeyDown, error, clearable, onClear }, fieldValueManager, valueManager, validator } = params;
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const isRTL = 'rtl' === theme.direction;
    const stateResponse = useFieldState(params);
    const { state, activeSectionIndex, parsedSelectedSections, setSelectedSections, clearValue, clearActiveSection, updateSectionValue, setTempAndroidValueStr, sectionsValueBoundaries, localizedDigits, timezone } = stateResponse;
    const characterEditingResponse = useFieldCharacterEditing({
        sections: state.sections,
        updateSectionValue,
        sectionsValueBoundaries,
        localizedDigits,
        setTempAndroidValueStr,
        timezone
    });
    const { resetCharacterQuery } = characterEditingResponse;
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const useFieldTextField = enableAccessibleFieldDOMStructure ? useFieldV7TextField : useFieldV6TextField;
    const sectionOrder = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>getSectionOrder(state.sections, isRTL && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRTL,
        enableAccessibleFieldDOMStructure
    ]);
    const { returnedValue, interactions } = useFieldTextField(extends_extends({}, params, stateResponse, characterEditingResponse, {
        areAllSectionsEmpty,
        sectionOrder
    }));
    const handleContainerKeyDown = useEventCallback_useEventCallback((event)=>{
        onKeyDown?.(event);
        switch(true){
            case (event.ctrlKey || event.metaKey) && 'a' === event.key.toLowerCase() && !event.shiftKey && !event.altKey:
                event.preventDefault();
                setSelectedSections('all');
                break;
            case 'Enter' === event.key:
                event.preventDefault();
                break;
            case 'ArrowRight' === event.key:
                event.preventDefault();
                if (null == parsedSelectedSections) setSelectedSections(sectionOrder.startIndex);
                else if ('all' === parsedSelectedSections) setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (null !== nextSectionIndex) setSelectedSections(nextSectionIndex);
                }
                break;
            case 'ArrowLeft' === event.key:
                event.preventDefault();
                if (null == parsedSelectedSections) setSelectedSections(sectionOrder.endIndex);
                else if ('all' === parsedSelectedSections) setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (null !== nextSectionIndex) setSelectedSections(nextSectionIndex);
                }
                break;
            case 'Delete' === event.key:
                event.preventDefault();
                if (readOnly) break;
                if (null == parsedSelectedSections || 'all' === parsedSelectedSections) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || null == activeSectionIndex) break;
                    const activeSection = state.sections[activeSectionIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = adjustSectionValue(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
                        minutesStep
                    });
                    updateSectionValue({
                        activeSection,
                        newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    useEnhancedEffect(()=>{
        interactions.syncSelectionToDOM();
    });
    const validationError = useValidation(extends_extends({}, internalProps, {
        value: state.value,
        timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (void 0 !== error) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!inputError && null == activeSectionIndex) resetCharacterQuery();
    }, [
        state.referenceValue,
        activeSectionIndex,
        inputError
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null != state.tempValueStrAndroid && null != activeSectionIndex) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.sections
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
            setSelectedSections: interactions.setSelectedSections,
            focusField: interactions.focusField,
            isFieldFocused: interactions.isFieldFocused
        }));
    const handleClearValue = useEventCallback_useEventCallback((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (interactions.isFieldFocused()) setSelectedSections(sectionOrder.startIndex);
        else interactions.focusField(0);
    });
    const commonForwardedProps = {
        onKeyDown: handleContainerKeyDown,
        onClear: handleClearValue,
        error: inputError,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    };
    const commonAdditionalProps = {
        disabled,
        readOnly
    };
    return extends_extends({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};
const DATE_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const TIME_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const DATE_TIME_VALIDATION_PROP_NAMES = [
    'minDateTime',
    'maxDateTime'
];
const VALIDATION_PROP_NAMES = [
    ...DATE_VALIDATION_PROP_NAMES,
    ...TIME_VALIDATION_PROP_NAMES,
    ...DATE_TIME_VALIDATION_PROP_NAMES
];
const extractValidationProps = (props)=>VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});
const SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator'
];
const splitFieldInternalAndForwardedProps = (props, valueType)=>{
    const forwardedProps = extends_extends({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if ('date' === valueType) DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
    else if ('time' === valueType) TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
    else if ('date-time' === valueType) {
        DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
        TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
    }
    return {
        forwardedProps,
        internalProps
    };
};
const useDefaultizedDateField = (props)=>{
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    return extends_extends({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? utils.formats.keyboardDate,
        minDate: applyDefaultDate(utils, props.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, props.maxDate, defaultDates.maxDate)
    });
};
const useDefaultizedDateTimeField = (props)=>{
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return extends_extends({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: applyDefaultDate(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
        minTime: props.minDateTime ?? props.minTime,
        maxTime: props.maxDateTime ?? props.maxTime
    });
};
const useDateField = (inProps)=>{
    const props = useDefaultizedDateField(inProps);
    const { forwardedProps, internalProps } = splitFieldInternalAndForwardedProps(props, 'date');
    return useField({
        forwardedProps,
        internalProps,
        valueManager: singleItemValueManager,
        fieldValueManager: singleItemFieldValueManager,
        validator: validateDate,
        valueType: 'date'
    });
};
const useClearableField_excluded = [
    "clearable",
    "onClear",
    "InputProps",
    "sx",
    "slots",
    "slotProps"
], useClearableField_excluded2 = [
    "ownerState"
];
const useClearableField = (props)=>{
    const localeText = useLocaleText();
    const { clearable, onClear, InputProps, sx, slots, slotProps } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, useClearableField_excluded);
    const IconButton = slots?.clearButton ?? __WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"];
    const _useSlotProps = useSlotProps({
        elementType: IconButton,
        externalSlotProps: slotProps?.clearButton,
        ownerState: {},
        className: 'clearButton',
        additionalProps: {
            title: localeText.fieldClearLabel
        }
    }), iconButtonProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps, useClearableField_excluded2);
    const EndClearIcon = slots?.clearIcon ?? ClearIcon;
    const endClearIconProps = useSlotProps({
        elementType: EndClearIcon,
        externalSlotProps: slotProps?.clearIcon,
        ownerState: {}
    });
    return extends_extends({}, other, {
        InputProps: extends_extends({}, InputProps, {
            endAdornment: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                children: [
                    clearable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__["default"], {
                        position: "end",
                        sx: {
                            marginRight: InputProps?.endAdornment ? -1 : -1.5
                        },
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconButton, extends_extends({}, iconButtonProps, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EndClearIcon, extends_extends({
                                fontSize: "small"
                            }, endClearIconProps))
                        }))
                    }),
                    InputProps?.endAdornment
                ]
            })
        }),
        sx: [
            {
                '& .clearButton': {
                    opacity: 1
                },
                '@media (pointer: fine)': {
                    '& .clearButton': {
                        opacity: 0
                    },
                    '&:hover, &:focus-within': {
                        '.clearButton': {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
};
function getPickersTextFieldUtilityClass(slot) {
    return generateUtilityClass('MuiPickersTextField', slot);
}
generateUtilityClasses('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);
function getPickersInputBaseUtilityClass(slot) {
    return generateUtilityClass('MuiPickersInputBase', slot);
}
const pickersInputBaseClasses = generateUtilityClasses('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input'
]);
function getPickersOutlinedInputUtilityClass(slot) {
    return generateUtilityClass('MuiPickersOutlinedInput', slot);
}
const pickersOutlinedInputClasses = extends_extends({}, pickersInputBaseClasses, generateUtilityClasses('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
const Outline_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const OutlineRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme })=>{
    const borderColor = 'light' === theme.palette.mode ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const OutlineLabel = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('span')(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const OutlineLegend = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('legend')(({ theme })=>({
        float: 'unset',
        width: 'auto',
        overflow: 'hidden',
        variants: [
            {
                props: {
                    withLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    withLabel: true
                },
                style: {
                    display: 'block',
                    padding: 0,
                    height: 11,
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    withLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function Outline(props) {
    const { className, label } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, Outline_excluded);
    const withLabel = null != label && '' !== label;
    const ownerState = extends_extends({}, props, {
        withLabel
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(OutlineRoot, extends_extends({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(OutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}
function formatMuiErrorMessage(code) {
    let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
}
function capitalize(string) {
    if ('string' != typeof string) throw new Error("production" !== process.env.NODE_ENV ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
const visuallyHidden_visuallyHidden = visuallyHidden;
function getPickersSectionListUtilityClass(slot) {
    return generateUtilityClass('MuiPickersSectionList', slot);
}
const pickersSectionListClasses = generateUtilityClasses('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);
const PickersSectionList_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef"
];
const PickersSectionListRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const PickersSectionListSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section',
    overridesResolver: (props, styles)=>styles.section
})({});
const PickersSectionListSectionSeparator = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator',
    overridesResolver: (props, styles)=>styles.sectionSeparator
})({
    whiteSpace: 'pre'
});
const PickersSectionListSectionContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.sectionContent
})({
    outline: 'none'
});
const PickersSectionList_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return composeClasses(slots, getPickersSectionListUtilityClass, classes);
};
function PickersSection(props) {
    const { slots, slotProps, element, classes } = props;
    const Section = slots?.section ?? PickersSectionListSection;
    const sectionProps = useSlotProps({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: {}
    });
    const SectionContent = slots?.sectionContent ?? PickersSectionListSectionContent;
    const sectionContentProps = useSlotProps({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: {}
    });
    const SectionSeparator = slots?.sectionSeparator ?? PickersSectionListSectionSeparator;
    const sectionSeparatorBeforeProps = useSlotProps({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: {
            position: 'before'
        }
    });
    const sectionSeparatorAfterProps = useSlotProps({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: {
            position: 'after'
        }
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Section, extends_extends({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SectionSeparator, extends_extends({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SectionContent, extends_extends({}, sectionContentProps)),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SectionSeparator, extends_extends({}, sectionSeparatorAfterProps))
        ]
    }));
}
const PickersSectionList_PickersSectionList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots, slotProps, elements, sectionListRef } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersSectionList_excluded);
    const classes = PickersSectionList_useUtilityClasses(props);
    const rootRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRootRef = useForkRef_useForkRef(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${index}"] .${pickersSectionListClasses.sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (null == element || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains(pickersSectionListClasses.section)) sectionContainer = element;
                else if (element.classList.contains(pickersSectionListClasses.sectionContent)) sectionContainer = element.parentElement;
                if (null == sectionContainer) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? PickersSectionListRoot;
    const rootProps = useSlotProps({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: {}
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Root, extends_extends({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content, before, after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});
"production" !== process.env.NODE_ENV && (PickersSectionList_PickersSectionList.propTypes = {
    classes: prop_types_default().object,
    contentEditable: prop_types_default().bool.isRequired,
    elements: prop_types_default().arrayOf(prop_types_default().shape({
        after: prop_types_default().object.isRequired,
        before: prop_types_default().object.isRequired,
        container: prop_types_default().object.isRequired,
        content: prop_types_default().object.isRequired
    })).isRequired,
    sectionListRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                getRoot: prop_types_default().func.isRequired,
                getSectionContainer: prop_types_default().func.isRequired,
                getSectionContent: prop_types_default().func.isRequired,
                getSectionIndexFromDOMElement: prop_types_default().func.isRequired
            })
        })
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object
});
const PickersInputBase_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef"
];
const round = (value)=>Math.round(1e5 * value) / 1e5;
const PickersInputBaseRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>extends_extends({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        letterSpacing: `${round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const PickersInputBaseSectionsContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersSectionListRoot, {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})(({ theme })=>extends_extends({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        width: '182px'
    }, 'rtl' === theme.direction && {
        textAlign: 'right /*! @noflip */'
    }, {
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    adornedStart: false,
                    focused: false,
                    filled: false
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: ({ adornedStart, focused, filled, label })=>!adornedStart && !focused && !filled && null == label,
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: 'light' === theme.palette.mode ? 0.42 : 0.5
                }
            }
        ]
    }));
const PickersInputBaseSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersSectionListSection, {
    name: 'MuiPickersInputBase',
    slot: 'Section',
    overridesResolver: (props, styles)=>styles.section
})(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        display: 'flex'
    }));
const PickersInputBaseSectionContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersSectionListSectionContent, {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content
})(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const PickersInputBaseSectionSeparator = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersSectionListSectionSeparator, {
    name: 'MuiPickersInputBase',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const PickersInputBaseInput = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput
})(extends_extends({}, visuallyHidden_visuallyHidden));
const PickersInputBase_useUtilityClasses = (ownerState)=>{
    const { focused, disabled, error, classes, fullWidth, readOnly, color, size, endAdornment, startAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            focused && !disabled && 'focused',
            disabled && 'disabled',
            readOnly && 'readOnly',
            error && 'error',
            fullWidth && 'fullWidth',
            `color${capitalize(color)}`,
            'small' === size && 'inputSizeSmall',
            Boolean(startAdornment) && 'adornedStart',
            Boolean(endAdornment) && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ]
    };
    return composeClasses(slots, getPickersInputBaseUtilityClass, classes);
};
const PickersInputBase_PickersInputBase = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements, areAllSectionsEmpty, value, onChange, id, endAdornment, startAdornment, renderSuffix, slots, slotProps, contentEditable, tabIndex, onInput, onPaste, onKeyDown, name, readOnly, inputProps, inputRef, sectionListRef } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersInputBase_excluded);
    const rootRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRootRef = useForkRef_useForkRef(ref, rootRef);
    const handleInputRef = useForkRef_useForkRef(inputProps?.ref, inputRef);
    const muiFormControl = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__.useFormControl)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const handleInputFocus = (event)=>{
        if (muiFormControl.disabled) return void event.stopPropagation();
        muiFormControl.onFocus?.(event);
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const ownerState = extends_extends({}, props, muiFormControl);
    const classes = PickersInputBase_useUtilityClasses(ownerState);
    const InputRoot = slots?.root || PickersInputBaseRoot;
    const inputRootProps = useSlotProps({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState
    });
    const InputSectionsContainer = slots?.input || PickersInputBaseSectionsContainer;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(InputRoot, extends_extends({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersSectionList_PickersSectionList, {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: muiFormControl.onBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: PickersInputBaseSection,
                    sectionContent: PickersInputBaseSectionContent,
                    sectionSeparator: PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: {
                        ownerState
                    },
                    sectionContent: {
                        className: pickersInputBaseClasses.sectionContent
                    },
                    sectionSeparator: ({ position })=>({
                            className: 'before' === position ? pickersInputBaseClasses.sectionBefore : pickersInputBaseClasses.sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix(extends_extends({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersInputBaseInput, extends_extends({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled
            }, inputProps, {
                ref: handleInputRef
            }))
        ]
    }));
});
"production" !== process.env.NODE_ENV && (PickersInputBase_PickersInputBase.propTypes = {
    areAllSectionsEmpty: prop_types_default().bool.isRequired,
    className: prop_types_default().string,
    component: prop_types_default().elementType,
    contentEditable: prop_types_default().bool.isRequired,
    elements: prop_types_default().arrayOf(prop_types_default().shape({
        after: prop_types_default().object.isRequired,
        before: prop_types_default().object.isRequired,
        container: prop_types_default().object.isRequired,
        content: prop_types_default().object.isRequired
    })).isRequired,
    endAdornment: prop_types_default().node,
    fullWidth: prop_types_default().bool,
    id: prop_types_default().string,
    inputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    name: prop_types_default().string,
    onChange: prop_types_default().func.isRequired,
    onClick: prop_types_default().func.isRequired,
    onInput: prop_types_default().func.isRequired,
    onKeyDown: prop_types_default().func.isRequired,
    onPaste: prop_types_default().func.isRequired,
    ownerState: prop_types_default().any,
    readOnly: prop_types_default().bool,
    renderSuffix: prop_types_default().func,
    sectionListRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                getRoot: prop_types_default().func.isRequired,
                getSectionContainer: prop_types_default().func.isRequired,
                getSectionContent: prop_types_default().func.isRequired,
                getSectionIndexFromDOMElement: prop_types_default().func.isRequired
            })
        })
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    startAdornment: prop_types_default().node,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().string.isRequired
});
const PickersOutlinedInput_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "notched"
];
const PickersOutlinedInputRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersInputBaseRoot, {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>{
    const borderColor = 'light' === theme.palette.mode ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        '@media (hover: none)': {
            [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${pickersOutlinedInputClasses.focused} .${pickersOutlinedInputClasses.notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${pickersOutlinedInputClasses.disabled}`]: {
            [`& .${pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${pickersOutlinedInputClasses.error} .${pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette).filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                props: {
                    color
                },
                style: {
                    [`&.${pickersOutlinedInputClasses.focused}:not(.${pickersOutlinedInputClasses.error}) .${pickersOutlinedInputClasses.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const PickersOutlinedInputSectionsContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersInputBaseSectionsContainer, {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const PickersOutlinedInput_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = composeClasses(slots, getPickersOutlinedInputUtilityClass, classes);
    return extends_extends({}, classes, composedClasses);
};
const PickersOutlinedInput_PickersOutlinedInput = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label, ownerState: ownerStateProp, notched } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersOutlinedInput_excluded);
    const muiFormControl = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__.useFormControl)();
    const ownerState = extends_extends({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || 'primary'
    });
    const classes = PickersOutlinedInput_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersInputBase_PickersInputBase, extends_extends({
        slots: {
            root: PickersOutlinedInputRoot,
            input: PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Outline, {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: null != label && '' !== label && muiFormControl?.required ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label,
                ownerState: ownerState
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
"production" !== process.env.NODE_ENV && (PickersOutlinedInput_PickersOutlinedInput.propTypes = {
    areAllSectionsEmpty: prop_types_default().bool.isRequired,
    className: prop_types_default().string,
    component: prop_types_default().elementType,
    contentEditable: prop_types_default().bool.isRequired,
    elements: prop_types_default().arrayOf(prop_types_default().shape({
        after: prop_types_default().object.isRequired,
        before: prop_types_default().object.isRequired,
        container: prop_types_default().object.isRequired,
        content: prop_types_default().object.isRequired
    })).isRequired,
    endAdornment: prop_types_default().node,
    fullWidth: prop_types_default().bool,
    id: prop_types_default().string,
    inputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    name: prop_types_default().string,
    notched: prop_types_default().bool,
    onChange: prop_types_default().func.isRequired,
    onClick: prop_types_default().func.isRequired,
    onInput: prop_types_default().func.isRequired,
    onKeyDown: prop_types_default().func.isRequired,
    onPaste: prop_types_default().func.isRequired,
    ownerState: prop_types_default().any,
    readOnly: prop_types_default().bool,
    renderSuffix: prop_types_default().func,
    sectionListRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                getRoot: prop_types_default().func.isRequired,
                getSectionContainer: prop_types_default().func.isRequired,
                getSectionContent: prop_types_default().func.isRequired,
                getSectionIndexFromDOMElement: prop_types_default().func.isRequired
            })
        })
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    startAdornment: prop_types_default().node,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().string.isRequired
});
PickersOutlinedInput_PickersOutlinedInput.muiName = 'Input';
function getPickersFilledInputUtilityClass(slot) {
    return generateUtilityClass('MuiPickersFilledInput', slot);
}
const pickersFilledInputClasses = extends_extends({}, pickersInputBaseClasses, generateUtilityClasses('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));
const PickersFilledInput_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const PickersFilledInputRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersInputBaseRoot, {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.shouldForwardProp)(prop) && 'disableUnderline' !== prop
})(({ theme })=>{
    const light = 'light' === theme.palette.mode;
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${pickersFilledInputClasses.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${pickersFilledInputClasses.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette).filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none'
                    },
                    [`&.${pickersFilledInputClasses.focused}:after`]: {
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${pickersFilledInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none'
                    },
                    [`&:hover:not(.${pickersFilledInputClasses.disabled}, .${pickersFilledInputClasses.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${pickersFilledInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: ({ startAdornment })=>!!startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ endAdornment })=>!!endAdornment,
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const PickersFilledSectionsContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersInputBaseSectionsContainer, {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: ({ startAdornment })=>!!startAdornment,
            style: {
                paddingLeft: 0
            }
        },
        {
            props: ({ endAdornment })=>!!endAdornment,
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                size: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const PickersFilledInput_useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = composeClasses(slots, getPickersFilledInputUtilityClass, classes);
    return extends_extends({}, classes, composedClasses);
};
const PickersFilledInput_PickersFilledInput = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label, disableUnderline = false, ownerState: ownerStateProp } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersFilledInput_excluded);
    const muiFormControl = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__.useFormControl)();
    const ownerState = extends_extends({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || 'primary'
    });
    const classes = PickersFilledInput_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersInputBase_PickersInputBase, extends_extends({
        slots: {
            root: PickersFilledInputRoot,
            input: PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
"production" !== process.env.NODE_ENV && (PickersFilledInput_PickersFilledInput.propTypes = {
    areAllSectionsEmpty: prop_types_default().bool.isRequired,
    className: prop_types_default().string,
    component: prop_types_default().elementType,
    contentEditable: prop_types_default().bool.isRequired,
    disableUnderline: prop_types_default().bool,
    elements: prop_types_default().arrayOf(prop_types_default().shape({
        after: prop_types_default().object.isRequired,
        before: prop_types_default().object.isRequired,
        container: prop_types_default().object.isRequired,
        content: prop_types_default().object.isRequired
    })).isRequired,
    endAdornment: prop_types_default().node,
    fullWidth: prop_types_default().bool,
    hiddenLabel: prop_types_default().bool,
    id: prop_types_default().string,
    inputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    name: prop_types_default().string,
    onChange: prop_types_default().func.isRequired,
    onClick: prop_types_default().func.isRequired,
    onInput: prop_types_default().func.isRequired,
    onKeyDown: prop_types_default().func.isRequired,
    onPaste: prop_types_default().func.isRequired,
    ownerState: prop_types_default().any,
    readOnly: prop_types_default().bool,
    renderSuffix: prop_types_default().func,
    sectionListRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                getRoot: prop_types_default().func.isRequired,
                getSectionContainer: prop_types_default().func.isRequired,
                getSectionContent: prop_types_default().func.isRequired,
                getSectionIndexFromDOMElement: prop_types_default().func.isRequired
            })
        })
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    startAdornment: prop_types_default().node,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().string.isRequired
});
PickersFilledInput_PickersFilledInput.muiName = 'Input';
function getPickersInputUtilityClass(slot) {
    return generateUtilityClass('MuiPickersFilledInput', slot);
}
const pickersInputClasses = extends_extends({}, pickersInputBaseClasses, generateUtilityClasses('MuiPickersInput', [
    'root',
    'input'
]));
const PickersInput_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const PickersInputRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersInputBaseRoot, {
    name: 'MuiPickersInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>{
    const light = 'light' === theme.palette.mode;
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette).filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none'
                    },
                    [`&.${pickersInputClasses.focused}:after`]: {
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${pickersInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none'
                    },
                    [`&:hover:not(.${pickersInputClasses.disabled}, .${pickersInputClasses.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${pickersInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const PickersInput_useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = composeClasses(slots, getPickersInputUtilityClass, classes);
    return extends_extends({}, classes, composedClasses);
};
const PickersInput_PickersInput = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label, disableUnderline = false, ownerState: ownerStateProp } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersInput_excluded);
    const muiFormControl = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__.useFormControl)();
    const ownerState = extends_extends({}, props, ownerStateProp, muiFormControl, {
        disableUnderline,
        color: muiFormControl?.color || 'primary'
    });
    const classes = PickersInput_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersInputBase_PickersInputBase, extends_extends({
        slots: {
            root: PickersInputRoot
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
"production" !== process.env.NODE_ENV && (PickersInput_PickersInput.propTypes = {
    areAllSectionsEmpty: prop_types_default().bool.isRequired,
    className: prop_types_default().string,
    component: prop_types_default().elementType,
    contentEditable: prop_types_default().bool.isRequired,
    disableUnderline: prop_types_default().bool,
    elements: prop_types_default().arrayOf(prop_types_default().shape({
        after: prop_types_default().object.isRequired,
        before: prop_types_default().object.isRequired,
        container: prop_types_default().object.isRequired,
        content: prop_types_default().object.isRequired
    })).isRequired,
    endAdornment: prop_types_default().node,
    fullWidth: prop_types_default().bool,
    id: prop_types_default().string,
    inputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    name: prop_types_default().string,
    onChange: prop_types_default().func.isRequired,
    onClick: prop_types_default().func.isRequired,
    onInput: prop_types_default().func.isRequired,
    onKeyDown: prop_types_default().func.isRequired,
    onPaste: prop_types_default().func.isRequired,
    ownerState: prop_types_default().any,
    readOnly: prop_types_default().bool,
    renderSuffix: prop_types_default().func,
    sectionListRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                getRoot: prop_types_default().func.isRequired,
                getSectionContainer: prop_types_default().func.isRequired,
                getSectionContent: prop_types_default().func.isRequired,
                getSectionIndexFromDOMElement: prop_types_default().func.isRequired
            })
        })
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    startAdornment: prop_types_default().node,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().string.isRequired
});
PickersInput_PickersInput.muiName = 'Input';
const PickersTextField_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps"
];
const VARIANT_COMPONENT = {
    standard: PickersInput_PickersInput,
    filled: PickersFilledInput_PickersFilledInput,
    outlined: PickersOutlinedInput_PickersOutlinedInput
};
const PickersTextFieldRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__["default"], {
    name: 'MuiPickersTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const PickersTextField_useUtilityClasses = (ownerState)=>{
    const { focused, disabled, classes, required } = ownerState;
    const slots = {
        root: [
            'root',
            focused && !disabled && 'focused',
            disabled && 'disabled',
            required && 'required'
        ]
    };
    return composeClasses(slots, getPickersTextFieldUtilityClass, classes);
};
const PickersTextField_PickersTextField = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus, onBlur, className, color = 'primary', disabled = false, error = false, variant = 'outlined', required = false, InputProps, inputProps, inputRef, sectionListRef, elements, areAllSectionsEmpty, onClick, onKeyDown, onPaste, onInput, endAdornment, startAdornment, tabIndex, contentEditable, focused, value, onChange, fullWidth, id: idProp, name, helperText, FormHelperTextProps, label, InputLabelProps } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersTextField_excluded);
    const rootRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRootRef = useForkRef_useForkRef(ref, rootRef);
    const id = useId(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
    const inputLabelId = label && id ? `${id}-label` : void 0;
    const ownerState = extends_extends({}, props, {
        color,
        disabled,
        error,
        focused,
        required,
        variant
    });
    const classes = PickersTextField_useUtilityClasses(ownerState);
    const PickersInputComponent = VARIANT_COMPONENT[variant];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersTextFieldRoot, extends_extends({
        className: dist_clsx(classes.root, className),
        ref: handleRootRef,
        focused: focused,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        variant: variant,
        error: error,
        color: color,
        fullWidth: fullWidth,
        required: required,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputLabel_cf26b488__["default"], extends_extends({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersInputComponent, extends_extends({
                elements: elements,
                areAllSectionsEmpty: areAllSectionsEmpty,
                onClick: onClick,
                onKeyDown: onKeyDown,
                onInput: onInput,
                onPaste: onPaste,
                endAdornment: endAdornment,
                startAdornment: startAdornment,
                tabIndex: tabIndex,
                contentEditable: contentEditable,
                value: value,
                onChange: onChange,
                id: id,
                fullWidth: fullWidth,
                inputProps: inputProps,
                inputRef: inputRef,
                sectionListRef: sectionListRef,
                label: label,
                name: name,
                role: "group",
                "aria-labelledby": inputLabelId
            }, InputProps)),
            helperText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormHelperText_3b87fa55__["default"], extends_extends({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
"production" !== process.env.NODE_ENV && (PickersTextField_PickersTextField.propTypes = {
    areAllSectionsEmpty: prop_types_default().bool.isRequired,
    className: prop_types_default().string,
    color: prop_types_default().oneOf([
        'error',
        'info',
        'primary',
        'secondary',
        'success',
        'warning'
    ]),
    component: prop_types_default().elementType,
    contentEditable: prop_types_default().bool.isRequired,
    disabled: prop_types_default().bool.isRequired,
    elements: prop_types_default().arrayOf(prop_types_default().shape({
        after: prop_types_default().object.isRequired,
        before: prop_types_default().object.isRequired,
        container: prop_types_default().object.isRequired,
        content: prop_types_default().object.isRequired
    })).isRequired,
    endAdornment: prop_types_default().node,
    error: prop_types_default().bool.isRequired,
    focused: prop_types_default().bool,
    FormHelperTextProps: prop_types_default().object,
    fullWidth: prop_types_default().bool,
    helperText: prop_types_default().node,
    hiddenLabel: prop_types_default().bool,
    id: prop_types_default().string,
    InputLabelProps: prop_types_default().object,
    inputProps: prop_types_default().object,
    InputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    name: prop_types_default().string,
    onBlur: prop_types_default().func.isRequired,
    onChange: prop_types_default().func.isRequired,
    onClick: prop_types_default().func.isRequired,
    onFocus: prop_types_default().func.isRequired,
    onInput: prop_types_default().func.isRequired,
    onKeyDown: prop_types_default().func.isRequired,
    onPaste: prop_types_default().func.isRequired,
    readOnly: prop_types_default().bool,
    required: prop_types_default().bool,
    sectionListRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                getRoot: prop_types_default().func.isRequired,
                getSectionContainer: prop_types_default().func.isRequired,
                getSectionContent: prop_types_default().func.isRequired,
                getSectionIndexFromDOMElement: prop_types_default().func.isRequired
            })
        })
    ]),
    size: prop_types_default().oneOf([
        'medium',
        'small'
    ]),
    startAdornment: prop_types_default().node,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().string.isRequired,
    variant: prop_types_default().oneOf([
        'filled',
        'outlined',
        'standard'
    ])
});
const convertFieldResponseIntoMuiTextFieldProps_excluded = [
    "enableAccessibleFieldDOMStructure"
], convertFieldResponseIntoMuiTextFieldProps_excluded2 = [
    "InputProps",
    "readOnly"
], convertFieldResponseIntoMuiTextFieldProps_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef"
];
const convertFieldResponseIntoMuiTextFieldProps = (_ref)=>{
    let { enableAccessibleFieldDOMStructure } = _ref, fieldResponse = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, convertFieldResponseIntoMuiTextFieldProps_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps, readOnly } = fieldResponse, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(fieldResponse, convertFieldResponseIntoMuiTextFieldProps_excluded2);
        return extends_extends({}, other, {
            InputProps: extends_extends({}, InputProps ?? {}, {
                readOnly
            })
        });
    }
    const { onPaste, onKeyDown, inputMode, readOnly, InputProps, inputProps, inputRef } = fieldResponse, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(fieldResponse, convertFieldResponseIntoMuiTextFieldProps_excluded3);
    return extends_extends({}, other, {
        InputProps: extends_extends({}, InputProps ?? {}, {
            readOnly
        }),
        inputProps: extends_extends({}, inputProps ?? {}, {
            inputMode,
            onPaste,
            onKeyDown,
            ref: inputRef
        })
    });
};
const DateField_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
const DateField_DateField = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, inRef) {
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots, slotProps, InputProps, inputProps } = themeProps, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(themeProps, DateField_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? PickersTextField_PickersTextField : __WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"]);
    const textFieldProps = useSlotProps({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        additionalProps: {
            ref: inRef
        },
        ownerState
    });
    textFieldProps.inputProps = extends_extends({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = extends_extends({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = useDateField(textFieldProps);
    const convertedFieldResponse = convertFieldResponseIntoMuiTextFieldProps(fieldResponse);
    const processedFieldProps = useClearableField(extends_extends({}, convertedFieldResponse, {
        slots,
        slotProps
    }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TextField, extends_extends({}, processedFieldProps));
});
"production" !== process.env.NODE_ENV && (DateField_DateField.propTypes = {
    autoFocus: prop_types_default().bool,
    className: prop_types_default().string,
    clearable: prop_types_default().bool,
    color: prop_types_default().oneOf([
        'error',
        'info',
        'primary',
        'secondary',
        'success',
        'warning'
    ]),
    component: prop_types_default().elementType,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    enableAccessibleFieldDOMStructure: prop_types_default().bool,
    focused: prop_types_default().bool,
    format: prop_types_default().string,
    formatDensity: prop_types_default().oneOf([
        'dense',
        'spacious'
    ]),
    FormHelperTextProps: prop_types_default().object,
    fullWidth: prop_types_default().bool,
    helperText: prop_types_default().node,
    hiddenLabel: prop_types_default().bool,
    id: prop_types_default().string,
    InputLabelProps: prop_types_default().object,
    inputProps: prop_types_default().object,
    InputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    maxDate: prop_types_default().object,
    minDate: prop_types_default().object,
    name: prop_types_default().string,
    onBlur: prop_types_default().func,
    onChange: prop_types_default().func,
    onClear: prop_types_default().func,
    onError: prop_types_default().func,
    onFocus: prop_types_default().func,
    onSelectedSectionsChange: prop_types_default().func,
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    required: prop_types_default().bool,
    selectedSections: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        prop_types_default().number
    ]),
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    shouldRespectLeadingZeros: prop_types_default().bool,
    size: prop_types_default().oneOf([
        'medium',
        'small'
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    unstableFieldRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().object,
    variant: prop_types_default().oneOf([
        'filled',
        'outlined',
        'standard'
    ])
});
const useIsDateDisabled = ({ shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone })=>{
    const adapter = useLocalizationContext();
    return __WEBPACK_EXTERNAL_MODULE_react__.useCallback((day)=>null !== validateDate({
            adapter,
            value: day,
            props: {
                shouldDisableDate,
                shouldDisableMonth,
                shouldDisableYear,
                minDate,
                maxDate,
                disableFuture,
                disablePast,
                timezone
            }
        }), [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};
const createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return extends_extends({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return extends_extends({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (null != state.focusedDay && null != action.focusedDay && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = null != action.focusedDay && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return extends_extends({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: null != action.focusedDay && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const useCalendarState = (params)=>{
    const { value, referenceDate: referenceDateProp, disableFuture, disablePast, disableSwitchToMonthOnDayFocus = false, maxDate, minDate, onMonthChange, reduceAnimations, shouldDisableDate, timezone } = params;
    const utils = useUtils_useUtils();
    const reducerFn = __WEBPACK_EXTERNAL_MODULE_react__.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>singleItemValueManager.getInitialReferenceValue({
            value,
            utils,
            timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: SECTION_TYPE_GRANULARITY.day
        }), []);
    const [calendarState, dispatch] = __WEBPACK_EXTERNAL_MODULE_react__.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const handleChangeMonth = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((payload)=>{
        dispatch(extends_extends({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = useIsDateDisabled({
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    });
    const onMonthSwitchingAnimationEnd = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = useEventCallback_useEventCallback((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate,
        calendarState,
        changeMonth,
        changeFocusedDay,
        isDateDisabled,
        onMonthSwitchingAnimationEnd,
        handleChangeMonth
    };
};
function esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded) {
    if (null == source) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) target[key] = source[key];
    }
    return target;
}
function esm_extends_extends() {
    esm_extends_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return esm_extends_extends.apply(this, arguments);
}
function _assertThisInitialized(self1) {
    if (void 0 === self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function setPrototypeOf_setPrototypeOf(o, p) {
    setPrototypeOf_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return setPrototypeOf_setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf_setPrototypeOf(subClass, superClass);
}
const TransitionGroupContext = __WEBPACK_EXTERNAL_MODULE_react__["default"].createContext(null);
function getChildMapping(children, mapFn) {
    var mapper = function(child) {
        return mapFn && (0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) __WEBPACK_EXTERNAL_MODULE_react__.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    }
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev)if (prevKey in next) {
        if (pendingKeys.length) {
            nextKeysPending[prevKey] = pendingKeys;
            pendingKeys = [];
        }
    } else pendingKeys.push(prevKey);
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return null != props[prop] ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, __WEBPACK_EXTERNAL_MODULE_react__.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(prevChild) && !prevChild.props.in;
        if (hasNext && (!hasPrev || isLeaving)) children[key] = (0, __WEBPACK_EXTERNAL_MODULE_react__.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (hasNext || !hasPrev || isLeaving) {
            if (hasNext && hasPrev && (0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(prevChild)) children[key] = (0, __WEBPACK_EXTERNAL_MODULE_react__.cloneElement)(child, {
                onExited: onExited.bind(null, child),
                in: prevChild.props.in,
                exit: getProp(child, 'exit', nextProps),
                enter: getProp(child, 'enter', nextProps)
            });
        } else children[key] = (0, __WEBPACK_EXTERNAL_MODULE_react__.cloneElement)(child, {
            in: false
        });
    });
    return children;
}
var TransitionGroup_values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var TransitionGroup_defaultProps = {
    component: 'div',
    childFactory: function(child) {
        return child;
    }
};
var TransitionGroup_TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function(child, node) {
        var currentChildMapping = getChildMapping(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = esm_extends_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = TransitionGroup_values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (null === Component) return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(TransitionGroupContext.Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(TransitionGroupContext.Provider, {
            value: contextValue
        }, /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(Component, props, children));
    };
    return TransitionGroup;
}(__WEBPACK_EXTERNAL_MODULE_react__["default"].Component);
TransitionGroup_TransitionGroup.propTypes = "production" !== process.env.NODE_ENV ? {
    component: prop_types_default().any,
    children: prop_types_default().node,
    appear: prop_types_default().bool,
    enter: prop_types_default().bool,
    exit: prop_types_default().bool,
    childFactory: prop_types_default().func
} : {};
TransitionGroup_TransitionGroup.defaultProps = TransitionGroup_defaultProps;
const esm_TransitionGroup = TransitionGroup_TransitionGroup;
const getPickersFadeTransitionGroupUtilityClass = (slot)=>generateUtilityClass('MuiPickersFadeTransitionGroup', slot);
generateUtilityClasses('MuiPickersFadeTransitionGroup', [
    'root'
]);
const PickersFadeTransitionGroup_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
const PickersFadeTransitionGroupRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(esm_TransitionGroup, {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function PickersFadeTransitionGroup(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children, className, reduceAnimations, transKey } = props;
    const classes = PickersFadeTransitionGroup_useUtilityClasses(props);
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersFadeTransitionGroupRoot, {
        className: dist_clsx(classes.root, className),
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Fade_74850abd__["default"], {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}
function getPickersDayUtilityClass(slot) {
    return generateUtilityClass('MuiPickersDay', slot);
}
const pickersDayClasses = generateUtilityClasses('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);
const PickersDay_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const PickersDay_useUtilityClasses = (ownerState)=>{
    const { selected, disableMargin, disableHighlightToday, today, disabled, outsideCurrentMonth, showDaysOutsideCurrentMonth, classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return composeClasses(slots, getPickersDayUtilityClass, classes);
};
const styleArg = ({ theme })=>extends_extends({}, theme.typography.caption, {
        width: DAY_SIZE,
        height: DAY_SIZE,
        borderRadius: '50%',
        padding: 0,
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${pickersDayClasses.selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${pickersDayClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${DAY_MARGIN}px`
                }
            },
            {
                props: {
                    outsideCurrentMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    today: true
                },
                style: {
                    [`&:not(.${pickersDayClasses.selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const PickersDayRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_ButtonBase_d8a51b7c__["default"], {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver
})(styleArg);
const PickersDayFiller = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver
})(({ theme })=>extends_extends({}, styleArg({
        theme
    }), {
        opacity: 0,
        pointerEvents: 'none'
    }));
const PickersDay_noop = ()=>{};
const PickersDayRaw = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, forwardedRef) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus = false, className, day, disabled = false, disableHighlightToday = false, disableMargin = false, isAnimating, onClick, onDaySelect, onFocus = PickersDay_noop, onBlur = PickersDay_noop, onKeyDown = PickersDay_noop, onMouseDown = PickersDay_noop, onMouseEnter = PickersDay_noop, outsideCurrentMonth, selected = false, showDaysOutsideCurrentMonth = false, children, today: isToday = false } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersDay_excluded);
    const ownerState = extends_extends({}, props, {
        autoFocus,
        disabled,
        disableHighlightToday,
        disableMargin,
        selected,
        showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = PickersDay_useUtilityClasses(ownerState);
    const utils = useUtils_useUtils();
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, forwardedRef);
    useEnhancedEffect(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersDayFiller, {
        className: dist_clsx(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersDayRoot, extends_extends({
        className: dist_clsx(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: children ? children : utils.format(day, 'dayOfMonth')
    }));
});
"production" !== process.env.NODE_ENV && (PickersDayRaw.propTypes = {
    action: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                focusVisible: prop_types_default().func.isRequired
            })
        })
    ]),
    centerRipple: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    component: prop_types_default().elementType,
    day: prop_types_default().object.isRequired,
    disabled: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disableMargin: prop_types_default().bool,
    disableRipple: prop_types_default().bool,
    disableTouchRipple: prop_types_default().bool,
    focusRipple: prop_types_default().bool,
    focusVisibleClassName: prop_types_default().string,
    isAnimating: prop_types_default().bool,
    isFirstVisibleCell: prop_types_default().bool.isRequired,
    isLastVisibleCell: prop_types_default().bool.isRequired,
    onBlur: prop_types_default().func,
    onDaySelect: prop_types_default().func.isRequired,
    onFocus: prop_types_default().func,
    onFocusVisible: prop_types_default().func,
    onKeyDown: prop_types_default().func,
    onMouseEnter: prop_types_default().func,
    outsideCurrentMonth: prop_types_default().bool.isRequired,
    selected: prop_types_default().bool,
    showDaysOutsideCurrentMonth: prop_types_default().bool,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    tabIndex: prop_types_default().number,
    today: prop_types_default().bool,
    TouchRippleProps: prop_types_default().object,
    touchRippleRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                pulsate: prop_types_default().func.isRequired,
                start: prop_types_default().func.isRequired,
                stop: prop_types_default().func.isRequired
            })
        })
    ])
});
const PickersDay_PickersDay = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(PickersDayRaw);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return -1 !== (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ");
}
function addClass_addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!hasClass(element, className)) if ('string' == typeof element.className) element.className = element.className + " " + className;
    else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass_removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if ('string' == typeof element.className) element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}
const esm_config = {
    disabled: false
};
var timeoutsShape = 'production' !== process.env.NODE_ENV ? prop_types_default().oneOfType([
    prop_types_default().number,
    prop_types_default().shape({
        enter: prop_types_default().number,
        exit: prop_types_default().number,
        appear: prop_types_default().number
    }).isRequired
]) : null;
var classNamesShape = 'production' !== process.env.NODE_ENV ? prop_types_default().oneOfType([
    prop_types_default().string,
    prop_types_default().shape({
        enter: prop_types_default().string,
        exit: prop_types_default().string,
        active: prop_types_default().string
    }),
    prop_types_default().shape({
        enter: prop_types_default().string,
        enterDone: prop_types_default().string,
        enterActive: prop_types_default().string,
        exit: prop_types_default().string,
        exitDone: prop_types_default().string,
        exitActive: prop_types_default().string
    })
]) : null;
var reflow_forceReflow = function(node) {
    return node.scrollTop;
};
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
var Transition_Transition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context;
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) if (appear) {
            initialStatus = EXITED;
            _this.appearStatus = ENTERING;
        } else initialStatus = ENTERED;
        else initialStatus = props.unmountOnExit || props.mountOnEnter ? UNMOUNTED : EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (null != timeout && 'number' != typeof timeout) {
            exit = timeout.exit;
            enter = timeout.enter;
            appear = void 0 !== timeout.appear ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function(mounting, nextStatus) {
        if (void 0 === mounting) mounting = false;
        if (null !== nextStatus) {
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__["default"].findDOMNode(this);
                    if (node) reflow_forceReflow(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__["default"].findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
        if (!mounting && !enter || esm_config.disabled) return void this.safeSetState({
            status: ENTERED
        }, function() {
            _this2.props.onEntered(maybeNode);
        });
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? void 0 : __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__["default"].findDOMNode(this);
        if (!exit || esm_config.disabled) return void this.safeSetState({
            status: EXITED
        }, function() {
            _this3.props.onExited(maybeNode);
        });
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function() {
        if (null !== this.nextCallback) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__["default"].findDOMNode(this);
        var doesNotHaveTimeoutOrListener = null == timeout && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) return void setTimeout(this.nextCallback, 0);
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (null != timeout) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = (_this$props.in, _this$props.mountOnEnter, _this$props.unmountOnExit, _this$props.appear, _this$props.enter, _this$props.exit, _this$props.timeout, _this$props.addEndListener, _this$props.onEnter, _this$props.onEntering, _this$props.onEntered, _this$props.onExit, _this$props.onExiting, _this$props.onExited, _this$props.nodeRef, esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]));
        return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(TransitionGroupContext.Provider, {
            value: null
        }, 'function' == typeof children ? children(status, childProps) : __WEBPACK_EXTERNAL_MODULE_react__["default"].cloneElement(__WEBPACK_EXTERNAL_MODULE_react__["default"].Children.only(children), childProps));
    };
    return Transition;
}(__WEBPACK_EXTERNAL_MODULE_react__["default"].Component);
Transition_Transition.contextType = TransitionGroupContext;
Transition_Transition.propTypes = "production" !== process.env.NODE_ENV ? {
    nodeRef: prop_types_default().shape({
        current: 'undefined' == typeof Element ? prop_types_default().any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return prop_types_default().instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    children: prop_types_default().oneOfType([
        prop_types_default().func.isRequired,
        prop_types_default().element.isRequired
    ]).isRequired,
    in: prop_types_default().bool,
    mountOnEnter: prop_types_default().bool,
    unmountOnExit: prop_types_default().bool,
    appear: prop_types_default().bool,
    enter: prop_types_default().bool,
    exit: prop_types_default().bool,
    timeout: function(props) {
        var pt = timeoutsShape;
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    addEndListener: prop_types_default().func,
    onEnter: prop_types_default().func,
    onEntering: prop_types_default().func,
    onEntered: prop_types_default().func,
    onExit: prop_types_default().func,
    onExiting: prop_types_default().func,
    onExited: prop_types_default().func
} : {};
function Transition_noop() {}
Transition_Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: Transition_noop,
    onEntering: Transition_noop,
    onEntered: Transition_noop,
    onExit: Transition_noop,
    onExiting: Transition_noop,
    onExited: Transition_noop
};
Transition_Transition.UNMOUNTED = UNMOUNTED;
Transition_Transition.EXITED = EXITED;
Transition_Transition.ENTERING = ENTERING;
Transition_Transition.ENTERED = ENTERED;
Transition_Transition.EXITING = EXITING;
const esm_Transition = Transition_Transition;
var _addClass = function(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return addClass_addClass(node, c);
    });
};
var CSSTransition_removeClass = function(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return removeClass_removeClass(node, c);
    });
};
var CSSTransition_CSSTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = 'string' == typeof classNames;
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if ('appear' === type && 'done' === phase && doneClassName) className += " " + doneClassName;
        if ('active' === phase) {
            if (node) reflow_forceReflow(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass(node, className);
        }
    };
    _proto.removeClasses = function(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) CSSTransition_removeClass(node, baseClassName);
        if (activeClassName) CSSTransition_removeClass(node, activeClassName);
        if (doneClassName) CSSTransition_removeClass(node, doneClassName);
    };
    _proto.render = function() {
        var _this$props = this.props, props = (_this$props.classNames, esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_this$props, [
            "classNames"
        ]));
        return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(esm_Transition, esm_extends_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}(__WEBPACK_EXTERNAL_MODULE_react__["default"].Component);
CSSTransition_CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition_CSSTransition.propTypes = "production" !== process.env.NODE_ENV ? esm_extends_extends({}, esm_Transition.propTypes, {
    classNames: classNamesShape,
    onEnter: prop_types_default().func,
    onEntering: prop_types_default().func,
    onEntered: prop_types_default().func,
    onExit: prop_types_default().func,
    onExiting: prop_types_default().func,
    onExited: prop_types_default().func
}) : {};
const esm_CSSTransition = CSSTransition_CSSTransition;
const getPickersSlideTransitionUtilityClass = (slot)=>generateUtilityClass('MuiPickersSlideTransition', slot);
const pickersSlideTransitionClasses = generateUtilityClasses('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);
const PickersSlideTransition_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const PickersSlideTransition_useUtilityClasses = (ownerState)=>{
    const { classes, slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return composeClasses(slots, getPickersSlideTransitionUtilityClass, classes);
};
const PickersSlideTransitionRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(esm_TransitionGroup, {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${pickersSlideTransitionClasses["slideEnter-left"]}`]: styles['slideEnter-left']
            },
            {
                [`.${pickersSlideTransitionClasses["slideEnter-right"]}`]: styles['slideEnter-right']
            },
            {
                [`.${pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
            },
            {
                [`.${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${pickersSlideTransitionClasses["slideEnter-left"]}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${pickersSlideTransitionClasses["slideEnter-right"]}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${pickersSlideTransitionClasses.slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function PickersSlideTransition(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children, className, reduceAnimations, transKey } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersSlideTransition_excluded);
    const classes = PickersSlideTransition_useUtilityClasses(props);
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    if (reduceAnimations) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: dist_clsx(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersSlideTransitionRoot, {
        className: dist_clsx(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(esm_CSSTransition, extends_extends({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}
const getDayCalendarUtilityClass = (slot)=>generateUtilityClass('MuiDayCalendar', slot);
generateUtilityClasses('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);
const DayCalendar_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], DayCalendar_excluded2 = [
    "ownerState"
];
const DayCalendar_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return composeClasses(slots, getDayCalendarUtilityClass, classes);
};
const weeksContainerHeight = (DAY_SIZE + 2 * DAY_MARGIN) * 6;
const PickersCalendarDayRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const PickersCalendarDayHeader = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const PickersCalendarWeekDayLabel = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const PickersCalendarWeekNumberLabel = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const PickersCalendarWeekNumber = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme })=>extends_extends({}, theme.typography.caption, {
        width: DAY_SIZE,
        height: DAY_SIZE,
        padding: 0,
        margin: `0 ${DAY_MARGIN}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const PickersCalendarLoadingContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersSlideTransition, {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const PickersCalendarWeek = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${DAY_MARGIN}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function WrappedDay(_ref) {
    let { parentProps, day, focusableDay, selectedDays, isDateDisabled, currentMonthNumber, isViewFocused } = _ref, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, DayCalendar_excluded);
    const { disabled, disableHighlightToday, isMonthSwitchingAnimating, showDaysOutsideCurrentMonth, slots, slotProps, timezone } = parentProps;
    const utils = useUtils_useUtils();
    const now = useNow(timezone);
    const isFocusableDay = null !== focusableDay && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = slots?.day ?? PickersDay_PickersDay;
    const _useSlotProps = useSlotProps({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: extends_extends({
            disableHighlightToday,
            showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: extends_extends({}, parentProps, {
            day,
            selected: isSelected
        })
    }), dayProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps, DayCalendar_excluded2);
    const isDisabled = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Day, extends_extends({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : void 0
    }));
}
function DayCalendar(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const utils = useUtils_useUtils();
    const { onFocusedDayChange, className, currentMonth, selectedDays, focusedDay, loading, onSelectedDaysChange, onMonthSwitchingAnimationEnd, readOnly, reduceAnimations, renderLoading = ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
            children: "..."
        }), slideDirection, TransitionProps, disablePast, disableFuture, minDate, maxDate, shouldDisableDate, shouldDisableMonth, shouldDisableYear, dayOfWeekFormatter = (date)=>utils.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus, onFocusedViewChange, gridLabelId, displayWeekNumber, fixedWeekNumber, autoFocus, timezone } = props;
    const now = useNow(timezone);
    const classes = DayCalendar_useUtilityClasses(props);
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const isRTL = 'rtl' === theme.direction;
    const isDateDisabled = useIsDateDisabled({
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disablePast,
        disableFuture,
        timezone
    });
    const localeText = useLocaleText();
    const [internalHasFocus, setInternalHasFocus] = useControlled({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const [internalFocusedDay, setInternalFocusedDay] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>focusedDay || now);
    const handleDaySelect = useEventCallback_useEventCallback((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange?.(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = useEventCallback_useEventCallback((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = findClosestEnabledDate({
                        utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled,
                        timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = findClosestEnabledDate({
                        utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled,
                        timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = useEventCallback_useEventCallback((event, day)=>focusDay(day));
    const handleBlur = useEventCallback_useEventCallback((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    const slideNodeRef = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return findClosestEnabledDate({
            utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    getWeekdays(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarSlideTransition, extends_extends({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: dist_clsx(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}
function getPickersMonthUtilityClass(slot) {
    return generateUtilityClass('MuiPickersMonth', slot);
}
const pickersMonthClasses = generateUtilityClasses('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);
const PickersMonth_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow"
];
const PickersMonth_useUtilityClasses = (ownerState)=>{
    const { disabled, selected, classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return composeClasses(slots, getPickersMonthUtilityClass, classes);
};
const PickersMonthRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '33.3%',
    variants: [
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                flexBasis: '25%'
            }
        }
    ]
});
const PickersMonthButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${pickersMonthClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${pickersMonthClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>extends_extends({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${pickersMonthClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${pickersMonthClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const PickersMonth_PickersMonth = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(function(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus, children, disabled, selected, value, tabIndex, onClick, onKeyDown, onFocus, onBlur, 'aria-current': ariaCurrent, 'aria-label': ariaLabel } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersMonth_excluded);
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const classes = PickersMonth_useUtilityClasses(props);
    useEnhancedEffect(()=>{
        if (autoFocus) ref.current?.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersMonthRoot, extends_extends({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});
function getMonthCalendarUtilityClass(slot) {
    return generateUtilityClass('MuiMonthCalendar', slot);
}
generateUtilityClasses('MuiMonthCalendar', [
    'root'
]);
const MonthCalendar_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId"
];
const MonthCalendar_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props,
        name
    });
    return extends_extends({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const MonthCalendarRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: DIALOG_WIDTH,
    boxSizing: 'border-box'
});
const MonthCalendar_MonthCalendar = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
    const { className, value: valueProp, defaultValue, referenceDate: referenceDateProp, disabled, disableFuture, disablePast, maxDate, minDate, onChange, shouldDisableMonth, readOnly, autoFocus = false, onMonthFocus, hasFocus, onFocusedViewChange, monthsPerRow = 3, timezone: timezoneProp, gridLabelId } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, MonthCalendar_excluded);
    const { value, handleValueChange, timezone } = useControlledValueWithTimezone({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange: onChange,
        valueManager: singleItemValueManager
    });
    const now = useNow(timezone);
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.useTheme)();
    const utils = useUtils_useUtils();
    const referenceDate = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>singleItemValueManager.getInitialReferenceValue({
            value,
            utils,
            props,
            timezone,
            referenceDate: referenceDateProp,
            granularity: SECTION_TYPE_GRANULARITY.month
        }), []);
    const ownerState = props;
    const classes = MonthCalendar_useUtilityClasses(ownerState);
    const todayMonth = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (null != value) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = useControlled({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = useEventCallback_useEventCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = useEventCallback_useEventCallback((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = useEventCallback_useEventCallback((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>null !== selectedMonth && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = useEventCallback_useEventCallback((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + ('ltr' === theme.direction ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + ('ltr' === theme.direction ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = useEventCallback_useEventCallback((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = useEventCallback_useEventCallback((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MonthCalendarRoot, extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: getMonthsInYear(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersMonth_PickersMonth, {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : void 0,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});
"production" !== process.env.NODE_ENV && (MonthCalendar_MonthCalendar.propTypes = {
    autoFocus: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    gridLabelId: prop_types_default().string,
    hasFocus: prop_types_default().bool,
    maxDate: prop_types_default().object,
    minDate: prop_types_default().object,
    monthsPerRow: prop_types_default().oneOf([
        3,
        4
    ]),
    onChange: prop_types_default().func,
    onFocusedViewChange: prop_types_default().func,
    onMonthFocus: prop_types_default().func,
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    shouldDisableMonth: prop_types_default().func,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object
});
function getPickersYearUtilityClass(slot) {
    return generateUtilityClass('MuiPickersYear', slot);
}
const pickersYearClasses = generateUtilityClasses('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);
const PickersYear_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const PickersYear_useUtilityClasses = (ownerState)=>{
    const { disabled, selected, classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return composeClasses(slots, getPickersYearUtilityClass, classes);
};
const PickersYearRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '33.3%',
    variants: [
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                flexBasis: '25%'
            }
        }
    ]
});
const PickersYearButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${pickersYearClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${pickersYearClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>extends_extends({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '6px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${pickersYearClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${pickersYearClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const PickersYear_PickersYear = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(function(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus, className, children, disabled, selected, value, tabIndex, onClick, onKeyDown, onFocus, onBlur, 'aria-current': ariaCurrent } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersYear_excluded);
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const classes = PickersYear_useUtilityClasses(props);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (autoFocus) ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersYearRoot, extends_extends({
        className: dist_clsx(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});
function getYearCalendarUtilityClass(slot) {
    return generateUtilityClass('MuiYearCalendar', slot);
}
generateUtilityClasses('MuiYearCalendar', [
    'root'
]);
const YearCalendar_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone",
    "gridLabelId"
];
const YearCalendar_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props,
        name
    });
    return extends_extends({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const YearCalendarRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: DIALOG_WIDTH,
    maxHeight: MAX_CALENDAR_HEIGHT,
    boxSizing: 'border-box',
    position: 'relative'
});
const YearCalendar_YearCalendar = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus, className, value: valueProp, defaultValue, referenceDate: referenceDateProp, disabled, disableFuture, disablePast, maxDate, minDate, onChange, readOnly, shouldDisableYear, onYearFocus, hasFocus, onFocusedViewChange, yearsPerRow, timezone: timezoneProp, gridLabelId } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, YearCalendar_excluded);
    const { value, handleValueChange, timezone } = useControlledValueWithTimezone({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange: onChange,
        valueManager: singleItemValueManager
    });
    const now = useNow(timezone);
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.useTheme)();
    const utils = useUtils_useUtils();
    const referenceDate = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>singleItemValueManager.getInitialReferenceValue({
            value,
            utils,
            props,
            timezone,
            referenceDate: referenceDateProp,
            granularity: SECTION_TYPE_GRANULARITY.year
        }), []);
    const ownerState = props;
    const classes = YearCalendar_useUtilityClasses(ownerState);
    const todayYear = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (null != value) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = useControlled({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = useEventCallback_useEventCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = useEventCallback_useEventCallback((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = useEventCallback_useEventCallback((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>null !== selectedYear && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = useEventCallback_useEventCallback((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + ('ltr' === theme.direction ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + ('ltr' === theme.direction ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = useEventCallback_useEventCallback((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = useEventCallback_useEventCallback((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, scrollerRef);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (autoFocus || null === scrollerRef.current) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(YearCalendarRoot, extends_extends({
        ref: handleRef,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: utils.getYearRange([
            minDate,
            maxDate
        ]).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersYear_PickersYear, {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : void 0,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});
"production" !== process.env.NODE_ENV && (YearCalendar_YearCalendar.propTypes = {
    autoFocus: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    gridLabelId: prop_types_default().string,
    hasFocus: prop_types_default().bool,
    maxDate: prop_types_default().object,
    minDate: prop_types_default().object,
    onChange: prop_types_default().func,
    onFocusedViewChange: prop_types_default().func,
    onYearFocus: prop_types_default().func,
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    shouldDisableYear: prop_types_default().func,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    yearsPerRow: prop_types_default().oneOf([
        3,
        4
    ])
});
function getPickersArrowSwitcherUtilityClass(slot) {
    return generateUtilityClass('MuiPickersArrowSwitcher', slot);
}
generateUtilityClasses('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);
const PickersArrowSwitcher_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], PickersArrowSwitcher_excluded2 = [
    "ownerState"
], PickersArrowSwitcher_excluded3 = [
    "ownerState"
];
const PickersArrowSwitcherRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const PickersArrowSwitcherSpacer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme })=>({
        width: theme.spacing(3)
    }));
const PickersArrowSwitcherButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})({
    variants: [
        {
            props: {
                hidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const PickersArrowSwitcher_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return composeClasses(slots, getPickersArrowSwitcherUtilityClass, classes);
};
const PickersArrowSwitcher_PickersArrowSwitcher = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const isRTL = 'rtl' === theme.direction;
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children, className, slots, slotProps, isNextDisabled, isNextHidden, onGoToNext, nextLabel, isPreviousDisabled, isPreviousHidden, onGoToPrevious, previousLabel } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersArrowSwitcher_excluded);
    const ownerState = props;
    const classes = PickersArrowSwitcher_useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? PickersArrowSwitcherButton;
    const previousIconButtonProps = useSlotProps({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: extends_extends({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = slots?.nextIconButton ?? PickersArrowSwitcherButton;
    const nextIconButtonProps = useSlotProps({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: extends_extends({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? ArrowLeftIcon;
    const _useSlotProps = useSlotProps({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: void 0
    }), leftArrowIconProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps, PickersArrowSwitcher_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? ArrowRightIcon;
    const _useSlotProps2 = useSlotProps({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: void 0
    }), rightArrowIconProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps2, PickersArrowSwitcher_excluded3);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersArrowSwitcherRoot, extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PreviousIconButton, extends_extends({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RightArrowIcon, extends_extends({}, rightArrowIconProps)) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftArrowIcon, extends_extends({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NextIconButton, extends_extends({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftArrowIcon, extends_extends({}, leftArrowIconProps)) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RightArrowIcon, extends_extends({}, rightArrowIconProps))
            }))
        ]
    }));
});
function useNextMonthDisabled(month, { disableFuture, maxDate, timezone }) {
    const utils = useUtils_useUtils();
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const now = utils.date(void 0, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function usePreviousMonthDisabled(month, { disablePast, minDate, timezone }) {
    const utils = useUtils_useUtils();
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const now = utils.date(void 0, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function useMeridiemMode(date, ampm, onChange, selectionState) {
    const utils = useUtils_useUtils();
    const meridiemMode = getMeridiem(date, utils);
    const handleMeridiemChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((mode)=>{
        const timeWithMeridiem = null == date ? null : convertToMeridiem(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode,
        handleMeridiemChange
    };
}
const getPickersCalendarHeaderUtilityClass = (slot)=>generateUtilityClass('MuiPickersCalendarHeader', slot);
const pickersCalendarHeaderClasses = generateUtilityClasses('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);
const PickersCalendarHeader_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone",
    "format"
], PickersCalendarHeader_excluded2 = [
    "ownerState"
];
const PickersCalendarHeader_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return composeClasses(slots, getPickersCalendarHeaderUtilityClass, classes);
};
const PickersCalendarHeaderRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    maxHeight: 40,
    minHeight: 40
});
const PickersCalendarHeaderLabelContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme })=>extends_extends({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const PickersCalendarHeaderLabel = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const PickersCalendarHeaderSwitchViewIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(ArrowDropDownIcon, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
const PickersCalendarHeader_PickersCalendarHeader = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const localeText = useLocaleText();
    const utils = useUtils_useUtils();
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots, slotProps, currentMonth: month, disabled, disableFuture, disablePast, maxDate, minDate, onMonthChange, onViewChange, view, reduceAnimations, views, labelId, className, timezone, format = `${utils.formats.month} ${utils.formats.year}` } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersCalendarHeader_excluded);
    const ownerState = props;
    const classes = PickersCalendarHeader_useUtilityClasses(props);
    const SwitchViewButton = slots?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = useSlotProps({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon;
    const _useSlotProps = useSlotProps({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: void 0,
        className: classes.switchViewIcon
    }), switchViewIconProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_useSlotProps, PickersCalendarHeader_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = useNextMonthDisabled(month, {
        disableFuture,
        maxDate,
        timezone
    });
    const isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
        disablePast,
        minDate,
        timezone
    });
    const handleToggleView = ()=>{
        if (1 === views.length || !onViewChange || disabled) return;
        if (2 === views.length) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            const nextIndexToOpen = 0 !== views.indexOf(view) ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    if (1 === views.length && 'year' === views[0]) return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersCalendarHeaderRoot, extends_extends({}, other, {
        ownerState: ownerState,
        className: dist_clsx(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersFadeTransitionGroup, {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SwitchViewButton, extends_extends({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SwitchViewIcon, extends_extends({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Fade_74850abd__["default"], {
                in: 'day' === view,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersArrowSwitcher_PickersArrowSwitcher, {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});
"production" !== process.env.NODE_ENV && (PickersCalendarHeader_PickersCalendarHeader.propTypes = {
    classes: prop_types_default().object,
    className: prop_types_default().string,
    currentMonth: prop_types_default().object.isRequired,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    format: prop_types_default().string,
    labelId: prop_types_default().string,
    maxDate: prop_types_default().object.isRequired,
    minDate: prop_types_default().object.isRequired,
    onMonthChange: prop_types_default().func.isRequired,
    onViewChange: prop_types_default().func,
    reduceAnimations: prop_types_default().bool.isRequired,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string.isRequired,
    view: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired,
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired).isRequired
});
const PickerViewRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div')({
    overflow: 'hidden',
    width: DIALOG_WIDTH,
    maxHeight: VIEW_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});
const getDateCalendarUtilityClass = (slot)=>generateUtilityClass('MuiDateCalendar', slot);
generateUtilityClasses('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);
const DateCalendar_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const DateCalendar_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return composeClasses(slots, getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    const defaultReduceAnimations = useDefaultReduceAnimations();
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props,
        name
    });
    return extends_extends({}, themeProps, {
        loading: themeProps.loading ?? false,
        disablePast: themeProps.disablePast ?? false,
        disableFuture: themeProps.disableFuture ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                children: "..."
            })),
        minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const DateCalendarRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickerViewRoot, {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    height: VIEW_HEIGHT
});
const DateCalendarViewTransitionContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersFadeTransitionGroup, {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const DateCalendar_DateCalendar = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const utils = useUtils_useUtils();
    const id = useId();
    const props = useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus, onViewChange, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableFuture, disablePast, onChange, onYearChange, onMonthChange, reduceAnimations, shouldDisableDate, shouldDisableMonth, shouldDisableYear, view: inView, views, openTo, className, disabled, readOnly, minDate, maxDate, disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange, showDaysOutsideCurrentMonth, fixedWeekNumber, dayOfWeekFormatter, slots, slotProps, loading, renderLoading, displayWeekNumber, yearsPerRow, monthsPerRow, timezone: timezoneProp } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, DateCalendar_excluded);
    const { value, handleValueChange, timezone } = useControlledValueWithTimezone({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange,
        valueManager: singleItemValueManager
    });
    const { view, setView, focusedView, setFocusedView, goToNextView, setValueAndGoToNextView } = useViews({
        view: inView,
        views,
        openTo,
        onChange: handleValueChange,
        onViewChange,
        autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange
    });
    const { referenceDate, calendarState, changeFocusedDay, changeMonth, handleChangeMonth, isDateDisabled, onMonthSwitchingAnimationEnd } = useCalendarState({
        value,
        referenceDate: referenceDateProp,
        reduceAnimations,
        onMonthChange,
        minDate,
        maxDate,
        shouldDisableDate,
        disablePast,
        disableFuture,
        timezone
    });
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = null !== focusedView;
    const CalendarHeader = slots?.calendarHeader ?? PickersCalendarHeader_PickersCalendarHeader;
    const calendarHeaderProps = useSlotProps({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views,
            view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth,
                    direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled,
            disablePast,
            disableFuture,
            reduceAnimations,
            timezone,
            labelId: gridLabelId,
            slots,
            slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = useEventCallback_useEventCallback((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
            utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange?.(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = useEventCallback_useEventCallback((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
            utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange?.(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = useEventCallback_useEventCallback((day)=>{
        if (day) return handleValueChange(mergeDateAndTime(utils, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null != value && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]);
    const ownerState = props;
    const classes = DateCalendar_useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast,
        disableFuture,
        maxDate,
        minDate
    };
    const commonViewProps = {
        disableHighlightToday,
        readOnly,
        disabled,
        timezone,
        gridLabelId
    };
    const prevOpenViewRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(view);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateCalendarRoot, extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CalendarHeader, extends_extends({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                    children: [
                        'year' === view && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(YearCalendar_YearCalendar, extends_extends({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        'month' === view && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MonthCalendar_MonthCalendar, extends_extends({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        'day' === view && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DayCalendar, extends_extends({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});
"production" !== process.env.NODE_ENV && (DateCalendar_DateCalendar.propTypes = {
    autoFocus: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    dayOfWeekFormatter: prop_types_default().func,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    displayWeekNumber: prop_types_default().bool,
    fixedWeekNumber: prop_types_default().number,
    focusedView: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    loading: prop_types_default().bool,
    maxDate: prop_types_default().object,
    minDate: prop_types_default().object,
    monthsPerRow: prop_types_default().oneOf([
        3,
        4
    ]),
    onChange: prop_types_default().func,
    onFocusedViewChange: prop_types_default().func,
    onMonthChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    onYearChange: prop_types_default().func,
    openTo: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    readOnly: prop_types_default().bool,
    reduceAnimations: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    renderLoading: prop_types_default().func,
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    showDaysOutsideCurrentMonth: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    yearsPerRow: prop_types_default().oneOf([
        3,
        4
    ])
});
const renderDateViewCalendar = ({ view, onViewChange, views, focusedView, onFocusedViewChange, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minDate, maxDate, shouldDisableDate, shouldDisableMonth, shouldDisableYear, reduceAnimations, onMonthChange, monthsPerRow, onYearChange, yearsPerRow, slots, slotProps, loading, renderLoading, disableHighlightToday, readOnly, disabled, showDaysOutsideCurrentMonth, dayOfWeekFormatter, sx, autoFocus, fixedWeekNumber, displayWeekNumber, timezone })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DateCalendar_DateCalendar, {
        view: view,
        onViewChange: onViewChange,
        views: views.filter(isDatePickerView),
        focusedView: focusedView && isDatePickerView(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });
const DesktopDatePicker_DesktopDatePicker = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const localeText = useLocaleText();
    const utils = useUtils_useUtils();
    const defaultizedProps = useDatePickerDefaultizedProps(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = extends_extends({
        day: renderDateViewCalendar,
        month: renderDateViewCalendar,
        year: renderDateViewCalendar
    }, defaultizedProps.viewRenderers);
    const props = extends_extends({}, defaultizedProps, {
        viewRenderers,
        format: resolveDateFormat(utils, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: extends_extends({
            openPickerIcon: CalendarIcon,
            field: DateField_DateField
        }, defaultizedProps.slots),
        slotProps: extends_extends({}, defaultizedProps.slotProps, {
            field: (ownerState)=>extends_extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps), {
                    ref
                }),
            toolbar: extends_extends({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = useDesktopPicker({
        props,
        valueManager: singleItemValueManager,
        valueType: 'date',
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: validateDate
    });
    return renderPicker();
});
DesktopDatePicker_DesktopDatePicker.propTypes = {
    autoFocus: prop_types_default().bool,
    className: prop_types_default().string,
    closeOnSelect: prop_types_default().bool,
    dayOfWeekFormatter: prop_types_default().func,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disableOpenPicker: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    displayWeekNumber: prop_types_default().bool,
    enableAccessibleFieldDOMStructure: prop_types_default().any,
    fixedWeekNumber: prop_types_default().number,
    format: prop_types_default().string,
    formatDensity: prop_types_default().oneOf([
        'dense',
        'spacious'
    ]),
    inputRef: refType,
    label: prop_types_default().node,
    loading: prop_types_default().bool,
    localeText: prop_types_default().object,
    maxDate: prop_types_default().object,
    minDate: prop_types_default().object,
    monthsPerRow: prop_types_default().oneOf([
        3,
        4
    ]),
    name: prop_types_default().string,
    onAccept: prop_types_default().func,
    onChange: prop_types_default().func,
    onClose: prop_types_default().func,
    onError: prop_types_default().func,
    onMonthChange: prop_types_default().func,
    onOpen: prop_types_default().func,
    onSelectedSectionsChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    onYearChange: prop_types_default().func,
    open: prop_types_default().bool,
    openTo: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    orientation: prop_types_default().oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: prop_types_default().bool,
    reduceAnimations: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    renderLoading: prop_types_default().func,
    selectedSections: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        prop_types_default().number
    ]),
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    showDaysOutsideCurrentMonth: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    viewRenderers: prop_types_default().shape({
        day: prop_types_default().func,
        month: prop_types_default().func,
        year: prop_types_default().func
    }),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    yearsPerRow: prop_types_default().oneOf([
        3,
        4
    ])
};
const desktop_date_picker_DesktopDatePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slots, slotProps, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DesktopDatePicker_DesktopDatePicker, {
        slots: {
            openPickerIcon: CalendarOutlined,
            ...slots
        },
        slotProps: {
            textField: {
                id
            },
            ...slotProps
        },
        ...rest,
        ref: ref
    });
});
const PickersModalDialogRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__["default"])({
    [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__.dialogClasses.container}`]: {
        outline: 0
    },
    [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__.dialogClasses.paper}`]: {
        outline: 0,
        minWidth: DIALOG_WIDTH
    }
});
const PickersModalDialogContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogContent_37fd6d87__["default"])({
    '&:first-of-type': {
        padding: 0
    }
});
function PickersModalDialog(props) {
    const { children, onDismiss, open, slots, slotProps } = props;
    const Dialog = slots?.dialog ?? PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? __WEBPACK_EXTERNAL_MODULE__mui_material_Fade_74850abd__["default"];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Dialog, extends_extends({
        open: open,
        onClose: onDismiss
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersModalDialogContent, {
            children: children
        })
    }));
}
const useMobilePicker_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const useMobilePicker = (_ref)=>{
    let { props, getOpenDialogAriaText } = _ref, pickerParams = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, useMobilePicker_excluded);
    const { slots, slotProps: innerSlotProps, className, sx, format, formatDensity, enableAccessibleFieldDOMStructure, selectedSections, onSelectedSectionsChange, timezone, name, label, inputRef, readOnly, disabled, localeText } = props;
    const utils = useUtils_useUtils();
    const fieldRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const labelId = useId();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open, actions, layoutProps, renderCurrentView, fieldProps: pickerFieldProps } = usePicker(extends_extends({}, pickerParams, {
        props,
        fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = useSlotProps({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: extends_extends({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: onSpaceOrEnter(actions.onOpen)
        }, {
            readOnly: readOnly ?? true,
            disabled,
            className,
            sx,
            format,
            formatDensity,
            enableAccessibleFieldDOMStructure,
            selectedSections,
            onSelectedSectionsChange,
            timezone,
            label,
            name
        }, inputRef ? {
            inputRef
        } : {}),
        ownerState: props
    });
    fieldProps.inputProps = extends_extends({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = extends_extends({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = slots.layout ?? PickersLayout_PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) labelledById = label ? `${labelId}-label` : void 0;
    const slotProps = extends_extends({}, innerSlotProps, {
        toolbar: extends_extends({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: extends_extends({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const handleFieldRef = useForkRef_useForkRef(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(LocalizationProvider_LocalizationProvider, {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Field, extends_extends({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersModalDialog, extends_extends({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Layout, extends_extends({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker
    };
};
const MobileDatePicker_MobileDatePicker = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const localeText = useLocaleText();
    const utils = useUtils_useUtils();
    const defaultizedProps = useDatePickerDefaultizedProps(inProps, 'MuiMobileDatePicker');
    const viewRenderers = extends_extends({
        day: renderDateViewCalendar,
        month: renderDateViewCalendar,
        year: renderDateViewCalendar
    }, defaultizedProps.viewRenderers);
    const props = extends_extends({}, defaultizedProps, {
        viewRenderers,
        format: resolveDateFormat(utils, defaultizedProps, false),
        slots: extends_extends({
            field: DateField_DateField
        }, defaultizedProps.slots),
        slotProps: extends_extends({}, defaultizedProps.slotProps, {
            field: (ownerState)=>extends_extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps), {
                    ref
                }),
            toolbar: extends_extends({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = useMobilePicker({
        props,
        valueManager: singleItemValueManager,
        valueType: 'date',
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: validateDate
    });
    return renderPicker();
});
MobileDatePicker_MobileDatePicker.propTypes = {
    autoFocus: prop_types_default().bool,
    className: prop_types_default().string,
    closeOnSelect: prop_types_default().bool,
    dayOfWeekFormatter: prop_types_default().func,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disableOpenPicker: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    displayWeekNumber: prop_types_default().bool,
    enableAccessibleFieldDOMStructure: prop_types_default().any,
    fixedWeekNumber: prop_types_default().number,
    format: prop_types_default().string,
    formatDensity: prop_types_default().oneOf([
        'dense',
        'spacious'
    ]),
    inputRef: refType,
    label: prop_types_default().node,
    loading: prop_types_default().bool,
    localeText: prop_types_default().object,
    maxDate: prop_types_default().object,
    minDate: prop_types_default().object,
    monthsPerRow: prop_types_default().oneOf([
        3,
        4
    ]),
    name: prop_types_default().string,
    onAccept: prop_types_default().func,
    onChange: prop_types_default().func,
    onClose: prop_types_default().func,
    onError: prop_types_default().func,
    onMonthChange: prop_types_default().func,
    onOpen: prop_types_default().func,
    onSelectedSectionsChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    onYearChange: prop_types_default().func,
    open: prop_types_default().bool,
    openTo: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    orientation: prop_types_default().oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: prop_types_default().bool,
    reduceAnimations: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    renderLoading: prop_types_default().func,
    selectedSections: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        prop_types_default().number
    ]),
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    showDaysOutsideCurrentMonth: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]),
    viewRenderers: prop_types_default().shape({
        day: prop_types_default().func,
        month: prop_types_default().func,
        year: prop_types_default().func
    }),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    yearsPerRow: prop_types_default().oneOf([
        3,
        4
    ])
};
const mobileDatePickerTextFieldStyleOverrides = {
    "& .MuiOutlinedInput-root": {
        "&:has([readonly])": {
            backgroundColor: palette_Background.paper,
            cursor: cursor_style_CursorStyle.pointer
        }
    },
    "& .Mui-readOnly": {
        cursor: cursor_style_CursorStyle.pointer
    }
};
const mobileDatePickerTextFieldDisabledStyleOverrides = {
    "& .MuiOutlinedInput-root": {
        "&:has([readonly])": {
            backgroundColor: palette_Background.paper
        }
    }
};
function generateCustomTextFieldStyle(disabled) {
    const iconColor = disabled ? "disabled" : "action";
    return {
        sx: disabled ? mobileDatePickerTextFieldDisabledStyleOverrides : mobileDatePickerTextFieldStyleOverrides,
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CalendarOutlined, {
                color: iconColor
            })
        }
    };
}
const mobile_date_picker_MobileDatePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slotProps, disabled, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MobileDatePicker_MobileDatePicker, {
        slotProps: {
            textField: {
                id,
                ...generateCustomTextFieldStyle(disabled)
            },
            ...slotProps
        },
        disabled: disabled,
        ...rest,
        ref: ref
    });
});
const date_picker_DatePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isMobile, ...rest }, ref) {
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(mobile_date_picker_MobileDatePicker, {
        ...rest,
        ref: ref
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(desktop_date_picker_DesktopDatePicker, {
        ...rest,
        ref: ref
    });
});
const validateTime = ({ adapter, value, props })=>{
    if (null === value) return null;
    const { minTime, maxTime, minutesStep, shouldDisableTime, disableIgnoringDatePartForTimeValidation = false, disablePast, disableFuture, timezone } = props;
    const now = adapter.utils.date(void 0, timezone);
    const isAfter = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
const validateDateTime = ({ props, value, adapter })=>{
    const dateValidationResult = validateDate({
        adapter,
        value,
        props
    });
    if (null !== dateValidationResult) return dateValidationResult;
    return validateTime({
        adapter,
        value,
        props
    });
};
const useDateTimeField = (inProps)=>{
    const props = useDefaultizedDateTimeField(inProps);
    const { forwardedProps, internalProps } = splitFieldInternalAndForwardedProps(props, 'date-time');
    return useField({
        forwardedProps,
        internalProps,
        valueManager: singleItemValueManager,
        fieldValueManager: singleItemFieldValueManager,
        validator: validateDateTime,
        valueType: 'date-time'
    });
};
const DateTimeField_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
const DateTimeField_DateTimeField = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, inRef) {
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimeField'
    });
    const { slots, slotProps, InputProps, inputProps } = themeProps, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(themeProps, DateTimeField_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? PickersTextField_PickersTextField : __WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"]);
    const textFieldProps = useSlotProps({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        ownerState,
        additionalProps: {
            ref: inRef
        }
    });
    textFieldProps.inputProps = extends_extends({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = extends_extends({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = useDateTimeField(textFieldProps);
    const convertedFieldResponse = convertFieldResponseIntoMuiTextFieldProps(fieldResponse);
    const processedFieldProps = useClearableField(extends_extends({}, convertedFieldResponse, {
        slots,
        slotProps
    }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TextField, extends_extends({}, processedFieldProps));
});
"production" !== process.env.NODE_ENV && (DateTimeField_DateTimeField.propTypes = {
    ampm: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    className: prop_types_default().string,
    clearable: prop_types_default().bool,
    color: prop_types_default().oneOf([
        'error',
        'info',
        'primary',
        'secondary',
        'success',
        'warning'
    ]),
    component: prop_types_default().elementType,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableIgnoringDatePartForTimeValidation: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    enableAccessibleFieldDOMStructure: prop_types_default().bool,
    focused: prop_types_default().bool,
    format: prop_types_default().string,
    formatDensity: prop_types_default().oneOf([
        'dense',
        'spacious'
    ]),
    FormHelperTextProps: prop_types_default().object,
    fullWidth: prop_types_default().bool,
    helperText: prop_types_default().node,
    hiddenLabel: prop_types_default().bool,
    id: prop_types_default().string,
    InputLabelProps: prop_types_default().object,
    inputProps: prop_types_default().object,
    InputProps: prop_types_default().object,
    inputRef: refType,
    label: prop_types_default().node,
    margin: prop_types_default().oneOf([
        'dense',
        'none',
        'normal'
    ]),
    maxDate: prop_types_default().object,
    maxDateTime: prop_types_default().object,
    maxTime: prop_types_default().object,
    minDate: prop_types_default().object,
    minDateTime: prop_types_default().object,
    minTime: prop_types_default().object,
    minutesStep: prop_types_default().number,
    name: prop_types_default().string,
    onBlur: prop_types_default().func,
    onChange: prop_types_default().func,
    onClear: prop_types_default().func,
    onError: prop_types_default().func,
    onFocus: prop_types_default().func,
    onSelectedSectionsChange: prop_types_default().func,
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    required: prop_types_default().bool,
    selectedSections: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        prop_types_default().number
    ]),
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableTime: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    shouldRespectLeadingZeros: prop_types_default().bool,
    size: prop_types_default().oneOf([
        'medium',
        'small'
    ]),
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    style: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    unstableFieldRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().object,
    variant: prop_types_default().oneOf([
        'filled',
        'outlined',
        'standard'
    ])
});
function getDateTimePickerTabsUtilityClass(slot) {
    return generateUtilityClass('MuiDateTimePickerTabs', slot);
}
generateUtilityClasses('MuiDateTimePickerTabs', [
    'root'
]);
const viewToTab = (view)=>{
    if (isDatePickerView(view)) return 'date';
    return 'time';
};
const tabToView = (tab)=>{
    if ('date' === tab) return 'day';
    return 'hours';
};
const DateTimePickerTabs_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getDateTimePickerTabsUtilityClass, classes);
};
const DateTimePickerTabsRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tabs_81f0807c__["default"], {
    name: 'MuiDateTimePickerTabs',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        '&:last-child': {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_Tabs_81f0807c__.tabsClasses.indicator}`]: {
                bottom: 'auto',
                top: 0
            }
        }
    }));
const DateTimePickerTabs_DateTimePickerTabs = function(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePickerTabs'
    });
    const { dateIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DateRangeIcon, {}), onViewChange, timeIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TimeIcon, {}), view, hidden = 'undefined' == typeof window || window.innerHeight < 667, className, sx } = props;
    const localeText = useLocaleText();
    const classes = DateTimePickerTabs_useUtilityClasses(props);
    const handleChange = (event, value)=>{
        onViewChange(tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateTimePickerTabsRoot, {
        ownerState: props,
        variant: "fullWidth",
        value: viewToTab(view),
        onChange: handleChange,
        className: dist_clsx(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tab_d16acec7__["default"], {
                value: "date",
                "aria-label": localeText.dateTableLabel,
                icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tab_d16acec7__["default"], {
                value: "time",
                "aria-label": localeText.timeTableLabel,
                icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};
"production" !== process.env.NODE_ENV && (DateTimePickerTabs_DateTimePickerTabs.propTypes = {
    classes: prop_types_default().object,
    className: prop_types_default().string,
    dateIcon: prop_types_default().node,
    hidden: prop_types_default().bool,
    onViewChange: prop_types_default().func.isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timeIcon: prop_types_default().node,
    view: prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired
});
function getPickersToolbarTextUtilityClass(slot) {
    return generateUtilityClass('MuiPickersToolbarText', slot);
}
const pickersToolbarTextClasses = generateUtilityClasses('MuiPickersToolbarText', [
    'root',
    'selected'
]);
const PickersToolbarText_excluded = [
    "className",
    "selected",
    "value"
];
const PickersToolbarText_useUtilityClasses = (ownerState)=>{
    const { classes, selected } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected'
        ]
    };
    return composeClasses(slots, getPickersToolbarTextUtilityClass, classes);
};
const PickersToolbarTextRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
    name: 'MuiPickersToolbarText',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${pickersToolbarTextClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${pickersToolbarTextClasses.selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const PickersToolbarText_PickersToolbarText = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className, value } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersToolbarText_excluded);
    const classes = PickersToolbarText_useUtilityClasses(props);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarTextRoot, extends_extends({
        ref: ref,
        className: dist_clsx(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});
const PickersToolbarButton_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const PickersToolbarButton_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getPickersToolbarUtilityClass, classes);
};
const PickersToolbarButtonRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
    name: 'MuiPickersToolbarButton',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const PickersToolbarButton_PickersToolbarButton = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align, className, selected, typographyClassName, value, variant, width } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, PickersToolbarButton_excluded);
    const classes = PickersToolbarButton_useUtilityClasses(props);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButtonRoot, extends_extends({
        variant: "text",
        ref: ref,
        className: dist_clsx(className, classes.root)
    }, width ? {
        sx: {
            width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarText_PickersToolbarText, {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});
function getDateTimePickerToolbarUtilityClass(slot) {
    return generateUtilityClass('MuiDateTimePickerToolbar', slot);
}
const dateTimePickerToolbarClasses = generateUtilityClasses('MuiDateTimePickerToolbar', [
    'root',
    'dateContainer',
    'timeContainer',
    'timeDigitsContainer',
    'separator',
    'timeLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);
const DateTimePickerToolbar_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "onChange",
    "view",
    "isLandscape",
    "onViewChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "disabled",
    "readOnly",
    "toolbarVariant",
    "toolbarTitle",
    "className"
];
const DateTimePickerToolbar_useUtilityClasses = (ownerState)=>{
    const { classes, theme, isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        dateContainer: [
            'dateContainer'
        ],
        timeContainer: [
            'timeContainer',
            'rtl' === theme.direction && 'timeLabelReverse'
        ],
        timeDigitsContainer: [
            'timeDigitsContainer',
            'rtl' === theme.direction && 'timeLabelReverse'
        ],
        separator: [
            'separator'
        ],
        ampmSelection: [
            'ampmSelection',
            isLandscape && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return composeClasses(slots, getDateTimePickerToolbarUtilityClass, classes);
};
const DateTimePickerToolbarRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersToolbar_PickersToolbar, {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'space-around',
        position: 'relative',
        variants: [
            {
                props: {
                    toolbarVariant: 'desktop'
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${pickersToolbarClasses.content} .${pickersToolbarTextClasses.selected}`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    isLandscape: true
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    isLandscape: false
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
DateTimePickerToolbarRoot.propTypes = {
    as: prop_types_default().elementType,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    isLandscape: prop_types_default().bool.isRequired,
    isMobileKeyboardViewOpen: prop_types_default().bool,
    landscapeDirection: prop_types_default().oneOf([
        'column',
        'row'
    ]),
    ownerState: prop_types_default().object.isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    toggleMobileKeyboardView: prop_types_default().func,
    toolbarTitle: prop_types_default().node,
    viewType: prop_types_default().oneOf([
        'date',
        'time'
    ])
};
const DateTimePickerToolbarDateContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'DateContainer',
    overridesResolver: (props, styles)=>styles.dateContainer
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
});
const DateTimePickerToolbarTimeContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeContainer',
    overridesResolver: (props, styles)=>styles.timeContainer
})(({ theme })=>extends_extends({
        display: 'flex',
        flexDirection: 'row'
    }, 'rtl' === theme.direction && {
        flexDirection: 'row-reverse'
    }, {
        variants: [
            {
                props: ({ isLandscape, toolbarVariant })=>isLandscape && 'desktop' !== toolbarVariant,
                style: extends_extends({
                    flexDirection: 'column'
                }, 'rtl' === theme.direction && {
                    flexDirection: 'column-reverse'
                })
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    isLandscape: false
                },
                style: {
                    gap: 9,
                    marginRight: 4,
                    alignSelf: 'flex-end'
                }
            }
        ]
    }));
const DateTimePickerToolbarTimeDigitsContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeDigitsContainer',
    overridesResolver: (props, styles)=>styles.timeDigitsContainer
})(({ theme })=>extends_extends({
        display: 'flex'
    }, 'rtl' === theme.direction && {
        flexDirection: 'row-reverse'
    }, {
        variants: [
            {
                props: {
                    toolbarVariant: 'desktop'
                },
                style: {
                    gap: 1.5
                }
            }
        ]
    }));
DateTimePickerToolbarTimeContainer.propTypes = {
    as: prop_types_default().elementType,
    ownerState: prop_types_default().object.isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
};
const DateTimePickerToolbarSeparator = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersToolbarText_PickersToolbarText, {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    margin: '0 4px 0 2px',
    cursor: 'default',
    variants: [
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                margin: 0
            }
        }
    ]
});
const DateTimePickerToolbarAmPmSelection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${dateTimePickerToolbarClasses.ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${dateTimePickerToolbarClasses.ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12,
    [`& .${dateTimePickerToolbarClasses.ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: '4px 0 auto',
                flexDirection: 'row',
                justifyContent: 'space-around',
                width: '100%'
            }
        }
    ]
});
function DateTimePickerToolbar(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePickerToolbar'
    });
    const { ampm, ampmInClock, value, onChange, view, isLandscape, onViewChange, toolbarFormat, toolbarPlaceholder = '––', views, disabled, readOnly, toolbarVariant = 'mobile', toolbarTitle: inToolbarTitle, className } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, DateTimePickerToolbar_excluded);
    const ownerState = props;
    const utils = useUtils_useUtils();
    const { meridiemMode, handleMeridiemChange } = useMeridiemMode(value, ampm, onChange);
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const isDesktop = 'desktop' === toolbarVariant;
    const localeText = useLocaleText();
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const classes = DateTimePickerToolbar_useUtilityClasses(extends_extends({}, ownerState, {
        theme
    }));
    const toolbarTitle = inToolbarTitle ?? localeText.dateTimePickerToolbarTitle;
    const formatHours = (time)=>ampm ? utils.format(time, 'hours12h') : utils.format(time, 'hours24h');
    const dateText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(value, toolbarFormat);
        return utils.format(value, 'shortDate');
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateTimePickerToolbarRoot, extends_extends({
        isLandscape: isLandscape,
        className: dist_clsx(classes.root, className),
        toolbarTitle: toolbarTitle
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes('year') && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>onViewChange('year'),
                        selected: 'year' === view,
                        value: value ? utils.format(value, 'year') : '–'
                    }),
                    views.includes('day') && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                        tabIndex: -1,
                        variant: isDesktop ? 'h5' : 'h4',
                        onClick: ()=>onViewChange('day'),
                        selected: 'day' === view,
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        children: [
                            views.includes('hours') && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && !isLandscape ? MULTI_SECTION_CLOCK_SECTION_WIDTH : void 0,
                                        onClick: ()=>onViewChange('hours'),
                                        selected: 'hours' === view,
                                        value: value ? formatHours(value) : '--'
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && !isLandscape ? MULTI_SECTION_CLOCK_SECTION_WIDTH : void 0,
                                        onClick: ()=>onViewChange('minutes'),
                                        selected: 'minutes' === view || !views.includes('minutes') && 'hours' === view,
                                        value: value ? utils.format(value, 'minutes') : '--',
                                        disabled: !views.includes('minutes')
                                    })
                                ]
                            }),
                            views.includes('seconds') && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && !isLandscape ? MULTI_SECTION_CLOCK_SECTION_WIDTH : void 0,
                                        onClick: ()=>onViewChange('seconds'),
                                        selected: 'seconds' === view,
                                        value: value ? utils.format(value, 'seconds') : '--'
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                                variant: "subtitle2",
                                selected: 'am' === meridiemMode,
                                typographyClassName: classes.ampmLabel,
                                value: formatMeridiem(utils, 'am'),
                                onClick: readOnly ? void 0 : ()=>handleMeridiemChange('am'),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                                variant: "subtitle2",
                                selected: 'pm' === meridiemMode,
                                typographyClassName: classes.ampmLabel,
                                value: formatMeridiem(utils, 'pm'),
                                onClick: readOnly ? void 0 : ()=>handleMeridiemChange('pm'),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PickersToolbarButton_PickersToolbarButton, {
                        variant: "h5",
                        onClick: ()=>onViewChange('meridiem'),
                        selected: 'meridiem' === view,
                        value: value && meridiemMode ? formatMeridiem(utils, meridiemMode) : '--',
                        width: MULTI_SECTION_CLOCK_SECTION_WIDTH
                    })
                ]
            })
        ]
    }));
}
"production" !== process.env.NODE_ENV && (DateTimePickerToolbar.propTypes = {
    ampm: prop_types_default().bool,
    ampmInClock: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    disabled: prop_types_default().bool,
    hidden: prop_types_default().bool,
    isLandscape: prop_types_default().bool.isRequired,
    onChange: prop_types_default().func.isRequired,
    onViewChange: prop_types_default().func.isRequired,
    readOnly: prop_types_default().bool,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    titleId: prop_types_default().string,
    toolbarFormat: prop_types_default().string,
    toolbarPlaceholder: prop_types_default().node,
    toolbarTitle: prop_types_default().node,
    toolbarVariant: prop_types_default().oneOf([
        'desktop',
        'mobile'
    ]),
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired).isRequired
});
function useDateTimePickerDefaultizedProps(props, name) {
    const utils = useUtils_useUtils();
    const defaultDates = useDefaultDates();
    const themeProps = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props,
        name
    });
    const ampm = themeProps.ampm ?? utils.is12HourCycleInCurrentLocale();
    const localeText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return extends_extends({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return extends_extends({}, themeProps, applyDefaultViewProps({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day',
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'day'
    }), {
        ampm,
        localeText,
        orientation: themeProps.orientation ?? 'portrait',
        disableIgnoringDatePartForTimeValidation: themeProps.disableIgnoringDatePartForTimeValidation ?? Boolean(themeProps.minDateTime || themeProps.maxDateTime || themeProps.disablePast || themeProps.disableFuture),
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: applyDefaultDate(utils, themeProps.minDateTime ?? themeProps.minDate, defaultDates.minDate),
        maxDate: applyDefaultDate(utils, themeProps.maxDateTime ?? themeProps.maxDate, defaultDates.maxDate),
        minTime: themeProps.minDateTime ?? themeProps.minTime,
        maxTime: themeProps.maxDateTime ?? themeProps.maxTime,
        slots: extends_extends({
            toolbar: DateTimePickerToolbar,
            tabs: DateTimePickerTabs_DateTimePickerTabs
        }, themeProps.slots),
        slotProps: extends_extends({}, themeProps.slotProps, {
            toolbar: extends_extends({
                ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}
const date_time_utils_excluded = [
    "views",
    "format"
];
const resolveDateTimeFormat = (utils, _ref)=>{
    let { views, format } = _ref, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, date_time_utils_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if (isTimeView(view)) timeViews.push(view);
        else dateViews.push(view);
    });
    if (0 === timeViews.length) return resolveDateFormat(utils, extends_extends({
        views: dateViews
    }, other), false);
    if (0 === dateViews.length) return resolveTimeFormat(utils, extends_extends({
        views: timeViews
    }, other));
    const timeFormat = resolveTimeFormat(utils, extends_extends({
        views: timeViews
    }, other));
    const dateFormat = resolveDateFormat(utils, extends_extends({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!isInternalTimeView(view) || 'hours' === view);
    return ampm ? [
        ...views,
        'meridiem'
    ] : views;
};
const resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function resolveTimeViewsResponse({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm, timeSteps: inTimeSteps, views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = extends_extends({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn,
        timeSteps,
        shouldRenderTimeInASingleColumn,
        views: resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}
function getTimeClockUtilityClass(slot) {
    return generateUtilityClass('MuiTimeClock', slot);
}
generateUtilityClasses('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);
const CLOCK_WIDTH = 220;
const CLOCK_HOUR_WIDTH = 36;
const clockCenter = {
    x: CLOCK_WIDTH / 2,
    y: CLOCK_WIDTH / 2
};
const baseClockPoint = {
    x: clockCenter.x,
    y: 0
};
const cx = baseClockPoint.x - clockCenter.x;
const cy = baseClockPoint.y - clockCenter.y;
const rad2deg = (rad)=>180 / Math.PI * rad;
const getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - clockCenter.x;
    const y = offsetY - clockCenter.y;
    const atan = Math.atan2(cx, cy) - Math.atan2(x, y);
    let deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value,
        distance
    };
};
const getMinutes = (offsetX, offsetY, step = 1)=>{
    const angleStep = 6 * step;
    let { value } = getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const getHours = (offsetX, offsetY, ampm)=>{
    const { value, distance } = getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (ampm) hour %= 12;
    else if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
        hour += 12;
        hour %= 24;
    }
    return hour;
};
function getClockPointerUtilityClass(slot) {
    return generateUtilityClass('MuiClockPointer', slot);
}
generateUtilityClasses('MuiClockPointer', [
    'root',
    'thumb'
]);
const ClockPointer_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const ClockPointer_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return composeClasses(slots, getClockPointerUtilityClass, classes);
};
const ClockPointerRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px',
        variants: [
            {
                props: {
                    shouldAnimate: true
                },
                style: {
                    transition: theme.transitions.create([
                        'transform',
                        'height'
                    ])
                }
            }
        ]
    }));
const ClockPointerThumb = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb',
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${CLOCK_HOUR_WIDTH / 2}px)`,
        border: `${(CLOCK_HOUR_WIDTH - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box',
        variants: [
            {
                props: {
                    hasSelected: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
function ClockPointer(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className, isInner, type, viewValue } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, ClockPointer_excluded);
    const previousType = __WEBPACK_EXTERNAL_MODULE_react__.useRef(type);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = extends_extends({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = ClockPointer_useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = 'hours' === type ? 12 : 60;
        let angle = 360 / max * viewValue;
        if ('hours' === type && viewValue > 12) angle -= 360;
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * CLOCK_WIDTH),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockPointerRoot, extends_extends({
        style: getAngleStyle(),
        className: dist_clsx(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}
function getClockUtilityClass(slot) {
    return generateUtilityClass('MuiClock', slot);
}
generateUtilityClasses('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText'
]);
const Clock_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton'
        ],
        pmButton: [
            'pmButton'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return composeClasses(slots, getClockUtilityClass, classes);
};
const ClockRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const ClockClock = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClock',
    slot: 'Clock',
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const ClockWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClock',
    slot: 'Wrapper',
    overridesResolver: (_, styles)=>styles.wrapper
})({
    '&:focus': {
        outline: 'none'
    }
});
const ClockSquareMask = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClock',
    slot: 'SquareMask',
    overridesResolver: (_, styles)=>styles.squareMask
})({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    touchAction: 'none',
    userSelect: 'none',
    variants: [
        {
            props: {
                disabled: false
            },
            style: {
                '@media (pointer: fine)': {
                    cursor: 'pointer',
                    borderRadius: '50%'
                },
                '&:active': {
                    cursor: 'move'
                }
            }
        }
    ]
});
const ClockPin = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiClock',
    slot: 'Pin',
    overridesResolver: (_, styles)=>styles.pin
})(({ theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const ClockAmButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
    name: 'MuiClock',
    slot: 'AmButton',
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme })=>({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        left: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: CLOCK_HOUR_WIDTH,
        variants: [
            {
                props: {
                    meridiemMode: 'am'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    }));
const ClockPmButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
    name: 'MuiClock',
    slot: 'PmButton',
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme })=>({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        right: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: CLOCK_HOUR_WIDTH,
        variants: [
            {
                props: {
                    meridiemMode: 'pm'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    }));
const ClockMeridiemText = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
    name: 'MuiClock',
    slot: 'meridiemText',
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
function Clock(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm, ampmInClock, autoFocus, children, value, handleMeridiemChange, isTimeDisabled, meridiemMode, minutesStep = 1, onChange, selectedId, type, viewValue, disabled = false, readOnly, className } = props;
    const ownerState = props;
    const utils = useUtils_useUtils();
    const localeText = useLocaleText();
    const isMoving = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const classes = Clock_useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && 'hours' === type && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX, offsetY } = event;
        if (void 0 === offsetX) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = 'seconds' === type || 'minutes' === type ? getMinutes(offsetX, offsetY, minutesStep) : getHours(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const hasSelected = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if ('hours' === type) return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = 'minutes' === type ? minutesStep : 1;
    const listboxRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    useEnhancedEffect(()=>{
        if (autoFocus) listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                handleValueChange(0, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange('minutes' === type ? 59 : 23, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(viewValue + keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(viewValue - keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ClockRoot, {
        className: dist_clsx(className, classes.root),
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockPin, {
                                className: classes.pin
                            }),
                            null != value && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockPointer, {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockAmButton, {
                        onClick: readOnly ? void 0 : ()=>handleMeridiemChange('am'),
                        disabled: disabled || null === meridiemMode,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: formatMeridiem(utils, 'am'),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: formatMeridiem(utils, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockPmButton, {
                        disabled: disabled || null === meridiemMode,
                        onClick: readOnly ? void 0 : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: formatMeridiem(utils, 'pm'),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: formatMeridiem(utils, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}
function getClockNumberUtilityClass(slot) {
    return generateUtilityClass('MuiClockNumber', slot);
}
const clockNumberClasses = generateUtilityClasses('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);
const ClockNumber_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const ClockNumber_useUtilityClasses = (ownerState)=>{
    const { classes, selected, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled'
        ]
    };
    return composeClasses(slots, getClockNumberUtilityClass, classes);
};
const ClockNumberRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${clockNumberClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${clockNumberClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>({
        height: CLOCK_HOUR_WIDTH,
        width: CLOCK_HOUR_WIDTH,
        position: 'absolute',
        left: `calc((100% - ${CLOCK_HOUR_WIDTH}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${clockNumberClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${clockNumberClasses.disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    inner: true
                },
                style: extends_extends({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
function ClockNumber(inProps) {
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className, disabled, index, inner, label, selected } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, ClockNumber_excluded);
    const ownerState = props;
    const classes = ClockNumber_useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = (CLOCK_WIDTH - CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockNumberRoot, extends_extends({
        className: dist_clsx(className, classes.root),
        "aria-disabled": disabled ? true : void 0,
        "aria-selected": selected ? true : void 0,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + (CLOCK_WIDTH - CLOCK_HOUR_WIDTH) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}
const getHourNumbers = ({ ampm, value, getClockNumberText, isDisabled, selectedId, utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (null === currentHours) return false;
        if (ampm) {
            if (12 === hour) return 12 === currentHours || 0 === currentHours;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (0 === hour) label = '00';
        const inner = !ampm && (0 === hour || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockNumber, {
            id: selected ? selectedId : void 0,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const getMinutesNumbers = ({ utils, value, isDisabled, getClockNumberText, selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockNumber, {
            label: label,
            id: selected ? selectedId : void 0,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};
const useClockReferenceDate = ({ value, referenceDate: referenceDateProp, utils, props, timezone })=>{
    const referenceDate = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>singleItemValueManager.getInitialReferenceValue({
            value,
            utils,
            props,
            referenceDate: referenceDateProp,
            granularity: SECTION_TYPE_GRANULARITY.day,
            timezone,
            getTodayDate: ()=>getTodayDate(utils, timezone, 'date')
        }), []);
    return value ?? referenceDate;
};
const TimeClock_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const TimeClock_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return composeClasses(slots, getTimeClockUtilityClass, classes);
};
const TimeClockRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickerViewRoot, {
    name: 'MuiTimeClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const TimeClockArrowSwitcher = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickersArrowSwitcher_PickersArrowSwitcher, {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher',
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
const TimeClock_TimeClock = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const utils = useUtils_useUtils();
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock = false, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, showViewSwitcher, onChange, view: inView, views = TIME_CLOCK_DEFAULT_VIEWS, openTo, onViewChange, focusedView, onFocusedViewChange, className, disabled, readOnly, timezone: timezoneProp } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, TimeClock_excluded);
    const { value, handleValueChange, timezone } = useControlledValueWithTimezone({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange,
        valueManager: singleItemValueManager
    });
    const valueOrReferenceDate = useClockReferenceDate({
        value,
        referenceDate: referenceDateProp,
        utils,
        props,
        timezone
    });
    const localeText = useLocaleText();
    const now = useNow(timezone);
    const { view, setView, previousView, nextView, setValueAndGoToNextView } = useViews({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView,
        onFocusedViewChange
    });
    const { meridiemMode, handleMeridiemChange } = useMeridiemMode(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rawValue, viewType)=>{
        const isAfter = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = 'hours' === viewType || 'minutes' === viewType && views.includes('seconds');
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = convertValueToMeridiem(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = useId();
    const viewProps = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = convertValueToMeridiem(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, 'hours');
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: getHourNumbers({
                            value,
                            utils,
                            ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId
                        })
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish, 'minutes');
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: getMinutesNumbers({
                            utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId
                        })
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish, 'seconds');
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: getMinutesNumbers({
                            utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId
                        })
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = TimeClock_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(TimeClockRoot, extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Clock, extends_extends({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});
"production" !== process.env.NODE_ENV && (TimeClock_TimeClock.propTypes = {
    ampm: prop_types_default().bool,
    ampmInClock: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableIgnoringDatePartForTimeValidation: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    focusedView: prop_types_default().oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    maxTime: prop_types_default().object,
    minTime: prop_types_default().object,
    minutesStep: prop_types_default().number,
    onChange: prop_types_default().func,
    onFocusedViewChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    openTo: prop_types_default().oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    shouldDisableTime: prop_types_default().func,
    showViewSwitcher: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
});
function getDigitalClockUtilityClass(slot) {
    return generateUtilityClass('MuiDigitalClock', slot);
}
const digitalClockClasses = generateUtilityClasses('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);
const DigitalClock_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const DigitalClock_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return composeClasses(slots, getDigitalClockUtilityClass, classes);
};
const DigitalClockRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickerViewRoot, {
    name: 'MuiDigitalClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflowY: 'auto',
    width: '100%',
    '@media (prefers-reduced-motion: no-preference)': {
        scrollBehavior: 'auto'
    },
    maxHeight: DIGITAL_CLOCK_VIEW_HEIGHT,
    variants: [
        {
            props: {
                alreadyRendered: true
            },
            style: {
                '@media (prefers-reduced-motion: no-preference)': {
                    scrollBehavior: 'smooth'
                }
            }
        }
    ]
});
const DigitalClockList = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuList_abce8441__["default"], {
    name: 'MuiDigitalClock',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const DigitalClockItem = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
    name: 'MuiDigitalClock',
    slot: 'Item',
    overridesResolver: (props, styles)=>styles.item
})(({ theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const DigitalClock_DigitalClock = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const utils = useUtils_useUtils();
    const containerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, containerRef);
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm = utils.is12HourCycleInCurrentLocale(), timeStep = 30, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, onChange, view: inView, openTo, onViewChange, focusedView, onFocusedViewChange, className, disabled, readOnly, views = [
        'hours'
    ], skipDisabled = false, timezone: timezoneProp } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, DigitalClock_excluded);
    const { value, handleValueChange: handleRawValueChange, timezone } = useControlledValueWithTimezone({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange,
        valueManager: singleItemValueManager
    });
    const localeText = useLocaleText();
    const now = useNow(timezone);
    const ownerState = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>extends_extends({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = DigitalClock_useUtilityClasses(ownerState);
    const ClockItem = slots?.digitalClockItem ?? DigitalClockItem;
    const clockItemProps = useSlotProps({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = useClockReferenceDate({
        value,
        referenceDate: referenceDateProp,
        utils,
        props,
        timezone
    });
    const handleValueChange = useEventCallback_useEventCallback((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView } = useViews({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView,
        onFocusedViewChange
    });
    const handleItemSelect = useEventCallback_useEventCallback((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null === containerRef.current) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((valueToCheck)=>{
        const isAfter = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        return [
            startOfDay,
            ...Array.from({
                length: Math.ceil(1440 / timeStep) - 1
            }, (_, index)=>utils.addMinutes(startOfDay, timeStep * (index + 1)))
        ];
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>utils.isEqual(option, valueOrReferenceDate));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DigitalClockRoot, extends_extends({
        ref: handleRef,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DigitalClockList, {
            role: "listbox",
            "aria-label": localeText.timePickerToolbarTitle,
            className: classes.list,
            children: timeOptions.map((option, index)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                const formattedValue = utils.format(option, ampm ? 'fullTime12h' : 'fullTime24h');
                const tabIndex = focusedOptionIndex === index || -1 === focusedOptionIndex && 0 === index ? 0 : -1;
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockItem, extends_extends({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex
                }, clockItemProps, {
                    children: formattedValue
                }), formattedValue);
            })
        })
    }));
});
"production" !== process.env.NODE_ENV && (DigitalClock_DigitalClock.propTypes = {
    ampm: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableIgnoringDatePartForTimeValidation: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    focusedView: prop_types_default().oneOf([
        'hours'
    ]),
    maxTime: prop_types_default().object,
    minTime: prop_types_default().object,
    minutesStep: prop_types_default().number,
    onChange: prop_types_default().func,
    onFocusedViewChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    openTo: prop_types_default().oneOf([
        'hours'
    ]),
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    shouldDisableTime: prop_types_default().func,
    skipDisabled: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timeStep: prop_types_default().number,
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'hours'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'hours'
    ]))
});
function getMultiSectionDigitalClockUtilityClass(slot) {
    return generateUtilityClass('MuiMultiSectionDigitalClock', slot);
}
const multiSectionDigitalClockClasses = generateUtilityClasses('MuiMultiSectionDigitalClock', [
    'root'
]);
function getMultiSectionDigitalClockSectionUtilityClass(slot) {
    return generateUtilityClass('MuiMultiSectionDigitalClockSection', slot);
}
const multiSectionDigitalClockSectionClasses = generateUtilityClasses('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);
const MultiSectionDigitalClockSection_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const MultiSectionDigitalClockSection_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return composeClasses(slots, getMultiSectionDigitalClockSectionUtilityClass, classes);
};
const MultiSectionDigitalClockSectionRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuList_abce8441__["default"], {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        maxHeight: DIGITAL_CLOCK_VIEW_HEIGHT,
        width: 56,
        padding: 0,
        overflow: 'hidden',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        '&::after': {
            display: 'block',
            content: '""',
            height: 'calc(100% - 40px - 6px)'
        },
        variants: [
            {
                props: {
                    alreadyRendered: true
                },
                style: {
                    '@media (prefers-reduced-motion: no-preference)': {
                        scrollBehavior: 'smooth'
                    }
                }
            }
        ]
    }));
const MultiSectionDigitalClockSectionItem = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item',
    overridesResolver: (_, styles)=>styles.item
})(({ theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: MULTI_SECTION_CLOCK_SECTION_WIDTH,
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const MultiSectionDigitalClockSection_MultiSectionDigitalClockSection = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const containerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, containerRef);
    const previousActive = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus, onChange, className, disabled, readOnly, items, active, slots, slotProps, skipDisabled } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, MultiSectionDigitalClockSection_excluded);
    const ownerState = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>extends_extends({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = MultiSectionDigitalClockSection_useUtilityClasses(ownerState);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? MultiSectionDigitalClockSectionItem;
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (null === containerRef.current) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MultiSectionDigitalClockSectionRoot, extends_extends({
        ref: handleRef,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox"
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || -1 === focusedOptionIndex && 0 === index ? 0 : -1;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DigitalClockSectionItem, extends_extends({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || void 0,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});
const getHourSectionOptions = ({ now, value, utils, ampm, isDisabled, resolveAriaLabel, timeStep, valueOrReferenceDate })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (null === resolvedCurrentHours) return false;
        if (ampm) {
            if (12 === hour) return 12 === resolvedCurrentHours || 0 === resolvedCurrentHours;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>isSelected(hour, utils.getHours(valueOrReferenceDate));
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label,
            isSelected,
            isDisabled,
            isFocused,
            ariaLabel
        });
    }
    return result;
};
const getTimeSectionOptions = ({ value, utils, isDisabled, timeStep, resolveLabel, resolveAriaLabel, hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (null === value) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>value === timeValue;
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled,
                isSelected,
                isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};
const MultiSectionDigitalClock_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const MultiSectionDigitalClock_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getMultiSectionDigitalClockUtilityClass, classes);
};
const MultiSectionDigitalClockRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(PickerViewRoot, {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const MultiSectionDigitalClock_MultiSectionDigitalClock = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const utils = useUtils_useUtils();
    const props = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo, onViewChange, focusedView: inFocusedView, onFocusedViewChange, className, disabled, readOnly, skipDisabled = false, timezone: timezoneProp } = props, other = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, MultiSectionDigitalClock_excluded);
    const { value, handleValueChange: handleRawValueChange, timezone } = useControlledValueWithTimezone({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        onChange,
        valueManager: singleItemValueManager
    });
    const localeText = useLocaleText();
    const now = useNow(timezone);
    const timeSteps = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>extends_extends({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = useClockReferenceDate({
        value,
        referenceDate: referenceDateProp,
        utils,
        props,
        timezone
    });
    const handleValueChange = useEventCallback_useEventCallback((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view, setValueAndGoToNextView, focusedView } = useViews({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange
    });
    const handleMeridiemValueChange = useEventCallback_useEventCallback((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode, handleMeridiemChange } = useMeridiemMode(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rawValue, viewType)=>{
        const isAfter = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = 'hours' === viewType || 'minutes' === viewType && views.includes('seconds');
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = convertValueToMeridiem(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = convertValueToMeridiem(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: getHourSectionOptions({
                        now,
                        value,
                        ampm,
                        utils,
                        isDisabled: (hours)=>isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: localeText.hoursClockNumberText,
                        valueOrReferenceDate
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: getTimeSectionOptions({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: getTimeSectionOptions({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = formatMeridiem(utils, 'am');
                    const pmLabel = formatMeridiem(utils, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && 'am' === meridiemMode,
                                isFocused: ()=>!!valueOrReferenceDate && 'am' === meridiemMode,
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && 'pm' === meridiemMode,
                                isFocused: ()=>!!valueOrReferenceDate && 'pm' === meridiemMode,
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewTimeOptions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>views.reduce((result, currentView)=>extends_extends({}, result, {
                [currentView]: buildViewProps(currentView)
            }), {}), [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = MultiSectionDigitalClock_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MultiSectionDigitalClockRoot, extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: Object.entries(viewTimeOptions).map(([timeView, viewOptions])=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MultiSectionDigitalClockSection_MultiSectionDigitalClockSection, {
                items: viewOptions.items,
                onChange: viewOptions.onChange,
                active: view === timeView,
                autoFocus: autoFocus ?? focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": localeText.selectViewText(timeView)
            }, timeView))
    }));
});
"production" !== process.env.NODE_ENV && (MultiSectionDigitalClock_MultiSectionDigitalClock.propTypes = {
    ampm: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableIgnoringDatePartForTimeValidation: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    focusedView: prop_types_default().oneOf([
        'hours',
        'meridiem',
        'minutes',
        'seconds'
    ]),
    maxTime: prop_types_default().object,
    minTime: prop_types_default().object,
    minutesStep: prop_types_default().number,
    onChange: prop_types_default().func,
    onFocusedViewChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    openTo: prop_types_default().oneOf([
        'hours',
        'meridiem',
        'minutes',
        'seconds'
    ]),
    readOnly: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    shouldDisableTime: prop_types_default().func,
    skipDisabled: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timeSteps: prop_types_default().shape({
        hours: prop_types_default().number,
        minutes: prop_types_default().number,
        seconds: prop_types_default().number
    }),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'hours',
        'meridiem',
        'minutes',
        'seconds'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'hours',
        'meridiem',
        'minutes',
        'seconds'
    ]).isRequired)
});
const renderTimeViewClock = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, ampmInClock, slots, slotProps, readOnly, disabled, sx, autoFocus, showViewSwitcher, disableIgnoringDatePartForTimeValidation, timezone })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TimeClock_TimeClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && isTimeView(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter(isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const renderDigitalClockTimeView = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, slots, slotProps, readOnly, disabled, sx, autoFocus, disableIgnoringDatePartForTimeValidation, timeSteps, skipDisabled, timezone })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DigitalClock_DigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter(isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const renderMultiSectionDigitalClockTimeView = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, slots, slotProps, readOnly, disabled, sx, autoFocus, disableIgnoringDatePartForTimeValidation, timeSteps, skipDisabled, timezone })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MultiSectionDigitalClock_MultiSectionDigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter(isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
function DesktopDateTimePickerLayout(props) {
    const { toolbar, tabs, content, actionBar, shortcuts } = PickersLayout_usePickerLayout(props);
    const { sx, className, isLandscape, ref } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersLayoutRoot, {
        ref: ref,
        className: dist_clsx(className, pickersLayoutClasses.root),
        sx: [
            {
                [`& .${pickersLayoutClasses.tabs}`]: {
                    gridRow: 4,
                    gridColumn: '1 / 4'
                },
                [`& .${pickersLayoutClasses.actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: props,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PickersLayoutContentWrapper, {
                className: pickersLayoutClasses.contentWrapper,
                sx: {
                    display: 'grid'
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], {
                        sx: {
                            gridRow: 3,
                            gridColumn: '1 / 4'
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
}
"production" !== process.env.NODE_ENV && (DesktopDateTimePickerLayout.propTypes = {
    children: prop_types_default().node,
    classes: prop_types_default().object,
    className: prop_types_default().string,
    disabled: prop_types_default().bool,
    isLandscape: prop_types_default().bool.isRequired,
    isValid: prop_types_default().func.isRequired,
    onAccept: prop_types_default().func.isRequired,
    onCancel: prop_types_default().func.isRequired,
    onChange: prop_types_default().func.isRequired,
    onClear: prop_types_default().func.isRequired,
    onClose: prop_types_default().func.isRequired,
    onDismiss: prop_types_default().func.isRequired,
    onOpen: prop_types_default().func.isRequired,
    onSelectShortcut: prop_types_default().func.isRequired,
    onSetToday: prop_types_default().func.isRequired,
    onViewChange: prop_types_default().func.isRequired,
    orientation: prop_types_default().oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    value: prop_types_default().any,
    view: prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired).isRequired,
    wrapperVariant: prop_types_default().oneOf([
        'desktop',
        'mobile'
    ])
});
const DesktopDateTimePicker_excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const DesktopDateTimePicker_rendererInterceptor = function(inViewRenderers, popperView, rendererProps) {
    const { openTo, focusedView, timeViewsCount } = rendererProps, otherProps = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(rendererProps, DesktopDateTimePicker_excluded);
    const finalProps = extends_extends({}, otherProps, {
        focusedView: null,
        sx: [
            {
                [`&.${multiSectionDigitalClockClasses.root}`]: {
                    borderBottom: 0
                },
                [`&.${multiSectionDigitalClockClasses.root}, .${multiSectionDigitalClockSectionClasses.root}, &.${digitalClockClasses.root}`]: {
                    maxHeight: VIEW_HEIGHT
                }
            }
        ]
    });
    const isTimeViewActive = isInternalTimeView(popperView);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
        children: [
            inViewRenderers[!isTimeViewActive ? popperView : 'day']?.(extends_extends({}, rendererProps, {
                view: isTimeViewActive ? 'day' : popperView,
                focusedView: focusedView && isDatePickerView(focusedView) ? focusedView : null,
                views: rendererProps.views.filter(isDatePickerView),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    inViewRenderers[isTimeViewActive ? popperView : 'hours']?.(extends_extends({}, finalProps, {
                        view: isTimeViewActive ? popperView : 'hours',
                        focusedView: focusedView && isInternalTimeView(focusedView) ? focusedView : null,
                        openTo: isInternalTimeView(openTo) ? openTo : 'hours',
                        views: rendererProps.views.filter(isInternalTimeView),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
const DesktopDateTimePicker_DesktopDateTimePicker = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const localeText = useLocaleText();
    const utils = useUtils_useUtils();
    const defaultizedProps = useDateTimePickerDefaultizedProps(inProps, 'MuiDesktopDateTimePicker');
    const { shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn, views: resolvedViews, timeSteps } = resolveTimeViewsResponse(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? renderDigitalClockTimeView : renderMultiSectionDigitalClockTimeView;
    const viewRenderers = extends_extends({
        day: renderDateViewCalendar,
        month: renderDateViewCalendar,
        year: renderDateViewCalendar,
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === renderMultiSectionDigitalClockTimeView.name;
    const views = shouldHoursRendererContainMeridiemView ? resolvedViews : resolvedViews.filter((view)=>'meridiem' !== view);
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        'accept'
    ];
    const props = extends_extends({}, defaultizedProps, {
        viewRenderers,
        format: resolveDateTimeFormat(utils, defaultizedProps),
        views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock,
        timeSteps,
        thresholdToRenderTimeInASingleColumn,
        shouldRenderTimeInASingleColumn,
        slots: extends_extends({
            field: DateTimeField_DateTimeField,
            layout: DesktopDateTimePickerLayout,
            openPickerIcon: CalendarIcon
        }, defaultizedProps.slots),
        slotProps: extends_extends({}, defaultizedProps.slotProps, {
            field: (ownerState)=>extends_extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps), {
                    ref
                }),
            toolbar: extends_extends({
                hidden: true,
                ampmInClock,
                toolbarVariant: 'desktop'
            }, defaultizedProps.slotProps?.toolbar),
            tabs: extends_extends({
                hidden: true
            }, defaultizedProps.slotProps?.tabs),
            actionBar: (ownerState)=>extends_extends({
                    actions: actionBarActions
                }, resolveComponentProps(defaultizedProps.slotProps?.actionBar, ownerState))
        })
    });
    const { renderPicker } = useDesktopPicker({
        props,
        valueManager: singleItemValueManager,
        valueType: 'date-time',
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: validateDateTime,
        rendererInterceptor: DesktopDateTimePicker_rendererInterceptor
    });
    return renderPicker();
});
DesktopDateTimePicker_DesktopDateTimePicker.propTypes = {
    ampm: prop_types_default().bool,
    ampmInClock: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    className: prop_types_default().string,
    closeOnSelect: prop_types_default().bool,
    dayOfWeekFormatter: prop_types_default().func,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disableIgnoringDatePartForTimeValidation: prop_types_default().bool,
    disableOpenPicker: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    displayWeekNumber: prop_types_default().bool,
    enableAccessibleFieldDOMStructure: prop_types_default().any,
    fixedWeekNumber: prop_types_default().number,
    format: prop_types_default().string,
    formatDensity: prop_types_default().oneOf([
        'dense',
        'spacious'
    ]),
    inputRef: refType,
    label: prop_types_default().node,
    loading: prop_types_default().bool,
    localeText: prop_types_default().object,
    maxDate: prop_types_default().object,
    maxDateTime: prop_types_default().object,
    maxTime: prop_types_default().object,
    minDate: prop_types_default().object,
    minDateTime: prop_types_default().object,
    minTime: prop_types_default().object,
    minutesStep: prop_types_default().number,
    monthsPerRow: prop_types_default().oneOf([
        3,
        4
    ]),
    name: prop_types_default().string,
    onAccept: prop_types_default().func,
    onChange: prop_types_default().func,
    onClose: prop_types_default().func,
    onError: prop_types_default().func,
    onMonthChange: prop_types_default().func,
    onOpen: prop_types_default().func,
    onSelectedSectionsChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    onYearChange: prop_types_default().func,
    open: prop_types_default().bool,
    openTo: prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    orientation: prop_types_default().oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: prop_types_default().bool,
    reduceAnimations: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    renderLoading: prop_types_default().func,
    selectedSections: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        prop_types_default().number
    ]),
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableTime: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    showDaysOutsideCurrentMonth: prop_types_default().bool,
    skipDisabled: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    thresholdToRenderTimeInASingleColumn: prop_types_default().number,
    timeSteps: prop_types_default().shape({
        hours: prop_types_default().number,
        minutes: prop_types_default().number,
        seconds: prop_types_default().number
    }),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    viewRenderers: prop_types_default().shape({
        day: prop_types_default().func,
        hours: prop_types_default().func,
        meridiem: prop_types_default().func,
        minutes: prop_types_default().func,
        month: prop_types_default().func,
        seconds: prop_types_default().func,
        year: prop_types_default().func
    }),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    yearsPerRow: prop_types_default().oneOf([
        3,
        4
    ])
};
const desktop_date_time_picker_DesktopDateTimePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slots, slotProps, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DesktopDateTimePicker_DesktopDateTimePicker, {
        slots: {
            openPickerIcon: CalendarOutlined,
            ...slots
        },
        slotProps: {
            textField: {
                id
            },
            ...slotProps
        },
        viewRenderers: {
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock
        },
        ...rest,
        ref: ref
    });
});
const MobileDateTimePicker_MobileDateTimePicker = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const localeText = useLocaleText();
    const utils = useUtils_useUtils();
    const defaultizedProps = useDateTimePickerDefaultizedProps(inProps, 'MuiMobileDateTimePicker');
    const viewRenderers = extends_extends({
        day: renderDateViewCalendar,
        month: renderDateViewCalendar,
        year: renderDateViewCalendar,
        hours: renderTimeViewClock,
        minutes: renderTimeViewClock,
        seconds: renderTimeViewClock
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    const props = extends_extends({}, defaultizedProps, {
        viewRenderers,
        format: resolveDateTimeFormat(utils, defaultizedProps),
        ampmInClock,
        slots: extends_extends({
            field: DateTimeField_DateTimeField
        }, defaultizedProps.slots),
        slotProps: extends_extends({}, defaultizedProps.slotProps, {
            field: (ownerState)=>extends_extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps), {
                    ref
                }),
            toolbar: extends_extends({
                hidden: false,
                ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: extends_extends({
                hidden: false
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker } = useMobilePicker({
        props,
        valueManager: singleItemValueManager,
        valueType: 'date-time',
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: validateDateTime
    });
    return renderPicker();
});
MobileDateTimePicker_MobileDateTimePicker.propTypes = {
    ampm: prop_types_default().bool,
    ampmInClock: prop_types_default().bool,
    autoFocus: prop_types_default().bool,
    className: prop_types_default().string,
    closeOnSelect: prop_types_default().bool,
    dayOfWeekFormatter: prop_types_default().func,
    defaultValue: prop_types_default().object,
    disabled: prop_types_default().bool,
    disableFuture: prop_types_default().bool,
    disableHighlightToday: prop_types_default().bool,
    disableIgnoringDatePartForTimeValidation: prop_types_default().bool,
    disableOpenPicker: prop_types_default().bool,
    disablePast: prop_types_default().bool,
    displayWeekNumber: prop_types_default().bool,
    enableAccessibleFieldDOMStructure: prop_types_default().any,
    fixedWeekNumber: prop_types_default().number,
    format: prop_types_default().string,
    formatDensity: prop_types_default().oneOf([
        'dense',
        'spacious'
    ]),
    inputRef: refType,
    label: prop_types_default().node,
    loading: prop_types_default().bool,
    localeText: prop_types_default().object,
    maxDate: prop_types_default().object,
    maxDateTime: prop_types_default().object,
    maxTime: prop_types_default().object,
    minDate: prop_types_default().object,
    minDateTime: prop_types_default().object,
    minTime: prop_types_default().object,
    minutesStep: prop_types_default().number,
    monthsPerRow: prop_types_default().oneOf([
        3,
        4
    ]),
    name: prop_types_default().string,
    onAccept: prop_types_default().func,
    onChange: prop_types_default().func,
    onClose: prop_types_default().func,
    onError: prop_types_default().func,
    onMonthChange: prop_types_default().func,
    onOpen: prop_types_default().func,
    onSelectedSectionsChange: prop_types_default().func,
    onViewChange: prop_types_default().func,
    onYearChange: prop_types_default().func,
    open: prop_types_default().bool,
    openTo: prop_types_default().oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    orientation: prop_types_default().oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: prop_types_default().bool,
    reduceAnimations: prop_types_default().bool,
    referenceDate: prop_types_default().object,
    renderLoading: prop_types_default().func,
    selectedSections: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        prop_types_default().number
    ]),
    shouldDisableDate: prop_types_default().func,
    shouldDisableMonth: prop_types_default().func,
    shouldDisableTime: prop_types_default().func,
    shouldDisableYear: prop_types_default().func,
    showDaysOutsideCurrentMonth: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    timezone: prop_types_default().string,
    value: prop_types_default().object,
    view: prop_types_default().oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    viewRenderers: prop_types_default().shape({
        day: prop_types_default().func,
        hours: prop_types_default().func,
        minutes: prop_types_default().func,
        month: prop_types_default().func,
        seconds: prop_types_default().func,
        year: prop_types_default().func
    }),
    views: prop_types_default().arrayOf(prop_types_default().oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    yearsPerRow: prop_types_default().oneOf([
        3,
        4
    ])
};
const mobile_date_time_picker_MobileDateTimePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slotProps, disabled, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MobileDateTimePicker_MobileDateTimePicker, {
        slotProps: {
            textField: {
                id,
                ...generateCustomTextFieldStyle(disabled)
            },
            tabs: {
                hidden: false,
                dateIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CalendarOutlined, {}),
                timeIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ClockOutlined, {})
            },
            ...slotProps
        },
        disabled: disabled,
        ...rest,
        ref: ref
    });
});
const date_time_picker_DateTimePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isMobile, ...rest }, ref) {
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(mobile_date_time_picker_MobileDateTimePicker, {
        ...rest,
        ref: ref
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(desktop_date_time_picker_DesktopDateTimePicker, {
        ...rest,
        ref: ref
    });
});
const DialogGridContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    gap: Spacing["1500"],
    textAlign: alignment_Alignment.center
});
const DialogIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    textAlign: alignment_Alignment.center
});
function dialog_Dialog({ id, children, title, description, primaryButton, secondaryButton, icon, iconAlignment = "center", maxWidth, onCloseButtonClick, closeButtonWrappperProps, centerButtons, customDialogActions, customTitle, ...rest }) {
    const titleVariant = "sm" === maxWidth || "xs" === maxWidth ? "h6" : "h5";
    const descriptionVariant = "sm" === maxWidth || "xs" === maxWidth ? "body2" : "body1";
    const buttonAlignment = centerButtons ? "align-center" : "align-end";
    const dialogActions = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (customDialogActions) return customDialogActions;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogActions_c3764e69__["default"], {
            children: [
                secondaryButton && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                    ...secondaryButton
                }),
                primaryButton && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                    ...primaryButton
                })
            ]
        });
    }, [
        customDialogActions,
        primaryButton,
        secondaryButton
    ]);
    const dialogTitle = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (customTitle) return customTitle;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogTitle_112a25af__["default"], {
            component: titleVariant,
            children: title
        });
    }, [
        customTitle,
        title
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__["default"], {
        ...rest,
        maxWidth: maxWidth,
        id: id,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                display: displaying_Displaying.flex,
                justifyContent: alignment_Alignment.flexEnd,
                ...closeButtonWrappperProps,
                children: onCloseButtonClick ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                    size: "small",
                    onClick: onCloseButtonClick,
                    id: "dialog-close-button",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TimesSolid, {})
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DialogGridContainer, {
                container: true,
                children: [
                    icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "inner-icon",
                            style: {
                                textAlign: iconAlignment
                            },
                            children: icon
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: dialogTitle
                    }),
                    description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                            variant: descriptionVariant,
                            color: "textSecondary",
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogContent_37fd6d87__["default"], {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        className: buttonAlignment,
                        item: true,
                        children: dialogActions
                    })
                ]
            })
        ]
    });
}
function isArrayPopulated(collection) {
    const MIN_LENGTH = 1;
    const collectionSize = collection.length;
    return collectionSize >= MIN_LENGTH;
}
var dropzone_enum_DropzonePhase = /*#__PURE__*/ function(DropzonePhase) {
    DropzonePhase["Empty"] = "empty";
    DropzonePhase["Loading"] = "loading";
    DropzonePhase["SelectedFiles"] = "selected";
    DropzonePhase["ConfirmedFiles"] = "confirmed";
    DropzonePhase["Invalid"] = "error";
    DropzonePhase["Valid"] = "success";
    return DropzonePhase;
}({});
const CustomDropzone = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(function({ theme, status }) {
    const dropzoneStyle = computeDropzoneStyle(theme, status);
    return dropzoneStyle;
});
function computeDropzoneStyle(theme, status) {
    const isStatusValid = status?.phase === dropzone_enum_DropzonePhase.Valid;
    const isStatusInvalid = status?.phase === dropzone_enum_DropzonePhase.Invalid;
    const isStatusError = status?.phase === dropzone_enum_DropzonePhase.Invalid;
    const isBackgroundTransparent = status?.phase === dropzone_enum_DropzonePhase.Empty;
    const isStatusValidOrInvalid = isStatusInvalid || isStatusValid;
    let borderColor = theme.palette.primary.main;
    let borderColorHovered = theme.palette.primary.dark;
    const borderStyle = isStatusValidOrInvalid ? border_style_BorderStyle.solid : border_style_BorderStyle.dashed;
    if (isStatusValid) {
        borderColor = theme.palette.success.main;
        borderColorHovered = theme.palette.success.dark;
    } else if (isStatusError) {
        borderColor = theme.palette.error.main;
        borderColorHovered = theme.palette.error.dark;
    }
    const borderStyled = getBorderStyle(borderStyle, borderColor);
    const borderHovered = getBorderStyle(borderStyle, borderColorHovered);
    const backgroundColor = isBackgroundTransparent ? TRANSPARENT_COLOR : theme.palette.background.paper;
    const dropzoneStyle = {
        border: borderStyled,
        flex: "1 0 0",
        borderRadius: theme.spacing(2),
        padding: theme.spacing(7),
        textAlign: alignment_Alignment.center,
        backgroundColor,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer,
            border: borderHovered
        }
    };
    return dropzoneStyle;
}
function getBorderStyle(style, borderColor) {
    return `${ONE_PIXEL_REM} ${style} ${borderColor}`;
}
function parseErrorMessage(error) {
    return `${isError(error) ? error.message : error}`;
}
function handleOnDropEventAndReturnNewStatus(acceptedFiles, fileRejections, event, onDrop, onDropError) {
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.SelectedFiles, mapAcceptedFiles(acceptedFiles));
    if (!isFunction(onDrop)) return newStatus;
    try {
        onDrop(acceptedFiles, fileRejections, event);
        return newStatus;
    } catch (onDropCallbackError) {
        handleCallbackError(onDropCallbackError, onDropError);
        return createNewStatus(dropzone_enum_DropzonePhase.Invalid, mapAcceptedFiles(acceptedFiles), parseErrorMessage(onDropCallbackError));
    }
}
async function handleOnConfirmEventAndReturnNewStatus(files, onConfirm, onConfirmError) {
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.ConfirmedFiles, mapAcceptedFiles(files ?? []));
    if (!isFunction(onConfirm)) return newStatus;
    try {
        await onConfirm(files);
        return newStatus;
    } catch (onConfirmCallbackError) {
        handleCallbackError(onConfirmCallbackError, onConfirmError);
        return createNewStatus(dropzone_enum_DropzonePhase.Invalid, mapAcceptedFiles(files ?? []), parseErrorMessage(onConfirmCallbackError));
    }
}
async function handleClearButtonClickEventAndReturnNewStatus(event, onClear, onClearError) {
    event.stopPropagation();
    event.preventDefault();
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.Empty);
    if (!isFunction(onClear)) return newStatus;
    try {
        onClear();
    } catch (onClearCallbackError) {
        handleCallbackError(onClearCallbackError, onClearError);
    }
    return null;
}
function handleModifyButtonEventAndReturnNewStatus(dropzoneStatus, onModify, onModifyError) {
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.SelectedFiles, dropzoneStatus.acceptedFiles);
    if (isFunction(onModify)) try {
        onModify();
    } catch (onModifyCallbackError) {
        handleCallbackError(onModifyCallbackError, onModifyError);
    }
    return newStatus;
}
function createNewStatus(phase, acceptedFiles, message) {
    return {
        phase,
        acceptedFiles: acceptedFiles ?? [],
        message
    };
}
function handleCallbackError(error, errorCallback) {
    if (isFunction(errorCallback)) errorCallback(error);
}
function mapAcceptedFiles(acceptedFiles) {
    return acceptedFiles.map((f)=>({
            file: f,
            url: URL.createObjectURL(f)
        }));
}
const CustomTrashIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.end
});
function DropzoneClearButton({ onClick, clearButtonId }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomTrashIconContainer, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
            id: clearButtonId,
            className: "clear-button",
            color: "default",
            size: "small",
            onClick: onClick,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TrashOutlined, {
                color: "action"
            })
        })
    });
}
function Progress({ hideLabel, value, labelSize, ...rest }) {
    if (hideLabel) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
        value: value,
        ...rest
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        position: positioning_Positioning.relative,
        display: displaying_Displaying.inlineFlex,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
                value: value,
                ...rest
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: displaying_Displaying.flex,
                alignItems: alignment_Alignment.center,
                justifyContent: alignment_Alignment.center,
                position: positioning_Positioning.absolute,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                    variant: "caption",
                    component: "div",
                    color: "textSecondary",
                    fontSize: labelSize,
                    children: `${Math.round(value)}%`
                })
            })
        ]
    });
}
const modifyButtonDefaultText = "Modifica Documento";
const confirmButtonDefaultText = "Conferma Documento";
const defaultUploadButtonText = "Carica Documento";
const defaultLoadingText = "Caricamento...";
const SEE_FILE_PREVIEW = "Vedi anteprima";
const LETTER_SPACING_0_1 = "0.1px";
const TooltipTitleTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    lineHeight: "157%",
    fontSize: Spacing["875"],
    letterSpacing: LETTER_SPACING_0_1,
    fontWeight: typography_FontWeight.bold
});
const TooltipDescriptionTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    letterSpacing: typography_LetterSpacing.wider
});
function TooltipContainerText({ title, description }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipTitleTypographyContainer, {
                className: "tooltip-title",
                variant: "subtitle2",
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipDescriptionTypographyContainer, {
                className: "tooltip-description",
                variant: "caption",
                children: description
            })
        ]
    });
}
function Tooltip({ children, title, description, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tooltip_69cc2f11__["default"], {
        title: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipContainerText, {
            title: title,
            description: description
        }),
        ...rest,
        children: children
    });
}
function FilePreview({ fileType, fileUrl, fileName }) {
    if (fileType.includes("image") && fileUrl) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
        src: fileUrl,
        alt: `file preview ${fileName}`,
        style: {
            maxWidth: Spacing["12500"],
            maxHeight: Spacing["12500"]
        },
        "data-testid": "file-image-preview"
    });
    if (fileType.includes("pdf")) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PDFFileOutlined, {
        color: "primary",
        style: {
            width: Spacing["2180"],
            height: Spacing["2180"]
        },
        "data-testid": "pdf-file-outlined-icon"
    });
    if (fileType.includes("zip")) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ZipOutlined, {
        style: {
            fontSize: Spacing["2180"]
        },
        color: palette_Primary.main,
        "data-testid": "zip-file-outlined-icon"
    });
    if (fileType.includes("video")) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(VideoPlayOutlined, {
        color: "primary",
        style: {
            width: Spacing["2180"],
            height: Spacing["2180"]
        },
        "data-testid": "video-play-outlined-icon"
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileOutlined, {
        color: "primary",
        style: {
            width: Spacing["2180"],
            height: Spacing["2180"]
        },
        "data-testid": "file-outlined-icon"
    });
}
function FileDetailsPreview({ file, url, shouldShowTooltip }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
        placement: "bottom",
        description: SEE_FILE_PREVIEW,
        open: shouldShowTooltip,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilePreview, {
                    fileType: file.type,
                    fileUrl: url,
                    fileName: file.name
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                    color: "textSecondary",
                    fontSize: typography_FontSize.xs,
                    "data-testid": `${file.name}-typography-file-details-preview`,
                    children: file.name
                })
            ]
        }, `${file.name}-${file.size}-${file.type}`)
    }, `see-file-preview-tooltip_${file.name}`);
}
const file_details_preview = FileDetailsPreview;
function toFilePreview({ fileWithUrl, shouldShowTooltip }) {
    const { file, url } = fileWithUrl;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(file_details_preview, {
        shouldShowTooltip: shouldShowTooltip,
        file,
        url
    }, `file-details-preview-${file.name}`);
}
const to_file_preview = toFilePreview;
const FilePreviewContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    padding: `${Spacing["1500"]} 0px`,
    flexDirection: direction_Direction.row,
    justifyContent: alignment_Alignment.center,
    alignItems: alignment_Alignment.center,
    gap: Spacing["2000"]
});
function DropzonePreviewer({ acceptedFiles, shouldShowTooltip }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilePreviewContainer, {
        "data-testid": "styled-dropzone-previewer",
        children: acceptedFiles.map((acceptedFile)=>to_file_preview({
                fileWithUrl: acceptedFile,
                shouldShowTooltip
            }))
    });
}
const CustomDropzoneContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    padding: `${Spacing["1500"]} 0px`,
    flexDirection: direction_Direction.column,
    justifyContent: alignment_Alignment.center,
    alignItems: alignment_Alignment.center,
    gap: Spacing["2000"]
});
const MemoizedLoadingPhase = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(function({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Progress, {
                variant: "indeterminate",
                value: 0,
                hideLabel: true,
                size: Spacing["2000"],
                color: "secondary"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "textSecondary",
                fontSize: typography_FontSize.xs,
                children: children
            })
        ]
    });
});
const MemoizeDropPhase = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(function({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UploadAltSolid, {
                color: "primary",
                scale: Spacing["2000"]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                color: "primary",
                variant: "outlined",
                size: "small",
                endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InboxUploadOutlined, {}),
                children: children
            })
        ]
    });
});
function DropzoneContainer({ uploadButtonText, isLoading, loadingText, acceptedFiles, shouldShowTooltip }) {
    const hasFiles = acceptedFiles && acceptedFiles.length > 0;
    const showOnlyFilePreview = !isLoading && hasFiles;
    if (showOnlyFilePreview) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzonePreviewer, {
        acceptedFiles: acceptedFiles,
        shouldShowTooltip: shouldShowTooltip
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomDropzoneContainer, {
        children: isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MemoizedLoadingPhase, {
            children: loadingText ?? defaultLoadingText
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MemoizeDropPhase, {
            children: uploadButtonText ?? defaultUploadButtonText
        })
    });
}
const CustomDropzoneMessageContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ theme, color })=>{
    const selectedColor = color === dropzone_enum_DropzonePhase.Valid ? theme.palette.success.main : theme.palette.error.main;
    return {
        color: selectedColor,
        display: displaying_Displaying.flex,
        padding: `${theme.spacing(2)} 0px`,
        flexDirection: direction_Direction.row,
        justifyContent: alignment_Alignment.center,
        alignItems: alignment_Alignment.center
    };
});
function DropzoneMessage({ message, color }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomDropzoneMessageContainer, {
        className: "dropzone-message",
        color: color,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: "caption",
            children: message
        })
    });
}
function dropzone_Dropzone({ status, uploadButtonText, loadingText, modifyButtonText, confirmButtonText, onDrop, onDropError, onClear, onClearError, onConfirm, onConfirmError, onModify, onModifyError, onClickMobile, clearButtonId, id, onClickPreviewHandler, enableShowFilePreviewTooltip = true, ...rest }) {
    const [dropzoneStatus, setDropzoneStatus] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)({
        phase: status?.phase ?? dropzone_enum_DropzonePhase.Empty,
        message: status?.message,
        acceptedFiles: status?.acceptedFiles ?? []
    });
    const [shouldShowTooltip, setShouldShowTooltip] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        setDropzoneStatus({
            phase: status?.phase ?? dropzone_enum_DropzonePhase.Empty,
            message: status?.message,
            acceptedFiles: status?.acceptedFiles ?? []
        });
    }, [
        status
    ]);
    const handleMouseEnterCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        setShouldShowTooltip(true);
    }, []);
    const handleMouseLeaveCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        setShouldShowTooltip(false);
    }, []);
    const isInputDisabled = isInputDisabledCheck(dropzoneStatus);
    const isClearButtonDisabled = isClearButtonDisabledCheck(dropzoneStatus);
    const isFileCollectedFromDropzone = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        const DEFAULT_FILES_COLLESTION = [];
        const filesCollection = dropzoneStatus.acceptedFiles ?? DEFAULT_FILES_COLLESTION;
        const containsFiles = isArrayPopulated(filesCollection);
        return containsFiles;
    }, [
        dropzoneStatus.acceptedFiles
    ]);
    const onDropHandler = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(acceptedFiles, fileRejections, event) {
        const newStatus = handleOnDropEventAndReturnNewStatus(acceptedFiles, fileRejections, event, onDrop, onDropError);
        setDropzoneStatus(newStatus);
    }, [
        setDropzoneStatus,
        onDrop,
        onDropError
    ]);
    const isDropzoneClickDisabled = isInputDisabled || isFileCollectedFromDropzone;
    const { getRootProps, getInputProps, open } = useDropzone({
        noClick: isDropzoneClickDisabled,
        noDrag: isInputDisabled,
        noDragEventsBubbling: isInputDisabled,
        noKeyboard: true,
        onDrop: onDropHandler,
        ...rest
    });
    const isPhaseLoading = dropzoneStatus.phase === dropzone_enum_DropzonePhase.Loading;
    const onClearClickHandler = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(async function(event) {
        const newStatus = await handleClearButtonClickEventAndReturnNewStatus(event, onClear, onClearError);
        if (newStatus) setDropzoneStatus(newStatus);
    }, [
        setDropzoneStatus,
        onClear,
        onClearError
    ]);
    const onClickPipeline = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(async function(event) {
        event.preventDefault();
        event.stopPropagation();
        const filesCollection = dropzoneStatus.acceptedFiles;
        let isShowFilePreviewEnabled = false;
        let canOpenDefaultDialog = true;
        if (isFunction(onClickMobile)) canOpenDefaultDialog = await onClickMobile(event);
        if (isFunction(onClickPreviewHandler)) isShowFilePreviewEnabled = onClickPreviewHandler(isDropzoneClickDisabled, filesCollection);
        if (canOpenDefaultDialog && !isShowFilePreviewEnabled) open();
    }, [
        isInputDisabled,
        isFileCollectedFromDropzone
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(CustomDropzone, {
                id: id,
                ...getRootProps({
                    onClick: onClickPipeline
                }),
                status: dropzoneStatus,
                onMouseOver: handleMouseEnterCallback,
                onMouseLeave: handleMouseLeaveCallback,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                        ...getInputProps(),
                        className: "dropzone-input"
                    }),
                    !isClearButtonDisabled && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzoneClearButton, {
                        clearButtonId: clearButtonId,
                        onClick: onClearClickHandler
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzoneContainer, {
                        uploadButtonText: uploadButtonText,
                        loadingText: loadingText,
                        isLoading: isPhaseLoading,
                        acceptedFiles: dropzoneStatus.acceptedFiles,
                        shouldShowTooltip: enableShowFilePreviewTooltip && shouldShowTooltip
                    })
                ]
            }),
            dropzoneStatus.message && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzoneMessage, {
                color: dropzoneStatus.phase,
                message: dropzoneStatus.message
            })
        ]
    });
}
const dropzoneStatusesWithoutClearButton = [
    dropzone_enum_DropzonePhase.Valid,
    dropzone_enum_DropzonePhase.Loading,
    dropzone_enum_DropzonePhase.ConfirmedFiles,
    dropzone_enum_DropzonePhase.Empty
];
function isClearButtonDisabledCheck(dropzoneStatus) {
    const isDropzoneStatusNotAllowed = dropzoneStatusesWithoutClearButton.includes(dropzoneStatus.phase);
    return isDropzoneStatusNotAllowed;
}
const dropzoneStatusesWithInputDisabled = [
    dropzone_enum_DropzonePhase.Valid,
    dropzone_enum_DropzonePhase.ConfirmedFiles
];
function isInputDisabledCheck(dropzoneStatus) {
    return dropzoneStatusesWithInputDisabled.includes(dropzoneStatus.phase);
}
const CustomDropzoneActionButtonContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginTop: Spacing["750"],
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.center
});
function DropzoneActionButton({ onClick, text, icon }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomDropzoneActionButtonContainer, {
        onClick: onClick,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
            color: "primary",
            variant: "contained",
            size: "medium",
            endIcon: icon,
            children: text
        })
    });
}
const COUNTRY_CODE_WITH_PREFIX = [
    {
        country: "it",
        prefix: "39"
    },
    {
        country: "fr",
        prefix: "590"
    }
];
const FLAG_EXT = "jpg";
function FlagImage({ children, countryCode }) {
    const imageSrc = `${countryCode.toLowerCase()}.${FLAG_EXT}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FlagImageContainer, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
                alt: countryCode,
                src: imageSrc,
                width: 22,
                height: 14
            }),
            children
        ]
    });
}
const FlagImageContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(({ theme })=>({
        display: displaying_Displaying.flex,
        gap: theme.spacing(1),
        alignItems: alignment_Alignment.center
    }));
function FormControlLabel(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormControlLabel_8c33cd98__["default"], {
        ...props
    });
}
function Color({ color, title, token }) {
    const paletteStyle = {
        background: color,
        width: "100%",
        height: Spacing["2500"],
        padding: "5px 10px",
        fontWeight: typography_FontWeight.bold
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        container: true,
        xs: 12,
        md: 12,
        sx: {
            boxShadow: "grey 0 0 1px",
            margin: `${Spacing["1000"]} 0`
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    container: true,
                    rowSpacing: 1,
                    sx: {
                        display: displaying_Displaying.flex,
                        justifyContent: alignment_Alignment.spaceBetween,
                        padding: "10px",
                        fontSize: "0.9rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 6,
                            children: title
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 6,
                            sx: {
                                display: displaying_Displaying.flex,
                                justifyContent: alignment_Alignment.flexEnd
                            },
                            children: token ?? color
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box, {
                    sx: paletteStyle
                })
            })
        ]
    });
}
const tealDuskPalette = {
    main: tealDusk.getMainColor(100),
    light: tealDusk.getMainColor(10),
    dark: tealDusk.getDarkColor(100),
    contrastText: palette_Common.white.main
};
const pinkHazePalette = {
    main: pinkHaze.getMainColor(100),
    light: pinkHaze.getMainColor(10),
    dark: pinkHaze.getDarkColor(100),
    contrastText: palette_Common.white.main
};
const goldenUmberPalette = {
    main: goldenUmber.getMainColor(100),
    light: goldenUmber.getMainColor(10),
    dark: goldenUmber.getDarkColor(100),
    contrastText: palette_Common.white.main
};
const colorMapper = {
    Bluex: Bluex,
    Tealx: Tealx,
    Pinkx: Pinkx,
    DeepBluex: DeepBluex,
    Nudex: Nudex,
    Purplex: Purplex,
    Napolix: Napolix,
    Celestex: Celestex,
    Orangex: Orangex,
    Redx: Redx,
    Greenx: Greenx,
    Greyx: Greyx,
    Goldenx: Goldenx,
    AlphaDeep: AlphaDeep
};
const paletteMapper = {
    Primary: {
        ...palette_Primary,
        main: {
            token: "Bluex 400",
            color: Bluex["400"]
        },
        light: {
            token: "Bluex 50",
            color: Bluex["50"]
        },
        dark: {
            token: "Bluex 500",
            color: Bluex["500"]
        }
    },
    Secondary: {
        ...palette_Secondary,
        main: {
            token: "Tealx 400",
            color: Tealx["400"]
        },
        light: {
            token: "Tealx 0",
            color: Tealx["0"]
        },
        dark: {
            token: "Tealx 500",
            color: Tealx["500"]
        }
    },
    Tertiary: {
        ...palette_Tertiary,
        main: {
            token: "Pinkx 400",
            color: Pinkx["400"]
        },
        light: {
            token: "Pinkx 0",
            color: Pinkx["0"]
        },
        dark: {
            token: "Pinkx 500",
            color: Pinkx["500"]
        }
    },
    Error: {
        ...ErrorToken,
        main: {
            token: "Redx 400",
            color: Redx["400"]
        },
        light: {
            token: "Redx 200",
            color: Redx["200"]
        },
        dark: {
            token: "Redx 600",
            color: Redx["600"]
        }
    },
    Warning: {
        ...palette_Warning,
        main: {
            token: "Orangex 400",
            color: Orangex["400"]
        },
        light: {
            token: "Orangex 100",
            color: Orangex["100"]
        },
        dark: {
            token: "Orangex 600",
            color: Orangex["600"]
        }
    },
    Info: {
        ...palette_Info,
        main: {
            token: "Napolix 500",
            color: Napolix["500"]
        },
        light: {
            token: "Napolix 0",
            color: Napolix["0"]
        },
        dark: {
            token: "Napolix 600",
            color: Napolix["600"]
        }
    },
    Success: {
        ...palette_Success,
        main: {
            token: "Greenx 400",
            color: Greenx["400"]
        },
        light: {
            token: "Greenx 0",
            color: Greenx["0"]
        },
        dark: {
            token: "Greenx 500",
            color: Greenx["500"]
        }
    },
    Purple: {
        ...palette_Purple,
        main: {
            token: "Purplex 400",
            color: Purplex["400"]
        },
        light: {
            token: "Purplex 100",
            color: Purplex["100"]
        },
        dark: {
            token: "Purplex 700",
            color: Purplex["700"]
        }
    },
    DeepBlue: {
        ...palette_DeepBlue,
        main: {
            token: "DeepBluex 300",
            color: DeepBluex["300"]
        },
        light: {
            token: "DeepBluex 0",
            color: DeepBluex["0"]
        },
        dark: {
            token: "DeepBluex 700",
            color: DeepBluex["700"]
        }
    },
    Text: {
        ...palette_Text,
        primary: {
            token: "DeepBluex 600",
            color: DeepBluex["600"]
        },
        secondary: {
            token: "AlphaDeep 70",
            color: AlphaDeep["70"]
        },
        disabled: {
            token: "AlphaDeep 38",
            color: AlphaDeep["38"]
        }
    },
    Action: {
        ...palette_Action,
        active: {
            token: "AlphaDeep 56",
            color: AlphaDeep["56"]
        },
        disabled: {
            token: "AlphaDeep 24",
            color: AlphaDeep["24"]
        },
        disabledBackground: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        focus: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        hover: {
            token: "AlphaDeep 4",
            color: AlphaDeep["4"]
        },
        selected: {
            token: "AlphaDeep 8",
            color: AlphaDeep["8"]
        }
    },
    Border: {
        ...palette_Border,
        main: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        light: {
            token: "AlphaDeep 10",
            color: AlphaDeep["10"]
        },
        dark: {
            token: "AlphaDeep 30",
            color: AlphaDeep["30"]
        },
        outlinedBorder: {
            token: "AlphaDeep 50",
            color: AlphaDeep["50"]
        },
        selected: {
            token: "AlphaDeep 8",
            color: AlphaDeep["8"]
        },
        focus: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        focusVisible: {
            token: "AlphaDeep 30",
            color: AlphaDeep["30"]
        },
        fillBackdrop: {
            token: "AlphaDeep 50",
            color: AlphaDeep["50"]
        }
    },
    PurpleLight: {
        ...PurpleLight,
        main: {
            token: "Purplex 0",
            color: PurpleLight.main
        },
        dark: {
            token: "Purplex 100",
            color: PurpleLight.dark
        },
        contrastText: {
            token: "Purplex 600",
            color: PurpleLight.contrastText
        }
    },
    Goldenx: {
        main: {
            token: "Goldenx 500",
            color: Goldenx["500"]
        },
        light: {
            token: "Goldenx 100",
            color: Goldenx["100"]
        },
        dark: {
            token: "Goldenx 700",
            color: Goldenx["700"]
        }
    },
    Tier1: {
        main: {
            token: "Main",
            color: tealDuskPalette.main
        },
        dark: {
            token: "Dark",
            color: tealDuskPalette.dark
        },
        light: {
            token: "Light",
            color: tealDuskPalette.light
        }
    },
    Tier2: {
        main: {
            token: "Main",
            color: pinkHazePalette.main
        },
        dark: {
            token: "Dark",
            color: pinkHazePalette.dark
        },
        light: {
            token: "Light",
            color: pinkHazePalette.light
        }
    },
    Tier3: {
        main: {
            token: "Main",
            color: goldenUmberPalette.main
        },
        dark: {
            token: "Dark",
            color: goldenUmberPalette.dark
        },
        light: {
            token: "Light",
            color: goldenUmberPalette.light
        }
    },
    Background: {
        ...palette_Background,
        default: {
            token: "Greyx 0",
            color: Greyx["0"]
        }
    }
};
function isColorPaletteWithToken(value) {
    return void 0 !== value.token;
}
function GradientPaletteBox({ background, color, text, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        sx: {
            display: displaying_Displaying.flex,
            justifyContent: alignment_Alignment.center,
            alignItems: alignment_Alignment.center,
            background,
            height: "100%",
            minHeight: "3rem",
            width: "100%",
            color,
            borderRadius: "0.3rem"
        },
        ...props,
        children: text
    });
}
const gradient_box_tealDuskStyle = tealDusk.getBoxStylesOverride();
const gradient_box_pinkHazeStyle = pinkHaze.getBoxStylesOverride();
const gradient_box_goldenUmberStyle = goldenUmber.getBoxStylesOverride();
const GradientBoxStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])`
  ${gradient_box_tealDuskStyle}
  ${gradient_box_pinkHazeStyle}
  ${gradient_box_goldenUmberStyle}
`;
function GradientBox(props) {
    const gradientClassName = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        let gradientClassName = "";
        if (props.gradient) {
            const colorNameCapitalized = capitalizeFirstLetter(props.gradient);
            gradientClassName = ` box-gradient${colorNameCapitalized}`;
        }
        return gradientClassName;
    }, [
        props.gradient
    ]);
    const defaultClassname = "";
    const propsClassName = props.className ?? defaultClassname;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GradientBoxStyled, {
        ...props,
        children: void 0,
        className: propsClassName + gradientClassName,
        sx: {
            position: positioning_Positioning.relative,
            ...props.sx
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GradientBoxStyled, {
                gradient: props.gradient,
                className: "background",
                sx: {
                    width: "100%",
                    height: "100%"
                }
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                className: "content",
                sx: {
                    position: positioning_Positioning.relative,
                    zIndex: 2,
                    padding: Spacing["1000"]
                },
                children: props.children
            })
        ]
    });
}
const tealDuskBorderStyle = tealDusk.getBoxOutlinedStylesOverride();
const pinkHazeBorderStyle = pinkHaze.getBoxOutlinedStylesOverride();
const goldenUmberBorderStyle = goldenUmber.getBoxOutlinedStylesOverride();
const boxContentClassName = "content";
const defaultGradientBox = "&.box-gradientOutlinedDefault";
const defaultBorderStyle = {
    [defaultGradientBox]: {
        background: palette_Background.paper,
        border: `1px solid ${palette_Border.main}`
    }
};
const darkGradientBox = "&.box-gradientOutlinedDark";
const darkBorderStyle = {
    [darkGradientBox]: {
        background: palette_Background.paper,
        border: `1px solid ${palette_Border.dark}`
    }
};
const BoxOutlinedWithGradient = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    ...tealDuskBorderStyle,
    ...pinkHazeBorderStyle,
    ...goldenUmberBorderStyle,
    ...defaultBorderStyle,
    ...darkBorderStyle
});
function GradientBoxOutlined({ children, size, gradient, withLabel = false, hasDarkBorders = false, ...otherProps }) {
    const gradientClassName = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        let gradientClassName = hasDarkBorders ? " box-gradientOutlinedDark" : " box-gradientOutlinedDefault";
        if (gradient) {
            const colorNameCapitalized = capitalizeFirstLetter(gradient);
            gradientClassName = ` box-gradientOutlined${colorNameCapitalized}`;
        }
        return gradientClassName;
    }, [
        gradient,
        hasDarkBorders
    ]);
    const borderRadiusConfig = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        const defaultContentBoxRadius = "0.7rem";
        let gradientBoxValue = Spacing["750"];
        let contentBoxValue = defaultContentBoxRadius;
        if (withLabel) {
            const noTopLeftBorder = "0%";
            gradientBoxValue = `${noTopLeftBorder} ${Spacing["750"]} ${Spacing["750"]} ${Spacing["750"]}`;
            contentBoxValue = `${noTopLeftBorder} ${defaultContentBoxRadius} ${defaultContentBoxRadius} ${defaultContentBoxRadius}`;
        }
        return {
            gradientBoxValue,
            contentBoxValue
        };
    }, [
        withLabel
    ]);
    const contentBoxPadding = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if ("small" === size) return Spacing["750"];
        return `${Spacing["1500"]} ${Spacing["1000"]}`;
    }, [
        size
    ]);
    const defaultClassname = "";
    const propsClassName = otherProps.className ?? defaultClassname;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxOutlinedWithGradient, {
        ...otherProps,
        sx: {
            ...otherProps.sx,
            borderRadius: borderRadiusConfig.gradientBoxValue
        },
        className: propsClassName + gradientClassName,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
            className: boxContentClassName,
            sx: {
                padding: contentBoxPadding,
                borderRadius: borderRadiusConfig.contentBoxValue
            },
            children: children
        })
    });
}
function generateIseeCardTitle({ title, icon }) {
    const isIconSet = void 0 !== icon;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            isIconSet && icon,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                sx: theme_theme.typography.subtitle1,
                children: title
            })
        ]
    });
}
const IseeCardTitle = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(generateIseeCardTitle);
function formatCurrency(value, options) {
    const { locale = "it-IT", minimumFractionDigits = 2, maximumFractionDigits = 2 } = options ?? {};
    return value.toLocaleString(locale, {
        minimumFractionDigits,
        maximumFractionDigits
    });
}
var lodash_isNaN = __webpack_require__("./node_modules/lodash/isNaN.js");
var isNaN_default = /*#__PURE__*/ __webpack_require__.n(lodash_isNaN);
function generateIseeCardContent({ title, value, currency }) {
    const isValueParsableToNumber = !isNaN_default()(Number(value));
    if (isValueParsableToNumber) value = formatCurrency(Number(value));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "textSecondary",
                sx: theme_theme.typography.body2,
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Typography, {
                sx: theme_theme.typography.body1,
                display: displaying_Displaying.flex,
                children: [
                    value,
                    isValueParsableToNumber && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                        marginLeft: Spacing["250"],
                        color: "textSecondary",
                        children: currency
                    })
                ]
            })
        ]
    });
}
const IseeCardContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(generateIseeCardContent);
const DEFAULT_CARD_BORDER = `1px solid ${theme_theme.palette.border.main}`;
const CustomCard = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(function({ isMobile, maxWidth }) {
    const selectedPadding = isMobile ? Spacing["1000"] : Spacing["1500"];
    return {
        maxWidth,
        borderRadius: BorderRadius.paper,
        boxShadow: NONE_OPTION,
        paddingLeft: selectedPadding,
        paddingRight: selectedPadding,
        paddingTop: selectedPadding,
        paddingBottom: selectedPadding,
        backgroundColor: theme_theme.palette.background.paper,
        border: DEFAULT_CARD_BORDER,
        display: displaying_Displaying.flex,
        justifyContent: alignment_Alignment.flexStart,
        flexWrap: wrapping_Wrapping.wrap,
        gap: Spacing["3000"]
    };
});
function CustomCardComponent({ isMobile, ...rest }) {
    const isCurrentlyMobile = use_is_mobile();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomCard, {
        isMobile: isMobile ?? isCurrentlyMobile,
        ...rest
    });
}
const DualGridCardLayourWrapper = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomCardComponent);
const CustomBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    gap: Spacing["1000"]
});
const DualGridCardLayoutColumn = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomBox);
const content_wrapper_CustomBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], styledOptions)(({ gap })=>({
        display: displaying_Displaying.flex,
        flexWrap: wrapping_Wrapping.wrap,
        justifyContent: alignment_Alignment.flexStart,
        gap
    }));
const DualGridCardLayoutContentWrapper = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(content_wrapper_CustomBox);
const content_CustomBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column
});
const DualGridCardLayoutContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(content_CustomBox);
function generateDualGridCardLayoutElement({ titleContent, startContent, endContent }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DualGridCardLayoutColumn, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutContentWrapper, {
                gap: Spacing["500"],
                children: titleContent
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DualGridCardLayoutContentWrapper, {
                gap: Spacing["2000"],
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutContent, {
                        children: startContent
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutContent, {
                        children: endContent
                    })
                ]
            })
        ]
    });
}
const DualGridCardLayoutElement = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(generateDualGridCardLayoutElement);
function generateDualGridCardLayout({ startElement, endElement, maxWidth, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DualGridCardLayourWrapper, {
        maxWidth: maxWidth,
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutElement, {
                ...startElement
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutElement, {
                ...endElement
            })
        ]
    });
}
const DualGridCardLayout = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(generateDualGridCardLayout);
function generateIseeCard({ certificatedIseeValue, simulatedIseeValue, certificatedIseeIcon, simulatedIseeIcon, simulatedIseeTitle = "Valore ISEE simulato", certificatedIseeTitle = "Valore ISEE certificato", currentTitle = "Corrente", ordinaryTitle = "Ordinario", currency = "\u20AC", ...rest }) {
    const startElement = {
        titleContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardTitle, {
            title: certificatedIseeTitle,
            icon: certificatedIseeIcon
        }),
        startContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: ordinaryTitle,
            value: certificatedIseeValue.ordinary,
            currency: currency
        }),
        endContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: currentTitle,
            value: certificatedIseeValue.current,
            currency: currency
        })
    };
    const endElement = {
        titleContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardTitle, {
            title: simulatedIseeTitle,
            icon: simulatedIseeIcon
        }),
        startContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: ordinaryTitle,
            value: simulatedIseeValue.ordinary,
            currency: currency
        }),
        endContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: currentTitle,
            value: simulatedIseeValue.current,
            currency: currency
        })
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayout, {
        startElement: startElement,
        endElement: endElement,
        ...rest
    });
}
const IseeCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(generateIseeCard);
function LinearProgress({ ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_LinearProgress_13636fa3__["default"], {
        ...rest
    });
}
const containers_BoxWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"], styledOptions)(({ disablepadding = false })=>({
        padding: disablepadding ? "inherit" : Spacing["1000"]
    }));
const LeftSlotWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    minWidth: Spacing["3500"]
});
function NonInteractive({ primary, secondaryText, leftSlot, rightSlot, secondRightSlot, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            leftSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemAvatar_037fd911__["default"], {
                "data-testid": rest?.buttonid,
                ...rest,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftSlotWrapper, {
                    children: leftSlot
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                primary: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                    variant: "body1",
                    children: primary
                }),
                secondary: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                    variant: "body2",
                    children: secondaryText
                })
            }),
            rightSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                children: [
                    rightSlot,
                    secondRightSlot
                ]
            })
        ]
    });
}
function Interactive({ primary, secondaryText, leftSlot, rightSlot, secondRightSlot, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__["default"], {
        "data-testid": rest?.buttonid,
        ...rest,
        children: [
            leftSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftSlotWrapper, {
                children: leftSlot
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                primary: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                    variant: "body1",
                    children: primary
                }),
                secondary: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                    variant: "body2",
                    children: secondaryText
                })
            }),
            rightSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                children: [
                    rightSlot,
                    secondRightSlot
                ]
            })
        ]
    });
}
function ListItem({ disablepadding, parentid, interactive = false, divider, ...rest }) {
    const { id = "listitem-id" } = rest;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(containers_BoxWrapper, {
        disablepadding: disablepadding,
        "data-testid": parentid,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItem_695b112b__["default"], {
                alignItems: alignment_Alignment.center,
                id: id,
                "data-testid": id,
                children: [
                    !interactive && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NonInteractive, {
                        ...rest
                    }),
                    interactive && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Interactive, {
                        ...rest
                    })
                ]
            }),
            divider && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], {})
        ]
    });
}
function AdminPanel() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
        width: "162",
        height: "22",
        viewBox: "0 0 162 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M5.088 19V7.8H9.232C10.128 7.8 10.8693 7.94933 11.456 8.248C12.0427 8.54667 12.48 8.95733 12.768 9.48C13.056 10.0027 13.2 10.5893 13.2 11.24C13.2 11.8587 13.0613 12.4293 12.784 12.952C12.5067 13.464 12.0747 13.88 11.488 14.2C10.9013 14.5093 10.1493 14.664 9.232 14.664H7.136V19H5.088ZM7.136 13H9.104C9.81867 13 10.3307 12.8453 10.64 12.536C10.96 12.216 11.12 11.784 11.12 11.24C11.12 10.6853 10.96 10.2533 10.64 9.944C10.3307 9.624 9.81867 9.464 9.104 9.464H7.136V13ZM17.1447 19.192C16.4621 19.192 15.9021 19.0853 15.4647 18.872C15.0274 18.648 14.7021 18.3547 14.4887 17.992C14.2754 17.6293 14.1687 17.2293 14.1687 16.792C14.1687 16.056 14.4567 15.4587 15.0327 15C15.6087 14.5413 16.4727 14.312 17.6247 14.312H19.6407V14.12C19.6407 13.576 19.4861 13.176 19.1767 12.92C18.8674 12.664 18.4834 12.536 18.0247 12.536C17.6087 12.536 17.2461 12.6373 16.9367 12.84C16.6274 13.032 16.4354 13.32 16.3607 13.704H14.3607C14.4141 13.128 14.6061 12.6267 14.9367 12.2C15.2781 11.7733 15.7154 11.448 16.2487 11.224C16.7821 10.9893 17.3794 10.872 18.0408 10.872C19.1714 10.872 20.0621 11.1547 20.7127 11.72C21.3634 12.2853 21.6888 13.0853 21.6888 14.12V19H19.9447L19.7527 17.72C19.5181 18.1467 19.1874 18.4987 18.7607 18.776C18.3447 19.0533 17.8061 19.192 17.1447 19.192ZM17.6087 17.592C18.1954 17.592 18.6487 17.4 18.9688 17.016C19.2994 16.632 19.5074 16.1573 19.5928 15.592H17.8487C17.3047 15.592 16.9154 15.6933 16.6807 15.896C16.4461 16.088 16.3287 16.328 16.3287 16.616C16.3287 16.9253 16.4461 17.1653 16.6807 17.336C16.9154 17.5067 17.2247 17.592 17.6087 17.592ZM23.7931 19V11.064H25.6011L25.7611 12.408C26.0065 11.9387 26.3585 11.5653 26.8171 11.288C27.2865 11.0107 27.8358 10.872 28.4651 10.872C29.4465 10.872 30.2091 11.1813 30.7531 11.8C31.2971 12.4187 31.5691 13.3253 31.5691 14.52V19H29.5211V14.712C29.5211 14.0293 29.3825 13.5067 29.1051 13.144C28.8278 12.7813 28.3958 12.6 27.8091 12.6C27.2331 12.6 26.7585 12.8027 26.3851 13.208C26.0225 13.6133 25.8411 14.1787 25.8411 14.904V19H23.7931ZM33.6775 19V11.064H35.4855L35.6455 12.408C35.8908 11.9387 36.2428 11.5653 36.7015 11.288C37.1708 11.0107 37.7202 10.872 38.3495 10.872C39.3308 10.872 40.0935 11.1813 40.6375 11.8C41.1815 12.4187 41.4535 13.3253 41.4535 14.52V19H39.4055V14.712C39.4055 14.0293 39.2668 13.5067 38.9895 13.144C38.7122 12.7813 38.2802 12.6 37.6935 12.6C37.1175 12.6 36.6428 12.8027 36.2695 13.208C35.9068 13.6133 35.7255 14.1787 35.7255 14.904V19H33.6775ZM47.4179 19.192C46.6179 19.192 45.9085 19.0213 45.2899 18.68C44.6712 18.3387 44.1859 17.8587 43.8339 17.24C43.4819 16.6213 43.3059 15.9067 43.3059 15.096C43.3059 14.2747 43.4765 13.544 43.8179 12.904C44.1699 12.264 44.6499 11.768 45.2579 11.416C45.8765 11.0533 46.6019 10.872 47.4339 10.872C48.2125 10.872 48.9005 11.0427 49.4979 11.384C50.0952 11.7253 50.5592 12.1947 50.8899 12.792C51.2312 13.3787 51.4019 14.0347 51.4019 14.76C51.4019 14.8773 51.3965 15 51.3859 15.128C51.3859 15.256 51.3805 15.3893 51.3699 15.528H45.3379C45.3805 16.1467 45.5939 16.632 45.9779 16.984C46.3725 17.336 46.8472 17.512 47.4019 17.512C47.8179 17.512 48.1645 17.4213 48.4419 17.24C48.7299 17.048 48.9432 16.8027 49.0819 16.504H51.1619C51.0125 17.0053 50.7619 17.464 50.4099 17.88C50.0685 18.2853 49.6419 18.6053 49.1299 18.84C48.6285 19.0747 48.0579 19.192 47.4179 19.192ZM47.4339 12.536C46.9325 12.536 46.4899 12.68 46.1059 12.968C45.7219 13.2453 45.4765 13.672 45.3699 14.248H49.3219C49.2899 13.7253 49.0979 13.3093 48.7459 13C48.3939 12.6907 47.9565 12.536 47.4339 12.536ZM53.2744 19V7.48H55.3224V19H53.2744ZM57.565 19V7.48H59.613V19H57.565ZM65.6636 19.192C64.8956 19.192 64.2023 19.016 63.5836 18.664C62.9756 18.312 62.4903 17.8267 62.1276 17.208C61.7756 16.5787 61.5996 15.8533 61.5996 15.032C61.5996 14.2107 61.781 13.4907 62.1436 12.872C62.5063 12.2427 62.9916 11.752 63.5996 11.4C64.2183 11.048 64.9116 10.872 65.6796 10.872C66.437 10.872 67.1196 11.048 67.7276 11.4C68.3463 11.752 68.8316 12.2427 69.1836 12.872C69.5463 13.4907 69.7276 14.2107 69.7276 15.032C69.7276 15.8533 69.5463 16.5787 69.1836 17.208C68.8316 17.8267 68.3463 18.312 67.7276 18.664C67.109 19.016 66.421 19.192 65.6636 19.192ZM65.6636 17.416C66.197 17.416 66.661 17.2187 67.0556 16.824C67.4503 16.4187 67.6476 15.8213 67.6476 15.032C67.6476 14.2427 67.4503 13.6507 67.0556 13.256C66.661 12.8507 66.2023 12.648 65.6796 12.648C65.1356 12.648 64.6663 12.8507 64.2716 13.256C63.8876 13.6507 63.6956 14.2427 63.6956 15.032C63.6956 15.8213 63.8876 16.4187 64.2716 16.824C64.6663 17.2187 65.1303 17.416 65.6636 17.416ZM78.4072 19.192C77.7246 19.192 77.1646 19.0853 76.7272 18.872C76.2899 18.648 75.9646 18.3547 75.7512 17.992C75.5379 17.6293 75.4312 17.2293 75.4312 16.792C75.4312 16.056 75.7192 15.4587 76.2952 15C76.8712 14.5413 77.7352 14.312 78.8872 14.312H80.9032V14.12C80.9032 13.576 80.7486 13.176 80.4392 12.92C80.1299 12.664 79.7459 12.536 79.2872 12.536C78.8712 12.536 78.5086 12.6373 78.1992 12.84C77.8899 13.032 77.6979 13.32 77.6232 13.704H75.6232C75.6766 13.128 75.8686 12.6267 76.1992 12.2C76.5406 11.7733 76.9779 11.448 77.5112 11.224C78.0446 10.9893 78.6419 10.872 79.3032 10.872C80.4339 10.872 81.3246 11.1547 81.9752 11.72C82.6259 12.2853 82.9512 13.0853 82.9512 14.12V19H81.2072L81.0152 17.72C80.7806 18.1467 80.4499 18.4987 80.0232 18.776C79.6072 19.0533 79.0686 19.192 78.4072 19.192ZM78.8712 17.592C79.4579 17.592 79.9112 17.4 80.2312 17.016C80.5619 16.632 80.7699 16.1573 80.8552 15.592H79.1112C78.5672 15.592 78.1779 15.6933 77.9432 15.896C77.7086 16.088 77.5912 16.328 77.5912 16.616C77.5912 16.9253 77.7086 17.1653 77.9432 17.336C78.1779 17.5067 78.4872 17.592 78.8712 17.592ZM88.7036 19.192C87.957 19.192 87.2903 19.0107 86.7036 18.648C86.117 18.2853 85.653 17.7893 85.3116 17.16C84.9703 16.5307 84.7996 15.816 84.7996 15.016C84.7996 14.216 84.9703 13.5067 85.3116 12.888C85.653 12.2587 86.117 11.768 86.7036 11.416C87.2903 11.0533 87.957 10.872 88.7036 10.872C89.301 10.872 89.8236 10.984 90.2716 11.208C90.7196 11.432 91.0823 11.7467 91.3596 12.152V7.48H93.4076V19H91.5836L91.3596 17.864C91.1036 18.216 90.7623 18.5253 90.3356 18.792C89.9196 19.0587 89.3756 19.192 88.7036 19.192ZM89.1356 17.4C89.797 17.4 90.3356 17.1813 90.7516 16.744C91.1783 16.296 91.3916 15.7253 91.3916 15.032C91.3916 14.3387 91.1783 13.7733 90.7516 13.336C90.3356 12.888 89.797 12.664 89.1356 12.664C88.485 12.664 87.9463 12.8827 87.5196 13.32C87.093 13.7573 86.8796 14.3227 86.8796 15.016C86.8796 15.7093 87.093 16.28 87.5196 16.728C87.9463 17.176 88.485 17.4 89.1356 17.4ZM95.6431 19V11.064H97.4511L97.6271 12.136C97.8831 11.752 98.2191 11.448 98.6351 11.224C99.0618 10.9893 99.5525 10.872 100.107 10.872C101.334 10.872 102.203 11.3467 102.715 12.296C103.003 11.8587 103.387 11.512 103.867 11.256C104.358 11 104.891 10.872 105.467 10.872C106.502 10.872 107.296 11.1813 107.851 11.8C108.406 12.4187 108.683 13.3253 108.683 14.52V19H106.635V14.712C106.635 14.0293 106.502 13.5067 106.235 13.144C105.979 12.7813 105.579 12.6 105.035 12.6C104.48 12.6 104.032 12.8027 103.691 13.208C103.36 13.6133 103.195 14.1787 103.195 14.904V19H101.147V14.712C101.147 14.0293 101.014 13.5067 100.747 13.144C100.48 12.7813 100.07 12.6 99.5151 12.6C98.9711 12.6 98.5285 12.8027 98.1871 13.208C97.8565 13.6133 97.6911 14.1787 97.6911 14.904V19H95.6431ZM111.882 9.832C111.508 9.832 111.199 9.72 110.954 9.496C110.719 9.272 110.602 8.98933 110.602 8.648C110.602 8.30667 110.719 8.02933 110.954 7.816C111.199 7.592 111.508 7.48 111.882 7.48C112.255 7.48 112.559 7.592 112.794 7.816C113.039 8.02933 113.162 8.30667 113.162 8.648C113.162 8.98933 113.039 9.272 112.794 9.496C112.559 9.72 112.255 9.832 111.882 9.832ZM110.858 19V11.064H112.906V19H110.858ZM115.193 19V11.064H117.001L117.161 12.408C117.406 11.9387 117.758 11.5653 118.217 11.288C118.686 11.0107 119.236 10.872 119.865 10.872C120.846 10.872 121.609 11.1813 122.153 11.8C122.697 12.4187 122.969 13.3253 122.969 14.52V19H120.921V14.712C120.921 14.0293 120.782 13.5067 120.505 13.144C120.228 12.7813 119.796 12.6 119.209 12.6C118.633 12.6 118.158 12.8027 117.785 13.208C117.422 13.6133 117.241 14.1787 117.241 14.904V19H115.193Z",
            fill: "#1246C8"
        })
    });
}
function Logo() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
        width: "150",
        height: "24",
        viewBox: "0 0 150 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M132.271 13.2899C131.48 15.0027 130.459 16.829 128.489 17.9615C125.057 19.9291 119.31 18.9657 119.818 13.534C121.576 14.7824 123.74 15.4126 125.936 15.3161C128.133 15.2196 130.225 14.4024 131.854 13.0051L132.286 13.262L132.271 13.2899Z",
                fill: "#00BB8C"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M133.515 10.6115C134.303 8.89871 135.327 7.07029 137.294 5.9377C140.727 3.97012 146.478 4.93357 145.966 10.376C144.208 9.12753 142.044 8.49738 139.847 8.59389C137.651 8.6904 135.558 9.50754 133.93 10.9048L133.898 10.9348L133.475 10.6864L133.515 10.6115Z",
                fill: "#DD4C77"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M145.713 18.6382H140.456L132.841 13.6496L131.883 13.0202L120.064 5.27405H125.32L145.713 18.6382Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.0444 10.9648C21.5312 11.0419 22.19 11.1168 22.8331 11.2539C23.8248 11.468 24.7055 11.8705 25.2829 12.7033C26.0618 13.8273 26.012 15.0113 25.4776 16.1931C24.898 17.4777 23.7183 18.0515 22.3712 18.362C21.1779 18.636 19.9576 18.6489 18.7349 18.6467C13.9801 18.6339 9.20951 18.6467 4.44795 18.6467H3.99512V5.27404C3.99512 5.27404 15.2934 5.25263 20.7183 5.27404C21.701 5.27404 22.6972 5.31472 23.6617 5.78574C25.1425 6.51582 25.9033 7.79614 25.2467 9.21134C24.8731 10.0014 24.135 10.3782 23.3176 10.5816C22.5002 10.785 21.6964 10.8556 21.0444 10.9648ZM13.7764 10.7165C15.5401 10.7165 17.0639 10.7165 18.8277 10.7165C19.3106 10.7176 19.7928 10.6833 20.27 10.6137C20.5525 10.5586 20.8062 10.4131 20.9885 10.2017C21.1708 9.99032 21.2705 9.72601 21.2708 9.45327C21.3047 8.86664 20.8836 8.38277 20.227 8.23933C19.7254 8.12986 19.2108 8.08307 18.6964 8.10016C15.205 8.08089 7.8578 8.08517 7.8578 8.08517V10.7229L13.7764 10.7165ZM13.7764 15.8741C15.5401 15.8741 17.7794 15.8741 19.5432 15.8741C20.0261 15.8754 20.5083 15.841 20.9855 15.7714C21.2699 15.7169 21.5256 15.5708 21.7089 15.358C21.8922 15.1453 21.9918 14.879 21.9908 14.6045C22.0247 14.0179 21.6036 13.534 20.947 13.3906C20.4454 13.2811 19.9308 13.2343 19.4164 13.2514C15.9251 13.2321 7.86912 13.2364 7.86912 13.2364V15.8891L13.7764 15.8741Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M116.593 7.3807C112.475 6.81975 101.758 5.61865 98.9848 8.8794C98.4756 9.53279 98.2611 10.3505 98.3884 11.1532C98.5158 11.9559 98.9745 12.6781 99.6641 13.1614C100.506 13.7437 101.586 13.9043 102.626 14.0028C104.84 14.2169 107.07 14.2169 109.294 14.3111C110.383 14.3539 111.485 14.3646 112.556 14.5766C112.9 14.6216 113.26 14.8164 113.29 15.1739C113.351 16.1417 111.544 16.101 110.836 16.1888C109.223 16.283 107.605 16.3151 105.988 16.2594C103.546 16.1589 101.12 15.8392 98.7426 15.3045C98.7426 16.238 98.7426 18.1713 98.7426 18.1713C101.301 18.683 103.928 18.7901 106.538 18.8757C109.269 18.9271 114.859 19.017 116.478 16.6405C117.223 15.6064 117.284 14.1056 116.437 13.1464C115.699 12.3093 114.483 12.0245 113.344 11.8618C110.797 11.5043 108.209 11.5471 105.646 11.4336C104.75 11.4262 103.857 11.3452 102.977 11.1917C102.792 11.1604 102.619 11.0869 102.472 10.9776C102.353 10.8765 102.278 10.7382 102.26 10.5885C102.242 10.4388 102.281 10.2879 102.372 10.164C102.59 9.94798 102.886 9.81604 103.201 9.7936C103.933 9.68686 104.671 9.61895 105.411 9.59021C107.929 9.46446 110.454 9.52746 112.962 9.77862C114.175 9.90494 115.384 10.0741 116.584 10.2753C116.584 9.41893 116.584 7.40639 116.584 7.40639",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M48.6384 9.41669C47.4769 8.18133 45.7244 7.50691 44.0467 7.15579C42.6889 6.89366 41.3071 6.75813 39.9213 6.75114C39.6225 6.75114 39.3236 6.73829 39.0157 6.73615C36.2239 6.71903 33.3145 6.96738 30.885 8.34404C29.3454 9.21543 28.4058 10.485 28.168 12.1829C28.016 13.2304 28.207 14.2968 28.7155 15.2385C29.2239 16.1802 30.0254 16.9519 31.0118 17.4497C33.3598 18.6979 36.1017 18.8542 38.7372 18.8885C40.424 18.9099 42.1335 18.8885 43.7908 18.5737C46.6301 18.0299 49.4739 16.6062 49.9426 13.6644C50.084 12.9092 50.04 12.1334 49.8138 11.3969C49.5877 10.6604 49.1855 9.98285 48.6384 9.41669ZM40.7138 15.9703H37.4874C34.6481 15.9703 32.3454 15.0411 32.3454 12.8937C32.3454 10.7462 34.6481 9.81705 37.4874 9.81705H40.7025C43.5214 9.83204 45.7991 10.7313 45.7991 12.8937C45.7991 15.0561 43.5282 15.951 40.7161 15.9703H40.7138Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M52.9697 18.6423V7.0509H57.0951V10.9646C57.0951 10.9646 58.1773 8.23915 61.0528 7.30996C63.6702 6.46855 65.9435 6.5392 68.4114 7.09586C70.739 7.61826 72.5571 9.56015 72.7337 11.7911C72.8537 13.2748 72.822 14.7692 72.8469 16.2593C72.8469 17.0429 72.8469 17.8437 72.8469 18.6444H68.7714V18.2697C68.7714 16.771 68.785 15.2616 68.7714 13.7587C68.7703 13.2818 68.7095 12.8068 68.5903 12.3435C68.4945 11.9632 68.3173 11.6055 68.0696 11.2925C67.822 10.9795 67.5091 10.7178 67.1503 10.5236C66.2242 10.0333 65.0559 9.93054 64.0144 9.8813C61.8408 9.80208 60.0317 10.2645 59.0332 10.6992C58.2453 11.0439 57.5502 11.5406 57.2218 12.3392C57.1266 12.5788 57.0775 12.8326 57.0769 13.0885C57.0769 14.8013 57.0769 18.6316 57.0769 18.6316L52.9697 18.6423Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M95.613 7.03613V18.6275H91.4899V14.7138C91.4899 14.7138 90.4076 17.4371 87.5254 18.3663C84.9057 19.2099 82.6325 19.1371 80.1668 18.5804C77.8347 18.0623 76.0188 16.1183 75.8377 13.8895C75.7199 12.4058 75.7516 10.9092 75.7267 9.41907C75.7132 8.6376 75.7267 7.83687 75.7267 7.03613H79.8023V7.40867C79.8023 8.90737 79.7864 10.4061 79.8023 11.9176C79.8041 12.3952 79.8656 12.871 79.9857 13.335C80.0813 13.7153 80.2584 14.073 80.5061 14.3861C80.7538 14.6991 81.0668 14.9607 81.4257 15.1548C82.3517 15.643 83.5178 15.7479 84.5593 15.7971C86.7329 15.8742 88.5442 15.4117 89.5405 14.9792C90.3284 14.6324 91.0258 14.1357 91.3518 13.3392C91.4479 13.0998 91.4977 12.846 91.499 12.5899C91.499 10.8771 91.499 7.04684 91.499 7.04684L95.613 7.03613Z",
                fill: "#1246C8"
            })
        ]
    });
}
function OperatorPanel() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
        width: "162",
        height: "23",
        viewBox: "0 0 162 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M5.088 19V7.8H9.232C10.128 7.8 10.8693 7.94933 11.456 8.248C12.0427 8.54667 12.48 8.95733 12.768 9.48C13.056 10.0027 13.2 10.5893 13.2 11.24C13.2 11.8587 13.0613 12.4293 12.784 12.952C12.5067 13.464 12.0747 13.88 11.488 14.2C10.9013 14.5093 10.1493 14.664 9.232 14.664H7.136V19H5.088ZM7.136 13H9.104C9.81867 13 10.3307 12.8453 10.64 12.536C10.96 12.216 11.12 11.784 11.12 11.24C11.12 10.6853 10.96 10.2533 10.64 9.944C10.3307 9.624 9.81867 9.464 9.104 9.464H7.136V13ZM17.1447 19.192C16.4621 19.192 15.9021 19.0853 15.4647 18.872C15.0274 18.648 14.7021 18.3547 14.4887 17.992C14.2754 17.6293 14.1687 17.2293 14.1687 16.792C14.1687 16.056 14.4567 15.4587 15.0327 15C15.6087 14.5413 16.4727 14.312 17.6247 14.312H19.6407V14.12C19.6407 13.576 19.4861 13.176 19.1767 12.92C18.8674 12.664 18.4834 12.536 18.0247 12.536C17.6087 12.536 17.2461 12.6373 16.9367 12.84C16.6274 13.032 16.4354 13.32 16.3607 13.704H14.3607C14.4141 13.128 14.6061 12.6267 14.9367 12.2C15.2781 11.7733 15.7154 11.448 16.2487 11.224C16.7821 10.9893 17.3794 10.872 18.0408 10.872C19.1714 10.872 20.0621 11.1547 20.7127 11.72C21.3634 12.2853 21.6888 13.0853 21.6888 14.12V19H19.9447L19.7527 17.72C19.5181 18.1467 19.1874 18.4987 18.7607 18.776C18.3447 19.0533 17.8061 19.192 17.1447 19.192ZM17.6087 17.592C18.1954 17.592 18.6487 17.4 18.9688 17.016C19.2994 16.632 19.5074 16.1573 19.5928 15.592H17.8487C17.3047 15.592 16.9154 15.6933 16.6807 15.896C16.4461 16.088 16.3287 16.328 16.3287 16.616C16.3287 16.9253 16.4461 17.1653 16.6807 17.336C16.9154 17.5067 17.2247 17.592 17.6087 17.592ZM23.7931 19V11.064H25.6011L25.7611 12.408C26.0065 11.9387 26.3585 11.5653 26.8171 11.288C27.2865 11.0107 27.8358 10.872 28.4651 10.872C29.4465 10.872 30.2091 11.1813 30.7531 11.8C31.2971 12.4187 31.5691 13.3253 31.5691 14.52V19H29.5211V14.712C29.5211 14.0293 29.3825 13.5067 29.1051 13.144C28.8278 12.7813 28.3958 12.6 27.8091 12.6C27.2331 12.6 26.7585 12.8027 26.3851 13.208C26.0225 13.6133 25.8411 14.1787 25.8411 14.904V19H23.7931ZM33.6775 19V11.064H35.4855L35.6455 12.408C35.8908 11.9387 36.2428 11.5653 36.7015 11.288C37.1708 11.0107 37.7202 10.872 38.3495 10.872C39.3308 10.872 40.0935 11.1813 40.6375 11.8C41.1815 12.4187 41.4535 13.3253 41.4535 14.52V19H39.4055V14.712C39.4055 14.0293 39.2668 13.5067 38.9895 13.144C38.7122 12.7813 38.2802 12.6 37.6935 12.6C37.1175 12.6 36.6428 12.8027 36.2695 13.208C35.9068 13.6133 35.7255 14.1787 35.7255 14.904V19H33.6775ZM47.4179 19.192C46.6179 19.192 45.9085 19.0213 45.2899 18.68C44.6712 18.3387 44.1859 17.8587 43.8339 17.24C43.4819 16.6213 43.3059 15.9067 43.3059 15.096C43.3059 14.2747 43.4765 13.544 43.8179 12.904C44.1699 12.264 44.6499 11.768 45.2579 11.416C45.8765 11.0533 46.6019 10.872 47.4339 10.872C48.2125 10.872 48.9005 11.0427 49.4979 11.384C50.0952 11.7253 50.5592 12.1947 50.8899 12.792C51.2312 13.3787 51.4019 14.0347 51.4019 14.76C51.4019 14.8773 51.3965 15 51.3859 15.128C51.3859 15.256 51.3805 15.3893 51.3699 15.528H45.3379C45.3805 16.1467 45.5939 16.632 45.9779 16.984C46.3725 17.336 46.8472 17.512 47.4019 17.512C47.8179 17.512 48.1645 17.4213 48.4419 17.24C48.7299 17.048 48.9432 16.8027 49.0819 16.504H51.1619C51.0125 17.0053 50.7619 17.464 50.4099 17.88C50.0685 18.2853 49.6419 18.6053 49.1299 18.84C48.6285 19.0747 48.0579 19.192 47.4179 19.192ZM47.4339 12.536C46.9325 12.536 46.4899 12.68 46.1059 12.968C45.7219 13.2453 45.4765 13.672 45.3699 14.248H49.3219C49.2899 13.7253 49.0979 13.3093 48.7459 13C48.3939 12.6907 47.9565 12.536 47.4339 12.536ZM53.2744 19V7.48H55.3224V19H53.2744ZM57.565 19V7.48H59.613V19H57.565ZM65.6636 19.192C64.8956 19.192 64.2023 19.016 63.5836 18.664C62.9756 18.312 62.4903 17.8267 62.1276 17.208C61.7756 16.5787 61.5996 15.8533 61.5996 15.032C61.5996 14.2107 61.781 13.4907 62.1436 12.872C62.5063 12.2427 62.9916 11.752 63.5996 11.4C64.2183 11.048 64.9116 10.872 65.6796 10.872C66.437 10.872 67.1196 11.048 67.7276 11.4C68.3463 11.752 68.8316 12.2427 69.1836 12.872C69.5463 13.4907 69.7276 14.2107 69.7276 15.032C69.7276 15.8533 69.5463 16.5787 69.1836 17.208C68.8316 17.8267 68.3463 18.312 67.7276 18.664C67.109 19.016 66.421 19.192 65.6636 19.192ZM65.6636 17.416C66.197 17.416 66.661 17.2187 67.0556 16.824C67.4503 16.4187 67.6476 15.8213 67.6476 15.032C67.6476 14.2427 67.4503 13.6507 67.0556 13.256C66.661 12.8507 66.2023 12.648 65.6796 12.648C65.1356 12.648 64.6663 12.8507 64.2716 13.256C63.8876 13.6507 63.6956 14.2427 63.6956 15.032C63.6956 15.8213 63.8876 16.4187 64.2716 16.824C64.6663 17.2187 65.1303 17.416 65.6636 17.416ZM79.4792 19.192C78.7112 19.192 78.0179 19.016 77.3992 18.664C76.7912 18.312 76.3059 17.8267 75.9432 17.208C75.5912 16.5787 75.4152 15.8533 75.4152 15.032C75.4152 14.2107 75.5966 13.4907 75.9592 12.872C76.3219 12.2427 76.8072 11.752 77.4152 11.4C78.0339 11.048 78.7272 10.872 79.4952 10.872C80.2526 10.872 80.9352 11.048 81.5432 11.4C82.1619 11.752 82.6472 12.2427 82.9992 12.872C83.3619 13.4907 83.5432 14.2107 83.5432 15.032C83.5432 15.8533 83.3619 16.5787 82.9992 17.208C82.6472 17.8267 82.1619 18.312 81.5432 18.664C80.9246 19.016 80.2366 19.192 79.4792 19.192ZM79.4792 17.416C80.0126 17.416 80.4766 17.2187 80.8712 16.824C81.2659 16.4187 81.4632 15.8213 81.4632 15.032C81.4632 14.2427 81.2659 13.6507 80.8712 13.256C80.4766 12.8507 80.0179 12.648 79.4952 12.648C78.9512 12.648 78.4819 12.8507 78.0872 13.256C77.7032 13.6507 77.5112 14.2427 77.5112 15.032C77.5112 15.8213 77.7032 16.4187 78.0872 16.824C78.4819 17.2187 78.9459 17.416 79.4792 17.416ZM85.5244 22.52V11.064H87.3484L87.5724 12.2C87.8284 11.848 88.1644 11.5387 88.5804 11.272C89.007 11.0053 89.5564 10.872 90.2284 10.872C90.975 10.872 91.6417 11.0533 92.2284 11.416C92.815 11.7787 93.279 12.2747 93.6204 12.904C93.9617 13.5333 94.1324 14.248 94.1324 15.048C94.1324 15.848 93.9617 16.5627 93.6204 17.192C93.279 17.8107 92.815 18.3013 92.2284 18.664C91.6417 19.016 90.975 19.192 90.2284 19.192C89.631 19.192 89.1084 19.08 88.6604 18.856C88.2124 18.632 87.8497 18.3173 87.5724 17.912V22.52H85.5244ZM89.7964 17.4C90.447 17.4 90.9857 17.1813 91.4124 16.744C91.839 16.3067 92.0524 15.7413 92.0524 15.048C92.0524 14.3547 91.839 13.784 91.4124 13.336C90.9857 12.888 90.447 12.664 89.7964 12.664C89.135 12.664 88.591 12.888 88.1644 13.336C87.7484 13.7733 87.5404 14.3387 87.5404 15.032C87.5404 15.7253 87.7484 16.296 88.1644 16.744C88.591 17.1813 89.135 17.4 89.7964 17.4ZM99.9679 19.192C99.1679 19.192 98.4585 19.0213 97.8399 18.68C97.2212 18.3387 96.7359 17.8587 96.3839 17.24C96.0319 16.6213 95.8559 15.9067 95.8559 15.096C95.8559 14.2747 96.0265 13.544 96.3679 12.904C96.7199 12.264 97.1999 11.768 97.8079 11.416C98.4265 11.0533 99.1519 10.872 99.9839 10.872C100.763 10.872 101.451 11.0427 102.048 11.384C102.645 11.7253 103.109 12.1947 103.44 12.792C103.781 13.3787 103.952 14.0347 103.952 14.76C103.952 14.8773 103.947 15 103.936 15.128C103.936 15.256 103.931 15.3893 103.92 15.528H97.8879C97.9305 16.1467 98.1439 16.632 98.5279 16.984C98.9225 17.336 99.3972 17.512 99.9519 17.512C100.368 17.512 100.715 17.4213 100.992 17.24C101.28 17.048 101.493 16.8027 101.632 16.504H103.712C103.563 17.0053 103.312 17.464 102.96 17.88C102.619 18.2853 102.192 18.6053 101.68 18.84C101.179 19.0747 100.608 19.192 99.9679 19.192ZM99.9839 12.536C99.4825 12.536 99.0399 12.68 98.6559 12.968C98.2719 13.2453 98.0265 13.672 97.9199 14.248H101.872C101.84 13.7253 101.648 13.3093 101.296 13C100.944 12.6907 100.507 12.536 99.9839 12.536ZM105.824 19V11.064H107.648L107.84 12.552C108.128 12.04 108.518 11.6347 109.008 11.336C109.51 11.0267 110.096 10.872 110.768 10.872V13.032H110.192C109.744 13.032 109.344 13.1013 108.992 13.24C108.64 13.3787 108.363 13.6187 108.16 13.96C107.968 14.3013 107.872 14.776 107.872 15.384V19H105.824ZM115.054 19.192C114.371 19.192 113.811 19.0853 113.374 18.872C112.937 18.648 112.611 18.3547 112.398 17.992C112.185 17.6293 112.078 17.2293 112.078 16.792C112.078 16.056 112.366 15.4587 112.942 15C113.518 14.5413 114.382 14.312 115.534 14.312H117.55V14.12C117.55 13.576 117.395 13.176 117.086 12.92C116.777 12.664 116.393 12.536 115.934 12.536C115.518 12.536 115.155 12.6373 114.846 12.84C114.537 13.032 114.345 13.32 114.27 13.704H112.27C112.323 13.128 112.515 12.6267 112.846 12.2C113.187 11.7733 113.625 11.448 114.158 11.224C114.691 10.9893 115.289 10.872 115.95 10.872C117.081 10.872 117.971 11.1547 118.622 11.72C119.273 12.2853 119.598 13.0853 119.598 14.12V19H117.854L117.662 17.72C117.427 18.1467 117.097 18.4987 116.67 18.776C116.254 19.0533 115.715 19.192 115.054 19.192ZM115.518 17.592C116.105 17.592 116.558 17.4 116.878 17.016C117.209 16.632 117.417 16.1573 117.502 15.592H115.758C115.214 15.592 114.825 15.6933 114.59 15.896C114.355 16.088 114.238 16.328 114.238 16.616C114.238 16.9253 114.355 17.1653 114.59 17.336C114.825 17.5067 115.134 17.592 115.518 17.592ZM125.129 19C124.297 19 123.63 18.7973 123.129 18.392C122.628 17.9867 122.377 17.2667 122.377 16.232V12.776H121.017V11.064H122.377L122.617 8.936H124.425V11.064H126.569V12.776H124.425V16.248C124.425 16.632 124.505 16.8987 124.665 17.048C124.836 17.1867 125.124 17.256 125.529 17.256H126.521V19H125.129ZM132.082 19.192C131.314 19.192 130.621 19.016 130.002 18.664C129.394 18.312 128.909 17.8267 128.546 17.208C128.194 16.5787 128.018 15.8533 128.018 15.032C128.018 14.2107 128.2 13.4907 128.562 12.872C128.925 12.2427 129.41 11.752 130.018 11.4C130.637 11.048 131.33 10.872 132.098 10.872C132.856 10.872 133.538 11.048 134.146 11.4C134.765 11.752 135.25 12.2427 135.602 12.872C135.965 13.4907 136.146 14.2107 136.146 15.032C136.146 15.8533 135.965 16.5787 135.602 17.208C135.25 17.8267 134.765 18.312 134.146 18.664C133.528 19.016 132.84 19.192 132.082 19.192ZM132.082 17.416C132.616 17.416 133.08 17.2187 133.474 16.824C133.869 16.4187 134.066 15.8213 134.066 15.032C134.066 14.2427 133.869 13.6507 133.474 13.256C133.08 12.8507 132.621 12.648 132.098 12.648C131.554 12.648 131.085 12.8507 130.69 13.256C130.306 13.6507 130.114 14.2427 130.114 15.032C130.114 15.8213 130.306 16.4187 130.69 16.824C131.085 17.2187 131.549 17.416 132.082 17.416ZM138.127 19V11.064H139.951L140.143 12.552C140.431 12.04 140.821 11.6347 141.311 11.336C141.813 11.0267 142.399 10.872 143.071 10.872V13.032H142.495C142.047 13.032 141.647 13.1013 141.295 13.24C140.943 13.3787 140.666 13.6187 140.463 13.96C140.271 14.3013 140.175 14.776 140.175 15.384V19H138.127ZM148.337 19.192C147.537 19.192 146.827 19.0213 146.209 18.68C145.59 18.3387 145.105 17.8587 144.753 17.24C144.401 16.6213 144.225 15.9067 144.225 15.096C144.225 14.2747 144.395 13.544 144.737 12.904C145.089 12.264 145.569 11.768 146.177 11.416C146.795 11.0533 147.521 10.872 148.353 10.872C149.131 10.872 149.819 11.0427 150.417 11.384C151.014 11.7253 151.478 12.1947 151.809 12.792C152.15 13.3787 152.321 14.0347 152.321 14.76C152.321 14.8773 152.315 15 152.305 15.128C152.305 15.256 152.299 15.3893 152.289 15.528H146.257C146.299 16.1467 146.513 16.632 146.897 16.984C147.291 17.336 147.766 17.512 148.321 17.512C148.737 17.512 149.083 17.4213 149.361 17.24C149.649 17.048 149.862 16.8027 150.001 16.504H152.081C151.931 17.0053 151.681 17.464 151.329 17.88C150.987 18.2853 150.561 18.6053 150.049 18.84C149.547 19.0747 148.977 19.192 148.337 19.192ZM148.353 12.536C147.851 12.536 147.409 12.68 147.025 12.968C146.641 13.2453 146.395 13.672 146.289 14.248H150.241C150.209 13.7253 150.017 13.3093 149.665 13C149.313 12.6907 148.875 12.536 148.353 12.536Z",
            fill: "#1246C8"
        })
    });
}
function ModalBarIconBuilder({ onClick, icon, color, ...rest }) {
    if (!icon) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    const isClickable = isFunction(onClick);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
        disableRipple: !isClickable,
        disableTouchRipple: !isClickable,
        sx: {
            cursor: isClickable ? "pointer" : "default"
        },
        color: color,
        onClick: onClick,
        ...rest,
        children: icon
    });
}
const ModalBarIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ModalBarIconBuilder);
const defaultTextStyle = {
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};
function ModalBarHeaderBuilder({ title, description }) {
    const isMobile = use_is_mobile();
    const titleStyle = isMobile ? theme_theme.typography.subtitle1 : theme_theme.typography.h6;
    const descriptionStyle = isMobile ? theme_theme.typography.caption : theme_theme.typography.body1;
    const textAlignment = isMobile ? alignment_Alignment.start : alignment_Alignment.center;
    const leftPadding = isMobile ? Spacing["250"] : void 0;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
        textAlign: textAlignment,
        sx: defaultTextStyle,
        paddingLeft: leftPadding,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                sx: {
                    ...titleStyle,
                    ...defaultTextStyle
                },
                children: title
            }),
            description ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "textSecondary",
                sx: {
                    ...descriptionStyle,
                    ...defaultTextStyle
                },
                children: description
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
}
const ModalBarHeader = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ModalBarHeaderBuilder);
function ModalBar({ title, description, onStartIconClick, onEndIconClick, startIcon, startIconColor, endIcon, endIconColor, progressBar, progressValue, progressColor, ...rest }) {
    startIconColor = startIconColor ?? "primary";
    endIconColor = endIconColor ?? "default";
    progressColor = progressColor ?? "success";
    progressValue = progressValue ?? 0;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(app_bar_AppBar, {
                position: positioning_Positioning["static"],
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ModalBarIcon, {
                        "data-testid": "modal-bar-start-icon",
                        color: startIconColor,
                        icon: startIcon,
                        onClick: onStartIconClick
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ModalBarHeader, {
                        "data-testid": "modal-bar-header",
                        title: title,
                        description: description
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ModalBarIcon, {
                        "data-testid": "modal-bar-end-icon",
                        color: endIconColor,
                        icon: endIcon,
                        onClick: onEndIconClick
                    })
                ]
            }),
            progressBar ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                width: "100%",
                "data-testid": "modal-bar-progress-container",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_LinearProgress_13636fa3__["default"], {
                    "data-testid": "modal-bar-progress",
                    variant: "determinate",
                    value: progressValue,
                    color: progressColor
                })
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
}
const IconElementStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)("div", styledOptions)(({ isMobile, isMarkedAsRead })=>{
    const iconButtonSize = isMobile ? Spacing["2000"] : Spacing["2500"];
    const iconButtonBackground = isMarkedAsRead ? palette_Action.hover : palette_Primary.light;
    const iconElementStyle = {
        backgroundColor: `${iconButtonBackground} !important`,
        "&:hover": {
            cursor: cursor_style_CursorStyle["default"]
        },
        width: iconButtonSize,
        height: iconButtonSize,
        borderRadius: BorderRadius.full,
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.center,
        padding: Spacing["500"]
    };
    return iconElementStyle;
});
function IconElement({ isMobile, isMarkedAsRead, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconElementStyled, {
        isMobile: isMobile,
        isMarkedAsRead: isMarkedAsRead,
        children: children
    });
}
const BadgeStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(badge_Badge)({
    "&:hover": {
        cursor: cursor_style_CursorStyle["default"]
    }
});
function BadgeContainer({ isMarkedAsRead, isMobile }) {
    const badgeVariant = isMarkedAsRead ? "standard" : "dot";
    const iconColor = isMarkedAsRead ? "action" : "primary";
    const iconFontSize = isMobile ? Spacing["1000"] : Spacing["1500"];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeStyled, {
            color: "tertiary",
            variant: badgeVariant,
            "data-testid": "notification-card-badge-styled",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconElement, {
                isMobile: isMobile,
                isMarkedAsRead: isMarkedAsRead,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BellOutlined, {
                    color: iconColor,
                    sx: {
                        fontSize: `${iconFontSize} !important`
                    }
                })
            })
        })
    });
}
const ACTION_CONTENT_BORDER_RADIUS = "62.4375rem";
const ACTION_CONTENT_BACKGROUND_COLOR = "rgba(18, 70, 200, 0.04)";
const FILTER_GRAYSCALE = "grayscale(100%)";
const CARD_CONTAINER_BORDER_THICK = "0.063rem";
const MIDDLE_OPACITY = 0.5;
const MAX_OPACITY = 1;
const NotificationCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ isMobile, theme })=>{
    const padding = isMobile ? `${Spacing["1000"]}` : `${Spacing["1500"]}`;
    const defaultBorder = `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD}`;
    const borderHovered = `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD_HOVERED}`;
    const componentStyle = {
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        borderRadius: theme.spacing(2),
        boxShadow: displaying_Displaying.none,
        border: defaultBorder,
        padding,
        "&:hover": {
            cursor: isMobile ? cursor_style_CursorStyle["default"] : cursor_style_CursorStyle.pointer,
            border: isMobile ? defaultBorder : borderHovered
        }
    };
    return componentStyle;
});
const NotificationCardContentContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)("div")({
    display: displaying_Displaying.flex,
    gap: Spacing["1000"],
    width: "100%"
});
const GridItemSpaceBetween = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.spaceBetween,
    alignItems: alignment_Alignment.center,
    minHeight: Spacing["2500"]
});
function NotificationCardDescription({ description, typographyVariant }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridItemSpaceBetween, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: typographyVariant,
            color: palette_Text.secondary,
            children: description
        })
    });
}
var custom_arrow_button_interface_CustomArrowButtonDirections = /*#__PURE__*/ function(CustomArrowButtonDirections) {
    CustomArrowButtonDirections[CustomArrowButtonDirections["up"] = 0] = "up";
    CustomArrowButtonDirections[CustomArrowButtonDirections["down"] = 1] = "down";
    return CustomArrowButtonDirections;
}({});
const EMPTY_STRING = "";
const DEFAULT_STEP = 1;
const NUMBER_INPUT_ALLOWED_KEYS = new Set([
    "-",
    "Backspace",
    "Enter",
    "ArrowRight",
    "ArrowLeft",
    "Delete"
]);
const IS_NUMBER_CHARACTER_REGEX = /^\d$/;
function computeNewValueBasedOnDirection({ direction, value, step = DEFAULT_STEP, minValue, maxValue }) {
    const updateStep = direction === custom_arrow_button_interface_CustomArrowButtonDirections.up ? step : -step;
    const parsedCurrentValue = Number(value);
    let newValue = updateStep;
    if (!isNaN(parsedCurrentValue)) newValue = parsedCurrentValue + updateStep;
    return getNextBestValue({
        newValue,
        minValue,
        maxValue
    });
}
function computeNewValueBasedOnUserInput({ newValue, minValue, maxValue }) {
    const isNewValueEmpty = isValueEmpty(newValue);
    const isNewValueTheMinusSymbol = "-" === newValue;
    if (isNewValueEmpty || isNewValueTheMinusSymbol) return EMPTY_STRING;
    const parsedValue = Number(newValue);
    if (!isNaN(parsedValue)) return getNextBestValue({
        newValue: parsedValue,
        minValue,
        maxValue
    });
    return EMPTY_STRING;
}
function isLabelShrunk(currentValue, isFocused) {
    return isFocused || !isValueEmpty(currentValue);
}
function isAllowedKey(key) {
    return IS_NUMBER_CHARACTER_REGEX.test(key) || NUMBER_INPUT_ALLOWED_KEYS.has(key);
}
function callOnChangeWithNewValue(newValue, onChange) {
    if (isFunction(onChange)) onChange(newValue);
}
function getNextBestValue({ newValue, minValue, maxValue }) {
    if (isValueInRange({
        newValue,
        minValue,
        maxValue
    })) return newValue;
    if (!isValueBelowOrEqualToMaxValue({
        newValue,
        maxValue
    })) return maxValue ?? EMPTY_STRING;
    return minValue ?? EMPTY_STRING;
}
function isValueInRange(props) {
    return isValueAboveOrEqualToMinValue(props) && isValueBelowOrEqualToMaxValue(props);
}
function isValueAboveOrEqualToMinValue({ newValue, minValue }) {
    return void 0 === minValue || Number(newValue) >= minValue;
}
function isValueBelowOrEqualToMaxValue({ newValue, maxValue }) {
    return void 0 === maxValue || Number(newValue) <= maxValue;
}
function isValueEmpty(currentValue) {
    const isDefined = null != currentValue;
    if (isDefined && "string" == typeof currentValue) return currentValue.length <= 0;
    return !isDefined;
}
function NotificationCardFooter({ date, actionText = EMPTY_STRING, buttonSize, onClick }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridItemSpaceBetween, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "body2",
                color: palette_Text.secondary,
                children: date
            }),
            actionText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                size: buttonSize,
                color: "primary",
                variant: "text",
                endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {}),
                onClick: onClick,
                children: actionText
            })
        ]
    });
}
function EnvelopeContent({ isMarkedAsRead, tooltipDescription, isNotificationStatusLoading, isMobile, onClickEnvelope }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
        placement: "top",
        description: tooltipDescription,
        disableHoverListener: isMobile,
        enterDelay: 0,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
            size: "small",
            isLoading: isNotificationStatusLoading,
            disabled: isNotificationStatusLoading,
            onClick: onClickEnvelope,
            children: isMarkedAsRead ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EnvelopeOpenOutlined, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EnvelopeOutlined, {})
        })
    });
}
function NotificationCardHeader({ isMobile, isMarkedAsRead, title, tooltipDescription, isNotificationStatusLoading, onClickEnvelope }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridItemSpaceBetween, {
        item: true,
        xs: 12,
        children: [
            isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeContainer, {
                isMarkedAsRead: isMarkedAsRead,
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "h6",
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EnvelopeContent, {
                isMarkedAsRead: isMarkedAsRead,
                tooltipDescription: tooltipDescription,
                isNotificationStatusLoading: isNotificationStatusLoading,
                onClickEnvelope: onClickEnvelope,
                isMobile: isMobile
            })
        ]
    });
}
const GridContainerCentering = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    alignItems: alignment_Alignment.center
});
const notification_card_NotificationCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ title, description, date, actionText = EMPTY_STRING, isMarkedAsRead, isMobile, tooltipDescription, onClick, onMarkAsRead, ...rest }, ref) {
    const midGap = isMobile ? Spacing["750"] : void 0;
    const smallGap = isMobile ? Spacing["250"] : void 0;
    const buttonSize = isMobile ? "small" : "medium";
    const typographyVariant = isMobile ? "body2" : "body1";
    const isDesktop = !isMobile;
    const [isNotificationStatusLoading, setIsNotificationStatusLoading] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const handleEnvelopeClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.stopPropagation();
        setIsNotificationStatusLoading(true);
        onMarkAsRead();
    }, [
        onMarkAsRead
    ]);
    const handleOnClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.stopPropagation();
        onClick?.();
    }, [
        onMarkAsRead
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardContainer, {
        isMobile: isMobile,
        "data-testid": "notification-card-container",
        onClick: onClick,
        ref: ref,
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(NotificationCardContentContainer, {
            "data-testid": "notification-card-content",
            children: [
                isDesktop && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    "data-testid": "notification-card-badge-container-desktop",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeContainer, {
                        isMarkedAsRead: isMarkedAsRead,
                        isMobile: isMobile
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainerCentering, {
                    container: true,
                    gap: midGap,
                    "data-testid": "notification-card-content-grid",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainerCentering, {
                                container: true,
                                gap: smallGap,
                                "data-testid": "notification-card-content-header-desc",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardHeader, {
                                        isMobile: isMobile,
                                        isMarkedAsRead: isMarkedAsRead,
                                        title: title,
                                        tooltipDescription: tooltipDescription,
                                        onClickEnvelope: handleEnvelopeClick,
                                        isNotificationStatusLoading: isNotificationStatusLoading
                                    }),
                                    isMobile && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridItemSpaceBetween, {
                                        item: true,
                                        xs: 12,
                                        "data-testid": "notification-card-content-mobile-title",
                                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                            variant: "subtitle1",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardDescription, {
                                        description: description,
                                        typographyVariant: typographyVariant,
                                        "data-testid": "notification-card-description"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                container: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardFooter, {
                                    date: date,
                                    actionText: actionText,
                                    buttonSize: buttonSize,
                                    onClick: handleOnClick
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
});
const customBorderStyle = `1px solid ${theme_theme.palette.border.main}`;
const customBorderRadius = ` ${BorderRadius.soft} ${BorderRadius.soft} `;
const zeroBorderRadius = ` ${BorderRadius.none} ${BorderRadius.none} `;
const defaultHoverStyle = {
    backgroundColor: theme_theme.palette.primary.main,
    borderColor: theme_theme.palette.primary.main,
    cursor: cursor_style_CursorStyle.pointer,
    color: theme_theme.palette.primary.contrastText
};
const disabledHoverStyle = {
    cursor: cursor_style_CursorStyle.notAllowed
};
const CustomButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("button")(({ direction, disabled })=>{
    const hoverStyle = disabled ? disabledHoverStyle : defaultHoverStyle;
    let borderRadius = customBorderRadius + zeroBorderRadius;
    let borderTop;
    if (direction === custom_arrow_button_interface_CustomArrowButtonDirections.down) {
        borderRadius = zeroBorderRadius + customBorderRadius;
        borderTop = displaying_Displaying.none;
    }
    return {
        border: customBorderStyle,
        borderTop,
        borderRadius,
        padding: Spacing["250"],
        display: displaying_Displaying.flex,
        appearance: displaying_Displaying.none,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.center,
        boxSizing: "border-box",
        background: theme_theme.palette.background["default"],
        color: theme_theme.palette.action.active,
        fontSize: Spacing["650"],
        "&:hover": hoverStyle
    };
});
function CustomArrowButtonBuilder({ onClick, direction, disabled, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomButton, {
        onClick: onClick,
        direction: direction,
        disabled: disabled,
        ...rest,
        children: direction === custom_arrow_button_interface_CustomArrowButtonDirections.up ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CaretUpSolid, {
            fontSize: displaying_Displaying.inherit
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CaretDownSolid, {
            fontSize: displaying_Displaying.inherit
        })
    });
}
const CustomArrowButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomArrowButtonBuilder);
function CustomNumberSpinnerBuilder({ onUpArrowClick, onDownArrowClick, disabled }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box, {
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: Spacing["0"],
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomArrowButton, {
                direction: custom_arrow_button_interface_CustomArrowButtonDirections.up,
                onClick: onUpArrowClick,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomArrowButton, {
                direction: custom_arrow_button_interface_CustomArrowButtonDirections.down,
                onClick: onDownArrowClick,
                disabled: disabled
            })
        ]
    });
}
const CustomNumberSpinner = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomNumberSpinnerBuilder);
const number_input_NumberInput = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ value, minValue, maxValue, disabled, onChange, step = DEFAULT_STEP, ...rest }, ref) {
    const [currentValue, setCurrentValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(value ?? EMPTY_STRING);
    const [isFocused, setIsFocused] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(function() {
        setCurrentValue(value ?? EMPTY_STRING);
    }, [
        value
    ]);
    const handleInputChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        const newValue = computeNewValueBasedOnUserInput({
            newValue: event.target?.value,
            minValue,
            maxValue
        });
        setCurrentValue(newValue);
        callOnChangeWithNewValue(newValue, onChange);
    }, [
        onChange,
        minValue,
        maxValue
    ]);
    const handleKeyDown = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        const pressedKey = event.key;
        if (!isAllowedKey(pressedKey)) event.preventDefault();
    }, [
        isAllowedKey
    ]);
    const handleArrowButtonClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(direction) {
        const newValue = computeNewValueBasedOnDirection({
            direction,
            value: currentValue,
            step,
            minValue,
            maxValue
        });
        setCurrentValue(newValue);
        callOnChangeWithNewValue(newValue, onChange);
    }, [
        currentValue,
        step,
        minValue,
        maxValue,
        onChange
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(text_field_TextField, {
        ref: ref,
        value: currentValue,
        disabled: disabled,
        inputProps: {
            min: minValue,
            max: maxValue,
            pattern: "[0-9]*",
            inputMode: "numeric",
            onKeyDown: handleKeyDown
        },
        InputLabelProps: {
            shrink: isLabelShrunk(currentValue, isFocused)
        },
        type: "text",
        inputMode: "numeric",
        autoComplete: "off",
        autoCorrect: "off",
        maxRows: 1,
        onFocus: ()=>{
            setIsFocused(true);
        },
        onBlur: ()=>{
            setIsFocused(false);
        },
        onChange: handleInputChange,
        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomNumberSpinner, {
            disabled: disabled,
            onUpArrowClick: ()=>{
                handleArrowButtonClick(custom_arrow_button_interface_CustomArrowButtonDirections.up);
            },
            onDownArrowClick: ()=>{
                handleArrowButtonClick(custom_arrow_button_interface_CustomArrowButtonDirections.down);
            }
        }),
        ...rest
    });
});
function PaypalSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "60",
            height: "16",
            viewBox: "0 0 60 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M22.4451 3.79028H19.1292C18.9023 3.79028 18.7093 3.95513 18.6739 4.17913L17.3328 12.6819C17.3062 12.8497 17.4361 13.0009 17.6063 13.0009H19.1893C19.4162 13.0009 19.6092 12.8361 19.6446 12.6116L20.0063 10.3183C20.0412 10.0938 20.2346 9.92895 20.4611 9.92895H21.5108C23.695 9.92895 24.9556 8.87198 25.2848 6.77743C25.4332 5.86107 25.2911 5.14107 24.862 4.63683C24.3908 4.08313 23.5549 3.79028 22.4451 3.79028ZM22.8276 6.89574C22.6463 8.08556 21.7372 8.08556 20.8582 8.08556H20.3578L20.7088 5.86349C20.7297 5.72919 20.846 5.63028 20.9818 5.63028H21.2111C21.8099 5.63028 22.3748 5.63028 22.6666 5.97162C22.8407 6.17525 22.894 6.4778 22.8276 6.89574Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M32.3567 6.85734H30.7688C30.6336 6.85734 30.5167 6.95625 30.4959 7.09055L30.4256 7.53467L30.3145 7.3737C29.9708 6.8748 29.2042 6.70801 28.4391 6.70801C26.6845 6.70801 25.1858 8.03698 24.8939 9.90122C24.7422 10.8312 24.9579 11.7204 25.4855 12.3405C25.9693 12.9107 26.6617 13.1482 27.4854 13.1482C28.8993 13.1482 29.6833 12.2392 29.6833 12.2392L29.6125 12.6804C29.5858 12.8491 29.7158 13.0004 29.885 13.0004H31.3153C31.5427 13.0004 31.7347 12.8355 31.7705 12.611L32.6287 7.17637C32.6559 7.0091 32.5264 6.85734 32.3567 6.85734ZM30.1434 9.94776C29.9902 10.8549 29.2702 11.4639 28.3519 11.4639C27.8908 11.4639 27.5223 11.316 27.2857 11.0358C27.051 10.7575 26.9618 10.3613 27.0365 9.92013C27.1795 9.02073 27.9116 8.39189 28.8159 8.39189C29.2668 8.39189 29.6333 8.5417 29.8748 8.82437C30.1167 9.10995 30.2127 9.50849 30.1434 9.94776Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M40.8134 6.85742H39.2178C39.0655 6.85742 38.9225 6.93306 38.8362 7.0596L36.6355 10.3013L35.7026 7.18615C35.6439 6.99124 35.4641 6.85742 35.2604 6.85742H33.6924C33.5019 6.85742 33.3695 7.0436 33.4301 7.223L35.1877 12.3808L33.5353 14.7134C33.4054 14.8972 33.5363 15.1498 33.7608 15.1498H35.3545C35.5058 15.1498 35.6473 15.0761 35.7332 14.952L41.0403 7.29136C41.1673 7.10809 41.0369 6.85742 40.8134 6.85742Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M46.0964 3.79028H42.7801C42.5537 3.79028 42.3607 3.95513 42.3253 4.17913L40.9842 12.6819C40.9575 12.8497 41.0875 13.0009 41.2567 13.0009H42.9585C43.1166 13.0009 43.2518 12.8856 43.2766 12.7285L43.6572 10.3183C43.6921 10.0938 43.8855 9.92895 44.112 9.92895H45.1612C47.3459 9.92895 48.606 8.87198 48.9357 6.77743C49.0846 5.86107 48.9415 5.14107 48.5124 4.63683C48.0416 4.08313 47.2063 3.79028 46.0964 3.79028ZM46.479 6.89574C46.2981 8.08556 45.389 8.08556 44.5095 8.08556H44.0097L44.3612 5.86349C44.382 5.72919 44.4974 5.63028 44.6336 5.63028H44.863C45.4613 5.63028 46.0266 5.63028 46.3185 5.97162C46.4926 6.17525 46.5454 6.4778 46.479 6.89574Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M56.0077 6.85734H54.4208C54.2846 6.85734 54.1687 6.95625 54.1483 7.09055L54.078 7.53467L53.9665 7.3737C53.6228 6.8748 52.8567 6.70801 52.0916 6.70801C50.3369 6.70801 48.8388 8.03698 48.5469 9.90122C48.3956 10.8312 48.6104 11.7204 49.1379 12.3405C49.6228 12.9107 50.3142 13.1482 51.1379 13.1482C52.5517 13.1482 53.3357 12.2392 53.3357 12.2392L53.2649 12.6804C53.2383 12.8491 53.3682 13.0004 53.5384 13.0004H54.9682C55.1946 13.0004 55.3876 12.8355 55.423 12.611L56.2817 7.17637C56.3078 7.0091 56.1779 6.85734 56.0077 6.85734ZM53.7944 9.94776C53.6422 10.8549 52.9212 11.4639 52.0029 11.4639C51.5428 11.4639 51.1733 11.316 50.9367 11.0358C50.702 10.7575 50.6138 10.3613 50.6875 9.92013C50.8315 9.02073 51.5626 8.39189 52.4669 8.39189C52.9178 8.39189 53.2843 8.5417 53.5258 8.82437C53.7687 9.10995 53.8647 9.50849 53.7944 9.94776Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M57.8796 4.02349L56.5186 12.6819C56.492 12.8497 56.6219 13.0009 56.7911 13.0009H58.1593C58.3867 13.0009 58.5797 12.8361 58.6146 12.6116L59.9567 4.10931C59.9833 3.94155 59.8534 3.78979 59.6842 3.78979H58.1521C58.0168 3.79028 57.9004 3.88919 57.8796 4.02349Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M3.56256 14.6534L3.81614 13.0428L3.25129 13.0297H0.554077L2.4285 1.14459C2.43432 1.10871 2.45323 1.07525 2.48087 1.0515C2.5085 1.02774 2.5439 1.01465 2.58074 1.01465H7.12862C8.63844 1.01465 9.68038 1.32883 10.2244 1.94895C10.4794 2.23986 10.6418 2.54386 10.7204 2.87841C10.8028 3.22944 10.8043 3.64883 10.7238 4.16035L10.718 4.19768V4.52544L10.973 4.66992C11.1878 4.78386 11.3584 4.91428 11.4893 5.06362C11.7075 5.31235 11.8486 5.62847 11.9083 6.00325C11.9698 6.38871 11.9495 6.84738 11.8486 7.36665C11.7323 7.96398 11.5441 8.48422 11.2901 8.90992C11.0564 9.30216 10.7587 9.6275 10.4052 9.87962C10.0678 10.1191 9.6668 10.301 9.21347 10.4173C8.7742 10.5317 8.27335 10.5894 7.72402 10.5894H7.37008C7.11699 10.5894 6.87117 10.6806 6.6782 10.844C6.48474 11.0108 6.35674 11.2386 6.31747 11.4879L6.2908 11.6328L5.8428 14.4716L5.82244 14.5759C5.81711 14.6088 5.8079 14.6253 5.79432 14.6365C5.7822 14.6466 5.76474 14.6534 5.74777 14.6534H3.56256Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M11.2144 4.23535C11.2008 4.32214 11.1853 4.41087 11.1679 4.50202C10.5681 7.58129 8.51624 8.64505 5.89564 8.64505H4.56133C4.24085 8.64505 3.97079 8.87778 3.92085 9.1939L3.2377 13.5265L3.04424 14.7546C3.01176 14.9621 3.17176 15.1493 3.38121 15.1493H5.74776C6.028 15.1493 6.26606 14.9457 6.31018 14.6693L6.33345 14.549L6.77903 11.7214L6.80764 11.5663C6.85127 11.2889 7.08982 11.0853 7.37006 11.0853H7.724C10.0168 11.0853 11.8118 10.1544 12.3364 7.46056C12.5555 6.33523 12.4421 5.39559 11.8622 4.73475C11.6867 4.53547 11.469 4.37014 11.2144 4.23535Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10.5871 3.98529C10.4954 3.95863 10.4009 3.93438 10.3039 3.91257C10.2065 3.89123 10.1066 3.87232 10.0038 3.85584C9.64405 3.79766 9.24987 3.77002 8.82757 3.77002H5.26296C5.1752 3.77002 5.09181 3.7899 5.01714 3.82578C4.85278 3.90481 4.7306 4.06044 4.70102 4.25099L3.94272 9.0539L3.9209 9.19402C3.97084 8.8779 4.2409 8.64517 4.56138 8.64517H5.89569C8.51629 8.64517 10.5682 7.58093 11.1679 4.50214C11.1859 4.41099 11.2009 4.32226 11.2145 4.23547C11.0627 4.15499 10.8984 4.08614 10.7214 4.02747C10.6777 4.01293 10.6327 3.99887 10.5871 3.98529Z",
                    fill: "#222D65"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.701 4.25092C4.73058 4.06037 4.85276 3.90473 5.01712 3.82619C5.09227 3.79031 5.17518 3.77043 5.26294 3.77043H8.82755C9.24985 3.77043 9.64403 3.79807 10.0038 3.85625C10.1066 3.87273 10.2065 3.89164 10.3039 3.91298C10.4009 3.93479 10.4954 3.95904 10.5871 3.9857C10.6326 3.99928 10.6777 4.01334 10.7218 4.0274C10.8988 4.08607 11.0632 4.1554 11.2149 4.2354C11.3934 3.09746 11.2135 2.32267 10.5982 1.6211C9.91991 0.848733 8.69567 0.518066 7.12912 0.518066H2.58124C2.26124 0.518066 1.98827 0.750794 1.93882 1.0674L0.0445159 13.0747C0.00718259 13.3122 0.190455 13.5266 0.42997 13.5266H3.23773L3.9427 9.05382L4.701 4.25092Z",
                    fill: "#253B80"
                })
            ]
        })
    });
}
const PAYPAL_BUTTON_BACKGROUND = "#F9A000";
const PAYPAL_TEXT_COLOR = "#253B80";
const ButtonContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(button_Button)({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    flexDirection: direction_Direction.row,
    background: PAYPAL_BUTTON_BACKGROUND,
    padding: `${Spacing["750"]} ${Spacing["1000"]}`,
    gap: Spacing["250"],
    ":hover": {
        background: PAYPAL_BUTTON_BACKGROUND
    },
    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
        background: palette_Action.disabledBackground,
        "& p": {
            color: palette_Text.disabled
        }
    }
});
const PaypalTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    color: PAYPAL_TEXT_COLOR,
    fontFamily: "Inter",
    fontSize: Spacing["750"],
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: Spacing["1000"],
    letterSpacing: "-0.24px"
});
const PaypalIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(PaypalSolid)({
    width: "4rem"
});
function PaypalButton({ children, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ButtonContainer, {
        className: "paypal-button",
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PaypalTypographyContainer, {
                children: children
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PaypalIconContainer, {})
        ]
    });
}
var isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");
var isEmpty_default = /*#__PURE__*/ __webpack_require__.n(isEmpty);
var isUndefined = __webpack_require__("./node_modules/lodash/isUndefined.js");
var isUndefined_default = /*#__PURE__*/ __webpack_require__.n(isUndefined);
const PlanSelectorClickableGridSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
    shouldForwardProp: ()=>true
})(({ onClick })=>({
        [":hover"]: {
            cursor: isUndefined_default()(onClick) ? cursor_style_CursorStyle["default"] : cursor_style_CursorStyle.pointer
        }
    }));
function PlanSelectorIconSection({ color, readonly, selected, notAvailable }) {
    if (readonly || notAvailable) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    if (selected) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CheckCircleSolid, {
        fontSize: "medium",
        color: color
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CircleLargeOutlined, {
        fontSize: "medium",
        color: "action"
    });
}
const PlanSelectorLabelSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(chip_Chip)`
  border-radius: ${Spacing["500"]} ${Spacing["500"]} 0px 0px;
  padding: ${Spacing["500"]} ${Spacing["750"]};
  color: ${({ theme, notAvailable })=>notAvailable ? theme.palette.text.secondary : void 0};
`;
function PlanSelector(props) {
    const defaultExtraTextVariant = "body2";
    const defaultExtraTextColor = "text.secondary";
    const extraTextConfig = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        let extraTextGradient;
        let extraTextVariant = defaultExtraTextVariant;
        let extraTextColor = defaultExtraTextColor;
        if (props.readonly || props.notAvailable) return {
            gradient: extraTextGradient,
            variant: extraTextVariant,
            color: extraTextColor
        };
        if (props.extraTextHighlighted) {
            extraTextGradient = props.borderColor;
            extraTextVariant = "subtitle2";
            extraTextColor = void 0;
        }
        return {
            gradient: extraTextGradient,
            variant: extraTextVariant,
            color: extraTextColor
        };
    }, [
        props.extraTextHighlighted,
        props.borderColor,
        props.readonly,
        props.notAvailable
    ]);
    const color = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (props.selected && true !== props.readonly && true !== props.notAvailable) return props.borderColor;
    }, [
        props.selected,
        props.borderColor,
        props.readonly,
        props.notAvailable
    ]);
    const formattedFrequencyCaption = `/${props.frequencyCaption}`;
    const priceTextProperties = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        const defaultProperties = {
            color: "text.primary",
            fontWeight: typography_FontWeight.bold
        };
        if (isEmpty_default()(props.discountedPrice)) return defaultProperties;
        return {
            fontSize: typography_FontSize.xs,
            color: "text.secondary",
            sx: {
                textDecoration: "line-through"
            }
        };
    }, [
        props.discountedPrice
    ]);
    let onClickCallback;
    if (props.onClick && !props.readonly && !props.notAvailable) onClickCallback = props.onClick;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        container: true,
        direction: direction_Direction.column,
        rowSpacing: 0,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                item: true,
                children: props.label && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlanSelectorLabelSection, {
                    size: "small",
                    label: props.label,
                    notAvailable: props.notAvailable
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlanSelectorClickableGridSection, {
                item: true,
                onClick: onClickCallback,
                id: props.id,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GradientBoxOutlined, {
                    gradient: color,
                    size: "small",
                    withLabel: !!props.label,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        container: true,
                        direction: direction_Direction.column,
                        rowGap: Spacing["250"],
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
                                    direction: direction_Direction.row,
                                    gap: Spacing["500"],
                                    alignItems: alignment_Alignment.center,
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlanSelectorIconSection, {
                                            selected: props.selected,
                                            readonly: props.readonly,
                                            notAvailable: props.notAvailable,
                                            color: color
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                            variant: "subtitle1",
                                            color: props.notAvailable ? "textSecondary" : void 0,
                                            children: props.frequencyTitle
                                        })
                                    ]
                                })
                            }),
                            !props.notAvailable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
                                    direction: direction_Direction.row,
                                    spacing: Spacing["0"],
                                    alignItems: "baseline",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
                                            direction: direction_Direction.row,
                                            spacing: Spacing["250"],
                                            alignItems: "baseline",
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Typography, {
                                                    variant: "body1",
                                                    ...priceTextProperties,
                                                    children: [
                                                        props.price,
                                                        " ",
                                                        props.currency
                                                    ]
                                                }),
                                                props.discountedPrice && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Typography, {
                                                    variant: "body1",
                                                    fontWeight: typography_FontWeight.bold,
                                                    children: [
                                                        props.discountedPrice,
                                                        " ",
                                                        props.currency
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                            variant: "body1",
                                            children: formattedFrequencyCaption
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: true,
                                alignContent: alignment_Alignment.center,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                    variant: extraTextConfig.variant,
                                    gradient: extraTextConfig.gradient,
                                    color: extraTextConfig.color,
                                    children: props.extraText
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function getChipColor(accentColor, disabled) {
    if (disabled) return "default";
    if (!accentColor) return "tertiary";
    if ("primary" === accentColor) return "info";
    return "secondary";
}
function getIconColor(accentColor, disabled) {
    if (disabled || !accentColor) return "action";
    return accentColor;
}
function hexToRgba(hex, opacity) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const red = bigint >> 16 & 255;
    const green = bigint >> 8 & 255;
    const blue = 255 & bigint;
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
const GREYX_700_WITH_OPACITY = hexToRgba(Greyx["700"], 0.5);
const ProductCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ disabled = false, accentColor, isMobile, theme })=>{
    const isBorderEnabled = !!accentColor;
    let borderLeftStyle = `${ONE_PIXEL_REM} ${border_style_BorderStyle.solid} inherit`;
    if (isBorderEnabled) {
        const borderColor = disabled ? GREYX_700_WITH_OPACITY : theme.palette[accentColor].main;
        borderLeftStyle = `${theme.spacing(2)} ${border_style_BorderStyle.solid} ${borderColor}`;
    }
    const padding = isMobile ? `${Spacing["750"]} ${Spacing["750"]} ${Spacing["750"]} ${Spacing["1500"]}` : `${Spacing["1000"]} ${Spacing["1500"]}`;
    return {
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        borderRadius: theme.spacing(2),
        boxShadow: displaying_Displaying.none,
        border: `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD}`,
        padding,
        borderLeft: borderLeftStyle,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer,
            border: `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD_HOVERED}`,
            borderLeft: borderLeftStyle,
            "& #card-action-content": {
                background: ACTION_CONTENT_BACKGROUND_COLOR,
                borderRadius: ACTION_CONTENT_BORDER_RADIUS,
                padding: Spacing["500"]
            }
        }
    };
});
const ProductCardContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isMobile })=>{
    const gap = isMobile ? Spacing["500"] : Spacing["2000"];
    return {
        gap,
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        width: "100%"
    };
});
function ProductCardChipBuilder({ accentColor, disabled, badge }) {
    const chipConfig = {
        label: badge,
        variant: "outlined",
        size: "small",
        disabled,
        color: accentColor,
        sx: {
            opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
        }
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_Chip, {
        "data-testid": "product-card-chip",
        ...chipConfig
    });
}
const ProductCardChip = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardChipBuilder);
function ProductCardDateBuilder({ date }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: "body2",
            color: "GrayText",
            "data-testid": "product-card-date",
            children: date
        })
    });
}
const ProductCardDate = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardDateBuilder);
function PriceSectionBuilder({ price, disabled }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        item: true,
        xs: 12,
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        "data-testid": "card-container-price-section",
        sx: {
            opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
        },
        children: price
    });
}
const ProductCardPrice = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(PriceSectionBuilder);
function ProductCardActionBuilder({ iconButtonId, disabled = false, isMobile }) {
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    const sxForOpacity = {
        opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        sx: sxForOpacity,
        "data-testid": "card-container-boundary-margin-left",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
            id: iconButtonId ?? "product-card-action-icon",
            color: "default",
            size: "medium",
            disabled: disabled,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {})
        })
    });
}
const ProductCardAction = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardActionBuilder);
function ProductCardTitleGenerator({ isLocked, disabled, accentColor, title, titleVariant, titleIcon }) {
    const iconColor = getIconColor(accentColor, disabled);
    let renderedTitleIcon = titleIcon;
    if (titleIcon && !titleIcon?.props?.color) renderedTitleIcon = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].cloneElement(titleIcon, {
        color: iconColor,
        ...titleIcon?.props
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            isLocked ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LockViewfinderOutlined, {
                color: iconColor
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            renderedTitleIcon || /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: titleVariant,
                color: "textPrimary",
                "data-testid": "product-card-title",
                children: title
            })
        ]
    });
}
const ProductCardTitle = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardTitleGenerator);
const BlurEffectGrid = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])(({ isBlurred, disabled })=>({
        filter: isBlurred ? "blur(0.35rem)" : "none",
        opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
    }));
const product_card_ProductCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ accentColor = PRIMARY_COLOR, title, price, date, badge, description, disabled = false, iconButtonId, isMobile: isMobileProp, isLocked, titleIcon, isBlurred, ...rest }, ref) {
    const isMobileHookResult = use_is_mobile();
    const isMobile = isMobileProp ?? isMobileHookResult;
    const color = getChipColor(accentColor, disabled);
    const productChip = {
        accentColor: color,
        disabled,
        badge
    };
    if (isBlurred) {
        productChip.accentColor = "tealDusk";
        productChip.disabled = false;
    }
    const titleItemsAlignment = isMobile ? alignment_Alignment.start : alignment_Alignment.center;
    const titleVariant = isMobile ? "subtitle1" : "h6";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardContainer, {
        accentColor: accentColor,
        disabled: disabled,
        isMobile: isMobile,
        ref: ref,
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProductCardContent, {
            isMobile: isMobile,
            "data-testid": "card-container-content-flexed",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    container: true,
                    wrap: "nowrap",
                    direction: direction_Direction.column,
                    justifyContent: alignment_Alignment.center,
                    alignItems: alignment_Alignment.flexStart,
                    spacing: 2,
                    style: {
                        marginLeft: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardChip, {
                                ...productChip
                            })
                        }),
                        date ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardDate, {
                            date: date
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlurEffectGrid, {
                            item: true,
                            isBlurred: isBlurred,
                            disabled: disabled,
                            zeroMinWidth: true,
                            display: displaying_Displaying.flex,
                            gap: Spacing["500"],
                            alignItems: titleItemsAlignment,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardTitle, {
                                title: title,
                                titleVariant: titleVariant,
                                isLocked: isLocked,
                                disabled: disabled,
                                accentColor: accentColor,
                                titleIcon: titleIcon
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlurEffectGrid, {
                            item: true,
                            isBlurred: isBlurred,
                            disabled: disabled,
                            children: description
                        }),
                        isBlurred ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardPrice, {
                            price: price,
                            disabled: disabled
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardAction, {
                    iconButtonId: iconButtonId,
                    disabled: disabled,
                    isMobile: isMobile
                })
            ]
        })
    });
});
const IconSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ disabled })=>({
        filter: disabled ? FILTER_GRAYSCALE : INITIAL_OPTION
    }));
const ImageSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("img", styledOptions)(({ disabled })=>({
        objectFit: CONTAIN_OPTION,
        filter: disabled ? FILTER_GRAYSCALE : INITIAL_OPTION
    }));
function useIsHovering() {
    const [isHovering, setIsHovering] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    return {
        isHovering,
        startHover,
        endHover
    };
    function startHover() {
        setIsHovering(true);
    }
    function endHover() {
        setIsHovering(false);
    }
}
const use_is_hovering = useIsHovering;
var profile_questionnaire_status_enum_ProfileQuestionnaireStatus = /*#__PURE__*/ function(ProfileQuestionnaireStatus) {
    ProfileQuestionnaireStatus["ToComplete"] = "to-complete";
    ProfileQuestionnaireStatus["Completing"] = "completing";
    ProfileQuestionnaireStatus["Completed"] = "completed";
    return ProfileQuestionnaireStatus;
}({});
const IconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginRight: Spacing["750"],
    "&.mobile-version": {
        paddingTop: Spacing["250"],
        alignItems: alignment_Alignment.flexStart,
        alignSelf: alignment_Alignment.stretch
    }
});
const IconWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isActive })=>({
        padding: Spacing["250"],
        background: isActive ? palette_Secondary.main : palette_Common.white.main,
        borderRadius: BorderRadius.brand,
        color: isActive ? palette_Common.white.main : palette_Text.secondary,
        "& svg": {
            width: 20,
            height: 20
        }
    }));
function ProfileQuestionnaireIcon({ isMobile, isSectionCompleted, isSectionActive, activeIcon, inactiveIcon }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconContainer, {
        className: isMobile ? "mobile-version" : void 0,
        children: isSectionCompleted ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CheckCircleSolid, {
            color: "secondary",
            style: {
                fontSize: 28
            }
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconWrapper, {
            isActive: isSectionActive,
            children: isSectionActive ? activeIcon : inactiveIcon
        })
    });
}
const ACTIVE_PADDING = `${Spacing["750"]} ${Spacing["1500"]}`;
const MOBILE_PADDING = Spacing["0"];
function getProfileQuestionnaireItemWrapperPadding({ isMobile, isActive }) {
    if (isMobile) return MOBILE_PADDING;
    return isActive ? ACTIVE_PADDING : MOBILE_PADDING;
}
const ProfileQuestionnaireItemWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)((args)=>{
    const padding = getProfileQuestionnaireItemWrapperPadding(args);
    return {
        width: "100%",
        padding
    };
});
const ACTIVE_MOBILE_PADDING_STYLES = `${Spacing["500"]} ${Spacing["1000"]} ${Spacing["1000"]} ${Spacing["1000"]}`;
const INACTIVE_MOBILE_PADDING_STYLES = `${Spacing["750"]} ${Spacing["1000"]}`;
const ACTIVE_PADDING_STYLES = `${Spacing["1500"]} ${Spacing["0"]}`;
const INACTIVE_PADDING_STYLES = `${Spacing["1500"]} ${Spacing["1500"]}`;
function getProfileQuestionnairePaperPadding({ isMobile, isActive }) {
    if (isMobile) return isActive ? ACTIVE_MOBILE_PADDING_STYLES : INACTIVE_MOBILE_PADDING_STYLES;
    return isActive ? ACTIVE_PADDING_STYLES : INACTIVE_PADDING_STYLES;
}
const ProfileQuestionnairePaper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__["default"], styledOptions)((args)=>{
    const padding = getProfileQuestionnairePaperPadding(args);
    return {
        display: displaying_Displaying.flex,
        justifyContent: alignment_Alignment.spaceBetween,
        alignItems: alignment_Alignment.center,
        padding,
        borderRadius: 0,
        background: args.isActive ? palette_Secondary.light : palette_Common.white.main,
        "& div": {
            display: displaying_Displaying.inherit,
            alignItems: displaying_Displaying.inherit
        }
    };
});
const MAX_PERCENTAGE = 100;
const profile_questionnaire_item_EMPTY_STRING = "";
const PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE = "1.9375rem";
function ProfileQuestionnaireItem({ id, activeIcon, inactiveIcon, percentage, sectionNumber, title, fallbackDescription, status, isMobile = false, buttonText = "button text", percentagePrefixText = "percentage prefix text", withLinearProgress = false, withBottomDivider = true, onClick, onClickEndActionButton, editButtonTooltipText = "", tooltipOpen = false, itemTooltipMessage }) {
    const { isHovering, startHover, endHover } = use_is_hovering();
    const isSectionActive = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return status === profile_questionnaire_status_enum_ProfileQuestionnaireStatus.Completing;
    }, [
        status
    ]);
    const isSectionCompleted = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return percentage === MAX_PERCENTAGE;
    }, [
        percentage
    ]);
    const description = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (isSectionCompleted) return profile_questionnaire_item_EMPTY_STRING;
        if (status === profile_questionnaire_status_enum_ProfileQuestionnaireStatus.Completing) return `${percentagePrefixText} ${percentage}%`;
        return fallbackDescription;
    }, [
        isSectionCompleted,
        status
    ]);
    const shouldUseGrayText = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return isSectionActive || isSectionCompleted;
    }, [
        isSectionActive,
        isSectionCompleted
    ]);
    const shouldShowTooltipMessage = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return itemTooltipMessage && "" !== itemTooltipMessage;
    }, [
        itemTooltipMessage
    ]);
    const shouldShowEditButtonTooltip = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "" !== editButtonTooltipText;
    }, []);
    const titleVariant = isMobile ? "subtitle1" : "h6";
    const descriptionVariant = isMobile ? "caption" : "body1";
    const onClickBoxCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        if (isSectionCompleted) return onClick?.(id);
        if (isSectionActive) return onClickEndActionButton?.(id);
    }, [
        isSectionCompleted,
        isSectionActive,
        onClick,
        onClickEndActionButton
    ]);
    const profileQuestionnaireItem = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"], {
        onMouseEnter: startHover,
        onMouseLeave: endHover,
        onClick: onClickBoxCallback,
        style: {
            cursor: isSectionActive || isSectionCompleted ? "pointer" : "initial"
        },
        children: [
            withLinearProgress ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LinearProgress, {
                value: percentage,
                color: "secondary",
                variant: "determinate"
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileQuestionnairePaper, {
                elevation: 0,
                isMobile: isMobile,
                isActive: isSectionActive,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProfileQuestionnaireItemWrapper, {
                    isMobile: isMobile,
                    isActive: isSectionActive,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileQuestionnaireIcon, {
                            isMobile: isMobile,
                            isSectionCompleted: isSectionCompleted,
                            isSectionActive: isSectionActive,
                            activeIcon: activeIcon,
                            inactiveIcon: inactiveIcon
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            style: {
                                display: isMobile ? displaying_Displaying.initial : displaying_Displaying.inherit,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    style: {
                                        display: displaying_Displaying.flex
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                            style: {
                                                minWidth: PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                                    color: shouldUseGrayText ? palette_Text.primary : palette_Text.secondary,
                                                    variant: titleVariant,
                                                    children: sectionNumber
                                                }),
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                                    color: palette_Text.secondary,
                                                    variant: titleVariant,
                                                    style: {
                                                        marginLeft: Spacing["500"],
                                                        marginRight: Spacing["500"]
                                                    },
                                                    children: "\xb7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                            style: {
                                                marginRight: Spacing["500"]
                                            },
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                                color: shouldUseGrayText ? palette_Text.primary : palette_Text.secondary,
                                                variant: titleVariant,
                                                children: title
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: {
                                        flexGrow: 1,
                                        marginLeft: isMobile ? PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE : 0
                                    },
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                        color: isSectionActive ? palette_Success.main : palette_Text.secondary,
                                        variant: descriptionVariant,
                                        children: description
                                    })
                                }),
                                isSectionActive ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: {
                                        marginLeft: isMobile ? Spacing["1500"] : 0,
                                        marginTop: isMobile ? Spacing["750"] : "initial"
                                    },
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                                        variant: "contained",
                                        color: "success",
                                        size: "medium",
                                        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {}),
                                        onClick: ()=>onClickEndActionButton?.(id),
                                        children: buttonText
                                    })
                                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
                            ]
                        }),
                        isSectionCompleted ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
                            description: editButtonTooltipText,
                            disableHoverListener: !shouldShowEditButtonTooltip,
                            disableTouchListener: !shouldShowEditButtonTooltip,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                                size: "small",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onClick?.(id);
                                },
                                style: {
                                    opacity: isHovering || isMobile ? 1 : 0,
                                    transition: "all .1s"
                                },
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PenOutlined, {
                                    color: "primary"
                                })
                            })
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
                    ]
                })
            }),
            withBottomDivider ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], {
                style: {
                    borderColor: isSectionActive ? palette_Secondary.main : palette_Border.main
                }
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
    return shouldShowTooltipMessage ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
        open: tooltipOpen,
        description: itemTooltipMessage ?? "",
        arrow: true,
        placement: "top",
        children: profileQuestionnaireItem
    }) : profileQuestionnaireItem;
}
const ProfileQuestionnaireStack = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"])({
    borderRadius: BorderRadius.brand,
    border: `1px solid ${palette_Border.main}`,
    overflow: "hidden"
});
function ProfileQuestionnaire({ sections, id, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileQuestionnaireStack, {
        id: id,
        children: sections.map(function(section, index) {
            const sectionNumber = index + 1;
            const shouldShowLinearProgress = section.status === profile_questionnaire_status_enum_ProfileQuestionnaireStatus.Completing && section.percentage > 0;
            const shouldShowBottomDivider = index + 1 !== sections.length;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(ProfileQuestionnaireItem, {
                ...section,
                ...rest,
                key: section.id,
                sectionNumber: sectionNumber,
                withLinearProgress: shouldShowLinearProgress,
                withBottomDivider: shouldShowBottomDivider
            });
        })
    });
}
const QuantitySelectorContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
});
const quantitySelectorLetterSpacing = "0.009375rem";
const QuantitySelectorTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    fontStyle: "normal",
    fontSize: Spacing["1000"],
    letterSpacing: quantitySelectorLetterSpacing,
    color: palette_Text.primary,
    lineHeight: "150%"
});
const TypographyWrapperContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    padding: `0 ${Spacing["250"]}`
});
function QuantitySelector({ quantity, color, size, incrementButtonId, decrementButtonId, isIncrementButtonDisable, isDecrementButtonDisable, onIncrementButtonClick, onDecrementButtonClick, ...rest }) {
    const _color = color ?? "default";
    const _size = size ?? "small";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(QuantitySelectorContainer, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                id: decrementButtonId,
                "data-testid": decrementButtonId,
                color: _color,
                size: _size,
                disabled: isDecrementButtonDisable ?? false,
                onClick: onDecrementButtonClick,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MinusCircleSolid, {})
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TypographyWrapperContainer, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(QuantitySelectorTypographyContainer, {
                    variant: "body1",
                    children: quantity
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                id: incrementButtonId,
                "data-testid": incrementButtonId,
                color: _color,
                size: _size,
                disabled: isIncrementButtonDisable ?? false,
                onClick: onIncrementButtonClick,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlusCircleSolid, {})
            })
        ]
    });
}
const LargeRadio = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.Radio)({
    "& .MuiSvgIcon-root": {
        fontSize: Spacing["1750"]
    }
});
const radio_Radio = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isLarge, ...rest }, ref) {
    if (isLarge) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LargeRadio, {
        ...rest
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.Radio, {
        ref: ref,
        ...rest
    });
});
const SCROLL_AREA_DEFAULT_COLOR = PRIMARY_COLOR;
const SCROLL_AREA_HEIGHT = 320;
const SCROLL_AREA_WIDTH = 640;
const scroll_paper_area_ScrollPaperArea = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ color, title, children, ...rest }, ref) {
    const isMobile = use_is_mobile();
    const typographyStyles = isMobile ? theme_theme.typography.subtitle1 : theme_theme.typography.h6;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ScrollPaperAreaRoot, {
        ref: ref,
        ...rest,
        sx: {
            width: isMobile ? SCROLL_AREA_HEIGHT : SCROLL_AREA_WIDTH
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ScrollPaperAreaHeader, {
                color: color,
                sx: {
                    ...typographyStyles
                },
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ScrollPaperAreaContent, {
                children: children
            })
        ]
    });
});
const ScrollPaperAreaRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(({ theme })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(3),
        height: SCROLL_AREA_HEIGHT,
        maxHeight: SCROLL_AREA_HEIGHT,
        overflow: "hidden"
    }));
const ScrollPaperAreaHeader = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ color = SCROLL_AREA_DEFAULT_COLOR, theme })=>({
        borderBottom: `1px solid ${theme.palette.border.main}`,
        backgroundColor: `${theme.palette[color].light}`,
        color: `${theme.palette[color].dark}`,
        textAlign: alignment_Alignment.center,
        padding: theme.spacing(1, 5)
    }));
const ScrollPaperAreaContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(({ theme })=>({
        padding: theme.spacing(4, 6),
        overflowY: "scroll"
    }));
var search_card_interface_SearchCardTypes = /*#__PURE__*/ function(SearchCardTypes) {
    SearchCardTypes["BonusAndEconomicContributions"] = "bonusAndEconomicContributions";
    SearchCardTypes["DeductionsAndFiscalBonus"] = "deductionsAndFiscalBonus";
    SearchCardTypes["FiscalDeclarationAnd730"] = "fiscalDeclarationAnd730";
    SearchCardTypes["CertificatesAndSupportServices"] = "certificatesAndSupportServices";
    SearchCardTypes["FinancialServices"] = "financialServices";
    SearchCardTypes["Other"] = "other";
    return SearchCardTypes;
}({});
const BORDER_THICKNESS = "0.063rem";
const SearchCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ accentColor })=>({
        padding: `${Spacing["750"]} ${Spacing["1000"]}`,
        borderRadius: Spacing["500"],
        border: `${BORDER_THICKNESS} ${border_style_BorderStyle.solid} ${palette_Border.main}`,
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette[accentColor].main}`,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer,
            border: `${BORDER_THICKNESS} ${border_style_BorderStyle.solid} ${palette_Border.dark}`,
            borderLeft: `${Spacing["500"]} solid ${theme_theme.palette[accentColor].main}`
        }
    }));
function getMainColor(type) {
    return colorsBasedOnTypes[type];
}
const colorsBasedOnTypes = {
    bonusAndEconomicContributions: SECONDARY_OPTION,
    deductionsAndFiscalBonus: SECONDARY_OPTION,
    fiscalDeclarationAnd730: PRIMARY_COLOR,
    certificatesAndSupportServices: PRIMARY_COLOR,
    financialServices: PRIMARY_COLOR,
    other: PRIMARY_COLOR
};
const SEARCH_CARD_ICON_ID = "search-card-icon";
function CustomIconCard({ type, color }) {
    const iconsBasedOnType = {
        bonusAndEconomicContributions: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HandHoldingDollarCircleSolid, {
            "data-testid": SEARCH_CARD_ICON_ID,
            color: color
        }),
        deductionsAndFiscalBonus: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeDiscountSolid, {
            "data-testid": SEARCH_CARD_ICON_ID,
            color: color
        }),
        fiscalDeclarationAnd730: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InvoiceSolid, {
            "data-testid": SEARCH_CARD_ICON_ID,
            color: color
        }),
        certificatesAndSupportServices: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DocumentListSolid, {
            "data-testid": SEARCH_CARD_ICON_ID,
            color: color
        }),
        financialServices: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CoinsSolid, {
            "data-testid": SEARCH_CARD_ICON_ID,
            color: color
        }),
        other: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalSolid, {
            "data-testid": SEARCH_CARD_ICON_ID,
            color: color
        })
    };
    return iconsBasedOnType[type];
}
function emotion_memoize_esm_memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (void 0 === cache[arg]) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* #__PURE__ */ emotion_memoize_esm_memoize(function(prop) {
    return reactPropsRegex.test(prop) || 111 === prop.charCodeAt(0) && 110 === prop.charCodeAt(1) && prop.charCodeAt(2) < 91;
});
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (void 0 !== registered[className]) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var emotion_utils_browser_esm_registerStyles = function(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if ((false === isStringTag || false === isBrowser) && void 0 === cache.registered[className]) cache.registered[className] = serialized.styles;
};
var emotion_utils_browser_esm_insertStyles = function(cache, serialized, isStringTag) {
    emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (void 0 === cache.inserted[serialized.name]) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (void 0 !== current);
    }
};
function murmur2(str) {
    var h = 0;
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = 0xff & str.charCodeAt(i) | (0xff & str.charCodeAt(++i)) << 8 | (0xff & str.charCodeAt(++i)) << 16 | (0xff & str.charCodeAt(++i)) << 24;
        k = (0xffff & k) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= k >>> 24;
        h = (0xffff & k) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ (0xffff & h) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    }
    switch(len){
        case 3:
            h ^= (0xff & str.charCodeAt(i + 2)) << 16;
        case 2:
            h ^= (0xff & str.charCodeAt(i + 1)) << 8;
        case 1:
            h ^= 0xff & str.charCodeAt(i);
            h = (0xffff & h) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    }
    h ^= h >>> 13;
    h = (0xffff & h) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var emotion_serialize_browser_esm_isCustomProperty = function(property) {
    return 45 === property.charCodeAt(1);
};
var emotion_serialize_browser_esm_isProcessableValue = function(value) {
    return null != value && 'boolean' != typeof value;
};
var processStyleName = /* #__PURE__ */ emotion_memoize_esm_memoize(function(styleName) {
    return emotion_serialize_browser_esm_isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var emotion_serialize_browser_esm_processStyleValue = function(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if ('string' == typeof value) return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if (1 !== unitlessKeys[key] && !emotion_serialize_browser_esm_isCustomProperty(key) && 'number' == typeof value && 0 !== value) return value + 'px';
    return value;
};
if ('production' !== process.env.NODE_ENV) {
    var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = [
        'normal',
        'none',
        'initial',
        'inherit',
        'unset'
    ];
    var oldProcessStyleValue = emotion_serialize_browser_esm_processStyleValue;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g;
    var hyphenatedCache = {};
    emotion_serialize_browser_esm_processStyleValue = function(key, value) {
        if ('content' === key) {
            if ('string' != typeof value || -1 === contentValues.indexOf(value) && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || '"' !== value.charAt(0) && "'" !== value.charAt(0))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
        }
        var processed = oldProcessStyleValue(key, value);
        if ('' !== processed && !emotion_serialize_browser_esm_isCustomProperty(key) && -1 !== key.indexOf('-') && void 0 === hyphenatedCache[key]) {
            hyphenatedCache[key] = true;
            console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function(str, _char) {
                return _char.toUpperCase();
            }) + "?");
        }
        return processed;
    };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (null == interpolation) return '';
    if (void 0 !== interpolation.__emotion_styles) {
        if ('production' !== process.env.NODE_ENV && 'NO_COMPONENT_SELECTOR' === interpolation.toString()) throw new Error(noComponentSelectorMessage);
        return interpolation;
    }
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (1 === interpolation.anim) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (void 0 !== interpolation.styles) {
                var next = interpolation.next;
                if (void 0 !== next) while(void 0 !== next){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                if ('production' !== process.env.NODE_ENV && void 0 !== interpolation.map) styles += interpolation.map;
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (void 0 !== mergedProps) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            if ('production' !== process.env.NODE_ENV) console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
            break;
        case 'string':
            if ('production' !== process.env.NODE_ENV) {
                var matched = [];
                var replaced = interpolation.replace(animationRegex, function(match, p1, p2) {
                    var fakeVarName = "animation" + matched.length;
                    matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
                    return "${" + fakeVarName + "}";
                });
                if (matched.length) console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, [
                    "`" + replaced + "`"
                ]).join('\n') + "\n\nYou should wrap it with `css` like this:\n\ncss`" + replaced + "`");
            }
            break;
    }
    if (null == registered) return interpolation;
    var cached = registered[interpolation];
    return void 0 !== cached ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if ('object' != typeof value) {
            if (null != registered && void 0 !== registered[value]) string += _key + "{" + registered[value] + "}";
            else if (emotion_serialize_browser_esm_isProcessableValue(value)) string += processStyleName(_key) + ":" + emotion_serialize_browser_esm_processStyleValue(_key, value) + ";";
        } else {
            if ('NO_COMPONENT_SELECTOR' === _key && 'production' !== process.env.NODE_ENV) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && 'string' == typeof value[0] && (null == registered || void 0 === registered[value[0]])) {
                for(var _i = 0; _i < value.length; _i++)if (emotion_serialize_browser_esm_isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + emotion_serialize_browser_esm_processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        if ('production' !== process.env.NODE_ENV && 'undefined' === _key) console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if ('production' !== process.env.NODE_ENV) sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
var cursor;
var emotion_serialize_browser_esm_serializeStyles = function(args, registered, mergedProps) {
    if (1 === args.length && 'object' == typeof args[0] && null !== args[0] && void 0 !== args[0].styles) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = void 0;
    var strings = args[0];
    if (null == strings || void 0 === strings.raw) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        if ('production' !== process.env.NODE_ENV && void 0 === strings[0]) console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        styles += strings[0];
    }
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            if ('production' !== process.env.NODE_ENV && void 0 === strings[i]) console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles += strings[i];
        }
    }
    var sourceMap;
    if ('production' !== process.env.NODE_ENV) styles = styles.replace(sourceMapPattern, function(match) {
        sourceMap = match;
        return '';
    });
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match;
    while(null !== (match = labelPattern.exec(styles)))identifierName += '-' + match[1];
    var name = murmur2(styles) + identifierName;
    if ('production' !== process.env.NODE_ENV) return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: cursor,
        toString: function() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
    };
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};
var emotion_use_insertion_effect_with_fallbacks_browser_esm_syncFallback = function(create) {
    return create();
};
var useInsertionEffect = __WEBPACK_EXTERNAL_MODULE_react__["useInsertionEffect"] ? __WEBPACK_EXTERNAL_MODULE_react__["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || emotion_use_insertion_effect_with_fallbacks_browser_esm_syncFallback;
useInsertionEffect || __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect;
var testOmitPropsOnStringTag = isPropValid;
var emotion_styled_base_browser_esm_testOmitPropsOnComponent = function(key) {
    return 'theme' !== key;
};
var emotion_styled_base_browser_esm_getDefaultShouldForwardProp = function(tag) {
    return 'string' == typeof tag && tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : emotion_styled_base_browser_esm_testOmitPropsOnComponent;
};
var emotion_styled_base_browser_esm_composeShouldForwardProps = function(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if ('function' != typeof shouldForwardProp && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var emotion_styled_base_browser_esm_ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var emotion_styled_base_browser_esm_Insertion = function(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
    useInsertionEffectAlwaysWithSyncFallback(function() {
        return emotion_utils_browser_esm_insertStyles(cache, serialized, isStringTag);
    });
    return null;
};
var emotion_styled_base_browser_esm_createStyled = function createStyled(tag, options) {
    if ('production' !== process.env.NODE_ENV) {
        if (void 0 === tag) throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (void 0 !== options) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = emotion_styled_base_browser_esm_composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || emotion_styled_base_browser_esm_getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && void 0 !== tag.__emotion_styles ? tag.__emotion_styles.slice(0) : [];
        if (void 0 !== identifierName) styles.push("label:" + identifierName + ";");
        if (null == args[0] || void 0 === args[0].raw) styles.push.apply(styles, args);
        else {
            if ('production' !== process.env.NODE_ENV && void 0 === args[0][0]) console.error(emotion_styled_base_browser_esm_ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++){
                if ('production' !== process.env.NODE_ENV && void 0 === args[0][i]) console.error(emotion_styled_base_browser_esm_ILLEGAL_ESCAPE_SEQUENCE_ERROR);
                styles.push(args[i], args[0][i]);
            }
        }
        var Styled = (0, __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (null == props.theme) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = __WEBPACK_EXTERNAL_MODULE_react__.useContext(__WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.ThemeContext);
            }
            if ('string' == typeof props.className) className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
            else if (null != props.className) className = props.className + " ";
            var serialized = emotion_serialize_browser_esm_serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (void 0 !== targetClassName) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && void 0 === shouldForwardProp ? emotion_styled_base_browser_esm_getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props)if (!shouldUseAs || 'as' !== _key) {
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createElement(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, null, /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createElement(emotion_styled_base_browser_esm_Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: 'string' == typeof FinalTag
            }), /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createElement(FinalTag, newProps));
        });
        Styled.displayName = void 0 !== identifierName ? identifierName : "Styled(" + ('string' == typeof baseTag ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function() {
                if (void 0 === targetClassName && 'production' !== process.env.NODE_ENV) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, esm_extends_extends({}, options, nextOptions, {
                shouldForwardProp: emotion_styled_base_browser_esm_composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var emotion_styled_browser_esm_tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    "noscript",
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    "script",
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var newStyled = emotion_styled_base_browser_esm_createStyled.bind();
emotion_styled_browser_esm_tags.forEach(function(tagName) {
    newStyled[tagName] = newStyled(tagName);
});
const SearchCardContent = newStyled(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])`
  gap: ${Spacing["500"]};
  display: ${displaying_Displaying.flex};
  align-items: ${alignment_Alignment.center};
`;
const SearchCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ type, isSmall = false, isMobile = false, value, ...rest }, ref) {
    const selectedColor = getMainColor(type);
    const isSmallBasedOnMobile = isMobile || isSmall;
    const typographyVariant = isSmallBasedOnMobile ? "body2" : "body1";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SearchCardContainer, {
        elevation: 0,
        accentColor: selectedColor,
        ref: ref,
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProductCardContent, {
            isMobile: isMobile,
            "data-testid": "search-card-container-content-flexed",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    container: true,
                    justifyContent: alignment_Alignment.spaceBetween,
                    wrap: "nowrap",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SearchCardContent, {
                        "data-testid": "search-card-content",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomIconCard, {
                                type: type,
                                color: selectedColor
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                variant: typographyVariant,
                                children: value
                            })
                        ]
                    })
                }),
                isSmallBasedOnMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {
                        "data-testid": "search-card-angle-right-icon"
                    })
                })
            ]
        })
    });
});
const DEFAULT_ELEVATION = `${Spacing["0"]} ${Spacing["0"]} ${Spacing["1250"]} ${Spacing["0"]} ${WHITE_TRANSPARENT_LIGHT}`;
const NONE_ELEVATION = "none";
const SELECT_MAX_HEIGHT = "13.56rem";
const SELECT_MIN_WIDTH = "11.25rem";
const select_Select = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, error, size, helperText, label, labelId, fullWidth, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__["default"], {
        error: error,
        size: size,
        fullWidth: fullWidth,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputLabel_cf26b488__["default"], {
                id: labelId,
                children: label
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Select_bb5d0ab2__["default"], {
                ref: ref,
                color: PRIMARY_COLOR,
                variant: "outlined",
                error: error,
                label: label,
                labelId: labelId,
                IconComponent: AngleDownSmallOutlined,
                sx: {
                    minWidth: SELECT_MIN_WIDTH,
                    ...rest.sx
                },
                MenuProps: {
                    slotProps: {
                        paper: {
                            sx: {
                                boxShadow: DEFAULT_ELEVATION,
                                maxHeight: SELECT_MAX_HEIGHT
                            }
                        }
                    },
                    ...rest.MenuProps
                },
                ...rest,
                children: children
            }),
            helperText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormHelperText_3b87fa55__["default"], {
                children: helperText
            })
        ]
    });
});
const sidebarRoutes = [
    {
        label: "Profilo",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UserCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UserCircleDuotone, {})
    },
    {
        label: "Bonus",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EuroCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EuroCircleDuotone, {})
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileTextEditOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileTextEditDuotone, {})
    },
    {
        label: "Upgrade",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileWandOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileWandDuotone, {})
    },
    {
        label: "Altro",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MoreHorizontalDuotone, {}),
        disabled: true,
        isSectionDivider: true
    },
    {
        label: "Documenti",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FolderOpenOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FolderOpenDuotone, {})
    },
    {
        label: "Impostazioni",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SettingsOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SettingsDuotone, {})
    },
    {
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxOutlined, {}),
        label: "Scartoffie",
        subpaths: [
            {
                label: "Termini di utilizzo"
            },
            {
                label: "Condizioni Generali di Servizio"
            },
            {
                label: "Privacy Policy"
            },
            {
                label: "Cookies Policy"
            }
        ],
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxDuotone, {})
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutDuotone, {})
    }
];
const adminRoutes = [
    {
        label: "Home",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HomeOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HomeDuotone, {})
    },
    {
        label: "Configurazioni",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SettingsOutlined, {}),
        subpaths: [
            {
                label: "Documenti"
            },
            {
                label: "Avanzate"
            },
            {
                label: "Sconti"
            }
        ],
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SettingsDuotone, {})
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ListOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ListDuotone, {})
    },
    {
        label: "Anagrafica",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UsersGroupAltOutlined, {}),
        subpaths: [
            {
                label: "Utenti"
            },
            {
                label: "Enti Partner"
            }
        ],
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UsersGroupAltDuotone, {})
    },
    {
        label: "Pi\xf9",
        disabled: true
    },
    {
        label: "Guida",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BookOpenTextOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BookOpenTextDuotone, {})
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutDuotone, {})
    }
];
const operatorRoutes = [
    {
        label: "Home",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HomeOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HomeDuotone, {})
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ListOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ListDuotone, {})
    },
    {
        label: "Anagrafica",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UsersGroupAltOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UsersGroupAltDuotone, {})
    },
    {
        label: "Pi\xf9",
        disabled: true
    },
    {
        label: "Guida",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BookOpenTextOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BookOpenTextDuotone, {})
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LogOutDuotone, {})
    }
];
const SIDEBAR_WIDTH = "16.5rem";
function Sidebar({ logo, items, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SidebarContainer, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SidebarLogo, {
                        children: logo
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationList, {
                        disablePadding: true,
                        children: items && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NestedNavigation, {
                            navigationItems: items
                        })
                    })
                ]
            }),
            children
        ]
    });
}
const SidebarContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"])(({ theme })=>({
        height: "100vh",
        overflow: "hidden",
        borderRight: "1px solid",
        scrollbarGutter: "stable",
        backgroundColor: palette_Common.white.main,
        borderRightColor: theme.palette.border.main,
        padding: `${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(10)} ${theme.spacing(3)}`,
        width: SIDEBAR_WIDTH,
        minWidth: SIDEBAR_WIDTH,
        justifyContent: "space-between",
        ":hover": {
            overflowY: "auto"
        }
    }));
const SidebarLogo = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    height: Spacing["3500"]
});
function SnackBarIcon({ variant }) {
    switch(variant){
        case "success":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CheckCircleSolid, {
                "data-testid": "snackbar-success-icon"
            });
        case "error":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TimesCircleSolid, {
                "data-testid": "snackbar-error-icon"
            });
        case "warning":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ExclamationCircleSolid, {
                "data-testid": "snackbar-warning-icon"
            });
        default:
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InfoCircleSolid, {
                "data-testid": "snackbar-info-icon"
            });
    }
}
const SNACKBAR_ELEVATION = "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)";
const SnackBarContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], styledOptions)(({ theme, variant })=>{
    const variantColor = theme.palette[variant ?? "primary"];
    const backgroundColor = variantColor.main;
    const elementsColor = variantColor.contrastText;
    return {
        maxWidth: "fit-content",
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        gap: Spacing["500"],
        alignSelf: alignment_Alignment.stretch,
        padding: `0.375rem ${Spacing["1000"]}`,
        backgroundColor,
        color: elementsColor,
        borderRadius: Spacing["250"],
        boxShadow: SNACKBAR_ELEVATION
    };
});
function SnackbarSlide(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Slide_61aa8233__["default"], {
        ...props,
        direction: alignment_Alignment.left,
        in: true,
        mountOnEnter: true,
        unmountOnExit: true
    });
}
const MemoizedSnackBarIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(SnackBarIcon, function(prevProps, nextProps) {
    return prevProps.variant === nextProps.variant;
});
function SnackBar({ variant, message, minWidth, maxWidth, actionButtonText, onCloseButtonClick, onActionButtonClick, ...rest }) {
    const actionButton = onActionButtonClick && actionButtonText ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
        color: "white",
        variant: "text",
        onClick: onActionButtonClick,
        "data-testid": "snackbar-action-button",
        children: actionButtonText
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    const closeButton = onCloseButtonClick ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
        color: "inherit",
        "data-testid": "snackbar-icon-button",
        size: "medium",
        onClick: onCloseButtonClick,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TimesSolid, {})
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SnackbarSlide, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SnackBarContainer, {
            variant: variant,
            ...rest,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MemoizedSnackBarIcon, {
                    variant: variant
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                    minWidth: minWidth ?? Spacing["18750"],
                    maxWidth: maxWidth ?? Spacing["18750"],
                    "data-testid": "snackbar-container-message",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                        variant: "body1",
                        color: palette_Success.contrastText,
                        children: message
                    })
                }),
                actionButton,
                closeButton
            ]
        })
    });
}
const switch_Switch = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Switch_72bb925c__["default"], {
        ...rest,
        ref: ref
    });
});
function chainPropTypes(propType1, propType2) {
    if ('production' === process.env.NODE_ENV) return ()=>null;
    return function(...args) {
        return propType1(...args) || propType2(...args);
    };
}
function getDataGridUtilityClass(slot) {
    return generateUtilityClass('MuiDataGrid', slot);
}
const gridClasses_gridClasses = generateUtilityClasses('MuiDataGrid', [
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'autoHeight',
    'autosizing',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--withRenderer',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--selectionMode',
    'cell',
    'cellContent',
    'cellCheckbox',
    'cellSkeleton',
    'checkboxInput',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderDropZone',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnGroupHeader',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeader--showColumnBorder',
    'columnHeaders',
    'columnHeadersInner',
    'columnHeadersInner--scrollable',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsPanel',
    'columnsPanelRow',
    'detailPanel',
    'detailPanels',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'row',
    'row--editable',
    'row--editing',
    'row--lastVisible',
    'row--dragging',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea',
    'selectedRowCount',
    'sortIcon',
    'toolbarContainer',
    'toolbarFilterList',
    'virtualScroller',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'pinnedColumns',
    'pinnedColumns--left',
    'pinnedColumns--right',
    'pinnedColumnHeaders',
    'pinnedColumnHeaders--left',
    'pinnedColumnHeaders--right',
    'withBorderColor',
    'cell--withRightBorder',
    'columnHeader--withRightBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pinnedRowsRenderZone'
]);
function getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if ('light' === theme.palette.mode) return (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.lighten)((0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.divider, 1), 0.88);
    return (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.darken)((0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.divider, 1), 0.68);
}
const columnHeadersStyles = {
    [`.${gridClasses_gridClasses.columnSeparator}, .${gridClasses_gridClasses["columnSeparator--resizing"]}`]: {
        visibility: 'visible',
        width: 'auto'
    }
};
const columnHeaderStyles = {
    [`& .${gridClasses_gridClasses.iconButtonContainer}`]: {
        visibility: 'visible',
        width: 'auto'
    },
    [`& .${gridClasses_gridClasses.menuIcon}`]: {
        width: 'auto',
        visibility: 'visible'
    }
};
const GridRootStyles = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            {
                [`&.${gridClasses_gridClasses.autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${gridClasses_gridClasses.aggregationColumnHeader}`]: styles.aggregationColumnHeader
            },
            {
                [`&.${gridClasses_gridClasses["aggregationColumnHeader--alignLeft"]}`]: styles['aggregationColumnHeader--alignLeft']
            },
            {
                [`&.${gridClasses_gridClasses["aggregationColumnHeader--alignCenter"]}`]: styles['aggregationColumnHeader--alignCenter']
            },
            {
                [`&.${gridClasses_gridClasses["aggregationColumnHeader--alignRight"]}`]: styles['aggregationColumnHeader--alignRight']
            },
            {
                [`&.${gridClasses_gridClasses.aggregationColumnHeaderLabel}`]: styles.aggregationColumnHeaderLabel
            },
            {
                [`&.${gridClasses_gridClasses["root--disableUserSelection"]} .${gridClasses_gridClasses.cell}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${gridClasses_gridClasses.autosizing}`]: styles.autosizing
            },
            {
                [`& .${gridClasses_gridClasses.editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${gridClasses_gridClasses["cell--editing"]}`]: styles['cell--editing']
            },
            {
                [`& .${gridClasses_gridClasses["cell--textCenter"]}`]: styles['cell--textCenter']
            },
            {
                [`& .${gridClasses_gridClasses["cell--textLeft"]}`]: styles['cell--textLeft']
            },
            {
                [`& .${gridClasses_gridClasses["cell--textRight"]}`]: styles['cell--textRight']
            },
            {
                [`& .${gridClasses_gridClasses["cell--withRenderer"]}`]: styles['cell--withRenderer']
            },
            {
                [`& .${gridClasses_gridClasses.cell}`]: styles.cell
            },
            {
                [`& .${gridClasses_gridClasses["cell--rangeTop"]}`]: styles['cell--rangeTop']
            },
            {
                [`& .${gridClasses_gridClasses["cell--rangeBottom"]}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${gridClasses_gridClasses["cell--rangeLeft"]}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${gridClasses_gridClasses["cell--rangeRight"]}`]: styles['cell--rangeRight']
            },
            {
                [`& .${gridClasses_gridClasses["cell--withRightBorder"]}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${gridClasses_gridClasses.cellContent}`]: styles.cellContent
            },
            {
                [`& .${gridClasses_gridClasses.cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${gridClasses_gridClasses.cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${gridClasses_gridClasses.checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--alignCenter"]}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--alignLeft"]}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--alignRight"]}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--dragging"]}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--moving"]}`]: styles['columnHeader--moving']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--numeric"]}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--sortable"]}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--sorted"]}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${gridClasses_gridClasses["columnHeader--withRightBorder"]}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${gridClasses_gridClasses.columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${gridClasses_gridClasses.headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${gridClasses_gridClasses.columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${gridClasses_gridClasses.columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${gridClasses_gridClasses.columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${gridClasses_gridClasses["columnSeparator--resizable"]}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${gridClasses_gridClasses["columnSeparator--resizing"]}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${gridClasses_gridClasses.columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${gridClasses_gridClasses.filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${gridClasses_gridClasses.iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${gridClasses_gridClasses.menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${gridClasses_gridClasses.menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${gridClasses_gridClasses.menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${gridClasses_gridClasses.menuList}`]: styles.menuList
            },
            {
                [`& .${gridClasses_gridClasses["row--editable"]}`]: styles['row--editable']
            },
            {
                [`& .${gridClasses_gridClasses["row--editing"]}`]: styles['row--editing']
            },
            {
                [`& .${gridClasses_gridClasses["row--dragging"]}`]: styles['row--dragging']
            },
            {
                [`& .${gridClasses_gridClasses.row}`]: styles.row
            },
            {
                [`& .${gridClasses_gridClasses.rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${gridClasses_gridClasses.rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${gridClasses_gridClasses["rowReorderCell--draggable"]}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${gridClasses_gridClasses.sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${gridClasses_gridClasses.withBorderColor}`]: styles.withBorderColor
            },
            {
                [`& .${gridClasses_gridClasses.treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${gridClasses_gridClasses.treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${gridClasses_gridClasses.detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${gridClasses_gridClasses["detailPanelToggleCell--expanded"]}`]: styles['detailPanelToggleCell--expanded']
            },
            styles.root
        ]
})(({ theme })=>{
    const borderColor = getBorderColor(theme);
    const radius = theme.shape.borderRadius;
    const gridStyle = esm_extends_extends({
        '--unstable_DataGrid-radius': 'number' == typeof radius ? `${radius}px` : radius,
        '--unstable_DataGrid-headWeight': theme.typography.fontWeightMedium,
        '--unstable_DataGrid-overlayBackground': theme.vars ? `rgba(${theme.vars.palette.background.defaultChannel} / ${theme.vars.palette.action.disabledOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.background.default, theme.palette.action.disabledOpacity),
        '--DataGrid-cellOffsetMultiplier': 2,
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body2, {
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        minHeight: 0,
        flexDirection: 'column',
        overflowAnchor: 'none',
        [`&.${gridClasses_gridClasses.autoHeight}`]: {
            height: 'auto',
            [`& .${gridClasses_gridClasses["row--lastVisible"]} .${gridClasses_gridClasses.cell}`]: {
                borderBottomColor: 'transparent'
            }
        },
        [`&.${gridClasses_gridClasses.autosizing}`]: {
            [`& .${gridClasses_gridClasses.columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            [`& .${gridClasses_gridClasses.cell} > *`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap'
            },
            [`& .${gridClasses_gridClasses.groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${gridClasses_gridClasses.treeDataGroupingCell}`]: {
                width: 'unset'
            }
        },
        [`& .${gridClasses_gridClasses["virtualScrollerContent--overflowed"]} .${gridClasses_gridClasses["row--lastVisible"]} .${gridClasses_gridClasses.cell}`]: {
            borderBottomColor: 'transparent'
        },
        [`& .${gridClasses_gridClasses.columnHeader}, & .${gridClasses_gridClasses.cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            lineHeight: null,
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${gridClasses_gridClasses.columnHeader}:focus-within, & .${gridClasses_gridClasses.cell}:focus-within`]: {
            outline: `solid ${theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.5)` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, 0.5)} 1px`,
            outlineWidth: 1,
            outlineOffset: -1
        },
        [`& .${gridClasses_gridClasses.columnHeader}:focus, & .${gridClasses_gridClasses.cell}:focus`]: {
            outline: `solid ${theme.palette.primary.main} 1px`
        },
        [`& .${gridClasses_gridClasses.columnHeaderCheckbox}, & .${gridClasses_gridClasses.cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${gridClasses_gridClasses.columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${gridClasses_gridClasses["columnHeader--sorted"]} .${gridClasses_gridClasses.iconButtonContainer}, & .${gridClasses_gridClasses["columnHeader--filtered"]} .${gridClasses_gridClasses.iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${gridClasses_gridClasses.columnHeader}:not(.${gridClasses_gridClasses["columnHeader--sorted"]}) .${gridClasses_gridClasses.sortIcon}`]: {
            opacity: 0,
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            })
        },
        [`& .${gridClasses_gridClasses.columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            position: 'relative'
        },
        [`& .${gridClasses_gridClasses.columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${gridClasses_gridClasses["columnHeader--filledGroup"]} .${gridClasses_gridClasses.columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${gridClasses_gridClasses["columnHeader--filledGroup"]}.${gridClasses_gridClasses["columnHeader--showColumnBorder"]} .${gridClasses_gridClasses.columnHeaderTitleContainer}`]: {
            borderBottom: "none"
        },
        [`& .${gridClasses_gridClasses["columnHeader--filledGroup"]}.${gridClasses_gridClasses["columnHeader--showColumnBorder"]}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${gridClasses_gridClasses.headerFilterRow}`]: {
            borderTop: `1px solid ${borderColor}`
        },
        [`& .${gridClasses_gridClasses.sortIcon}, & .${gridClasses_gridClasses.filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${gridClasses_gridClasses["columnHeader--sortable"]}`]: {
            cursor: 'pointer'
        },
        [`& .${gridClasses_gridClasses["columnHeader--alignCenter"]} .${gridClasses_gridClasses.columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${gridClasses_gridClasses["columnHeader--alignRight"]} .${gridClasses_gridClasses.columnHeaderDraggableContainer}, & .${gridClasses_gridClasses["columnHeader--alignRight"]} .${gridClasses_gridClasses.columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${gridClasses_gridClasses["columnHeader--alignCenter"]} .${gridClasses_gridClasses.menuIcon}, & .${gridClasses_gridClasses["columnHeader--alignRight"]} .${gridClasses_gridClasses.menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -6
        },
        [`& .${gridClasses_gridClasses["columnHeader--alignRight"]} .${gridClasses_gridClasses.menuIcon}, & .${gridClasses_gridClasses["columnHeader--alignRight"]} .${gridClasses_gridClasses.menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -10
        },
        [`& .${gridClasses_gridClasses["columnHeader--moving"]}`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`& .${gridClasses_gridClasses.columnSeparator}`]: {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: borderColor
        },
        '@media (hover: hover)': {
            [`& .${gridClasses_gridClasses.columnHeaders}:hover`]: columnHeadersStyles,
            [`& .${gridClasses_gridClasses.columnHeader}:hover`]: columnHeaderStyles,
            [`& .${gridClasses_gridClasses.columnHeader}:not(.${gridClasses_gridClasses["columnHeader--sorted"]}):hover .${gridClasses_gridClasses.sortIcon}`]: {
                opacity: 0.5
            }
        },
        '@media (hover: none)': {
            [`& .${gridClasses_gridClasses.columnHeaders}`]: columnHeadersStyles,
            [`& .${gridClasses_gridClasses.columnHeader}`]: columnHeaderStyles
        },
        [`& .${gridClasses_gridClasses["columnSeparator--sideLeft"]}`]: {
            left: -12
        },
        [`& .${gridClasses_gridClasses["columnSeparator--sideRight"]}`]: {
            right: -12
        },
        [`& .${gridClasses_gridClasses["columnSeparator--resizable"]}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            '&:hover': {
                color: (theme.vars || theme).palette.text.primary,
                '@media (hover: none)': {
                    color: borderColor
                }
            },
            [`&.${gridClasses_gridClasses["columnSeparator--resizing"]}`]: {
                color: (theme.vars || theme).palette.text.primary
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${gridClasses_gridClasses.iconSeparator}`]: {
            color: 'inherit'
        },
        [`& .${gridClasses_gridClasses.menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -10,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${gridClasses_gridClasses.menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${gridClasses_gridClasses.row}`]: {
            display: 'flex',
            width: 'fit-content',
            breakInside: 'avoid',
            '&:hover, &.Mui-hovered': {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&.Mui-selected': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(
                ${theme.vars.palette.action.selectedOpacity} + 
                ${theme.vars.palette.action.hoverOpacity}
              ))` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`& .${gridClasses_gridClasses.cell}`]: {
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid',
            '&.Mui-selected': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity + theme.palette.action.hoverOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`&.${gridClasses_gridClasses["root--disableUserSelection"]} .${gridClasses_gridClasses.cell}`]: {
            userSelect: 'none'
        },
        [`& .${gridClasses_gridClasses.row}:not(.${gridClasses_gridClasses["row--dynamicHeight"]}) > .${gridClasses_gridClasses.cell}`]: {
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        },
        [`& .${gridClasses_gridClasses.cellContent}`]: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        [`& .${gridClasses_gridClasses.cell}.${gridClasses_gridClasses["cell--selectionMode"]}`]: {
            cursor: 'default'
        },
        [`& .${gridClasses_gridClasses.cell}.${gridClasses_gridClasses["cell--editing"]}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: theme.shadows[2],
            backgroundColor: (theme.vars || theme).palette.background.paper,
            '&:focus-within': {
                outline: `solid ${(theme.vars || theme).palette.primary.main} 1px`,
                outlineOffset: '-1px'
            }
        },
        [`& .${gridClasses_gridClasses["row--editing"]}`]: {
            boxShadow: theme.shadows[2]
        },
        [`& .${gridClasses_gridClasses["row--editing"]} .${gridClasses_gridClasses.cell}`]: {
            boxShadow: theme.shadows[0],
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`& .${gridClasses_gridClasses.editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${gridClasses_gridClasses.booleanCell}[data-value="true"]`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`& .${gridClasses_gridClasses.booleanCell}[data-value="false"]`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`& .${gridClasses_gridClasses.actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: theme.spacing(1)
        },
        [`& .${gridClasses_gridClasses.rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& .${gridClasses_gridClasses["rowReorderCell--draggable"]}`]: {
            cursor: 'move',
            opacity: 1
        },
        [`& .${gridClasses_gridClasses.rowReorderCellContainer}`]: {
            padding: 0,
            alignItems: 'stretch'
        },
        [`.${gridClasses_gridClasses.withBorderColor}`]: {
            borderColor
        },
        [`& .${gridClasses_gridClasses["cell--withRightBorder"]}`]: {
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${gridClasses_gridClasses["columnHeader--withRightBorder"]}`]: {
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${gridClasses_gridClasses["cell--textLeft"]}`]: {
            justifyContent: 'flex-start'
        },
        [`& .${gridClasses_gridClasses["cell--textRight"]}`]: {
            justifyContent: 'flex-end'
        },
        [`& .${gridClasses_gridClasses["cell--textCenter"]}`]: {
            justifyContent: 'center'
        },
        [`& .${gridClasses_gridClasses.columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${gridClasses_gridClasses.rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${gridClasses_gridClasses["columnHeader--dragging"]}, & .${gridClasses_gridClasses["row--dragging"]}`]: {
            background: (theme.vars || theme).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& .${gridClasses_gridClasses["row--dragging"]}`]: {
            background: (theme.vars || theme).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            [`& .${gridClasses_gridClasses.rowReorderCellPlaceholder}`]: {
                display: 'flex'
            }
        },
        [`& .${gridClasses_gridClasses.treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${gridClasses_gridClasses.treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: theme.spacing(2)
        },
        [`& .${gridClasses_gridClasses.groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${gridClasses_gridClasses.groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: theme.spacing(2)
        }
    });
    return gridStyle;
});
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}
const EMPTY = [];
function useOnMount(fn) {
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(fn, EMPTY);
}
const warning_buildWarning = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if ('error' === gravity) console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};
const is = Object.is;
function fastObjectShallowCompare(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    for(const key in a){
        aLength += 1;
        if (!is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    for(const _ in b)bLength += 1;
    return aLength === bLength;
}
const stateNotInitializedWarning = warning_buildWarning([
    'MUI: `useGridSelector` has been called before the initialization of the state.',
    'This hook can only be used inside the context of the grid.'
]);
function isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
function applySelector(apiRef, selector) {
    if (isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
}
const defaultCompare = Object.is;
const objectShallowCompare = fastObjectShallowCompare;
const createRefs = ()=>({
        state: null,
        equals: null,
        selector: null
    });
const useGridSelector = (apiRef, selector, equals = defaultCompare)=>{
    if ('production' !== process.env.NODE_ENV) {
        if (!apiRef.current.state) stateNotInitializedWarning();
    }
    const refs = useLazyRef(createRefs);
    const didInit = null !== refs.current.selector;
    const [state, setState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(didInit ? null : applySelector(apiRef, selector));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    useOnMount(()=>apiRef.current.store.subscribe(()=>{
            const newState = applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        }));
    return state;
};
const GridPrivateApiContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext(void 0);
if ('production' !== process.env.NODE_ENV) GridPrivateApiContext.displayName = 'GridPrivateApiContext';
function useGridPrivateApiContext() {
    const privateApiRef = __WEBPACK_EXTERNAL_MODULE_react__.useContext(GridPrivateApiContext);
    if (void 0 === privateApiRef) throw new Error("MUI: Could not find the data grid private context.\nIt looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.\nThis can also happen if you are bundling multiple versions of the data grid.");
    return privateApiRef;
}
const GridRootPropsContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext(void 0);
if ('production' !== process.env.NODE_ENV) GridRootPropsContext.displayName = 'GridRootPropsContext';
const useGridRootProps = ()=>{
    const contextValue = __WEBPACK_EXTERNAL_MODULE_react__.useContext(GridRootPropsContext);
    if (!contextValue) throw new Error('MUI: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};
var NOT_FOUND = 'NOT_FOUND';
function createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultMemoize_defaultEqualityCheck = function(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function(prev, next) {
        if (null === prev || null === next || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++)if (!equalityCheck(prev[i], next[i])) return false;
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = 'object' == typeof equalityCheckOrOptions ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = void 0 === _providedOptions$equa ? defaultMemoize_defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = void 0 === _providedOptions$maxS ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = 1 === maxSize ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return 'function' == typeof dep;
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return 'function' == typeof dep ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult;
        var directlyPassedOptions = {
            memoizeOptions: void 0
        };
        var resultFunc = funcs.pop();
        if ('object' == typeof resultFunc) {
            directlyPassedOptions = resultFunc;
            resultFunc = funcs.pop();
        }
        if ('function' != typeof resultFunc) throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = void 0 === _directlyPassedOption2 ? memoizeOptionsFromArgs : _directlyPassedOption2;
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function() {
                _recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions));
        var selector = memoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)params.push(dependencies[i].apply(null, arguments));
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function() {
                return _lastResult;
            },
            recomputations: function() {
                return _recomputations;
            },
            resetRecomputations: function() {
                return _recomputations = 0;
            }
        });
        return selector;
    };
    return createSelector;
}
var es_createSelector = /* #__PURE__ */ createSelectorCreator(defaultMemoize);
const cacheContainer = {
    cache: new WeakMap()
};
const missingInstanceIdWarning = warning_buildWarning([
    'MUI: A selector was called without passing the instance ID, which may impact the performance of the grid.',
    'To fix, call it with `apiRef`, e.g. `mySelector(apiRef)`, or pass the instance ID explicitly, e.g. `mySelector(state, apiRef.current.instanceId)`.'
]);
function checkIsAPIRef(value) {
    return 'current' in value && 'instanceId' in value.current;
}
const DEFAULT_INSTANCE_ID = {
    id: 'default'
};
const createSelector_createSelector = (a, b, c, d, e, f, ...rest)=>{
    if (rest.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    if (a && b && c && d && e && f) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = checkIsAPIRef(stateOrApiRef);
        const instanceId = null != instanceIdParam ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        const ve = e(state, instanceId);
        return f(va, vb, vc, vd, ve);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = checkIsAPIRef(stateOrApiRef);
        const instanceId = null != instanceIdParam ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        return e(va, vb, vc, vd);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = checkIsAPIRef(stateOrApiRef);
        const instanceId = null != instanceIdParam ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        return d(va, vb, vc);
    };
    else if (a && b && c) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = checkIsAPIRef(stateOrApiRef);
        const instanceId = null != instanceIdParam ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        return c(va, vb);
    };
    else if (a && b) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = checkIsAPIRef(stateOrApiRef);
        const instanceId = null != instanceIdParam ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        return b(va);
    };
    else throw new Error('Missing arguments');
    selector.acceptsApiRef = true;
    return selector;
};
const createSelectorMemoized = (...args)=>{
    const selector = (...selectorArgs)=>{
        var _cache$get, _cache$get3;
        const [stateOrApiRef, instanceId] = selectorArgs;
        const isAPIRef = checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : null != instanceId ? instanceId : DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        if ('production' !== process.env.NODE_ENV) {
            if ('default' === cacheKey.id) missingInstanceIdWarning();
        }
        const { cache } = cacheContainer;
        if (cache.get(cacheKey) && null != (_cache$get = cache.get(cacheKey)) && _cache$get.get(args)) {
            var _cache$get2;
            return null == (_cache$get2 = cache.get(cacheKey)) ? void 0 : _cache$get2.get(args)(state, cacheKey);
        }
        const newSelector = es_createSelector(...args);
        if (!cache.get(cacheKey)) cache.set(cacheKey, new Map());
        null == (_cache$get3 = cache.get(cacheKey)) || _cache$get3.set(args, newSelector);
        return newSelector(state, cacheKey);
    };
    selector.acceptsApiRef = true;
    return selector;
};
const gridDensitySelector = (state)=>state.density;
const gridDensityValueSelector = createSelector_createSelector(gridDensitySelector, (density)=>density.value);
const gridDensityFactorSelector = createSelector_createSelector(gridDensitySelector, (density)=>density.factor);
const gridColumnsStateSelector = (state)=>state.columns;
const gridColumnFieldsSelector = createSelector_createSelector(gridColumnsStateSelector, (columnsState)=>columnsState.orderedFields);
const gridColumnLookupSelector = createSelector_createSelector(gridColumnsStateSelector, (columnsState)=>columnsState.lookup);
const gridColumnDefinitionsSelector = createSelectorMemoized(gridColumnFieldsSelector, gridColumnLookupSelector, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const gridColumnVisibilityModelSelector = createSelector_createSelector(gridColumnsStateSelector, (columnsState)=>columnsState.columnVisibilityModel);
const gridVisibleColumnDefinitionsSelector = createSelectorMemoized(gridColumnDefinitionsSelector, gridColumnVisibilityModelSelector, (columns, columnVisibilityModel)=>columns.filter((column)=>false !== columnVisibilityModel[column.field]));
const gridVisibleColumnFieldsSelector = createSelectorMemoized(gridVisibleColumnDefinitionsSelector, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const gridColumnPositionsSelector = createSelectorMemoized(gridVisibleColumnDefinitionsSelector, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const gridColumnsTotalWidthSelector = createSelector_createSelector(gridVisibleColumnDefinitionsSelector, gridColumnPositionsSelector, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (0 === colCount) return 0;
    return positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth;
});
const gridFilterableColumnDefinitionsSelector = createSelectorMemoized(gridColumnDefinitionsSelector, (columns)=>columns.filter((col)=>col.filterable));
const gridFilterableColumnLookupSelector = createSelectorMemoized(gridColumnDefinitionsSelector, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
const gridColumnGroupingSelector = (state)=>state.columnGrouping;
const gridColumnGroupsUnwrappedModelSelector = createSelectorMemoized(gridColumnGroupingSelector, (columnGrouping)=>{
    var _columnGrouping$unwra;
    return null != (_columnGrouping$unwra = null == columnGrouping ? void 0 : columnGrouping.unwrappedGroupingModel) ? _columnGrouping$unwra : {};
});
const gridColumnGroupsLookupSelector = createSelectorMemoized(gridColumnGroupingSelector, (columnGrouping)=>{
    var _columnGrouping$looku;
    return null != (_columnGrouping$looku = null == columnGrouping ? void 0 : columnGrouping.lookup) ? _columnGrouping$looku : {};
});
const gridColumnGroupsHeaderStructureSelector = createSelectorMemoized(gridColumnGroupingSelector, (columnGrouping)=>{
    var _columnGrouping$heade;
    return null != (_columnGrouping$heade = null == columnGrouping ? void 0 : columnGrouping.headerStructure) ? _columnGrouping$heade : [];
});
const gridColumnGroupsHeaderMaxDepthSelector = createSelector_createSelector(gridColumnGroupingSelector, (columnGrouping)=>{
    var _columnGrouping$maxDe;
    return null != (_columnGrouping$maxDe = null == columnGrouping ? void 0 : columnGrouping.maxDepth) ? _columnGrouping$maxDe : 0;
});
const gridRowsStateSelector = (state)=>state.rows;
const gridRowCountSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.totalRowCount);
const gridRowsLoadingSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.loading);
const gridTopLevelRowCountSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const gridRowsLookupSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
const gridRowsDataRowIdToIdLookupSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.dataRowIdToIdLookup);
const gridRowTreeSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.tree);
const gridRowGroupingNameSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.groupingName);
const gridRowTreeDepthsSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.treeDepths);
const gridRowMaximumTreeDepthSelector = createSelectorMemoized(gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (0 === entries.length) return 1;
    return entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] + 1;
});
const gridDataRowIdsSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>rows.dataRowIds);
const gridAdditionalRowGroupsSelector = createSelector_createSelector(gridRowsStateSelector, (rows)=>null == rows ? void 0 : rows.additionalRowGroups);
const gridPinnedRowsSelector = createSelectorMemoized(gridAdditionalRowGroupsSelector, (additionalRowGroups)=>{
    var _rawPinnedRows$bottom, _rawPinnedRows$top;
    const rawPinnedRows = null == additionalRowGroups ? void 0 : additionalRowGroups.pinnedRows;
    return {
        bottom: null == rawPinnedRows || null == (_rawPinnedRows$bottom = rawPinnedRows.bottom) ? void 0 : _rawPinnedRows$bottom.map((rowEntry)=>{
            var _rowEntry$model;
            return {
                id: rowEntry.id,
                model: null != (_rowEntry$model = rowEntry.model) ? _rowEntry$model : {}
            };
        }),
        top: null == rawPinnedRows || null == (_rawPinnedRows$top = rawPinnedRows.top) ? void 0 : _rawPinnedRows$top.map((rowEntry)=>{
            var _rowEntry$model2;
            return {
                id: rowEntry.id,
                model: null != (_rowEntry$model2 = rowEntry.model) ? _rowEntry$model2 : {}
            };
        })
    };
});
const gridPinnedRowsCountSelector = createSelector_createSelector(gridPinnedRowsSelector, (pinnedRows)=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    return ((null == pinnedRows || null == (_pinnedRows$top = pinnedRows.top) ? void 0 : _pinnedRows$top.length) || 0) + ((null == pinnedRows || null == (_pinnedRows$bottom = pinnedRows.bottom) ? void 0 : _pinnedRows$bottom.length) || 0);
});
const useGridAriaAttributes = ()=>{
    var _rootProps$experiment;
    const apiRef = useGridPrivateApiContext();
    const rootProps = useGridRootProps();
    const visibleColumns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
    const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
    const headerGroupingMaxDepth = useGridSelector(apiRef, gridColumnGroupsHeaderMaxDepthSelector);
    const pinnedRowsCount = useGridSelector(apiRef, gridPinnedRowsCountSelector);
    let role = 'grid';
    if (null != (_rootProps$experiment = rootProps.experimentalFeatures) && _rootProps$experiment.ariaV7 && rootProps.treeData) role = 'treegrid';
    return {
        role,
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + totalRowCount,
        'aria-multiselectable': !rootProps.disableMultipleRowSelection
    };
};
const GridRoot_excluded = [
    "children",
    "className"
];
const GridRoot_useUtilityClasses = (ownerState)=>{
    const { autoHeight, density, classes } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${capitalize(density)}`,
            'withBorderColor'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridRoot_GridRoot = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$experiment;
    const rootProps = useGridRootProps();
    const { children, className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridRoot_excluded);
    const apiRef = useGridPrivateApiContext();
    const densityValue = useGridSelector(apiRef, gridDensityValueSelector);
    const rootContainerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(rootContainerRef, ref);
    const getAriaAttributes = null != (_rootProps$experiment = rootProps.experimentalFeatures) && _rootProps$experiment.ariaV7 ? null : useGridAriaAttributes;
    const ariaAttributes = 'function' == typeof getAriaAttributes ? getAriaAttributes() : null;
    const ownerState = esm_extends_extends({}, rootProps, {
        density: densityValue
    });
    const classes = GridRoot_useUtilityClasses(ownerState);
    apiRef.current.register('public', {
        rootElementRef: rootContainerRef
    });
    const [mountedState, setMountedState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    useEnhancedEffect(()=>{
        setMountedState(true);
    }, []);
    if (!mountedState) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridRootStyles, esm_extends_extends({
        ref: handleRef,
        className: dist_clsx(className, classes.root),
        ownerState: ownerState
    }, ariaAttributes, other, {
        children: children
    }));
});
"production" !== process.env.NODE_ENV && (GridRoot_GridRoot.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
function GridHeader() {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const rootProps = useGridRootProps();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.preferencesPanel, esm_extends_extends({}, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.preferencesPanel)),
            rootProps.slots.toolbar && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.toolbar, esm_extends_extends({}, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.toolbar))
        ]
    });
}
const GridMainContainer_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'main'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridMainContainerRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>styles.main
})(()=>({
        position: 'relative',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    }));
const GridMainContainer = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    var _rootProps$experiment;
    const rootProps = useGridRootProps();
    const classes = GridMainContainer_useUtilityClasses(rootProps);
    const getAriaAttributes = null != (_rootProps$experiment = rootProps.experimentalFeatures) && _rootProps$experiment.ariaV7 ? useGridAriaAttributes : null;
    const ariaAttributes = 'function' == typeof getAriaAttributes ? getAriaAttributes() : null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridMainContainerRoot, esm_extends_extends({
        ref: ref,
        className: classes.root,
        ownerState: rootProps
    }, ariaAttributes, {
        children: props.children
    }));
});
const gridSortingStateSelector = (state)=>state.sorting;
const gridSortedRowIdsSelector = createSelector_createSelector(gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const gridSortedRowEntriesSelector = createSelectorMemoized(gridSortedRowIdsSelector, gridRowsLookupSelector, (sortedIds, idRowsLookup)=>sortedIds.map((id)=>{
        var _idRowsLookup$id;
        return {
            id,
            model: null != (_idRowsLookup$id = idRowsLookup[id]) ? _idRowsLookup$id : {}
        };
    }));
const gridSortModelSelector = createSelector_createSelector(gridSortingStateSelector, (sorting)=>sorting.sortModel);
const gridSortColumnLookupSelector = createSelectorMemoized(gridSortModelSelector, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : void 0
        };
        return res;
    }, {});
    return result;
});
const gridFilterStateSelector = (state)=>state.filter;
const gridFilterModelSelector = createSelector_createSelector(gridFilterStateSelector, (filterState)=>filterState.filterModel);
createSelector_createSelector(gridFilterModelSelector, (filterModel)=>filterModel.quickFilterValues);
const gridVisibleRowsLookupSelector = (state)=>state.visibleRowsLookup;
const gridFilteredRowsLookupSelector = createSelector_createSelector(gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
createSelector_createSelector(gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const gridExpandedSortedRowEntriesSelector = createSelectorMemoized(gridVisibleRowsLookupSelector, gridSortedRowEntriesSelector, (visibleRowsLookup, sortedRows)=>sortedRows.filter((row)=>false !== visibleRowsLookup[row.id]));
const gridExpandedSortedRowIdsSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const gridFilteredSortedRowEntriesSelector = createSelectorMemoized(gridFilteredRowsLookupSelector, gridSortedRowEntriesSelector, (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>false !== filteredRowsLookup[row.id]));
const gridFilteredSortedRowIdsSelector = createSelectorMemoized(gridFilteredSortedRowEntriesSelector, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const gridFilteredSortedTopLevelRowEntriesSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, gridRowTreeSelector, gridRowMaximumTreeDepthSelector, (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>{
        var _rowTree$row$id;
        return (null == (_rowTree$row$id = rowTree[row.id]) ? void 0 : _rowTree$row$id.depth) === 0;
    });
});
const gridExpandedRowCountSelector = createSelector_createSelector(gridExpandedSortedRowEntriesSelector, (visibleSortedRows)=>visibleSortedRows.length);
const gridFilteredTopLevelRowCountSelector = createSelector_createSelector(gridFilteredSortedTopLevelRowEntriesSelector, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const gridFilterActiveItemsSelector = createSelectorMemoized(gridFilterModelSelector, gridColumnLookupSelector, (filterModel, columnLookup)=>{
    var _filterModel$items;
    return null == (_filterModel$items = filterModel.items) ? void 0 : _filterModel$items.filter((item)=>{
        var _column$filterOperato, _item$value;
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!(null != column && column.filterOperators) || (null == column || null == (_column$filterOperato = column.filterOperators) ? void 0 : _column$filterOperato.length) === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || null != item.value && (null == (_item$value = item.value) ? void 0 : _item$value.toString()) !== '';
    });
});
const gridFilterActiveItemsLookupSelector = createSelectorMemoized(gridFilterActiveItemsSelector, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (res[filterItem.field]) res[filterItem.field].push(filterItem);
        else res[filterItem.field] = [
            filterItem
        ];
        return res;
    }, {});
    return result;
});
const gridFocusStateSelector = (state)=>state.focus;
const gridFocusCellSelector = createSelector_createSelector(gridFocusStateSelector, (focusState)=>focusState.cell);
const gridFocusColumnHeaderSelector = createSelector_createSelector(gridFocusStateSelector, (focusState)=>focusState.columnHeader);
createSelector_createSelector(gridFocusStateSelector, (focusState)=>focusState.columnHeaderFilter);
const unstable_gridFocusColumnGroupHeaderSelector = createSelector_createSelector(gridFocusStateSelector, (focusState)=>focusState.columnGroupHeader);
const gridTabIndexStateSelector = (state)=>state.tabIndex;
const gridTabIndexCellSelector = createSelector_createSelector(gridTabIndexStateSelector, (state)=>state.cell);
const gridTabIndexColumnHeaderSelector = createSelector_createSelector(gridTabIndexStateSelector, (state)=>state.columnHeader);
createSelector_createSelector(gridTabIndexStateSelector, (state)=>state.columnHeaderFilter);
const unstable_gridTabIndexColumnGroupHeaderSelector = createSelector_createSelector(gridTabIndexStateSelector, (state)=>state.columnGroupHeader);
const gridColumnMenuSelector = (state)=>state.columnMenu;
function GridBody(props) {
    const { VirtualScrollerComponent, ColumnHeadersProps, children } = props;
    const apiRef = useGridPrivateApiContext();
    const rootProps = useGridRootProps();
    const rootRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const visibleColumns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
    const filterColumnLookup = useGridSelector(apiRef, gridFilterActiveItemsLookupSelector);
    const sortColumnLookup = useGridSelector(apiRef, gridSortColumnLookupSelector);
    const columnPositions = useGridSelector(apiRef, gridColumnPositionsSelector);
    const columnHeaderTabIndexState = useGridSelector(apiRef, gridTabIndexColumnHeaderSelector);
    const cellTabIndexState = useGridSelector(apiRef, gridTabIndexCellSelector);
    const columnGroupHeaderTabIndexState = useGridSelector(apiRef, unstable_gridTabIndexColumnGroupHeaderSelector);
    const columnHeaderFocus = useGridSelector(apiRef, gridFocusColumnHeaderSelector);
    const columnGroupHeaderFocus = useGridSelector(apiRef, unstable_gridFocusColumnGroupHeaderSelector);
    const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
    const headerGroupingMaxDepth = useGridSelector(apiRef, gridColumnGroupsHeaderMaxDepthSelector);
    const columnMenuState = useGridSelector(apiRef, gridColumnMenuSelector);
    const columnVisibility = useGridSelector(apiRef, gridColumnVisibilityModelSelector);
    const columnGroupsHeaderStructure = useGridSelector(apiRef, gridColumnGroupsHeaderStructureSelector);
    const hasOtherElementInTabSequence = !(null === columnGroupHeaderTabIndexState && null === columnHeaderTabIndexState && null === cellTabIndexState);
    useEnhancedEffect(()=>{
        apiRef.current.computeSizeAndPublishResizeEvent();
        const elementToObserve = rootRef.current;
        if ('undefined' == typeof ResizeObserver) return ()=>{};
        let animationFrame;
        const observer = new ResizeObserver(()=>{
            animationFrame = requestAnimationFrame(()=>{
                apiRef.current.computeSizeAndPublishResizeEvent();
            });
        });
        if (elementToObserve) observer.observe(elementToObserve);
        return ()=>{
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
            if (elementToObserve) observer.unobserve(elementToObserve);
        };
    }, [
        apiRef
    ]);
    const columnHeadersRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const columnsContainerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const virtualScrollerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    apiRef.current.register('private', {
        columnHeadersContainerElementRef: columnsContainerRef,
        columnHeadersElementRef: columnHeadersRef,
        virtualScrollerRef,
        mainElementRef: rootRef
    });
    const hasDimensions = !!apiRef.current.getRootDimensions();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridMainContainer, {
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnHeaders, esm_extends_extends({
                ref: columnsContainerRef,
                innerRef: columnHeadersRef,
                visibleColumns: visibleColumns,
                filterColumnLookup: filterColumnLookup,
                sortColumnLookup: sortColumnLookup,
                columnPositions: columnPositions,
                columnHeaderTabIndexState: columnHeaderTabIndexState,
                columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
                columnHeaderFocus: columnHeaderFocus,
                columnGroupHeaderFocus: columnGroupHeaderFocus,
                densityFactor: densityFactor,
                headerGroupingMaxDepth: headerGroupingMaxDepth,
                columnMenuState: columnMenuState,
                columnVisibility: columnVisibility,
                columnGroupsHeaderStructure: columnGroupsHeaderStructure,
                hasOtherElementInTabSequence: hasOtherElementInTabSequence
            }, ColumnHeadersProps)),
            hasDimensions && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(VirtualScrollerComponent, {
                ref: virtualScrollerRef
            }),
            children
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridBody.propTypes = {
    children: prop_types_default().node,
    ColumnHeadersProps: prop_types_default().object,
    VirtualScrollerComponent: prop_types_default().elementType.isRequired
});
function GridFooterPlaceholder() {
    var _rootProps$slotProps;
    const rootProps = useGridRootProps();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.footer, esm_extends_extends({}, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.footer));
}
const GridApiContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext(void 0);
if ('production' !== process.env.NODE_ENV) GridApiContext.displayName = 'GridApiContext';
function GridContextProvider({ privateApiRef, props, children }) {
    const apiRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridRootPropsContext.Provider, {
        value: props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPrivateApiContext.Provider, {
            value: privateApiRef,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridApiContext.Provider, {
                value: apiRef,
                children: children
            })
        })
    });
}
function isNumber(value) {
    return 'number' == typeof value && !Number.isNaN(value);
}
function utils_isFunction(value) {
    return 'function' == typeof value;
}
function utils_isObject(value) {
    return 'object' == typeof value && null !== value;
}
function localStorageAvailable() {
    try {
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
function isDeepEqual(a, b) {
    if (a === b) return true;
    if (a && b && 'object' == typeof a && 'object' == typeof b) {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1)if (!isDeepEqual(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1)if (!b.has(entriesA[i][0])) return false;
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!isDeepEqual(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1)if (!b.has(entries[i][0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!isDeepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function mulberry32(a) {
    return ()=>{
        let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, 1 | t);
        t ^= t + Math.imul(t ^ t >>> 7, 61 | t);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function randomNumberBetween(seed, min, max) {
    const random = mulberry32(seed);
    return ()=>min + (max - min) * random();
}
function deepClone(obj) {
    if ('function' == typeof structuredClone) return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
function useGridApiMethod(privateApiRef, apiMethods, visibility) {
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}
const forceDebug = localStorageAvailable() && null != window.localStorage.getItem('DEBUG');
const useGridLoggerFactory_noop = ()=>{};
const noopLogger = {
    debug: useGridLoggerFactory_noop,
    info: useGridLoggerFactory_noop,
    warn: useGridLoggerFactory_noop,
    error: useGridLoggerFactory_noop
};
const LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = LOG_LEVELS.indexOf(logLevel);
    if (-1 === minLogLevelIdx) throw new Error(`MUI: Log level ${logLevel} not recognized.`);
    const logger = LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = useGridLoggerFactory_noop;
        return loggerObj;
    }, {});
    return logger;
}
const useGridLoggerFactory = (apiRef, props)=>{
    const getLogger = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((name)=>{
        if (forceDebug) return getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return noopLogger;
        return getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    useGridApiMethod(apiRef, {
        getLogger
    }, 'private');
};
class Store {
    static create(value) {
        return new Store(value);
    }
    constructor(_value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>this.value;
        this.update = (value)=>{
            this.value = value;
            this.listeners.forEach((l)=>l(value));
        };
        this.value = _value;
        this.listeners = new Set();
    }
}
const CLEANUP_TIMER_LOOP_MILLIS = 1000;
class TimerBasedCleanupTracking {
    constructor(timeout = CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if ('function' == typeof unsubscribe) unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = void 0;
        }
    }
}
class FinalizationRegistryBasedCleanupTracking {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if ('function' == typeof unsubscribe) unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    reset() {}
}
var useGridApiEventHandler_GridSignature = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    return GridSignature;
}(useGridApiEventHandler_GridSignature || {});
class ObjectToBeRetainedByReact {
}
function createUseGridApiEventHandler(registryContainer) {
    let cleanupTokensCounter = 0;
    return function(apiRef, eventName, handler, options) {
        if (null === registryContainer.registry) registryContainer.registry = 'undefined' != typeof FinalizationRegistry ? new FinalizationRegistryBasedCleanupTracking() : new TimerBasedCleanupTracking();
        const [objectRetainedByReact] = __WEBPACK_EXTERNAL_MODULE_react__.useState(new ObjectToBeRetainedByReact());
        const subscription = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
        const handlerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
        handlerRef.current = handler;
        const cleanupTokenRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) {
                    var _handlerRef$current;
                    null == (_handlerRef$current = handlerRef.current) || _handlerRef$current.call(handlerRef, params, event, details);
                }
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, ()=>{
                var _subscription$current;
                null == (_subscription$current = subscription.current) || _subscription$current.call(subscription);
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    if (!event.defaultMuiPrevented) {
                        var _handlerRef$current2;
                        null == (_handlerRef$current2 = handlerRef.current) || _handlerRef$current2.call(handlerRef, params, event, details);
                    }
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                var _subscription$current2;
                null == (_subscription$current2 = subscription.current) || _subscription$current2.call(subscription);
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const useGridApiEventHandler_registryContainer = {
    registry: null
};
const useGridApiEventHandler_useGridApiEventHandler = createUseGridApiEventHandler(useGridApiEventHandler_registryContainer);
const optionsSubscriberOptions = {
    isFirst: true
};
function useGridApiOptionHandler(apiRef, eventName, handler) {
    useGridApiEventHandler_useGridApiEventHandler(apiRef, eventName, handler, optionsSubscriberOptions);
}
class EventManager {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
        if ('production' !== process.env.NODE_ENV) {
            const collectionSize = collection.highPriority.size + collection.regular.size;
            if (collectionSize > this.maxListeners && !this.warnOnce) {
                this.warnOnce = true;
                console.warn([
                    `Possible EventEmitter memory leak detected. ${collectionSize} ${eventName} listeners added.`
                ].join('\n'));
            }
        }
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}
const SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const isSyntheticEvent = (event)=>void 0 !== event.isPropagationStopped;
let useGridApiInitialization_globalId = 0;
function createPrivateAPI(publicApiRef) {
    var _publicApiRef$current;
    const existingPrivateApi = null == (_publicApiRef$current = publicApiRef.current) ? void 0 : _publicApiRef$current[SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state,
        store: Store.create(state),
        instanceId: {
            id: useGridApiInitialization_globalId
        }
    };
    useGridApiInitialization_globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if ((null == currentPrivateMethod ? void 0 : currentPrivateMethod.spying) === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if ('public' === visibility) {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if ((null == currentPublicMethod ? void 0 : currentPublicMethod.spying) === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new EventManager()
    });
    return privateApi;
}
function createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function useGridApiInitialization(inputApiRef, props) {
    const publicApiRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const privateApiRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    if (!privateApiRef.current) privateApiRef.current = createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = createPublicAPI(privateApiRef);
    const publishEvent = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if (isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === useGridApiEventHandler_GridSignature.DataGridPro ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    useGridApiMethod(privateApiRef, {
        subscribeEvent,
        publishEvent
    }, 'public');
    __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}
const useGridLocaleText = (apiRef, props)=>{
    const getLocaleText = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((key)=>{
        if (null == props.localeText[key]) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText
    });
};
function typeof_typeof(o) {
    return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, typeof_typeof(o);
}
function toPrimitive(t, r) {
    if ("object" != typeof_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == typeof_typeof(i) ? i : i + "";
}
const useGridPipeProcessing = (apiRef)=>{
    const processorsCache = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const isRunning = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const runAppliers = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((group, id, processor)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        const groupCache = processorsCache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            runAppliers(groupCache);
        }
        return ()=>{
            processorsCache.current[group].processors.set(id, null);
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((group, id, applier)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        processorsCache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = processorsCache.current[group].appliers, otherAppliers = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_appliers, [
                id
            ].map(toPropertyKey));
            processorsCache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((group)=>{
        const groupCache = processorsCache.current[group];
        runAppliers(groupCache);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!processorsCache.current[group]) return value;
        const preProcessors = Array.from(processorsCache.current[group].processors.values());
        return preProcessors.reduce((acc, preProcessor)=>{
            if (!preProcessor) return acc;
            return preProcessor(acc, context);
        }, value);
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor,
        registerPipeApplier,
        requestPipeProcessorsApplication
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    useGridApiMethod(apiRef, preProcessingPrivateApi, 'private');
    useGridApiMethod(apiRef, preProcessingPublicApi, 'public');
};
const GRID_DEFAULT_STRATEGY = 'none';
const GRID_STRATEGIES_PROCESSORS = {
    rowTreeCreation: 'rowTree',
    filtering: 'rowTree',
    sorting: 'rowTree',
    visibleRowsLookupCreation: 'rowTree'
};
const useGridStrategyProcessing = (apiRef)=>{
    const availableStrategies = __WEBPACK_EXTERNAL_MODULE_react__.useRef(new Map());
    const strategiesCache = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const registerStrategyProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, [
                strategyName
            ].map(toPropertyKey));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy(GRID_STRATEGIES_PROCESSORS[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy(GRID_STRATEGIES_PROCESSORS[processorName]);
        if (null == activeStrategy) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((strategyGroup)=>{
        var _availableStrategyEnt;
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return null != (_availableStrategyEnt = null == availableStrategyEntry ? void 0 : availableStrategyEntry[0]) ? _availableStrategyEnt : GRID_DEFAULT_STRATEGY;
    }, []);
    const setStrategyAvailability = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor,
        applyStrategyProcessor,
        getActiveStrategy,
        setStrategyAvailability
    };
    useGridApiMethod(apiRef, strategyProcessingApi, 'private');
};
const useGridStateInitialization = (apiRef, props)=>{
    const controlStateMapRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const [, rawForceUpdate] = __WEBPACK_EXTERNAL_MODULE_react__.useState();
    const registerControlState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((state, reason)=>{
        let newState;
        newState = utils_isFunction(state) ? state(apiRef.current.state) : state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false;
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            if (void 0 !== controlState.propModel && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            apiRef.current.state = newState;
            if (apiRef.current.publishEvent) apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (1 === updatedControlStateIds.length) {
            const { stateId, hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) {
                const details = props.signature === useGridApiEventHandler_GridSignature.DataGridPro ? {
                    api: apiRef.current,
                    reason
                } : {
                    reason
                };
                controlState.propOnChange(model, details);
            }
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef,
        props.signature
    ]);
    const updateControlState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((key, state, reason)=>apiRef.current.setState((previousState)=>esm_extends_extends({}, previousState, {
                [key]: state(previousState[key])
            }), reason), [
        apiRef
    ]);
    const forceUpdate = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>rawForceUpdate(()=>apiRef.current.state), [
        apiRef
    ]);
    const publicStateApi = {
        setState,
        forceUpdate
    };
    const privateStateApi = {
        updateControlState,
        registerControlState
    };
    useGridApiMethod(apiRef, publicStateApi, 'public');
    useGridApiMethod(apiRef, privateStateApi, 'private');
};
const useGridInitialization = (inputApiRef, props)=>{
    const privateApiRef = useGridApiInitialization(inputApiRef, props);
    useGridLoggerFactory(privateApiRef, props);
    useGridStateInitialization(privateApiRef, props);
    useGridPipeProcessing(privateApiRef);
    useGridStrategyProcessing(privateApiRef);
    useGridLocaleText(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
    return privateApiRef;
};
const useGridInitializeState = (initializer, privateApiRef, props)=>{
    const isInitialized = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};
function useGridLogger(privateApiRef, name) {
    const logger = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}
const useGridNativeEventListener = (apiRef, ref, eventName, handler, options)=>{
    const logger = useGridLogger(apiRef, 'useNativeEventListener');
    const [added, setAdded] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const handlerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(handler);
    const wrapHandler = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>handlerRef.current && handlerRef.current(event), []);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        let targetElement;
        targetElement = utils_isFunction(ref) ? ref() : ref && ref.current ? ref.current : null;
        if (targetElement && eventName && !added) {
            logger.debug(`Binding native ${eventName} event`);
            targetElement.addEventListener(eventName, wrapHandler, options);
            const boundElem = targetElement;
            setAdded(true);
            const unsubscribe = ()=>{
                logger.debug(`Clearing native ${eventName} event`);
                boundElem.removeEventListener(eventName, wrapHandler, options);
            };
            apiRef.current.subscribeEvent('unmount', unsubscribe);
        }
    }, [
        ref,
        wrapHandler,
        eventName,
        added,
        logger,
        options,
        apiRef
    ]);
};
const isEscapeKey = (key)=>'Escape' === key;
const isEnterKey = (key)=>'Enter' === key;
const isTabKey = (key)=>'Tab' === key;
const isSpaceKey = (key)=>' ' === key;
const isArrowKeys = (key)=>0 === key.indexOf('Arrow');
const isHomeOrEndKeys = (key)=>'Home' === key || 'End' === key;
const isPageKeys = (key)=>0 === key.indexOf('Page');
function isPrintableKey(event) {
    return 1 === event.key.length && !event.ctrlKey && !event.metaKey;
}
const isNavigationKey = (key)=>isHomeOrEndKeys(key) || isArrowKeys(key) || isPageKeys(key) || isSpaceKey(key);
const isKeyboardEvent = (event)=>!!event.key;
const isHideMenuKey = (key)=>isTabKey(key) || isEscapeKey(key);
function useGridApiContext() {
    const apiRef = __WEBPACK_EXTERNAL_MODULE_react__.useContext(GridApiContext);
    if (void 0 === apiRef) throw new Error("MUI: Could not find the data grid context.\nIt looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.\nThis can also happen if you are bundling multiple versions of the data grid.");
    return apiRef;
}
const GridCellCheckboxRenderer_excluded = [
    "field",
    "id",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const GridCellCheckboxRenderer_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridCellCheckboxForwardRef = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$slotProps;
    const { field, id, value: isChecked, rowNode, hasFocus, tabIndex } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridCellCheckboxRenderer_excluded);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = GridCellCheckboxRenderer_useUtilityClasses(ownerState);
    const checkboxElement = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const rippleRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(checkboxElement, ref);
    const element = apiRef.current.getCellElement(id, field);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        if (0 === tabIndex && element) element.tabIndex = -1;
    }, [
        element,
        tabIndex
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (hasFocus) {
            var _checkboxElement$curr;
            const input = null == (_checkboxElement$curr = checkboxElement.current) ? void 0 : _checkboxElement$curr.querySelector('input');
            null == input || input.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        if (isSpaceKey(event.key)) event.stopPropagation();
    }, []);
    if ('footer' === rowNode.type || 'pinnedRow' === rowNode.type) return null;
    const isSelectable = apiRef.current.isRowSelectable(id);
    const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseCheckbox, esm_extends_extends({
        ref: handleRef,
        tabIndex: tabIndex,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label
        },
        onKeyDown: handleKeyDown,
        disabled: !isSelectable,
        touchRippleRef: rippleRef
    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});
"production" !== process.env.NODE_ENV && (GridCellCheckboxForwardRef.propTypes = {
    api: prop_types_default().object.isRequired,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                focus: prop_types_default().func.isRequired
            })
        })
    ]),
    formattedValue: prop_types_default().any,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    isEditable: prop_types_default().bool,
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const GridCellCheckboxRenderer_GridCellCheckboxRenderer = GridCellCheckboxForwardRef;
const gridRowSelectionStateSelector = (state)=>state.rowSelection;
const selectedGridRowsCountSelector = createSelector_createSelector(gridRowSelectionStateSelector, (selection)=>selection.length);
const selectedGridRowsSelector = createSelectorMemoized(gridRowSelectionStateSelector, gridRowsLookupSelector, (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const selectedIdsLookupSelector = createSelectorMemoized(gridRowSelectionStateSelector, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));
const MAX_PAGE_SIZE = 100;
const defaultPageSize = (autoPageSize)=>autoPageSize ? 0 : 100;
const getPageCount = (rowCount, pageSize)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    return 0;
};
const noRowCountInServerMode = warning_buildWarning([
    "MUI: the 'rowCount' prop is undefined while using paginationMode='server'",
    'For more detail, see http://mui.com/components/data-grid/pagination/#basic-implementation'
], 'error');
const getDefaultGridPaginationModel = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const getValidPage = (page, pageCount = 0)=>{
    if (0 === pageCount) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const throwIfPageSizeExceedsTheLimit = (pageSize, signatureProp)=>{
    if (signatureProp === useGridApiEventHandler_GridSignature.DataGrid && pageSize > MAX_PAGE_SIZE) throw new Error("MUI: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.\nYou need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.");
};
const gridPaginationSelector = (state)=>state.pagination;
const gridPaginationModelSelector = createSelector_createSelector(gridPaginationSelector, (pagination)=>pagination.paginationModel);
const gridPageSelector = createSelector_createSelector(gridPaginationModelSelector, (paginationModel)=>paginationModel.page);
const gridPageSizeSelector = createSelector_createSelector(gridPaginationModelSelector, (paginationModel)=>paginationModel.pageSize);
createSelector_createSelector(gridPaginationModelSelector, gridFilteredTopLevelRowCountSelector, (paginationModel, visibleTopLevelRowCount)=>getPageCount(visibleTopLevelRowCount, paginationModel.pageSize));
const gridPaginationRowRangeSelector = createSelectorMemoized(gridPaginationModelSelector, gridRowTreeSelector, gridRowMaximumTreeDepthSelector, gridExpandedSortedRowEntriesSelector, gridFilteredSortedTopLevelRowEntriesSelector, (paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    if (-1 === topLevelFirstRowIndex || -1 === topLevelLastRowIndex) return null;
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        var _rowTree$row$id;
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = null == (_rowTree$row$id = rowTree[row.id]) ? void 0 : _rowTree$row$id.depth;
        if (void 0 === depth) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (0 === depth) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const gridPaginatedVisibleSortedGridRowEntriesSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, gridPaginationRowRangeSelector, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const gridPaginatedVisibleSortedGridRowIdsSelector = createSelectorMemoized(gridExpandedSortedRowIdsSelector, gridPaginationRowRangeSelector, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const GridHeaderCheckbox_excluded = [
    "field",
    "colDef"
];
const GridHeaderCheckbox_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridHeaderCheckbox_GridHeaderCheckbox = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$slotProps;
    const other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridHeaderCheckbox_excluded);
    const [, forceUpdate] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = GridHeaderCheckbox_useUtilityClasses(ownerState);
    const tabIndexState = useGridSelector(apiRef, gridTabIndexColumnHeaderSelector);
    const selection = useGridSelector(apiRef, gridRowSelectionStateSelector);
    const visibleRowIds = useGridSelector(apiRef, gridExpandedSortedRowIdsSelector);
    const paginatedVisibleRowIds = useGridSelector(apiRef, gridPaginatedVisibleSortedGridRowIdsSelector);
    const filteredSelection = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if ('function' != typeof rootProps.isRowSelectable) return selection;
        return selection.filter((id)=>{
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection
    ]);
    const selectionCandidates = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const rowIds = rootProps.pagination && rootProps.checkboxSelectionVisibleOnly ? paginatedVisibleRowIds : visibleRowIds;
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    const currentSelectionSize = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = null !== tabIndexState && tabIndexState.field === props.field ? 0 : -1;
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (0 === tabIndex && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        if (' ' === event.key) apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange), [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseCheckbox, esm_extends_extends({
        ref: ref,
        indeterminate: isIndeterminate,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown
    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});
"production" !== process.env.NODE_ENV && (GridHeaderCheckbox_GridHeaderCheckbox.propTypes = {
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired
});
const GridEditInputCell_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const GridEditInputCell_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridEditInputCellRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputBase_7d3cd5a3__["default"], {
    name: 'MuiDataGrid',
    slot: 'EditInputCell',
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme })=>esm_extends_extends({}, theme.typography.body2, {
        padding: '1px 0',
        '& input': {
            padding: '0 16px',
            height: '100%'
        }
    }));
const GridEditInputCell = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    const rootProps = useGridRootProps();
    const { id, value, field, colDef, hasFocus, debounceMs = 200, isProcessingProps, onValueChange } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridEditInputCell_excluded);
    const apiRef = useGridApiContext();
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const [valueState, setValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(value);
    const classes = GridEditInputCell_useUtilityClasses(rootProps);
    const handleChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(async (event)=>{
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getCellParams(id, field));
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id,
            field,
            value: parsedValue,
            debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if ((null == meta ? void 0 : meta.changeReason) !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    useEnhancedEffect(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridEditInputCellRoot, esm_extends_extends({
        ref: ref,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: 'number' === colDef.type ? colDef.type : 'text',
        value: null != valueState ? valueState : '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : void 0
    }, other));
});
"production" !== process.env.NODE_ENV && (GridEditInputCell.propTypes = {
    api: prop_types_default().object.isRequired,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: prop_types_default().oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    colDef: prop_types_default().object.isRequired,
    debounceMs: prop_types_default().number,
    field: prop_types_default().string.isRequired,
    formattedValue: prop_types_default().any,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    isEditable: prop_types_default().bool,
    isProcessingProps: prop_types_default().bool,
    isValidating: prop_types_default().bool,
    onValueChange: prop_types_default().func,
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const renderEditInputCell = (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridEditInputCell, esm_extends_extends({}, params));
const sortModelDisableMultiColumnsSortingWarning = warning_buildWarning([
    'MUI: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.',
    'If you are using the community version of the `DataGrid`, this prop is always `true`.'
], 'error');
const sanitizeSortModel = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) {
        sortModelDisableMultiColumnsSortingWarning();
        return [
            model[0]
        ];
    }
    return model;
};
const mergeStateWithSortModel = (sortModel, disableMultipleColumnsSorting)=>(state)=>esm_extends_extends({}, state, {
            sorting: esm_extends_extends({}, state.sorting, {
                sortModel: sanitizeSortModel(sortModel, disableMultipleColumnsSorting)
            })
        });
const isDesc = (direction)=>'desc' === direction;
const parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column) return null;
    const comparator = isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    const getSortCellParams = (id)=>({
            id,
            field: column.field,
            rowNode: apiRef.current.getRowNode(id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams,
        comparator
    };
};
const compareRows = (parsedSortItems, row1, row2)=>parsedSortItems.reduce((res, item, index)=>{
        if (0 !== res) return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
const buildAggregatedSortingApplier = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (0 === comparatorList.length) return null;
    return (rowList)=>rowList.map((node)=>({
                node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const getNextGridSortDirection = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || -1 === currentIdx || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const gridNillComparator = (v1, v2)=>{
    if (null == v1 && null != v2) return -1;
    if (null == v2 && null != v1) return 1;
    if (null == v1 && null == v2) return 0;
    return null;
};
const gridSortingUtils_collator = new Intl.Collator();
const gridStringOrNumberComparator = (value1, value2)=>{
    const nillResult = gridNillComparator(value1, value2);
    if (null !== nillResult) return nillResult;
    if ('string' == typeof value1) return gridSortingUtils_collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const gridNumberComparator = (value1, value2)=>{
    const nillResult = gridNillComparator(value1, value2);
    if (null !== nillResult) return nillResult;
    return Number(value1) - Number(value2);
};
const gridDateComparator = (value1, value2)=>{
    const nillResult = gridNillComparator(value1, value2);
    if (null !== nillResult) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};
class Timeout {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (0 !== this.currentId) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>this.clear;
    }
    static create() {
        return new Timeout();
    }
    start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(fn, delay);
    }
}
function useTimeout() {
    const timeout = useLazyRef(Timeout.create).current;
    useOnMount(timeout.disposeEffect);
    return timeout;
}
const GridFilterInputValue_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "clearButton",
    "InputProps",
    "variant"
];
function GridFilterInputValue(props) {
    var _item$value, _rootProps$slotProps;
    const { item, applyValue, type, apiRef, focusElementRef, tabIndex, disabled, clearButton, InputProps, variant = 'standard' } = props, others = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterInputValue_excluded);
    const filterTimeout = useTimeout();
    const [filterValueState, setFilterValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null != (_item$value = item.value) ? _item$value : '');
    const [applying, setIsApplying] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const id = useId();
    const rootProps = useGridRootProps();
    const onFilterChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const { value } = event.target;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = esm_extends_extends({}, item, {
                value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        id,
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || void 0 === item.value) {
            var _item$value2;
            setFilterValueState(String(null != (_item$value2 = item.value) ? _item$value2 : ''));
        }
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTextField, esm_extends_extends({
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: variant,
        type: type || 'text',
        InputProps: esm_extends_extends({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled
        }, InputProps, {
            inputProps: esm_extends_extends({
                tabIndex
            }, null == InputProps ? void 0 : InputProps.inputProps)
        }),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTextField));
}
"production" !== process.env.NODE_ENV && (GridFilterInputValue.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }).isRequired,
    applyValue: prop_types_default().func.isRequired,
    clearButton: prop_types_default().node,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    isFilterActive: prop_types_default().bool,
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired
});
const GridFilterInputMultipleValue_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
function GridFilterInputMultipleValue(props) {
    const { item, applyValue, type, apiRef, focusElementRef, color, error, helperText, size, variant } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterInputMultipleValue_excluded);
    const TextFieldProps = {
        color,
        error,
        helperText,
        size,
        variant
    };
    const [filterValueState, setFilterValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(item.value || []);
    const id = useId();
    const rootProps = useGridRootProps();
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        var _item$value;
        const itemValue = null != (_item$value = item.value) ? _item$value : [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue(esm_extends_extends({}, item, {
            value: [
                ...value
            ]
        }));
    }, [
        applyValue,
        item
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__["default"], esm_extends_extends({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue } = params;
            return null == inputValue || '' === inputValue ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseChip, esm_extends_extends({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, getTagProps({
                    index
                })))),
        renderInput: (params)=>{
            var _rootProps$slotProps;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTextField, esm_extends_extends({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: esm_extends_extends({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || 'text'
            }, TextFieldProps, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTextField));
        }
    }, other));
}
"production" !== process.env.NODE_ENV && (GridFilterInputMultipleValue.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }).isRequired,
    applyValue: prop_types_default().func.isRequired,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired,
    type: prop_types_default().oneOf([
        'number',
        'text'
    ])
});
const GLOBAL_API_REF = {
    current: null
};
function tagInternalFilter(fn) {
    fn.isInternal = true;
    return fn;
}
function isInternalFilter(fn) {
    return void 0 !== fn && true === fn.isInternal;
}
function convertFilterV7ToLegacy(fn) {
    return tagInternalFilter((filterItem, column)=>{
        const filterFn = fn(filterItem, column);
        if (!filterFn) return filterFn;
        return (cellParams)=>filterFn(cellParams.value, cellParams.row, column, GLOBAL_API_REF.current);
    });
}
function convertLegacyOperators(ops) {
    return ops.map((op)=>esm_extends_extends({}, op, {
            getApplyFilterFn: convertFilterV7ToLegacy(op.getApplyFilterFnV7),
            getApplyFilterFnV7: tagInternalFilter(op.getApplyFilterFnV7)
        }));
}
function convertQuickFilterV7ToLegacy(fn) {
    return tagInternalFilter((filterItem, column, apiRef)=>{
        const filterFn = fn(filterItem, column, apiRef);
        if (!filterFn) return filterFn;
        return (cellParams)=>filterFn(cellParams.value, cellParams.row, column, apiRef);
    });
}
var gridFilterItem_GridLogicOperator = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}(gridFilterItem_GridLogicOperator || {});
const getDefaultGridFilterModel = ()=>({
        items: [],
        logicOperator: gridFilterItem_GridLogicOperator.And,
        quickFilterValues: [],
        quickFilterLogicOperator: gridFilterItem_GridLogicOperator.And
    });
function getPublicApiRef(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}
let hasEval;
function getHasEval() {
    if (void 0 !== hasEval) return hasEval;
    try {
        hasEval = new Function('return true')();
    } catch (_) {
        hasEval = false;
    }
    return hasEval;
}
const cleanFilterItem = (item, apiRef)=>{
    const cleanItem = esm_extends_extends({}, item);
    if (null == cleanItem.id) cleanItem.id = Math.round(1e5 * Math.random());
    if (null == cleanItem.operator) {
        const column = gridColumnLookupSelector(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const filterModelDisableMultiColumnsFilteringWarning = warning_buildWarning([
    'MUI: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.',
    'If you are using the community version of the `DataGrid`, this prop is always `true`.'
], 'error');
const filterModelMissingItemIdWarning = warning_buildWarning('MUI: The `id` field is required on `filterModel.items` when you use multiple filters.', 'error');
const filterModelMissingItemOperatorWarning = warning_buildWarning('MUI: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.', 'error');
const sanitizeFilterModel = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        filterModelDisableMultiColumnsFilteringWarning();
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>null == item.id);
    const hasItemWithoutOperator = items.some((item)=>null == item.operator);
    if (hasItemsWithoutIds) filterModelMissingItemIdWarning();
    if (hasItemWithoutOperator) filterModelMissingItemOperatorWarning();
    if (hasItemWithoutOperator || hasItemsWithoutIds) return esm_extends_extends({}, model, {
        items: items.map((item)=>cleanFilterItem(item, apiRef))
    });
    if (model.items !== items) return esm_extends_extends({}, model, {
        items
    });
    return model;
};
const mergeStateWithFilterModel = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>esm_extends_extends({}, filteringState, {
            filterModel: sanitizeFilterModel(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const removeDiacritics = (value)=>{
    if ('string' == typeof value) return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
const getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        var _filterItem$value;
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? null == (_filterItem$value = filterItem.value) ? void 0 : _filterItem$value.map((x)=>parser(x)) : parser(filterItem.value);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = removeDiacritics(parsedValue);
    const newFilterItem = esm_extends_extends({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!(null != filterOperators && filterOperators.length)) throw new Error(`MUI: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const hasUserFunctionLegacy = !isInternalFilter(filterOperator.getApplyFilterFn);
    const hasUserFunctionV7 = !isInternalFilter(filterOperator.getApplyFilterFnV7);
    const publicApiRef = getPublicApiRef(apiRef);
    if (filterOperator.getApplyFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) {
        const applyFilterOnRow = filterOperator.getApplyFilterFnV7(newFilterItem, column);
        if ('function' != typeof applyFilterOnRow) return null;
        return {
            v7: true,
            item: newFilterItem,
            fn: (row)=>{
                let value = apiRef.current.getRowValue(row, column);
                if (ignoreDiacritics) value = removeDiacritics(value);
                return applyFilterOnRow(value, row, column, publicApiRef);
            }
        };
    }
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if ('function' != typeof applyFilterOnRow) return null;
    return {
        v7: false,
        item: newFilterItem,
        fn: (rowId)=>{
            const params = apiRef.current.getCellParams(rowId, newFilterItem.field);
            GLOBAL_API_REF.current = publicApiRef;
            if (ignoreDiacritics) params.value = removeDiacritics(params.value);
            const result = applyFilterOnRow(params);
            GLOBAL_API_REF.current = null;
            return result;
        }
    };
};
let filterItemsApplierId = 1;
const buildAggregatedFilterItemsApplier = (filterModel, apiRef, disableEval)=>{
    const { items } = filterModel;
    const appliers = items.map((item)=>getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (0 === appliers.length) return null;
    if (disableEval || !getHasEval()) return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.v7 ? applier.fn(row) : applier.fn(apiRef.current.getRowId(row));
        }
        return resultPerItemId;
    };
    const filterItemCore = new Function('getRowId', 'appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i}
    ? false
    : ${applier.v7 ? `appliers[${i}].fn(row)` : `appliers[${i}].fn(getRowId(row))`},`).join('\n')}
};

return result$$;`.replaceAll('$$', String(filterItemsApplierId)));
    filterItemsApplierId += 1;
    const filterItem = (row, shouldApplyItem)=>filterItemCore(apiRef.current.getRowId, appliers, row, shouldApplyItem);
    return filterItem;
};
const buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    var _filterModel$quickFil, _filterModel$quickFil2, _filterModel$quickFil3;
    const quickFilterValues = null != (_filterModel$quickFil = null == (_filterModel$quickFil2 = filterModel.quickFilterValues) ? void 0 : _filterModel$quickFil2.filter(Boolean)) ? _filterModel$quickFil : [];
    if (0 === quickFilterValues.length) return null;
    const quickFilterExcludeHiddenColumns = null != (_filterModel$quickFil3 = filterModel.quickFilterExcludeHiddenColumns) ? _filterModel$quickFil3 : false;
    const columnFields = quickFilterExcludeHiddenColumns ? gridVisibleColumnFieldsSelector(apiRef) : gridColumnFieldsSelector(apiRef);
    const appliersPerField = [];
    const { ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = getPublicApiRef(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = null == column ? void 0 : column.getApplyQuickFilterFn;
        const getApplyQuickFilterFnV7 = null == column ? void 0 : column.getApplyQuickFilterFnV7;
        const hasUserFunctionLegacy = !isInternalFilter(getApplyQuickFilterFn);
        const hasUserFunctionV7 = !isInternalFilter(getApplyQuickFilterFnV7);
        if (getApplyQuickFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) appliersPerField.push({
            column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? removeDiacritics(quickFilterValue) : quickFilterValue;
                return {
                    v7: true,
                    fn: getApplyQuickFilterFnV7(value, column, publicApiRef)
                };
            })
        });
        else if (getApplyQuickFilterFn) appliersPerField.push({
            column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? removeDiacritics(quickFilterValue) : quickFilterValue;
                return {
                    v7: false,
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function(row, shouldApplyFilter) {
        const result = {};
        const usedCellParams = {};
        outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column, appliers } = appliersPerField[i];
                const { field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = apiRef.current.getRowValue(row, column);
                if (null !== applier.fn) if (applier.v7) {
                    if (ignoreDiacritics) value = removeDiacritics(value);
                    const isMatching = applier.fn(value, row, column, publicApiRef);
                    if (isMatching) {
                        result[filterValue] = true;
                        continue outer;
                    }
                } else {
                    var _usedCellParams$field;
                    const cellParams = null != (_usedCellParams$field = usedCellParams[field]) ? _usedCellParams$field : apiRef.current.getCellParams(apiRef.current.getRowId(row), field);
                    if (ignoreDiacritics) cellParams.value = removeDiacritics(cellParams.value);
                    usedCellParams[field] = cellParams;
                    const isMatching = applier.fn(cellParams);
                    if (isMatching) {
                        result[filterValue] = true;
                        continue outer;
                    }
                }
            }
            result[filterValue] = false;
        }
        return result;
    };
};
const buildAggregatedFilterApplier = (filterModel, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = buildAggregatedFilterItemsApplier(filterModel, apiRef, disableEval);
    const isRowMatchingQuickFilter = buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return function(row, shouldApplyFilter, result) {
        var _isRowMatchingFilterI, _isRowMatchingQuickFi;
        result.passingFilterItems = null != (_isRowMatchingFilterI = null == isRowMatchingFilterItems ? void 0 : isRowMatchingFilterItems(row, shouldApplyFilter)) ? _isRowMatchingFilterI : null;
        result.passingQuickFilterValues = null != (_isRowMatchingQuickFi = null == isRowMatchingQuickFilter ? void 0 : isRowMatchingQuickFilter(row, shouldApplyFilter)) ? _isRowMatchingQuickFi : null;
    };
};
const isNotNull = (result)=>null != result;
const filterModelItems = (cache, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>null !== getFilterCallbackFromItem(item, apiRef));
    return cache.cleanedFilterItems;
};
const passFilterLogic = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache)=>{
    const cleanedFilterItems = filterModelItems(cache, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter(isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter(isNotNull);
    if (cleanedFilterItemResults.length > 0) {
        var _filterModel$logicOpe;
        const filterItemPredicate = (item)=>cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        const logicOperator = null != (_filterModel$logicOpe = filterModel.logicOperator) ? _filterModel$logicOpe : getDefaultGridFilterModel().logicOperator;
        if (logicOperator === gridFilterItem_GridLogicOperator.And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    if (cleanedQuickFilterResults.length > 0 && null != filterModel.quickFilterValues) {
        var _filterModel$quickFil4;
        const quickFilterValuePredicate = (value)=>cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        const quickFilterLogicOperator = null != (_filterModel$quickFil4 = filterModel.quickFilterLogicOperator) ? _filterModel$quickFil4 : getDefaultGridFilterModel().quickFilterLogicOperator;
        if (quickFilterLogicOperator === gridFilterItem_GridLogicOperator.And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};
const getGridStringQuickFilterFn = tagInternalFilter((value)=>{
    if (!value) return null;
    const filterRegex = new RegExp(escapeRegExp(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = removeDiacritics(columnValue);
        return null != columnValue ? filterRegex.test(columnValue.toString()) : false;
    };
});
const getGridStringOperators = (disableTrim = false)=>convertLegacyOperators([
        {
            value: 'contains',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(escapeRegExp(filterItemValue), 'i');
                return (value)=>null != value ? filterRegex.test(String(value)) : false;
            },
            InputComponent: GridFilterInputValue
        },
        {
            value: 'equals',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const collator = new Intl.Collator(void 0, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>null != value ? 0 === collator.compare(filterItemValue, value.toString()) : false;
            },
            InputComponent: GridFilterInputValue
        },
        {
            value: 'startsWith',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${escapeRegExp(filterItemValue)}.*$`, 'i');
                return (value)=>null != value ? filterRegex.test(value.toString()) : false;
            },
            InputComponent: GridFilterInputValue
        },
        {
            value: 'endsWith',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${escapeRegExp(filterItemValue)}$`, 'i');
                return (value)=>null != value ? filterRegex.test(value.toString()) : false;
            },
            InputComponent: GridFilterInputValue
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>(value)=>'' === value || null == value,
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>(value)=>'' !== value && null != value,
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || 0 === filterItem.value.length) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(void 0, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>null != value ? filterItemValue.some((filterValue)=>0 === collator.compare(filterValue, value.toString() || '')) : false;
            },
            InputComponent: GridFilterInputMultipleValue
        }
    ]);
const GRID_STRING_COL_DEF = {
    width: 100,
    minWidth: 50,
    maxWidth: 1 / 0,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    aggregable: true,
    editable: false,
    sortComparator: gridStringOrNumberComparator,
    type: 'string',
    align: 'left',
    filterOperators: getGridStringOperators(),
    renderEditCell: renderEditInputCell,
    getApplyQuickFilterFn: convertQuickFilterV7ToLegacy(getGridStringQuickFilterFn),
    getApplyQuickFilterFnV7: getGridStringQuickFilterFn
};
const GRID_ROOT_GROUP_ID = "auto-generated-group-node-root";
const GRID_ID_AUTOGENERATED = Symbol('mui.id_autogenerated');
const buildRootGroup = ()=>({
        type: 'group',
        id: GRID_ROOT_GROUP_ID,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function checkGridRowIdIsValid(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (null == id) throw new Error([
        'MUI: The data grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const getRowIdFromRowModel = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    checkGridRowIdIsValid(id, rowModel, detailErrorMessage);
    return id;
};
const createRowsInternalCache = ({ rows, getRowId, loading, rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    const dataRowIdToIdLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = getRowIdFromRowModel(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        dataRowIdToIdLookup[id] = id;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates,
        dataRowIdToIdLookup,
        dataRowIdToModelLookup
    };
};
const getTopLevelRowCount = ({ tree, rowCountProp = 0 })=>{
    const rootGroupNode = tree[GRID_ROOT_GROUP_ID];
    return Math.max(rowCountProp, rootGroupNode.children.length + (null == rootGroupNode.footerId ? 0 : 1));
};
const getRowsStateFromCache = ({ apiRef, rowCountProp = 0, loadingProp, previousTree, previousTreeDepths })=>{
    const cache = apiRef.current.caches.rows;
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree,
        previousTreeDepths,
        updates: cache.updates,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return esm_extends_extends({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: getTopLevelRowCount({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp
        }),
        groupingName,
        loading: loadingProp
    });
};
const isAutoGeneratedRow = (rowNode)=>'skeletonRow' === rowNode.type || 'footer' === rowNode.type || 'group' === rowNode.type && rowNode.isAutoGenerated || 'pinnedRow' === rowNode.type && rowNode.isAutoGenerated;
const getTreeNodeDescendants = (tree, parentId, skipAutoGeneratedRows)=>{
    const node = tree[parentId];
    if ('group' !== node.type) return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !isAutoGeneratedRow(tree[child])) validDescendants.push(child);
        const childDescendants = getTreeNodeDescendants(tree, child, skipAutoGeneratedRows);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && null != node.footerId) validDescendants.push(node.footerId);
    return validDescendants;
};
const updateCacheWithNewRows = ({ previousCache, getRowId, updates })=>{
    var _previousCache$update, _previousCache$update2, _previousCache$update3;
    if ('full' === previousCache.updates.type) throw new Error('MUI: Unable to prepare a partial update if a full update is not applied yet');
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = getRowIdFromRowModel(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, esm_extends_extends({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...null != (_previousCache$update = previousCache.updates.actions.insert) ? _previousCache$update : []
            ],
            modify: [
                ...null != (_previousCache$update2 = previousCache.updates.actions.modify) ? _previousCache$update2 : []
            ],
            remove: [
                ...null != (_previousCache$update3 = previousCache.updates.actions.remove) ? _previousCache$update3 : []
            ]
        },
        idToActionLookup: esm_extends_extends({}, previousCache.updates.idToActionLookup)
    };
    const dataRowIdToModelLookup = esm_extends_extends({}, previousCache.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = esm_extends_extends({}, previousCache.dataRowIdToIdLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        if ('delete' === partialRow._action) {
            if ('remove' === actionAlreadyAppliedToRow || !dataRowIdToModelLookup[id]) return;
            if (null != actionAlreadyAppliedToRow) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            delete dataRowIdToIdLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        if (oldRow) {
            if ('remove' === actionAlreadyAppliedToRow) {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (null == actionAlreadyAppliedToRow) partialUpdates.actions.modify.push(id);
            dataRowIdToModelLookup[id] = esm_extends_extends({}, oldRow, partialRow);
            return;
        }
        if ('remove' === actionAlreadyAppliedToRow) {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (null == actionAlreadyAppliedToRow) partialUpdates.actions.insert.push(id);
        dataRowIdToModelLookup[id] = partialRow;
        dataRowIdToIdLookup[id] = id;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup,
        dataRowIdToIdLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
function calculatePinnedRowsHeight(apiRef) {
    var _pinnedRows$top, _pinnedRows$bottom;
    const pinnedRows = gridPinnedRowsSelector(apiRef);
    const topPinnedRowsHeight = (null == pinnedRows || null == (_pinnedRows$top = pinnedRows.top) ? void 0 : _pinnedRows$top.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    const bottomPinnedRowsHeight = (null == pinnedRows || null == (_pinnedRows$bottom = pinnedRows.bottom) ? void 0 : _pinnedRows$bottom.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    return {
        top: topPinnedRowsHeight,
        bottom: bottomPinnedRowsHeight
    };
}
function getMinimalContentHeight(apiRef, rowHeight) {
    const densityFactor = gridDensityFactorSelector(apiRef);
    return `var(--DataGrid-overlayHeight, ${2 * Math.floor(rowHeight * densityFactor)}px)`;
}
const GridBooleanCell_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex"
];
const GridBooleanCell_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridBooleanCellRaw(props) {
    const { value } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridBooleanCell_excluded);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = GridBooleanCell_useUtilityClasses(ownerState);
    const Icon = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Icon, esm_extends_extends({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
"production" !== process.env.NODE_ENV && (GridBooleanCellRaw.propTypes = {
    api: prop_types_default().object.isRequired,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                focus: prop_types_default().func.isRequired
            })
        })
    ]),
    formattedValue: prop_types_default().any,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    isEditable: prop_types_default().bool,
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const GridBooleanCell = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(GridBooleanCellRaw);
const renderBooleanCell = (params)=>{
    if (isAutoGeneratedRow(params.rowNode)) return '';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridBooleanCell, esm_extends_extends({}, params));
};
const GridEditBooleanCell_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const GridEditBooleanCell_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridEditBooleanCell(props) {
    var _rootProps$slotProps;
    const { id: idProp, value, field, className, hasFocus, onValueChange } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridEditBooleanCell_excluded);
    const apiRef = useGridApiContext();
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const id = useId();
    const [valueState, setValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(value);
    const rootProps = useGridRootProps();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = GridEditBooleanCell_useUtilityClasses(ownerState);
    const handleChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    useEnhancedEffect(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("label", esm_extends_extends({
        htmlFor: id,
        className: dist_clsx(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseCheckbox, esm_extends_extends({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseCheckbox))
    }));
}
"production" !== process.env.NODE_ENV && (GridEditBooleanCell.propTypes = {
    api: prop_types_default().object.isRequired,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: prop_types_default().oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired,
    formattedValue: prop_types_default().any,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    isEditable: prop_types_default().bool,
    isProcessingProps: prop_types_default().bool,
    isValidating: prop_types_default().bool,
    onValueChange: prop_types_default().func,
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const renderEditBooleanCell = (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridEditBooleanCell, esm_extends_extends({}, params));
const GridFilterInputBoolean_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "variant",
    "InputLabelProps"
];
const BooleanOperatorContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div')({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    ["& button"]: {
        margin: 'auto 0px 5px 5px'
    }
});
function GridFilterInputBoolean(props) {
    var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2, _rootProps$slotProps3;
    const { item, applyValue, apiRef, focusElementRef, clearButton, tabIndex, label: labelProp, variant = 'standard' } = props, others = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterInputBoolean_excluded);
    const [filterValueState, setFilterValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(item.value || '');
    const rootProps = useGridRootProps();
    const labelId = useId();
    const selectId = useId();
    const baseSelectProps = (null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseSelect) || {};
    const isSelectNative = null != (_baseSelectProps$nati = baseSelectProps.native) ? _baseSelectProps$nati : true;
    const baseSelectOptionProps = (null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseSelectOption) || {};
    const onFilterChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(value);
        applyValue(esm_extends_extends({}, item, {
            value
        }));
    }, [
        applyValue,
        item
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setFilterValueState(item.value || '');
    }, [
        item.value
    ]);
    const label = null != labelProp ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseInputLabel, esm_extends_extends({}, null == (_rootProps$slotProps3 = rootProps.slotProps) ? void 0 : _rootProps$slotProps3.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(rootProps.slots.baseSelect, esm_extends_extends({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: variant,
                        notched: 'outlined' === variant ? true : void 0,
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex
                        }
                    }, others, baseSelectProps, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelectOption, esm_extends_extends({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText('filterValueAny')
                            })),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelectOption, esm_extends_extends({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText('filterValueTrue')
                            })),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelectOption, esm_extends_extends({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText('filterValueFalse')
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridFilterInputBoolean.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }).isRequired,
    applyValue: prop_types_default().func.isRequired,
    clearButton: prop_types_default().node,
    focusElementRef: refType,
    isFilterActive: prop_types_default().bool,
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired
});
const getGridBooleanOperators = ()=>convertLegacyOperators([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const valueAsBoolean = 'true' === filterItem.value;
                return (value)=>Boolean(value) === valueAsBoolean;
            },
            InputComponent: GridFilterInputBoolean
        }
    ]);
function gridBooleanFormatter({ value, api }) {
    return value ? api.getLocaleText('booleanCellTrueLabel') : api.getLocaleText('booleanCellFalseLabel');
}
const stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return;
    }
};
const GRID_BOOLEAN_COL_DEF = esm_extends_extends({}, GRID_STRING_COL_DEF, {
    type: 'boolean',
    align: 'center',
    headerAlign: 'center',
    renderCell: renderBooleanCell,
    renderEditCell: renderEditBooleanCell,
    sortComparator: gridNumberComparator,
    valueFormatter: gridBooleanFormatter,
    filterOperators: getGridBooleanOperators(),
    getApplyQuickFilterFn: void 0,
    getApplyQuickFilterFnV7: void 0,
    aggregable: false,
    pastedValueParser: (value)=>stringToBoolean(value)
});
const GRID_CHECKBOX_SELECTION_FIELD = '__check__';
const GRID_CHECKBOX_SELECTION_COL_DEF = esm_extends_extends({}, GRID_BOOLEAN_COL_DEF, {
    field: GRID_CHECKBOX_SELECTION_FIELD,
    type: 'checkboxSelection',
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: void 0,
    getApplyQuickFilterFnV7: void 0,
    valueGetter: (params)=>{
        const selectionLookup = selectedIdsLookupSelector(params.api.state, params.api.instanceId);
        return void 0 !== selectionLookup[params.id];
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridHeaderCheckbox_GridHeaderCheckbox, esm_extends_extends({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridCellCheckboxRenderer_GridCellCheckboxRenderer, esm_extends_extends({}, params))
});
function sanitizeCellValue(value, delimiterCharacter, shouldAppendQuotes) {
    if ('string' == typeof value) {
        if ([
            delimiterCharacter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>value.includes(delimiter))) {
            if (shouldAppendQuotes) return `"${value.replace(/"/g, '""')}"`;
            return `${value.replace(/"/g, '""')}`;
        }
    }
    return value;
}
const serializeCellValue = (cellParams, options)=>{
    const { delimiterCharacter, ignoreValueFormatter, shouldAppendQuotes } = options;
    let value;
    if (ignoreValueFormatter) {
        var _cellParams$value2;
        const columnType = cellParams.colDef.type;
        if ('number' === columnType) value = String(cellParams.value);
        else if ('date' === columnType || 'dateTime' === columnType) {
            var _cellParams$value;
            value = null == (_cellParams$value = cellParams.value) ? void 0 : _cellParams$value.toISOString();
        } else value = 'function' == typeof (null == (_cellParams$value2 = cellParams.value) ? void 0 : _cellParams$value2.toString) ? cellParams.value.toString() : cellParams.value;
    } else value = cellParams.formattedValue;
    return sanitizeCellValue(value, delimiterCharacter, shouldAppendQuotes);
};
const objectFormattedValueWarning = warning_buildWarning([
    'MUI: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.',
    'You can provide a `valueFormatter` with a string representation to be used.'
]);
class CSVRow {
    constructor(options){
        this.options = void 0;
        this.rowString = '';
        this.isEmpty = true;
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.delimiterCharacter;
        if (null == value) this.rowString += '';
        else if ('function' == typeof this.options.sanitizeCellValue) this.rowString += this.options.sanitizeCellValue(value, this.options.delimiterCharacter, this.options.shouldAppendQuotes);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const serializeRow = ({ id, columns, getCellParams, delimiterCharacter, ignoreValueFormatter, shouldAppendQuotes })=>{
    const row = new CSVRow({
        delimiterCharacter,
        shouldAppendQuotes
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        if ('production' !== process.env.NODE_ENV) {
            if ('[object Object]' === String(cellParams.formattedValue)) objectFormattedValueWarning();
        }
        row.addValue(serializeCellValue(cellParams, {
            delimiterCharacter,
            ignoreValueFormatter,
            shouldAppendQuotes
        }));
    });
    return row.getRowString();
};
function buildCSV(options) {
    const { columns, rowIds, delimiterCharacter, includeHeaders, includeColumnGroupsHeaders, ignoreValueFormatter, apiRef, shouldAppendQuotes } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${serializeRow({
            id,
            columns,
            getCellParams: apiRef.current.getCellParams,
            delimiterCharacter,
            ignoreValueFormatter,
            shouldAppendQuotes
        })}\r\n`, '').trim();
    if (!includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== GRID_CHECKBOX_SELECTION_COL_DEF.field);
    const headerRows = [];
    if (includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.unstable_getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.unstable_getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new CSVRow({
                delimiterCharacter,
                sanitizeCellValue,
                shouldAppendQuotes
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new CSVRow({
        delimiterCharacter,
        sanitizeCellValue,
        shouldAppendQuotes
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}
function writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        writeToClipboardPolyfill(data);
    });
    else writeToClipboardPolyfill(data);
}
function hasNativeSelection(element) {
    var _window$getSelection;
    if (null != (_window$getSelection = window.getSelection()) && _window$getSelection.toString()) return true;
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const useGridClipboard = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = ('object' == typeof ignoreValueFormatterProp ? null == ignoreValueFormatterProp ? void 0 : ignoreValueFormatterProp.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        if (!((event.ctrlKey || event.metaKey) && 'c' === event.key)) return;
        if (hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRows = apiRef.current.getSelectedRows();
        if (selectedRows.size > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false
        });
        else {
            const focusedCell = gridFocusCellSelector(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = serializeCellValue(cellParams, {
                    delimiterCharacter: clipboardCopyCellDelimiter,
                    ignoreValueFormatter,
                    shouldAppendQuotes: false
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    useGridNativeEventListener(apiRef, apiRef.current.rootElementRef, 'keydown', handleCopy);
    useGridApiOptionHandler(apiRef, 'clipboardCopy', props.onClipboardCopy);
};
const columnMenuStateInitializer = (state)=>esm_extends_extends({}, state, {
        columnMenu: {
            open: false
        }
    });
const useGridColumnMenu = (apiRef)=>{
    const logger = useGridLogger(apiRef, 'useGridColumnMenu');
    const showColumnMenu = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>{
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (state.columnMenu.open && state.columnMenu.field === field) return state;
            logger.debug('Opening Column Menu');
            return esm_extends_extends({}, state, {
                columnMenu: {
                    open: true,
                    field
                }
            });
        });
        if (shouldUpdate) {
            apiRef.current.hidePreferences();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const columnMenuState = gridColumnMenuSelector(apiRef.current.state);
        if (columnMenuState.field) {
            const columnLookup = gridColumnLookupSelector(apiRef);
            const columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef);
            const orderedFields = gridColumnFieldsSelector(apiRef);
            let fieldToFocus = columnMenuState.field;
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            if (false === columnVisibilityModel[fieldToFocus]) {
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return false !== columnVisibilityModel[field];
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (!state.columnMenu.open && void 0 === state.columnMenu.field) return state;
            logger.debug('Hiding Column Menu');
            return esm_extends_extends({}, state, {
                columnMenu: esm_extends_extends({}, state.columnMenu, {
                    open: false,
                    field: void 0
                })
            });
        });
        if (shouldUpdate) apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = gridColumnMenuSelector(apiRef.current.state);
        if (columnMenu.open && columnMenu.field === field) hideColumnMenu();
        else showColumnMenu(field);
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu,
        hideColumnMenu,
        toggleColumnMenu
    };
    useGridApiMethod(apiRef, columnMenuApi, 'public');
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnResizeStart', hideColumnMenu);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};
const useFirstRender = (callback)=>{
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};
const useGridRegisterPipeProcessor = (apiRef, group, callback)=>{
    const cleanup = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const id = __WEBPACK_EXTERNAL_MODULE_react__.useRef(`mui-${Math.round(1e9 * Math.random())}`);
    const registerPreProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    useFirstRender(()=>{
        registerPreProcessor();
    });
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};
const useGridRegisterPipeApplier = (apiRef, group, callback)=>{
    const cleanup = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const id = __WEBPACK_EXTERNAL_MODULE_react__.useRef(`mui-${Math.round(1e9 * Math.random())}`);
    const registerPreProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    useFirstRender(()=>{
        registerPreProcessor();
    });
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};
const parseNumericValue = (value)=>{
    if (null == value) return null;
    return Number(value);
};
const getGridNumericQuickFilterFn = tagInternalFilter((value)=>{
    if (null == value || Number.isNaN(value) || '' === value) return null;
    return (columnValue)=>parseNumericValue(columnValue) === parseNumericValue(value);
});
const getGridNumericOperators = ()=>convertLegacyOperators([
        {
            value: '=',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || Number.isNaN(filterItem.value)) return null;
                return (value)=>parseNumericValue(value) === filterItem.value;
            },
            InputComponent: GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || Number.isNaN(filterItem.value)) return null;
                return (value)=>parseNumericValue(value) !== filterItem.value;
            },
            InputComponent: GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (null == value) return false;
                    return parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (null == value) return false;
                    return parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (null == value) return false;
                    return parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (null == value) return false;
                    return parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>(value)=>null == value,
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>(value)=>null != value,
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || 0 === filterItem.value.length) return null;
                return (value)=>null != value && filterItem.value.includes(Number(value));
            },
            InputComponent: GridFilterInputMultipleValue,
            InputComponentProps: {
                type: 'number'
            }
        }
    ]);
const GRID_NUMERIC_COL_DEF = esm_extends_extends({}, GRID_STRING_COL_DEF, {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: gridNumberComparator,
    valueParser: (value)=>'' === value ? null : Number(value),
    valueFormatter: ({ value })=>isNumber(value) ? value.toLocaleString() : value || '',
    filterOperators: getGridNumericOperators(),
    getApplyQuickFilterFn: convertQuickFilterV7ToLegacy(getGridNumericQuickFilterFn),
    getApplyQuickFilterFnV7: getGridNumericQuickFilterFn
});
const GridFilterInputDate_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "disabled"
];
function GridFilterInputDate(props) {
    var _item$value, _rootProps$slotProps;
    const { item, applyValue, type, apiRef, focusElementRef, InputProps, clearButton, tabIndex, disabled } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterInputDate_excluded);
    const filterTimeout = useTimeout();
    const [filterValueState, setFilterValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null != (_item$value = item.value) ? _item$value : '');
    const [applying, setIsApplying] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const id = useId();
    const rootProps = useGridRootProps();
    const onFilterChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            applyValue(esm_extends_extends({}, item, {
                value
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        var _item$value2;
        const itemValue = null != (_item$value2 = item.value) ? _item$value2 : '';
        setFilterValueState(String(itemValue));
    }, [
        item.value
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTextField, esm_extends_extends({
        fullWidth: true,
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: esm_extends_extends({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled
        }, InputProps, {
            inputProps: esm_extends_extends({
                max: 'datetime-local' === type ? '9999-12-31T23:59' : '9999-12-31',
                tabIndex
            }, null == InputProps ? void 0 : InputProps.inputProps)
        })
    }, other, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTextField));
}
"production" !== process.env.NODE_ENV && (GridFilterInputDate.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }).isRequired,
    applyValue: prop_types_default().func.isRequired,
    clearButton: prop_types_default().node,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    isFilterActive: prop_types_default().bool,
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired
});
const dateRegex = /(\d+)-(\d+)-(\d+)/;
const dateTimeRegex = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const [year, month, day, hour, minute] = filterItem.value.match(showTime ? dateTimeRegex : dateRegex).slice(1).map(Number);
    const time = new Date(year, month - 1, day, hour || 0, minute || 0).getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        const dateCopy = new Date(value);
        const timeToCompare = dateCopy.setHours(showTime ? value.getHours() : 0, showTime ? value.getMinutes() : 0, 0, 0);
        return compareFn(timeToCompare, time);
    };
}
const getGridDateOperators = (showTime)=>convertLegacyOperators([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime),
            InputComponent: GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFnV7: (filterItem)=>buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime),
            InputComponent: GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFnV7: (filterItem)=>buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime),
            InputComponent: GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFnV7: (filterItem)=>buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime),
            InputComponent: GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFnV7: (filterItem)=>buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime),
            InputComponent: GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFnV7: (filterItem)=>buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime),
            InputComponent: GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>(value)=>null == value,
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>(value)=>null != value,
            requiresFilterValue: false
        }
    ]);
const GridEditDateCell_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const StyledInputBase = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputBase_7d3cd5a3__["default"])({
    fontSize: 'inherit'
});
const GridEditDateCell_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridEditDateCell(props) {
    const { id, value: valueProp, field, colDef, hasFocus, inputProps, onValueChange } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridEditDateCell_excluded);
    const isDateTime = 'dateTime' === colDef.type;
    const apiRef = useGridApiContext();
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const valueTransformed = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        let parsedDate;
        parsedDate = null == valueProp ? null : valueProp instanceof Date ? valueProp : new Date((null != valueProp ? valueProp : '').toString());
        let formattedDate;
        if (null == parsedDate || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - 60 * parsedDate.getTimezoneOffset() * 1000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(valueTransformed);
    const rootProps = useGridRootProps();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = GridEditDateCell_useUtilityClasses(ownerState);
    const parseValueToDate = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((value)=>{
        if ('' === value) return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id,
            field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setValueState((state)=>{
            var _valueTransformed$par, _state$parsed;
            if (valueTransformed.parsed !== state.parsed && (null == (_valueTransformed$par = valueTransformed.parsed) ? void 0 : _valueTransformed$par.getTime()) !== (null == (_state$parsed = state.parsed) ? void 0 : _state$parsed.getTime())) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    useEnhancedEffect(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledInputBase, esm_extends_extends({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        inputProps: esm_extends_extends({
            max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
"production" !== process.env.NODE_ENV && (GridEditDateCell.propTypes = {
    api: prop_types_default().object.isRequired,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: prop_types_default().oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired,
    formattedValue: prop_types_default().any,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    isEditable: prop_types_default().bool,
    isProcessingProps: prop_types_default().bool,
    isValidating: prop_types_default().bool,
    onValueChange: prop_types_default().func,
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const renderEditDateCell = (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridEditDateCell, esm_extends_extends({}, params));
function throwIfNotDateObject({ value, columnType, rowId, field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
function gridDateFormatter({ value, field, id }) {
    if (!value) return '';
    throwIfNotDateObject({
        value,
        columnType: 'date',
        rowId: id,
        field
    });
    return value.toLocaleDateString();
}
function gridDateTimeFormatter({ value, field, id }) {
    if (!value) return '';
    throwIfNotDateObject({
        value,
        columnType: 'dateTime',
        rowId: id,
        field
    });
    return value.toLocaleString();
}
const GRID_DATE_COL_DEF = esm_extends_extends({}, GRID_STRING_COL_DEF, {
    type: 'date',
    sortComparator: gridDateComparator,
    valueFormatter: gridDateFormatter,
    filterOperators: getGridDateOperators(),
    renderEditCell: renderEditDateCell,
    pastedValueParser: (value)=>new Date(value)
});
const GRID_DATETIME_COL_DEF = esm_extends_extends({}, GRID_STRING_COL_DEF, {
    type: 'dateTime',
    sortComparator: gridDateComparator,
    valueFormatter: gridDateTimeFormatter,
    filterOperators: getGridDateOperators(true),
    renderEditCell: renderEditDateCell,
    pastedValueParser: (value)=>new Date(value)
});
var gridEditCellParams_GridCellEditStartReasons = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}(gridEditCellParams_GridCellEditStartReasons || {});
var gridEditCellParams_GridCellEditStopReasons = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}(gridEditCellParams_GridCellEditStopReasons || {});
var gridEditRowModel_GridEditModes = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}(gridEditRowModel_GridEditModes || {});
var gridEditRowModel_GridCellModes = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}(gridEditRowModel_GridCellModes || {});
var gridEditRowModel_GridRowModes = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}(gridEditRowModel_GridRowModes || {});
function isSingleSelectColDef(colDef) {
    return (null == colDef ? void 0 : colDef.type) === 'singleSelect';
}
function getValueFromValueOptions(value, valueOptions, getOptionValue) {
    if (void 0 === valueOptions) return;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}
const GridEditSingleSelectCell_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen",
    "getOptionLabel",
    "getOptionValue"
], GridEditSingleSelectCell_excluded2 = [
    "MenuProps"
];
function GridEditSingleSelectCell_isKeyboardEvent(event) {
    return !!event.key;
}
function GridEditSingleSelectCell(props) {
    var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2;
    const rootProps = useGridRootProps();
    const { id, value: valueProp, field, row, colDef, hasFocus, error, onValueChange, initialOpen = rootProps.editMode === gridEditRowModel_GridEditModes.Cell, getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridEditSingleSelectCell_excluded);
    const apiRef = useGridApiContext();
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const [open, setOpen] = __WEBPACK_EXTERNAL_MODULE_react__.useState(initialOpen);
    const baseSelectProps = (null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseSelect) || {};
    const isSelectNative = null != (_baseSelectProps$nati = baseSelectProps.native) ? _baseSelectProps$nati : false;
    const _ref = (null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseSelect) || {}, { MenuProps } = _ref, otherBaseSelectProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, GridEditSingleSelectCell_excluded2);
    useEnhancedEffect(()=>{
        if (hasFocus) {
            var _inputRef$current;
            null == (_inputRef$current = inputRef.current) || _inputRef$current.focus();
        }
    }, [
        hasFocus
    ]);
    if (!isSingleSelectColDef(colDef)) return null;
    let valueOptions;
    valueOptions = 'function' == typeof (null == colDef ? void 0 : colDef.valueOptions) ? null == colDef ? void 0 : colDef.valueOptions({
        id,
        row,
        field
    }) : null == colDef ? void 0 : colDef.valueOptions;
    if (!valueOptions) return null;
    const getOptionValue = getOptionValueProp || colDef.getOptionValue;
    const getOptionLabel = getOptionLabelProp || colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!isSingleSelectColDef(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        const formattedTargetValue = getValueFromValueOptions(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === gridEditRowModel_GridEditModes.Row) return void setOpen(false);
        if ('backdropClick' === reason || isEscapeKey(event.key)) {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', esm_extends_extends({}, params, {
                reason: isEscapeKey(event.key) ? gridEditCellParams_GridCellEditStopReasons.escapeKeyDown : gridEditCellParams_GridCellEditStopReasons.cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if (GridEditSingleSelectCell_isKeyboardEvent(event) && 'Enter' === event.key) return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelect, esm_extends_extends({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: esm_extends_extends({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map((valueOption)=>{
            var _rootProps$slotProps3;
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(rootProps.slots.baseSelectOption, esm_extends_extends({}, (null == (_rootProps$slotProps3 = rootProps.slotProps) ? void 0 : _rootProps$slotProps3.baseSelectOption) || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
"production" !== process.env.NODE_ENV && (GridEditSingleSelectCell.propTypes = {
    api: prop_types_default().object.isRequired,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: prop_types_default().oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired,
    formattedValue: prop_types_default().any,
    getOptionLabel: prop_types_default().func,
    getOptionValue: prop_types_default().func,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    initialOpen: prop_types_default().bool,
    isEditable: prop_types_default().bool,
    isProcessingProps: prop_types_default().bool,
    isValidating: prop_types_default().bool,
    onValueChange: prop_types_default().func,
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const renderEditSingleSelectCell = (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridEditSingleSelectCell, esm_extends_extends({}, params));
const GridFilterInputSingleSelect_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "getOptionLabel",
    "getOptionValue",
    "placeholder",
    "tabIndex",
    "label",
    "variant",
    "isFilterActive",
    "clearButton",
    "InputLabelProps"
];
const renderSingleSelectOptions = ({ column: { valueOptions, field }, OptionComponent, getOptionLabel, getOptionValue, isSelectNative, baseSelectOptionProps })=>{
    const iterableColumnValues = 'function' == typeof valueOptions ? [
        '',
        ...valueOptions({
            field
        })
    ] : [
        '',
        ...valueOptions || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        const label = getOptionLabel(option);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(OptionComponent, esm_extends_extends({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
const SingleSelectOperatorContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div')({
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    ["& button"]: {
        margin: 'auto 0px 5px 5px'
    }
});
function GridFilterInputSingleSelect(props) {
    var _item$value, _rootProps$slotProps$, _rootProps$slotProps, _resolvedColumn, _resolvedColumn2, _rootProps$slotProps2, _rootProps$slotProps3, _rootProps$slotProps4;
    const { item, applyValue, type, apiRef, focusElementRef, getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp, placeholder, tabIndex, label: labelProp, variant = 'standard', clearButton } = props, others = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterInputSingleSelect_excluded);
    const [filterValueState, setFilterValueState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null != (_item$value = item.value) ? _item$value : '');
    const id = useId();
    const labelId = useId();
    const rootProps = useGridRootProps();
    const isSelectNative = null != (_rootProps$slotProps$ = null == (_rootProps$slotProps = rootProps.slotProps) || null == (_rootProps$slotProps = _rootProps$slotProps.baseSelect) ? void 0 : _rootProps$slotProps.native) ? _rootProps$slotProps$ : true;
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if (isSingleSelectColDef(column)) resolvedColumn = column;
    }
    const getOptionValue = getOptionValueProp || (null == (_resolvedColumn = resolvedColumn) ? void 0 : _resolvedColumn.getOptionValue);
    const getOptionLabel = getOptionLabelProp || (null == (_resolvedColumn2 = resolvedColumn) ? void 0 : _resolvedColumn2.getOptionLabel);
    const currentValueOptions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!resolvedColumn) return;
        return 'function' == typeof resolvedColumn.valueOptions ? resolvedColumn.valueOptions({
            field: resolvedColumn.field
        }) : resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const onFilterChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        let value = event.target.value;
        value = getValueFromValueOptions(value, currentValueOptions, getOptionValue);
        setFilterValueState(String(value));
        applyValue(esm_extends_extends({}, item, {
            value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        var _itemValue;
        let itemValue;
        if (void 0 !== currentValueOptions) {
            itemValue = getValueFromValueOptions(item.value, currentValueOptions, getOptionValue);
            if (itemValue !== item.value) return void applyValue(esm_extends_extends({}, item, {
                value: itemValue
            }));
        } else itemValue = item.value;
        itemValue = null != (_itemValue = itemValue) ? _itemValue : '';
        setFilterValueState(String(itemValue));
    }, [
        item,
        currentValueOptions,
        applyValue,
        getOptionValue
    ]);
    if (!isSingleSelectColDef(resolvedColumn)) return null;
    if (!isSingleSelectColDef(resolvedColumn)) return null;
    const label = null != labelProp ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SingleSelectOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(rootProps.slots.baseFormControl, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseInputLabel, esm_extends_extends({}, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseInputLabel, {
                        id: labelId,
                        htmlFor: id,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelect, esm_extends_extends({
                        id: id,
                        label: label,
                        labelId: labelId,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: variant,
                        type: type || 'text',
                        inputProps: {
                            tabIndex,
                            ref: focusElementRef,
                            placeholder: null != placeholder ? placeholder : apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                        },
                        native: isSelectNative,
                        notched: 'outlined' === variant ? true : void 0
                    }, others, null == (_rootProps$slotProps3 = rootProps.slotProps) ? void 0 : _rootProps$slotProps3.baseSelect, {
                        children: renderSingleSelectOptions({
                            column: resolvedColumn,
                            OptionComponent: rootProps.slots.baseSelectOption,
                            getOptionLabel,
                            getOptionValue,
                            isSelectNative,
                            baseSelectOptionProps: null == (_rootProps$slotProps4 = rootProps.slotProps) ? void 0 : _rootProps$slotProps4.baseSelectOption
                        })
                    }))
                ]
            }),
            clearButton
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridFilterInputSingleSelect.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }).isRequired,
    applyValue: prop_types_default().func.isRequired,
    clearButton: prop_types_default().node,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    getOptionLabel: prop_types_default().func,
    getOptionValue: prop_types_default().func,
    isFilterActive: prop_types_default().bool,
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired
});
const GridFilterInputMultipleSingleSelect_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant",
    "getOptionLabel",
    "getOptionValue"
];
const filter = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__.createFilterOptions)();
function GridFilterInputMultipleSingleSelect(props) {
    var _resolvedColumn, _resolvedColumn2;
    const { item, applyValue, apiRef, focusElementRef, color, error, helperText, size, variant = 'standard', getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterInputMultipleSingleSelect_excluded);
    const TextFieldProps = {
        color,
        error,
        helperText,
        size,
        variant
    };
    const id = useId();
    const rootProps = useGridRootProps();
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if (isSingleSelectColDef(column)) resolvedColumn = column;
    }
    const getOptionValue = getOptionValueProp || (null == (_resolvedColumn = resolvedColumn) ? void 0 : _resolvedColumn.getOptionValue);
    const getOptionLabel = getOptionLabelProp || (null == (_resolvedColumn2 = resolvedColumn) ? void 0 : _resolvedColumn2.getOptionLabel);
    const isOptionEqualToValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        var _resolvedColumn3;
        if (!(null != (_resolvedColumn3 = resolvedColumn) && _resolvedColumn3.valueOptions)) return [];
        if ('function' == typeof resolvedColumn.valueOptions) return resolvedColumn.valueOptions({
            field: resolvedColumn.field
        });
        return resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const resolvedFormattedValueOptions = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>null == resolvedValueOptions ? void 0 : resolvedValueOptions.map(getOptionValue), [
        resolvedValueOptions,
        getOptionValue
    ]);
    const filteredValues = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        if (void 0 !== resolvedValueOptions) {
            const itemValueIndexes = item.value.map((element)=>null == resolvedFormattedValueOptions ? void 0 : resolvedFormattedValueOptions.findIndex((formattedOption)=>formattedOption === element));
            return itemValueIndexes.filter((index)=>index >= 0).map((index)=>resolvedValueOptions[index]);
        }
        return item.value;
    }, [
        item.value,
        resolvedValueOptions,
        resolvedFormattedValueOptions
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!Array.isArray(item.value) || filteredValues.length !== item.value.length) applyValue(esm_extends_extends({}, item, {
            value: filteredValues.map(getOptionValue)
        }));
    }, [
        item,
        filteredValues,
        applyValue,
        getOptionValue
    ]);
    const handleChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event, value)=>{
        applyValue(esm_extends_extends({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__["default"], esm_extends_extends({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: filter,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseChip, esm_extends_extends({
                    variant: "outlined",
                    size: "small",
                    label: getOptionLabel(option)
                }, getTagProps({
                    index
                })))),
        renderInput: (params)=>{
            var _rootProps$slotProps;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTextField, esm_extends_extends({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: esm_extends_extends({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTextField));
        }
    }, other));
}
"production" !== process.env.NODE_ENV && (GridFilterInputMultipleSingleSelect.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }).isRequired,
    applyValue: prop_types_default().func.isRequired,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    getOptionLabel: prop_types_default().func,
    getOptionValue: prop_types_default().func,
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired,
    type: prop_types_default().oneOf([
        'singleSelect'
    ])
});
const parseObjectValue = (value)=>{
    if (null == value || !utils_isObject(value)) return value;
    return value.value;
};
const getGridSingleSelectOperators = ()=>convertLegacyOperators([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || '' === filterItem.value) return null;
                return (value)=>parseObjectValue(value) === parseObjectValue(filterItem.value);
            },
            InputComponent: GridFilterInputSingleSelect
        },
        {
            value: 'not',
            getApplyFilterFnV7: (filterItem)=>{
                if (null == filterItem.value || '' === filterItem.value) return null;
                return (value)=>parseObjectValue(value) !== parseObjectValue(filterItem.value);
            },
            InputComponent: GridFilterInputSingleSelect
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || 0 === filterItem.value.length) return null;
                const filterItemValues = filterItem.value.map(parseObjectValue);
                return (value)=>filterItemValues.includes(parseObjectValue(value));
            },
            InputComponent: GridFilterInputMultipleSingleSelect
        }
    ]);
const isArrayOfObjects = (options)=>'object' == typeof options[0];
const defaultGetOptionValue = (value)=>utils_isObject(value) ? value.value : value;
const defaultGetOptionLabel = (value)=>utils_isObject(value) ? value.label : String(value);
const GRID_SINGLE_SELECT_COL_DEF = esm_extends_extends({}, GRID_STRING_COL_DEF, {
    type: 'singleSelect',
    getOptionLabel: defaultGetOptionLabel,
    getOptionValue: defaultGetOptionValue,
    valueFormatter (params) {
        const { id, field, value, api } = params;
        const colDef = params.api.getColumn(field);
        if (!isSingleSelectColDef(colDef)) return '';
        let valueOptions;
        valueOptions = 'function' == typeof colDef.valueOptions ? colDef.valueOptions({
            id,
            row: id ? api.getRow(id) : null,
            field
        }) : colDef.valueOptions;
        if (null == value) return '';
        if (!valueOptions) return value;
        if (!isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: renderEditSingleSelectCell,
    filterOperators: getGridSingleSelectOperators(),
    pastedValueParser: (value, params)=>{
        const colDef = params.colDef;
        const colDefValueOptions = colDef.valueOptions;
        const valueOptions = 'function' == typeof colDefValueOptions ? colDefValueOptions({
            field: colDef.field
        }) : colDefValueOptions || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
    }
});
function HTMLElementType(props, propName, componentName, location, propFullName) {
    if ('production' === process.env.NODE_ENV) return null;
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (null == propValue) return null;
    if (propValue && 1 !== propValue.nodeType) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an HTMLElement.`);
    return null;
}
const GridMenu_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const GridMenu_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridMenuRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Popper_24cb866b__["default"], {
    name: 'MuiDataGrid',
    slot: 'Menu',
    overridesResolver: (_, styles)=>styles.menu
})(({ theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${gridClasses_gridClasses.menuList}`]: {
            outline: 0
        }
    }));
const transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function GridMenu(props) {
    var _rootProps$slotProps;
    const { open, target, onClose, children, position, className, onExited } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridMenu_excluded);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const classes = GridMenu_useUtilityClasses(rootProps);
    const savedFocusRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    useEnhancedEffect(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            var _savedFocusRef$curren, _savedFocusRef$curren2;
            null == (_savedFocusRef$curren = savedFocusRef.current) || null == (_savedFocusRef$curren2 = _savedFocusRef$curren.focus) || _savedFocusRef$curren2.call(_savedFocusRef$curren);
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || null != target && target.contains(event.target))) return;
        onClose(event);
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridMenuRoot, esm_extends_extends({
        as: rootProps.slots.basePopper,
        className: dist_clsx(className, classes.root),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.basePopper, {
        children: ({ TransitionProps, placement })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ClickAwayListener_a7328dbe__["default"], {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grow_8b326669__["default"], esm_extends_extends({}, TransitionProps, {
                    style: {
                        transformOrigin: transformOrigin[placement]
                    },
                    onExited: handleExited(null == TransitionProps ? void 0 : TransitionProps.onExited),
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__["default"], {
                        children: children
                    })
                }))
            })
    }));
}
"production" !== process.env.NODE_ENV && (GridMenu.propTypes = {
    children: prop_types_default().node,
    onClose: prop_types_default().func.isRequired,
    onExited: prop_types_default().func,
    open: prop_types_default().bool.isRequired,
    position: prop_types_default().oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    target: HTMLElementType
});
const GridActionsCell_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const hasActions = (colDef)=>'function' == typeof colDef.getActions;
function GridActionsCell(props) {
    var _rootProps$slotProps;
    const { colDef, id, hasFocus, tabIndex, position = 'bottom-end', focusElementRef } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridActionsCell_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = __WEBPACK_EXTERNAL_MODULE_react__.useState(-1);
    const [open, setOpen] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const apiRef = useGridApiContext();
    const rootRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const buttonRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const ignoreCallToFocus = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const touchRippleRefs = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const menuId = useId();
    const buttonId = useId();
    const rootProps = useGridRootProps();
    if (!hasActions(colDef)) throw new Error('MUI: Missing the `getActions` property in the `GridColDef`.');
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            null == ref || ref.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                if (!ignoreCallToFocus.current) {
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            var _options;
            if (index < 0 || index > options.length) return index;
            const rtlMod = 'rtl' === theme.direction ? -1 : 1;
            const indexMod = ('left' === direction ? -1 : 1) * rtlMod;
            return null != (_options = options[index + indexMod]) && _options.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if ('ArrowRight' === event.key) newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if ('ArrowLeft' === event.key) newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return;
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault();
            event.stopPropagation();
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if ('Tab' === event.key) event.preventDefault();
        if ([
            'Tab',
            'Escape'
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", esm_extends_extends({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: gridClasses_gridClasses.actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseIconButton, esm_extends_extends({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : void 0,
                role: "menuitem",
                size: "small",
                onClick: showMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseIconButton, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridMenu, {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuList_abce8441__["default"], {
                    id: menuId,
                    className: gridClasses_gridClasses.menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
"production" !== process.env.NODE_ENV && (GridActionsCell.propTypes = {
    api: prop_types_default().object,
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]).isRequired,
    colDef: prop_types_default().object.isRequired,
    field: prop_types_default().string.isRequired,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().shape({
            current: prop_types_default().shape({
                focus: prop_types_default().func.isRequired
            })
        })
    ]),
    formattedValue: prop_types_default().any,
    hasFocus: prop_types_default().bool.isRequired,
    id: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    isEditable: prop_types_default().bool,
    position: prop_types_default().oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    row: prop_types_default().any.isRequired,
    rowNode: prop_types_default().object.isRequired,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired,
    value: prop_types_default().any
});
const renderActionsCell = (params)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridActionsCell, esm_extends_extends({}, params));
const GRID_ACTIONS_COLUMN_TYPE = 'actions';
const GRID_ACTIONS_COL_DEF = esm_extends_extends({}, GRID_STRING_COL_DEF, {
    sortable: false,
    filterable: false,
    aggregable: false,
    width: 100,
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: renderActionsCell,
    getApplyQuickFilterFn: void 0,
    getApplyQuickFilterFnV7: void 0
});
const DEFAULT_GRID_COL_TYPE_KEY = '__default__';
const getGridDefaultColumnTypes = ()=>{
    const nativeColumnTypes = {
        string: GRID_STRING_COL_DEF,
        number: GRID_NUMERIC_COL_DEF,
        date: GRID_DATE_COL_DEF,
        dateTime: GRID_DATETIME_COL_DEF,
        boolean: GRID_BOOLEAN_COL_DEF,
        singleSelect: GRID_SINGLE_SELECT_COL_DEF,
        [GRID_ACTIONS_COLUMN_TYPE]: GRID_ACTIONS_COL_DEF,
        [DEFAULT_GRID_COL_TYPE_KEY]: GRID_STRING_COL_DEF
    };
    return nativeColumnTypes;
};
const COLUMNS_DIMENSION_PROPERTIES = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
function computeFlexColumnsWidth({ initialFreeSpace, totalFlexUnits, flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && true !== value.frozen) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    function loopOverFlexItems() {
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && true === flexColumnsLookup.all[column.field].frozen) continue;
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth,
                flex: column.flex
            };
        }
        if (totalViolation < 0) Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else flexColumns.forEach(({ field })=>{
            flexColumnsLookup.freeze(field);
        });
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const hydrateColumnsWidth = (rawState, viewportInnerWidth)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    rawState.orderedFields.forEach((columnField)=>{
        const newColumn = esm_extends_extends({}, rawState.lookup[columnField]);
        if (false === rawState.columnVisibilityModel[columnField]) newColumn.computedWidth = 0;
        else {
            let computedWidth;
            if (newColumn.flex && newColumn.flex > 0) {
                totalFlexUnits += newColumn.flex;
                computedWidth = 0;
                flexColumns.push(newColumn);
            } else computedWidth = clamp(newColumn.width || GRID_STRING_COL_DEF.width, newColumn.minWidth || GRID_STRING_COL_DEF.minWidth, newColumn.maxWidth || GRID_STRING_COL_DEF.maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
            newColumn.computedWidth = computedWidth;
        }
        columnsLookup[columnField] = newColumn;
    });
    const initialFreeSpace = Math.max(viewportInnerWidth - widthAllocatedBeforeFlex, 0);
    if (totalFlexUnits > 0 && viewportInnerWidth > 0) {
        const computedColumnWidths = computeFlexColumnsWidth({
            initialFreeSpace,
            totalFlexUnits,
            flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return esm_extends_extends({}, rawState, {
        lookup: columnsLookup
    });
};
const applyInitialState = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields = [], dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (0 === columnsWithUpdatedDimensions.length && 0 === orderedFields.length) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = 0 === cleanOrderedFields.length ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = esm_extends_extends({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = esm_extends_extends({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = -1 === value ? 1 / 0 : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = esm_extends_extends({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function getDefaultColTypeDef(columnTypes, type) {
    let colDef = columnTypes[DEFAULT_GRID_COL_TYPE_KEY];
    if (type && columnTypes[type]) colDef = columnTypes[type];
    return colDef;
}
const createColumnsState = ({ apiRef, columnsToUpsert, initialState, columnTypes, columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef), keepOnlyColumnsToUpsert = false })=>{
    var _apiRef$current$getRo, _apiRef$current$getRo2, _apiRef$current;
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel
    };
    else {
        const currentState = gridColumnsStateSelector(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: esm_extends_extends({}, currentState.lookup),
            columnVisibilityModel
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key)=>esm_extends_extends({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (null == existingState) {
            existingState = esm_extends_extends({}, getDefaultColTypeDef(columnTypes, newColumn.type), {
                field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        if (existingState && existingState.type !== newColumn.type) existingState = esm_extends_extends({}, getDefaultColTypeDef(columnTypes, newColumn.type), {
            field
        });
        let hasBeenResized = existingState.hasBeenResized;
        COLUMNS_DIMENSION_PROPERTIES.forEach((key)=>{
            if (void 0 !== newColumn[key]) {
                hasBeenResized = true;
                if (-1 === newColumn[key]) newColumn[key] = 1 / 0;
            }
        });
        columnsState.lookup[field] = esm_extends_extends({}, existingState, newColumn, {
            hasBeenResized
        });
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = applyInitialState(columnsStateWithPreProcessing, initialState);
    return hydrateColumnsWidth(columnsStateWithPortableColumns, null != (_apiRef$current$getRo = null == (_apiRef$current$getRo2 = (_apiRef$current = apiRef.current).getRootDimensions) || null == (_apiRef$current$getRo2 = _apiRef$current$getRo2.call(_apiRef$current)) ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) ? _apiRef$current$getRo : 0);
};
const mergeColumnsState = (columnsState)=>(state)=>esm_extends_extends({}, state, {
            columns: columnsState
        });
function getFirstNonSpannedColumnToRender({ firstColumnToRender, apiRef, firstRowToRender, lastRowToRender, visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    for(let i = firstRowToRender; i < lastRowToRender; i += 1){
        const row = visibleRows[i];
        if (row) {
            const rowId = visibleRows[i].id;
            const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
            if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
        }
    }
    return firstNonSpannedColumnToRender;
}
function getFirstColumnIndexToRender({ firstColumnIndex, minColumnIndex, columnBuffer, firstRowToRender, lastRowToRender, apiRef, visibleRows }) {
    const initialFirstColumnToRender = Math.max(firstColumnIndex - columnBuffer, minColumnIndex);
    const firstColumnToRender = getFirstNonSpannedColumnToRender({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef,
        firstRowToRender,
        lastRowToRender,
        visibleRows
    });
    return firstColumnToRender;
}
function getTotalHeaderHeight(apiRef, headerHeight) {
    const densityFactor = gridDensityFactorSelector(apiRef);
    const maxDepth = gridColumnGroupsHeaderMaxDepthSelector(apiRef);
    return Math.floor(headerHeight * densityFactor) * ((null != maxDepth ? maxDepth : 0) + 1);
}
var gridPreferencePanelsValue_GridPreferencePanelsValue = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    return GridPreferencePanelsValue;
}(gridPreferencePanelsValue_GridPreferencePanelsValue || {});
const defaultColumnTypes = getGridDefaultColumnTypes();
const columnsStateInitializer = (state, props, apiRef)=>{
    var _props$initialState, _ref, _props$columnVisibili, _props$initialState2;
    const columnsState = createColumnsState({
        apiRef,
        columnTypes: defaultColumnTypes,
        columnsToUpsert: props.columns,
        initialState: null == (_props$initialState = props.initialState) ? void 0 : _props$initialState.columns,
        columnVisibilityModel: null != (_ref = null != (_props$columnVisibili = props.columnVisibilityModel) ? _props$columnVisibili : null == (_props$initialState2 = props.initialState) || null == (_props$initialState2 = _props$initialState2.columns) ? void 0 : _props$initialState2.columnVisibilityModel) ? _ref : {},
        keepOnlyColumnsToUpsert: true
    });
    return esm_extends_extends({}, state, {
        columns: columnsState
    });
};
function useGridColumns(apiRef, props) {
    var _props$initialState4, _props$slotProps2;
    const logger = useGridLogger(apiRef, 'useGridColumns');
    const columnTypes = defaultColumnTypes;
    const previousColumnsProp = __WEBPACK_EXTERNAL_MODULE_react__.useRef(props.columns);
    const previousColumnTypesProp = __WEBPACK_EXTERNAL_MODULE_react__.useRef(columnTypes);
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: gridColumnVisibilityModelSelector,
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState(mergeColumnsState(columnsState));
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    const getColumn = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>gridColumnLookupSelector(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>gridColumnDefinitionsSelector(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>gridVisibleColumnDefinitionsSelector(apiRef), [
        apiRef
    ]);
    const getColumnIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? gridVisibleColumnDefinitionsSelector(apiRef) : gridColumnDefinitionsSelector(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>{
        const index = getColumnIndex(field);
        return gridColumnPositionsSelector(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((model)=>{
        const currentModel = gridColumnVisibilityModelSelector(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                    columns: createColumnsState({
                        apiRef,
                        columnTypes,
                        columnsToUpsert: [],
                        initialState: void 0,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        columnTypes
    ]);
    const updateColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columns)=>{
        const columnsState = createColumnsState({
            apiRef,
            columnTypes,
            columnsToUpsert: columns,
            initialState: void 0,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState,
        columnTypes
    ]);
    const setColumnVisibility = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, isVisible)=>{
        var _columnVisibilityMode;
        const columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef);
        const isCurrentlyVisible = null != (_columnVisibilityMode = columnVisibilityModel[field]) ? _columnVisibilityMode : true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = esm_extends_extends({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>{
        const allColumns = gridColumnFieldsSelector(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, targetIndexPosition)=>{
        const allColumns = gridColumnFieldsSelector(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState(esm_extends_extends({}, gridColumnsStateSelector(apiRef.current.state), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, width)=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = gridColumnsStateSelector(apiRef.current.state);
        const column = columnsState.lookup[field];
        const newColumn = esm_extends_extends({}, column, {
            width,
            hasBeenResized: true
        });
        setGridColumnsState(hydrateColumnsWidth(esm_extends_extends({}, columnsState, {
            lookup: esm_extends_extends({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), null != (_apiRef$current$getRo = null == (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) ? _apiRef$current$getRo : 0));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn,
        getAllColumns,
        getColumnIndex,
        getColumnPosition,
        getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns,
        updateColumns,
        setColumnVisibilityModel,
        setColumnVisibility,
        setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex
    };
    useGridApiMethod(apiRef, columnApi, 'public');
    useGridApiMethod(apiRef, columnReorderApi, props.signature === useGridApiEventHandler_GridSignature.DataGrid ? 'private' : 'public');
    const stateExportPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((prevState, context)=>{
        var _props$initialState$c, _props$initialState3;
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = gridColumnVisibilityModelSelector(apiRef);
        const shouldExportColumnVisibilityModel = !context.exportOnlyDirtyModels || null != props.columnVisibilityModel || Object.keys(null != (_props$initialState$c = null == (_props$initialState3 = props.initialState) || null == (_props$initialState3 = _props$initialState3.columns) ? void 0 : _props$initialState3.columnVisibilityModel) ? _props$initialState$c : {}).length > 0 || Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = gridColumnFieldsSelector(apiRef);
        const columns = gridColumnDefinitionsSelector(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                COLUMNS_DIMENSION_PROPERTIES.forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === 1 / 0) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return esm_extends_extends({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        null == (_props$initialState4 = props.initialState) ? void 0 : _props$initialState4.columns
    ]);
    const stateRestorePreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, context)=>{
        var _context$stateToResto;
        const columnVisibilityModelToImport = null == (_context$stateToResto = context.stateToRestore.columns) ? void 0 : _context$stateToResto.columnVisibilityModel;
        const initialState = context.stateToRestore.columns;
        if (null == columnVisibilityModelToImport && null == initialState) return params;
        const columnsState = createColumnsState({
            apiRef,
            columnTypes,
            columnsToUpsert: [],
            initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState(mergeColumnsState(columnsState));
        if (null != initialState) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef,
        columnTypes
    ]);
    const preferencePanelPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((initialValue, value)=>{
        if (value === gridPreferencePanelsValue_GridPreferencePanelsValue.columns) {
            var _props$slotProps;
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ColumnsPanel, esm_extends_extends({}, null == (_props$slotProps = props.slotProps) ? void 0 : _props$slotProps.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        null == (_props$slotProps2 = props.slotProps) ? void 0 : _props$slotProps2.columnsPanel
    ]);
    const addColumnMenuItems = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columnMenuItems)=>{
        if (props.disableColumnSelector) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector
    ]);
    useGridRegisterPipeProcessor(apiRef, 'columnMenu', addColumnMenuItems);
    useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    const prevInnerWidth = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            setGridColumnsState(hydrateColumnsWidth(gridColumnsStateSelector(apiRef.current.state), viewportInnerSize.width));
        }
    };
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    const hydrateColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        logger.info("Columns pipe processing have changed, regenerating the columns");
        const columnsState = createColumnsState({
            apiRef,
            columnTypes,
            columnsToUpsert: [],
            initialState: void 0,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        columnTypes
    ]);
    useGridRegisterPipeApplier(apiRef, 'hydrateColumns', hydrateColumns);
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns && previousColumnTypesProp.current === columnTypes) return;
        const columnsState = createColumnsState({
            apiRef,
            columnTypes,
            initialState: void 0,
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        previousColumnTypesProp.current = columnTypes;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        columnTypes
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (void 0 !== props.columnVisibilityModel) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
const COMPACT_DENSITY_FACTOR = 0.7;
const COMFORTABLE_DENSITY_FACTOR = 1.3;
const DENSITY_FACTORS = {
    compact: COMPACT_DENSITY_FACTOR,
    comfortable: COMFORTABLE_DENSITY_FACTOR,
    standard: 1
};
const densityStateInitializer = (state, props)=>esm_extends_extends({}, state, {
        density: {
            value: props.density,
            factor: DENSITY_FACTORS[props.density]
        }
    });
const useGridDensity = (apiRef, props)=>{
    const logger = useGridLogger(apiRef, 'useDensity');
    const setDensity = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((newDensity)=>{
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>{
            const currentDensityState = gridDensitySelector(state);
            const newDensityState = {
                value: newDensity,
                factor: DENSITY_FACTORS[newDensity]
            };
            if (isDeepEqual(currentDensityState, newDensityState)) return state;
            return esm_extends_extends({}, state, {
                density: newDensityState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        apiRef
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
    const densityApi = {
        setDensity
    };
    useGridApiMethod(apiRef, densityApi, 'public');
};
function exportAs(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    if ('download' in HTMLAnchorElement.prototype) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        a.click();
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI: exportAs not supported');
}
const getColumnsToExport = ({ apiRef, options })=>{
    const columns = gridColumnDefinitionsSelector(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : gridVisibleColumnDefinitionsSelector(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const defaultGetRowsToExport = ({ apiRef })=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
    const rowTree = gridRowTreeSelector(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>'footer' !== rowTree[id].type);
    const pinnedRows = gridPinnedRowsSelector(apiRef);
    const topPinnedRowsIds = (null == pinnedRows || null == (_pinnedRows$top = pinnedRows.top) ? void 0 : _pinnedRows$top.map((row)=>row.id)) || [];
    const bottomPinnedRowsIds = (null == pinnedRows || null == (_pinnedRows$bottom = pinnedRows.bottom) ? void 0 : _pinnedRows$bottom.map((row)=>row.id)) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};
const GridToolbarExportContainer_excluded = [
    "children",
    "onClick"
];
const GridToolbarExportContainer_GridToolbarExportContainer = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$slotProps;
    const { children, onClick } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridToolbarExportContainer_excluded);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const exportButtonId = useId();
    const exportMenuId = useId();
    const [open, setOpen] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const buttonRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        null == onClick || onClick(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if (isTabKey(event.key)) event.preventDefault();
        if (isHideMenuKey(event.key)) handleMenuClose();
    };
    if (null == children) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseButton, esm_extends_extends({
                ref: handleRef,
                size: "small",
                startIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.exportIcon, {}),
                "aria-expanded": open,
                "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                "aria-haspopup": "menu",
                "aria-controls": open ? exportMenuId : void 0,
                id: exportButtonId
            }, other, {
                onClick: handleMenuOpen
            }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseButton, {
                children: apiRef.current.getLocaleText('toolbarExport')
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridMenu, {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuList_abce8441__["default"], {
                    id: exportMenuId,
                    className: gridClasses_gridClasses.menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: __WEBPACK_EXTERNAL_MODULE_react__.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.isValidElement(child)) return child;
                        return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});
const GridToolbarExport_excluded = [
    "hideMenu",
    "options"
], GridToolbarExport_excluded2 = [
    "hideMenu",
    "options"
], GridToolbarExport_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function GridCsvExportMenuItem(props) {
    const apiRef = useGridApiContext();
    const { hideMenu, options } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridToolbarExport_excluded);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], esm_extends_extends({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            null == hideMenu || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function GridPrintExportMenuItem(props) {
    const apiRef = useGridApiContext();
    const { hideMenu, options } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridToolbarExport_excluded2);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], esm_extends_extends({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            null == hideMenu || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
const GridToolbarExport_GridToolbarExport = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { csvOptions = {}, printOptions = {}, excelOptions } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridToolbarExport_excluded3);
    const apiRef = useGridApiContext();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions,
        csvOptions,
        printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (0 === preProcessedButtons.length) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridToolbarExportContainer_GridToolbarExportContainer, esm_extends_extends({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(button.component, {
                key: index
            }))
    }));
});
"production" !== process.env.NODE_ENV && (GridToolbarExport_GridToolbarExport.propTypes = {
    csvOptions: prop_types_default().object,
    printOptions: prop_types_default().object
});
const useGridCsvExport = (apiRef, props)=>{
    const logger = useGridLogger(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = ('object' == typeof ignoreValueFormatterProp ? null == ignoreValueFormatterProp ? void 0 : ignoreValueFormatterProp.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((options = {})=>{
        var _options$getRowsToExp, _options$includeHeade, _options$includeColum, _options$shouldAppend;
        logger.debug("Get data as CSV");
        const exportedColumns = getColumnsToExport({
            apiRef,
            options
        });
        const getRowsToExport = null != (_options$getRowsToExp = options.getRowsToExport) ? _options$getRowsToExp : defaultGetRowsToExport;
        const exportedRowIds = getRowsToExport({
            apiRef
        });
        return buildCSV({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            delimiterCharacter: options.delimiter || ',',
            includeHeaders: null != (_options$includeHeade = options.includeHeaders) ? _options$includeHeade : true,
            includeColumnGroupsHeaders: null != (_options$includeColum = options.includeColumnGroupsHeaders) ? _options$includeColum : true,
            ignoreValueFormatter,
            apiRef,
            shouldAppendQuotes: null != (_options$shouldAppend = options.shouldAppendQuotes) ? _options$shouldAppend : true
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((options)=>{
        logger.debug("Export data as CSV");
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            null != options && options.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        exportAs(blob, 'csv', null == options ? void 0 : options.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv,
        exportDataAsCsv
    };
    useGridApiMethod(apiRef, csvExportApi, 'public');
    const addExportMenuButtons = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((initialValue, options)=>{
        var _options$csvOptions;
        if (null != (_options$csvOptions = options.csvOptions) && _options$csvOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridCsvExportMenuItem, {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    useGridRegisterPipeProcessor(apiRef, 'exportMenu', addExportMenuButtons);
};
const gridRowsMetaSelector = (state)=>state.rowsMeta;
const paginationStateInitializer = (state, props)=>{
    var _props$paginationMode, _props$initialState;
    const paginationModel = esm_extends_extends({}, getDefaultGridPaginationModel(props.autoPageSize), null != (_props$paginationMode = props.paginationModel) ? _props$paginationMode : null == (_props$initialState = props.initialState) || null == (_props$initialState = _props$initialState.pagination) ? void 0 : _props$initialState.paginationModel);
    throwIfPageSizeExceedsTheLimit(paginationModel.pageSize, props.signature);
    return esm_extends_extends({}, state, {
        pagination: {
            paginationModel
        }
    });
};
const mergeStateWithPaginationModel = (rowCount, signature, paginationModelProp)=>(paginationState)=>{
        var _paginationModelProp$;
        let paginationModel = paginationState.paginationModel;
        const pageSize = null != (_paginationModelProp$ = null == paginationModelProp ? void 0 : paginationModelProp.pageSize) ? _paginationModelProp$ : paginationModel.pageSize;
        const pageCount = getPageCount(rowCount, pageSize);
        if (paginationModelProp && ((null == paginationModelProp ? void 0 : paginationModelProp.page) !== paginationModel.page || (null == paginationModelProp ? void 0 : paginationModelProp.pageSize) !== paginationModel.pageSize)) paginationModel = paginationModelProp;
        const validPage = getValidPage(paginationModel.page, pageCount);
        if (validPage !== paginationModel.page) paginationModel = esm_extends_extends({}, paginationModel, {
            page: validPage
        });
        throwIfPageSizeExceedsTheLimit(paginationModel.pageSize, signature);
        return {
            paginationModel
        };
    };
const useGridPagination = (apiRef, props)=>{
    var _props$initialState3;
    const logger = useGridLogger(apiRef, 'useGridPagination');
    const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
    const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'pagination',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: gridPaginationModelSelector,
        changeEvent: 'paginationModelChange'
    });
    const setPage = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((page)=>{
        const currentModel = gridPaginationModelSelector(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((pageSize)=>{
        const currentModel = gridPaginationModelSelector(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((paginationModel)=>{
        var _props$rowCount;
        const currentModel = gridPaginationModelSelector(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel(null != (_props$rowCount = props.rowCount) ? _props$rowCount : visibleTopLevelRowCount, props.signature, paginationModel), 'setPaginationModel');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.rowCount,
        props.signature,
        visibleTopLevelRowCount
    ]);
    const pageApi = {
        setPage,
        setPageSize,
        setPaginationModel
    };
    useGridApiMethod(apiRef, pageApi, 'public');
    const stateExportPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((prevState, context)=>{
        var _props$initialState2;
        const paginationModel = gridPaginationModelSelector(apiRef);
        const shouldExportPaginationModel = !context.exportOnlyDirtyModels || null != props.paginationModel || (null == (_props$initialState2 = props.initialState) || null == (_props$initialState2 = _props$initialState2.pagination) ? void 0 : _props$initialState2.paginationModel) != null || 0 !== paginationModel.page && paginationModel.pageSize !== defaultPageSize(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return esm_extends_extends({}, prevState, {
            pagination: esm_extends_extends({}, prevState.pagination, {
                paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        null == (_props$initialState3 = props.initialState) || null == (_props$initialState3 = _props$initialState3.pagination) ? void 0 : _props$initialState3.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, context)=>{
        var _context$stateToResto, _context$stateToResto2, _props$rowCount2;
        const paginationModel = null != (_context$stateToResto = context.stateToRestore.pagination) && _context$stateToResto.paginationModel ? esm_extends_extends({}, getDefaultGridPaginationModel(props.autoPageSize), null == (_context$stateToResto2 = context.stateToRestore.pagination) ? void 0 : _context$stateToResto2.paginationModel) : gridPaginationModelSelector(apiRef);
        apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel(null != (_props$rowCount2 = props.rowCount) ? _props$rowCount2 : visibleTopLevelRowCount, props.signature, paginationModel), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.rowCount,
        props.signature,
        visibleTopLevelRowCount
    ]);
    useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
    const handlePaginationModelChange = ()=>{
        var _apiRef$current$virtu;
        const paginationModel = gridPaginationModelSelector(apiRef);
        if (null != (_apiRef$current$virtu = apiRef.current.virtualScrollerRef) && _apiRef$current$virtu.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
        apiRef.current.forceUpdate();
    };
    const handleUpdateAutoPageSize = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!props.autoPageSize || !dimensions) return;
        const pinnedRowsHeight = calculatePinnedRowsHeight(apiRef);
        const maximumPageSizeWithoutScrollBar = Math.floor((dimensions.viewportInnerSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom) / rowHeight);
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'paginationModelChange', handlePaginationModelChange);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if ('production' !== process.env.NODE_ENV) {
            if ('server' === props.paginationMode && null == props.rowCount) noRowCountInServerMode();
        }
    }, [
        props.rowCount,
        props.paginationMode
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        var _props$rowCount3;
        apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel(null != (_props$rowCount3 = props.rowCount) ? _props$rowCount3 : visibleTopLevelRowCount, props.signature, props.paginationModel));
    }, [
        apiRef,
        props.paginationModel,
        props.rowCount,
        props.paginationMode,
        visibleTopLevelRowCount,
        props.signature
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        handleUpdateAutoPageSize();
    }, [
        handleUpdateAutoPageSize
    ]);
};
function raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    iframeEl.title = title || document.title;
    return iframeEl;
}
const useGridPrintExport = (apiRef, props)=>{
    const logger = useGridLogger(apiRef, 'useGridPrintExport');
    const doc = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const previousGridState = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const previousColumnVisibility = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const previousRows = __WEBPACK_EXTERNAL_MODULE_react__.useRef([]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        doc.current = ownerDocument(apiRef.current.rootElementRef.current);
    }, [
        apiRef
    ]);
    const updateGridColumnsForPrint = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = getColumnsToExport({
                apiRef,
                options: {
                    fields,
                    allColumns
                }
            }).map((column)=>column.field);
            const columns = gridColumnDefinitionsSelector(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[GRID_CHECKBOX_SELECTION_COL_DEF.field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef
        });
        const newRows = rowsToExportIds.map((id)=>apiRef.current.getRow(id));
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((printWindow, options)=>{
        var _querySelector, _querySelector2;
        const normalizeOptions = esm_extends_extends({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = gridRowsMetaSelector(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        const gridMain = gridClone.querySelector(`.${gridClasses_gridClasses.main}`);
        gridMain.style.overflow = 'visible';
        gridClone.style.contain = 'size';
        const columnHeaders = gridClone.querySelector(`.${gridClasses_gridClasses.columnHeaders}`);
        const columnHeadersInner = columnHeaders.querySelector(`.${gridClasses_gridClasses.columnHeadersInner}`);
        columnHeadersInner.style.width = '100%';
        let gridToolbarElementHeight = (null == (_querySelector = gridRootElement.querySelector(`.${gridClasses_gridClasses.toolbarContainer}`)) ? void 0 : _querySelector.offsetHeight) || 0;
        let gridFooterElementHeight = (null == (_querySelector2 = gridRootElement.querySelector(`.${gridClasses_gridClasses.footerContainer}`)) ? void 0 : _querySelector2.offsetHeight) || 0;
        if (normalizeOptions.hideToolbar) {
            var _gridClone$querySelec;
            null == (_gridClone$querySelec = gridClone.querySelector(`.${gridClasses_gridClasses.toolbarContainer}`)) || _gridClone$querySelec.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter) {
            var _gridClone$querySelec2;
            null == (_gridClone$querySelec2 = gridClone.querySelector(`.${gridClasses_gridClasses.footerContainer}`)) || _gridClone$querySelec2.remove();
            gridFooterElementHeight = 0;
        }
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + getTotalHeaderHeight(apiRef, props.columnHeaderHeight) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        gridClone.style.boxSizing = 'content-box';
        if (null != options && options.getRowsToExport) {
            const gridFooterElement = gridClone.querySelector(`.${gridClasses_gridClasses.footerContainer}`);
            gridFooterElement.style.position = 'absolute';
            gridFooterElement.style.width = '100%';
            gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        }
        const container = document.createElement('div');
        container.appendChild(gridClone);
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = 'function' == typeof normalizeOptions.pageStyle ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if ('string' == typeof defaultPageStyle) {
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        const stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = 'ShadowRoot' === rootCandidate.constructor.name ? rootCandidate : doc.current;
            const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if ('STYLE' === node.tagName) {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = '';
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if ('string' == typeof sheet.cssRules[j].cssText) styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute('href')) {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
                    }
                    stylesheetLoadPromises.push(new Promise((resolve)=>{
                        newHeadStyleElements.addEventListener('load', ()=>resolve());
                    }));
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        }
        if ('test' !== process.env.NODE_ENV) Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props.columnHeaderHeight
    ]);
    const handlePrintWindowAfterPrint = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((printWindow)=>{
        var _previousGridState$cu;
        doc.current.body.removeChild(printWindow);
        apiRef.current.restoreState(previousGridState.current || {});
        if (!(null != (_previousGridState$cu = previousGridState.current) && null != (_previousGridState$cu = _previousGridState$cu.columns) && _previousGridState$cu.columnVisibilityModel)) apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.unstable_setVirtualization(true);
        apiRef.current.setRows(previousRows.current);
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(async (options)=>{
        logger.debug("Export data as Print");
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        previousColumnVisibility.current = gridColumnVisibilityModelSelector(apiRef);
        const gridRowsLookup = gridRowsLookupSelector(apiRef);
        previousRows.current = gridDataRowIdsSelector(apiRef).map((rowId)=>gridRowsLookup[rowId]);
        if (props.pagination) {
            const visibleRowCount = gridExpandedRowCountSelector(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel(visibleRowCount, 'DataGridPro', paginationModel));
            apiRef.current.forceUpdate();
        }
        await updateGridColumnsForPrint(null == options ? void 0 : options.fields, null == options ? void 0 : options.allColumns, null == options ? void 0 : options.includeCheckboxes);
        if (null != options && options.getRowsToExport) updateGridRowsForPrint(options.getRowsToExport);
        apiRef.current.unstable_setVirtualization(false);
        await raf();
        const printWindow = buildPrintWindow(null == options ? void 0 : options.fileName);
        if ('test' === process.env.NODE_ENV) {
            doc.current.body.appendChild(printWindow);
            handlePrintWindowLoad(printWindow, options);
            handlePrintWindowAfterPrint(printWindow);
        } else {
            printWindow.onload = ()=>{
                handlePrintWindowLoad(printWindow, options);
                const mediaQueryList = printWindow.contentWindow.matchMedia('print');
                mediaQueryList.addEventListener('change', (mql)=>{
                    const isAfterPrint = false === mql.matches;
                    if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
                });
            };
            doc.current.body.appendChild(printWindow);
        }
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint
    };
    useGridApiMethod(apiRef, printExportApi, 'public');
    const addExportMenuButtons = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((initialValue, options)=>{
        var _options$printOptions;
        if (null != (_options$printOptions = options.printOptions) && _options$printOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPrintExportMenuItem, {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    useGridRegisterPipeProcessor(apiRef, 'exportMenu', addExportMenuButtons);
};
const useGridRegisterStrategyProcessor = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    useFirstRender(()=>{
        registerPreProcessor();
    });
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};
const filterStateInitializer = (state, props, apiRef)=>{
    var _ref, _props$filterModel, _props$initialState;
    const filterModel = null != (_ref = null != (_props$filterModel = props.filterModel) ? _props$filterModel : null == (_props$initialState = props.initialState) || null == (_props$initialState = _props$initialState.filter) ? void 0 : _props$initialState.filterModel) ? _ref : getDefaultGridFilterModel();
    return esm_extends_extends({}, state, {
        filter: {
            filterModel: sanitizeFilterModel(filterModel, props.disableMultipleColumnsFiltering, apiRef),
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        },
        visibleRowsLookup: {}
    });
};
const getVisibleRowsLookup = (params)=>params.filteredRowsLookup;
function getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function createMemoizedValues() {
    return defaultMemoize(Object.values);
}
const useGridFilter = (apiRef, props)=>{
    var _props$initialState3, _props$slotProps2;
    const logger = useGridLogger(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: gridFilterModelSelector,
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = gridFilterModelSelector(state, apiRef.current.instanceId);
            const isRowMatchingFilters = 'client' === props.filterMode ? buildAggregatedFilterApplier(filterModel, apiRef, props.disableEval) : null;
            const filteringResult = apiRef.current.applyStrategyProcessor('filtering', {
                isRowMatchingFilters,
                filterModel: null != filterModel ? filterModel : getDefaultGridFilterModel()
            });
            const newState = esm_extends_extends({}, state, {
                filter: esm_extends_extends({}, state.filter, filteringResult)
            });
            const visibleRowsLookupState = getVisibleRowsLookupState(apiRef, newState);
            return esm_extends_extends({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef,
        props.filterMode,
        props.disableEval
    ]);
    const addColumnMenuItem = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columnMenuItems, colDef)=>{
        if (null == colDef || false === colDef.filterable || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    const applyFilters = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((item)=>{
        const filterModel = gridFilterModelSelector(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (-1 === itemIndex) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((items)=>{
        const filterModel = gridFilterModelSelector(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
            if (-1 === itemIndex) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            items
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((itemToDelete)=>{
        const filterModel = gridFilterModelSelector(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = gridFilterModelSelector(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                var _column$filterOperato;
                if (void 0 !== item.value) {
                    if (Array.isArray(item.value) && 0 === item.value.length) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = null == (_column$filterOperato = column.filterOperators) ? void 0 : _column$filterOperato.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = void 0 === (null == filterOperator ? void 0 : filterOperator.requiresFilterValue) ? true : null == filterOperator ? void 0 : filterOperator.requiresFilterValue;
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            newFilterItems = filterItemOnTarget ? filterItemsWithValue : props.disableMultipleColumnsFiltering ? [
                cleanFilterItem({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ] : [
                ...filterItemsWithValue,
                cleanFilterItem({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences(gridPreferencePanelsValue_GridPreferencePanelsValue.filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((logicOperator)=>{
        const filterModel = gridFilterModelSelector(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((values)=>{
        const filterModel = gridFilterModelSelector(apiRef);
        if (isDeepEqual(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((model, reason)=>{
        const currentModel = gridFilterModelSelector(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', mergeStateWithFilterModel(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const filterApi = {
        setFilterLogicOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem,
        upsertFilterItem,
        upsertFilterItems,
        setFilterModel,
        showFilterPanel,
        hideFilterPanel,
        setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics
    };
    useGridApiMethod(apiRef, filterApi, 'public');
    const stateExportPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((prevState, context)=>{
        var _props$initialState2;
        const filterModelToExport = gridFilterModelSelector(apiRef);
        const shouldExportFilterModel = !context.exportOnlyDirtyModels || null != props.filterModel || (null == (_props$initialState2 = props.initialState) || null == (_props$initialState2 = _props$initialState2.filter) ? void 0 : _props$initialState2.filterModel) != null || !isDeepEqual(filterModelToExport, getDefaultGridFilterModel());
        if (!shouldExportFilterModel) return prevState;
        return esm_extends_extends({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        null == (_props$initialState3 = props.initialState) || null == (_props$initialState3 = _props$initialState3.filter) ? void 0 : _props$initialState3.filterModel
    ]);
    const stateRestorePreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, context)=>{
        var _context$stateToResto;
        const filterModel = null == (_context$stateToResto = context.stateToRestore.filter) ? void 0 : _context$stateToResto.filterModel;
        if (null == filterModel) return params;
        apiRef.current.updateControlState('filter', mergeStateWithFilterModel(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return esm_extends_extends({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((initialValue, value)=>{
        if (value === gridPreferencePanelsValue_GridPreferencePanelsValue.filters) {
            var _props$slotProps;
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterPanel, esm_extends_extends({}, null == (_props$slotProps = props.slotProps) ? void 0 : _props$slotProps.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        null == (_props$slotProps2 = props.slotProps) ? void 0 : _props$slotProps2.filterPanel
    ]);
    const { getRowId } = props;
    const getRowsRef = useLazyRef(createMemoizedValues);
    const flatFilteringMethod = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        if ('client' !== props.filterMode || !params.isRowMatchingFilters) return {
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        };
        const dataRowIdToModelLookup = gridRowsLookupSelector(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, void 0, result);
            const isRowPassing = passFilterLogic([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, apiRef, filterCache);
            filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup,
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'columnMenu', addColumnMenuItem);
    useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'filtering', flatFilteringMethod);
    useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'visibleRowsLookupCreation', getVisibleRowsLookup);
    const handleColumnsChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = gridFilterModelSelector(apiRef);
        const filterableColumnsLookup = gridFilterableColumnLookupSelector(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && filterableColumnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((methodName)=>{
        if ('filtering' === methodName) apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                visibleRowsLookup: getVisibleRowsLookupState(apiRef, state)
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowsSet', updateFilteredRows);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnsChange', handleColumnsChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = gridFilterModelSelector(apiRef);
        if (filterModel.quickFilterValues && filterModel.quickFilterExcludeHiddenColumns) apiRef.current.unstable_applyFilters();
    });
    useFirstRender(()=>{
        apiRef.current.unstable_applyFilters();
    });
    useEnhancedEffect(()=>{
        if (void 0 !== props.filterModel) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};
const getVisibleRows = (apiRef, props)=>{
    let rows;
    let range;
    if (props.pagination && 'client' === props.paginationMode) {
        range = gridPaginationRowRangeSelector(apiRef);
        rows = gridPaginatedVisibleSortedGridRowEntriesSelector(apiRef);
    } else {
        rows = gridExpandedSortedRowEntriesSelector(apiRef);
        range = 0 === rows.length ? null : {
            firstRowIndex: 0,
            lastRowIndex: rows.length - 1
        };
    }
    return {
        rows,
        range
    };
};
const useGridVisibleRows = (apiRef, props)=>{
    const response = getVisibleRows(apiRef, props);
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            rows: response.rows,
            range: response.range
        }), [
        response.rows,
        response.range
    ]);
};
const focusStateInitializer = (state)=>esm_extends_extends({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const useGridFocus = (apiRef, props)=>{
    const logger = useGridLogger(apiRef, 'useGridFocus');
    const lastClickedCell = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const publishCellFocusOut = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((cell, event)=>{
        if (cell) {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const focusedCell = gridFocusCellSelector(apiRef);
        if ((null == focusedCell ? void 0 : focusedCell.id) === id && (null == focusedCell ? void 0 : focusedCell.field) === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return esm_extends_extends({}, state, {
                tabIndex: {
                    cell: {
                        id,
                        field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id,
                        field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, event = {})=>{
        const cell = gridFocusCellSelector(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return esm_extends_extends({}, state, {
                tabIndex: {
                    columnHeader: {
                        field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, event = {})=>{
        const cell = gridFocusCellSelector(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return esm_extends_extends({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, depth, event = {})=>{
        const cell = gridFocusCellSelector(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field,
                        depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field,
                        depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>unstable_gridFocusColumnGroupHeaderSelector(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
        const currentPage = getVisibleRows(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = gridPinnedRowsSelector(apiRef);
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if ('right' === direction) columnIndexToFocus += 1;
        else if ('left' === direction) columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = clamp(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if ('left' === direction || 'below' === direction) columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if ('right' === direction) columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = clamp(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ id, field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if ('Enter' === event.key || 'Tab' === event.key || 'Shift' === event.key || isNavigationKey(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ fields, depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = unstable_gridFocusColumnGroupHeaderSelector(apiRef);
        if (null !== focusedColumnGroup && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((_, event)=>{
        var _event$relatedTarget;
        if (null != (_event$relatedTarget = event.relatedTarget) && _event$relatedTarget.className.includes(gridClasses_gridClasses.columnHeader)) return;
        logger.debug("Clearing focus");
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = gridFocusCellSelector(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if ((null == cellParams ? void 0 : cellParams.id) === focusedCell.id && (null == cellParams ? void 0 : cellParams.field) === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (null != cellElement && cellElement.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            apiRef.current.forceUpdate();
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        if ('view' === params.cellMode) return;
        const cell = gridFocusCellSelector(apiRef);
        if ((null == cell ? void 0 : cell.id) !== params.id || (null == cell ? void 0 : cell.field) !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const cell = gridFocusCellSelector(apiRef);
        if (cell && !apiRef.current.getRow(cell.id)) apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        apiRef
    ]);
    const handlePaginationModelChange = useEventCallback_useEventCallback(()=>{
        const currentFocusedCell = gridFocusCellSelector(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = getVisibleRows(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage) return;
        const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            }));
    });
    const focusApi = {
        setCellFocus,
        setColumnHeaderFocus,
        setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell,
        setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus
    };
    useGridApiMethod(apiRef, focusApi, 'public');
    useGridApiMethod(apiRef, focusPrivateApi, 'private');
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const doc = ownerDocument(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        handleDocumentClick
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderBlur', handleBlur);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellMouseDown', handleCellMouseDown);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellKeyDown', handleCellKeyDown);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellModeChange', handleCellModeChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowsSet', handleRowSet);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'paginationModelChange', handlePaginationModelChange);
};
const GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';
const unstable_gridHeaderFilteringStateSelector = (state)=>state.headerFiltering;
const unstable_gridHeaderFilteringEditFieldSelector = createSelector_createSelector(unstable_gridHeaderFilteringStateSelector, (headerFilteringState)=>headerFilteringState.editing);
const unstable_gridHeaderFilteringMenuSelector = createSelector_createSelector(unstable_gridHeaderFilteringStateSelector, (headerFilteringState)=>headerFilteringState.menuOpen);
function isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function findParentElementFromClassName(elem, className) {
    return elem.closest(`.${className}`);
}
function escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function getGridColumnHeaderElement(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${escapeOperandAttributeSelector(field)}"]`);
}
function getGridRowElementSelector(id) {
    return `.${gridClasses_gridClasses.row}[data-id="${escapeOperandAttributeSelector(String(id))}"]`;
}
function getGridRowElement(root, id) {
    return root.querySelector(getGridRowElementSelector(id));
}
function getGridCellElement(root, { id, field }) {
    const rowSelector = getGridRowElementSelector(id);
    const cellSelector = `.${gridClasses_gridClasses.cell}[data-field="${escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
function isEventTargetInPortal(event) {
    if (1 === event.target.nodeType && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function enrichPageRowsWithPinnedRows(apiRef, rows) {
    const pinnedRows = gridPinnedRowsSelector(apiRef) || {};
    return [
        ...pinnedRows.top || [],
        ...rows,
        ...pinnedRows.bottom || []
    ];
}
const getLeftColumnIndex = ({ currentColIndex, firstColIndex, lastColIndex, direction })=>{
    if ('rtl' === direction) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if ('ltr' === direction) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const getRightColumnIndex = ({ currentColIndex, firstColIndex, lastColIndex, direction })=>{
    if ('rtl' === direction) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if ('ltr' === direction) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
const useGridKeyboardNavigation = (apiRef, props)=>{
    const logger = useGridLogger(apiRef, 'useGridKeyboardNavigation');
    const initialCurrentPageRows = useGridVisibleRows(apiRef, props).rows;
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const currentPageRows = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>enrichPageRowsWithPinnedRows(apiRef, initialCurrentPageRows), [
        apiRef,
        initialCurrentPageRows
    ]);
    const headerFilteringEnabled = 'DataGrid' !== props.signature && props.unstable_headerFilters;
    const goToCell = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((colIndex, rowId, closestColumnToUse = 'left')=>{
        const visibleSortedRows = gridExpandedSortedRowEntriesSelector(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if ('left' === closestColumnToUse) colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if ('right' === closestColumnToUse) colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === rowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setCellFocus(rowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex
        });
        const { field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rowIndex)=>{
        var _currentPageRows$rowI;
        return null == (_currentPageRows$rowI = currentPageRows[rowIndex]) ? void 0 : _currentPageRows$rowI.id;
    }, [
        currentPageRows
    ]);
    const handleColumnHeaderKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${gridClasses_gridClasses.columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== GRID_CHECKBOX_SELECTION_COL_DEF.field) return;
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
        const columnGroupMaxDepth = gridColumnGroupsHeaderMaxDepthSelector(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (null !== firstRowIndexInPage) if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex,
                        lastColIndex,
                        direction: theme.direction
                    });
                    if (null !== rightColIndex) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex,
                        lastColIndex,
                        direction: theme.direction
                    });
                    if (null !== leftColIndex) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (null !== firstRowIndexInPage && null !== lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        theme.direction,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const isEditing = unstable_gridHeaderFilteringEditFieldSelector(apiRef) === params.field;
        const isHeaderMenuOpen = unstable_gridHeaderFilteringMenuSelector(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !isNavigationKey(event.key)) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (null !== firstRowIndexInPage && null != rowId) goToCell(colIndexBefore, rowId);
                    break;
                }
            case 'ArrowRight':
                {
                    const rightColIndex = getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex,
                        lastColIndex,
                        direction: theme.direction
                    });
                    if (null !== rightColIndex) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex,
                        lastColIndex,
                        direction: theme.direction
                    });
                    if (null !== leftColIndex) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (null !== firstRowIndexInPage && null !== lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeaderFilter,
        theme.direction,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const focusedColumnGroup = unstable_gridFocusColumnGroupHeaderSelector(apiRef);
        if (null === focusedColumnGroup) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields, depth, maxDepth } = params;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (null !== firstRowIndexInPage && null !== lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (isEventTargetInPortal(event)) return;
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === gridEditRowModel_GridCellModes.Edit || !isNavigationKey(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const dimensions = apiRef.current.getRootDimensions();
        if (0 === currentPageRows.length || !dimensions) return;
        const direction = theme.direction;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1));
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex,
                        lastColIndex,
                        direction
                    });
                    if (null !== rightColIndex) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), 'rtl' === direction ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex,
                        lastColIndex,
                        direction
                    });
                    if (null !== leftColIndex) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), 'rtl' === direction ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) break;
                    const colDef = params.colDef;
                    if (colDef && 'treeDataGroup' === colDef.type) break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                event.ctrlKey || event.metaKey || event.shiftKey ? goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage)) : goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                event.ctrlKey || event.metaKey || event.shiftKey ? goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage)) : goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows,
        theme.direction,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((initialValue, { event })=>{
        if (' ' === event.key) return false;
        return initialValue;
    }, []);
    useGridRegisterPipeProcessor(apiRef, 'canStartEditing', checkIfCanStartEditing);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellKeyDown', handleCellKeyDown);
};
const gridPreferencePanelStateSelector = (state)=>state.preferencePanel;
const preferencePanelStateInitializer = (state, props)=>{
    var _props$initialState$p, _props$initialState;
    return esm_extends_extends({}, state, {
        preferencePanel: null != (_props$initialState$p = null == (_props$initialState = props.initialState) ? void 0 : _props$initialState.preferencePanel) ? _props$initialState$p : {
            open: false
        }
    });
};
const useGridPreferencesPanel = (apiRef, props)=>{
    var _props$initialState3;
    const logger = useGridLogger(apiRef, 'useGridPreferencesPanel');
    const hideTimeout = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const immediateTimeout = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const hidePreferences = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        logger.debug('Hiding Preferences Panel');
        const preferencePanelState = gridPreferencePanelStateSelector(apiRef.current.state);
        if (preferencePanelState.openedPanelValue) apiRef.current.publishEvent('preferencePanelClose', {
            openedPanelValue: preferencePanelState.openedPanelValue
        });
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                preferencePanel: {
                    open: false
                }
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const doNotHidePanel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        immediateTimeout.current = setTimeout(()=>clearTimeout(hideTimeout.current), 0);
    }, []);
    const hidePreferencesDelayed = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        hideTimeout.current = setTimeout(hidePreferences, 100);
    }, [
        hidePreferences
    ]);
    const showPreferences = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        doNotHidePanel();
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                preferencePanel: esm_extends_extends({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId,
                    labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        doNotHidePanel,
        apiRef
    ]);
    useGridApiMethod(apiRef, {
        showPreferences,
        hidePreferences: hidePreferencesDelayed
    }, 'public');
    const stateExportPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((prevState, context)=>{
        var _props$initialState2;
        const preferencePanelToExport = gridPreferencePanelStateSelector(apiRef.current.state);
        const shouldExportPreferencePanel = !context.exportOnlyDirtyModels || (null == (_props$initialState2 = props.initialState) ? void 0 : _props$initialState2.preferencePanel) != null || preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return esm_extends_extends({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        null == (_props$initialState3 = props.initialState) ? void 0 : _props$initialState3.preferencePanel
    ]);
    const stateRestorePreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (null != preferencePanel) apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>()=>{
            clearTimeout(hideTimeout.current);
            clearTimeout(immediateTimeout.current);
        }, []);
};
const gridEditRowsStateSelector = (state)=>state.editRows;
const useGridCellEditing_excluded = [
    "id",
    "field"
], useGridCellEditing_excluded2 = [
    "id",
    "field"
];
const missingOnProcessRowUpdateErrorWarning = warning_buildWarning([
    'MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
    'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
    'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'
], 'error');
const useGridCellEditing = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = __WEBPACK_EXTERNAL_MODULE_react__.useState({});
    const cellModesModelRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(cellModesModel);
    const prevCellModesModel = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const { processRowUpdate, onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === gridEditRowModel_GridEditModes.Cell) callback(...args);
        };
    const throwIfNotEditable = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === gridEditRowModel_GridCellModes.Edit) return;
        const newParams = esm_extends_extends({}, params, {
            reason: gridEditCellParams_GridCellEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (params.cellMode === gridEditRowModel_GridCellModes.View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === gridEditRowModel_GridCellModes.View) return;
        const newParams = esm_extends_extends({}, params, {
            reason: gridEditCellParams_GridCellEditStopReasons.cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (params.cellMode === gridEditRowModel_GridCellModes.Edit) {
            if (229 === event.which) return;
            let reason;
            if ('Escape' === event.key) reason = gridEditCellParams_GridCellEditStopReasons.escapeKeyDown;
            else if ('Enter' === event.key) reason = gridEditCellParams_GridCellEditStopReasons.enterKeyDown;
            else if ('Tab' === event.key) {
                reason = event.shiftKey ? gridEditCellParams_GridCellEditStopReasons.shiftTabKeyDown : gridEditCellParams_GridCellEditStopReasons.tabKeyDown;
                event.preventDefault();
            }
            if (reason) {
                const newParams = esm_extends_extends({}, params, {
                    reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if (isPrintableKey(event)) reason = gridEditCellParams_GridCellEditStartReasons.printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && 'v' === event.key) reason = gridEditCellParams_GridCellEditStartReasons.pasteKeyDown;
            else if ('Enter' === event.key) reason = gridEditCellParams_GridCellEditStartReasons.enterKeyDown;
            else if ('Delete' === event.key || 'Backspace' === event.key) reason = gridEditCellParams_GridCellEditStartReasons.deleteKeyDown;
            if (reason) {
                const newParams = esm_extends_extends({}, params, {
                    reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field, reason } = params;
        const startCellEditModeParams = {
            id,
            field
        };
        if (reason === gridEditCellParams_GridCellEditStartReasons.printableKeyDown || reason === gridEditCellParams_GridCellEditStartReasons.deleteKeyDown || reason === gridEditCellParams_GridCellEditStartReasons.pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field, reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === gridEditCellParams_GridCellEditStopReasons.enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === gridEditCellParams_GridCellEditStopReasons.tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === gridEditCellParams_GridCellEditStopReasons.shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = 'escapeKeyDown' === reason;
        apiRef.current.stopCellEditMode({
            id,
            field,
            ignoreModifications,
            cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    useGridApiOptionHandler(apiRef, 'cellEditStart', props.onCellEditStart);
    useGridApiOptionHandler(apiRef, 'cellEditStop', props.onCellEditStop);
    const getCellMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? gridEditRowModel_GridCellModes.Edit : gridEditRowModel_GridCellModes.View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = useEventCallback_useEventCallback((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {});
        if (props.cellModesModel && isNewModelDifferentFromProp) return;
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field, newProps)=>{
        const newModel = esm_extends_extends({}, cellModesModelRef.current);
        if (null !== newProps) newModel[id] = esm_extends_extends({}, newModel[id], {
            [field]: esm_extends_extends({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_newModel$id, [
                field
            ].map(toPropertyKey));
            newModel[id] = otherFields;
            if (0 === Object.keys(newModel[id]).length) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = esm_extends_extends({}, state.editRows);
            if (null !== newProps) newEditingState[id] = esm_extends_extends({}, newEditingState[id], {
                [field]: esm_extends_extends({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (0 === Object.keys(newEditingState[id]).length) delete newEditingState[id];
            }
            return esm_extends_extends({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field } = params, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(params, useGridCellEditing_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, gridEditRowModel_GridCellModes.View);
        updateFieldInCellModesModel(id, field, esm_extends_extends({
            mode: gridEditRowModel_GridCellModes.Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = useEventCallback_useEventCallback((params)=>{
        const { id, field, deleteValue, initialValue } = params;
        let newValue = apiRef.current.getCellValue(id, field);
        if (deleteValue || initialValue) newValue = deleteValue ? '' : initialValue;
        const newProps = {
            value: newValue,
            error: false,
            isProcessingProps: false
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
    });
    const stopCellEditMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field } = params, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(params, useGridCellEditing_excluded2);
        throwIfNotInMode(id, field, gridEditRowModel_GridCellModes.Edit);
        updateFieldInCellModesModel(id, field, esm_extends_extends({
            mode: gridEditRowModel_GridCellModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = useEventCallback_useEventCallback(async (params)=>{
        const { id, field, ignoreModifications, cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, gridEditRowModel_GridCellModes.Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if ('none' !== cellToFocusAfter) apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) return void finishCellEditMode();
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        const { error, isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            prevCellModesModel.current[id][field].mode = gridEditRowModel_GridCellModes.Edit;
            updateFieldInCellModesModel(id, field, {
                mode: gridEditRowModel_GridCellModes.Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = gridEditRowModel_GridCellModes.Edit;
                updateFieldInCellModesModel(id, field, {
                    mode: gridEditRowModel_GridCellModes.Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else missingOnProcessRowUpdateErrorWarning();
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(async (params)=>{
        var _editingState$id;
        const { id, field, value, debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, gridEditRowModel_GridCellModes.Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = gridEditRowsStateSelector(apiRef.current.state);
        let newProps = esm_extends_extends({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = esm_extends_extends({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id,
                row,
                props: newProps,
                hasChanged
            }));
        }
        if (apiRef.current.getCellMode(id, field) === gridEditRowModel_GridCellModes.View) return false;
        editingState = gridEditRowsStateSelector(apiRef.current.state);
        newProps = esm_extends_extends({}, newProps, {
            isProcessingProps: false
        });
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = gridEditRowsStateSelector(apiRef.current.state);
        return !(null != (_editingState$id = editingState[id]) && null != (_editingState$id = _editingState$id[field]) && _editingState$id.error);
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter({
            value,
            row
        }) : esm_extends_extends({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode,
        startCellEditMode,
        stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing
    };
    useGridApiMethod(apiRef, editingApi, 'public');
    useGridApiMethod(apiRef, editingPrivateApi, 'private');
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    useEnhancedEffect(()=>{
        const idToIdLookup = gridRowsDataRowIdToIdLookupSelector(apiRef);
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = deepClone(cellModesModel);
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                var _copyOfPrevCellModes$, _idToIdLookup$id;
                const prevMode = (null == (_copyOfPrevCellModes$ = copyOfPrevCellModes[id]) || null == (_copyOfPrevCellModes$ = _copyOfPrevCellModes$[field]) ? void 0 : _copyOfPrevCellModes$.mode) || gridEditRowModel_GridCellModes.View;
                const originalId = null != (_idToIdLookup$id = idToIdLookup[id]) ? _idToIdLookup$id : id;
                if (params.mode === gridEditRowModel_GridCellModes.Edit && prevMode === gridEditRowModel_GridCellModes.View) updateStateToStartCellEditMode(esm_extends_extends({
                    id: originalId,
                    field
                }, params));
                else if (params.mode === gridEditRowModel_GridCellModes.View && prevMode === gridEditRowModel_GridCellModes.Edit) updateStateToStopCellEditMode(esm_extends_extends({
                    id: originalId,
                    field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};
var gridRowParams_GridRowEditStartReasons = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}(gridRowParams_GridRowEditStartReasons || {});
var gridRowParams_GridRowEditStopReasons = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}(gridRowParams_GridRowEditStopReasons || {});
const useGridRowEditing_excluded = [
    "id"
], useGridRowEditing_excluded2 = [
    "id"
];
const useGridRowEditing_missingOnProcessRowUpdateErrorWarning = warning_buildWarning([
    'MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
    'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
    'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'
], 'error');
const useGridRowEditing = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = __WEBPACK_EXTERNAL_MODULE_react__.useState({});
    const rowModesModelRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(rowModesModel);
    const prevRowModesModel = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const focusTimeout = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const nextFocusedCell = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const { processRowUpdate, onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === gridEditRowModel_GridEditModes.Row) callback(...args);
        };
    const throwIfNotEditable = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === gridEditRowModel_GridRowModes.Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = esm_extends_extends({}, rowParams, {
            field: params.field,
            reason: gridRowParams_GridRowEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === gridEditRowModel_GridRowModes.View) return;
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            var _nextFocusedCell$curr;
            focusTimeout.current = null;
            if ((null == (_nextFocusedCell$curr = nextFocusedCell.current) ? void 0 : _nextFocusedCell$curr.id) !== params.id) {
                if (!apiRef.current.getRow(params.id)) return;
                if (apiRef.current.getRowMode(params.id) === gridEditRowModel_GridRowModes.View) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = esm_extends_extends({}, rowParams, {
                    field: params.field,
                    reason: gridRowParams_GridRowEditStopReasons.rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>()=>{
            clearTimeout(focusTimeout.current);
        }, []);
    const handleCellKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (params.cellMode === gridEditRowModel_GridRowModes.Edit) {
            if (229 === event.which) return;
            let reason;
            if ('Escape' === event.key) reason = gridRowParams_GridRowEditStopReasons.escapeKeyDown;
            else if ('Enter' === event.key) reason = gridRowParams_GridRowEditStopReasons.enterKeyDown;
            else if ('Tab' === event.key) {
                const columnFields = gridVisibleColumnFieldsSelector(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === GRID_ACTIONS_COLUMN_TYPE) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) reason = gridRowParams_GridRowEditStopReasons.shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) reason = gridRowParams_GridRowEditStopReasons.tabKeyDown;
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                const newParams = esm_extends_extends({}, apiRef.current.getRowParams(params.id), {
                    reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if (isPrintableKey(event)) reason = gridRowParams_GridRowEditStartReasons.printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && 'v' === event.key) reason = gridRowParams_GridRowEditStartReasons.printableKeyDown;
            else if ('Enter' === event.key) reason = gridRowParams_GridRowEditStartReasons.enterKeyDown;
            else if ('Delete' === event.key || 'Backspace' === event.key) reason = gridRowParams_GridRowEditStartReasons.deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = esm_extends_extends({}, rowParams, {
                    field: params.field,
                    reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleRowEditStart = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field, reason } = params;
        const startRowEditModeParams = {
            id,
            fieldToFocus: field
        };
        if (reason === gridRowParams_GridRowEditStartReasons.printableKeyDown || reason === gridRowParams_GridRowEditStartReasons.deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, reason, field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === gridRowParams_GridRowEditStopReasons.enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === gridRowParams_GridRowEditStopReasons.tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === gridRowParams_GridRowEditStopReasons.shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = 'escapeKeyDown' === reason;
        apiRef.current.stopRowEditMode({
            id,
            ignoreModifications,
            field,
            cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    useGridApiOptionHandler(apiRef, 'rowEditStart', props.onRowEditStart);
    useGridApiOptionHandler(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        if (props.editMode === gridEditRowModel_GridEditModes.Cell) return gridEditRowModel_GridRowModes.View;
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        const isEditing = editingState[id] && Object.keys(editingState[id]).length > 0;
        return isEditing ? gridEditRowModel_GridRowModes.Edit : gridEditRowModel_GridRowModes.View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = useEventCallback_useEventCallback((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {});
        if (props.rowModesModel && isNewModelDifferentFromProp) return;
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, newProps)=>{
        const newModel = esm_extends_extends({}, rowModesModelRef.current);
        if (null !== newProps) newModel[id] = esm_extends_extends({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = esm_extends_extends({}, state.editRows);
            if (null !== newProps) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return esm_extends_extends({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = esm_extends_extends({}, state.editRows);
            if (null !== newProps) newEditingState[id] = esm_extends_extends({}, newEditingState[id], {
                [field]: esm_extends_extends({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (0 === Object.keys(newEditingState[id]).length) delete newEditingState[id];
            }
            return esm_extends_extends({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id } = params, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(params, useGridRowEditing_excluded);
        throwIfNotInMode(id, gridEditRowModel_GridRowModes.View);
        updateRowInRowModesModel(id, esm_extends_extends({
            mode: gridEditRowModel_GridRowModes.Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = useEventCallback_useEventCallback((params)=>{
        const { id, fieldToFocus, deleteValue, initialValue } = params;
        const columnFields = gridColumnFieldsSelector(apiRef);
        const newProps = columnFields.reduce((acc, field)=>{
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) newValue = deleteValue ? '' : initialValue;
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: false
            };
            return acc;
        }, {});
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
    });
    const stopRowEditMode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id } = params, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(params, useGridRowEditing_excluded2);
        throwIfNotInMode(id, gridEditRowModel_GridRowModes.Edit);
        updateRowInRowModesModel(id, esm_extends_extends({
            mode: gridEditRowModel_GridRowModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = useEventCallback_useEventCallback((params)=>{
        const { id, ignoreModifications, field: focusedField, cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if ('none' !== cellToFocusAfter && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
        };
        if (ignoreModifications) return void finishRowEditMode();
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = gridEditRowModel_GridRowModes.Edit;
            return;
        }
        const hasSomeFieldWithError = Object.values(editingState[id]).some((fieldProps)=>fieldProps.error);
        if (hasSomeFieldWithError) {
            prevRowModesModel.current[id].mode = gridEditRowModel_GridRowModes.Edit;
            updateRowInRowModesModel(id, {
                mode: gridEditRowModel_GridRowModes.Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevRowModesModel.current[id].mode = gridEditRowModel_GridRowModes.Edit;
                updateRowInRowModesModel(id, {
                    mode: gridEditRowModel_GridRowModes.Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else useGridRowEditing_missingOnProcessRowUpdateErrorWarning();
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field, value, debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = gridEditRowsStateSelector(apiRef.current.state);
        let newProps = esm_extends_extends({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = esm_extends_extends({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_editingState$id, [
                    field
                ].map(toPropertyKey));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id,
                    row,
                    props: newProps,
                    hasChanged,
                    otherFieldsProps
                })).then((processedProps)=>{
                    if (apiRef.current.getRowMode(id) === gridEditRowModel_GridRowModes.View) return void resolve(false);
                    editingState = gridEditRowsStateSelector(apiRef.current.state);
                    processedProps = esm_extends_extends({}, processedProps, {
                        isProcessingProps: false
                    });
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = esm_extends_extends({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = gridEditRowsStateSelector(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_editingState$id2, [
                    thisField
                ].map(toPropertyKey));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id,
                    row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps
                })).then((processedProps)=>{
                    if (apiRef.current.getRowMode(id) === gridEditRowModel_GridRowModes.View) return void resolve(false);
                    processedProps = esm_extends_extends({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === gridEditRowModel_GridRowModes.Edit) {
                    editingState = gridEditRowsStateSelector(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = esm_extends_extends({}, row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            if (column.valueSetter) rowUpdate = column.valueSetter({
                value: fieldProps.value,
                row: rowUpdate
            });
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode,
        startRowEditMode,
        stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing
    };
    useGridApiMethod(apiRef, editingApi, 'public');
    useGridApiMethod(apiRef, editingPrivateApi, 'private');
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    useEnhancedEffect(()=>{
        const idToIdLookup = gridRowsDataRowIdToIdLookupSelector(apiRef);
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = deepClone(rowModesModel);
        Object.entries(rowModesModel).forEach(([id, params])=>{
            var _copyOfPrevRowModesMo, _idToIdLookup$id;
            const prevMode = (null == (_copyOfPrevRowModesMo = copyOfPrevRowModesModel[id]) ? void 0 : _copyOfPrevRowModesMo.mode) || gridEditRowModel_GridRowModes.View;
            const originalId = null != (_idToIdLookup$id = idToIdLookup[id]) ? _idToIdLookup$id : id;
            if (params.mode === gridEditRowModel_GridRowModes.Edit && prevMode === gridEditRowModel_GridRowModes.View) updateStateToStartRowEditMode(esm_extends_extends({
                id: originalId
            }, params));
            else if (params.mode === gridEditRowModel_GridRowModes.View && prevMode === gridEditRowModel_GridRowModes.Edit) updateStateToStopRowEditMode(esm_extends_extends({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};
const editingStateInitializer = (state)=>esm_extends_extends({}, state, {
        editRows: {}
    });
const useGridEditing = (apiRef, props)=>{
    useGridCellEditing(apiRef, props);
    useGridRowEditing(apiRef, props);
    const debounceMap = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        if (isAutoGeneratedRow(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) return void callback();
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (field) {
            if (debounceMap.current[id][field]) {
                const [, runCallback] = debounceMap.current[id][field];
                runCallback();
            }
        } else Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
    }, []);
    const setEditCellValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { id, field, debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === gridEditRowModel_GridEditModes.Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                if (apiRef.current.getCellMode(id, field) === gridEditRowModel_GridCellModes.Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>props.editMode === gridEditRowModel_GridEditModes.Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id), [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        var _editingState$id$fiel, _editingState$id;
        const editingState = gridEditRowsStateSelector(apiRef.current.state);
        return null != (_editingState$id$fiel = null == (_editingState$id = editingState[id]) ? void 0 : _editingState$id[field]) ? _editingState$id$fiel : null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable,
        setEditCellValue,
        getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation
    };
    useGridApiMethod(apiRef, editingSharedApi, 'public');
    useGridApiMethod(apiRef, editingSharedPrivateApi, 'private');
};
const rowsStateInitializer = (state, props, apiRef)=>{
    apiRef.current.caches.rows = createRowsInternalCache({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return esm_extends_extends({}, state, {
        rows: getRowsStateFromCache({
            apiRef,
            rowCountProp: props.rowCount,
            loadingProp: props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const useGridRows = (apiRef, props)=>{
    if ('production' !== process.env.NODE_ENV) try {
        Object.freeze(props.rows);
    } catch (error) {}
    const logger = useGridLogger(apiRef, 'useGridRows');
    const currentPage = useGridVisibleRows(apiRef, props);
    const lastUpdateMs = __WEBPACK_EXTERNAL_MODULE_react__.useRef(Date.now());
    const timeout = useTimeout();
    const getRow = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        const model = gridRowsLookupSelector(apiRef)[id];
        if (model) return model;
        const node = apiRef.current.getRowNode(id);
        if (node && isAutoGeneratedRow(node)) return {
            [GRID_ID_AUTOGENERATED]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowIdProp = props.getRowId;
    const getRowId = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((row)=>{
        if (GRID_ID_AUTOGENERATED in row) return row[GRID_ID_AUTOGENERATED];
        if (getRowIdProp) return getRowIdProp(row);
        return row.id;
    }, [
        getRowIdProp
    ]);
    const lookup = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>currentPage.rows.reduce((acc, { id }, index)=>{
            acc[id] = index;
            return acc;
        }, {}), [
        currentPage.rows
    ]);
    const throttledRowsChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ cache, throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                    rows: getRowsStateFromCache({
                        apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: gridRowTreeSelector(apiRef),
                        previousTreeDepths: gridRowTreeDepthsSelector(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
            apiRef.current.forceUpdate();
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) return void run();
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) return void timeout.start(throttleRemainingTimeMs, run);
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    const setRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = createRowsInternalCache({
            rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((updates)=>{
        if (props.signature === useGridApiEventHandler_GridSignature.DataGrid && updates.length > 1) throw new Error("MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.\nYou need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.");
        const nonPinnedRowsUpdates = [];
        updates.forEach((update)=>{
            const id = getRowIdFromRowModel(update, props.getRowId, 'A row was provided without id when calling updateRows():');
            const rowNode = apiRef.current.getRowNode(id);
            if ((null == rowNode ? void 0 : rowNode.type) === 'pinnedRow') {
                const pinnedRowsCache = apiRef.current.caches.pinnedRows;
                const prevModel = pinnedRowsCache.idLookup[id];
                if (prevModel) pinnedRowsCache.idLookup[id] = esm_extends_extends({}, prevModel, update);
            } else nonPinnedRowsUpdates.push(update);
        });
        const cache = updateCacheWithNewRows({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache,
            throttle: true
        });
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const getRowModels = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const dataRows = gridDataRowIdsSelector(apiRef);
        const idRowsLookup = gridRowsLookupSelector(apiRef);
        return new Map(dataRows.map((id)=>{
            var _idRowsLookup$id;
            return [
                id,
                null != (_idRowsLookup$id = idRowsLookup[id]) ? _idRowsLookup$id : {}
            ];
        }));
    }, [
        apiRef
    ]);
    const getRowsCount = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>gridRowCountSelector(apiRef), [
        apiRef
    ]);
    const getAllRowIds = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>gridDataRowIdsSelector(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>lookup[id], [
        lookup
    ]);
    const setRowChildrenExpansion = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI: No row with id #${id} found`);
        if ('group' !== currentNode.type) throw new Error('MUI: Only group nodes can be expanded or collapsed');
        const newNode = esm_extends_extends({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                rows: esm_extends_extends({}, state.rows, {
                    tree: esm_extends_extends({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            }));
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const getRowNode = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        var _ref;
        return null != (_ref = gridRowTreeSelector(apiRef)[id]) ? _ref : null;
    }, [
        apiRef
    ]);
    const getRowGroupChildren = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ skipAutoGeneratedRows = true, groupId, applySorting, applyFiltering })=>{
        const tree = gridRowTreeSelector(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = gridSortedRowIdsSelector(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !isAutoGeneratedRow(tree[id])) children.push(id);
            }
        } else children = getTreeNodeDescendants(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = gridFilteredRowsLookupSelector(apiRef);
            children = children.filter((childId)=>false !== filteredRowsLookup[childId]);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rowId, targetIndex)=>{
        const node = apiRef.current.getRowNode(rowId);
        if (!node) throw new Error(`MUI: No row with id #${rowId} found`);
        if (node.parent !== GRID_ROOT_GROUP_ID) throw new Error("MUI: The row reordering do not support reordering of grouped rows yet");
        if ('leaf' !== node.type) throw new Error("MUI: The row reordering do not support reordering of footer or grouping rows");
        apiRef.current.setState((state)=>{
            const group = gridRowTreeSelector(state, apiRef.current.instanceId)[GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (-1 === oldIndex || oldIndex === targetIndex) return state;
            logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return esm_extends_extends({}, state, {
                rows: esm_extends_extends({}, state.rows, {
                    tree: esm_extends_extends({}, state.rows.tree, {
                        [GRID_ROOT_GROUP_ID]: esm_extends_extends({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === useGridApiEventHandler_GridSignature.DataGrid && newRows.length > 1) throw new Error("MUI: You can't replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.\nYou need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.");
        if (0 === newRows.length) return;
        const treeDepth = gridRowMaximumTreeDepthSelector(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = esm_extends_extends({}, gridRowTreeSelector(apiRef));
        const dataRowIdToModelLookup = esm_extends_extends({}, gridRowsLookupSelector(apiRef));
        const dataRowIdToIdLookup = esm_extends_extends({}, gridRowsDataRowIdToIdLookupSelector(apiRef));
        const rootGroup = tree[GRID_ROOT_GROUP_ID];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = getRowIdFromRowModel(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete dataRowIdToIdLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: GRID_ROOT_GROUP_ID,
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            dataRowIdToIdLookup[rowId] = rowId;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[GRID_ROOT_GROUP_ID] = esm_extends_extends({}, rootGroup, {
            children: rootGroupChildren
        });
        const dataRowIds = rootGroupChildren.filter((childId)=>'leaf' === tree[childId].type);
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                rows: esm_extends_extends({}, state.rows, {
                    dataRowIdToModelLookup,
                    dataRowIdToIdLookup,
                    dataRowIds,
                    tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow,
        getRowId,
        getRowModels,
        getRowsCount,
        getAllRowIds,
        setRows,
        updateRows,
        getRowNode,
        getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex,
        setRowChildrenExpansion,
        getRowGroupChildren
    };
    const groupRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        logger.info("Row grouping pre-processing have changed, regenerating the row tree");
        let cache;
        cache = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows ? esm_extends_extends({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: gridDataRowIdsSelector(apiRef)
            }
        }) : createRowsInternalCache({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const handleStrategyProcessorChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((methodName)=>{
        if ('rowTreeCreation' === methodName) groupRows();
    }, [
        groupRows
    ]);
    const handleStrategyActivityChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (apiRef.current.getActiveStrategy('rowTree') !== gridRowGroupingNameSelector(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    const applyHydrateRowsProcessor = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: gridRowTreeSelector(state, apiRef.current.instanceId),
                treeDepths: gridRowTreeDepthsSelector(state, apiRef.current.instanceId),
                dataRowIds: gridDataRowIdsSelector(state, apiRef.current.instanceId),
                dataRowIdToModelLookup: gridRowsLookupSelector(state, apiRef.current.instanceId),
                dataRowIdToIdLookup: gridRowsDataRowIdToIdLookupSelector(state, apiRef.current.instanceId)
            });
            return esm_extends_extends({}, state, {
                rows: esm_extends_extends({}, state.rows, response, {
                    totalTopLevelRowCount: getTopLevelRowCount({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.rowCount
    ]);
    useGridRegisterPipeApplier(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    useGridApiMethod(apiRef, rowApi, 'public');
    useGridApiMethod(apiRef, rowProApi, props.signature === useGridApiEventHandler_GridSignature.DataGrid ? 'private' : 'public');
    const isFirstRender = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        if (areNewRowsAlreadyInState) {
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                        rows: esm_extends_extends({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                        rows: esm_extends_extends({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            return;
        }
        logger.debug(`Updating all rows, new length ${props.rows.length}`);
        throttledRowsChange({
            cache: createRowsInternalCache({
                rows: props.rows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};
const createFlatRowTree = (rows)=>{
    const tree = {
        [GRID_ROOT_GROUP_ID]: esm_extends_extends({}, buildRootGroup(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: GRID_DEFAULT_STRATEGY,
        tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const updateFlatRowTree = ({ previousTree, actions })=>{
    const tree = esm_extends_extends({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    const rootGroup = tree[GRID_ROOT_GROUP_ID];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[GRID_ROOT_GROUP_ID] = esm_extends_extends({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: GRID_DEFAULT_STRATEGY,
        tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const flatRowTreeCreationMethod = (params)=>{
    if ('full' === params.updates.type) return createFlatRowTree(params.updates.rows);
    return updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const useGridRowsPreProcessors = (apiRef)=>{
    useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'rowTreeCreation', flatRowTreeCreationMethod);
};
class MissingRowIdError extends Error {
}
function useGridParamsApi(apiRef, props) {
    const { getRowId } = props;
    const getColumnHeaderParams = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>({
            field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new MissingRowIdError(`No row with id #${id} found`);
        const params = {
            id,
            columns: apiRef.current.getAllColumns(),
            row
        };
        return params;
    }, [
        apiRef
    ]);
    const getBaseCellParams = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new MissingRowIdError(`No row with id #${id} found`);
        const cellFocus = gridFocusCellSelector(apiRef);
        const cellTabIndex = gridTabIndexCellSelector(apiRef);
        const params = {
            id,
            field,
            row,
            rowNode,
            value: row[field],
            colDef: apiRef.current.getColumn(field),
            cellMode: apiRef.current.getCellMode(id, field),
            api: apiRef.current,
            hasFocus: null !== cellFocus && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const value = apiRef.current.getCellValue(id, field);
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new MissingRowIdError(`No row with id #${id} found`);
        const cellFocus = gridFocusCellSelector(apiRef);
        const cellTabIndex = gridTabIndexCellSelector(apiRef);
        const params = {
            id,
            field,
            row,
            rowNode,
            colDef,
            cellMode: apiRef.current.getCellMode(id, field),
            hasFocus: null !== cellFocus && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            value,
            formattedValue: value,
            isEditable: false
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter({
            id,
            field: params.field,
            value: params.value,
            api: apiRef.current
        });
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        if (!colDef || !colDef.valueGetter) {
            const rowModel = apiRef.current.getRow(id);
            if (!rowModel) throw new MissingRowIdError(`No row with id #${id} found`);
            return rowModel[field];
        }
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        apiRef,
        getBaseCellParams
    ]);
    const getRowValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((row, colDef)=>{
        var _getRowId;
        const id = GRID_ID_AUTOGENERATED in row ? row[GRID_ID_AUTOGENERATED] : null != (_getRowId = null == getRowId ? void 0 : getRowId(row)) ? _getRowId : row.id;
        const field = colDef.field;
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        getBaseCellParams,
        getRowId
    ]);
    const getRowFormattedValue = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((row, colDef)=>{
        var _ref;
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        const id = null != (_ref = getRowId ? getRowId(row) : row.id) ? _ref : row[GRID_ID_AUTOGENERATED];
        const field = colDef.field;
        return colDef.valueFormatter({
            id,
            field,
            value,
            api: apiRef.current
        });
    }, [
        apiRef,
        getRowId,
        getRowValue
    ]);
    const getColumnHeaderElement = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return getGridColumnHeaderElement(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return getGridRowElement(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return getGridCellElement(apiRef.current.rootElementRef.current, {
            id,
            field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue,
        getCellParams,
        getCellElement,
        getRowValue,
        getRowFormattedValue,
        getRowParams,
        getRowElement,
        getColumnHeaderParams,
        getColumnHeaderElement
    };
    useGridApiMethod(apiRef, paramsApi, 'public');
}
const getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (null == selectionModelProp) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const rowSelectionStateInitializer = (state, props)=>{
    var _getSelectionModelPro;
    return esm_extends_extends({}, state, {
        rowSelection: props.rowSelection ? null != (_getSelectionModelPro = getSelectionModelPropValue(props.rowSelectionModel)) ? _getSelectionModelPro : [] : []
    });
};
const useGridRowSelection = (apiRef, props)=>{
    const logger = useGridLogger(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = (callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        };
    const propRowSelectionModel = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>getSelectionModelPropValue(props.rowSelectionModel, gridRowSelectionStateSelector(apiRef.current.state)), [
        apiRef,
        props.rowSelectionModel
    ]);
    const lastRowToggled = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: gridRowSelectionStateSelector,
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection, disableMultipleRowSelection, disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = !disableMultipleRowSelection || checkboxSelection;
    const visibleRows = useGridVisibleRows(apiRef, props);
    const expandMouseRowRangeSelection = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        var _lastRowToggled$curre;
        let endId = id;
        const startId = null != (_lastRowToggled$curre = lastRowToggled.current) ? _lastRowToggled$curre : id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = gridExpandedSortedRowIdsSelector(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            endId = startIndex > endIndex ? visibleRowIds[endIndex + 1] : visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId,
            endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    const setRowSelectionModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((model)=>{
        if (props.signature === useGridApiEventHandler_GridSignature.DataGrid && !props.checkboxSelection && Array.isArray(model) && model.length > 1) throw new Error("MUI: `rowSelectionModel` can only contain 1 item in DataGrid.\nYou need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.");
        const currentModel = gridRowSelectionStateSelector(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug("Setting selection model");
            apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                    rowSelection: props.rowSelection ? model : []
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        props.checkboxSelection
    ]);
    const isRowSelected = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>gridRowSelectionStateSelector(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = apiRef.current.getRowNode(id);
        if ((null == rowNode ? void 0 : rowNode.type) === 'footer' || (null == rowNode ? void 0 : rowNode.type) === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        propIsRowSelectable
    ]);
    const getSelectedRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>selectedGridRowsSelector(apiRef), [
        apiRef
    ]);
    const selectRow = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            apiRef.current.setRowSelectionModel(isSelected ? [
                id
            ] : []);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = gridRowSelectionStateSelector(apiRef.current.state);
            const newSelection = selection.filter((el)=>el !== id);
            if (isSelected) newSelection.push(id);
            const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug("Setting selection for several rows");
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) newSelection = isSelected ? selectableIds : [];
        else {
            const selectionLookup = esm_extends_extends({}, selectedIdsLookupSelector(apiRef));
            selectableIds.forEach((id)=>{
                if (isSelected) selectionLookup[id] = id;
                else delete selectionLookup[id];
            });
            newSelection = Object.values(selectionLookup);
        }
        const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRowRange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ startId, endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        const allPagesRowIds = gridExpandedSortedRowIdsSelector(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow,
        setRowSelectionModel,
        getSelectedRows,
        isRowSelected,
        isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows,
        selectRowRange
    };
    useGridApiMethod(apiRef, selectionPublicApi, 'public');
    useGridApiMethod(apiRef, selectionPrivateApi, props.signature === useGridApiEventHandler_GridSignature.DataGrid ? 'private' : 'public');
    const removeOutdatedSelection = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (props.keepNonExistentRowsSelected) return;
        const currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
        const rowsLookup = gridRowsLookupSelector(apiRef);
        const selectionLookup = esm_extends_extends({}, selectedIdsLookupSelector(apiRef));
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (!rowsLookup[id]) {
                delete selectionLookup[id];
                hasChanged = true;
            }
        });
        if (hasChanged) apiRef.current.setRowSelectionModel(Object.values(selectionLookup));
    }, [
        apiRef,
        props.keepNonExistentRowsSelected
    ]);
    const handleSingleRowSelection = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !isKeyboardEvent(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, isMultipleSelectionDisabled ? true : !isSelected, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        var _closest;
        if (disableRowSelectionOnClick) return;
        const field = null == (_closest = event.target.closest(`.${gridClasses_gridClasses.cell}`)) ? void 0 : _closest.getAttribute('data-field');
        if (field === GRID_CHECKBOX_SELECTION_COL_DEF.field) return;
        if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if ((null == column ? void 0 : column.type) === GRID_ACTIONS_COLUMN_TYPE) return;
        }
        const rowNode = apiRef.current.getRowNode(params.id);
        if ('pinnedRow' === rowNode.type) return;
        if (event.shiftKey && (canHaveMultipleSelection || checkboxSelection)) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        checkboxSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) {
            var _window$getSelection;
            null == (_window$getSelection = window.getSelection()) || _window$getSelection.removeAllRanges();
        }
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value);
    }, [
        apiRef,
        expandMouseRowRangeSelection
    ]);
    const handleHeaderSelectionCheckboxChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const shouldLimitSelectionToCurrentPage = props.checkboxSelectionVisibleOnly && props.pagination;
        const rowsToBeSelected = shouldLimitSelectionToCurrentPage ? gridPaginatedVisibleSortedGridRowIdsSelector(apiRef) : gridExpandedSortedRowIdsSelector(apiRef);
        const filterModel = gridFilterModelSelector(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value, (null == filterModel ? void 0 : filterModel.items.length) > 0);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination
    ]);
    const handleCellKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, event)=>{
        if (apiRef.current.getCellMode(params.id, params.field) === gridEditRowModel_GridCellModes.Edit) return;
        if (isEventTargetInPortal(event)) return;
        if (isNavigationKey(event.key) && event.shiftKey) {
            const focusCell = gridFocusCellSelector(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) return void apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) if (isNextRowSelected) {
                    start = previousRowIndex;
                    end = newRowIndex - 1;
                } else {
                    start = previousRowIndex;
                    end = newRowIndex;
                }
                else if (isNextRowSelected) {
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (' ' === event.key && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if ('a' === event.key && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        visibleRows.rows,
        canHaveMultipleSelection
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(removeOutdatedSelection));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (void 0 !== propRowSelectionModel) apiRef.current.setRowSelectionModel(propRowSelectionModel);
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!props.rowSelection) apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        props.rowSelection
    ]);
    const isStateControlled = null != propRowSelectionModel;
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (isStateControlled || !props.rowSelection) return;
        const currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
};
const useGridRowSelectionPreProcessors_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return composeClasses(slots, getDataGridUtilityClass, classes);
    }, [
        classes
    ]);
};
const useGridRowSelectionPreProcessors = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = useGridRowSelectionPreProcessors_useUtilityClasses(ownerState);
    const updateSelectionColumn = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columnsState)=>{
        const selectionColumn = esm_extends_extends({}, GRID_CHECKBOX_SELECTION_COL_DEF, {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const haveSelectionColumn = null != columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD];
        if (shouldHaveSelectionColumn && !haveSelectionColumn) {
            columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
            columnsState.orderedFields = [
                GRID_CHECKBOX_SELECTION_FIELD,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && haveSelectionColumn) {
            delete columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== GRID_CHECKBOX_SELECTION_FIELD);
        } else if (shouldHaveSelectionColumn && haveSelectionColumn) columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD] = esm_extends_extends({}, selectionColumn, columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD]);
        return columnsState;
    }, [
        apiRef,
        classes,
        props.checkboxSelection
    ]);
    useGridRegisterPipeProcessor(apiRef, 'hydrateColumns', updateSelectionColumn);
};
const sortingStateInitializer = (state, props)=>{
    var _ref, _props$sortModel, _props$initialState;
    const sortModel = null != (_ref = null != (_props$sortModel = props.sortModel) ? _props$sortModel : null == (_props$initialState = props.initialState) || null == (_props$initialState = _props$initialState.sorting) ? void 0 : _props$initialState.sortModel) ? _ref : [];
    return esm_extends_extends({}, state, {
        sorting: {
            sortModel: sanitizeSortModel(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const useGridSorting = (apiRef, props)=>{
    var _props$initialState3;
    const logger = useGridLogger(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: gridSortModelSelector,
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field, sortItem)=>{
        const sortModel = gridSortModelSelector(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) if (sortItem) newSortModel.splice(existingIdx, 1, sortItem);
        else newSortModel.splice(existingIdx, 1);
        else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((col, directionOverride)=>{
        var _col$sortingOrder2;
        const sortModel = gridSortModelSelector(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            var _col$sortingOrder;
            const nextSort = void 0 === directionOverride ? getNextGridSortDirection(null != (_col$sortingOrder = col.sortingOrder) ? _col$sortingOrder : props.sortingOrder, existing.sort) : directionOverride;
            return null == nextSort ? void 0 : esm_extends_extends({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: void 0 === directionOverride ? getNextGridSortDirection(null != (_col$sortingOrder2 = col.sortingOrder) ? _col$sortingOrder2 : props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columnMenuItems, colDef)=>{
        if (null == colDef || false === colDef.sortable) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder
    ]);
    const applySorting = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if ('server' === props.sortingMode) {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return esm_extends_extends({}, state, {
                    sorting: esm_extends_extends({}, state.sorting, {
                        sortedRows: getTreeNodeDescendants(gridRowTreeSelector(apiRef), GRID_ROOT_GROUP_ID, false)
                    })
                });
            }
            const sortModel = gridSortModelSelector(state, apiRef.current.instanceId);
            const sortRowList = buildAggregatedSortingApplier(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList
            });
            return esm_extends_extends({}, state, {
                sorting: esm_extends_extends({}, state.sorting, {
                    sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((model)=>{
        const currentModel = gridSortModelSelector(apiRef);
        if (currentModel !== model) {
            logger.debug("Setting sort model");
            apiRef.current.setState(mergeStateWithSortModel(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((column, direction, allowMultipleSorting)=>{
        if (!column.sortable) return;
        const sortItem = createSortItem(column, direction);
        let sortModel;
        sortModel = !allowMultipleSorting || props.disableMultipleColumnsSorting ? sortItem ? [
            sortItem
        ] : [] : upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>gridSortModelSelector(apiRef), [
        apiRef
    ]);
    const getSortedRows = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const sortedRows = gridSortedRowEntriesSelector(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>gridSortedRowIdsSelector(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel,
        getSortedRows,
        getSortedRowIds,
        getRowIdFromRowIndex,
        setSortModel,
        sortColumn,
        applySorting
    };
    useGridApiMethod(apiRef, sortApi, 'public');
    const stateExportPreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((prevState, context)=>{
        var _props$initialState2;
        const sortModelToExport = gridSortModelSelector(apiRef);
        const shouldExportSortModel = !context.exportOnlyDirtyModels || null != props.sortModel || (null == (_props$initialState2 = props.initialState) || null == (_props$initialState2 = _props$initialState2.sorting) ? void 0 : _props$initialState2.sortModel) != null || sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return esm_extends_extends({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        null == (_props$initialState3 = props.initialState) || null == (_props$initialState3 = _props$initialState3.sorting) ? void 0 : _props$initialState3.sortModel
    ]);
    const stateRestorePreProcessing = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params, context)=>{
        var _context$stateToResto;
        const sortModel = null == (_context$stateToResto = context.stateToRestore.sorting) ? void 0 : _context$stateToResto.sortModel;
        if (null == sortModel) return params;
        apiRef.current.setState(mergeStateWithSortModel(sortModel, props.disableMultipleColumnsSorting));
        return esm_extends_extends({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const rowTree = gridRowTreeSelector(apiRef);
        const rootGroupNode = rowTree[GRID_ROOT_GROUP_ID];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (null != rootGroupNode.footerId) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
    useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'sorting', flatSortingMethod);
    const handleColumnHeaderClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ colDef }, event)=>{
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(colDef, void 0, allowMultipleSorting);
    }, [
        sortColumn
    ]);
    const handleColumnHeaderKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ colDef }, event)=>{
        if (isEnterKey(event.key) && !event.ctrlKey && !event.metaKey) sortColumn(colDef, void 0, event.shiftKey);
    }, [
        sortColumn
    ]);
    const handleColumnsChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const sortModel = gridSortModelSelector(apiRef);
        const latestColumns = gridColumnLookupSelector(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((methodName)=>{
        if ('sorting' === methodName) apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'columnMenu', addColumnMenuItem);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowsSet', apiRef.current.applySorting);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnsChange', handleColumnsChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    useFirstRender(()=>{
        apiRef.current.applySorting();
    });
    useEnhancedEffect(()=>{
        if (void 0 !== props.sortModel) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};
function scrollIntoView(dimensions) {
    const { clientHeight, scrollTop, offsetHeight, offsetTop } = dimensions;
    const elementBottom = offsetTop + offsetHeight;
    if (offsetHeight > clientHeight) return offsetTop;
    if (elementBottom - clientHeight > scrollTop) return elementBottom - clientHeight;
    if (offsetTop < scrollTop) return offsetTop;
}
const useGridScroll = (apiRef, props)=>{
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const logger = useGridLogger(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersElementRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = useGridSelector(apiRef, gridExpandedSortedRowEntriesSelector);
    const scrollToIndexes = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const totalRowCount = gridRowCountSelector(apiRef);
        const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
        const scrollToHeader = null == params.rowIndex;
        if (!scrollToHeader && 0 === totalRowCount || 0 === visibleColumns.length) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (null != params.colIndex) {
            const columnPositions = gridColumnPositionsSelector(apiRef);
            let cellWidth;
            if (void 0 !== params.rowIndex) {
                var _visibleSortedRows$pa;
                const rowId = null == (_visibleSortedRows$pa = visibleSortedRows[params.rowIndex]) ? void 0 : _visibleSortedRows$pa.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (void 0 === cellWidth) cellWidth = visibleColumns[params.colIndex].computedWidth;
            scrollCoordinates.left = scrollIntoView({
                clientHeight: virtualScrollerRef.current.clientWidth,
                scrollTop: Math.abs(virtualScrollerRef.current.scrollLeft),
                offsetHeight: cellWidth,
                offsetTop: columnPositions[params.colIndex]
            });
        }
        if (null != params.rowIndex) {
            var _querySelector, _querySelector2;
            const rowsMeta = gridRowsMetaSelector(apiRef.current.state);
            const page = gridPageSelector(apiRef);
            const pageSize = gridPageSizeSelector(apiRef);
            const elementIndex = props.pagination ? params.rowIndex - page * pageSize : params.rowIndex;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            const topPinnedRowsHeight = (null == (_querySelector = virtualScrollerRef.current.querySelector(`.${gridClasses_gridClasses["pinnedRows--top"]}`)) ? void 0 : _querySelector.clientHeight) || 0;
            const bottomPinnedRowsHeight = (null == (_querySelector2 = virtualScrollerRef.current.querySelector(`.${gridClasses_gridClasses["pinnedRows--bottom"]}`)) ? void 0 : _querySelector2.clientHeight) || 0;
            scrollCoordinates.top = scrollIntoView({
                clientHeight: virtualScrollerRef.current.clientHeight - topPinnedRowsHeight - bottomPinnedRowsHeight,
                scrollTop: virtualScrollerRef.current.scrollTop,
                offsetHeight: targetOffsetHeight,
                offsetTop: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows
    ]);
    const scroll = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        if (virtualScrollerRef.current && null != params.left && colRef.current) {
            const direction = 'rtl' === theme.direction ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && null != params.top) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug("Scrolling, updating container, and viewport");
    }, [
        virtualScrollerRef,
        theme.direction,
        colRef,
        logger
    ]);
    const getScrollPosition = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (!(null != virtualScrollerRef && virtualScrollerRef.current)) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll,
        scrollToIndexes,
        getScrollPosition
    };
    useGridApiMethod(apiRef, scrollApi, 'public');
};
function useGridEvents(apiRef, props) {
    useGridApiOptionHandler(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    useGridApiOptionHandler(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    useGridApiOptionHandler(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    useGridApiOptionHandler(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    useGridApiOptionHandler(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    useGridApiOptionHandler(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    useGridApiOptionHandler(apiRef, 'cellClick', props.onCellClick);
    useGridApiOptionHandler(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    useGridApiOptionHandler(apiRef, 'cellKeyDown', props.onCellKeyDown);
    useGridApiOptionHandler(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    useGridApiOptionHandler(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    useGridApiOptionHandler(apiRef, 'menuOpen', props.onMenuOpen);
    useGridApiOptionHandler(apiRef, 'menuClose', props.onMenuClose);
    useGridApiOptionHandler(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    useGridApiOptionHandler(apiRef, 'rowClick', props.onRowClick);
    useGridApiOptionHandler(apiRef, 'stateChange', props.onStateChange);
}
function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}
function ownerWindow(node) {
    const doc = ownerDocument(node);
    return doc.defaultView || window;
}
const isTestEnvironment = 'test' === process.env.NODE_ENV;
const hasScroll = ({ content, container, scrollBarSize })=>{
    const hasScrollXIfNoYScrollBar = content.width > container.width;
    const hasScrollYIfNoXScrollBar = content.height > container.height;
    let hasScrollX = false;
    let hasScrollY = false;
    if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
        hasScrollX = hasScrollXIfNoYScrollBar;
        hasScrollY = content.height + (hasScrollX ? scrollBarSize : 0) > container.height;
        if (hasScrollY) hasScrollX = content.width + scrollBarSize > container.width;
    }
    return {
        hasScrollX,
        hasScrollY
    };
};
function useGridDimensions(apiRef, props) {
    const logger = useGridLogger(apiRef, 'useResizeContainer');
    const errorShown = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const rootDimensionsRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const fullDimensionsRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const rowsMeta = useGridSelector(apiRef, gridRowsMetaSelector);
    const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    const totalHeaderHeight = getTotalHeaderHeight(apiRef, props.columnHeaderHeight);
    const updateGridDimensionsRef = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        var _apiRef$current$rootE;
        const rootElement = null == (_apiRef$current$rootE = apiRef.current.rootElementRef) ? void 0 : _apiRef$current$rootE.current;
        const columnsTotalWidth = gridColumnsTotalWidthSelector(apiRef);
        const pinnedRowsHeight = calculatePinnedRowsHeight(apiRef);
        if (!rootDimensionsRef.current) return;
        let scrollBarSize;
        if (null != props.scrollbarSize) scrollBarSize = props.scrollbarSize;
        else if (columnsTotalWidth && rootElement) {
            const doc = ownerDocument(rootElement);
            const scrollDiv = doc.createElement('div');
            scrollDiv.style.width = '99px';
            scrollDiv.style.height = '99px';
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.overflow = 'scroll';
            scrollDiv.className = 'scrollDiv';
            rootElement.appendChild(scrollDiv);
            scrollBarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            rootElement.removeChild(scrollDiv);
        } else scrollBarSize = 0;
        let viewportOuterSize;
        let hasScrollX;
        let hasScrollY;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rowsMeta.currentPageTotalHeight + (hasScrollX ? scrollBarSize : 0)
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: Math.max(rootDimensionsRef.current.height - totalHeaderHeight, 0)
            };
            const scrollInformation = hasScroll({
                content: {
                    width: Math.round(columnsTotalWidth),
                    height: rowsMeta.currentPageTotalHeight
                },
                container: {
                    width: Math.round(viewportOuterSize.width),
                    height: viewportOuterSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom
                },
                scrollBarSize
            });
            hasScrollY = scrollInformation.hasScrollY;
            hasScrollX = scrollInformation.hasScrollX;
        }
        const viewportInnerSize = {
            width: viewportOuterSize.width - (hasScrollY ? scrollBarSize : 0),
            height: viewportOuterSize.height - (hasScrollX ? scrollBarSize : 0)
        };
        const newFullDimensions = {
            viewportOuterSize,
            viewportInnerSize,
            hasScrollX,
            hasScrollY,
            scrollBarSize
        };
        const prevDimensions = fullDimensionsRef.current;
        fullDimensionsRef.current = newFullDimensions;
        if (newFullDimensions.viewportInnerSize.width !== (null == prevDimensions ? void 0 : prevDimensions.viewportInnerSize.width) || newFullDimensions.viewportInnerSize.height !== (null == prevDimensions ? void 0 : prevDimensions.viewportInnerSize.height)) apiRef.current.publishEvent('viewportInnerSizeChange', newFullDimensions.viewportInnerSize);
    }, [
        apiRef,
        props.scrollbarSize,
        props.autoHeight,
        rowsMeta.currentPageTotalHeight,
        totalHeaderHeight
    ]);
    const [savedSize, setSavedSize] = __WEBPACK_EXTERNAL_MODULE_react__.useState();
    const debouncedSetSavedSize = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>debounce(setSavedSize, 60), []);
    const previousSize = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    useEnhancedEffect(()=>{
        if (savedSize) {
            updateGridDimensionsRef();
            apiRef.current.publishEvent('debouncedResize', rootDimensionsRef.current);
        }
    }, [
        apiRef,
        savedSize,
        updateGridDimensionsRef
    ]);
    const resize = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.computeSizeAndPublishResizeEvent();
    }, [
        apiRef
    ]);
    const getRootDimensions = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>fullDimensionsRef.current, []);
    const getViewportPageSize = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return 0;
        const currentPage = getVisibleRows(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        if (props.getRowHeight) {
            const renderContext = apiRef.current.getRenderContext();
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode,
        props.getRowHeight,
        rowHeight
    ]);
    const computeSizeAndPublishResizeEvent = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        var _apiRef$current$mainE, _previousSize$current, _previousSize$current2;
        const mainEl = null == (_apiRef$current$mainE = apiRef.current.mainElementRef) ? void 0 : _apiRef$current$mainE.current;
        if (!mainEl) return;
        const win = ownerWindow(mainEl);
        const computedStyle = win.getComputedStyle(mainEl);
        const height = parseFloat(computedStyle.height) || 0;
        const width = parseFloat(computedStyle.width) || 0;
        const hasHeightChanged = height !== (null == (_previousSize$current = previousSize.current) ? void 0 : _previousSize$current.height);
        const hasWidthChanged = width !== (null == (_previousSize$current2 = previousSize.current) ? void 0 : _previousSize$current2.width);
        if (!previousSize.current || hasHeightChanged || hasWidthChanged) {
            const size = {
                width,
                height
            };
            apiRef.current.publishEvent('resize', size);
            previousSize.current = size;
        }
    }, [
        apiRef
    ]);
    const dimensionsApi = {
        resize,
        getRootDimensions
    };
    const dimensionsPrivateApi = {
        getViewportPageSize,
        updateGridDimensionsRef,
        computeSizeAndPublishResizeEvent
    };
    useGridApiMethod(apiRef, dimensionsApi, 'public');
    useGridApiMethod(apiRef, dimensionsPrivateApi, 'private');
    const isFirstSizing = __WEBPACK_EXTERNAL_MODULE_react__.useRef(true);
    const handleResize = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((size)=>{
        rootDimensionsRef.current = size;
        const isJSDOM = /jsdom/.test(window.navigator.userAgent);
        if (0 === size.height && !errorShown.current && !props.autoHeight && !isJSDOM) {
            logger.error("The parent DOM element of the data grid has an empty height.\nPlease make sure that this element has an intrinsic height.\nThe grid displays with a height of 0px.\n\nMore details: https://mui.com/r/x-data-grid-no-dimensions.");
            errorShown.current = true;
        }
        if (0 === size.width && !errorShown.current && !isJSDOM) {
            logger.error("The parent DOM element of the data grid has an empty width.\nPlease make sure that this element has an intrinsic width.\nThe grid displays with a width of 0px.\n\nMore details: https://mui.com/r/x-data-grid-no-dimensions.");
            errorShown.current = true;
        }
        if (isTestEnvironment) {
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        if (isFirstSizing.current) {
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        debouncedSetSavedSize(size);
    }, [
        props.autoHeight,
        debouncedSetSavedSize,
        logger
    ]);
    useEnhancedEffect(()=>updateGridDimensionsRef(), [
        updateGridDimensionsRef
    ]);
    useGridApiOptionHandler(apiRef, 'sortedRowsSet', updateGridDimensionsRef);
    useGridApiOptionHandler(apiRef, 'paginationModelChange', updateGridDimensionsRef);
    useGridApiOptionHandler(apiRef, 'columnsChange', updateGridDimensionsRef);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'resize', handleResize);
    useGridApiOptionHandler(apiRef, 'debouncedResize', props.onResize);
}
const GRID_DEFAULT_LOCALE_TEXT = {
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>1 !== count ? `${count} active filters` : `${count} active filter`,
    toolbarQuickFilterPlaceholder: 'Search…',
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    columnsPanelTextFieldLabel: 'Find column',
    columnsPanelTextFieldPlaceholder: 'Column title',
    columnsPanelDragIconLabel: 'Reorder column',
    columnsPanelShowAllButton: 'Show all',
    columnsPanelHideAllButton: 'Hide all',
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    filterOperatorContains: 'contains',
    filterOperatorEquals: 'equals',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    columnHeaderFiltersTooltipActive: (count)=>1 !== count ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    footerRowSelected: (count)=>1 !== count ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    footerTotalRows: 'Total Rows:',
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    actionsCellMore: 'more',
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    MuiTablePagination: {},
    rowReorderingHeaderName: 'Row reordering',
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size'
};
const GridSkeletonCell_excluded = [
    "field",
    "align",
    "width",
    "contentWidth"
];
const GridSkeletonCell_useUtilityClasses = (ownerState)=>{
    const { align, classes } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${capitalize(align)}`,
            'withBorderColor'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridSkeletonCell(props) {
    const { align, width, contentWidth } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridSkeletonCell_excluded);
    const rootProps = useGridRootProps();
    const ownerState = {
        classes: rootProps.classes,
        align
    };
    const classes = GridSkeletonCell_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", esm_extends_extends({
        className: classes.root,
        style: {
            width
        }
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Skeleton_cf835446__["default"], {
            width: `${contentWidth}%`
        })
    }));
}
"production" !== process.env.NODE_ENV && (GridSkeletonCell.propTypes = {
    align: prop_types_default().string.isRequired,
    contentWidth: prop_types_default().number.isRequired,
    field: prop_types_default().string.isRequired,
    width: prop_types_default().number.isRequired
});
const GridIconButtonContainer_excluded = [
    "className"
];
const GridIconButtonContainer_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridIconButtonContainerRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer',
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const GridIconButtonContainer_GridIconButtonContainer = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridIconButtonContainer_excluded);
    const rootProps = useGridRootProps();
    const classes = GridIconButtonContainer_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridIconButtonContainerRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: rootProps
    }, other));
});
const GridColumnHeaderFilterIconButton_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderFilterIconButton(props) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { counter, field, onClick } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = esm_extends_extends({}, props, {
        classes: rootProps.classes
    });
    const classes = GridColumnHeaderFilterIconButton_useUtilityClasses(ownerState);
    const preferencePanel = useGridSelector(apiRef, gridPreferencePanelStateSelector);
    const labelId = useId();
    const panelId = useId();
    const toggleFilter = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open, openedPanelValue } = gridPreferencePanelStateSelector(apiRef.current.state);
        if (open && openedPanelValue === gridPreferencePanelsValue_GridPreferencePanelsValue.filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(void 0, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const open = preferencePanel.open && preferencePanel.labelId === labelId;
    const iconButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseIconButton, esm_extends_extends({
        id: labelId,
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-controls": open ? panelId : void 0
    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTooltip, esm_extends_extends({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseTooltip, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridIconButtonContainer_GridIconButtonContainer, {
            children: [
                counter > 1 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"], {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                1 === counter && iconButton
            ]
        })
    }));
}
"production" !== process.env.NODE_ENV && (GridColumnHeaderFilterIconButton.propTypes = {
    counter: prop_types_default().number,
    field: prop_types_default().string.isRequired,
    onClick: prop_types_default().func
});
const GridSelectedRowCount_excluded = [
    "className",
    "selectedRowCount"
];
const GridSelectedRowCount_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridSelectedRowCountRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount',
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2),
        visibility: 'hidden',
        width: 0,
        height: 0,
        [theme.breakpoints.up('sm')]: {
            visibility: 'visible',
            width: 'auto',
            height: 'auto'
        }
    }));
const GridSelectedRowCount_GridSelectedRowCount = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className, selectedRowCount } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridSelectedRowCount_excluded);
    const apiRef = useGridApiContext();
    const ownerState = useGridRootProps();
    const classes = GridSelectedRowCount_useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridSelectedRowCountRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: rowSelectedText
    }));
});
"production" !== process.env.NODE_ENV && (GridSelectedRowCount_GridSelectedRowCount.propTypes = {
    selectedRowCount: prop_types_default().number.isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridFooterContainer_excluded = [
    "className"
];
const GridFooterContainer_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridFooterContainerRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer',
    overridesResolver: (props, styles)=>styles.footerContainer
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const GridFooterContainer_GridFooterContainer = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFooterContainer_excluded);
    const rootProps = useGridRootProps();
    const classes = GridFooterContainer_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridFooterContainerRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: rootProps
    }, other));
});
"production" !== process.env.NODE_ENV && (GridFooterContainer_GridFooterContainer.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridFooter_GridFooter = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const totalTopLevelRowCount = useGridSelector(apiRef, gridTopLevelRowCountSelector);
    const selectedRowCount = useGridSelector(apiRef, selectedGridRowsCountSelector);
    const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridSelectedRowCount_GridSelectedRowCount, {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {});
    const rowCountElement = rootProps.hideFooterRowCount || rootProps.pagination ? null : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.footerRowCount, esm_extends_extends({}, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    }));
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.pagination, esm_extends_extends({}, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.pagination));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridFooterContainer_GridFooterContainer, esm_extends_extends({
        ref: ref
    }, props, {
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});
"production" !== process.env.NODE_ENV && (GridFooter_GridFooter.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridRowCount_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const GridRowCount_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridRowCountRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount',
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2)
    }));
const GridRowCount_GridRowCount = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className, rowCount, visibleRowCount } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridRowCount_excluded);
    const apiRef = useGridApiContext();
    const ownerState = useGridRootProps();
    const classes = GridRowCount_useUtilityClasses(ownerState);
    if (0 === rowCount) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridRowCountRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});
"production" !== process.env.NODE_ENV && (GridRowCount_GridRowCount.propTypes = {
    rowCount: prop_types_default().number.isRequired,
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    visibleRowCount: prop_types_default().number.isRequired
});
const GridPreferencesPanel_GridPreferencesPanel = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _preferencePanelState, _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = useGridApiContext();
    const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
    const rootProps = useGridRootProps();
    const preferencePanelState = useGridSelector(apiRef, gridPreferencePanelStateSelector);
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, null != (_preferencePanelState = preferencePanelState.openedPanelValue) ? _preferencePanelState : gridPreferencePanelsValue_GridPreferencePanelsValue.filters);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.panel, esm_extends_extends({
        ref: ref,
        as: rootProps.slots.basePopper,
        open: columns.length > 0 && preferencePanelState.open,
        id: preferencePanelState.panelId,
        "aria-labelledby": preferencePanelState.labelId
    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.panel, props, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.basePopper, {
        children: panelContent
    }));
});
const GridOverlay_excluded = [
    "className"
];
const GridOverlay_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridOverlayRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay',
    overridesResolver: (_, styles)=>styles.overlay
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--unstable_DataGrid-overlayBackground)'
});
const GridOverlay_GridOverlay = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridOverlay_excluded);
    const rootProps = useGridRootProps();
    const classes = GridOverlay_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlayRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: rootProps
    }, other));
});
"production" !== process.env.NODE_ENV && (GridOverlay_GridOverlay.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridLoadingOverlay_GridLoadingOverlay = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlay_GridOverlay, esm_extends_extends({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {})
    }));
});
"production" !== process.env.NODE_ENV && (GridLoadingOverlay_GridLoadingOverlay.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridNoRowsOverlay_GridNoRowsOverlay = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const apiRef = useGridApiContext();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlay_GridOverlay, esm_extends_extends({
        ref: ref
    }, props, {
        children: noRowsLabel
    }));
});
"production" !== process.env.NODE_ENV && (GridNoRowsOverlay_GridNoRowsOverlay.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridPaginationRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_TablePagination_0e00fcfb__["default"])(({ theme })=>({
        [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_TablePagination_0e00fcfb__.tablePaginationClasses.selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_TablePagination_0e00fcfb__.tablePaginationClasses.input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const GridPagination_GridPagination = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);
    const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
    const rowCount = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        var _ref, _rootProps$rowCount;
        return null != (_ref = null != (_rootProps$rowCount = rootProps.rowCount) ? _rootProps$rowCount : visibleTopLevelRowCount) ? _ref : 0;
    }, [
        rootProps.rowCount,
        visibleTopLevelRowCount
    ]);
    const lastPage = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>Math.floor(rowCount / (paginationModel.pageSize || 1)), [
        rowCount,
        paginationModel.pageSize
    ]);
    const handlePageSizeChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const pageSize = Number(event.target.value);
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if ('number' == typeof option) {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    if ('production' !== process.env.NODE_ENV) {
        var _rootProps$pagination, _rootProps$pagination2;
        const warnedOnceMissingInPageSizeOptions = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
        const pageSize = null != (_rootProps$pagination = null == (_rootProps$pagination2 = rootProps.paginationModel) ? void 0 : _rootProps$pagination2.pageSize) ? _rootProps$pagination : paginationModel.pageSize;
        if (!warnedOnceMissingInPageSizeOptions.current && !rootProps.autoPageSize && !isPageSizeIncludedInPageSizeOptions(pageSize)) {
            console.warn([
                `MUI X: The page size \`${paginationModel.pageSize}\` is not preset in the \`pageSizeOptions\`.`,
                "Add it to show the pagination select."
            ].join('\n'));
            warnedOnceMissingInPageSizeOptions.current = true;
        }
    }
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPaginationRoot, esm_extends_extends({
        ref: ref,
        component: "div",
        count: rowCount,
        page: paginationModel.page <= lastPage ? paginationModel.page : lastPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, apiRef.current.getLocaleText('MuiTablePagination'), props));
});
"production" !== process.env.NODE_ENV && (GridPagination_GridPagination.propTypes = {
    component: prop_types_default().elementType
});
const GridPanelContent_excluded = [
    "className"
];
const GridPanelContent_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelContentRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent',
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400
});
function GridPanelContent(props) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridPanelContent_excluded);
    const rootProps = useGridRootProps();
    const classes = GridPanelContent_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelContentRoot, esm_extends_extends({
        className: dist_clsx(className, classes.root),
        ownerState: rootProps
    }, other));
}
"production" !== process.env.NODE_ENV && (GridPanelContent.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridPanelFooter_excluded = [
    "className"
];
const GridPanelFooter_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelFooterRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter',
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme })=>({
        padding: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between'
    }));
function GridPanelFooter(props) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridPanelFooter_excluded);
    const rootProps = useGridRootProps();
    const classes = GridPanelFooter_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelFooterRoot, esm_extends_extends({
        className: dist_clsx(className, classes.root),
        ownerState: rootProps
    }, other));
}
"production" !== process.env.NODE_ENV && (GridPanelFooter.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridPanelWrapper_excluded = [
    "className",
    "slotProps"
];
const GridPanelWrapper_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelWrapperRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper',
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const isEnabled = ()=>true;
const GridPanelWrapper_GridPanelWrapper = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className, slotProps = {} } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridPanelWrapper_excluded);
    const rootProps = useGridRootProps();
    const classes = GridPanelWrapper_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Unstable_TrapFocus_0439b381__["default"], esm_extends_extends({
        open: true,
        disableEnforceFocus: true,
        isEnabled: isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelWrapperRoot, esm_extends_extends({
            ref: ref,
            tabIndex: -1,
            className: dist_clsx(className, classes.root),
            ownerState: rootProps
        }, other))
    }));
});
"production" !== process.env.NODE_ENV && (GridPanelWrapper_GridPanelWrapper.propTypes = {
    slotProps: prop_types_default().object
});
const GridFilterForm_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "multiFilterOperator",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "children"
], GridFilterForm_excluded2 = [
    "InputComponentProps"
];
const GridFilterForm_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridFilterFormRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm',
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme })=>({
        display: 'flex',
        padding: theme.spacing(1)
    }));
const FilterFormDeleteIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon',
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme })=>({
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const FilterFormLogicOperatorInput = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormLogicOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: 'end'
});
const FilterFormColumnInput = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput',
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const FilterFormOperatorInput = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 120
});
const FilterFormValueInput = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput',
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case gridFilterItem_GridLogicOperator.And:
            return 'filterPanelOperatorAnd';
        case gridFilterItem_GridLogicOperator.Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const getColumnLabel = (col)=>col.headerName || col.field;
const GridFilterForm_collator = new Intl.Collator();
const GridFilterForm_GridFilterForm = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2, _baseSelectProps$nati, _rootProps$slotProps3, _rootProps$slotProps4, _rootProps$slotProps5, _rootProps$slotProps6, _rootProps$slotProps7, _rootProps$slotProps8, _currentColumn$filter2;
    const { item, hasMultipleFilters, deleteFilter, applyFilterChanges, multiFilterOperator, showMultiFilterOperators, disableMultiFilterOperator, applyMultiFilterOperatorChanges, focusElementRef, logicOperators = [
        gridFilterItem_GridLogicOperator.And,
        gridFilterItem_GridLogicOperator.Or
    ], columnsSort, filterColumns, deleteIconProps = {}, logicOperatorInputProps = {}, operatorInputProps = {}, columnInputProps = {}, valueInputProps = {} } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterForm_excluded);
    const apiRef = useGridApiContext();
    const filterableColumns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);
    const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
    const columnSelectId = useId();
    const columnSelectLabelId = useId();
    const operatorSelectId = useId();
    const operatorSelectLabelId = useId();
    const rootProps = useGridRootProps();
    const classes = GridFilterForm_useUtilityClasses(rootProps);
    const valueRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const filterSelectorRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseFormControlProps = (null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseFormControl) || {};
    const baseSelectProps = (null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseSelect) || {};
    const isBaseSelectNative = null != (_baseSelectProps$nati = baseSelectProps.native) ? _baseSelectProps$nati : true;
    const baseInputLabelProps = (null == (_rootProps$slotProps3 = rootProps.slotProps) ? void 0 : _rootProps$slotProps3.baseInputLabel) || {};
    const baseSelectOptionProps = (null == (_rootProps$slotProps4 = rootProps.slotProps) ? void 0 : _rootProps$slotProps4.baseSelectOption) || {};
    const { InputComponentProps } = valueInputProps, valueInputPropsOther = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(valueInputProps, GridFilterForm_excluded2);
    const filteredColumns = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (void 0 === filterColumns || 'function' != typeof filterColumns) return filterableColumns;
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: (null == filterModel ? void 0 : filterModel.items) || []
        });
        return filterableColumns.filter((column)=>filteredFields.includes(column.field));
    }, [
        filterColumns,
        null == filterModel ? void 0 : filterModel.items,
        filterableColumns,
        item.field
    ]);
    const sortedFilteredColumns = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>GridFilterForm_collator.compare(getColumnLabel(a), getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-GridFilterForm_collator.compare(getColumnLabel(a), getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        var _currentColumn$filter;
        if (!item.operator || !currentColumn) return null;
        return null == (_currentColumn$filter = currentColumn.filterOperators) ? void 0 : _currentColumn$filter.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) return;
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        const eraseItemValue = !newOperator.InputComponent || newOperator.InputComponent !== (null == currentOperator ? void 0 : currentOperator.InputComponent) || column.type !== currentColumn.type;
        applyFilterChanges(esm_extends_extends({}, item, {
            field,
            operator: newOperator.value,
            value: eraseItemValue ? void 0 : item.value
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = null == currentColumn ? void 0 : currentColumn.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !(null != newOperator && newOperator.InputComponent) || (null == newOperator ? void 0 : newOperator.InputComponent) !== (null == currentOperator ? void 0 : currentOperator.InputComponent);
        applyFilterChanges(esm_extends_extends({}, item, {
            operator,
            value: eraseItemValue ? void 0 : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const logicOperator = event.target.value === gridFilterItem_GridLogicOperator.And.toString() ? gridFilterItem_GridLogicOperator.And : gridFilterItem_GridLogicOperator.Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        if (rootProps.disableMultipleColumnsFiltering) if (void 0 === item.value) deleteFilter(item);
        else applyFilterChanges(esm_extends_extends({}, item, {
            value: void 0
        }));
        else deleteFilter(item);
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (null != currentOperator && currentOperator.InputComponent) {
                    var _valueRef$current;
                    null == valueRef || null == (_valueRef$current = valueRef.current) || _valueRef$current.focus();
                } else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridFilterFormRoot, esm_extends_extends({
        ref: ref,
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterFormDeleteIcon, esm_extends_extends({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: dist_clsx(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseIconButton, esm_extends_extends({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small"
                }, null == (_rootProps$slotProps5 = rootProps.slotProps) ? void 0 : _rootProps$slotProps5.baseIconButton, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterFormLogicOperatorInput, esm_extends_extends({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, logicOperatorInputProps, {
                sx: esm_extends_extends({
                    display: hasLogicOperatorColumn ? 'flex' : 'none',
                    visibility: showMultiFilterOperators ? 'visible' : 'hidden'
                }, baseFormControlProps.sx || {}, logicOperatorInputProps.sx || {}),
                className: dist_clsx(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelect, esm_extends_extends({
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    },
                    value: multiFilterOperator,
                    onChange: changeLogicOperator,
                    disabled: !!disableMultiFilterOperator || 1 === logicOperators.length,
                    native: isBaseSelectNative
                }, null == (_rootProps$slotProps6 = rootProps.slotProps) ? void 0 : _rootProps$slotProps6.baseSelect, {
                    children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(rootProps.slots.baseSelectOption, esm_extends_extends({}, baseSelectOptionProps, {
                            native: isBaseSelectNative,
                            key: logicOperator.toString(),
                            value: logicOperator.toString()
                        }), apiRef.current.getLocaleText(getLogicOperatorLocaleKey(logicOperator))))
                }))
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FilterFormColumnInput, esm_extends_extends({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: dist_clsx(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseInputLabel, esm_extends_extends({}, baseInputLabelProps, {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelColumns')
                    })),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelect, esm_extends_extends({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText('filterPanelColumns'),
                        value: item.field || '',
                        onChange: changeColumn,
                        native: isBaseSelectNative
                    }, null == (_rootProps$slotProps7 = rootProps.slotProps) ? void 0 : _rootProps$slotProps7.baseSelect, {
                        children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(rootProps.slots.baseSelectOption, esm_extends_extends({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: col.field,
                                value: col.field
                            }), getColumnLabel(col)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FilterFormOperatorInput, esm_extends_extends({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: dist_clsx(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseInputLabel, esm_extends_extends({}, baseInputLabelProps, {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelOperator')
                    })),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSelect, esm_extends_extends({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText('filterPanelOperator'),
                        id: operatorSelectId,
                        value: item.operator,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef
                    }, null == (_rootProps$slotProps8 = rootProps.slotProps) ? void 0 : _rootProps$slotProps8.baseSelect, {
                        children: null == currentColumn || null == (_currentColumn$filter2 = currentColumn.filterOperators) ? void 0 : _currentColumn$filter2.map((operator)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(rootProps.slots.baseSelectOption, esm_extends_extends({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: operator.value,
                                value: operator.value
                            }), operator.label || apiRef.current.getLocaleText(`filterOperator${capitalize(operator.value)}`)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterFormValueInput, esm_extends_extends({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: dist_clsx(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: null != currentOperator && currentOperator.InputComponent ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(currentOperator.InputComponent, esm_extends_extends({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef
                }, currentOperator.InputComponentProps, InputComponentProps)) : null
            }))
        ]
    }));
});
"production" !== process.env.NODE_ENV && (GridFilterForm_GridFilterForm.propTypes = {
    applyFilterChanges: prop_types_default().func.isRequired,
    applyMultiFilterOperatorChanges: prop_types_default().func.isRequired,
    children: prop_types_default().node,
    columnInputProps: prop_types_default().any,
    columnsSort: prop_types_default().oneOf([
        'asc',
        'desc'
    ]),
    deleteFilter: prop_types_default().func.isRequired,
    deleteIconProps: prop_types_default().any,
    disableMultiFilterOperator: prop_types_default().bool,
    filterColumns: prop_types_default().func,
    focusElementRef: prop_types_default().oneOfType([
        prop_types_default().func,
        prop_types_default().object
    ]),
    hasMultipleFilters: prop_types_default().bool.isRequired,
    item: prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        id: prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]),
        operator: prop_types_default().string.isRequired,
        value: prop_types_default().any
    }).isRequired,
    logicOperatorInputProps: prop_types_default().any,
    logicOperators: prop_types_default().arrayOf(prop_types_default().oneOf([
        'and',
        'or'
    ]).isRequired),
    multiFilterOperator: prop_types_default().oneOf([
        'and',
        'or'
    ]),
    operatorInputProps: prop_types_default().any,
    showMultiFilterOperators: prop_types_default().bool,
    valueInputProps: prop_types_default().any
});
const GridFilterPanel_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const getGridFilter = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(1e5 * Math.random())
    });
const GridFilterPanel_GridFilterPanel = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
    const filterableColumns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);
    const lastFilterRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const placeholderFilter = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const { logicOperators = [
        gridFilterItem_GridLogicOperator.And,
        gridFilterItem_GridLogicOperator.Or
    ], columnsSort, filterFormProps, getColumnForNewFilter, disableAddFilterButton = false, disableRemoveAllButton = false } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridFilterPanel_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && 'function' == typeof getColumnForNewFilter) {
            const nextFieldName = getColumnForNewFilter({
                currentFilters: (null == filterModel ? void 0 : filterModel.items) || [],
                columns: filterableColumns
            });
            if (null === nextFieldName) return null;
            nextColumnWithOperator = filterableColumns.find(({ field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>{
            var _colDef$filterOperato;
            return null == (_colDef$filterOperato = colDef.filterOperators) ? void 0 : _colDef$filterOperato.length;
        });
        if (!nextColumnWithOperator) return null;
        return getGridFilter(nextColumnWithOperator);
    }, [
        null == filterModel ? void 0 : filterModel.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (void 0 === getColumnForNewFilter || 'function' != typeof getColumnForNewFilter) return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (null === nextColumnFieldName) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return getGridFilter(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const addNewFilter = ()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    };
    const deleteFilter = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((item)=>{
        const shouldCloseFilterPanel = 1 === items.length;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        items.length
    ]);
    const handleRemoveAll = ()=>{
        if (1 === items.length && void 0 === items[0].value) {
            apiRef.current.deleteFilterItem(items[0]);
            apiRef.current.hideFilterPanel();
        }
        apiRef.current.setFilterModel(esm_extends_extends({}, filterModel, {
            items: []
        }));
    };
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (items.length > 0) lastFilterRef.current.focus();
    }, [
        items.length
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridPanelWrapper_GridPanelWrapper, esm_extends_extends({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelContent, {
                children: items.map((item, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridFilterForm_GridFilterForm, esm_extends_extends({
                        item: item,
                        applyFilterChanges: applyFilter,
                        deleteFilter: deleteFilter,
                        hasMultipleFilters: hasMultipleFilters,
                        showMultiFilterOperators: index > 0,
                        multiFilterOperator: filterModel.logicOperator,
                        disableMultiFilterOperator: 1 !== index,
                        applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                        focusElementRef: index === items.length - 1 ? lastFilterRef : null,
                        logicOperators: logicOperators,
                        columnsSort: columnsSort
                    }, filterFormProps), null == item.id ? index : item.id))
            }),
            rootProps.disableMultipleColumnsFiltering || disableAddFilterButton && disableRemoveAllButton ? null : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridPanelFooter, {
                children: [
                    disableAddFilterButton ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseButton, esm_extends_extends({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })),
                    disableRemoveAllButton ? null : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseButton, esm_extends_extends({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    }))
                ]
            })
        ]
    }));
});
"production" !== process.env.NODE_ENV && (GridFilterPanel_GridFilterPanel.propTypes = {
    children: prop_types_default().node,
    columnsSort: prop_types_default().oneOf([
        'asc',
        'desc'
    ]),
    disableAddFilterButton: prop_types_default().bool,
    disableRemoveAllButton: prop_types_default().bool,
    filterFormProps: prop_types_default().shape({
        columnInputProps: prop_types_default().any,
        columnsSort: prop_types_default().oneOf([
            'asc',
            'desc'
        ]),
        deleteIconProps: prop_types_default().any,
        filterColumns: prop_types_default().func,
        logicOperatorInputProps: prop_types_default().any,
        operatorInputProps: prop_types_default().any,
        valueInputProps: prop_types_default().any
    }),
    getColumnForNewFilter: prop_types_default().func,
    logicOperators: prop_types_default().arrayOf(prop_types_default().oneOf([
        'and',
        'or'
    ]).isRequired),
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GridPanelHeader_excluded = [
    "className"
];
const GridPanelHeader_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'panelHeader'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelHeaderRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelHeader',
    overridesResolver: (props, styles)=>styles.panelHeader
})(({ theme })=>({
        padding: theme.spacing(1)
    }));
function GridPanelHeader(props) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridPanelHeader_excluded);
    const rootProps = useGridRootProps();
    const classes = GridPanelHeader_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelHeaderRoot, esm_extends_extends({
        className: dist_clsx(className, classes.root),
        ownerState: rootProps
    }, other));
}
"production" !== process.env.NODE_ENV && (GridPanelHeader.propTypes = {
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ])
});
const GRID_EXPERIMENTAL_ENABLED = false;
const GridColumnsPanel_excluded = [
    "sort",
    "searchPredicate",
    "autoFocusSearchField",
    "disableHideAllButton",
    "disableShowAllButton",
    "getTogglableColumns"
];
const GridColumnsPanel_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'columnsPanel'
        ],
        columnsPanelRow: [
            'columnsPanelRow'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnsPanelRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsPanel',
    overridesResolver: (props, styles)=>styles.columnsPanel
})({
    padding: '8px 0px 8px 8px'
});
const GridColumnsPanelRowRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsPanelRow',
    overridesResolver: (props, styles)=>styles.columnsPanelRow
})(({ theme })=>({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1px 8px 1px 7px',
        [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_Switch_72bb925c__.switchClasses.root}`]: {
            marginRight: theme.spacing(0.5)
        }
    }));
const GridIconButtonRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"])({
    justifyContent: 'flex-end'
});
const GridColumnsPanel_collator = new Intl.Collator();
const defaultSearchPredicate = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
function GridColumnsPanel(props) {
    var _rootProps$slotProps, _rootProps$slotProps3, _rootProps$slotProps4;
    const apiRef = useGridApiContext();
    const searchInputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
    const columnVisibilityModel = useGridSelector(apiRef, gridColumnVisibilityModelSelector);
    const rootProps = useGridRootProps();
    const [searchValue, setSearchValue] = __WEBPACK_EXTERNAL_MODULE_react__.useState('');
    const classes = GridColumnsPanel_useUtilityClasses(rootProps);
    const { sort, searchPredicate = defaultSearchPredicate, autoFocusSearchField = true, disableHideAllButton = false, disableShowAllButton = false, getTogglableColumns } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnsPanel_excluded);
    const sortedColumns = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>GridColumnsPanel_collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-GridColumnsPanel_collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, false === columnVisibilityModel[field]);
    };
    const toggleAllColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((isVisible)=>{
        const currentModel = gridColumnVisibilityModelSelector(apiRef);
        const newModel = esm_extends_extends({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        columns.forEach((col)=>{
            if (col.hideable && (null == togglableColumns || togglableColumns.includes(col.field))) if (isVisible) delete newModel[col.field];
            else newModel[col.field] = false;
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns
    ]);
    const handleSearchValueChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const currentColumns = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const firstSwitchRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && 'function' == typeof firstSwitchRef.current.focus) firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (false === firstHideableColumnFound && false !== column.hideable) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridPanelWrapper_GridPanelWrapper, esm_extends_extends({}, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelHeader, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTextField, esm_extends_extends({
                    label: apiRef.current.getLocaleText('columnsPanelTextFieldLabel'),
                    placeholder: apiRef.current.getLocaleText('columnsPanelTextFieldPlaceholder'),
                    inputRef: searchInputRef,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "standard",
                    fullWidth: true
                }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTextField))
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelContent, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnsPanelRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: currentColumns.map((column)=>{
                        var _rootProps$slotProps2;
                        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridColumnsPanelRowRoot, {
                            className: classes.columnsPanelRow,
                            ownerState: rootProps,
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormControlLabel_8c33cd98__["default"], {
                                    control: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseSwitch, esm_extends_extends({
                                        disabled: false === column.hideable,
                                        checked: false !== columnVisibilityModel[column.field],
                                        onClick: toggleColumn,
                                        name: column.field,
                                        size: "small",
                                        inputRef: isFirstHideableColumn(column) ? firstSwitchRef : void 0
                                    }, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseSwitch)),
                                    label: column.headerName || column.field
                                }),
                                !rootProps.disableColumnReorder && GRID_EXPERIMENTAL_ENABLED && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridIconButtonRoot, {
                                    draggable: true,
                                    "aria-label": apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
                                    title: apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
                                    size: "small",
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnReorderIcon, {})
                                })
                            ]
                        }, column.field);
                    })
                })
            }),
            disableShowAllButton && disableHideAllButton ? null : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridPanelFooter, {
                children: [
                    disableHideAllButton ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseButton, esm_extends_extends({
                        onClick: ()=>toggleAllColumns(false)
                    }, null == (_rootProps$slotProps3 = rootProps.slotProps) ? void 0 : _rootProps$slotProps3.baseButton, {
                        disabled: disableHideAllButton,
                        children: apiRef.current.getLocaleText('columnsPanelHideAllButton')
                    })),
                    disableShowAllButton ? null : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseButton, esm_extends_extends({
                        onClick: ()=>toggleAllColumns(true)
                    }, null == (_rootProps$slotProps4 = rootProps.slotProps) ? void 0 : _rootProps$slotProps4.baseButton, {
                        disabled: disableShowAllButton,
                        children: apiRef.current.getLocaleText('columnsPanelShowAllButton')
                    }))
                ]
            })
        ]
    }));
}
"production" !== process.env.NODE_ENV && (GridColumnsPanel.propTypes = {
    autoFocusSearchField: prop_types_default().bool,
    disableHideAllButton: prop_types_default().bool,
    disableShowAllButton: prop_types_default().bool,
    getTogglableColumns: prop_types_default().func,
    searchPredicate: prop_types_default().func,
    slotProps: prop_types_default().object,
    sort: prop_types_default().oneOf([
        'asc',
        'desc'
    ])
});
const GridPanel_excluded = [
    "children",
    "className",
    "classes"
];
const gridPanelClasses = generateUtilityClasses('MuiDataGrid', [
    'panel',
    'paper'
]);
const GridPanelRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Popper_24cb866b__["default"], {
    name: 'MuiDataGrid',
    slot: 'Panel',
    overridesResolver: (props, styles)=>styles.panel
})(({ theme })=>({
        zIndex: theme.zIndex.modal
    }));
const GridPaperRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__["default"], {
    name: 'MuiDataGrid',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: 'flex'
    }));
const GridPanel = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    const { children, className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridPanel_excluded);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const classes = gridPanelClasses;
    const [isPlaced, setIsPlaced] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const handleClickAway = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        if (isEscapeKey(event.key)) apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>[
            {
                name: 'flip',
                enabled: false
            },
            {
                name: 'isPlaced',
                enabled: true,
                phase: 'main',
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const [anchorEl, setAnchorEl] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        var _apiRef$current$rootE;
        const columnHeadersElement = null == (_apiRef$current$rootE = apiRef.current.rootElementRef) || null == (_apiRef$current$rootE = _apiRef$current$rootE.current) ? void 0 : _apiRef$current$rootE.querySelector(`.${gridClasses_gridClasses.columnHeaders}`);
        if (columnHeadersElement) setAnchorEl(columnHeadersElement);
    }, [
        apiRef
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPanelRoot, esm_extends_extends({
        ref: ref,
        placement: "bottom-start",
        className: dist_clsx(className, classes.panel),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ClickAwayListener_a7328dbe__["default"], {
            mouseEvent: "onMouseUp",
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});
"production" !== process.env.NODE_ENV && (GridPanel.propTypes = {
    children: prop_types_default().node,
    classes: prop_types_default().object,
    open: prop_types_default().bool.isRequired,
    ownerState: prop_types_default().object
});
function fastMemo(component) {
    return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(component, fastObjectShallowCompare);
}
let cachedSupportsPreventScroll;
function doesSupportPreventScroll() {
    if (void 0 === cachedSupportsPreventScroll) document.createElement('div').focus({
        get preventScroll () {
            cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return cachedSupportsPreventScroll;
}
const GridCell_excluded = [
    "changeReason",
    "unstable_updateValueOnRender"
], GridCell_excluded2 = [
    "align",
    "children",
    "editCellState",
    "colIndex",
    "column",
    "cellMode",
    "field",
    "formattedValue",
    "hasFocus",
    "height",
    "isEditable",
    "isSelected",
    "rowId",
    "tabIndex",
    "style",
    "value",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], GridCell_excluded3 = [
    "column",
    "rowId",
    "editCellState",
    "align",
    "children",
    "colIndex",
    "height",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver",
    "style"
], GridCell_excluded4 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const EMPTY_CELL_PARAMS = {
    id: -1,
    field: '__unset__',
    row: {},
    rowNode: {
        id: -1,
        depth: 0,
        type: 'leaf',
        parent: -1,
        groupingKey: null
    },
    colDef: {
        type: 'string',
        field: '__unset__',
        computedWidth: 0
    },
    cellMode: gridEditRowModel_GridCellModes.View,
    hasFocus: false,
    tabIndex: -1,
    value: null,
    formattedValue: '__unset__',
    isEditable: false,
    api: {}
};
const GridCell_useUtilityClasses = (ownerState)=>{
    const { align, showRightBorder, isEditable, isSelected, isSelectionMode, classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${capitalize(align)}`,
            isEditable && 'cell--editable',
            isSelected && 'selected',
            showRightBorder && 'cell--withRightBorder',
            isSelectionMode && !isEditable && 'cell--selectionMode',
            'withBorderColor'
        ],
        content: [
            'cellContent'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
let warnedOnce = false;
const GridCellWrapper = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    const { column, rowId, editCellState } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const field = column.field;
    const cellParamsWithAPI = useGridSelector(apiRef, ()=>{
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof MissingRowIdError) return EMPTY_CELL_PARAMS;
            throw e;
        }
    }, objectShallowCompare);
    const isSelected = useGridSelector(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field
        }));
    if (cellParamsWithAPI === EMPTY_CELL_PARAMS) return null;
    const { cellMode, hasFocus, isEditable, value, formattedValue } = cellParamsWithAPI;
    const managesOwnFocus = 'actions' === column.type;
    const tabIndex = 'view' !== cellMode && isEditable || managesOwnFocus ? -1 : cellParamsWithAPI.tabIndex;
    const { classes: rootClasses, getCellClassName } = rootProps;
    const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
        id: rowId,
        field
    });
    if (column.cellClassName) classNames.push('function' == typeof column.cellClassName ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    let children;
    if (null == editCellState && column.renderCell) {
        children = column.renderCell(cellParamsWithAPI);
        classNames.push(gridClasses_gridClasses["cell--withRenderer"]);
        classNames.push(null == rootClasses ? void 0 : rootClasses['cell--withRenderer']);
    }
    if (null != editCellState && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        const editCellStateRest = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(editCellState, GridCell_excluded);
        const params = esm_extends_extends({}, cellParamsWithAPI, {
            row: updatedRow
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push(gridClasses_gridClasses["cell--editing"]);
        classNames.push(null == rootClasses ? void 0 : rootClasses['cell--editing']);
    }
    const { slots } = rootProps;
    const CellComponent = slots.cell;
    const cellProps = esm_extends_extends({}, props, {
        ref,
        field,
        formattedValue,
        hasFocus,
        isEditable,
        isSelected,
        value,
        cellMode,
        children,
        tabIndex,
        className: dist_clsx(classNames)
    });
    return /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createElement(CellComponent, cellProps);
});
const GridCell = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    var _rootProps$experiment, _rootProps$experiment2;
    const { align, children: childrenProp, colIndex, column, cellMode, field, formattedValue, hasFocus, height, isEditable, isSelected, rowId, tabIndex, style: styleProp, value, width, className, showRightBorder, colSpan, disableDragEvents, isNotVisible, onClick, onDoubleClick, onMouseDown, onMouseUp, onMouseOver, onKeyDown, onKeyUp, onDragEnter, onDragOver } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridCell_excluded2);
    const valueToRender = null == formattedValue ? value : formattedValue;
    const cellRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, cellRef);
    const focusElementRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = {
        align,
        showRightBorder,
        isEditable,
        classes: rootProps.classes,
        isSelected
    };
    const classes = GridCell_useUtilityClasses(ownerState);
    const publishMouseUp = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName, propHandler)=>(event)=>{
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        };
        const cellStyle = esm_extends_extends({
            minWidth: width,
            maxWidth: width,
            minHeight: height,
            maxHeight: 'auto' === height ? 'none' : height
        }, styleProp);
        return cellStyle;
    }, [
        width,
        height,
        isNotVisible,
        styleProp
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!hasFocus || cellMode === gridEditRowModel_GridCellModes.Edit) return;
        const doc = ownerDocument(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if (doesSupportPreventScroll()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    let handleFocus = other.onFocus;
    if ('test' === process.env.NODE_ENV && null != (_rootProps$experiment = rootProps.experimentalFeatures) && _rootProps$experiment.warnIfFocusStateIsNotSynced) handleFocus = (event)=>{
        const focusedCell = gridFocusCellSelector(apiRef);
        if ((null == focusedCell ? void 0 : focusedCell.id) === rowId && focusedCell.field === field) {
            if ('function' == typeof other.onFocus) other.onFocus(event);
            return;
        }
        if (!warnedOnce) {
            console.warn([
                `MUI: The cell with id=${rowId} and field=${field} received focus.`,
                `According to the state, the focus should be at id=${null == focusedCell ? void 0 : focusedCell.id}, field=${null == focusedCell ? void 0 : focusedCell.field}.`,
                "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.",
                'Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state.'
            ].join('\n'));
            warnedOnce = true;
        }
    };
    const managesOwnFocus = 'actions' === column.type;
    let children = childrenProp;
    if (void 0 === children) {
        const valueString = null == valueToRender ? void 0 : valueToRender.toString();
        children = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: classes.content,
            title: valueString,
            role: "presentation",
            children: valueString
        });
    }
    if (/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.isValidElement(children) && managesOwnFocus) children = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(children, {
        focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    const ariaV7 = null == (_rootProps$experiment2 = rootProps.experimentalFeatures) ? void 0 : _rootProps$experiment2.ariaV7;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", esm_extends_extends({
        ref: handleRef,
        className: dist_clsx(className, classes.root),
        role: ariaV7 ? 'gridcell' : 'cell',
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    }));
});
const MemoizedCellWrapper = fastMemo(GridCellWrapper);
"production" !== process.env.NODE_ENV && (GridCellWrapper.propTypes = {
    align: prop_types_default().oneOf([
        'center',
        'left',
        'right'
    ]),
    className: prop_types_default().string,
    colIndex: prop_types_default().number,
    colSpan: prop_types_default().number,
    column: prop_types_default().object,
    disableDragEvents: prop_types_default().bool,
    height: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'auto'
        ]),
        prop_types_default().number
    ]),
    onClick: prop_types_default().func,
    onDoubleClick: prop_types_default().func,
    onDragEnter: prop_types_default().func,
    onDragOver: prop_types_default().func,
    onKeyDown: prop_types_default().func,
    onMouseDown: prop_types_default().func,
    onMouseUp: prop_types_default().func,
    rowId: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]),
    showRightBorder: prop_types_default().bool,
    width: prop_types_default().number
});
"production" !== process.env.NODE_ENV && (GridCell.propTypes = {
    align: prop_types_default().oneOf([
        'center',
        'left',
        'right'
    ]),
    cellMode: prop_types_default().oneOf([
        'edit',
        'view'
    ]),
    children: prop_types_default().node,
    className: prop_types_default().string,
    colIndex: prop_types_default().number,
    colSpan: prop_types_default().number,
    column: prop_types_default().object,
    disableDragEvents: prop_types_default().bool,
    editCellState: prop_types_default().shape({
        changeReason: prop_types_default().oneOf([
            'debouncedSetEditCellValue',
            'setEditCellValue'
        ]),
        isProcessingProps: prop_types_default().bool,
        isValidating: prop_types_default().bool,
        value: prop_types_default().any
    }),
    isNotVisible: prop_types_default().bool,
    height: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'auto'
        ]),
        prop_types_default().number
    ]),
    onClick: prop_types_default().func,
    onDoubleClick: prop_types_default().func,
    onDragEnter: prop_types_default().func,
    onDragOver: prop_types_default().func,
    onKeyDown: prop_types_default().func,
    onMouseDown: prop_types_default().func,
    onMouseUp: prop_types_default().func,
    rowId: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]),
    showRightBorder: prop_types_default().bool,
    width: prop_types_default().number
});
const GridCellV7 = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>{
    var _getActions, _ref, _rootProps$unstable_c, _rootProps$experiment3, _rootProps$experiment4;
    const { column, rowId, editCellState, align, colIndex, height, width, className, showRightBorder, colSpan, disableDragEvents, isNotVisible, onClick, onDoubleClick, onMouseDown, onMouseUp, onMouseOver, onKeyDown, onKeyUp, onDragEnter, onDragOver, style: styleProp } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridCell_excluded3);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const field = column.field;
    const cellParamsWithAPI = useGridSelector(apiRef, ()=>{
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof MissingRowIdError) return EMPTY_CELL_PARAMS;
            throw e;
        }
    }, objectShallowCompare);
    const isSelected = useGridSelector(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field
        }));
    const { cellMode, hasFocus, isEditable, value, formattedValue } = cellParamsWithAPI;
    const canManageOwnFocus = 'actions' === column.type && (null == (_getActions = (_ref = column).getActions) ? void 0 : _getActions.call(_ref, apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled));
    const tabIndex = 'view' !== cellMode && isEditable || canManageOwnFocus ? -1 : cellParamsWithAPI.tabIndex;
    const { classes: rootClasses, getCellClassName } = rootProps;
    const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
        id: rowId,
        field
    });
    if (column.cellClassName) classNames.push('function' == typeof column.cellClassName ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    const valueToRender = null == formattedValue ? value : formattedValue;
    const cellRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, cellRef);
    const focusElementRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const isSelectionMode = null != (_rootProps$unstable_c = rootProps.unstable_cellSelection) ? _rootProps$unstable_c : false;
    const ownerState = {
        align,
        showRightBorder,
        isEditable,
        classes: rootProps.classes,
        isSelected,
        isSelectionMode
    };
    const classes = GridCell_useUtilityClasses(ownerState);
    const publishMouseUp = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName, propHandler)=>(event)=>{
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (isNotVisible) return esm_extends_extends({
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        }, styleProp);
        const cellStyle = esm_extends_extends({
            minWidth: width,
            maxWidth: width,
            minHeight: height,
            maxHeight: 'auto' === height ? 'none' : height
        }, styleProp);
        return cellStyle;
    }, [
        width,
        height,
        isNotVisible,
        styleProp
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!hasFocus || cellMode === gridEditRowModel_GridCellModes.Edit) return;
        const doc = ownerDocument(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if (doesSupportPreventScroll()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (cellParamsWithAPI === EMPTY_CELL_PARAMS) return null;
    let handleFocus = other.onFocus;
    if ('test' === process.env.NODE_ENV && null != (_rootProps$experiment3 = rootProps.experimentalFeatures) && _rootProps$experiment3.warnIfFocusStateIsNotSynced) handleFocus = (event)=>{
        const focusedCell = gridFocusCellSelector(apiRef);
        if ((null == focusedCell ? void 0 : focusedCell.id) === rowId && focusedCell.field === field) {
            if ('function' == typeof other.onFocus) other.onFocus(event);
            return;
        }
        if (!warnedOnce) {
            console.warn([
                `MUI: The cell with id=${rowId} and field=${field} received focus.`,
                `According to the state, the focus should be at id=${null == focusedCell ? void 0 : focusedCell.id}, field=${null == focusedCell ? void 0 : focusedCell.field}.`,
                "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.",
                'Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state.'
            ].join('\n'));
            warnedOnce = true;
        }
    };
    let children;
    if (null == editCellState && column.renderCell) {
        children = column.renderCell(cellParamsWithAPI);
        classNames.push(gridClasses_gridClasses["cell--withRenderer"]);
        classNames.push(null == rootClasses ? void 0 : rootClasses['cell--withRenderer']);
    }
    if (null != editCellState && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        const editCellStateRest = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(editCellState, GridCell_excluded4);
        const params = esm_extends_extends({}, cellParamsWithAPI, {
            row: updatedRow
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push(gridClasses_gridClasses["cell--editing"]);
        classNames.push(null == rootClasses ? void 0 : rootClasses['cell--editing']);
    }
    if (void 0 === children) {
        const valueString = null == valueToRender ? void 0 : valueToRender.toString();
        children = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: classes.content,
            title: valueString,
            role: "presentation",
            children: valueString
        });
    }
    if (/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.cloneElement(children, {
        focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    const ariaV7 = null == (_rootProps$experiment4 = rootProps.experimentalFeatures) ? void 0 : _rootProps$experiment4.ariaV7;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", esm_extends_extends({
        ref: handleRef,
        className: dist_clsx(className, classNames, classes.root),
        role: ariaV7 ? 'gridcell' : 'cell',
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    }));
});
"production" !== process.env.NODE_ENV && (GridCellV7.propTypes = {
    align: prop_types_default().oneOf([
        'center',
        'left',
        'right'
    ]).isRequired,
    className: prop_types_default().string,
    colIndex: prop_types_default().number.isRequired,
    colSpan: prop_types_default().number,
    column: prop_types_default().object.isRequired,
    disableDragEvents: prop_types_default().bool,
    editCellState: prop_types_default().shape({
        changeReason: prop_types_default().oneOf([
            'debouncedSetEditCellValue',
            'setEditCellValue'
        ]),
        isProcessingProps: prop_types_default().bool,
        isValidating: prop_types_default().bool,
        value: prop_types_default().any
    }),
    height: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'auto'
        ]),
        prop_types_default().number
    ]).isRequired,
    isNotVisible: prop_types_default().bool,
    onClick: prop_types_default().func,
    onDoubleClick: prop_types_default().func,
    onDragEnter: prop_types_default().func,
    onDragOver: prop_types_default().func,
    onKeyDown: prop_types_default().func,
    onMouseDown: prop_types_default().func,
    onMouseUp: prop_types_default().func,
    rowId: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    showRightBorder: prop_types_default().bool,
    width: prop_types_default().number.isRequired
});
const MemoizedGridCellV7 = fastMemo(GridCellV7);
const GridRow_excluded = [
    "selected",
    "hovered",
    "rowId",
    "row",
    "index",
    "style",
    "position",
    "rowHeight",
    "className",
    "visibleColumns",
    "renderedColumns",
    "containerWidth",
    "firstColumnToRender",
    "lastColumnToRender",
    "isLastVisible",
    "focusedCellColumnIndexNotInRange",
    "isNotVisible",
    "focusedCell",
    "tabbableCell",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const GridRow_useUtilityClasses = (ownerState)=>{
    const { editable, editing, selected, isLastVisible, rowHeight, classes } = ownerState;
    const slots = {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isLastVisible && 'row--lastVisible',
            'auto' === rowHeight && 'row--dynamicHeight'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function EmptyCell({ width }) {
    if (!width) return null;
    const style = {
        width
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: `${gridClasses_gridClasses.cell} ${gridClasses_gridClasses.withBorderColor}`,
        style: style
    });
}
const GridRow_GridRow = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, refProp) {
    const { selected, hovered, rowId, row, index, style: styleProp, position, rowHeight, className, visibleColumns, renderedColumns, containerWidth, firstColumnToRender, isLastVisible = false, focusedCellColumnIndexNotInRange, isNotVisible, focusedCell, onClick, onDoubleClick, onMouseEnter, onMouseLeave, onMouseOut, onMouseOver } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridRow_excluded);
    const apiRef = useGridApiContext();
    const ref = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const rootProps = useGridRootProps();
    const currentPage = useGridVisibleRows(apiRef, rootProps);
    const columnsTotalWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
    const sortModel = useGridSelector(apiRef, gridSortModelSelector);
    const treeDepth = useGridSelector(apiRef, gridRowMaximumTreeDepthSelector);
    const headerGroupingMaxDepth = useGridSelector(apiRef, gridColumnGroupsHeaderMaxDepthSelector);
    const editRowsState = useGridSelector(apiRef, gridEditRowsStateSelector);
    const handleRef = useForkRef_useForkRef(ref, refProp);
    const ariaRowIndex = index + headerGroupingMaxDepth + 2;
    const ownerState = {
        selected,
        hovered,
        isLastVisible,
        classes: rootProps.classes,
        editing: apiRef.current.getRowMode(rowId) === gridEditRowModel_GridRowModes.Edit,
        editable: rootProps.editMode === gridEditRowModel_GridEditModes.Row,
        rowHeight
    };
    const classes = GridRow_useUtilityClasses(ownerState);
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        if ('auto' === rowHeight && ref.current && 'undefined' == typeof ResizeObserver) apiRef.current.unstable_storeRowHeightMeasurement(rowId, ref.current.clientHeight, position);
    }, [
        apiRef,
        rowHeight,
        rowId,
        position
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        if (currentPage.range) {
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            if (null != rowIndex) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        const rootElement = ref.current;
        const hasFixedHeight = 'auto' !== rowHeight;
        if (!rootElement || hasFixedHeight || 'undefined' == typeof ResizeObserver) return;
        const resizeObserver = new ResizeObserver((entries)=>{
            const [entry] = entries;
            const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
            apiRef.current.unstable_storeRowHeightMeasurement(rowId, height, position);
        });
        resizeObserver.observe(rootElement);
        return ()=>resizeObserver.disconnect();
    }, [
        apiRef,
        currentPage.range,
        index,
        rowHeight,
        rowId,
        position
    ]);
    const publish = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName, propHandler)=>(event)=>{
            if (isEventTargetInPortal(event)) return;
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        const cell = findParentElementFromClassName(event.target, gridClasses_gridClasses.cell);
        const field = null == cell ? void 0 : cell.getAttribute('data-field');
        if (field) {
            if (field === GRID_CHECKBOX_SELECTION_COL_DEF.field) return;
            if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) return;
            if ('__reorder__' === field) return;
            if (apiRef.current.getCellMode(rowId, field) === gridEditRowModel_GridCellModes.Edit) return;
            const column = apiRef.current.getColumn(field);
            if ((null == column ? void 0 : column.type) === GRID_ACTIONS_COLUMN_TYPE) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots, slotProps, disableColumnReorder } = rootProps;
    const CellComponent = slots.cell === MemoizedGridCellV7 ? MemoizedGridCellV7 : MemoizedCellWrapper;
    const rowReordering = rootProps.rowReordering;
    const getCell = (column, cellProps)=>{
        var _editRowsState$rowId$, _editRowsState$rowId;
        const disableDragEvents = disableColumnReorder && column.disableReorder || !rowReordering && !!sortModel.length && treeDepth > 1 && Object.keys(editRowsState).length > 0;
        const editCellState = null != (_editRowsState$rowId$ = null == (_editRowsState$rowId = editRowsState[rowId]) ? void 0 : _editRowsState$rowId[column.field]) ? _editRowsState$rowId$ : null;
        let cellIsNotVisible = false;
        if (void 0 !== focusedCellColumnIndexNotInRange && visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) cellIsNotVisible = true;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CellComponent, esm_extends_extends({
            column: column,
            width: cellProps.width,
            rowId: rowId,
            height: rowHeight,
            showRightBorder: cellProps.showRightBorder,
            align: column.align || 'left',
            colIndex: cellProps.indexRelativeToAllColumns,
            colSpan: cellProps.colSpan,
            disableDragEvents: disableDragEvents,
            editCellState: editCellState,
            isNotVisible: cellIsNotVisible
        }, null == slotProps ? void 0 : slotProps.cell), column.field);
    };
    const sizes = useGridSelector(apiRef, ()=>esm_extends_extends({}, apiRef.current.unstable_getRowInternalSizes(rowId)), objectShallowCompare);
    let minHeight = rowHeight;
    if ('auto' === minHeight && sizes) {
        let numberOfBaseSizes = 0;
        const maximumSize = Object.entries(sizes).reduce((acc, [key, size])=>{
            const isBaseHeight = /^base[A-Z]/.test(key);
            if (!isBaseHeight) return acc;
            numberOfBaseSizes += 1;
            if (size > acc) return size;
            return acc;
        }, 0);
        if (maximumSize > 0 && numberOfBaseSizes > 1) minHeight = maximumSize;
    }
    const style = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = esm_extends_extends({}, styleProp, {
            maxHeight: 'auto' === rowHeight ? 'none' : rowHeight,
            minHeight
        });
        if (null != sizes && sizes.spacingTop) {
            const property = 'border' === rootProps.rowSpacingType ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = sizes.spacingTop;
        }
        if (null != sizes && sizes.spacingBottom) {
            const property = 'border' === rootProps.rowSpacingType ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            if ('number' != typeof propertyValue) propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += sizes.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        minHeight,
        sizes,
        rootProps.rowSpacingType
    ]);
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    if ('function' == typeof rootProps.getRowClassName) {
        var _currentPage$range;
        const indexRelativeToCurrentPage = index - ((null == (_currentPage$range = currentPage.range) ? void 0 : _currentPage$range.firstRowIndex) || 0);
        const rowParams = esm_extends_extends({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: 0 === indexRelativeToCurrentPage,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const randomNumber = randomNumberBetween(10000, 20, 80);
    const rowNode = apiRef.current.getRowNode(rowId);
    if (!rowNode) return null;
    const rowType = rowNode.type;
    const cells = [];
    for(let i = 0; i < renderedColumns.length; i += 1){
        const column = renderedColumns[i];
        let indexRelativeToAllColumns = firstColumnToRender + i;
        if (void 0 !== focusedCellColumnIndexNotInRange && focusedCell) if (visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) indexRelativeToAllColumns = focusedCellColumnIndexNotInRange;
        else indexRelativeToAllColumns -= 1;
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) if ('skeletonRow' !== rowType) {
            const { colSpan, width } = cellColSpanInfo.cellProps;
            const cellProps = {
                width,
                colSpan,
                showRightBorder: rootProps.showCellVerticalBorder,
                indexRelativeToAllColumns
            };
            cells.push(getCell(column, cellProps));
        } else {
            const { width } = cellColSpanInfo.cellProps;
            const contentWidth = Math.round(randomNumber());
            cells.push(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(slots.skeletonCell, {
                width: width,
                contentWidth: contentWidth,
                field: column.field,
                align: column.align
            }, column.field));
        }
    }
    const emptyCellWidth = containerWidth - columnsTotalWidth;
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", esm_extends_extends({
        ref: handleRef,
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: dist_clsx(...rowClassNames, classes.root, className, hovered && 'Mui-hovered'),
        "aria-rowindex": ariaRowIndex,
        "aria-selected": selected,
        style: style
    }, eventHandlers, other, {
        children: [
            cells,
            emptyCellWidth > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EmptyCell, {
                width: emptyCellWidth
            })
        ]
    }));
});
"production" !== process.env.NODE_ENV && (GridRow_GridRow.propTypes = {
    containerWidth: prop_types_default().number.isRequired,
    firstColumnToRender: prop_types_default().number.isRequired,
    focusedCell: prop_types_default().string,
    focusedCellColumnIndexNotInRange: prop_types_default().number,
    index: prop_types_default().number.isRequired,
    isLastVisible: prop_types_default().bool,
    isNotVisible: prop_types_default().bool,
    lastColumnToRender: prop_types_default().number.isRequired,
    onClick: prop_types_default().func,
    onDoubleClick: prop_types_default().func,
    onMouseEnter: prop_types_default().func,
    onMouseLeave: prop_types_default().func,
    position: prop_types_default().oneOf([
        'center',
        'left',
        'right'
    ]).isRequired,
    renderedColumns: prop_types_default().arrayOf(prop_types_default().object).isRequired,
    row: prop_types_default().object,
    rowHeight: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            'auto'
        ]),
        prop_types_default().number
    ]).isRequired,
    rowId: prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().string
    ]).isRequired,
    selected: prop_types_default().bool.isRequired,
    tabbableCell: prop_types_default().string,
    visibleColumns: prop_types_default().arrayOf(prop_types_default().object).isRequired
});
const MemoizedGridRow = fastMemo(GridRow_GridRow);
const GridColumnHeaderSortIcon_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        icon: [
            'sortIcon'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if ('asc' === direction) Icon = icons.columnSortedAscendingIcon;
    else if ('desc' === direction) Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Icon, esm_extends_extends({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function GridColumnHeaderSortIconRaw(props) {
    var _rootProps$slotProps;
    const { direction, index, sortingOrder } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = esm_extends_extends({}, props, {
        classes: rootProps.classes
    });
    const classes = GridColumnHeaderSortIcon_useUtilityClasses(ownerState);
    const iconElement = getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseIconButton, esm_extends_extends({
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small"
    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridIconButtonContainer_GridIconButtonContainer, {
        children: [
            null != index && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"], {
                badgeContent: index,
                color: "default",
                children: iconButton
            }),
            null == index && iconButton
        ]
    });
}
const GridColumnHeaderSortIcon_GridColumnHeaderSortIcon = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(GridColumnHeaderSortIconRaw);
"production" !== process.env.NODE_ENV && (GridColumnHeaderSortIconRaw.propTypes = {
    direction: prop_types_default().oneOf([
        'asc',
        'desc'
    ]),
    index: prop_types_default().number,
    sortingOrder: prop_types_default().arrayOf(prop_types_default().oneOf([
        'asc',
        'desc'
    ])).isRequired
});
const ColumnHeaderMenuIcon_useUtilityClasses = (ownerState)=>{
    const { classes, open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const ColumnHeaderMenuIcon = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo((props)=>{
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { colDef, open, columnMenuId, columnMenuButtonId, iconButtonRef } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = esm_extends_extends({}, props, {
        classes: rootProps.classes
    });
    const classes = ColumnHeaderMenuIcon_useUtilityClasses(ownerState);
    const handleMenuIconClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTooltip, esm_extends_extends({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTooltip, {
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseIconButton, esm_extends_extends({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuLabel'),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : void 0,
                id: columnMenuButtonId
            }, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.baseIconButton, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "small"
                })
            }))
        }))
    });
});
function GridColumnHeaderMenu({ columnMenuId, columnMenuButtonId, ContentComponent, contentComponentProps, field, open, target, onExited }) {
    const apiRef = useGridApiContext();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = useEventCallback_useEventCallback((event)=>{
        if (event) {
            event.stopPropagation();
            if (null != target && target.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridMenu, {
        placement: `bottom-${'right' === colDef.align ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContentComponent, esm_extends_extends({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}
"production" !== process.env.NODE_ENV && (GridColumnHeaderMenu.propTypes = {
    columnMenuButtonId: prop_types_default().string,
    columnMenuId: prop_types_default().string,
    ContentComponent: prop_types_default().elementType.isRequired,
    contentComponentProps: prop_types_default().any,
    field: prop_types_default().string.isRequired,
    onExited: prop_types_default().func,
    open: prop_types_default().bool.isRequired,
    target: HTMLElementType
});
const GridColumnHeaderTitle_excluded = [
    "className"
];
const GridColumnHeaderTitle_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeaderTitleRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle',
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)'
});
const GridColumnHeaderTitle_ColumnHeaderInnerTitle = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnHeaderTitle_excluded);
    const rootProps = useGridRootProps();
    const classes = GridColumnHeaderTitle_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderTitleRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: rootProps
    }, other));
});
function GridColumnHeaderTitle(props) {
    var _rootProps$slotProps;
    const { label, description } = props;
    const rootProps = useGridRootProps();
    const titleRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const [tooltip, setTooltip] = __WEBPACK_EXTERNAL_MODULE_react__.useState('');
    const handleMouseOver = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (!description && null != titleRef && titleRef.current) {
            const isOver = isOverflown(titleRef.current);
            isOver ? setTooltip(label) : setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.baseTooltip, esm_extends_extends({
        title: description || tooltip
    }, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.baseTooltip, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderTitle_ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}
"production" !== process.env.NODE_ENV && (GridColumnHeaderTitle.propTypes = {
    columnWidth: prop_types_default().number.isRequired,
    description: prop_types_default().node,
    label: prop_types_default().string.isRequired
});
const GridColumnHeaderSeparator_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var GridColumnHeaderSeparator_GridColumnHeaderSeparatorSides = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}(GridColumnHeaderSeparator_GridColumnHeaderSeparatorSides || {});
const GridColumnHeaderSeparator_useUtilityClasses = (ownerState)=>{
    const { resizable, resizing, classes, side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${capitalize(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderSeparatorRaw(props) {
    const { height, side = GridColumnHeaderSeparator_GridColumnHeaderSeparatorSides.Right } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnHeaderSeparator_excluded);
    const rootProps = useGridRootProps();
    const ownerState = esm_extends_extends({}, props, {
        side,
        classes: rootProps.classes
    });
    const classes = GridColumnHeaderSeparator_useUtilityClasses(ownerState);
    const stopClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", esm_extends_extends({
        className: classes.root,
        style: {
            minHeight: height,
            opacity: rootProps.showColumnVerticalBorder ? 0 : 1
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    }));
}
const GridColumnHeaderSeparator = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(GridColumnHeaderSeparatorRaw);
"production" !== process.env.NODE_ENV && (GridColumnHeaderSeparatorRaw.propTypes = {
    height: prop_types_default().number.isRequired,
    resizable: prop_types_default().bool.isRequired,
    resizing: prop_types_default().bool.isRequired,
    side: prop_types_default().oneOf([
        'left',
        'right'
    ])
});
const GridGenericColumnHeaderItem_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps"
];
const GridGenericColumnHeaderItem_GridGenericColumnHeaderItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { classes, columnMenuOpen, colIndex, height, isResizing, sortDirection, hasFocus, tabIndex, separatorSide, isDraggable, headerComponent, description, width, columnMenuIconButton = null, columnMenu = null, columnTitleIconButtons = null, headerClassName, label, resizable, draggableContainerProps, columnHeaderSeparatorProps } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridGenericColumnHeaderItem_excluded);
    const apiRef = useGridPrivateApiContext();
    const rootProps = useGridRootProps();
    const headerCellRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = __WEBPACK_EXTERNAL_MODULE_react__.useState(columnMenuOpen);
    const handleRef = useForkRef_useForkRef(headerCellRef, ref);
    let ariaSort = 'none';
    if (null != sortDirection) ariaSort = 'asc' === sortDirection ? 'ascending' : 'descending';
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            null == elementToFocus || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", esm_extends_extends({
        ref: handleRef,
        className: dist_clsx(classes.root, headerClassName),
        style: {
            height,
            width,
            minWidth: width,
            maxWidth: width
        },
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort,
        "aria-label": null == headerComponent ? label : void 0
    }, other, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", esm_extends_extends({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: void 0 !== headerComponent ? headerComponent : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderTitle, {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderSeparator, esm_extends_extends({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});
const GridColumnHeaderItem_useUtilityClasses = (ownerState)=>{
    const { colDef, classes, isDragging, sortDirection, showRightBorder, filterItemsCounter } = ownerState;
    const isColumnSorted = null != sortDirection;
    const isColumnFiltered = null != filterItemsCounter && filterItemsCounter > 0;
    const isColumnNumeric = 'number' === colDef.type;
    const slots = {
        root: [
            'columnHeader',
            'left' === colDef.headerAlign && 'columnHeader--alignLeft',
            'center' === colDef.headerAlign && 'columnHeader--alignCenter',
            'right' === colDef.headerAlign && 'columnHeader--alignRight',
            colDef.sortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderItem(props) {
    var _rootProps$slotProps, _colDef$sortingOrder, _rootProps$slotProps2, _colDef$headerName;
    const { colDef, columnMenuOpen, colIndex, headerHeight, isResizing, sortDirection, sortIndex, filterItemsCounter, hasFocus, tabIndex, disableReorder, separatorSide } = props;
    const apiRef = useGridPrivateApiContext();
    const rootProps = useGridRootProps();
    const headerCellRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const columnMenuId = useId();
    const columnMenuButtonId = useId();
    const iconButtonRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = __WEBPACK_EXTERNAL_MODULE_react__.useState(columnMenuOpen);
    const isDraggable = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = esm_extends_extends({}, props, {
        classes: rootProps.classes,
        showRightBorder: rootProps.showColumnVerticalBorder
    });
    const classes = GridColumnHeaderItem_useUtilityClasses(ownerState);
    const publish = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName)=>(event)=>{
            if (isEventTargetInPortal(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            onMouseOut: publish('columnHeaderOut'),
            onMouseEnter: publish('columnHeaderEnter'),
            onMouseLeave: publish('columnHeaderLeave'),
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEnd: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ColumnHeaderMenuIcon, {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderMenu, {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = null != (_colDef$sortingOrder = colDef.sortingOrder) ? _colDef$sortingOrder : rootProps.sortingOrder;
    const columnTitleIconButtons = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnHeaderFilterIconButton, esm_extends_extends({
                field: colDef.field,
                counter: filterItemsCounter
            }, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.columnHeaderFilterIconButton)),
            colDef.sortable && !colDef.hideSortIcons && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderSortIcon_GridColumnHeaderSortIcon, {
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder
            })
        ]
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            null == elementToFocus || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = 'function' == typeof colDef.headerClassName ? colDef.headerClassName({
        field: colDef.field,
        colDef
    }) : colDef.headerClassName;
    const label = null != (_colDef$headerName = colDef.headerName) ? _colDef$headerName : colDef.field;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridGenericColumnHeaderItem_GridGenericColumnHeaderItem, esm_extends_extends({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: headerClassName,
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps
    }, mouseEventsHandlers));
}
"production" !== process.env.NODE_ENV && (GridColumnHeaderItem.propTypes = {
    colDef: prop_types_default().object.isRequired,
    colIndex: prop_types_default().number.isRequired,
    columnMenuOpen: prop_types_default().bool.isRequired,
    disableReorder: prop_types_default().bool,
    filterItemsCounter: prop_types_default().number,
    hasFocus: prop_types_default().bool,
    headerHeight: prop_types_default().number.isRequired,
    isDragging: prop_types_default().bool.isRequired,
    isResizing: prop_types_default().bool.isRequired,
    separatorSide: prop_types_default().oneOf([
        'left',
        'right'
    ]),
    sortDirection: prop_types_default().oneOf([
        'asc',
        'desc'
    ]),
    sortIndex: prop_types_default().number,
    tabIndex: prop_types_default().oneOf([
        -1,
        0
    ]).isRequired
});
const gridVirtualizationSelector = (state)=>state.virtualization;
const gridVirtualizationEnabledSelector = createSelector_createSelector(gridVirtualizationSelector, (state)=>state.enabled);
const gridVirtualizationColumnEnabledSelector = createSelector_createSelector(gridVirtualizationSelector, (state)=>state.enabledForColumns);
const useGridVirtualScroller_excluded = [
    "style"
], useGridVirtualScroller_excluded2 = [
    "style"
];
function binarySearch(offset, positions, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const itemOffset = positions[pivot];
    return offset <= itemOffset ? binarySearch(offset, positions, sliceStart, pivot) : binarySearch(offset, positions, pivot + 1, sliceEnd);
}
function exponentialSearch(offset, positions, index) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return binarySearch(offset, positions, Math.floor(index / 2), Math.min(index, positions.length));
}
const getRenderableIndexes = ({ firstIndex, lastIndex, buffer, minFirstIndex, maxLastIndex })=>[
        clamp(firstIndex - buffer, minFirstIndex, maxLastIndex),
        clamp(lastIndex + buffer, minFirstIndex, maxLastIndex)
    ];
const areRenderContextsEqual = (context1, context2)=>{
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
};
const MEMOIZE_OPTIONS = {
    maxSize: 3
};
const useGridVirtualScroller = (props)=>{
    var _currentPage$range3, _currentPage$range4;
    const apiRef = useGridPrivateApiContext();
    const rootProps = useGridRootProps();
    const visibleColumns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
    const enabled = useGridSelector(apiRef, gridVirtualizationEnabledSelector);
    const enabledForColumns = useGridSelector(apiRef, gridVirtualizationColumnEnabledSelector);
    const { ref, onRenderZonePositioning, renderZoneMinColumnIndex = 0, renderZoneMaxColumnIndex = visibleColumns.length, getRowProps } = props;
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const columnPositions = useGridSelector(apiRef, gridColumnPositionsSelector);
    const columnsTotalWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
    const cellFocus = useGridSelector(apiRef, gridFocusCellSelector);
    const cellTabIndex = useGridSelector(apiRef, gridTabIndexCellSelector);
    const rowsMeta = useGridSelector(apiRef, gridRowsMetaSelector);
    const selectedRowsLookup = useGridSelector(apiRef, selectedIdsLookupSelector);
    const currentPage = useGridVisibleRows(apiRef, rootProps);
    const renderZoneRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const rootRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleRef = useForkRef_useForkRef(ref, rootRef);
    const [renderContext, setRenderContextState] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null);
    const prevRenderContext = __WEBPACK_EXTERNAL_MODULE_react__.useRef(renderContext);
    const scrollPosition = __WEBPACK_EXTERNAL_MODULE_react__.useRef({
        top: 0,
        left: 0
    });
    const [containerDimensions, setContainerDimensions] = __WEBPACK_EXTERNAL_MODULE_react__.useState({
        width: null,
        height: null
    });
    const prevTotalWidth = __WEBPACK_EXTERNAL_MODULE_react__.useRef(columnsTotalWidth);
    const [hoveredRowId, setHoveredRowId] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null);
    const rowStyleCache = __WEBPACK_EXTERNAL_MODULE_react__.useRef(Object.create(null));
    const prevGetRowProps = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const prevRootRowStyle = __WEBPACK_EXTERNAL_MODULE_react__.useRef();
    const getRenderedColumnsRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(defaultMemoize((columns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, indexOfColumnWithFocusedCell)=>{
        let focusedCellColumnIndexNotInRange;
        const renderedColumns = columns.slice(firstColumnToRender, lastColumnToRender);
        if (indexOfColumnWithFocusedCell > -1) {
            if (firstColumnToRender > indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell >= minFirstColumn) focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
            else if (lastColumnToRender < indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell < maxLastColumn) focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
        }
        return {
            focusedCellColumnIndexNotInRange,
            renderedColumns
        };
    }, MEMOIZE_OPTIONS));
    const indexOfColumnWithFocusedCell = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (null !== cellFocus) return visibleColumns.findIndex((column)=>column.field === cellFocus.field);
        return -1;
    }, [
        cellFocus,
        visibleColumns
    ]);
    const getNearestIndexToRender = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((offset)=>{
        var _currentPage$range, _currentPage$range2;
        const lastMeasuredIndexRelativeToAllRows = apiRef.current.getLastMeasuredRowIndex();
        let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === 1 / 0;
        if (null != (_currentPage$range = currentPage.range) && _currentPage$range.lastRowIndex && !allRowsMeasured) allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= currentPage.range.lastRowIndex;
        const lastMeasuredIndexRelativeToCurrentPage = clamp(lastMeasuredIndexRelativeToAllRows - ((null == (_currentPage$range2 = currentPage.range) ? void 0 : _currentPage$range2.firstRowIndex) || 0), 0, rowsMeta.positions.length);
        if (allRowsMeasured || rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) return binarySearch(offset, rowsMeta.positions);
        return exponentialSearch(offset, rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage);
    }, [
        apiRef,
        null == (_currentPage$range3 = currentPage.range) ? void 0 : _currentPage$range3.firstRowIndex,
        null == (_currentPage$range4 = currentPage.range) ? void 0 : _currentPage$range4.lastRowIndex,
        rowsMeta.positions
    ]);
    const computeRenderContext = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (!enabled) return {
            firstRowIndex: 0,
            lastRowIndex: currentPage.rows.length,
            firstColumnIndex: 0,
            lastColumnIndex: visibleColumns.length
        };
        const { top, left } = scrollPosition.current;
        const firstRowIndex = Math.min(getNearestIndexToRender(top), rowsMeta.positions.length - 1);
        const lastRowIndex = rootProps.autoHeight ? firstRowIndex + currentPage.rows.length : getNearestIndexToRender(top + containerDimensions.height);
        let firstColumnIndex = 0;
        let lastColumnIndex = columnPositions.length;
        if (enabledForColumns) {
            let hasRowWithAutoHeight = false;
            const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
                firstIndex: firstRowIndex,
                lastIndex: lastRowIndex,
                minFirstIndex: 0,
                maxLastIndex: currentPage.rows.length,
                buffer: rootProps.rowBuffer
            });
            for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
                const row = currentPage.rows[i];
                hasRowWithAutoHeight = apiRef.current.rowHasAutoHeight(row.id);
            }
            if (!hasRowWithAutoHeight) {
                firstColumnIndex = binarySearch(Math.abs(left), columnPositions);
                lastColumnIndex = binarySearch(Math.abs(left) + containerDimensions.width, columnPositions);
            }
        }
        return {
            firstRowIndex,
            lastRowIndex,
            firstColumnIndex,
            lastColumnIndex
        };
    }, [
        enabled,
        enabledForColumns,
        getNearestIndexToRender,
        rowsMeta.positions.length,
        rootProps.autoHeight,
        rootProps.rowBuffer,
        currentPage.rows,
        columnPositions,
        visibleColumns.length,
        apiRef,
        containerDimensions
    ]);
    useEnhancedEffect(()=>{
        if (enabled) {
            rootRef.current.scrollLeft = 0;
            rootRef.current.scrollTop = 0;
        } else renderZoneRef.current.style.transform = "translate3d(0px, 0px, 0px)";
    }, [
        enabled
    ]);
    useEnhancedEffect(()=>{
        setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, [
        rowsMeta.currentPageTotalHeight
    ]);
    const handleResize = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (rootRef.current) setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, []);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'debouncedResize', handleResize);
    const updateRenderZonePosition = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const [initialFirstColumnToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: renderZoneMinColumnIndex,
            maxLastIndex: renderZoneMaxColumnIndex,
            buffer: rootProps.columnBuffer
        });
        const firstColumnToRender = getFirstNonSpannedColumnToRender({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef,
            firstRowToRender,
            lastRowToRender,
            visibleRows: currentPage.rows
        });
        const direction = 'ltr' === theme.direction ? 1 : -1;
        const top = gridRowsMetaSelector(apiRef.current.state).positions[firstRowToRender];
        const left = direction * gridColumnPositionsSelector(apiRef)[firstColumnToRender];
        renderZoneRef.current.style.transform = `translate3d(${left}px, ${top}px, 0px)`;
        if ('function' == typeof onRenderZonePositioning) onRenderZonePositioning({
            top,
            left
        });
    }, [
        apiRef,
        currentPage.rows,
        onRenderZonePositioning,
        renderZoneMinColumnIndex,
        renderZoneMaxColumnIndex,
        rootProps.columnBuffer,
        rootProps.rowBuffer,
        theme.direction
    ]);
    const getRenderContext = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>prevRenderContext.current, []);
    const setRenderContext = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((nextRenderContext)=>{
        if (prevRenderContext.current && areRenderContextsEqual(nextRenderContext, prevRenderContext.current)) return void updateRenderZonePosition(nextRenderContext);
        setRenderContextState(nextRenderContext);
        updateRenderZonePosition(nextRenderContext);
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        apiRef.current.publishEvent('renderedRowsIntervalChange', {
            firstRowToRender,
            lastRowToRender
        });
        prevRenderContext.current = nextRenderContext;
    }, [
        apiRef,
        setRenderContextState,
        prevRenderContext,
        currentPage.rows.length,
        rootProps.rowBuffer,
        updateRenderZonePosition
    ]);
    useEnhancedEffect(()=>{
        if (null == containerDimensions.width) return;
        const initialRenderContext = computeRenderContext();
        setRenderContext(initialRenderContext);
        const { top, left } = scrollPosition.current;
        const params = {
            top,
            left,
            renderContext: initialRenderContext
        };
        apiRef.current.publishEvent('scrollPositionChange', params);
    }, [
        apiRef,
        computeRenderContext,
        containerDimensions.width,
        setRenderContext
    ]);
    const handleScroll = useEventCallback_useEventCallback((event)=>{
        const { scrollTop, scrollLeft } = event.currentTarget;
        scrollPosition.current.top = scrollTop;
        scrollPosition.current.left = scrollLeft;
        if (!prevRenderContext.current || scrollTop < 0) return;
        if ('ltr' === theme.direction) {
            if (scrollLeft < 0) return;
        }
        if ('rtl' === theme.direction) {
            if (scrollLeft > 0) return;
        }
        const nextRenderContext = enabled ? computeRenderContext() : prevRenderContext.current;
        const topRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstRowIndex - prevRenderContext.current.firstRowIndex);
        const bottomRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastRowIndex - prevRenderContext.current.lastRowIndex);
        const topColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstColumnIndex - prevRenderContext.current.firstColumnIndex);
        const bottomColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastColumnIndex - prevRenderContext.current.lastColumnIndex);
        const shouldSetState = topRowsScrolledSincePreviousRender >= rootProps.rowThreshold || bottomRowsScrolledSincePreviousRender >= rootProps.rowThreshold || topColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || bottomColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || prevTotalWidth.current !== columnsTotalWidth;
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollTop,
            left: scrollLeft,
            renderContext: shouldSetState ? nextRenderContext : prevRenderContext.current
        }, event);
        if (shouldSetState) {
            __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__.flushSync(()=>{
                setRenderContext(nextRenderContext);
            });
            prevTotalWidth.current = columnsTotalWidth;
        }
    });
    const handleWheel = useEventCallback_useEventCallback((event)=>{
        apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
    });
    const handleTouchMove = useEventCallback_useEventCallback((event)=>{
        apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
    });
    const indexOfRowWithFocusedCell = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (null !== cellFocus) return currentPage.rows.findIndex((row)=>row.id === cellFocus.id);
        return -1;
    }, [
        cellFocus,
        currentPage.rows
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowMouseOver', (params, event)=>{
        var _params$id;
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setHoveredRowId(null != (_params$id = params.id) ? _params$id : null);
    });
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'rowMouseOut', (params, event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setHoveredRowId(null);
    });
    const getRows = (params = {
        renderContext
    })=>{
        var _rootProps$slotProps;
        const { onRowRender, renderContext: nextRenderContext, minFirstColumn = renderZoneMinColumnIndex, maxLastColumn = renderZoneMaxColumnIndex, availableSpace = containerDimensions.width, rowIndexOffset = 0, position = 'center' } = params;
        if (!nextRenderContext || null == availableSpace) return null;
        const rowBuffer = enabled ? rootProps.rowBuffer : 0;
        const columnBuffer = enabled ? rootProps.columnBuffer : 0;
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rowBuffer
        });
        const renderedRows = [];
        if (params.rows) params.rows.forEach((row)=>{
            renderedRows.push(row);
            apiRef.current.calculateColSpan({
                rowId: row.id,
                minFirstColumn,
                maxLastColumn,
                columns: visibleColumns
            });
        });
        else {
            if (!currentPage.range) return null;
            for(let i = firstRowToRender; i < lastRowToRender; i += 1){
                const row = currentPage.rows[i];
                renderedRows.push(row);
                apiRef.current.calculateColSpan({
                    rowId: row.id,
                    minFirstColumn,
                    maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        let isRowWithFocusedCellNotInRange = false;
        if (indexOfRowWithFocusedCell > -1) {
            const rowWithFocusedCell = currentPage.rows[indexOfRowWithFocusedCell];
            if (firstRowToRender > indexOfRowWithFocusedCell || lastRowToRender < indexOfRowWithFocusedCell) {
                isRowWithFocusedCellNotInRange = true;
                if (indexOfRowWithFocusedCell > firstRowToRender) renderedRows.push(rowWithFocusedCell);
                else renderedRows.unshift(rowWithFocusedCell);
                apiRef.current.calculateColSpan({
                    rowId: rowWithFocusedCell.id,
                    minFirstColumn,
                    maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        const [initialFirstColumnToRender, lastColumnToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: minFirstColumn,
            maxLastIndex: maxLastColumn,
            buffer: columnBuffer
        });
        const firstColumnToRender = getFirstNonSpannedColumnToRender({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef,
            firstRowToRender,
            lastRowToRender,
            visibleRows: currentPage.rows
        });
        let isColumnWihFocusedCellNotInRange = false;
        if (firstColumnToRender > indexOfColumnWithFocusedCell || lastColumnToRender < indexOfColumnWithFocusedCell) isColumnWihFocusedCellNotInRange = true;
        const { focusedCellColumnIndexNotInRange, renderedColumns } = getRenderedColumnsRef.current(visibleColumns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, isColumnWihFocusedCellNotInRange ? indexOfColumnWithFocusedCell : -1);
        const _ref = (null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.row) || {}, { style: rootRowStyle } = _ref, rootRowProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, useGridVirtualScroller_excluded);
        const invalidatesCachedRowStyle = prevGetRowProps.current !== getRowProps || prevRootRowStyle.current !== rootRowStyle;
        if (invalidatesCachedRowStyle) rowStyleCache.current = Object.create(null);
        const rows = [];
        let isRowWithFocusedCellRendered = false;
        for(let i = 0; i < renderedRows.length; i += 1){
            var _currentPage$range5;
            const { id, model } = renderedRows[i];
            const isRowNotVisible = isRowWithFocusedCellNotInRange && cellFocus.id === id;
            const lastVisibleRowIndex = isRowWithFocusedCellNotInRange ? firstRowToRender + i === currentPage.rows.length : firstRowToRender + i === currentPage.rows.length - 1;
            const baseRowHeight = apiRef.current.rowHasAutoHeight(id) ? 'auto' : apiRef.current.unstable_getRowHeight(id);
            let isSelected;
            isSelected = null == selectedRowsLookup[id] ? false : apiRef.current.isRowSelectable(id);
            if (onRowRender) onRowRender(id);
            const focusedCell = null !== cellFocus && cellFocus.id === id ? cellFocus.field : null;
            const columnWithFocusedCellNotInRange = void 0 !== focusedCellColumnIndexNotInRange && visibleColumns[focusedCellColumnIndexNotInRange];
            const renderedColumnsWithFocusedCell = columnWithFocusedCellNotInRange && focusedCell ? [
                columnWithFocusedCellNotInRange,
                ...renderedColumns
            ] : renderedColumns;
            let tabbableCell = null;
            if (null !== cellTabIndex && cellTabIndex.id === id) {
                const cellParams = apiRef.current.getCellParams(id, cellTabIndex.field);
                tabbableCell = 'view' === cellParams.cellMode ? cellTabIndex.field : null;
            }
            const _ref2 = 'function' == typeof getRowProps && getRowProps(id, model) || {}, { style: rowStyle } = _ref2, rowProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref2, useGridVirtualScroller_excluded2);
            if (!rowStyleCache.current[id]) {
                const style = esm_extends_extends({}, rowStyle, rootRowStyle);
                rowStyleCache.current[id] = style;
            }
            let index = rowIndexOffset + ((null == currentPage || null == (_currentPage$range5 = currentPage.range) ? void 0 : _currentPage$range5.firstRowIndex) || 0) + firstRowToRender + i;
            if (isRowWithFocusedCellNotInRange && (null == cellFocus ? void 0 : cellFocus.id) === id) {
                index = indexOfRowWithFocusedCell;
                isRowWithFocusedCellRendered = true;
            } else if (isRowWithFocusedCellRendered) index -= 1;
            rows.push(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.row, esm_extends_extends({
                row: model,
                rowId: id,
                focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange,
                isNotVisible: isRowNotVisible,
                rowHeight: baseRowHeight,
                focusedCell: focusedCell,
                tabbableCell: tabbableCell,
                renderedColumns: renderedColumnsWithFocusedCell,
                visibleColumns: visibleColumns,
                firstColumnToRender: firstColumnToRender,
                lastColumnToRender: lastColumnToRender,
                selected: isSelected,
                index: index,
                containerWidth: availableSpace,
                isLastVisible: lastVisibleRowIndex,
                position: position
            }, rowProps, rootRowProps, {
                hovered: hoveredRowId === id,
                style: rowStyleCache.current[id]
            }), id));
        }
        prevGetRowProps.current = getRowProps;
        prevRootRowStyle.current = rootRowStyle;
        return rows;
    };
    const needsHorizontalScrollbar = containerDimensions.width && columnsTotalWidth >= containerDimensions.width;
    const contentSize = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const height = Math.max(rowsMeta.currentPageTotalHeight, 1);
        let shouldExtendContent = false;
        if (null != rootRef && rootRef.current && height <= (null == rootRef ? void 0 : rootRef.current.clientHeight)) shouldExtendContent = true;
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
            height,
            minHeight: shouldExtendContent ? '100%' : 'auto'
        };
        if (rootProps.autoHeight && 0 === currentPage.rows.length) size.height = getMinimalContentHeight(apiRef, rootProps.rowHeight);
        return size;
    }, [
        apiRef,
        rootRef,
        columnsTotalWidth,
        rowsMeta.currentPageTotalHeight,
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        rootProps.rowHeight,
        currentPage.rows.length
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        apiRef.current.publishEvent('virtualScrollerContentSizeChange');
    }, [
        apiRef,
        contentSize
    ]);
    const rootStyle = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const style = {};
        if (!needsHorizontalScrollbar) style.overflowX = 'hidden';
        if (rootProps.autoHeight) style.overflowY = 'hidden';
        return style;
    }, [
        needsHorizontalScrollbar,
        rootProps.autoHeight
    ]);
    apiRef.current.register('private', {
        getRenderContext
    });
    return {
        renderContext,
        updateRenderZonePosition,
        getRows,
        getRootProps: (inputProps = {})=>esm_extends_extends({
                ref: handleRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove
            }, inputProps, {
                style: inputProps.style ? esm_extends_extends({}, inputProps.style, rootStyle) : rootStyle,
                role: 'presentation'
            }),
        getContentProps: ({ style } = {})=>({
                style: style ? esm_extends_extends({}, style, contentSize) : contentSize,
                role: 'presentation'
            }),
        getRenderZoneProps: ()=>({
                ref: renderZoneRef,
                role: 'rowgroup'
            })
    };
};
const GridColumnGroupHeader_useUtilityClasses = (ownerState)=>{
    const { classes, headerAlign, isDragging, showColumnBorder, groupId } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            'left' === headerAlign && 'columnHeader--alignLeft',
            'center' === headerAlign && 'columnHeader--alignCenter',
            'right' === headerAlign && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showColumnBorder && 'columnHeader--showColumnBorder',
            showColumnBorder && 'columnHeader--withRightBorder',
            'withBorderColor',
            null === groupId ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnGroupHeader(props) {
    var _columnGroupsLookup$g;
    const { groupId, width, depth, maxDepth, fields, height, colIndex, hasFocus, tabIndex, isLastColumn } = props;
    const rootProps = useGridRootProps();
    const headerCellRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const apiRef = useGridApiContext();
    const columnGroupsLookup = useGridSelector(apiRef, gridColumnGroupsLookupSelector);
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName = null != groupId ? groupId : '', description = '', headerAlign } = group;
    let headerComponent;
    const render = groupId && (null == (_columnGroupsLookup$g = columnGroupsLookup[groupId]) ? void 0 : _columnGroupsLookup$g.renderHeaderGroup);
    const renderParams = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            groupId,
            headerName,
            description,
            depth,
            maxDepth,
            fields,
            colIndex,
            isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const showColumnBorder = rootProps.showColumnVerticalBorder;
    const ownerState = esm_extends_extends({}, props, {
        classes: rootProps.classes,
        showColumnBorder,
        headerAlign,
        depth,
        isDragging: false
    });
    const label = null != headerName ? headerName : groupId;
    const id = useId();
    const elementId = null === groupId ? `empty-group-cell-${id}` : groupId;
    const classes = GridColumnGroupHeader_useUtilityClasses(ownerState);
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            null == elementToFocus || elementToFocus.focus();
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((eventName)=>(event)=>{
            if (isEventTargetInPortal(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = 'function' == typeof group.headerClassName ? group.headerClassName(renderParams) : group.headerClassName;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridGenericColumnHeaderItem_GridGenericColumnHeaderItem, esm_extends_extends({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`
    }, mouseEventsHandlers));
}
const GridColumnHeaderRow = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow',
    overridesResolver: (props, styles)=>styles.columnHeaderRow
})(()=>({
        display: 'flex'
    }));
function isUIEvent(event) {
    return !!event.target;
}
const useGridColumnHeaders = (props)=>{
    const { innerRef: innerRefProp, minColumnIndex = 0, visibleColumns, sortColumnLookup, filterColumnLookup, columnPositions, columnHeaderTabIndexState, columnGroupHeaderTabIndexState, columnHeaderFocus, columnGroupHeaderFocus, densityFactor, headerGroupingMaxDepth, columnMenuState, columnVisibility, columnGroupsHeaderStructure, hasOtherElementInTabSequence } = props;
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useTheme)();
    const [dragCol, setDragCol] = __WEBPACK_EXTERNAL_MODULE_react__.useState('');
    const [resizeCol, setResizeCol] = __WEBPACK_EXTERNAL_MODULE_react__.useState('');
    const apiRef = useGridPrivateApiContext();
    const hasVirtualization = useGridSelector(apiRef, gridVirtualizationColumnEnabledSelector);
    const rootProps = useGridRootProps();
    const innerRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const handleInnerRef = useForkRef_useForkRef(innerRefProp, innerRef);
    const [renderContext, setRenderContextRaw] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null);
    const prevRenderContext = __WEBPACK_EXTERNAL_MODULE_react__.useRef(renderContext);
    const prevScrollLeft = __WEBPACK_EXTERNAL_MODULE_react__.useRef(0);
    const currentPage = useGridVisibleRows(apiRef, rootProps);
    const totalHeaderHeight = getTotalHeaderHeight(apiRef, rootProps.columnHeaderHeight);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const setRenderContext = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((nextRenderContext)=>{
        if (renderContext && nextRenderContext && areRenderContextsEqual(renderContext, nextRenderContext)) return;
        setRenderContextRaw(nextRenderContext);
    }, [
        renderContext
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }, [
        apiRef
    ]);
    const getFirstColumnIndexToRenderRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(defaultMemoize(getFirstColumnIndexToRender, {
        equalityCheck: (a, b)=>[
                'firstColumnIndex',
                'minColumnIndex',
                'columnBuffer'
            ].every((key)=>a[key] === b[key])
    }));
    const updateInnerPosition = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex,
            columnBuffer: rootProps.columnBuffer,
            firstRowToRender,
            lastRowToRender,
            apiRef,
            visibleRows: currentPage.rows
        });
        const direction = 'ltr' === theme.direction ? 1 : -1;
        const offset = firstColumnToRender > 0 ? prevScrollLeft.current - direction * columnPositions[firstColumnToRender] : prevScrollLeft.current;
        innerRef.current.style.transform = `translate3d(${-offset}px, 0px, 0px)`;
    }, [
        columnPositions,
        minColumnIndex,
        rootProps.columnBuffer,
        apiRef,
        currentPage.rows,
        rootProps.rowBuffer,
        theme.direction
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useLayoutEffect(()=>{
        if (renderContext) updateInnerPosition(renderContext);
    }, [
        renderContext,
        updateInnerPosition
    ]);
    const handleScroll = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ left, renderContext: nextRenderContext = null }, event)=>{
        var _prevRenderContext$cu, _prevRenderContext$cu2;
        if (!innerRef.current) return;
        if (prevScrollLeft.current === left && (null == (_prevRenderContext$cu = prevRenderContext.current) ? void 0 : _prevRenderContext$cu.firstColumnIndex) === (null == nextRenderContext ? void 0 : nextRenderContext.firstColumnIndex) && (null == (_prevRenderContext$cu2 = prevRenderContext.current) ? void 0 : _prevRenderContext$cu2.lastColumnIndex) === (null == nextRenderContext ? void 0 : nextRenderContext.lastColumnIndex)) return;
        prevScrollLeft.current = left;
        let canUpdateInnerPosition = false;
        if (nextRenderContext === prevRenderContext.current && prevRenderContext.current) canUpdateInnerPosition = true;
        else {
            if (isUIEvent(event)) {
                __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__.flushSync(()=>{
                    setRenderContext(nextRenderContext);
                });
                canUpdateInnerPosition = true;
            } else setRenderContext(nextRenderContext);
            prevRenderContext.current = nextRenderContext;
        }
        if (nextRenderContext && canUpdateInnerPosition) updateInnerPosition(nextRenderContext);
    }, [
        updateInnerPosition,
        setRenderContext
    ]);
    const handleColumnResizeStart = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>setDragCol(''), []);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnResizeStart', handleColumnResizeStart);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnResizeStop', handleColumnResizeStop);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'scrollPositionChange', handleScroll);
    const getColumnsToRender = (params)=>{
        const { renderContext: nextRenderContext = renderContext, minFirstColumn = minColumnIndex, maxLastColumn = visibleColumns.length } = params || {};
        if (!nextRenderContext) return null;
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = hasVirtualization ? getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex: minFirstColumn,
            columnBuffer: rootProps.columnBuffer,
            apiRef,
            firstRowToRender,
            lastRowToRender,
            visibleRows: currentPage.rows
        }) : 0;
        const lastColumnToRender = hasVirtualization ? Math.min(nextRenderContext.lastColumnIndex + rootProps.columnBuffer, maxLastColumn) : maxLastColumn;
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns,
            firstColumnToRender,
            lastColumnToRender,
            minFirstColumn,
            maxLastColumn
        };
    };
    const getColumnHeaders = (params, other = {})=>{
        const columnsToRender = getColumnsToRender(params);
        if (null == columnsToRender) return null;
        const { renderedColumns, firstColumnToRender } = columnsToRender;
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = 0 === columnIndex;
            const tabIndex = null !== columnHeaderTabIndexState && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = null !== columnHeaderFocus && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            columns.push(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderItem, esm_extends_extends({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            }, other), colDef.field));
        }
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            children: columns
        });
    };
    const getColumnGroupHeaders = (params)=>{
        if (0 === headerGroupingMaxDepth) return null;
        const columnsToRender = getColumnsToRender(params);
        if (null == columnsToRender || 0 === columnsToRender.renderedColumns.length) return null;
        const { firstColumnToRender, lastColumnToRender } = columnsToRender;
        const columns = [];
        const headerToRender = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1){
            var _apiRef$current$unsta, _apiRef$current$unsta2;
            const rowStructure = columnGroupsHeaderStructure[depth];
            const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
            const firstGroupToRender = null != (_apiRef$current$unsta = apiRef.current.unstable_getColumnGroupPath(firstColumnFieldToRender)[depth]) ? _apiRef$current$unsta : null;
            const firstGroupIndex = rowStructure.findIndex(({ groupId, columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
            const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
            const lastGroupToRender = null != (_apiRef$current$unsta2 = apiRef.current.unstable_getColumnGroupPath(lastColumnFieldToRender)[depth]) ? _apiRef$current$unsta2 : null;
            const lastGroupIndex = rowStructure.findIndex(({ groupId, columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
            const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>esm_extends_extends({}, groupStructure, {
                    columnFields: groupStructure.columnFields.filter((field)=>false !== columnVisibility[field])
                })).filter((groupStructure)=>groupStructure.columnFields.length > 0);
            const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
            const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
            const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
                var _column$computedWidth;
                const column = apiRef.current.getColumn(field);
                return acc + (null != (_column$computedWidth = column.computedWidth) ? _column$computedWidth : 0);
            }, 0);
            let columnIndex = firstColumnToRender;
            const elements = visibleColumnGroupHeader.map(({ groupId, columnFields })=>{
                const hasFocus = null !== columnGroupHeaderFocus && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
                const tabIndex = null !== columnGroupHeaderTabIndexState && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
                const headerInfo = {
                    groupId,
                    width: columnFields.reduce((acc, field)=>acc + apiRef.current.getColumn(field).computedWidth, 0),
                    fields: columnFields,
                    colIndex: columnIndex,
                    hasFocus,
                    tabIndex
                };
                columnIndex += columnFields.length;
                return headerInfo;
            });
            headerToRender.push({
                leftOverflow,
                elements
            });
        }
        headerToRender.forEach((depthInfo, depthIndex)=>{
            columns.push(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeaderRow, {
                style: {
                    height: `${headerHeight}px`,
                    transform: `translateX(-${depthInfo.leftOverflow}px)`
                },
                role: "row",
                "aria-rowindex": depthIndex + 1,
                ownerState: rootProps,
                children: depthInfo.elements.map(({ groupId, width, fields, colIndex, hasFocus, tabIndex }, groupIndex)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnGroupHeader, {
                        groupId: groupId,
                        width: width,
                        fields: fields,
                        colIndex: colIndex,
                        depth: depthIndex,
                        isLastColumn: colIndex === visibleColumns.length - fields.length,
                        maxDepth: headerToRender.length,
                        height: headerHeight,
                        hasFocus: hasFocus,
                        tabIndex: tabIndex
                    }, groupIndex))
            }, depthIndex));
        });
        return columns;
    };
    const rootStyle = {
        minHeight: totalHeaderHeight,
        maxHeight: totalHeaderHeight,
        lineHeight: `${headerHeight}px`
    };
    return {
        renderContext,
        getColumnHeaders,
        getColumnsToRender,
        getColumnGroupHeaders,
        isDragging: !!dragCol,
        getRootProps: (other = {})=>esm_extends_extends({
                style: rootStyle
            }, other),
        getInnerProps: ()=>({
                ref: handleInnerRef,
                role: 'rowgroup'
            }),
        headerHeight
    };
};
const GridBaseColumnHeaders_excluded = [
    "className"
];
const GridBaseColumnHeaders_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders',
            'withBorderColor'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeadersRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders',
    overridesResolver: (props, styles)=>styles.columnHeaders
})({
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderBottom: '1px solid',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const GridBaseColumnHeaders = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridBaseColumnHeaders_excluded);
    const rootProps = useGridRootProps();
    const classes = GridBaseColumnHeaders_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeadersRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(className, classes.root),
        ownerState: rootProps
    }, other, {
        role: "presentation"
    }));
});
const GridColumnHeadersInner_excluded = [
    "isDragging",
    "className"
];
const GridColumnHeadersInner_useUtilityClasses = (ownerState)=>{
    const { isDragging, hasScrollX, classes } = ownerState;
    const slots = {
        root: [
            'columnHeadersInner',
            isDragging && 'columnHeaderDropZone',
            hasScrollX && 'columnHeadersInner--scrollable'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeadersInnerRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'columnHeadersInner',
    overridesResolver: (props, styles)=>[
            {
                [`&.${gridClasses_gridClasses.columnHeaderDropZone}`]: styles.columnHeaderDropZone
            },
            styles.columnHeadersInner
        ]
})(()=>({
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        [`&.${gridClasses_gridClasses.columnHeaderDropZone} .${gridClasses_gridClasses.columnHeaderDraggableContainer}`]: {
            cursor: 'move'
        },
        [`&.${gridClasses_gridClasses["columnHeadersInner--scrollable"]} .${gridClasses_gridClasses.columnHeader}:last-child`]: {
            borderRight: 'none'
        }
    }));
const GridColumnHeadersInner_GridColumnHeadersInner = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _apiRef$current$getRo, _apiRef$current$getRo2;
    const { isDragging, className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnHeadersInner_excluded);
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const ownerState = esm_extends_extends({}, rootProps, {
        isDragging,
        hasScrollX: null != (_apiRef$current$getRo = null == (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) ? void 0 : _apiRef$current$getRo2.hasScrollX) ? _apiRef$current$getRo : false
    });
    const classes = GridColumnHeadersInner_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnHeadersInnerRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(className, classes.root),
        ownerState: ownerState
    }, other));
});
const GridColumnHeaders_excluded = [
    "innerRef",
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnPositions",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "densityFactor",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const GridColumnHeaders_GridColumnHeaders = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { innerRef, visibleColumns, sortColumnLookup, filterColumnLookup, columnPositions, columnHeaderTabIndexState, columnGroupHeaderTabIndexState, columnHeaderFocus, columnGroupHeaderFocus, densityFactor, headerGroupingMaxDepth, columnMenuState, columnVisibility, columnGroupsHeaderStructure, hasOtherElementInTabSequence } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnHeaders_excluded);
    const { isDragging, getRootProps, getInnerProps, getColumnHeaders, getColumnGroupHeaders } = useGridColumnHeaders({
        innerRef,
        visibleColumns,
        sortColumnLookup,
        filterColumnLookup,
        columnPositions,
        columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState,
        columnHeaderFocus,
        columnGroupHeaderFocus,
        densityFactor,
        headerGroupingMaxDepth,
        columnMenuState,
        columnVisibility,
        columnGroupsHeaderStructure,
        hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridBaseColumnHeaders, esm_extends_extends({
        ref: ref
    }, getRootProps(other), {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridColumnHeadersInner_GridColumnHeadersInner, esm_extends_extends({
            isDragging: isDragging
        }, getInnerProps(), {
            children: [
                getColumnGroupHeaders(),
                getColumnHeaders()
            ]
        }))
    }));
});
"production" !== process.env.NODE_ENV && (GridColumnHeaders_GridColumnHeaders.propTypes = {
    columnGroupHeaderFocus: prop_types_default().shape({
        depth: prop_types_default().number.isRequired,
        field: prop_types_default().string.isRequired
    }),
    columnGroupHeaderTabIndexState: prop_types_default().shape({
        depth: prop_types_default().number.isRequired,
        field: prop_types_default().string.isRequired
    }),
    columnGroupsHeaderStructure: prop_types_default().arrayOf(prop_types_default().arrayOf(prop_types_default().shape({
        columnFields: prop_types_default().arrayOf(prop_types_default().string).isRequired,
        groupId: prop_types_default().string
    }))).isRequired,
    columnHeaderFocus: prop_types_default().shape({
        field: prop_types_default().string.isRequired
    }),
    columnHeaderTabIndexState: prop_types_default().shape({
        field: prop_types_default().string.isRequired
    }),
    columnMenuState: prop_types_default().shape({
        field: prop_types_default().string,
        open: prop_types_default().bool.isRequired
    }).isRequired,
    columnPositions: prop_types_default().arrayOf(prop_types_default().number).isRequired,
    columnVisibility: prop_types_default().object.isRequired,
    densityFactor: prop_types_default().number.isRequired,
    filterColumnLookup: prop_types_default().object.isRequired,
    hasOtherElementInTabSequence: prop_types_default().bool.isRequired,
    headerGroupingMaxDepth: prop_types_default().number.isRequired,
    innerRef: refType,
    minColumnIndex: prop_types_default().number,
    sortColumnLookup: prop_types_default().object.isRequired,
    visibleColumns: prop_types_default().arrayOf(prop_types_default().object).isRequired
});
const MemoizedGridColumnHeaders = fastMemo(GridColumnHeaders_GridColumnHeaders);
const useGridColumnMenuSlots_excluded = [
    "displayOrder"
];
const useGridColumnMenuSlots = (props)=>{
    const apiRef = useGridPrivateApiContext();
    const { defaultSlots, defaultSlotProps, slots = {}, slotProps = {}, hideMenu, colDef, addDividers = true } = props;
    const processedComponents = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>esm_extends_extends({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!slotProps || 0 === Object.keys(slotProps).length) return defaultSlotProps;
        const mergedProps = esm_extends_extends({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = esm_extends_extends({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>null != processedComponents[key]);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(null == leftItemProps ? void 0 : leftItemProps.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(null == rightItemProps ? void 0 : rightItemProps.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(processedComponentProps, useGridColumnMenuSlots_excluded);
                itemProps = esm_extends_extends({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    __WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"],
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems
    ]);
};
const GridColumnMenuContainer_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const StyledMenuList = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuList_abce8441__["default"])(()=>({
        minWidth: 248
    }));
const GridColumnMenuContainer_GridColumnMenuContainer = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { hideMenu, id, labelledby, className, children, open } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnMenuContainer_excluded);
    const handleListKeyDown = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        if (isTabKey(event.key)) event.preventDefault();
        if (isHideMenuKey(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledMenuList, esm_extends_extends({
        id: id,
        ref: ref,
        className: dist_clsx(gridClasses_gridClasses.menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        children: children
    }));
});
"production" !== process.env.NODE_ENV && (GridColumnMenuContainer_GridColumnMenuContainer.propTypes = {
    colDef: prop_types_default().object.isRequired,
    hideMenu: prop_types_default().func.isRequired,
    id: prop_types_default().string,
    labelledby: prop_types_default().string,
    open: prop_types_default().bool.isRequired
});
function GridColumnMenuHideItem(props) {
    const { colDef, onClick } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>true !== col.disableColumnMenu);
    const disabled = 1 === columnsWithMenu.length;
    const toggleColumn = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (false === colDef.hideable) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
        onClick: toggleColumn,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnMenuHideIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                children: apiRef.current.getLocaleText('columnMenuHideColumn')
            })
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridColumnMenuHideItem.propTypes = {
    colDef: prop_types_default().object.isRequired,
    onClick: prop_types_default().func.isRequired
});
function GridColumnMenuManageItem(props) {
    const { onClick } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const showColumns = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        onClick(event);
        apiRef.current.showPreferences(gridPreferencePanelsValue_GridPreferencePanelsValue.columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
        onClick: showColumns,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                children: apiRef.current.getLocaleText('columnMenuManageColumns')
            })
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridColumnMenuManageItem.propTypes = {
    colDef: prop_types_default().object.isRequired,
    onClick: prop_types_default().func.isRequired
});
function GridColumnMenuColumnsItem(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnMenuHideItem, esm_extends_extends({}, props)),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnMenuManageItem, esm_extends_extends({}, props))
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridColumnMenuColumnsItem.propTypes = {
    colDef: prop_types_default().object.isRequired,
    onClick: prop_types_default().func.isRequired
});
function GridColumnMenuFilterItem(props) {
    const { colDef, onClick } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const showFilter = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
        onClick: showFilter,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnMenuFilterIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                children: apiRef.current.getLocaleText('columnMenuFilter')
            })
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridColumnMenuFilterItem.propTypes = {
    colDef: prop_types_default().object.isRequired,
    onClick: prop_types_default().func.isRequired
});
function GridColumnMenuSortItem(props) {
    var _colDef$sortingOrder;
    const { colDef, onClick } = props;
    const apiRef = useGridApiContext();
    const sortModel = useGridSelector(apiRef, gridSortModelSelector);
    const rootProps = useGridRootProps();
    const sortDirection = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return null == sortItem ? void 0 : sortItem.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = null != (_colDef$sortingOrder = colDef.sortingOrder) ? _colDef$sortingOrder : rootProps.sortingOrder;
    const onSortMenuItemClick = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        apiRef.current.sortColumn(colDef, direction === sortDirection ? null : direction);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection
    ]);
    if (!colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return 'function' == typeof label ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react__.Fragment, {
        children: [
            sortingOrder.includes('asc') && 'asc' !== sortDirection ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                        children: getLabel('columnMenuSortAsc')
                    })
                ]
            }) : null,
            sortingOrder.includes('desc') && 'desc' !== sortDirection ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                        children: getLabel('columnMenuSortDesc')
                    })
                ]
            }) : null,
            sortingOrder.includes(null) && null != sortDirection ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], {
                onClick: onSortMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {}),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                        children: apiRef.current.getLocaleText('columnMenuUnsort')
                    })
                ]
            }) : null
        ]
    });
}
"production" !== process.env.NODE_ENV && (GridColumnMenuSortItem.propTypes = {
    colDef: prop_types_default().object.isRequired,
    onClick: prop_types_default().func.isRequired
});
const GridColumnMenu_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const GRID_COLUMN_MENU_SLOTS = {
    columnMenuSortItem: GridColumnMenuSortItem,
    columnMenuFilterItem: GridColumnMenuFilterItem,
    columnMenuColumnsItem: GridColumnMenuColumnsItem
};
const GRID_COLUMN_MENU_SLOT_PROPS = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const GridColumnMenu_GridGenericColumnMenu = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { defaultSlots, defaultSlotProps, slots, slotProps } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnMenu_excluded);
    const orderedSlots = useGridColumnMenuSlots(esm_extends_extends({}, other, {
        defaultSlots,
        defaultSlotProps,
        slots,
        slotProps
    }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnMenuContainer_GridColumnMenuContainer, esm_extends_extends({
        ref: ref
    }, other, {
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Component, esm_extends_extends({}, otherProps), index))
    }));
});
const GridColumnMenu_GridColumnMenu = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridColumnMenu_GridGenericColumnMenu, esm_extends_extends({}, props, {
        ref: ref,
        defaultSlots: GRID_COLUMN_MENU_SLOTS,
        defaultSlotProps: GRID_COLUMN_MENU_SLOT_PROPS
    }));
});
"production" !== process.env.NODE_ENV && (GridColumnMenu_GridColumnMenu.propTypes = {
    colDef: prop_types_default().object.isRequired,
    hideMenu: prop_types_default().func.isRequired,
    id: prop_types_default().string,
    labelledby: prop_types_default().string,
    open: prop_types_default().bool.isRequired,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object
});
const GridNoResultsOverlay_GridNoResultsOverlay = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const apiRef = useGridApiContext();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlay_GridOverlay, esm_extends_extends({
        ref: ref
    }, props, {
        children: noResultsOverlayLabel
    }));
});
const GridColumnUnsortedIcon_excluded = [
    "sortingOrder"
];
const GridColumnUnsortedIcon = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(function(props) {
    const { sortingOrder } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridColumnUnsortedIcon_excluded);
    const rootProps = useGridRootProps();
    const [nextSortDirection] = sortingOrder;
    const Icon = 'asc' === nextSortDirection ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Icon, esm_extends_extends({}, other)) : null;
});
const GridArrowUpwardIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const GridArrowDownwardIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const GridKeyboardArrowRight = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const GridExpandMoreIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const GridFilterListIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const GridFilterAltIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const GridSearchIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
(0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
(0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const GridColumnIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const GridSeparatorIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M11 19V5h2v14z"
}), 'Separator');
const GridViewHeadlineIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const GridTableRowsIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const GridViewStreamIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const GridTripleDotsVerticalIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const GridCloseIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const GridAddIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const GridRemoveIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const GridLoadIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const GridDragIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const GridSaveAltIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const GridCheckIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const GridMoreVertIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const GridVisibilityOffIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const GridViewColumnIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const GridClearIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
(0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const GridDeleteForeverIcon = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_utils_f63ffa7b__.createSvgIcon)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const MUISelectOption_excluded = [
    "native"
];
function MUISelectOption(_ref) {
    let { native } = _ref, props = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, MUISelectOption_excluded);
    if (native) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("option", esm_extends_extends({}, props));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_MenuItem_25e2acb5__["default"], esm_extends_extends({}, props));
}
const iconSlots = {
    BooleanCellTrueIcon: GridCheckIcon,
    BooleanCellFalseIcon: GridCloseIcon,
    ColumnMenuIcon: GridTripleDotsVerticalIcon,
    OpenFilterButtonIcon: GridFilterListIcon,
    FilterPanelDeleteIcon: GridCloseIcon,
    ColumnFilteredIcon: GridFilterAltIcon,
    ColumnSelectorIcon: GridColumnIcon,
    ColumnUnsortedIcon: GridColumnUnsortedIcon,
    ColumnSortedAscendingIcon: GridArrowUpwardIcon,
    ColumnSortedDescendingIcon: GridArrowDownwardIcon,
    ColumnResizeIcon: GridSeparatorIcon,
    DensityCompactIcon: GridViewHeadlineIcon,
    DensityStandardIcon: GridTableRowsIcon,
    DensityComfortableIcon: GridViewStreamIcon,
    ExportIcon: GridSaveAltIcon,
    MoreActionsIcon: GridMoreVertIcon,
    TreeDataCollapseIcon: GridExpandMoreIcon,
    TreeDataExpandIcon: GridKeyboardArrowRight,
    GroupingCriteriaCollapseIcon: GridExpandMoreIcon,
    GroupingCriteriaExpandIcon: GridKeyboardArrowRight,
    DetailPanelExpandIcon: GridAddIcon,
    DetailPanelCollapseIcon: GridRemoveIcon,
    RowReorderIcon: GridDragIcon,
    QuickFilterIcon: GridSearchIcon,
    QuickFilterClearIcon: GridCloseIcon,
    ColumnMenuHideIcon: GridVisibilityOffIcon,
    ColumnMenuSortAscendingIcon: GridArrowUpwardIcon,
    ColumnMenuSortDescendingIcon: GridArrowDownwardIcon,
    ColumnMenuFilterIcon: GridFilterAltIcon,
    ColumnMenuManageColumnsIcon: GridViewColumnIcon,
    ColumnMenuClearIcon: GridClearIcon,
    LoadIcon: GridLoadIcon,
    FilterPanelAddIcon: GridAddIcon,
    FilterPanelRemoveAllIcon: GridDeleteForeverIcon,
    ColumnReorderIcon: GridDragIcon
};
const materialSlots = esm_extends_extends({}, iconSlots, {
    BaseCheckbox: __WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__["default"],
    BaseTextField: __WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"],
    BaseFormControl: __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__["default"],
    BaseSelect: __WEBPACK_EXTERNAL_MODULE__mui_material_Select_bb5d0ab2__["default"],
    BaseSwitch: __WEBPACK_EXTERNAL_MODULE__mui_material_Switch_72bb925c__["default"],
    BaseButton: __WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"],
    BaseIconButton: __WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"],
    BaseInputAdornment: __WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__["default"],
    BaseTooltip: __WEBPACK_EXTERNAL_MODULE__mui_material_Tooltip_69cc2f11__["default"],
    BasePopper: __WEBPACK_EXTERNAL_MODULE__mui_material_Popper_24cb866b__["default"],
    BaseInputLabel: __WEBPACK_EXTERNAL_MODULE__mui_material_InputLabel_cf26b488__["default"],
    BaseSelectOption: MUISelectOption,
    BaseChip: __WEBPACK_EXTERNAL_MODULE__mui_material_Chip_305fde45__["default"]
});
const material = materialSlots;
const DATA_GRID_DEFAULT_SLOTS_COMPONENTS = esm_extends_extends({}, material, {
    Cell: MemoizedGridCellV7,
    SkeletonCell: GridSkeletonCell,
    ColumnHeaderFilterIconButton: GridColumnHeaderFilterIconButton,
    ColumnMenu: GridColumnMenu_GridColumnMenu,
    ColumnHeaders: MemoizedGridColumnHeaders,
    Footer: GridFooter_GridFooter,
    FooterRowCount: GridRowCount_GridRowCount,
    Toolbar: null,
    PreferencesPanel: GridPreferencesPanel_GridPreferencesPanel,
    LoadingOverlay: GridLoadingOverlay_GridLoadingOverlay,
    NoResultsOverlay: GridNoResultsOverlay_GridNoResultsOverlay,
    NoRowsOverlay: GridNoRowsOverlay_GridNoRowsOverlay,
    Pagination: GridPagination_GridPagination,
    FilterPanel: GridFilterPanel_GridFilterPanel,
    ColumnsPanel: GridColumnsPanel,
    Panel: GridPanel,
    Row: MemoizedGridRow
});
const uncapitalizeObjectKeys = (capitalizedObject)=>{
    if (void 0 === capitalizedObject) return;
    return Object.keys(capitalizedObject).reduce((acc, key)=>esm_extends_extends({}, acc, {
            [`${key.charAt(0).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};
const useProps_excluded = [
    "components",
    "componentsProps"
];
function groupForwardedProps(props) {
    var _props$forwardedProps;
    const keys = Object.keys(props);
    if (!keys.some((key)=>key.startsWith('aria-') || key.startsWith('data-'))) return props;
    const newProps = {};
    const forwardedProps = null != (_props$forwardedProps = props.forwardedProps) ? _props$forwardedProps : {};
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (key.startsWith('aria-') || key.startsWith('data-')) forwardedProps[key] = props[key];
        else newProps[key] = props[key];
    }
    newProps.forwardedProps = forwardedProps;
    return newProps;
}
function useProps(allProps) {
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const { components, componentsProps } = allProps, themedProps = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(allProps, useProps_excluded);
        return [
            components,
            componentsProps,
            groupForwardedProps(themedProps)
        ];
    }, [
        allProps
    ]);
}
function computeSlots({ defaultSlots, slots, components }) {
    const overrides = null != slots ? slots : components ? uncapitalizeObjectKeys(components) : null;
    if (!overrides || 0 === Object.keys(overrides).length) return defaultSlots;
    const result = esm_extends_extends({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (void 0 !== overrides[k]) result[k] = overrides[k];
    });
    return result;
}
const DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    disableMultipleRowSelection: true,
    throttleRowsMs: void 0,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    disableColumnResize: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid'
};
const DATA_GRID_PROPS_DEFAULT_VALUES = {
    autoHeight: false,
    autoPageSize: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    columnBuffer: 3,
    rowBuffer: 3,
    columnThreshold: 3,
    rowThreshold: 3,
    rowSelection: true,
    density: 'standard',
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnSelector: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleRowSelection: false,
    disableMultipleColumnsSorting: false,
    disableRowSelectionOnClick: false,
    disableVirtualization: false,
    editMode: gridEditRowModel_GridEditModes.Cell,
    filterMode: 'client',
    filterDebounceMs: 150,
    columnHeaderHeight: 56,
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    logger: console,
    logLevel: 'production' === process.env.NODE_ENV ? 'error' : 'warn',
    pagination: false,
    paginationMode: 'client',
    rowHeight: 52,
    pageSizeOptions: [
        25,
        50,
        100
    ],
    rowSpacingType: 'margin',
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    sortingMode: 'client',
    throttleRowsMs: 0,
    disableColumnReorder: false,
    disableColumnResize: false,
    keepNonExistentRowsSelected: false,
    keepColumnPositionIfDraggedOutside: false,
    unstable_ignoreValueFormatterDuringExport: false,
    clipboardCopyCellDelimiter: '\t',
    rowPositionsDebounceMs: 166
};
const useDataGridProps_defaultSlots = uncapitalizeObjectKeys(DATA_GRID_DEFAULT_SLOTS_COMPONENTS);
const useDataGridProps = (inProps)=>{
    const [components, componentsProps, themedProps] = useProps((0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.useThemeProps)({
        props: inProps,
        name: 'MuiDataGrid'
    }));
    const localeText = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>esm_extends_extends({}, GRID_DEFAULT_LOCALE_TEXT, themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>computeSlots({
            defaultSlots: useDataGridProps_defaultSlots,
            slots: themedProps.slots,
            components
        }), [
        components,
        themedProps.slots
    ]);
    return __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        var _themedProps$slotProp;
        return esm_extends_extends({}, DATA_GRID_PROPS_DEFAULT_VALUES, themedProps, {
            localeText,
            slots,
            slotProps: null != (_themedProps$slotProp = themedProps.slotProps) ? _themedProps$slotProp : componentsProps
        }, DATA_GRID_FORCED_PROPS);
    }, [
        themedProps,
        localeText,
        slots,
        componentsProps
    ]);
};
const rowsMetaStateInitializer = (state)=>esm_extends_extends({}, state, {
        rowsMeta: {
            currentPageTotalHeight: 0,
            positions: []
        }
    });
let warnedOnceInvalidRowHeight = false;
const getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if ('number' == typeof rowHeightProp && rowHeightProp > 0) return rowHeightProp;
    if ('production' !== process.env.NODE_ENV && !warnedOnceInvalidRowHeight && null != rowHeightProp) {
        console.warn(warningMessage);
        warnedOnceInvalidRowHeight = true;
    }
    return defaultRowHeight;
};
const rowHeightWarning = "MUI: The `rowHeight` prop should be a number greater than 0.\nThe default value will be used instead.";
const getRowHeightWarning = "MUI: The `getRowHeight` prop should return a number greater than 0 or 'auto'.\nThe default value will be used instead.";
const useGridRowsMeta = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing, getEstimatedRowHeight } = props;
    const rowsHeightLookup = __WEBPACK_EXTERNAL_MODULE_react__.useRef(Object.create(null));
    const lastMeasuredRowIndex = __WEBPACK_EXTERNAL_MODULE_react__.useRef(-1);
    const hasRowWithAutoHeight = __WEBPACK_EXTERNAL_MODULE_react__.useRef(false);
    const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
    const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
    const paginationState = useGridSelector(apiRef, gridPaginationSelector);
    const sortModel = useGridSelector(apiRef, gridSortModelSelector);
    const currentPage = useGridVisibleRows(apiRef, props);
    const pinnedRows = useGridSelector(apiRef, gridPinnedRowsSelector);
    const validRowHeight = getValidRowHeight(props.rowHeight, DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, rowHeightWarning);
    const rowHeight = Math.floor(validRowHeight * densityFactor);
    const hydrateRowsMeta = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        var _pinnedRows$top, _pinnedRows$bottom;
        hasRowWithAutoHeight.current = false;
        const calculateRowProcessedSizes = (row)=>{
            if (!rowsHeightLookup.current[row.id]) rowsHeightLookup.current[row.id] = {
                sizes: {
                    baseCenter: rowHeight
                },
                isResized: false,
                autoHeight: false,
                needsFirstMeasurement: true
            };
            const { isResized, needsFirstMeasurement, sizes } = rowsHeightLookup.current[row.id];
            let baseRowHeight = 'number' == typeof rowHeight && rowHeight > 0 ? rowHeight : 52;
            const existingBaseRowHeight = sizes.baseCenter;
            if (isResized) baseRowHeight = existingBaseRowHeight;
            else if (getRowHeightProp) {
                const rowHeightFromUser = getRowHeightProp(esm_extends_extends({}, row, {
                    densityFactor
                }));
                if ('auto' === rowHeightFromUser) {
                    if (needsFirstMeasurement) {
                        const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight(esm_extends_extends({}, row, {
                            densityFactor
                        })) : rowHeight;
                        baseRowHeight = null != estimatedRowHeight ? estimatedRowHeight : rowHeight;
                    } else baseRowHeight = existingBaseRowHeight;
                    hasRowWithAutoHeight.current = true;
                    rowsHeightLookup.current[row.id].autoHeight = true;
                } else {
                    baseRowHeight = getValidRowHeight(rowHeightFromUser, rowHeight, getRowHeightWarning);
                    rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
                    rowsHeightLookup.current[row.id].autoHeight = false;
                }
            } else rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
            const initialHeights = {};
            for(const key in sizes)if (/^base[A-Z]/.test(key)) initialHeights[key] = sizes[key];
            initialHeights.baseCenter = baseRowHeight;
            if (getRowSpacing) {
                var _spacing$top, _spacing$bottom;
                const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
                const spacing = getRowSpacing(esm_extends_extends({}, row, {
                    isFirstVisible: 0 === indexRelativeToCurrentPage,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage
                }));
                initialHeights.spacingTop = null != (_spacing$top = spacing.top) ? _spacing$top : 0;
                initialHeights.spacingBottom = null != (_spacing$bottom = spacing.bottom) ? _spacing$bottom : 0;
            }
            const processedSizes = apiRef.current.unstable_applyPipeProcessors('rowHeight', initialHeights, row);
            rowsHeightLookup.current[row.id].sizes = processedSizes;
            return processedSizes;
        };
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            let maximumBaseSize = 0;
            let otherSizes = 0;
            const processedSizes = calculateRowProcessedSizes(row);
            for(const key in processedSizes){
                const value = processedSizes[key];
                if (/^base[A-Z]/.test(key)) maximumBaseSize = value > maximumBaseSize ? value : maximumBaseSize;
                else otherSizes += value;
            }
            return acc + maximumBaseSize + otherSizes;
        }, 0);
        null == pinnedRows || null == (_pinnedRows$top = pinnedRows.top) || _pinnedRows$top.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        null == pinnedRows || null == (_pinnedRows$bottom = pinnedRows.bottom) || _pinnedRows$bottom.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                rowsMeta: {
                    currentPageTotalHeight,
                    positions
                }
            }));
        if (!hasRowWithAutoHeight.current) lastMeasuredRowIndex.current = 1 / 0;
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        currentPage.rows,
        rowHeight,
        getRowHeightProp,
        getRowSpacing,
        getEstimatedRowHeight,
        pinnedRows,
        densityFactor
    ]);
    const getRowHeight = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rowId)=>{
        const height = rowsHeightLookup.current[rowId];
        return height ? height.sizes.baseCenter : rowHeight;
    }, [
        rowHeight
    ]);
    const getRowInternalSizes = (rowId)=>{
        var _rowsHeightLookup$cur;
        return null == (_rowsHeightLookup$cur = rowsHeightLookup.current[rowId]) ? void 0 : _rowsHeightLookup$cur.sizes;
    };
    const setRowHeight = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, height)=>{
        rowsHeightLookup.current[id].sizes.baseCenter = height;
        rowsHeightLookup.current[id].isResized = true;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const debouncedHydrateRowsMeta = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>debounce(hydrateRowsMeta, props.rowPositionsDebounceMs), [
        hydrateRowsMeta,
        props.rowPositionsDebounceMs
    ]);
    const storeMeasuredRowHeight = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id, height, position)=>{
        if (!rowsHeightLookup.current[id] || !rowsHeightLookup.current[id].autoHeight) return;
        const needsHydration = rowsHeightLookup.current[id].sizes[`base${capitalize(position)}`] !== height;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        rowsHeightLookup.current[id].sizes[`base${capitalize(position)}`] = height;
        if (needsHydration) debouncedHydrateRowsMeta();
    }, [
        debouncedHydrateRowsMeta
    ]);
    const rowHasAutoHeight = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((id)=>{
        var _rowsHeightLookup$cur2;
        return (null == (_rowsHeightLookup$cur2 = rowsHeightLookup.current[id]) ? void 0 : _rowsHeightLookup$cur2.autoHeight) || false;
    }, []);
    const getLastMeasuredRowIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>lastMeasuredRowIndex.current, []);
    const setLastMeasuredRowIndex = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    }, []);
    const resetRowHeights = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        rowsHeightLookup.current = {};
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        hydrateRowsMeta();
    }, [
        rowHeight,
        filterModel,
        paginationState,
        sortModel,
        hydrateRowsMeta
    ]);
    useGridRegisterPipeApplier(apiRef, 'rowHeight', hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_getRowHeight: getRowHeight,
        unstable_getRowInternalSizes: getRowInternalSizes,
        unstable_setRowHeight: setRowHeight,
        unstable_storeRowHeightMeasurement: storeMeasuredRowHeight,
        resetRowHeights
    };
    const rowsMetaPrivateApi = {
        getLastMeasuredRowIndex,
        rowHasAutoHeight
    };
    useGridApiMethod(apiRef, rowsMetaApi, 'public');
    useGridApiMethod(apiRef, rowsMetaPrivateApi, 'private');
};
const useGridStatePersistence = (apiRef)=>{
    const exportState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState,
        restoreState
    };
    useGridApiMethod(apiRef, statePersistenceApi, 'public');
};
const useGridColumnSpanning = (apiRef)=>{
    const lookup = __WEBPACK_EXTERNAL_MODULE_react__.useRef({});
    const setCellColSpanInfo = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rowId, columnIndex, cellColSpanInfo)=>{
        const sizes = lookup.current;
        if (!sizes[rowId]) sizes[rowId] = {};
        sizes[rowId][columnIndex] = cellColSpanInfo;
    }, []);
    const getCellColSpanInfo = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((rowId, columnIndex)=>{
        var _lookup$current$rowId;
        return null == (_lookup$current$rowId = lookup.current[rowId]) ? void 0 : _lookup$current$rowId[columnIndex];
    }, []);
    const calculateCellColSpan = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((params)=>{
        const { columnIndex, rowId, minFirstColumnIndex, maxLastColumnIndex, columns } = params;
        const columnsLength = columns.length;
        const column = columns[columnIndex];
        const colSpan = 'function' == typeof column.colSpan ? column.colSpan(apiRef.current.getCellParams(rowId, column.field)) : column.colSpan;
        if (!colSpan || 1 === colSpan) {
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan: 1,
                    width: column.computedWidth
                }
            });
            return {
                colSpan: 1
            };
        }
        let width = column.computedWidth;
        for(let j = 1; j < colSpan; j += 1){
            const nextColumnIndex = columnIndex + j;
            if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
                const nextColumn = columns[nextColumnIndex];
                width += nextColumn.computedWidth;
                setCellColSpanInfo(rowId, columnIndex + j, {
                    spannedByColSpan: true,
                    rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                    leftVisibleCellIndex: columnIndex
                });
            }
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan,
                    width
                }
            });
        }
        return {
            colSpan
        };
    }, [
        apiRef,
        setCellColSpanInfo
    ]);
    const calculateColSpan = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(({ rowId, minFirstColumn, maxLastColumn, columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = calculateCellColSpan({
                columnIndex: i,
                rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        calculateCellColSpan
    ]);
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        calculateColSpan
    };
    useGridApiMethod(apiRef, columnSpanningPublicApi, 'public');
    useGridApiMethod(apiRef, columnSpanningPrivateApi, 'private');
    const handleColumnReorderChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        lookup.current = {};
    }, []);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnOrderChange', handleColumnReorderChange);
};
function isLeaf(node) {
    return void 0 !== node.field;
}
const recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if (isLeaf(columnGroupNode)) {
        if (void 0 !== unwrappedGroupingModelToComplete[columnGroupNode.field]) throw new Error([
            "MUI: columnGroupingModel contains duplicated field",
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId, children } = columnGroupNode;
    children.forEach((child)=>{
        recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const unwrapGroupingColumnModel = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const getColumnGroupsHeaderStructure = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>{
        var _unwrappedGroupingMod;
        return null != (_unwrappedGroupingMod = unwrappedGroupingModel[field]) ? _unwrappedGroupingMod : [];
    };
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>isDeepEqual(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    const haveDifferentContainers = (field1, field2)=>{
        if (null != pinnedFields && pinnedFields.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) return true;
        if (null != pinnedFields && pinnedFields.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) return true;
        return false;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = orderedColumns.reduce((structure, newField)=>{
            var _getParents$depth;
            const groupId = null != (_getParents$depth = getParents(newField)[depth]) ? _getParents$depth : null;
            if (0 === structure.length) return [
                {
                    columnFields: [
                        newField
                    ],
                    groupId
                }
            ];
            const lastGroup = structure[structure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            const prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || haveDifferentContainers(prevField, newField)) return [
                ...structure,
                {
                    columnFields: [
                        newField
                    ],
                    groupId
                }
            ];
            return [
                ...structure.slice(0, structure.length - 1),
                {
                    columnFields: [
                        ...lastGroup.columnFields,
                        newField
                    ],
                    groupId
                }
            ];
        }, []);
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};
const useGridColumnGrouping_excluded = [
    "groupId",
    "children"
];
const createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if (isLeaf(node)) return;
        const { groupId, children } = node, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(node, useGridColumnGrouping_excluded);
        if (!groupId) throw new Error('MUI: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        if (!children) console.warn(`MUI: group groupId=${groupId} has no children.`);
        const groupParam = esm_extends_extends({}, other, {
            groupId
        });
        const subTreeLookup = createGroupLookup(children);
        if (void 0 !== subTreeLookup[groupId] || void 0 !== groupLookup[groupId]) throw new Error(`MUI: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = esm_extends_extends({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return esm_extends_extends({}, groupLookup);
};
const columnGroupsStateInitializer = (state, props, apiRef)=>{
    var _props$experimentalFe, _props$columnGrouping, _props$columnGrouping2, _apiRef$current$state;
    if (!(null != (_props$experimentalFe = props.experimentalFeatures) && _props$experimentalFe.columnGrouping)) return state;
    const columnFields = gridColumnFieldsSelector(apiRef);
    const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
    const groupLookup = createGroupLookup(null != (_props$columnGrouping = props.columnGroupingModel) ? _props$columnGrouping : []);
    const unwrappedGroupingModel = unwrapGroupingColumnModel(null != (_props$columnGrouping2 = props.columnGroupingModel) ? _props$columnGrouping2 : []);
    const columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(columnFields, unwrappedGroupingModel, null != (_apiRef$current$state = apiRef.current.state.pinnedColumns) ? _apiRef$current$state : {});
    const maxDepth = 0 === visibleColumnFields.length ? 0 : Math.max(...visibleColumnFields.map((field)=>{
        var _unwrappedGroupingMod, _unwrappedGroupingMod2;
        return null != (_unwrappedGroupingMod = null == (_unwrappedGroupingMod2 = unwrappedGroupingModel[field]) ? void 0 : _unwrappedGroupingMod2.length) ? _unwrappedGroupingMod : 0;
    }));
    return esm_extends_extends({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth
        }
    });
};
const useGridColumnGrouping = (apiRef, props)=>{
    var _props$experimentalFe3;
    const getColumnGroupPath = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((field)=>{
        var _unwrappedGroupingMod3;
        const unwrappedGroupingModel = gridColumnGroupsUnwrappedModelSelector(apiRef);
        return null != (_unwrappedGroupingMod3 = unwrappedGroupingModel[field]) ? _unwrappedGroupingMod3 : [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        const columnGroupLookup = gridColumnGroupsLookupSelector(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        unstable_getColumnGroupPath: getColumnGroupPath,
        unstable_getAllGroupDetails: getAllGroupDetails
    };
    useGridApiMethod(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        var _props$columnGrouping3;
        const unwrappedGroupingModel = unwrapGroupingColumnModel(null != (_props$columnGrouping3 = props.columnGroupingModel) ? _props$columnGrouping3 : []);
        apiRef.current.setState((state)=>{
            var _state$columns$ordere, _state$columns, _state$pinnedColumns;
            const orderedFields = null != (_state$columns$ordere = null == (_state$columns = state.columns) ? void 0 : _state$columns.orderedFields) ? _state$columns$ordere : [];
            const pinnedColumns = null != (_state$pinnedColumns = state.pinnedColumns) ? _state$pinnedColumns : {};
            const columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return esm_extends_extends({}, state, {
                columnGrouping: esm_extends_extends({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((columnGroupingModel)=>{
        var _props$experimentalFe2, _apiRef$current$getPi, _apiRef$current$getPi2, _apiRef$current;
        if (!(null != (_props$experimentalFe2 = props.experimentalFeatures) && _props$experimentalFe2.columnGrouping)) return;
        const pinnedColumns = null != (_apiRef$current$getPi = null == (_apiRef$current$getPi2 = (_apiRef$current = apiRef.current).getPinnedColumns) ? void 0 : _apiRef$current$getPi2.call(_apiRef$current)) ? _apiRef$current$getPi : {};
        const columnFields = gridColumnFieldsSelector(apiRef);
        const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
        const groupLookup = createGroupLookup(null != columnGroupingModel ? columnGroupingModel : []);
        const unwrappedGroupingModel = unwrapGroupingColumnModel(null != columnGroupingModel ? columnGroupingModel : []);
        const columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = 0 === visibleColumnFields.length ? 0 : Math.max(...visibleColumnFields.map((field)=>{
            var _unwrappedGroupingMod4, _unwrappedGroupingMod5;
            return null != (_unwrappedGroupingMod4 = null == (_unwrappedGroupingMod5 = unwrappedGroupingModel[field]) ? void 0 : _unwrappedGroupingMod5.length) ? _unwrappedGroupingMod4 : 0;
        }));
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth
                }
            }));
    }, [
        apiRef,
        null == (_props$experimentalFe3 = props.experimentalFeatures) ? void 0 : _props$experimentalFe3.columnGrouping
    ]);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnIndexChange', handleColumnIndexChange);
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    useGridApiEventHandler_useGridApiEventHandler(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};
const virtualizationStateInitializer = (state, props)=>{
    const virtualization = {
        enabled: !props.disableVirtualization,
        enabledForColumns: true
    };
    return esm_extends_extends({}, state, {
        virtualization
    });
};
function useGridVirtualization(apiRef, props) {
    const setVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                virtualization: esm_extends_extends({}, state.virtualization, {
                    enabled
                })
            }));
    };
    const setColumnVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>esm_extends_extends({}, state, {
                virtualization: esm_extends_extends({}, state.virtualization, {
                    enabledForColumns: enabled
                })
            }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    useGridApiMethod(apiRef, api, 'public');
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setVirtualization(!props.disableVirtualization);
    }, [
        props.disableVirtualization
    ]);
}
const useDataGridComponent = (inputApiRef, props)=>{
    const apiRef = useGridInitialization(inputApiRef, props);
    useGridRowSelectionPreProcessors(apiRef, props);
    useGridRowsPreProcessors(apiRef);
    useGridInitializeState(rowSelectionStateInitializer, apiRef, props);
    useGridInitializeState(columnsStateInitializer, apiRef, props);
    useGridInitializeState(rowsStateInitializer, apiRef, props);
    useGridInitializeState(editingStateInitializer, apiRef, props);
    useGridInitializeState(focusStateInitializer, apiRef, props);
    useGridInitializeState(sortingStateInitializer, apiRef, props);
    useGridInitializeState(preferencePanelStateInitializer, apiRef, props);
    useGridInitializeState(filterStateInitializer, apiRef, props);
    useGridInitializeState(densityStateInitializer, apiRef, props);
    useGridInitializeState(paginationStateInitializer, apiRef, props);
    useGridInitializeState(rowsMetaStateInitializer, apiRef, props);
    useGridInitializeState(columnMenuStateInitializer, apiRef, props);
    useGridInitializeState(columnGroupsStateInitializer, apiRef, props);
    useGridInitializeState(virtualizationStateInitializer, apiRef, props);
    useGridKeyboardNavigation(apiRef, props);
    useGridRowSelection(apiRef, props);
    useGridColumns(apiRef, props);
    useGridRows(apiRef, props);
    useGridParamsApi(apiRef, props);
    useGridColumnSpanning(apiRef);
    useGridColumnGrouping(apiRef, props);
    useGridEditing(apiRef, props);
    useGridFocus(apiRef, props);
    useGridPreferencesPanel(apiRef, props);
    useGridFilter(apiRef, props);
    useGridSorting(apiRef, props);
    useGridDensity(apiRef, props);
    useGridPagination(apiRef, props);
    useGridRowsMeta(apiRef, props);
    useGridScroll(apiRef, props);
    useGridColumnMenu(apiRef);
    useGridCsvExport(apiRef, props);
    useGridPrintExport(apiRef, props);
    useGridClipboard(apiRef, props);
    useGridDimensions(apiRef, props);
    useGridEvents(apiRef, props);
    useGridStatePersistence(apiRef);
    useGridVirtualization(apiRef, props);
    return apiRef;
};
const GridVirtualScroller_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'virtualScroller'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>styles.virtualScroller
})({
    overflow: 'auto',
    height: '100%',
    position: 'relative',
    '@media print': {
        overflow: 'hidden'
    },
    zIndex: 0
});
const GridVirtualScroller_GridVirtualScroller = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const rootProps = useGridRootProps();
    const classes = GridVirtualScroller_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(VirtualScrollerRoot, esm_extends_extends({
        ref: ref
    }, props, {
        className: dist_clsx(classes.root, props.className),
        ownerState: rootProps
    }));
});
const GridVirtualScrollerContent_useUtilityClasses = (props, overflowedContent)=>{
    const { classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerContentRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>styles.virtualScrollerContent
})({});
const GridVirtualScrollerContent_GridVirtualScrollerContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    var _props$style;
    const rootProps = useGridRootProps();
    const overflowedContent = !rootProps.autoHeight && (null == (_props$style = props.style) ? void 0 : _props$style.minHeight) === 'auto';
    const classes = GridVirtualScrollerContent_useUtilityClasses(rootProps, overflowedContent);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(VirtualScrollerContentRoot, esm_extends_extends({
        ref: ref
    }, props, {
        ownerState: rootProps,
        className: dist_clsx(classes.root, props.className)
    }));
});
const GridVirtualScrollerRenderZone_excluded = [
    "className"
];
const GridVirtualScrollerRenderZone_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerRenderZoneRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone',
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column'
});
const GridVirtualScrollerRenderZone_GridVirtualScrollerRenderZone = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, GridVirtualScrollerRenderZone_excluded);
    const rootProps = useGridRootProps();
    const classes = GridVirtualScrollerRenderZone_useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(VirtualScrollerRenderZoneRoot, esm_extends_extends({
        ref: ref,
        className: dist_clsx(classes.root, className),
        ownerState: rootProps
    }, other));
});
const GridOverlayWrapperRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>'overlayType' !== prop,
    overridesResolver: (props, styles)=>styles.overlayWrapper
})(({ overlayType })=>({
        position: 'sticky',
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        zIndex: 'loadingOverlay' === overlayType ? 5 : 4
    }));
const GridOverlayWrapperInner = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>'overlayType' !== prop,
    overridesResolver: (props, styles)=>styles.overlayWrapperInner
})({});
const GridOverlays_useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridOverlayWrapper(props) {
    var _viewportInnerSize$he, _viewportInnerSize$wi;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const [viewportInnerSize, setViewportInnerSize] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        return null != (_apiRef$current$getRo = null == (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) ? void 0 : _apiRef$current$getRo2.viewportInnerSize) ? _apiRef$current$getRo : null;
    });
    const handleViewportSizeChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        var _apiRef$current$getRo3, _apiRef$current$getRo4;
        setViewportInnerSize(null != (_apiRef$current$getRo3 = null == (_apiRef$current$getRo4 = apiRef.current.getRootDimensions()) ? void 0 : _apiRef$current$getRo4.viewportInnerSize) ? _apiRef$current$getRo3 : null);
    }, [
        apiRef
    ]);
    useEnhancedEffect(()=>apiRef.current.subscribeEvent('viewportInnerSizeChange', handleViewportSizeChange), [
        apiRef,
        handleViewportSizeChange
    ]);
    let height = null != (_viewportInnerSize$he = null == viewportInnerSize ? void 0 : viewportInnerSize.height) ? _viewportInnerSize$he : 0;
    if (rootProps.autoHeight && 0 === height) height = getMinimalContentHeight(apiRef, rootProps.rowHeight);
    const classes = GridOverlays_useUtilityClasses(esm_extends_extends({}, props, {
        classes: rootProps.classes
    }));
    if (!viewportInnerSize) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlayWrapperRoot, {
        className: dist_clsx(classes.root),
        overlayType: props.overlayType,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlayWrapperInner, esm_extends_extends({
            className: dist_clsx(classes.inner),
            style: {
                height,
                width: null != (_viewportInnerSize$wi = null == viewportInnerSize ? void 0 : viewportInnerSize.width) ? _viewportInnerSize$wi : 0
            }
        }, props))
    });
}
"production" !== process.env.NODE_ENV && (GridOverlayWrapper.propTypes = {
    overlayType: prop_types_default().string.isRequired
});
function GridOverlays() {
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
    const visibleRowCount = useGridSelector(apiRef, gridExpandedRowCountSelector);
    const loading = useGridSelector(apiRef, gridRowsLoadingSelector);
    const showNoRowsOverlay = !loading && 0 === totalRowCount;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && 0 === visibleRowCount;
    let overlay = null;
    let overlayType = '';
    if (showNoRowsOverlay) {
        var _rootProps$slotProps;
        overlay = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.noRowsOverlay, esm_extends_extends({}, null == (_rootProps$slotProps = rootProps.slotProps) ? void 0 : _rootProps$slotProps.noRowsOverlay));
        overlayType = 'noRowsOverlay';
    }
    if (showNoResultsOverlay) {
        var _rootProps$slotProps2;
        overlay = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.noResultsOverlay, esm_extends_extends({}, null == (_rootProps$slotProps2 = rootProps.slotProps) ? void 0 : _rootProps$slotProps2.noResultsOverlay));
        overlayType = 'noResultsOverlay';
    }
    if (loading) {
        var _rootProps$slotProps3;
        overlay = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(rootProps.slots.loadingOverlay, esm_extends_extends({}, null == (_rootProps$slotProps3 = rootProps.slotProps) ? void 0 : _rootProps$slotProps3.loadingOverlay));
        overlayType = 'loadingOverlay';
    }
    if (null === overlay) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlayWrapper, {
        overlayType: overlayType,
        children: overlay
    });
}
const DataGridVirtualScroller_excluded = [
    "className"
];
const DataGridVirtualScroller_DataGridVirtualScroller = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(props, ref) {
    const { className } = props, other = esm_objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(props, DataGridVirtualScroller_excluded);
    const { getRootProps, getContentProps, getRenderZoneProps, getRows } = useGridVirtualScroller({
        ref
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridVirtualScroller_GridVirtualScroller, esm_extends_extends({
        className: className
    }, getRootProps(other), {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridOverlays, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridVirtualScrollerContent_GridVirtualScrollerContent, esm_extends_extends({}, getContentProps(), {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridVirtualScrollerRenderZone_GridVirtualScrollerRenderZone, esm_extends_extends({}, getRenderZoneProps(), {
                    children: getRows()
                }))
            }))
        ]
    }));
});
const DataGridRaw = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(function(inProps, ref) {
    const props = useDataGridProps(inProps);
    const privateApiRef = useDataGridComponent(props.apiRef, props);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridContextProvider, {
        privateApiRef: privateApiRef,
        props: props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridRoot_GridRoot, esm_extends_extends({
            className: props.className,
            style: props.style,
            sx: props.sx,
            ref: ref
        }, props.forwardedProps, {
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridHeader, {}),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridBody, {
                    VirtualScrollerComponent: DataGridVirtualScroller_DataGridVirtualScroller
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridFooterPlaceholder, {})
            ]
        }))
    });
});
const DataGrid_DataGrid = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.memo(DataGridRaw);
DATA_GRID_PROPS_DEFAULT_VALUES.filterDebounceMs;
DATA_GRID_PROPS_DEFAULT_VALUES.filterDebounceMs;
DataGridRaw.propTypes = {
    apiRef: prop_types_default().shape({
        current: prop_types_default().object.isRequired
    }),
    'aria-label': prop_types_default().string,
    'aria-labelledby': prop_types_default().string,
    autoHeight: prop_types_default().bool,
    autoPageSize: prop_types_default().bool,
    cellModesModel: prop_types_default().object,
    checkboxSelection: prop_types_default().bool,
    classes: prop_types_default().object,
    clipboardCopyCellDelimiter: prop_types_default().string,
    columnBuffer: prop_types_default().number,
    columnGroupingModel: prop_types_default().arrayOf(prop_types_default().object),
    columnHeaderHeight: prop_types_default().number,
    columns: chainPropTypes(prop_types_default().array.isRequired, (props)=>{
        if (props.columns && props.columns.some((column)=>column.resizable)) return new Error("MUI: `column.resizable = true` is not a valid prop.\nColumn resizing is not available in the MIT version.\n\nYou need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.");
        return null;
    }),
    columnThreshold: prop_types_default().number,
    columnVisibilityModel: prop_types_default().object,
    components: prop_types_default().object,
    componentsProps: prop_types_default().object,
    density: prop_types_default().oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    disableColumnFilter: prop_types_default().bool,
    disableColumnMenu: prop_types_default().bool,
    disableColumnSelector: prop_types_default().bool,
    disableDensitySelector: prop_types_default().bool,
    disableEval: prop_types_default().bool,
    disableRowSelectionOnClick: prop_types_default().bool,
    disableVirtualization: prop_types_default().bool,
    editMode: prop_types_default().oneOf([
        'cell',
        'row'
    ]),
    experimentalFeatures: prop_types_default().shape({
        ariaV7: prop_types_default().bool,
        columnGrouping: prop_types_default().bool,
        warnIfFocusStateIsNotSynced: prop_types_default().bool
    }),
    filterDebounceMs: prop_types_default().number,
    filterMode: prop_types_default().oneOf([
        'client',
        'server'
    ]),
    filterModel: prop_types_default().shape({
        items: prop_types_default().arrayOf(prop_types_default().shape({
            field: prop_types_default().string.isRequired,
            id: prop_types_default().oneOfType([
                prop_types_default().number,
                prop_types_default().string
            ]),
            operator: prop_types_default().string.isRequired,
            value: prop_types_default().any
        })).isRequired,
        logicOperator: prop_types_default().oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: prop_types_default().bool,
        quickFilterLogicOperator: prop_types_default().oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: prop_types_default().array
    }),
    forwardedProps: prop_types_default().object,
    getCellClassName: prop_types_default().func,
    getDetailPanelContent: prop_types_default().func,
    getEstimatedRowHeight: prop_types_default().func,
    getRowClassName: prop_types_default().func,
    getRowHeight: prop_types_default().func,
    getRowId: prop_types_default().func,
    getRowSpacing: prop_types_default().func,
    hideFooter: prop_types_default().bool,
    hideFooterPagination: prop_types_default().bool,
    hideFooterSelectedRowCount: prop_types_default().bool,
    ignoreDiacritics: prop_types_default().bool,
    initialState: prop_types_default().object,
    isCellEditable: prop_types_default().func,
    isRowSelectable: prop_types_default().func,
    keepNonExistentRowsSelected: prop_types_default().bool,
    loading: prop_types_default().bool,
    localeText: prop_types_default().object,
    logger: prop_types_default().shape({
        debug: prop_types_default().func.isRequired,
        error: prop_types_default().func.isRequired,
        info: prop_types_default().func.isRequired,
        warn: prop_types_default().func.isRequired
    }),
    logLevel: prop_types_default().oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    nonce: prop_types_default().string,
    onCellClick: prop_types_default().func,
    onCellDoubleClick: prop_types_default().func,
    onCellEditStart: prop_types_default().func,
    onCellEditStop: prop_types_default().func,
    onCellKeyDown: prop_types_default().func,
    onCellModesModelChange: prop_types_default().func,
    onClipboardCopy: prop_types_default().func,
    onColumnHeaderClick: prop_types_default().func,
    onColumnHeaderDoubleClick: prop_types_default().func,
    onColumnHeaderEnter: prop_types_default().func,
    onColumnHeaderLeave: prop_types_default().func,
    onColumnHeaderOut: prop_types_default().func,
    onColumnHeaderOver: prop_types_default().func,
    onColumnOrderChange: prop_types_default().func,
    onColumnVisibilityModelChange: prop_types_default().func,
    onFilterModelChange: prop_types_default().func,
    onMenuClose: prop_types_default().func,
    onMenuOpen: prop_types_default().func,
    onPaginationModelChange: prop_types_default().func,
    onPreferencePanelClose: prop_types_default().func,
    onPreferencePanelOpen: prop_types_default().func,
    onProcessRowUpdateError: prop_types_default().func,
    onResize: prop_types_default().func,
    onRowClick: prop_types_default().func,
    onRowDoubleClick: prop_types_default().func,
    onRowEditCommit: prop_types_default().func,
    onRowEditStart: prop_types_default().func,
    onRowEditStop: prop_types_default().func,
    onRowModesModelChange: prop_types_default().func,
    onRowSelectionModelChange: prop_types_default().func,
    onSortModelChange: prop_types_default().func,
    onStateChange: prop_types_default().func,
    pageSizeOptions: prop_types_default().arrayOf(prop_types_default().oneOfType([
        prop_types_default().number,
        prop_types_default().shape({
            label: prop_types_default().string.isRequired,
            value: prop_types_default().number.isRequired
        })
    ]).isRequired),
    pagination: (props)=>{
        if (false === props.pagination) return new Error("MUI: `<DataGrid pagination={false} />` is not a valid prop.\nInfinite scrolling is not available in the MIT version.\n\nYou need to upgrade to DataGridPro or DataGridPremium component to disable the pagination.");
        return null;
    },
    paginationMode: prop_types_default().oneOf([
        'client',
        'server'
    ]),
    paginationModel: prop_types_default().shape({
        page: prop_types_default().number.isRequired,
        pageSize: prop_types_default().number.isRequired
    }),
    processRowUpdate: prop_types_default().func,
    rowBuffer: prop_types_default().number,
    rowCount: prop_types_default().number,
    rowHeight: prop_types_default().number,
    rowModesModel: prop_types_default().object,
    rowPositionsDebounceMs: prop_types_default().number,
    rows: prop_types_default().arrayOf(prop_types_default().object).isRequired,
    rowSelection: prop_types_default().bool,
    rowSelectionModel: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().number,
            prop_types_default().string
        ]).isRequired),
        prop_types_default().number,
        prop_types_default().string
    ]),
    rowSpacingType: prop_types_default().oneOf([
        'border',
        'margin'
    ]),
    rowThreshold: prop_types_default().number,
    scrollbarSize: prop_types_default().number,
    showCellVerticalBorder: prop_types_default().bool,
    showColumnVerticalBorder: prop_types_default().bool,
    slotProps: prop_types_default().object,
    slots: prop_types_default().object,
    sortingMode: prop_types_default().oneOf([
        'client',
        'server'
    ]),
    sortingOrder: prop_types_default().arrayOf(prop_types_default().oneOf([
        'asc',
        'desc'
    ])),
    sortModel: prop_types_default().arrayOf(prop_types_default().shape({
        field: prop_types_default().string.isRequired,
        sort: prop_types_default().oneOf([
            'asc',
            'desc'
        ])
    })),
    sx: prop_types_default().oneOfType([
        prop_types_default().arrayOf(prop_types_default().oneOfType([
            prop_types_default().func,
            prop_types_default().object,
            prop_types_default().bool
        ])),
        prop_types_default().func,
        prop_types_default().object
    ]),
    unstable_ignoreValueFormatterDuringExport: prop_types_default().oneOfType([
        prop_types_default().shape({
            clipboardExport: prop_types_default().bool,
            csvExport: prop_types_default().bool
        }),
        prop_types_default().bool
    ])
};
const TABLE_ODD_ROW_BACKGROUND_COLOR = "#171F3614";
const TABLE_ODD_ROW_HOVER_BACKGROUND_COLOR = "#171F3629";
const TABLE_CELL_MIN_WIDTH_PX = 140;
const TABLE_SMALL_CELL_MIN_HEIGHT_PX = 36;
const TABLE_SMALL_CELL_MAX_HEIGHT_PX = 48;
const TABLE_MEDIUM_CELL_MIN_HEIGHT_PX = 64;
const TABLE_MEDIUM_CELL_MAX_HEIGHT_PX = 96;
const TABLE_SMALL_CELL_PADDING = `${theme_theme.spacing(0)} ${theme_theme.spacing(4)}`;
const TABLE_MEDIUM_CELL_PADDING = `${theme_theme.spacing(2)} ${theme_theme.spacing(4)}`;
function Table({ columns, size, ...rest }) {
    function getRowClassName(params) {
        return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledTable, {
        ...rest,
        getRowHeight: function() {
            return "auto";
        },
        columns: columns.map(function(column) {
            return {
                ...column,
                minWidth: TABLE_CELL_MIN_WIDTH_PX,
                renderHeader: ({ colDef: { headerName } })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TableHeader, {
                        children: headerName
                    })
            };
        }),
        slots: {
            columnSortedDescendingIcon: ArrowUpSmallOutlined,
            columnSortedAscendingIcon: ArrowDownSmallOutlined
        },
        getRowClassName: getRowClassName,
        disableColumnMenu: true,
        disableColumnFilter: true,
        hideFooter: true,
        sx: {
            ".MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                padding: "small" === size ? TABLE_SMALL_CELL_PADDING : TABLE_MEDIUM_CELL_PADDING
            },
            "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
                minHeight: "small" === size ? TABLE_SMALL_CELL_MIN_HEIGHT_PX : TABLE_MEDIUM_CELL_MIN_HEIGHT_PX,
                maxHeight: "small" === size ? TABLE_SMALL_CELL_MAX_HEIGHT_PX : TABLE_MEDIUM_CELL_MAX_HEIGHT_PX
            },
            ".MuiDataGrid-columnHeaderCheckbox": {
                padding: theme_theme.spacing(0)
            }
        }
    });
}
function TableHeader({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
        variant: "subtitle1",
        fontWeight: "bold",
        children: children
    });
}
const StyledTable = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(DataGrid_DataGrid)(({ theme })=>({
        "&.MuiDataGrid-root": {
            overflow: "hidden",
            borderColor: theme.palette.border.main
        },
        ".MuiDataGrid-row--lastVisible .MuiDataGrid-cell": {
            borderBottom: "none"
        },
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within, &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within": {
            outline: "none"
        },
        "&.MuiDataGrid-root .MuiDataGrid-columnSeparator": {
            display: "none"
        },
        [`& .${gridClasses_gridClasses.row}.odd`]: {
            backgroundColor: TABLE_ODD_ROW_BACKGROUND_COLOR,
            [`&:hover, &.${mui_class_collection_MuiClassCollection.hovered}`]: {
                backgroundColor: TABLE_ODD_ROW_HOVER_BACKGROUND_COLOR
            },
            [`&.${mui_class_collection_MuiClassCollection.selected}`]: {
                backgroundColor: theme.palette.primary.light
            }
        },
        [`& .${gridClasses_gridClasses.row}.even`]: {
            backgroundColor: theme.palette.common.white,
            [`&:hover, &.${mui_class_collection_MuiClassCollection.hovered}`]: {
                backgroundColor: theme.palette.action.hover
            },
            [`&.${mui_class_collection_MuiClassCollection.selected}`]: {
                backgroundColor: theme.palette.primary.light
            }
        }
    }));
const StyledTab = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tab_d16acec7__["default"], styledOptions)(({ theme, color, icon })=>{
    const selectedColor = color ? theme.palette[color].main : theme.palette.primary.main;
    return {
        [`&.${mui_class_collection_MuiClassCollection.selected}`]: {
            color: selectedColor
        },
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            cursor: cursor_style_CursorStyle.notAllowed,
            pointerEvents: "all",
            color: theme.palette.text.disabled
        },
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightMedium,
        minWidth: 60,
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        lineHeight: typography_LineHeight.md,
        minHeight: icon ? 0 : void 0,
        ...icon && {
            "& .MuiTab-iconWrapper": {
                height: 24,
                hidth: 24
            }
        }
    };
});
const tab_Tab = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ color, icon, iconPosition, leftIcon, rightIcon, ...rest }, ref) {
    const currentIcon = leftIcon ?? rightIcon;
    const currentIconPosition = leftIcon ? "start" : "end";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledTab, {
        color: color,
        ref: ref,
        icon: currentIcon,
        iconPosition: currentIconPosition,
        ...rest
    });
});
const tabs_Tabs = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, color, variant, allowScrollButtonsMobile, textColor, indicatorColor, ...rest }, ref) {
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useTheme)();
    const selectedColor = color ? theme.palette[color].main : theme.palette.primary.main;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tabs_81f0807c__["default"], {
        variant: "scrollable",
        allowScrollButtonsMobile: true,
        ref: ref,
        TabIndicatorProps: {
            style: {
                backgroundColor: selectedColor
            }
        },
        ...rest,
        children: __WEBPACK_EXTERNAL_MODULE_react__["default"].Children.map(children, (child)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].isValidElement(child) ? /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].cloneElement(child, {
                color
            }) : null)
    });
});
'use client';
function GlobalStyles_isEmpty(obj) {
    return null == obj || 0 === Object.keys(obj).length;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = 'function' == typeof styles ? (themeInput)=>styles(GlobalStyles_isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.Global, {
        styles: globalStyles
    });
}
"production" !== process.env.NODE_ENV && (GlobalStyles.propTypes = {
    defaultTheme: prop_types_default().object,
    styles: prop_types_default().oneOfType([
        prop_types_default().array,
        prop_types_default().string,
        prop_types_default().object,
        prop_types_default().func
    ])
});
const define_global_styles_tealDuskStyle = tealDusk.getIconStylesOverride();
const define_global_styles_pinkHazeStyle = pinkHaze.getIconStylesOverride();
const define_global_styles_goldenUmberStyle = goldenUmber.getIconStylesOverride();
const define_global_styles_styles = (0, __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.css)`
  .MuiSvgIcon-root {
    ${define_global_styles_tealDuskStyle}
    ${define_global_styles_pinkHazeStyle}
    ${define_global_styles_goldenUmberStyle}
  }
`;
function DefineGlobalStyles() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GlobalStyles, {
        styles: define_global_styles_styles
    });
}
function ThemeProvider({ children, theme = theme_theme }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.ThemeProvider, {
        theme: theme,
        children: children
    });
}
const tealDuskSvgLinearGradient = tealDusk.getSvgGradient();
const pinkHazeSvgLinearGradient = pinkHaze.getSvgGradient();
const goldenUmberSvgLinearGradient = goldenUmber.getSvgGradient();
function SvgLinearGradient() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box, {
        id: "hidden-svg-linear-gradient",
        sx: {
            position: "absolute",
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            overflow: "hidden"
        },
        children: [
            tealDuskSvgLinearGradient,
            " ",
            pinkHazeSvgLinearGradient,
            " ",
            goldenUmberSvgLinearGradient
        ]
    });
}
function ThemeStyles() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DefineGlobalStyles, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SvgLinearGradient, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CssBaseline_6a578862__["default"], {})
        ]
    });
}
const TicketCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ turnBorderColor, turn, theme })=>{
    const fullBorderColor = "user" === turn ? turnBorderColor : GREY_BORDER_CARD;
    const leftBorderColor = turnBorderColor;
    const borderWidth = `0.063rem 0.063rem 0.063rem ${theme.spacing(2)}`;
    return {
        borderRadius: theme.spacing(2),
        boxShadow: "none",
        padding: `${Spacing["1000"]} ${Spacing["1500"]}`,
        border: `solid ${fullBorderColor}`,
        borderWidth,
        borderLeft: `${theme.spacing(2)} solid ${leftBorderColor}`,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer
        }
    };
});
const ActionSectionFlexed = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.flexEnd,
    gap: "0.75rem"
});
const TicketCardDesktop = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ turn, turnIconToRender, turnColor, actionComponent, date, productName, productRequestedCode, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TicketCardContainer, {
        turnBorderColor: turnColor,
        turn: turn,
        ref: ref,
        "data-testid": "ticket-card-container-desktop",
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
            container: true,
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: "auto",
                    "data-testid": "ticket-card-desk-icon",
                    children: turnIconToRender
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xl: 7,
                    lg: 7,
                    md: 7,
                    sm: 6,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        container: true,
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                    variant: "body2",
                                    color: theme_theme.palette.text.secondary,
                                    "data-testid": "ticket-card-desk-date",
                                    children: date
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                    variant: "h6",
                                    "data-testid": "ticket-card-desk-product-name",
                                    children: productName
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                    variant: "body1",
                                    color: theme_theme.palette.text.secondary,
                                    "data-testid": "ticket-card-desk-code",
                                    children: `# ${productRequestedCode}`
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 5,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ActionSectionFlexed, {
                        "data-testid": "ticket-card-desk-action",
                        children: actionComponent
                    })
                })
            ]
        })
    });
});
var practice_turn_PracticeTurn = /*#__PURE__*/ function(PracticeTurn) {
    PracticeTurn["user"] = "user";
    PracticeTurn["operator"] = "cafOperator";
    PracticeTurn["finalized"] = "finalized";
    return PracticeTurn;
}({});
const CardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ turnBorderColor, turn, theme })=>{
    const fullBorderColor = turn === practice_turn_PracticeTurn.user ? turnBorderColor : GREY_BORDER_CARD;
    const leftBorderColor = turnBorderColor;
    const borderWidth = `${ONE_PIXEL_REM} ${ONE_PIXEL_REM} ${ONE_PIXEL_REM} ${theme.spacing(2)}`;
    return {
        borderRadius: theme.spacing(2),
        boxShadow: "none",
        padding: `${Spacing["1000"]} ${Spacing["1500"]}`,
        border: `solid ${fullBorderColor}`,
        borderWidth,
        borderLeft: `${theme.spacing(2)} solid ${leftBorderColor}`,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer
        }
    };
});
const ActionComponentStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)("div", styledOptions)(({ isFinalized })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.spaceBetween,
        marginTop: isFinalized ? "0" : `${Spacing["1000"]}`,
        borderTop: isFinalized ? "0" : `${ONE_PIXEL_REM} solid ${GREY_BORDER_CARD}`,
        paddingTop: `${Spacing["1000"]}`
    }));
const DivFlexedCentered = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    gap: `${Spacing["1000"]}`
});
const TicketCardMobile = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ turn, turnIconToRender, turnColor, actionComponent, date, productName, productRequestedCode, ...rest }, ref) {
    const isFinalized = turn === practice_turn_PracticeTurn.finalized;
    const productCodeWithSymbol = `# ${productRequestedCode}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardContainer, {
        turnBorderColor: turnColor,
        turn: turn,
        ref: ref,
        ...rest,
        "data-testid": "ticket-card-container-mobile",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
            container: true,
            alignItems: alignment_Alignment.center,
            spacing: 1,
            rowSpacing: 1,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DivFlexedCentered, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: "auto",
                            style: {
                                paddingTop: `${Spacing["500"]}`
                            },
                            "data-testid": "ticket-card-mobile-icon",
                            children: turnIconToRender
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 10,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                variant: "body2",
                                color: theme_theme.palette.text.secondary,
                                "data-testid": "ticket-card-mobile-date",
                                children: date
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                        variant: "subtitle1",
                        "data-testid": "ticket-card-mobile-product-name",
                        children: productName
                    })
                }),
                isFinalized ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                        variant: "body1",
                        color: theme_theme.palette.text.secondary,
                        "data-testid": "ticket-card-mobile-code",
                        children: productCodeWithSymbol
                    })
                }),
                isFinalized ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ActionComponentStyled, {
                        isFinalized: isFinalized,
                        "data-testid": "ticket-card-mobile-action",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                variant: "body1",
                                color: theme_theme.palette.text.secondary,
                                "data-testid": "ticket-card-mobile-code",
                                children: productCodeWithSymbol
                            }),
                            " ",
                            actionComponent
                        ]
                    })
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ActionComponentStyled, {
                        isFinalized: isFinalized,
                        "data-testid": "ticket-card-mobile-action",
                        children: actionComponent
                    })
                })
            ]
        })
    });
});
const WorkingTurnAction = {
    cafOperator: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {
        customColor: theme_theme.palette.action.active
    }),
    user: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
        color: "primary",
        size: "medium",
        variant: "contained",
        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {
            color: "inherit"
        }),
        children: "Procedi"
    }),
    finalized: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AngleRightSmallOutlined, {
        customColor: theme_theme.palette.action.active
    })
};
const TicketCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ turn, date, productName, productRequestedCode, actionText, ...rest }, ref) {
    const isMobile = use_is_mobile();
    const turnIconToRender = TurnIcons[turn];
    const turnColor = palette_WorkingTurnsColors[turn];
    const actionTextInputted = actionText ?? "";
    const actionComponent = composeActionComponent(turn, actionTextInputted);
    return isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TicketCardMobile, {
        ref: ref,
        turnIconToRender: turnIconToRender,
        turnColor: turnColor,
        actionComponent: actionComponent,
        turn: turn,
        date: date,
        productName: productName,
        productRequestedCode: productRequestedCode,
        ...rest
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TicketCardDesktop, {
        ref: ref,
        turnIconToRender: turnIconToRender,
        turnColor: turnColor,
        actionComponent: actionComponent,
        turn: turn,
        date: date,
        productName: productName,
        productRequestedCode: productRequestedCode,
        ...rest
    });
});
function composeActionComponent(turn, actionText) {
    const actionComponent = WorkingTurnAction[turn];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "body2",
                children: actionText
            }),
            actionComponent
        ]
    });
}
const UpgradeCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GradientBox, {
        sx: {
            maxWidth: "100%"
        },
        ref: ref,
        ...props.containerProps,
        gradient: props.gradient,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
            container: true,
            gap: 2,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                        variant: "subtitle1",
                        children: props.title
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    sx: {
                        display: displaying_Displaying.flex,
                        flexDirection: direction_Direction.row,
                        gap: Spacing["500"]
                    },
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StarMagicSolid, {
                            color: props.gradient
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                            variant: "body1",
                            children: props.subtitle
                        })
                    ]
                }),
                props.buttonProps?.children && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                        id: props.buttonProps?.id,
                        color: props.gradient,
                        variant: "contained",
                        fullWidth: true,
                        ...props.buttonProps,
                        children: props.buttonProps?.children
                    })
                })
            ]
        })
    });
});
function UploaderTabRenderer({ tab, activeTabIndex, setActiveTabIndex, tabs, onRemoveTab, onDrop }) {
    const currentIndex = activeTabIndex + 1;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        id: `tab-${tab.id}`,
        style: {
            display: tab.id === tabs[activeTabIndex].id ? "inherit" : "none"
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(dropzone_Dropzone, {
            onClear: ()=>{
                onRemoveTab(tabs[activeTabIndex].id);
                setActiveTabIndex(Math.max(0, currentIndex - 2));
            },
            onDrop: onDrop,
            ...tab.dropzone.props
        }, tab.dropzone.key)
    });
}
const UploaderContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ elevated })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: Spacing["750"],
        padding: Spacing["1500"],
        borderRadius: Spacing["750"],
        boxShadow: elevated ? DEFAULT_ELEVATION : "0",
        backgroundColor: palette_Primary.light,
        width: "100%"
    }));
const TitleTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    display: displaying_Displaying.flex,
    padding: "0 !important",
    lineHeight: `${Spacing["2000"]}`,
    color: palette_Text.primary
});
const DividerContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], styledOptions)(({ isMobile })=>({
        display: isMobile ? displaying_Displaying.none : displaying_Displaying.inherit
    }));
const GridContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], styledOptions)(({ isMobile })=>({
        display: displaying_Displaying.flex,
        flexDirection: isMobile ? direction_Direction.column : direction_Direction.row,
        gap: Spacing["750"],
        paddingBottom: isMobile ? Spacing["1500"] : Spacing["0"]
    }));
const SupportedFilesTextContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    paddingTop: Spacing["750"],
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.center,
    gap: Spacing["500"],
    alignItems: alignment_Alignment.center
});
const SupportedFilesTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    color: palette_Text.secondary,
    fontSize: Spacing["750"],
    fontStyle: "normal",
    fontWeight: typography_FontWeight.normal,
    lineHeight: "166%",
    letterSpacing: Spacing["25"]
});
const infoIconStyle = {
    width: Spacing["1000"],
    height: Spacing["1000"]
};
const DocumentReferenceYearContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    gap: Spacing["250"],
    justifyContent: alignment_Alignment.center,
    alignItems: alignment_Alignment.center
});
const chip_ChipStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(chip_Chip)({
    padding: `${Spacing["0"]} ${Spacing["500"]}`
});
const BoxCentered = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.center
});
function Uploader({ isMobile, addButtonText, title, disableAddButton, isAddButtonVisible = true, supportedFilesText, elevated, tabs, addNewTab, removeTab, isActionButtonVisible, onClickUploadEntireDocument, activeTabIndex, setActiveTabIndex, actionButtonText, onDrop, scrollButtons, tabsFullWidth, canModifyDocument, onClickModifyDocument, documentRefYear, documentRefYearText, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(UploaderContainer, {
        isMobile: isMobile,
        elevated: elevated,
        ...rest,
        children: [
            title ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "body2",
                children: title
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainer, {
                container: true,
                isMobile: isMobile,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        sx: {
                            width: tabsFullWidth ? "100%" : "initial"
                        },
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(tabs_Tabs, {
                            scrollButtons: scrollButtons,
                            value: activeTabIndex,
                            onChange: (_event, newValue)=>setActiveTabIndex(newValue),
                            children: tabs.map(function(tab, _) {
                                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(tab_Tab, {
                                    label: tab.label,
                                    "data-testid": `tab-${tab.id}`
                                }, tab.id);
                            })
                        })
                    }),
                    isAddButtonVisible && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainer, {
                            container: true,
                            isMobile: isMobile,
                            sx: {
                                paddingBottom: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                    item: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DividerContainer, {
                                        isMobile: isMobile,
                                        orientation: "vertical",
                                        variant: "middle"
                                    })
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                    item: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                                        "data-testid": "add-tab-button",
                                        disabled: disableAddButton ?? false,
                                        onClick: addNewTab,
                                        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlusOutlined, {}),
                                        children: addButtonText ?? "Add"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                children: tabs.map(function(tab, _) {
                    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UploaderTabRenderer, {
                        onDrop: onDrop,
                        tab: tab,
                        tabs: tabs,
                        activeTabIndex: activeTabIndex,
                        onRemoveTab: removeTab,
                        setActiveTabIndex: setActiveTabIndex
                    });
                })
            }),
            documentRefYear && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DocumentReferenceYearContainer, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                        variant: "body2",
                        color: palette_Text.secondary,
                        children: documentRefYearText ?? "Anno di riferimento:"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_ChipStyled, {
                        size: "small",
                        color: "default",
                        variant: "outlined",
                        label: documentRefYear
                    })
                ]
            }),
            isActionButtonVisible && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxCentered, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                    size: "small",
                    variant: "contained",
                    onClick: canModifyDocument ? onClickModifyDocument : onClickUploadEntireDocument,
                    children: actionButtonText
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SupportedFilesTextContainer, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InfoCircleOutlined, {
                        sx: infoIconStyle
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SupportedFilesTypographyContainer, {
                        children: supportedFilesText ?? "Supported files PDF, JPG. Max 1 Mb"
                    })
                ]
            })
        ]
    });
}
var uploader_accordion_UploaderAccordionVariant = /*#__PURE__*/ function(UploaderAccordionVariant) {
    UploaderAccordionVariant["RequestUpload"] = "request-upload";
    UploaderAccordionVariant["UploadSuccess"] = "upload-success";
    UploaderAccordionVariant["Success"] = "success";
    UploaderAccordionVariant["Error"] = "error";
    return UploaderAccordionVariant;
}({});
const iconMapping = {
    ["request-upload"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CloudUploadOutlined, {
        className: "uploader-icon"
    }),
    ["upload-success"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CloudUploadOutlined, {
        className: "uploader-icon"
    }),
    ["success"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CheckCircleSolid, {
        className: "uploader-icon"
    }),
    ["error"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TriangleExclamationSolid, {
        className: "uploader-icon"
    })
};
const UploaderAccordionElement = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Accordion)({
    ["&.request-upload"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.primary.main}`,
        borderColor: theme_theme.palette.primary.main,
        "& .uploader-icon": {
            color: theme_theme.palette.primary.main
        }
    },
    ["&.upload-success"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.secondary.main}`,
        borderColor: theme_theme.palette.secondary.main,
        "& .uploader-icon": {
            color: theme_theme.palette.secondary.main
        }
    },
    ["&.success"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.success.main}`,
        borderColor: theme_theme.palette.success.main,
        "& .uploader-icon": {
            color: theme_theme.palette.success.main
        }
    },
    ["&.error"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.error.main}`,
        borderColor: theme_theme.palette.error.main,
        "& .uploader-icon": {
            color: theme_theme.palette.error.main
        }
    },
    "&.uploader-disabled": {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.primary.light}`,
        borderColor: theme_theme.palette.primary.light,
        color: theme_theme.palette.text.disabled,
        "& .uploader-icon": {
            color: theme_theme.palette.action.disabled
        },
        "> *": {
            cursor: "not-allowed !important"
        }
    },
    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
        backgroundColor: "transparent",
        cursor: "not-allowed !important"
    }
});
const uploader_accordion_UploaderAccordion = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, uploadVariant, className, endAction, endChip, isMobile, disabled = false, ...rest }, ref) {
    const leftIcon = iconMapping[uploadVariant];
    const classNameOverride = `${className} ${uploadVariant} ${disabled ? "uploader-disabled" : ""}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UploaderAccordionElement, {
        ref: ref,
        disabled: disabled,
        startIcon: leftIcon,
        className: classNameOverride,
        isMobile: isMobile,
        endChip: endChip,
        endAction: endAction,
        ...rest,
        children: children
    });
});
const Opacity = {
    10: 0.1,
    20: 0.2,
    30: 0.3,
    40: 0.4,
    50: 0.5,
    60: 0.6,
    70: 0.7,
    80: 0.8,
    90: 0.9,
    100: 1
};
export { ACTION_CONTENT_BACKGROUND_COLOR, ACTION_CONTENT_BORDER_RADIUS, ACTIVE_MOBILE_PADDING_STYLES, ACTIVE_PADDING, ACTIVE_PADDING_STYLES, APP_BAR_HEIGHT_DESKTOP, APP_BAR_HEIGHT_MOBILE, AUTO_OPTION, AcceptedPayment, AcceptedPaymentContainer, Accordion, palette_Action as Action, AdminPanel, alert_Alert as Alert, alignment_Alignment as Alignment, AlphaDeep, Amex, app_bar_AppBar as AppBar, ApplePay, Autocomplete, AutocompleteTextField, avatar_Avatar as Avatar, AvatarProgressBar, AvatarStepper, BOTTOM_NAVIGATION_HEIGHT, palette_Background as Background, badge_Badge as Badge, BadgeContainer, Bancomat, BlockNotice, BlockNoticeBodyContainer, BlockNoticeContainer, BlockNoticeIconContainer, BlockNoticeTitleContainer, Bluex, palette_Border as Border, BorderRadius, border_style_BorderStyle as BorderStyle, BottomNavigation, BottomNavigationDrawer, BoxOutlinedWithGradient, containers_BoxWrapper as BoxWrapper, breadcrumbs_Breadcrumbs as Breadcrumbs, BreadcrumbsLink, button_Button as Button, ButtonContainer, CARD_CONTAINER_BORDER_THICK, CONTAIN_OPTION, COUNTRY_CODE_WITH_PREFIX, Celestex, chat_input_ChatInput as ChatInput, ChatInputBottomBar, ChatInputInnerBox, ChatInputOuterBox, checkbox_Checkbox as Checkbox, chip_Chip as Chip, chip_ChipStyled as ChipStyled, Color, palette_Common as Common, CompanyData, ContainerWithMarginRight, ContainerWithTopSpacing, conversation_bubble_ConversationBubble as ConversationBubble, cursor_style_CursorStyle as CursorStyle, CustomArrowButton, custom_arrow_button_interface_CustomArrowButtonDirections as CustomArrowButtonDirections, CustomDropzone, CustomIconCard, CustomNumberSpinner, DEFAULT_ELEVATION, DEFAULT_FONT_FAMILY, DEFAULT_ICON_SIZE, DEFAULT_STEP, DIVIDER_COLOR, date_picker_DatePicker as DatePicker, date_time_picker_DateTimePicker as DateTimePicker, palette_DeepBlue as DeepBlue, DeepBluex, DefineGlobalStyles, desktop_date_picker_DesktopDatePicker as DesktopDatePicker, desktop_date_time_picker_DesktopDateTimePicker as DesktopDateTimePicker, dialog_Dialog as Dialog, DialogGridContainer, DialogIconContainer, direction_Direction as Direction, displaying_Displaying as Displaying, DividerContainer, DocumentReferenceYearContainer, dropzone_Dropzone as Dropzone, DropzoneActionButton, DropzoneClearButton, DropzoneContainer, DropzoneMessage, dropzone_enum_DropzonePhase as DropzonePhase, DropzonePreviewer, DualGridCardLayourWrapper, DualGridCardLayout, DualGridCardLayoutColumn, DualGridCardLayoutContent, DualGridCardLayoutContentWrapper, DualGridCardLayoutElement, EMPTY_STRING, EndItemsContainer, EnvelopeContent, ErrorToken, FILTER_GRAYSCALE, FLAG_EXT, FilePreview, FlagImage, typography_FontSize as FontSize, typography_FontWeight as FontWeight, FormControlLabel, GREY_BORDER_CARD, GREY_BORDER_CARD_HOVERED, GREY_BORDER_CARD_HOVERED_MIDDLE_OPACITY, GREY_BORDER_CARD_MIDDLE_OPACITY, GoldenUmber, Goldenx, Gradient, GradientBox, GradientBoxOutlined, GradientPaletteBox, Greenx, Greyx, GridContainer, GridItemSpaceBetween, INACTIVE_MOBILE_PADDING_STYLES, INACTIVE_PADDING_STYLES, INITIAL_OPTION, icon_button_IconButton as IconButton, IconElement, IconSection, ImageSection, palette_Info as Info, InnerLabel, Interactive, IseeCard, IseeCardContent, IseeCardTitle, LeftActionsBox, LeftSlotWrapper, typography_LetterSpacing as LetterSpacing, typography_LineHeight as LineHeight, LinearProgress, List, ListItem, Logo, MAX_OPACITY, MIDDLE_OPACITY, MOBILE_PADDING, Maestro, MasterCard, mobile_date_picker_MobileDatePicker as MobileDatePicker, mobile_date_time_picker_MobileDateTimePicker as MobileDateTimePicker, ModalBar, ModalBarHeader, ModalBarIcon, MuiAccordionContainer, MuiAccordionSummaryContainer, MuiAccordionSummaryContentContainer, mui_class_collection_MuiClassCollection as MuiClassCollection, NONE_ELEVATION, NONE_OPTION, NUMBER_INPUT_ALLOWED_KEYS, Napolix, NavigationList, NavigationListItem, NavigationListItemCollapsible, NestedNavigation, NonInteractive, notification_card_NotificationCard as NotificationCard, NotificationCardContainer, NotificationCardContentContainer, NotificationCardDescription, NotificationCardFooter, NotificationCardHeader, Nudex, number_input_NumberInput as NumberInput, ONE_PIXEL_REM, Opacity, OperatorPanel, Orangex, PRIMARY_COLOR, Paypal, PaypalButton, PaypalIconContainer, PaypalSolid, PaypalTypographyContainer, PinkHaze, Pinkx, PlanSelector, PlanSelectorClickableGridSection, PlanSelectorIconSection, PlanSelectorLabelSection, positioning_Positioning as Positioning, practice_turn_PracticeTurn as PracticeTurn, palette_Primary as Primary, product_card_ProductCard as ProductCard, ProductCardAction, ProductCardChip, ProductCardContainer, ProductCardContent, ProductCardDate, ProductCardPrice, ProductCardTitle, ProfileQuestionnaire, ProfileQuestionnaireIcon, ProfileQuestionnaireItem, ProfileQuestionnaireItemWrapper, ProfileQuestionnairePaper, profile_questionnaire_status_enum_ProfileQuestionnaireStatus as ProfileQuestionnaireStatus, Progress, palette_Purple as Purple, PurpleLight, Purplex, QuantitySelector, QuantitySelectorContainer, QuantitySelectorTypographyContainer, radio_Radio as Radio, Redx, RightActionsBox, SCROLL_AREA_DEFAULT_COLOR, SCROLL_AREA_HEIGHT, SCROLL_AREA_WIDTH, SECONDARY_OPTION, SEE_FILE_PREVIEW, SIDEBAR_WIDTH, STABLE_OPTION, STORYBOOK_LARGE_MOBILE_WIDTH, scroll_paper_area_ScrollPaperArea as ScrollPaperArea, SearchCard, SearchCardContainer, SearchCardContent, search_card_interface_SearchCardTypes as SearchCardTypes, palette_Secondary as Secondary, select_Select as Select, SendButtonBox, Sidebar, SnackBar, SnackBarContainer, SnackBarIcon, SnackbarSlide, Spacing, StyledActionContainer, StyledChildrenContainer, StyledTable, StyledVerticalAlert, palette_Success as Success, SupportedFilesTextContainer, SupportedFilesTypographyContainer, SvgLinearGradient, switch_Switch as Switch, TRANSPARENT_COLOR, tab_Tab as Tab, Table, tabs_Tabs as Tabs, TealDusk, Tealx, palette_Tertiary as Tertiary, palette_Text as Text, text_field_TextField as TextField, ThemeProvider, ThemeStyles, TicketCard, TicketCardContainer, TicketCardDesktop, TicketCardMobile, TitleTypographyContainer, app_bar_Toolbar as Toolbar, Tooltip, TooltipContainerText, TooltipDescriptionTypographyContainer, TooltipTitleTypographyContainer, Typography, TypographyWrapperContainer, UpgradeCard, Uploader, uploader_accordion_UploaderAccordion as UploaderAccordion, uploader_accordion_UploaderAccordionVariant as UploaderAccordionVariant, UploaderContainer, UploaderTabRenderer, vertical_alert_VerticalAlert as VerticalAlert, Visa, WHITE_TRANSPARENT_LIGHT, palette_Warning as Warning, White, WorkingTurnAction, palette_WorkingTurnsColors as WorkingTurnsColors, wrapping_Wrapping as Wrapping, accordionDetailsStyleOverrides, accordionStyleOverrides, accordionSummaryStyleOverrides, adminRoutes, alertDefaultProps, alertStylesOverride, alertTitleStylesOverride, badgeStylesOverride, bottomBarStyles, bottomNavigationDrawerRoutes, bottomNavigationRoutes, boxContentClassName, buttonStyleOverrides, callOnChangeWithNewValue, chatInputBoxStyles, chatInputInnerBoxStyles, checkboxStylesOverride, chipStyleOverrides, colorMapper, computeInputProps, computeLabelProps, computeNewValueBasedOnDirection, computeNewValueBasedOnUserInput, confirmButtonDefaultText, conversationBubbleContainerStyles, conversationBubbleStartIconStyles, conversationBubbleTextStyles, defaultLoadingText, defaultUploadButtonText, dialogActionsStylesOverrides, dialogContentStylesOverrides, dialogStyleOverrides, dialogTitleStylesOverrides, generateCustomTextFieldStyle, getAdornmentAndIcon, getChipColor, getIconColor, getMainColor, getProfileQuestionnaireItemWrapperPadding, getProfileQuestionnairePaperPadding, getProgressBarFillColor, getProgressBarStrokeColor, getTextFieldInputAdornmentProperty, goldenUmber, goldenUmberPalette, handleClearButtonClickEventAndReturnNewStatus, handleModifyButtonEventAndReturnNewStatus, handleOnConfirmEventAndReturnNewStatus, handleOnDropEventAndReturnNewStatus, iconButtonStyleOverrides, infoIconStyle, inputStyleOverrides, isAllowedKey, isColorPaletteWithToken, isLabelShrunk, leftActionsBoxStyles, linearProgressStylesOverride, listItemButtonOverrides, menuItemStylesOverrides, modifyButtonDefaultText, operatorRoutes, palette, paletteMapper, paperStyleOverrides, pinkHaze, pinkHazePalette, radioStylesOverride, rightActionsBoxStyles, sendButtonBoxStyles, sendButtonStyles, sidebarRoutes, switchStylesOverride, tealDusk, tealDuskPalette, textFieldStyleOverrides, textFieldStyles, toolTipStyleOverrides, typography };
